/**
 * SEO 配置 - video-tools
 * 自动从 seo.ts 拆分生成
 */

export default {
    en: {
        textToMusic: {
            title: 'AI Music Generator - Create Unique Music with 微鲤AI | 微鲤AI',
            description: `Discover 微鲤AI's AI Music Generator. Quickly create unique, copyright-free music tailored to your projects with advanced AI technology. Perfect for content creators, game developers, and music enthusiasts.`,
            keywords: 'text to music, text to music free, AI text to music, AI music generator, AI song maker, lyric to music generator, make similar music, music creation, copyright-free music, free music download, 微鲤AI',
        },
        textToVideo: {
            title: 'Free AI Text to Video Generator (Veo 3.1, Kling & Sora) - Create AI Video from Text',
            description: `Turn your text prompts into cinematic videos instantly with 微鲤AI's Text to Video AI. Powered by Google Veo 3.1, Kling, and Sora. Support 16:9 & 9:16 ratios, up to 8s duration. No watermark options available.`,
            keywords: 'text to video ai, ai video generator, google veo 3.1, prompt to video, kling ai video, sora ai free, txt2vid',
            og_title: 'Free AI Text to Video Generator (Veo 3.1, Kling & Sora) - Create AI Video from Text',
            og_description: `Turn your text prompts into cinematic videos instantly with 微鲤AI's Text to Video AI. Powered by Google Veo 3.1, Kling, and Sora. Support 16:9 & 9:16 ratios, up to 8s duration. No watermark options available.`,
            twitter_title: 'Free AI Text to Video Generator (Veo 3.1, Kling & Sora) - Create AI Video from Text',
            twitter_description: `Turn your text prompts into cinematic videos instantly with 微鲤AI's Text to Video AI. Powered by Google Veo 3.1, Kling, and Sora. Support 16:9 & 9:16 ratios, up to 8s duration. No watermark options available.`,
            page: {
                title1: 'Free AI Text to Video Generator',
                title2: 'Simply type a prompt, and watch 微鲤AI bring your idea to life. Our Text to Video generator aggregates state-of-the-art models like Google Veo 3.1 and Kling AI, allowing you to create high-quality, physically accurate videos for social media (9:16) or cinematic projects (16:9) in seconds.',
                intro_title: 'Turn Imagination into Reality with Text to Video AI',
                feature_title: 'Features of 微鲤AI Text to Video',
                faq_title: 'Frequently Asked Questions about Text to Video',
                feature_title1: 'Multi-Model Powerhouse',
                feature_desc1: 'Switch between Veo 3.1 for realism and Kling for motion consistency. No need for multiple subscriptions.',
                feature_title2: 'Custom Aspect Ratios',
                feature_desc2: 'Generate vertical videos (9:16) for TikTok/Reels or widescreen (16:9) for YouTube directly.',
                feature_title3: 'Extended Duration',
                feature_desc3: 'Create videos up to 8 seconds (or longer with extensions) in a single generation, perfect for storytelling.',
                faq: [
                    {
                        question: 'How do I write a good prompt for AI text to video?',
                        answer: `Be specific. Describe the subject, action, lighting, and camera angle. For example: "A cinematic drone shot of a futuristic cyberpunk city at night, neon lights, 4k resolution." 微鲤AI's integrated models understand complex descriptions well.`,
                    },
                    {
                        question: 'Which model should I use: Google Veo 3.1 or Kling?',
                        answer: 'Google Veo 3.1 offers exceptional visual fidelity and prompt adherence, ideal for realistic scenes. Kling AI often performs better for complex character movements. We recommend trying both to see which fits your specific scene.',
                    },
                    {
                        question: 'Is 微鲤AI Text to Video free?',
                        answer: 'Yes, every user gets free daily credits to generate videos from text. You can create multiple clips to test different prompts and models.',
                    },
                    {
                        question: 'Can I generate videos longer than 8 seconds?',
                        answer: 'The base generation creates clips up to 8s (depending on the model). To make longer videos, you can use our AI Video Extender tool to seamlessly continue the footage.',
                    },
                    {
                        question: 'Do the generated videos have sound?',
                        answer: 'Yes, you can enable the "Generate Audio" toggle (as seen in the tool) to create matching sound effects and background ambience automatically.',
                    },
                ],
            },
            faq: [
                {
                    question: 'How do I write a good prompt for AI text to video?',
                    answer: `Be specific. Describe the subject, action, lighting, and camera angle. For example: "A cinematic drone shot of a futuristic cyberpunk city at night, neon lights, 4k resolution." 微鲤AI's integrated models understand complex descriptions well.`,
                },
                {
                    question: 'Which model should I use: Google Veo 3.1 or Kling?',
                    answer: 'Google Veo 3.1 offers exceptional visual fidelity and prompt adherence, ideal for realistic scenes. Kling AI often performs better for complex character movements. We recommend trying both to see which fits your specific scene.',
                },
                {
                    question: 'Is 微鲤AI Text to Video free?',
                    answer: 'Yes, every user gets free daily credits to generate videos from text. You can create multiple clips to test different prompts and models.',
                },
                {
                    question: 'Can I generate videos longer than 8 seconds?',
                    answer: 'The base generation creates clips up to 8s (depending on the model). To make longer videos, you can use our AI Video Extender tool to seamlessly continue the footage.',
                },
                {
                    question: 'Do the generated videos have sound?',
                    answer: 'Yes, you can enable the "Generate Audio" toggle (as seen in the tool) to create matching sound effects and background ambience automatically.',
                },
            ],
        },
        imageToVideo: {
            title: 'AI Image to Video Generator (Free & Online) - Powered by Kling, Veo & Sora',
            description: `Turn static photos into realistic videos in seconds with 微鲤AI's free Image to Video AI. Access top models like Kling, Google Veo, and Sora 2 in one place. No watermark options available.`,
            keywords: 'image to video AI, AI video generator, image animation, Sora video, Veo video, Seedance video, 微鲤AI video tools',
            og_title: 'AI Image to Video Generator (Free & Online) - Powered by Kling, Veo & Sora',
            og_description: `Turn static photos into realistic videos in seconds with 微鲤AI's free Image to Video AI. Access top models like Kling, Google Veo, and Sora 2 in one place. No watermark options available.`,
            twitter_title: 'AI Image to Video Generator (Free & Online) - Powered by Kling, Veo & Sora',
            twitter_description: `Turn static photos into realistic videos in seconds with 微鲤AI's free Image to Video AI. Access top models like Kling, Google Veo, and Sora 2 in one place. No watermark options available.`,
            page: {
                title1: 'Free Online AI Image to Video Generator',
                faq: [
                    {
                        question: 'How does the AI Image to Video generator work?',
                        answer: 'It uses advanced deep learning models like Kling and Sora to analyze your static image and predict motion, generating a coherent video clip in MP4 format.',
                    },
                    {
                        question: 'Is 微鲤AI image to video free to use?',
                        answer: 'Yes, we offer free credits daily for users to try our image to video AI. You can upgrade for premium models and faster generation speeds.',
                    },
                    {
                        question: 'Which model is best for realistic video: Kling or Veo?',
                        answer: 'Kling AI is renowned for its realistic motion and longer duration, while Google Veo excels at high-definition details. 微鲤AI lets you switch between them to find the best fit.',
                    },
                    {
                        question: 'Can I use the generated videos commercially?',
                        answer: 'Yes, videos generated under our paid plans come with a commercial license, perfect for YouTube, TikTok, and marketing ads.',
                    },
                    {
                        question: 'How to remove watermarks from AI videos?',
                        answer: '微鲤AI provides high-quality outputs. For watermark-free videos, please verify your plan details or use our dedicated AI Watermark Remover tool.',
                    },
                ],
            },
            faq: [
                {
                    question: 'How does the AI Image to Video generator work?',
                    answer: 'It uses advanced deep learning models like Kling and Sora to analyze your static image and predict motion, generating a coherent video clip in MP4 format.',
                },
                {
                    question: 'Is 微鲤AI image to video free to use?',
                    answer: 'Yes, we offer free credits daily for users to try our image to video AI. You can upgrade for premium models and faster generation speeds.',
                },
                {
                    question: 'Can I use the generated videos commercially?',
                    answer: 'Yes, videos generated under our paid plans come with a commercial license, perfect for YouTube, TikTok, and marketing ads.',
                },
            ],
        },
        videoToVideo: {
            title: 'Free AI Video to Video Generator - Restyle & Anime Filter Online',
            description: `Transform your videos into any style with 微鲤AI's Video to Video AI. Turn real-life footage into anime, 3D cartoons, or cyberpunk art using text prompts. Keep original motion consistent. Free & Online.`,
            keywords: 'video to video ai, vid2vid, ai video style transfer, turn video into anime, ai video restyle, free video filter ai',
            og_title: 'Free AI Video to Video Generator - Restyle & Anime Filter Online',
            og_description: `Transform your videos into any style with 微鲤AI's Video to Video AI. Turn real-life footage into anime, 3D cartoons, or cyberpunk art using text prompts. Keep original motion consistent. Free & Online.`,
            twitter_title: 'Free AI Video to Video Generator - Restyle & Anime Filter Online',
            twitter_description: `Transform your videos into any style with 微鲤AI's Video to Video AI. Turn real-life footage into anime, 3D cartoons, or cyberpunk art using text prompts. Keep original motion consistent. Free & Online.`,
            page: {
                title1: 'Free AI Video to Video Generator (Vid2Vid)',
                title2: `Upload a video, type a style, and watch the magic happen. 微鲤AI's Video to Video technology analyzes the motion in your source footage and applies a completely new artistic style based on your text prompt. Perfect for creating anime edits, claymation effects, or surreal visual art.`,
                feature_title1: 'Consistent Motion',
                feature_desc1: 'Unlike standard generation, our Vid2Vid engine locks onto the movement of your source video, ensuring smooth transitions without flickering.',
                feature_title2: 'Real to Anime',
                feature_desc2: 'The #1 tool for content creators. Turn yourself into an anime character or a 3D Pixar-style avatar instantly.',
                feature_title3: 'Prompt Control',
                feature_desc3: 'You have full creative control. Just type "Cyberpunk city style" or "Oil painting style" to define the exact look of the output.',
                faq: [
                    {
                        question: 'What is AI Video to Video (Vid2Vid)?',
                        answer: 'Video to Video is a generative AI process that takes an existing video clip as input and "repaints" it in a new style described by your text prompt, while preserving the original motion and structure.',
                    },
                    {
                        question: 'Can I turn my video into an anime style?',
                        answer: 'Yes! This is the most popular use case. Simply upload your video and enter prompts like "Japanese anime style, Studio Ghibli look" to transform your footage.',
                    },
                    {
                        question: 'How long can the source video be?',
                        answer: 'Currently, we support short clips (e.g., up to 5-10 seconds) to ensure the highest quality style transfer. For longer videos, we recommend splitting them into segments.',
                    },
                    {
                        question: 'Is it different from a video editor?',
                        answer: 'Yes. A traditional video editor cuts and trims clips. 微鲤AI Video to Video generates new pixels, completely changing the texture and artistic style of your footage.',
                    },
                    {
                        question: 'Does it cost money?',
                        answer: '微鲤AI offers free daily credits to try the Video to Video feature. Premium plans are available for faster processing and watermark-free downloads.',
                    },
                ],
            },
            faq: [
                {
                    question: 'What is AI Video to Video (Vid2Vid)?',
                    answer: 'Video to Video is a generative AI process that takes an existing video clip as input and "repaints" it in a new style described by your text prompt, while preserving the original motion and structure.',
                },
                {
                    question: 'Can I turn my video into an anime style?',
                    answer: 'Yes! This is the most popular use case. Simply upload your video and enter prompts like "Japanese anime style, Studio Ghibli look" to transform your footage.',
                },
                {
                    question: 'How long can the source video be?',
                    answer: 'Currently, we support short clips (e.g., up to 5-10 seconds) to ensure the highest quality style transfer. For longer videos, we recommend splitting them into segments.',
                },
                {
                    question: 'Is it different from a video editor?',
                    answer: 'Yes. A traditional video editor cuts and trims clips. 微鲤AI Video to Video generates new pixels, completely changing the texture and artistic style of your footage.',
                },
                {
                    question: 'Does it cost money?',
                    answer: '微鲤AI offers free daily credits to try the Video to Video feature. Premium plans are available for faster processing and watermark-free downloads.',
                },
            ],
        },
        removeWatermark: {
            title: 'Free AI Video Watermark Remover Online - Delete Logos, Text & Subtitles',
            description: `Easily remove watermarks, logos, subtitles, and date stamps from videos with 微鲤AI's Free AI Watermark Remover. Supports MP4/MOV and video links. No blur, just clean AI restoration.`,
            keywords: 'remove watermark from video, video watermark remover, remove watermark from video online, remove watermark online, AI watermark remover, ai video eraser, remove logo from video, remove text from video, delete subtitles, remove subtitles from video, remove date stamp from video, remove timestamp from video, remove watermark without blur, remove watermark without cropping, remove watermark from mp4, remove watermark from mov, remove watermark from video link, tiktok watermark remover, free watermark remover online',
            og_title: 'Free AI Video Watermark Remover Online - Delete Logos, Text & Subtitles',
            og_description: `Easily remove watermarks, logos, subtitles, and date stamps from videos with 微鲤AI's Free AI Watermark Remover. Supports MP4/MOV and video links. No blur, just clean AI restoration.`,
            twitter_title: 'Free AI Video Watermark Remover Online - Delete Logos, Text & Subtitles',
            twitter_description: `Easily remove watermarks, logos, subtitles, and date stamps from videos with 微鲤AI's Free AI Watermark Remover. Supports MP4/MOV and video links. No blur, just clean AI restoration.`,
            page: {
                title1: 'Free Online AI Video Watermark Remover',
                title2: 'Instantly erase watermarks, logos, text overlays, and subtitles from your videos. Paste a video link or upload a file, select the area, and let our AI restore the background pixel-perfectly without blurring.',
                click_erase: '1.One-Click Erase: AI automatically detects and removes common watermarks.',
                percision_erase: '2.Precision Erase: Use the brush tool to manually remove complex objects like moving subtitles or timestamps.',
                video_link_title: 'Support via Link',
                direct_link_desc: '1.Direct Link Removal: Paste links from social media platforms to remove watermarks directly without downloading the source file first.',
                lossless_qua_title: '2.Lossless Quality: Unlike traditional blurring tools, 微鲤AI analyzes surrounding pixels to reconstruct the background context.',
                faq: [
                    {
                        question: 'How to remove a watermark from a video online for free?',
                        answer: `Simply upload your video to 微鲤AI or paste a video link. Use the selection box to cover the watermark, and click "Generate". It's 100% free to try.`,
                    },
                    {
                        question: 'Can I remove moving subtitles or text?',
                        answer: 'Yes. Use the "Precision Erase" mode to select the text area. Our AI tracks the watermark across frames to ensure clean removal throughout the video.',
                    },
                    {
                        question: 'Does it work for TikTok or YouTube videos?',
                        answer: 'Absolutely. You can remove platform logos (like the TikTok bouncing watermark) or channel watermarks to get a clean video for personal use.',
                    },
                    {
                        question: 'Will the removed area look blurry?',
                        answer: 'No. 微鲤AI uses advanced "Video In-painting" technology to fill the erased area with realistic textures generated from the surrounding video, avoiding the ugly blur effect.',
                    },
                    {
                        question: 'What video formats do you support?',
                        answer: 'We support all major formats including MP4, MOV, AVI, and WebM.',
                    },
                ],
            },
            faq: [
                {
                    question: 'How to remove a watermark from a video online for free?',
                    answer: `Simply upload your video to 微鲤AI or paste a video link. Use the selection box to cover the watermark, and click "Generate". It's 100% free to try.`,
                },
                {
                    question: 'Can I remove moving subtitles or text?',
                    answer: 'Yes. Use the "Precision Erase" mode to select the text area. Our AI tracks the watermark across frames to ensure clean removal throughout the video.',
                },
                {
                    question: 'Will the removed area look blurry?',
                    answer: 'No. 微鲤AI uses advanced "Video In-painting" technology to fill the erased area with realistic textures generated from the surrounding video, avoiding the ugly blur effect.',
                },
            ],
        },
        videoFaceSwap: {
            title: 'Free AI Video Face Swap Online - Realistic Deepfake Maker',
            description: `Swap faces in videos instantly with 微鲤AI's AI Face Swapper. Create funny movie clips, memes, and realistic deepfakes for free. No watermark options available. 100% Private & Secure.`,
            keywords: 'video face swap, ai face swapper, free deepfake maker, replace face in video, movie face swap, reface online, meme maker ai',
            og_title: 'Free AI Video Face Swap Online - Realistic Deepfake Maker',
            og_description: `Swap faces in videos instantly with 微鲤AI's AI Face Swapper. Create funny movie clips, memes, and realistic deepfakes for free. No watermark options available. 100% Private & Secure.`,
            twitter_title: 'Free AI Video Face Swap Online - Realistic Deepfake Maker',
            twitter_description: `Swap faces in videos instantly with 微鲤AI's AI Face Swapper. Create funny movie clips, memes, and realistic deepfakes for free. No watermark options available. 100% Private & Secure.`,
            page: {
                title1: 'Free AI Video Face Swap',
                title2: 'Be the star of any movie! Upload a video clip and a target photo, and watch our AI seamlessly swap the faces. Perfect for creating hilarious memes, personalized greetings, or professional visual effects with high fidelity.',
                feature_title1: 'Hyper-Realistic Deepfake',
                feature_desc1: 'Our AI analyzes facial geometry and lighting to blend the new face naturally, preserving the original facial expressions and head movements.',
                feature_title2: 'Privacy First',
                feature_desc2: 'We prioritize your privacy. Uploaded videos and images are processed securely and deleted from our servers shortly after generation.',
                feature_title3: 'No Technical Skills Needed',
                feature_desc3: 'No need for complex software like After Effects. Just click "Create" and get Hollywood-level results in seconds.',
                faq: [
                    {
                        question: 'Is 微鲤AI Video Face Swap free?',
                        answer: 'Yes, we offer free credits for you to try face swapping on videos online. No credit card is required to start creating funny clips.',
                    },
                    {
                        question: 'Is it safe to upload my photos?',
                        answer: 'Absolutely. We use strict data protection protocols. Your source videos and target face images are used solely for the generation process and are not stored permanently.',
                    },
                    {
                        question: 'Can I swap faces in GIFs?',
                        answer: 'Yes! 微鲤AI supports both video (MP4/MOV) and GIF formats. You can easily create personalized reaction GIFs.',
                    },
                    {
                        question: 'How to get the best face swap results?',
                        answer: 'For the best quality, use a "Target Face" photo that is clear, front-facing, and well-lit. Avoid photos where the face is covered by hair or glasses.',
                    },
                    {
                        question: 'Can I use this for commercial projects?',
                        answer: 'Yes, but please ensure you have the rights to the original video footage and the likeness of the person you are swapping.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Is 微鲤AI Video Face Swap free?',
                    answer: 'Yes, we offer free credits for you to try face swapping on videos online. No credit card is required to start creating funny clips.',
                },
                {
                    question: 'Is it safe to upload my photos?',
                    answer: 'Absolutely. We use strict data protection protocols. Your source videos and target face images are used solely for the generation process.',
                },
                {
                    question: 'How to get the best face swap results?',
                    answer: 'For the best quality, use a "Target Face" photo that is clear, front-facing, and well-lit. Avoid photos where the face is covered by hair or glasses.',
                },
            ],
        },
        videoLipSync: {
            title: 'Free AI Video Lip Sync Generator - Sync Audio & Text to Video',
            description: `Perfectly sync lip movements to any audio or text with 微鲤AI's AI Lip Sync Tool. Powered by Kling AI. Ideal for video translation, dubbing, and creating talking avatars. Free & Online.`,
            keywords: 'ai video lip sync, auto lip sync, ai dubbing tool, make photo speak, kling ai video, text to speech video, audio to lip sync',
            og_title: 'Free AI Video Lip Sync Generator - Sync Audio & Text to Video',
            og_description: `Perfectly sync lip movements to any audio or text with 微鲤AI's AI Lip Sync Tool. Powered by Kling AI. Ideal for video translation, dubbing, and creating talking avatars. Free & Online.`,
            twitter_title: 'Free AI Video Lip Sync Generator - Sync Audio & Text to Video',
            twitter_description: `Perfectly sync lip movements to any audio or text with 微鲤AI's AI Lip Sync Tool. Powered by Kling AI. Ideal for video translation, dubbing, and creating talking avatars. Free & Online.`,
            page: {
                title1: 'Free AI Video Lip Sync & Dubbing Tool',
                title2: 'Say goodbye to awkward dubbed videos. Upload a video and an audio file (or type text), and our AI will regenerate the lip movements of the speaker to match the sound perfectly. Powered by Kling AI, it supports multi-language dubbing and realistic facial muscle adjustments.',
                dual_input_modes: 'Dual Input Modes',
                audio_sync: 'Audio Sync',
                text_sync: 'Text to Speech',
                text_sync_tip: 'Type any text, choose a preset AI voice, and let the character speak it instantly.',
                audio_sync_tip: 'Upload your own voiceover or song to sync.',
                feature_title1: 'Multi-Language Dubbing',
                feature_desc1: 'Expand your reach. Translate your video into Spanish, French, or Japanese, and sync the lips so it looks like the speaker is native fluent.',
                feature_title2: 'Kling AI Precision',
                feature_desc2: 'Unlike basic Wav2Lip tools, we use the Kling model to ensure teeth, tongue, and jaw movements are anatomically correct.',
                faq: [
                    {
                        question: 'How do I sync lips to audio in a video?',
                        answer: 'Upload your video clip to 微鲤AI. Then, either upload an audio file (MP3/WAV) or type text to generate AI speech. Click "Create", and our AI will adjust the mouth movements to match the sound.',
                    },
                    {
                        question: 'Can I use this for video translation/dubbing?',
                        answer: 'Yes! This is the perfect tool for dubbing. You can upload a translated audio track, and the AI will fix the lip-sync so the dubbed version looks natural.',
                    },
                    {
                        question: 'Does it work with static images (talking heads)?',
                        answer: 'Yes. If you upload a static portrait photo as the "video" source, the tool will animate it into a talking head video (Live Portrait effect).',
                    },
                    {
                        question: 'What languages are supported?',
                        answer: 'Since the technology analyzes audio waves, it works with any language (English, Spanish, Chinese, Hindi, etc.). For Text-to-Speech input, we support 50+ languages.',
                    },
                    {
                        question: 'Is the lip sync free?',
                        answer: '微鲤AI offers free daily credits to test the Lip Sync feature. For long-form videos or commercial use, premium plans are available.',
                    },
                ],
            },
            faq: [
                {
                    question: 'How do I sync lips to audio in a video?',
                    answer: 'Upload your video clip to 微鲤AI. Then, either upload an audio file (MP3/WAV) or type text to generate AI speech. Click "Create", and our AI will adjust the mouth movements to match the sound.',
                },
                {
                    question: 'Can I use this for video translation/dubbing?',
                    answer: 'Yes! This is the perfect tool for dubbing. You can upload a translated audio track, and the AI will fix the lip-sync so the dubbed version looks natural.',
                },
                {
                    question: 'Does it work with static images (talking heads)?',
                    answer: 'Yes. If you upload a static portrait photo as the "video" source, the tool will animate it into a talking head video (Live Portrait effect).',
                },
            ],
        },
        translateVideoSubtitle: {
            title: 'Free AI Video Subtitle Translator - Auto Caption & Translate Online',
            description: `Automatically generate and translate video subtitles with 微鲤AI's AI Subtitle Translator. Support English, Spanish, Chinese, and 90+ languages. Download videos with burned-in subtitles instantly.`,
            keywords: 'ai subtitle translator, translate video subtitles, auto caption generator, video translator, add subtitles to video, free video translation ai',
            og_title: 'Free AI Video Subtitle Translator - Auto Caption & Translate Online',
            og_description: `Automatically generate and translate video subtitles with 微鲤AI's AI Subtitle Translator. Support English, Spanish, Chinese, and 90+ languages. Download videos with burned-in subtitles instantly.`,
            twitter_title: 'Free AI Video Subtitle Translator - Auto Caption & Translate Online',
            twitter_description: `Automatically generate and translate video subtitles with 微鲤AI's AI Subtitle Translator. Support English, Spanish, Chinese, and 90+ languages. Download videos with burned-in subtitles instantly.`,
            page: {
                title1: 'Free AI Video Subtitle Translator',
                title2: 'Break language barriers instantly. Upload your video, select your target language, and let our AI automatically recognize speech, transcribe audio, and burn accurate translated subtitles directly into your video file.',
                feature_title1: '90+ Languages Support',
                feature_desc1: 'Translate your content from English to Spanish, French, German, Japanese, Chinese, and more. Reach a global audience with one click.',
                feature_title2: 'Auto-Sync & Burn-in',
                feature_desc2: 'No need to manually adjust timestamps. Our AI ensures subtitles are perfectly synchronized with the audio and burned into the video (Hardsubs) for universal compatibility.',
                feature_title3: 'Context-Aware Accuracy',
                feature_desc3: 'Powered by advanced LLMs, 微鲤AI understands context and slang, providing translations that are natural and accurate, not just robotic literal translations.',
                faq: [
                    {
                        question: 'How do I translate video subtitles automatically?',
                        answer: 'Upload your video to 微鲤AI, select the "Target Language" (e.g., English to Spanish), and click "Create". Our AI will generate and translate the subtitles automatically.',
                    },
                    {
                        question: 'What languages are supported for translation?',
                        answer: 'We support over 90 global languages, including major ones like English, Spanish, French, German, Portuguese, Hindi, Japanese, and Chinese.',
                    },
                    {
                        question: 'Is the subtitle translator free?',
                        answer: 'Yes, 微鲤AI offers free access to our AI Video Subtitle Translator. You can process videos without paying for expensive transcription services.',
                    },
                    {
                        question: 'Do I need to download an SRT file?',
                        answer: 'No. 微鲤AI generates videos with hardcoded subtitles (burned-in), meaning the text is part of the video. This ensures your subtitles show up correctly on TikTok, Instagram, and YouTube.',
                    },
                    {
                        question: 'How accurate is the AI translation?',
                        answer: 'Our AI uses state-of-the-art speech recognition models to ensure high accuracy. For clear audio, the accuracy rate can exceed 95%.',
                    },
                ],
            },
            faq: [
                {
                    question: 'How do I translate video subtitles automatically?',
                    answer: 'Upload your video to 微鲤AI, select the Target Language, and click Create. Our AI will generate and translate the subtitles automatically.',
                },
                {
                    question: 'What languages are supported for translation?',
                    answer: 'We support over 90 global languages, including English, Spanish, French, German, Portuguese, Hindi, Japanese, and Chinese.',
                },
                {
                    question: 'Do I need to download an SRT file?',
                    answer: 'No. 微鲤AI generates videos with hardcoded subtitles (burned-in), ensuring your subtitles show up correctly on all social platforms.',
                },
            ],
        },
        videoToAnime: {
            title: 'Free AI Video to Anime Converter - Turn Real Video to Cartoon & Pixar',
            description: `Transform your videos into Japanese anime, 3D Pixar style, or cartoons instantly with 微鲤AI's Video to Anime Converter. Features frame-by-frame stability for smooth animation. Free & Online.`,
            keywords: 'video to anime, ai anime filter, turn video into cartoon, pixar video filter, real to anime, domoai alternative, anime video generator',
            og_title: 'Free AI Video to Anime Converter - Turn Real Video to Cartoon & Pixar',
            og_description: `Transform your videos into Japanese anime, 3D Pixar style, or cartoons instantly with 微鲤AI's Video to Anime Converter. Features frame-by-frame stability for smooth animation. Free & Online.`,
            twitter_title: 'Free AI Video to Anime Converter - Turn Real Video to Cartoon & Pixar',
            twitter_description: `Transform your videos into Japanese anime, 3D Pixar style, or cartoons instantly with 微鲤AI's Video to Anime Converter. Features frame-by-frame stability for smooth animation. Free & Online.`,
            page: {
                title1: 'Free AI Video to Anime Converter',
                title2: 'Turn yourself into an anime protagonist in one click. Upload any real-life video, choose a style (Pixar 3D, Classic 2D, or Hand-drawn), and let our AI restyle your footage frame-by-frame while keeping the original motion smooth and consistent.',
                feature_desc1: '<div><p>Pixar & 3D: Create cute, Disney-style animated clips perfect for family videos.</p><p>Classic Anime: Get that authentic Japanese animation look (Ghibli/Shinkai style).</p><p>Sketch & Ink: Turn videos into artistic hand-drawn pencil animations.</p></div>',
                feature_title2: 'Frame-by-Frame Stability',
                feature_desc2: 'Sick of flickering AI videos? 微鲤AI uses advanced temporal consistency algorithms to ensure your anime video plays smoothly without the "jitters" common in other tools.',
                feature_title3: 'Viral Content Creator',
                feature_desc3: 'Designed for TikTok and Reels. Create trending "Real vs Anime" comparison videos that grab attention instantly.',
                faq: [
                    {
                        question: 'How to turn a video into anime for free?',
                        answer: `Upload your video clip to 微鲤AI's Video to Anime tool. Select a style preset (like "2D Style" or "Pixar Style") and click Create. It's free to try with daily credits.`,
                    },
                    {
                        question: 'Can I convert video to Pixar/Disney style?',
                        answer: 'Yes! We offer a specific "3D Cartoon" or "Pixar Style" preset that transforms real people into cute 3D animated characters, similar to popular movie styles.',
                    },
                    {
                        question: 'How long can the video be?',
                        answer: `Currently, we support clips up to 30 seconds (as seen in the screenshot's "Maximum video duration: 30s"). This is ideal for Shorts, Reels, and TikToks.`,
                    },
                    {
                        question: 'Will the anime character move like me?',
                        answer: 'Absolutely. Our AI analyzes your skeletal movement and expressions, ensuring the anime character mimics your actions perfectly.',
                    },
                    {
                        question: 'What is the best AI video to anime converter?',
                        answer: '微鲤AI is considered one of the best choices because it offers multiple styles (2D/3D) and focuses on frame stability to reduce visual noise.',
                    },
                ],
            },
            faq: [
                {
                    question: 'How to turn a video into anime for free?',
                    answer: 'Upload your video clip to 微鲤AI. Select a style preset (like 2D Style or Pixar Style) and click Create.',
                },
                {
                    question: 'Can I convert video to Pixar/Disney style?',
                    answer: 'Yes! We offer a specific 3D Cartoon/Pixar Style preset that transforms real people into cute 3D animated characters.',
                },
                {
                    question: 'Will the anime character move like me?',
                    answer: 'Absolutely. Our AI analyzes your skeletal movement and expressions, ensuring the anime character mimics your actions perfectly.',
                },
            ],
            app_name: '微鲤AI Video to Anime Converter',
            app_desc: 'Free AI tool to convert real videos into anime, cartoon, and Pixar styles. Features frame-by-frame rendering for stable animation.',
            featureList: 'Real to Anime, Pixar Filter, Frame Consistency, 2D/3D Styles',
        },
        videoUpscaler: {
            title: 'Free AI Video Upscaler & Enhancer - Upscale to 4K Online',
            description: `Instantly upscale low-res videos to 1080p, 2K, and 4K with 微鲤AI's Free AI Video Upscaler. Fix pixelated footage, reduce noise, and enhance video quality online without downloading software.`,
            keywords: 'video upscaler, ai video upscaler, upscale video to 4k, 4k video upscaler, 1080p to 4k upscaler, unblur video, denoise video, fix pixelated video, enhance video quality',
            og_title: 'Free AI Video Upscaler & Enhancer - Upscale to 4K Online',
            og_description: `Instantly upscale low-res videos to 1080p, 2K, and 4K with 微鲤AI's Free AI Video Upscaler. Fix pixelated footage, reduce noise, and enhance video quality online without downloading software.`,
            twitter_title: 'Free AI Video Upscaler & Enhancer - Upscale to 4K Online',
            twitter_description: `Instantly upscale low-res videos to 1080p, 2K, and 4K with 微鲤AI's Free AI Video Upscaler. Fix pixelated footage, reduce noise, and enhance video quality online without downloading software.`,
            page: {
                title1: 'Free AI Video Upscaler & Enhancer',
                title2: `Don't settle for blurry, pixelated footage. Upload your low-resolution videos (360p, 480p, 720p) and use our AI to automatically upscale them to stunning 4K resolution. Our engine not only increases size but also restores details, removes noise, and corrects colors.`,
                feature_title1: 'Upscale to 4K',
                feature_desc1: 'Bring new life to old videos. Convert SD content to HD or 4K with a single click, making them crisp on modern large screens.',
                feature_title2: 'Fix Blurry & Grainy Video',
                feature_desc2: 'Shot in low light? Our AI Denoising algorithm removes digital grain and compression artifacts, making your video look clean and professional.',
                feature_title3: 'Old Footage Restoration',
                feature_desc3: 'Perfect for family archives. Restore faded colors and sharpen details in old home movies or vintage clips.',
                faq: [
                    {
                        question: 'Can I upscale video to 4K online for free?',
                        answer: 'Yes, 微鲤AI allows you to select output resolutions up to 4K (as shown in the tool options). You can try it for free with our daily credits.',
                    },
                    {
                        question: 'How to fix a blurry video?',
                        answer: 'Simply upload the blurry video to our AI Video Upscaler. The AI analyzes the lost pixels and reconstructs the details to unblur the footage effectively.',
                    },
                    {
                        question: 'Does it work on old mobile phone videos?',
                        answer: 'Absolutely. It works best on low-quality videos from old phones or cameras (like 360p or 480p), transforming them into clear 1080p or higher.',
                    },
                    {
                        question: 'How long does the upscaling process take?',
                        answer: 'Upscaling is computationally intensive. However, 微鲤AI uses optimized cloud GPUs to process videos 2x faster than local software. A short clip typically takes a few minutes.',
                    },
                    {
                        question: 'Is it better than Topaz Video AI?',
                        answer: `微鲤AI offers comparable AI quality but runs entirely in your browser. You don't need to buy expensive hardware or install heavy software to get professional results.`,
                    },
                ],
            },
            faq: [
                {
                    question: 'Can I upscale video to 4K online?',
                    answer: 'Yes, 微鲤AI allows you to select output resolutions up to 4K. You can try it for free with our daily credits.',
                },
                {
                    question: 'How to fix a blurry video?',
                    answer: 'Simply upload the blurry video to our AI Video Upscaler. The AI analyzes the lost pixels and reconstructs the details to unblur the footage.',
                },
                {
                    question: 'Is it better than Topaz Video AI?',
                    answer: '微鲤AI offers comparable AI quality but runs entirely in your browser without requiring expensive hardware or installation.',
                },
            ],
            app_name: '微鲤AI Video Upscaler',
            app_desc: 'Free AI Video Upscaler to enhance video quality up to 4K. Fixes blurry videos, removes noise, and restores old footage online.',
            featureList: '4K Upscaling, AI Denoising, Video Sharpening, Color Correction',
        },
        removeVideoSubtitles: {
            title: 'Free AI Video Subtitle Remover - Delete Hardcoded Captions & Text',
            description: `Instantly remove hardcoded subtitles and captions from videos with 微鲤AI's AI Subtitle Eraser. Supports video links and local files. Restores background without blurring using AI in-painting.`,
            keywords: 'remove subtitles from video, delete hardcoded subtitles, ai subtitle remover, erase captions, remove text from tiktok video, video text remover online',
            og_title: 'Free AI Video Subtitle Remover - Delete Hardcoded Captions & Text',
            og_description: `Instantly remove hardcoded subtitles and captions from videos with 微鲤AI's AI Subtitle Eraser. Supports video links and local files. Restores background without blurring using AI in-painting.`,
            twitter_title: 'Free AI Video Subtitle Remover - Delete Hardcoded Captions & Text',
            twitter_description: `Instantly remove hardcoded subtitles and captions from videos with 微鲤AI's AI Subtitle Eraser. Supports video links and local files. Restores background without blurring using AI in-painting.`,
            page: {
                title1: 'Free AI Video Subtitle Remover',
                title2: `Struggling with burned-in captions? 微鲤AI's intelligent algorithm automatically detects and erases hardcoded subtitles, lyrics, and on-screen text from your videos. Paste a link or upload a file to restore a clean, text-free video instantly.`,
                feature_title1: 'Intelligent Text Detection',
                feature_desc1: 'No manual masking needed. Our AI automatically identifies text areas at the bottom of the screen (or anywhere) and separates them from the background.',
                feature_title2: 'Seamless In-painting',
                feature_desc2: 'Say goodbye to blurry boxes. 微鲤AI fills the erased text area by analyzing surrounding pixels, reconstructing textures like grass, sand, or crowds naturally.',
                feature_title3: 'Link & File Support',
                feature_desc3: 'Remove captions directly from TikTok, YouTube, or Instagram links, or upload MP4/MOV files. Perfect for content repurposing.',
                faq: [
                    {
                        question: 'Can I remove hardcoded (burned-in) subtitles?',
                        answer: 'Yes. This tool is specifically designed for hardcoded subtitles that are part of the video image and cannot be turned off. It erases them visually.',
                    },
                    {
                        question: 'How to remove captions from a TikTok/YouTube video?',
                        answer: 'Simply copy the video link, paste it into the "Video Link" tab on 微鲤AI, and click "Generate". The AI will remove the captions and let you download the clean video.',
                    },
                    {
                        question: 'Will it remove the background behind the text?',
                        answer: 'No. 微鲤AI uses AI In-painting technology. It removes the text and intelligently "repaints" the background behind it, so the video looks original and complete.',
                    },
                    {
                        question: 'What is the difference between this and the Watermark Remover?',
                        answer: 'While similar, the Subtitle Remover is optimized for text strips, lyrics, and captions usually found at the bottom of the screen, whereas the Watermark Remover focuses on logos and stamps.',
                    },
                    {
                        question: 'Is it free to use?',
                        answer: 'Yes, you can use our basic subtitle removal features for free with daily credits.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Can I remove hardcoded subtitles?',
                    answer: 'Yes. This tool is specifically designed for hardcoded subtitles that are part of the video image. It erases them visually.',
                },
                {
                    question: 'How to remove captions from a TikTok video link?',
                    answer: `Simply copy the video link, paste it into the 'Video Link' tab on 微鲤AI, and click 'Generate'. The AI will remove the captions automatically.`,
                },
                {
                    question: 'Will it remove the background behind the text?',
                    answer: 'No. 微鲤AI uses AI In-painting technology to remove the text and intelligently repaints the background behind it.',
                },
            ],
            app_name: '微鲤AI Video Subtitle Remover',
            app_desc: 'Free AI tool to erase hardcoded subtitles, captions, and text from videos. Supports in-painting technology to restore backgrounds without blurring.',
            featureList: 'Hardcoded Subtitle Removal, AI Background Restoration, Video Link Support, Lyrics Eraser',
        },
        videoBackgroundRemover: {
            title: 'Free AI Video Background Remover - No Green Screen & Transparent',
            description: `Automatically remove video backgrounds in one click with 微鲤AI's Free Video Background Remover. Export transparent videos (WebM/MOV) or change background color without a green screen. Hair-level precision.`,
            keywords: 'video background remover, remove background from video, video transparent background, ai green screen, remove video bg, free rotoscoping ai',
            og_title: 'Free AI Video Background Remover - No Green Screen & Transparent',
            og_description: `Automatically remove video backgrounds in one click with 微鲤AI's Free Video Background Remover. Export transparent videos (WebM/MOV) or change background color without a green screen. Hair-level precision.`,
            twitter_title: 'Free AI Video Background Remover - No Green Screen & Transparent',
            twitter_description: `Automatically remove video backgrounds in one click with 微鲤AI's Free Video Background Remover. Export transparent videos (WebM/MOV) or change background color without a green screen. Hair-level precision.`,
            page: {
                title1: 'Free AI Video Background Remover',
                title2: 'No green screen? No problem. Upload your video, and our AI automatically detects the subject, cuts it out with hair-level precision, and lets you download a transparent video or replace the background with a solid color instantly',
                feature_title1: 'No Green Screen Needed',
                feature_desc1: 'Forget expensive studio setups. Our AI separates humans, pets, and objects from complex, messy backgrounds automatically (Auto-Rotoscoping).',
                feature_title2: 'Solid Color Replacement',
                feature_desc2: 'Perfect for E-commerce. Change your product video background to pure white, black, or custom colors in one click to boost sales conversion.',
                feature_title3: 'Transparent Export',
                feature_desc3: 'Download your clip with an Alpha Channel (WebM/MOV). Easily overlay your subject onto any other video in editors like Premiere Pro, DaVinci Resolve, or CapCut.',
                faq: [
                    {
                        question: 'Can I remove video background without a green screen?',
                        answer: 'Yes! 微鲤AI uses advanced machine learning to distinguish the subject from the background, meaning you can remove backgrounds from videos filmed anywhere—your bedroom, the street, or an office.',
                    },
                    {
                        question: 'How do I save a video with a transparent background?',
                        answer: 'After removing the background, select WebM (Transparent) or MOV as your output format. Standard MP4 does not support transparency and will show a black background.',
                    },
                    {
                        question: 'Can I change the video background to white?',
                        answer: 'Yes. In the tool settings, use the "Background Color" picker to select white, black, or any specific hex code. This is ideal for Amazon or Shopify product videos.',
                    },
                    {
                        question: 'Does it handle hair well?',
                        answer: '微鲤AI excels at fine detail preservation. Our algorithm is trained to handle complex edges like frizzy hair, fur, and semi-transparent objects (like glasses).',
                    },
                    {
                        question: 'Is it free to use?',
                        answer: 'Yes, you can process videos for free using our daily credits.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Can I remove video background without a green screen?',
                    answer: 'Yes! 微鲤AI uses advanced machine learning to distinguish the subject from the background without needing a green screen.',
                },
                {
                    question: 'How do I save a video with a transparent background?',
                    answer: 'Select WebM (Transparent) or MOV as your output format. Standard MP4 does not support transparency.',
                },
                {
                    question: 'Can I change the video background to white?',
                    answer: 'Yes. Use the Background Color picker to select white, ideal for e-commerce product videos.',
                },
            ],
            app_name: '微鲤AI Video Background Remover',
            app_desc: 'Free AI tool to remove video backgrounds without a green screen. Export transparent videos or change background to white/black online.',
            featureList: 'No Green Screen, Transparent Video Export, Background Color Change, Hair Precision',
            step_name: 'How to remove video background online',
            step_list: [
                {
                    name: 'Upload Video',
                    text: 'Upload your footage (MP4, MOV) to 微鲤AI Background Remover.',
                },
                {
                    name: 'Remove Background',
                    text: 'The AI automatically processes the video. You can choose to leave it transparent or select a new background color.',
                },
                {
                    name: 'Export',
                    text: 'Download the result. Choose WebM/MOV for transparency or MP4 for solid backgrounds.',
                },
            ],
        },
        aiVideoExtender: {
            title: 'Free AI Video Extender - Extend Video Length & Create Slow Mo',
            description: 'Automatically extend short clips using AI Video Extender. Use text prompts to predict future frames, generate seamless loops, or create smooth slow motion. Powered by generative AI.',
            keywords: 'ai video extender, extend video length, outpaint video, ai slow motion, video loop maker, frame interpolation, generative video fill',
            og_title: 'Free AI Video Extender - Extend Video Length & Create Slow Mo',
            og_description: 'Automatically extend short clips using AI Video Extender. Use text prompts to predict future frames, generate seamless loops, or create smooth slow motion. Powered by generative AI.',
            twitter_title: 'Free AI Video Extender - Extend Video Length & Create Slow Mo',
            twitter_description: 'Automatically extend short clips using AI Video Extender. Use text prompts to predict future frames, generate seamless loops, or create smooth slow motion. Powered by generative AI.',
            page: {
                title1: 'Free AI Video Extender & Continuation',
                title2: 'Is your video too short? 微鲤AI uses generative AI to predict and generate new frames, extending your video clip seamlessly. You can even use text prompts to guide how the video continues, or turn standard footage into silky smooth slow motion.',
                feature_title1: 'Smart Generative Extension',
                feature_desc1: `Don't just stretch the video; create new content. Enter a prompt like "camera zooms out" or "character turns around," and our AI will hallucinately generate the next 5-10 seconds of footage consistent with the original style.`,
                feature_title2: 'Silky Smooth Slow Motion',
                feature_desc2: 'Transform standard 30fps videos into high-speed slow motion. 微鲤AI uses Frame Interpolation to insert AI-generated frames between existing ones, creating fluid motion without stuttering.',
                feature_title3: 'Perfect Loop Make',
                feature_desc3: 'Create mesmerizing Cinemagraphs and infinite loops for social media backgrounds. Our AI analyzes the start and end frames to blend them perfectly.',
                faq: [
                    {
                        question: 'How does the AI video extender work?',
                        answer: 'It uses "Generative Outpainting" technology. The AI analyzes the last frames of your video and your text prompt to predict and generate new frames that logically follow the original action.',
                    },
                    {
                        question: 'Can I control what happens in the extended part?',
                        answer: 'Yes! Use the "Prompt" box in the tool to describe the action. For example, if your video shows a car driving, you can type "car enters a tunnel" to guide the extension.',
                    },
                    {
                        question: 'What is the difference between Extension and Slow Motion?',
                        answer: 'Extension adds new time to the video by generating new events (making the story longer). Slow Motion stretches existing time by adding intermediate frames (making the action slower). 微鲤AI does both.',
                    },
                    {
                        question: 'How long can I extend a video?',
                        answer: 'You can extend a clip by 5 seconds at a time (as seen in the "Extension Duration" setting). You can repeat the process to create longer sequences.',
                    },
                    {
                        question: 'Is it free?',
                        answer: 'Yes, 微鲤AI offers free credits to try video extension and slow motion effects.',
                    },
                ],
            },
            faq: [
                {
                    question: 'How does the AI video extender work?',
                    answer: 'It uses "Generative Outpainting" technology. The AI analyzes the last frames of your video and your text prompt to predict and generate new frames that logically follow the original action.',
                },
                {
                    question: 'Can I control what happens in the extended part?',
                    answer: 'Yes! Use the "Prompt" box in the tool to describe the action. For example, if your video shows a car driving, you can type "car enters a tunnel" to guide the extension.',
                },
                {
                    question: 'What is the difference between Extension and Slow Motion?',
                    answer: 'Extension adds new time to the video by generating new events (making the story longer). Slow Motion stretches existing time by adding intermediate frames (making the action slower). 微鲤AI does both.',
                },
            ],
            app_name: '微鲤AI Video Extender',
            app_desc: 'Free AI tool to extend video length using generative fill and prompts. Also features AI slow motion (frame interpolation) and video looping.',
            featureList: 'Generative Video Extension, Prompt-guided Continuation, AI Slow Motion, Video Looping',
        },
        videoEffects: {
            title: 'Video Effects - Create Viral Videos with AI | 微鲤AI',
            description: 'Explore popular AI video effects on 微鲤AI. From AI Kissing to AI Dancing, create viral videos with just a few clicks.',
            keywords: 'AI video effects, AI viral videos, video trends, AI kissing, AI dancing, video generator',
        },
        aiDancing: {
            title: 'AI Dancing Video Generator | Photo to Dance Video Maker with Motion Transfer | 微鲤AI',
            description: 'Create dancing videos from any photo using 微鲤AI’s AI Dancing Video Generator. Upload a full-body image and instantly transform it into a smooth, realistic dance video with advanced pose estimation, motion transfer, and trend-driven dance templates. Free to use for social content creation.',
            keywords: 'AI dancing video generator, photo to dance video, AI motion transfer, AI dance maker, image to video dancing, AI pose estimation, 微鲤AI video tools, free AI dancing video',
            og_title: 'AI Dancing Video Generator | Make Photos Dance with AI',
            og_description: 'Upload any full-body photo and turn it into a lively dance video using AI motion transfer. Choose from K-pop, hip-hop, shuffle, meme dances and more—free on 微鲤AI.',
            twitter_title: 'AI Dancing Video Generator | Photo to Dance Video Maker',
            twitter_description: 'Transform any photo into a dynamic dance video with AI motion transfer. Supports popular dance templates, non-human characters, and smooth animation.',
            ogImage: 'https://static.weryai.com/growth/image/07ba2f17e6906f3339f6474b35fb8a33.jpg',
            twitterImage: 'https://static.weryai.com/growth/image/07ba2f17e6906f3339f6474b35fb8a33.jpg',
            ogImageAlt: 'AI Dancing Video Generator by 微鲤AI',
            twitterImageAlt: 'AI Photo Dancing Tool',
        },
        aiKissing: {
            title: 'AI Kissing Video Generator | Make Two Photos Kiss with AI Motion Transfer | 微鲤AI',
            description: 'Create realistic kissing videos from any two photos using 微鲤AI’s AI Kissing Video Generator. Supports French kisses, cheek kisses, playful air kisses, and cross-dimensional kissing between celebrities, anime characters, pets, or objects. Upload two images and generate a smooth, natural kissing animation in seconds—perfect for TikTok, Instagram, and creative social content.',
            keywords: 'AI kissing video generator, photo kissing AI, AI kiss maker, two photos kissing AI, motion transfer kiss, AI romance video, 微鲤AI video tools, AI couple video, French kiss AI, cheek kiss AI',
            og_title: 'AI Kissing Video Generator | Turn Two Photos into a Realistic Kiss',
            og_description: 'Upload two photos and let AI generate a romantic or fun kissing video. Supports French kisses, cheek kisses, air kisses, and cross-dimensional creativity. Try it free on 微鲤AI.',
            twitter_title: 'AI Kissing Video Generator | Create Romantic or Funny AI Kiss Videos',
            twitter_description: 'Transform photos into a smooth, ultra-realistic kissing video using AI motion transfer. Perfect for couples, memes, or creative social content.',
            ogImage: 'https://static.weryai.com/growth/image/18c7b02f915c379b5db138b485815359.jpg',
            twitterImage: 'https://static.weryai.com/growth/image/18c7b02f915c379b5db138b485815359.jpg',
            ogImageAlt: 'AI Kissing Video Generator by 微鲤AI',
            twitterImageAlt: 'Photo to Kissing Video AI',
        },
        videoMotionImitation: {
            title: 'AI Dance Generator & Motion Transfer - Make Photos Dance | 微鲤AI',
            description: `Use 微鲤AI's motion transfer tool to make photos dance or replace a person in a video. Upload a reference video and a character image—AI preserves background, lighting, and tones for seamless results.`,
            keywords: 'motion transfer, make photo dance, ai dance generator, make photos dance, video motion transfer, animate photo to video, photo dance ai',
            og_title: 'AI Dance Generator & Motion Transfer - Make Photos Dance | 微鲤AI',
            og_description: `Use 微鲤AI's motion transfer tool to make photos dance or replace a person in a video. Upload a reference video and a character image—AI preserves background, lighting, and tones for seamless results.`,
            twitter_title: 'AI Dance Generator & Motion Transfer - Make Photos Dance | 微鲤AI',
            twitter_description: `Use 微鲤AI's motion transfer tool to make photos dance or replace a person in a video. Upload a reference video and a character image—AI preserves background, lighting, and tones for seamless results.`,
            page: {
                title1: 'Free AI Dance Generator & Motion Transfer',
                title2: 'Want to see your favorite anime character dance like Michael Jackson? Or make a static photo perform a viral TikTok move? Simply upload a reference video and a character image, and our AI will transfer the motion perfectly.',
                feature_title1: 'Video Character Replacement',
                feature_desc1: 'Real-to-Anime Swap: Upload a video of a real person dancing or fighting, and replace them with a 3D character, panda, or anime avatar while keeping the original background and lighting.',
                feature_title2: 'Make Photos Dance',
                feature_desc2: 'Animate Static Images: Bring still photos to life. Upload a photo of yourself or a character, pick a reference dance video, and watch the photo mimic the moves perfectly. Ideal for creating Viggle-style viral content.',
                feature_title3: 'Break Dimension Walls',
                feature_desc3: `Cross-Dimensional Styles: Whether it's turning a ballerina into an anime girl or a karate kid into a panda, 微鲤AI handles complex body structures and occlusions seamlessly.`,
                faq: [
                    {
                        question: 'How do I make a photo dance with AI?',
                        answer: `Use 微鲤AI's "Move Mode". Upload the photo you want to animate (Character Image) and a video showing the dance moves (Reference Video). Click Create to transfer the motion.`,
                    },
                    {
                        question: 'What is the difference between Move Mode and Replace Mode?',
                        answer: `Move Mode animates a static image using a video's motion. Replace Mode replaces the person inside an existing video with a new character from an image.`,
                    },
                    {
                        question: 'Can I use this for TikTok trends?',
                        answer: 'Yes! This tool is perfect for TikTok challenges. You can make celebrities, anime characters, or friends perform trending dances without them actually learning the moves.',
                    },
                    {
                        question: 'Does it work on full-body shots?',
                        answer: 'Yes. For best results, ensure both the reference video and the character image show the full body clearly, so the AI can track limbs accurately.',
                    },
                    {
                        question: 'Is it free?',
                        answer: 'Yes, you can create motion transfer videos for free using your daily credits.',
                    },
                ],
            },
            faq: [
                {
                    question: 'How do I make a photo dance with AI?',
                    answer: `Use 微鲤AI's "Move Mode". Upload the photo you want to animate (Character Image) and a video showing the dance moves (Reference Video). Click Create to transfer the motion.`,
                },
                {
                    question: 'What is the difference between Move Mode and Replace Mode?',
                    answer: `Move Mode animates a static image using a video's motion. Replace Mode replaces the person inside an existing video with a new character from an image.`,
                },
            ],
            app_name: '微鲤AI Video Motion Transfer',
            app_desc: 'Free AI Dance Generator and Motion Transfer tool. Make photos dance, animate static images, and swap video characters online.',
            featureList: 'AI Dance Generation, Body Pose Transfer, Video Character Swap, Animate Photo',
            step_name: 'How to make a photo dance with AI',
            step_list: [
                {
                    name: 'Upload Reference Video',
                    text: 'Upload a video that contains the dance moves or motion you want to copy.',
                },
                {
                    name: 'Upload Character Image',
                    text: 'Upload the static photo of the person or character you want to animate.',
                },
                {
                    name: 'Select Move Mode',
                    text: `Choose 'Move Mode' and click Create. The AI will make the photo perform the moves from the video.`,
                },
            ],
        },
    },
    zh: {
        textToMusic: {
            title: '文生音乐 - AI 音乐生成器与配乐创作 | 微鲤AI',
            description: '输入主题、风格或歌词即可生成 AI 音乐，支持人声/纯音乐、时长与氛围选择，并可参考音频生成相似质感。适用于短视频、直播、游戏与广告配乐，支持下载与分享；同时提供公开可见与版权保护设置，方便内容分发与商用管理，立即免费试用。',
            keywords: '文生音乐, AI音乐生成器, 歌词生成音乐, 人声歌曲生成, 纯音乐生成, 参考音频, 配乐制作, 免版税音乐, 免费试用, 微鲤AI',
        },
        textToVideo: {
            title: '文生视频 - 免费 AI 文本生成视频工具 | 微鲤AI',
            description: '输入提示词即可生成短视频，支持竖屏/横屏比例、时长与清晰度选择，并可开启生成音频、续写延长与去水印流程。支持多风格与多分辨率导出，可批量迭代更快出片，适用于营销投放、社媒内容与创意短片制作，立即免费试用。',
            keywords: '文生视频, 文本转视频, AI视频生成器, 竖屏视频, 横屏视频, 生成音频, 视频延长, 去水印, 微鲤AI',
            og_title: '文生视频 - 免费 AI 文本生成视频工具 | 微鲤AI',
            og_description: '输入提示词即可生成短视频，支持竖屏/横屏比例、时长与清晰度选择，并可开启生成音频、续写延长与去水印流程。支持多风格与多分辨率导出，可批量迭代更快出片，适用于营销投放、社媒内容与创意短片制作，立即免费试用。',
            twitter_title: '文生视频 - 免费 AI 文本生成视频工具 | 微鲤AI',
            twitter_description: '输入提示词即可生成短视频，支持竖屏/横屏比例、时长与清晰度选择，并可开启生成音频、续写延长与去水印流程。支持多风格与多分辨率导出，可批量迭代更快出片，适用于营销投放、社媒内容与创意短片制作，立即免费试用。',
            page: {
                title1: '免费 AI 文生视频生成器',
                title2: '只需输入一段提示词，就能看到微鲤AI把你的想法变成视频。支持社媒竖屏（9:16）与电影横屏（16:9），可选择时长与清晰度，并可生成匹配音效，几步快速出片。',
                intro_title: '用文生视频 AI 将想象变为现实',
                feature_title: '微鲤AI 文生视频的核心功能',
                faq_title: '文生视频常见问题',
                feature_title1: '多模型强力聚合',
                feature_desc1: '同一面板内可切换不同风格与侧重点的模型能力，无需分别订阅多个平台，快速对比并选出最适合你场景的效果。',
                feature_title2: '自定义画面比例',
                feature_desc2: '直接生成 9:16 竖屏视频（TikTok/Reels）或 16:9 横屏视频（YouTube/电影项目）。',
                feature_title3: '更长时长',
                feature_desc3: '单次生成最长 8 秒（不同模型略有差异），也可用 AI 视频延长工具无缝续写，适合叙事内容。',
                faq: [
                    {
                        question: '如何写出好的文生视频提示词？',
                        answer: '尽量具体：描述主体、动作、光线与镜头语言。例如：“夜晚的未来赛博朋克城市航拍镜头，霓虹灯，4K 质感”。微鲤AI 集成的模型对复杂描述理解更好。',
                    },
                    {
                        question: '我该如何选择更适合的模型？',
                        answer: '建议用同一段提示词分别生成对比：写实、光影与细节更重要时优先选画面质感更强的模型；动作一致性与镜头运动更重要时选择运动更稳定的模型。以你的具体场景结果为准。',
                    },
                    {
                        question: '微鲤AI 的文生视频是免费的吗？',
                        answer: '是的，每位用户每天都会获得免费积分用于体验文生视频。你可以生成多个片段来测试不同提示词与模型。',
                    },
                    {
                        question: '我可以生成超过 8 秒的视频吗？',
                        answer: '基础生成通常最长可到 8 秒（取决于模型）。想要更长视频，可使用我们的 AI 视频延长工具，在保持风格与内容连贯的前提下继续生成。',
                    },
                    {
                        question: '生成的视频会带声音吗？',
                        answer: '会的。你可以开启“生成音频（Generate Audio）”开关，自动生成匹配的音效与环境氛围声。',
                    },
                ],
            },
            faq: [
                {
                    question: '如何写出好的文生视频提示词？',
                    answer: '尽量具体：描述主体、动作、光线与镜头语言。例如：“夜晚的未来赛博朋克城市航拍镜头，霓虹灯，4K 质感”。',
                },
                {
                    question: '我该如何选择更适合的模型？',
                    answer: '用同一段提示词分别生成对比，优先选择在你目标风格与动作稳定性上表现更符合预期的结果即可。',
                },
                {
                    question: '微鲤AI 的文生视频是免费的吗？',
                    answer: '是的，每天提供免费积分用来从文本生成视频。',
                },
                {
                    question: '我可以生成超过 8 秒的视频吗？',
                    answer: '基础生成通常最长到 8 秒；更长时长可使用 AI 视频延长工具无缝续写。',
                },
                {
                    question: '生成的视频会带声音吗？',
                    answer: '可以。开启“生成音频”开关即可自动生成匹配的音效与氛围声。',
                },
            ],
        },
        imageToVideo: {
            title: '图生视频 - 免费 AI 图片生成视频工具 | 微鲤AI',
            description: '上传照片或插画即可生成动态视频，支持多风格、镜头运动与分辨率选择，并可一键续写延长。适用于产品展示、人物动作、社媒内容与创意剪辑，也适合电商主图动效与海报视频化；支持多次生成对比挑选更自然镜头，支持无水印下载，立即免费试用。',
            keywords: '图生视频, 图片转视频, AI视频生成器, 图片动画, 镜头运动, 视频延长, 无水印下载, 微鲤AI',
            og_title: '图生视频 - 免费 AI 图片生成视频工具 | 微鲤AI',
            og_description: '上传照片或插画即可生成动态视频，支持多风格、镜头运动与分辨率选择，并可一键续写延长。适用于产品展示、人物动作、社媒内容与创意剪辑，也适合电商主图动效与海报视频化；支持多次生成对比挑选更自然镜头，支持无水印下载，立即免费试用。',
            twitter_title: '图生视频 - 免费 AI 图片生成视频工具 | 微鲤AI',
            twitter_description: '上传照片或插画即可生成动态视频，支持多风格、镜头运动与分辨率选择，并可一键续写延长。适用于产品展示、人物动作、社媒内容与创意剪辑，也适合电商主图动效与海报视频化；支持多次生成对比挑选更自然镜头，支持无水印下载，立即免费试用。',
            page: {
                title1: '免费在线 AI 图生视频生成器',
                faq: [
                    {
                        question: 'AI 图生视频生成器是怎么工作的？',
                        answer: '它会分析你的静态图片并预测运动轨迹，生成连贯的短视频片段；你也可以通过提示词与参数控制动作、镜头与整体风格走向。',
                    },
                    {
                        question: '微鲤AI 的图生视频是免费的吗？',
                        answer: '是的，我们每天提供免费积分，方便你体验图生视频 AI。你也可以升级以解锁更高级的模型与更快的生成速度。',
                    },
                    {
                        question: '如何生成更真实、更稳定的动态效果？',
                        answer: '建议优先使用清晰主体的图片，并在提示词里明确动作与镜头语言；生成后可通过多次迭代对比，选择更符合“细节清晰 + 动作稳定”的结果。',
                    },
                    {
                        question: '生成的视频可以商用吗？',
                        answer: '可以。在付费计划下生成的视频包含商业授权，非常适合用于 YouTube、TikTok 与营销广告。',
                    },
                    {
                        question: '如何去除 AI 视频水印？',
                        answer: '微鲤AI 提供高质量输出。如需无水印视频，请核对你的套餐权益，或使用我们的专用 AI 去水印工具。',
                    },
                ],
            },
            faq: [
                {
                    question: 'AI 图生视频生成器是怎么工作的？',
                    answer: '它会分析静态图片并预测运动轨迹，生成连贯的短视频片段；你也可以通过提示词控制动作与风格。',
                },
                {
                    question: '微鲤AI 的图生视频是免费的吗？',
                    answer: '是的，我们每天提供免费积分，方便你体验图生视频 AI。你也可以升级以解锁更高级的模型与更快的生成速度。',
                },
                {
                    question: '生成的视频可以商用吗？',
                    answer: '可以。在付费计划下生成的视频包含商业授权，非常适合用于 YouTube、TikTok 与营销广告。',
                },
            ],
        },
        videoToVideo: {
            title: '免费 AI 视频转视频生成器 - 在线换风格与动漫滤镜 | 微鲤AI',
            description: '使用微鲤AI的视频转视频 AI，将你的视频一键重绘为任意风格：把真人素材变成动漫、3D 卡通或赛博朋克艺术，同时尽量保持原始动作与结构稳定。支持短片快速出片与多风格尝试，适用于创作者与营销素材制作，立即免费试用。',
            keywords: '视频转视频AI, vid2vid, AI视频风格迁移, 视频变动漫, AI视频重风格, 免费AI视频滤镜',
            og_title: '免费 AI 视频转视频生成器 - 在线换风格与动漫滤镜 | 微鲤AI',
            og_description: '使用微鲤AI的视频转视频 AI，将你的视频一键重绘为任意风格：把真人素材变成动漫、3D 卡通或赛博朋克艺术，同时尽量保持原始动作与结构稳定。支持短片快速出片与多风格尝试，适用于创作者与营销素材制作。',
            twitter_title: '免费 AI 视频转视频生成器 - 在线换风格与动漫滤镜 | 微鲤AI',
            twitter_description: '使用微鲤AI的视频转视频 AI，将你的视频一键重绘为任意风格：把真人素材变成动漫、3D 卡通或赛博朋克艺术，同时尽量保持原始动作与结构稳定。支持短片快速出片与多风格尝试，适用于创作者与营销素材制作。',
            page: {
                title1: '免费 AI 视频转视频生成器（Vid2Vid）',
                title2: '上传一个视频，输入想要的风格，看魔法发生。微鲤AI 的视频转视频技术会分析源视频的动作，并基于你的文本提示为其应用全新的艺术风格。非常适合制作动漫剪辑、黏土动画效果或超现实视觉艺术。',
                feature_title1: '动作一致性',
                feature_desc1: '不同于普通生成，我们的 Vid2Vid 引擎会锁定源视频的运动轨迹，确保转场更顺滑、减少闪烁。',
                feature_title2: '真人转动漫',
                feature_desc2: '内容创作者的热门选择：把自己一键变成动漫角色或 3D 皮克斯风格的形象。',
                feature_title3: '提示词可控',
                feature_desc3: '你拥有完整的创作控制权。只要输入“赛博朋克城市风格”或“油画风格”，即可定义输出的具体观感。',
                faq: [
                    {
                        question: '什么是 AI 视频转视频（Vid2Vid）？',
                        answer: '视频转视频是一种生成式 AI 流程：以现有视频片段为输入，根据你的文本提示“重绘”成新的风格，同时尽量保留原始动作与结构。',
                    },
                    {
                        question: '我可以把视频变成动漫风格吗？',
                        answer: '可以！这是最常见的用法。上传视频后输入类似“日系动漫风格、吉卜力画风”等提示词即可转换。',
                    },
                    {
                        question: '源视频最长支持多长？',
                        answer: '目前我们更适合处理短片段（例如 5–10 秒）以确保最佳风格迁移质量。更长视频建议分段处理。',
                    },
                    {
                        question: '它和传统视频剪辑软件有什么区别？',
                        answer: '有区别。传统剪辑是裁剪与拼接素材；微鲤AI 的视频转视频会生成新的像素，彻底改变素材纹理与艺术风格。',
                    },
                    {
                        question: '需要付费吗？',
                        answer: '微鲤AI 提供每日免费积分用于体验视频转视频功能；也有高级套餐可获得更快处理与无水印下载。',
                    },
                ],
            },
            faq: [
                {
                    question: '什么是 AI 视频转视频（Vid2Vid）？',
                    answer: '视频转视频是一种生成式 AI 流程：以现有视频为输入，根据你的文本提示重绘成新风格，同时保留原始动作与结构。',
                },
                {
                    question: '我可以把视频变成动漫风格吗？',
                    answer: '可以。上传视频并输入“日系动漫风格、吉卜力画风”等提示词即可转换。',
                },
                {
                    question: '源视频最长支持多长？',
                    answer: '更适合短片段（例如 5–10 秒）以保证质量；更长视频建议分段处理。',
                },
                {
                    question: '它和传统视频剪辑软件有什么区别？',
                    answer: '传统剪辑是裁剪拼接；视频转视频会生成新像素，改变纹理与艺术风格。',
                },
                {
                    question: '需要付费吗？',
                    answer: '提供每日免费积分；升级套餐可获得更快速度与无水印下载。',
                },
            ],
        },
        removeWatermark: {
            title: '免费在线 AI 视频去水印 - 删除 Logo、文字与字幕 | 微鲤AI',
            description: '使用 微鲤AI 免费 AI 去水印工具，轻松去除视频中的水印、Logo、字幕与日期时间戳。支持 MP4/MOV 与视频链接导入。不糊不虚化，AI 无痕修复更干净。',
            keywords: '视频去水印, 去除视频水印, 视频水印去除, 在线视频去水印, 免费在线去水印, AI视频橡皮擦, AI去水印, 无痕去水印, 不裁剪去水印, 不模糊去水印, 去除视频logo, 去除视频文字, 删除字幕, 删除时间戳, 删除日期水印, MP4去水印, MOV去水印, 视频链接去水印, TikTok去水印',
            og_title: '免费在线 AI 视频去水印 - 删除 Logo、文字与字幕 | 微鲤AI',
            og_description: '使用 微鲤AI 免费 AI 去水印工具，轻松去除视频中的水印、Logo、字幕与日期时间戳。支持 MP4/MOV 与视频链接导入。不糊不虚化，AI 无痕修复更干净。',
            twitter_title: '免费在线 AI 视频去水印 - 删除 Logo、文字与字幕 | 微鲤AI',
            twitter_description: '使用 微鲤AI 免费 AI 去水印工具，轻松去除视频中的水印、Logo、字幕与日期时间戳。支持 MP4/MOV 与视频链接导入。不糊不虚化，AI 无痕修复更干净。',
            page: {
                title1: '免费在线 AI 视频去水印工具',
                title2: '一键擦除视频里的水印、Logo、文字叠加层与字幕。粘贴视频链接或上传文件，框选区域后让 AI 逐帧无痕补全背景，不再使用难看的模糊遮盖。',
                click_erase: '1.一键擦除：AI 自动识别并移除常见水印。',
                percision_erase: '2.精细擦除：使用画笔手动移除移动字幕、时间戳等复杂对象。',
                video_link_title: '链接导入',
                direct_link_desc: '1.直链去水印：粘贴社交平台视频链接，无需先下载源文件即可去水印。',
                lossless_qua_title: '2.无损画质：不同于传统模糊处理，微鲤AI 会分析周围像素并重建背景细节。',
                faq: [
                    {
                        question: '如何免费在线去除视频水印？',
                        answer: '把视频上传到 微鲤AI 或直接粘贴视频链接。用选框覆盖水印区域后点击“Generate（生成）”，即可免费试用。',
                    },
                    {
                        question: '可以去除移动字幕或动态文字吗？',
                        answer: '可以。切换到“Precision Erase（精细擦除）”模式，选中字幕/文字区域。AI 会跟踪水印在各帧中的位置，确保整段视频都能干净移除。',
                    },
                    {
                        question: '支持 TikTok 或 YouTube 的视频吗？',
                        answer: '当然支持。你可以移除平台 Logo（例如 TikTok 跳动水印）或频道水印，用于个人用途获得更干净的视频。',
                    },
                    {
                        question: '去除后的区域会变糊吗？',
                        answer: '不会。微鲤AI 使用先进的“视频修复（Video In‑painting）”技术，根据周围画面生成真实纹理来填补擦除区域，避免难看的模糊效果。',
                    },
                    {
                        question: '支持哪些视频格式？',
                        answer: '我们支持主流格式，包括 MP4、MOV、AVI 和 WebM。',
                    },
                ],
            },
            faq: [
                {
                    question: '如何免费在线去除视频水印？',
                    answer: '上传视频或粘贴链接，框选水印区域后点击“Generate（生成）”，即可免费试用。',
                },
                {
                    question: '可以去除移动字幕或动态文字吗？',
                    answer: '可以。使用“Precision Erase（精细擦除）”并框选文字区域，AI 会跨帧跟踪并清理。',
                },
                {
                    question: '去除后的区域会变糊吗？',
                    answer: '不会。我们用“视频修复（Video In‑painting）”生成真实纹理填补区域，避免模糊。',
                },
            ],
        },
        videoFaceSwap: {
            title: '免费在线 AI 视频换脸 - 真实 Deepfake 生成器 | 微鲤AI',
            description: '使用 微鲤AI 的 AI 视频换脸器，一键替换视频中的人脸。免费制作搞笑电影片段、表情包和逼真的 deepfake。支持无水印选项。100% 私密安全。',
            keywords: '视频换脸, AI换脸器, 免费deepfake生成器, 替换视频人脸, 电影换脸, 在线换脸, AI表情包制作',
            og_title: '免费在线 AI 视频换脸 - 真实 Deepfake 生成器 | 微鲤AI',
            og_description: '使用 微鲤AI 的 AI 视频换脸器，一键替换视频中的人脸。免费制作搞笑电影片段、表情包和逼真的 deepfake。支持无水印选项。100% 私密安全。',
            twitter_title: '免费在线 AI 视频换脸 - 真实 Deepfake 生成器 | 微鲤AI',
            twitter_description: '使用 微鲤AI 的 AI 视频换脸器，一键替换视频中的人脸。免费制作搞笑电影片段、表情包和逼真的 deepfake。支持无水印选项。100% 私密安全。',
            page: {
                title1: '免费 AI 视频换脸',
                title2: '成为任何电影的主角！上传一段视频片段和一张目标人脸照片，让 AI 无缝完成换脸。非常适合制作搞笑梗图、个性化祝福视频或高保真的视觉特效。',
                feature_title1: '超真实 Deepfake',
                feature_desc1: 'AI 会分析面部几何与光照，让新脸自然融合，并保留原始表情与头部运动。',
                feature_title2: '隐私优先',
                feature_desc2: '我们重视你的隐私。上传的视频与图片将被安全处理，并在生成后不久从服务器删除。',
                feature_title3: '零技术门槛',
                feature_desc3: '无需 After Effects 等复杂软件。只要点击“Create”，几秒钟就能得到电影级效果。',
                faq: [
                    {
                        question: '微鲤AI 的视频换脸免费吗？',
                        answer: '是的，我们提供免费积分，方便你在线体验视频换脸。开始创作搞笑片段不需要信用卡。',
                    },
                    {
                        question: '上传我的照片安全吗？',
                        answer: '当然安全。我们采用严格的数据保护机制。源视频与目标人脸图片仅用于生成过程，不会被永久保存。',
                    },
                    {
                        question: '我可以给 GIF 换脸吗？',
                        answer: '可以！微鲤AI 同时支持视频（MP4/MOV）与 GIF 格式，你可以轻松制作个性化反应动图。',
                    },
                    {
                        question: '如何获得最佳换脸效果？',
                        answer: '建议使用清晰、正脸、光线充足的“目标人脸”照片。尽量避免头发或眼镜遮挡面部的照片。',
                    },
                    {
                        question: '可以用于商业项目吗？',
                        answer: '可以，但请确保你拥有原视频素材与被替换人脸肖像的合法授权与使用权。',
                    },
                ],
            },
            faq: [
                {
                    question: '微鲤AI 的视频换脸免费吗？',
                    answer: '是的，我们提供免费积分让你在线体验视频换脸，开始无需信用卡。',
                },
                {
                    question: '上传我的照片安全吗？',
                    answer: '当然安全。我们使用严格的数据保护机制，素材仅用于生成过程。',
                },
                {
                    question: '如何获得最佳换脸效果？',
                    answer: '使用清晰、正脸、光线充足的目标人脸照片，避免头发或眼镜遮挡。',
                },
            ],
        },
        videoLipSync: {
            title: '免费 AI 视频对口型生成器 - 音频/文本同步到视频 | 微鲤AI',
            description: '使用 微鲤AI 的 AI 对口型工具，将口型与任意音频或文本精准同步。由 Kling AI 驱动，适合视频翻译、配音与会说话头像创作。免费在线使用。',
            keywords: '视频对口型, 口型同步, AI对口型, 视频配音, 语音同步, 说话视频, 对口型工具',
            og_title: '免费 AI 视频对口型生成器 - 音频/文本同步到视频 | 微鲤AI',
            og_description: '使用 微鲤AI 的 AI 对口型工具，将口型与任意音频或文本精准同步。由 Kling AI 驱动，适合视频翻译、配音与会说话头像创作。免费在线使用。',
            twitter_title: '免费 AI 视频对口型生成器 - 音频/文本同步到视频 | 微鲤AI',
            twitter_description: '使用 微鲤AI 的 AI 对口型工具，将口型与任意音频或文本精准同步。由 Kling AI 驱动，适合视频翻译、配音与会说话头像创作。免费在线使用。',
            page: {
                title1: '免费 AI 视频对口型与配音工具',
                title2: '告别尴尬的配音视频。上传视频与音频文件（或输入文本），AI 将重新生成说话者口型以精准匹配声音。由 Kling AI 驱动，支持多语言配音与更真实的面部肌肉细节。',
                dual_input_modes: '双输入模式',
                audio_sync: '音频同步',
                text_sync: '文本转语音',
                text_sync_tip: '输入任意文本，选择一个预设 AI 声音，让角色立刻开口说话。',
                audio_sync_tip: '上传你自己的配音或歌曲进行同步。',
                feature_title1: '多语言配音',
                feature_desc1: '拓展你的受众。将视频翻译成西班牙语、法语或日语，并同步口型，让说话者看起来像母语者一样自然。',
                feature_title2: 'Kling AI 精准度',
                feature_desc2: '不同于基础的 Wav2Lip 工具，我们使用 Kling 模型确保牙齿、舌头与下颌运动更符合真实解剖结构。',
                faq: [
                    {
                        question: '如何让视频口型与音频同步？',
                        answer: '将视频片段上传到 微鲤AI。然后上传音频文件（MP3/WAV）或输入文本生成 AI 语音。点击“Create”，AI 会自动调整口型以匹配声音。',
                    },
                    {
                        question: '可以用于视频翻译/配音吗？',
                        answer: '可以！这非常适合做配音。你可以上传翻译后的音轨，AI 会修正口型同步，让配音版本看起来更自然。',
                    },
                    {
                        question: '静态图片也能用吗（说话头像）？',
                        answer: '可以。如果你把一张静态人像照片作为“视频”源上传，工具会将其动画化为会说话的头像视频（Live Portrait 效果）。',
                    },
                    {
                        question: '支持哪些语言？',
                        answer: '由于技术会分析音频波形，因此适用于任何语言（英语、西班牙语、中文、印地语等）。如果使用文本转语音输入，我们支持 50+ 种语言。',
                    },
                    {
                        question: '对口型是免费的吗？',
                        answer: '微鲤AI 提供每日免费积分用于体验对口型功能。若需更长视频或商业用途，可选择高级套餐。',
                    },
                ],
            },
            faq: [
                {
                    question: '如何让视频口型与音频同步？',
                    answer: '将视频片段上传到 微鲤AI。然后上传音频文件（MP3/WAV）或输入文本生成 AI 语音。点击“Create”，AI 会自动调整口型以匹配声音。',
                },
                {
                    question: '可以用于视频翻译/配音吗？',
                    answer: '可以！这非常适合做配音。你可以上传翻译后的音轨，AI 会修正口型同步，让配音版本看起来更自然。',
                },
                {
                    question: '静态图片也能用吗（说话头像）？',
                    answer: '可以。如果你把一张静态人像照片作为“视频”源上传，工具会将其动画化为会说话的头像视频（Live Portrait 效果）。',
                },
            ],
        },
        translateVideoSubtitle: {
            title: '免费 AI 视频字幕翻译器 - 自动生成字幕并在线翻译 | 微鲤AI',
            description: '使用 微鲤AI 的 AI 字幕翻译器，自动生成并翻译视频字幕。支持中文、英文、西班牙语等 90+ 种语言，一键下载已烧录字幕（硬字幕）的成品视频。',
            keywords: 'AI字幕翻译, 视频字幕翻译器, 多语言字幕, 视频翻译, 字幕转换器, AI视频翻译',
            og_title: '免费 AI 视频字幕翻译器 - 自动生成字幕并在线翻译 | 微鲤AI',
            og_description: '使用 微鲤AI 的 AI 字幕翻译器，自动生成并翻译视频字幕。支持中文、英文、西班牙语等 90+ 种语言，一键下载已烧录字幕（硬字幕）的成品视频。',
            twitter_title: '免费 AI 视频字幕翻译器 - 自动生成字幕并在线翻译 | 微鲤AI',
            twitter_description: '使用 微鲤AI 的 AI 字幕翻译器，自动生成并翻译视频字幕。支持中文、英文、西班牙语等 90+ 种语言，一键下载已烧录字幕（硬字幕）的成品视频。',
            page: {
                title1: '免费 AI 视频字幕翻译器',
                title2: '一键打破语言障碍。上传视频，选择目标语言，AI 将自动识别语音、转写音频，并把准确的翻译字幕直接烧录到视频文件中。',
                feature_title1: '支持 90+ 种语言',
                feature_desc1: '将内容从英文翻译到西班牙语、法语、德语、日语、中文等更多语言，一键触达全球观众。',
                feature_title2: '自动对齐并烧录字幕',
                feature_desc2: '无需手动调整时间轴。AI 保证字幕与音频精准同步，并以硬字幕（Hardsubs）形式烧录到视频中，平台兼容性更强。',
                feature_title3: '理解语境，更自然准确',
                feature_desc3: '由先进大模型驱动，微鲤AI 能理解上下文与俚语，让翻译更自然，不是机械直译。',
                faq: [
                    {
                        question: '如何自动翻译视频字幕？',
                        answer: '把视频上传到 微鲤AI，选择“目标语言”（例如英文→西班牙语），然后点击“Create”。AI 会自动生成并翻译字幕。',
                    },
                    {
                        question: '支持哪些翻译语言？',
                        answer: '我们支持 90+ 种全球语言，包括英语、西班牙语、法语、德语、葡萄牙语、印地语、日语和中文等。',
                    },
                    {
                        question: '字幕翻译器是免费的吗？',
                        answer: '是的，微鲤AI 提供 AI 视频字幕翻译器的免费使用，你无需支付昂贵的转写服务费用即可处理视频。',
                    },
                    {
                        question: '需要下载 SRT 文件吗？',
                        answer: '不需要。微鲤AI 会生成已烧录字幕的视频（硬字幕），字幕文字已成为视频画面的一部分，能确保在 TikTok、Instagram 和 YouTube 等平台正确显示。',
                    },
                    {
                        question: 'AI 翻译准确率如何？',
                        answer: '我们使用业界领先的语音识别模型来确保高准确率。音频清晰时，准确率可超过 95%。',
                    },
                ],
            },
            faq: [
                {
                    question: '如何自动翻译视频字幕？',
                    answer: '把视频上传到 微鲤AI，选择“目标语言”（例如英文→西班牙语），然后点击“Create”。AI 会自动生成并翻译字幕。',
                },
                {
                    question: '支持哪些翻译语言？',
                    answer: '我们支持 90+ 种全球语言，包括英语、西班牙语、法语、德语、葡萄牙语、印地语、日语和中文等。',
                },
                {
                    question: '需要下载 SRT 文件吗？',
                    answer: '不需要。微鲤AI 会生成已烧录字幕的视频（硬字幕），确保字幕在各大社交平台正确显示。',
                },
            ],
        },
        videoToAnime: {
            title: '免费 AI 视频转动漫 - 真人视频一键变漫画 & 皮克斯风格 | 微鲤AI',
            description: '使用 微鲤AI 的视频转动漫工具，将真人视频一键转换为日系动漫、3D 皮克斯风格或卡通效果。逐帧稳定渲染，动画更顺滑。免费在线使用。',
            keywords: '视频转动漫, AI动漫滤镜, 视频转卡通, 皮克斯视频滤镜, 真人转动漫, domoai替代, 动漫视频生成器',
            og_title: '免费 AI 视频转动漫 - 真人视频一键变漫画 & 皮克斯风格 | 微鲤AI',
            og_description: '使用 微鲤AI 的视频转动漫工具，将真人视频一键转换为日系动漫、3D 皮克斯风格或卡通效果。逐帧稳定渲染，动画更顺滑。免费在线使用。',
            twitter_title: '免费 AI 视频转动漫 - 真人视频一键变漫画 & 皮克斯风格 | 微鲤AI',
            twitter_description: '使用 微鲤AI 的视频转动漫工具，将真人视频一键转换为日系动漫、3D 皮克斯风格或卡通效果。逐帧稳定渲染，动画更顺滑。免费在线使用。',
            page: {
                title1: '免费 AI 视频转动漫工具',
                title2: '一键变身动漫主角。上传任意真人视频，选择风格（皮克斯 3D、经典 2D 或手绘），AI 将逐帧重绘你的画面，同时保持原始动作顺滑一致。',
                feature_desc1: '<div><p>皮克斯 & 3D：生成可爱、迪士尼风的 3D 动画片段，适合家庭视频。</p><p>经典日漫：获得地道的日式动画观感（吉卜力/新海诚风）。</p><p>素描手绘：把视频变成铅笔手绘的艺术动画。</p></div>',
                feature_title2: '逐帧稳定渲染',
                feature_desc2: '受够了 AI 视频闪烁抖动？微鲤AI 使用先进的时序一致性算法，确保你的动漫视频顺滑播放，不再出现常见的“抖动/闪烁”。',
                feature_title3: '爆款内容神器',
                feature_desc3: '为 TikTok 和 Reels 设计。制作热门的“真人 vs 动漫”对比视频，瞬间抓住注意力。',
                faq: [
                    {
                        question: '如何免费把视频变成动漫？',
                        answer: '把视频上传到 微鲤AI 的视频转动漫工具，选择风格预设（如“2D 风格”或“Pixar 风格”），点击 Create 即可。每日免费积分可用于体验。',
                    },
                    {
                        question: '可以转换成皮克斯/迪士尼风吗？',
                        answer: '可以！我们提供“3D 卡通”或“Pixar 风格”预设，把真人转换成可爱的 3D 动画角色，效果接近热门电影风格。',
                    },
                    {
                        question: '视频最长支持多长？',
                        answer: '目前支持最长 30 秒（界面里会显示“Maximum video duration: 30s”）。非常适合 Shorts、Reels 和 TikTok。',
                    },
                    {
                        question: '动漫角色会像我一样动作吗？',
                        answer: '会的。AI 会分析你的骨骼动作与表情，让生成的动漫角色尽可能精准地复刻你的动作。',
                    },
                    {
                        question: '最好用的视频转动漫工具是什么？',
                        answer: '很多用户选择 微鲤AI 是因为它提供多种 2D/3D 风格，并重点优化逐帧稳定性，能明显降低画面噪点与闪烁。',
                    },
                ],
            },
            faq: [
                {
                    question: '如何免费把视频变成动漫？',
                    answer: '把视频上传到 微鲤AI，选择风格预设（如 2D 风格或 Pixar 风格），点击 Create 即可。',
                },
                {
                    question: '可以转换成皮克斯/迪士尼风吗？',
                    answer: '可以！我们提供 3D 卡通/Pixar 风格预设，把真人转换成可爱的 3D 动画角色。',
                },
                {
                    question: '动漫角色会像我一样动作吗？',
                    answer: '会的。AI 会分析你的骨骼动作与表情，让动漫角色尽可能精准地复刻动作。',
                },
            ],
            app_name: '微鲤AI 视频转动漫转换器',
            app_desc: '免费 AI 工具：把真人视频转换为动漫、卡通与皮克斯风格。支持逐帧渲染，动画更稳定顺滑。',
            featureList: '真人转动漫, 皮克斯滤镜, 逐帧稳定, 2D/3D 风格',
        },
        videoUpscaler: {
            title: '免费 AI 视频超分与增强 - 在线提升至 4K | 微鲤AI',
            description: '使用 微鲤AI 的免费 AI 视频超分工具，将低画质视频一键提升到 1080p、2K 和 4K。修复马赛克、降低噪点、提升清晰度，全程在线完成，无需下载软件。',
            keywords: '视频超分, AI视频超分, 视频提升至4K, 1080p升级4K, 修复模糊视频, 视频降噪, 修复马赛克视频, 提升视频画质',
            og_title: '免费 AI 视频超分与增强 - 在线提升至 4K | 微鲤AI',
            og_description: '使用 微鲤AI 的免费 AI 视频超分工具，将低画质视频一键提升到 1080p、2K 和 4K。修复马赛克、降低噪点、提升清晰度，全程在线完成，无需下载软件。',
            twitter_title: '免费 AI 视频超分与增强 - 在线提升至 4K | 微鲤AI',
            twitter_description: '使用 微鲤AI 的免费 AI 视频超分工具，将低画质视频一键提升到 1080p、2K 和 4K。修复马赛克、降低噪点、提升清晰度，全程在线完成，无需下载软件。',
            page: {
                title1: '免费 AI 视频超分与增强',
                title2: '别再忍受模糊、像素化的视频。上传你的低分辨率视频（360p、480p、720p），AI 会自动将其提升到惊艳的 4K。我们的引擎不仅“放大尺寸”，还会恢复细节、去噪并校正颜色。',
                feature_title1: '一键提升至 4K',
                feature_desc1: '让旧视频焕然一新。将 SD 内容一键提升到高清或 4K，在现代大屏上也能清晰锐利。',
                feature_title2: '修复模糊与颗粒噪点',
                feature_desc2: '夜景低光拍摄？我们的 AI 降噪算法可去除颗粒噪点与压缩伪影，让画面更干净专业。',
                feature_title3: '老视频修复',
                feature_desc3: '非常适合家庭影像存档。修复老家用录像或复古片段的褪色与模糊细节。',
                faq: [
                    {
                        question: '我可以免费在线把视频提升到 4K 吗？',
                        answer: '可以。微鲤AI 允许你选择最高 4K 的输出分辨率（工具选项中可见）。你可以使用每日免费积分进行体验。',
                    },
                    {
                        question: '如何修复模糊视频？',
                        answer: '只需把模糊视频上传到我们的 AI 视频超分工具。AI 会分析缺失像素并重建细节，从而有效“去模糊”。',
                    },
                    {
                        question: '旧手机拍的视频也能用吗？',
                        answer: '当然可以。它对老手机/相机拍摄的低画质视频（如 360p、480p）效果尤其明显，可提升到清晰的 1080p 或更高。',
                    },
                    {
                        question: '超分过程需要多久？',
                        answer: '视频超分计算量较大。但 微鲤AI 使用优化的云端 GPU，速度比本地软件更快。短视频通常只需要几分钟。',
                    },
                    {
                        question: '它比 Topaz Video AI 更好吗？',
                        answer: '微鲤AI 提供可媲美的 AI 画质提升效果，并且全程在浏览器中完成。你无需购买昂贵硬件或安装大型软件也能获得专业结果。',
                    },
                ],
            },
            faq: [
                {
                    question: '我可以在线把视频提升到 4K 吗？',
                    answer: '可以。微鲤AI 支持选择最高 4K 的输出分辨率，你可以使用每日免费积分体验。',
                },
                {
                    question: '如何修复模糊视频？',
                    answer: '把模糊视频上传到 AI 视频超分工具即可。AI 会分析缺失像素并重建细节，提升清晰度。',
                },
                {
                    question: '它比 Topaz Video AI 更好吗？',
                    answer: '微鲤AI 提供可媲美的 AI 画质提升效果，并且无需昂贵硬件或安装软件，直接在浏览器里完成。',
                },
            ],
            app_name: '微鲤AI 视频超分',
            app_desc: '免费 AI 视频超分与增强工具，最高可提升至 4K。可修复模糊、去噪，并在线修复老旧视频。',
            featureList: '4K 超分, AI 降噪, 视频锐化, 色彩校正',
        },
        removeVideoSubtitles: {
            title: '字幕擦除 - AI 视频字幕移除工具 | 微鲤AI',
            description: '使用 AI 技术擦除视频中的嵌入字幕。智能移除视频中的硬编码字幕和文字，同时保持视频质量。快速简单易用。',
            keywords: '视频字幕擦除, 字幕移除, 移除字幕, 擦除字幕, 视频字幕去除, 移除硬编码字幕',
            og_title: '字幕擦除 - AI 视频字幕移除工具 | 微鲤AI',
            og_description: '使用 AI 技术擦除视频中的嵌入字幕。智能移除视频中的硬编码字幕和文字，同时保持视频质量。快速简单易用。',
            twitter_title: '字幕擦除 - AI 视频字幕移除工具 | 微鲤AI',
            twitter_description: '使用 AI 技术擦除视频中的嵌入字幕。智能移除视频中的硬编码字幕和文字，同时保持视频质量。快速简单易用。',
            page: {
                title1: '免费 AI 视频字幕擦除',
                title2: '还在为“烧录/硬字幕”头疼？微鲤AI 会自动识别并擦除视频中的硬编码字幕、歌词与屏幕文字。支持粘贴视频链接或上传本地文件，一键还原干净无字的视频画面。',
                feature_title1: '智能文字识别',
                feature_desc1: '无需手动打码。AI 会自动定位底部字幕条（或画面任意位置）的文字区域，并与背景分离。',
                feature_title2: '无缝 AI 修复填充',
                feature_desc2: '告别模糊马赛克。微鲤AI 会分析周围像素进行“修复补全（In‑painting）”，自然重建草地、沙滩、人群等纹理。',
                feature_title3: '支持链接与本地文件',
                feature_desc3: '可直接处理 TikTok、YouTube、Instagram 等链接视频，或上传 MP4/MOV 文件。非常适合二次创作与内容复用。',
                faq: [
                    {
                        question: '可以移除硬编码（烧录）字幕吗？',
                        answer: '可以。本工具专为“硬字幕”设计：字幕已烙在画面里无法关闭。微鲤AI 会从画面上把它们视觉擦除。',
                    },
                    {
                        question: '如何移除 TikTok/YouTube 视频里的字幕？',
                        answer: '复制视频链接，粘贴到 微鲤AI 的 “Video Link” 选项卡里，点击 “Generate”。AI 会移除字幕并提供可下载的无字视频。',
                    },
                    {
                        question: '会把文字后面的背景也删掉吗？',
                        answer: '不会。微鲤AI 使用 AI 修复补全（In‑painting）技术：先移除文字，再智能“补画”文字后面的背景，让画面看起来像原始视频一样完整。',
                    },
                    {
                        question: '它和去水印工具有什么区别？',
                        answer: '两者原理相近，但“字幕擦除”更针对底部字幕条、歌词与成片文字；而“去水印”更侧重 Logo 与印章等标记。',
                    },
                    {
                        question: '可以免费使用吗？',
                        answer: '可以，你每天都有免费积分可用于体验基础字幕擦除功能。',
                    },
                ],
            },
            faq: [
                {
                    question: '可以移除硬字幕吗？',
                    answer: '可以。本工具专为画面中“硬编码字幕”设计，会从画面上把字幕视觉擦除。',
                },
                {
                    question: '如何通过 TikTok 视频链接移除字幕？',
                    answer: '复制视频链接，粘贴到 微鲤AI 的 “Video Link” 选项卡里，点击 “Generate”，AI 会自动移除字幕。',
                },
                {
                    question: '会影响文字后面的背景吗？',
                    answer: '不会。微鲤AI 会用 AI 修复补全技术移除文字，并智能重建文字后面的背景。',
                },
            ],
            app_name: '微鲤AI 视频字幕擦除器',
            app_desc: '免费 AI 工具：擦除视频中的硬字幕、字幕条、歌词与屏幕文字。使用修复补全（In‑painting）还原背景，不再出现模糊块。',
            featureList: '硬字幕移除, AI 背景修复, 视频链接支持, 歌词/文字擦除',
        },
        videoBackgroundRemover: {
            title: '视频背景去除器 - AI 视频背景移除工具 | 微鲤AI',
            description: '使用 AI 自动去除视频背景。创建绿幕效果、分离主体对象、轻松替换视频背景。适用于内容创作者和视频编辑者。',
            keywords: '视频背景去除, 移除视频背景, 绿幕, AI背景移除, 视频背景擦除器, 分离视频主体',
            og_title: '视频背景去除器 - AI 视频背景移除工具 | 微鲤AI',
            og_description: '使用 AI 自动去除视频背景。创建绿幕效果、分离主体对象、轻松替换视频背景。适用于内容创作者和视频编辑者。',
            twitter_title: '视频背景去除器 - AI 视频背景移除工具 | 微鲤AI',
            twitter_description: '使用 AI 自动去除视频背景。创建绿幕效果、分离主体对象、轻松替换视频背景。适用于内容创作者和视频编辑者。',
            page: {
                title1: '免费 AI 视频背景去除器',
                title2: '没有绿幕？没问题。上传你的视频，我们的 AI 会自动识别主体并进行发丝级抠像，让你一键下载透明背景视频，或立刻替换为纯色背景。',
                feature_title1: '无需绿幕',
                feature_desc1: '告别昂贵的棚拍。AI 可自动将人物、宠物或物体从复杂背景中分离（自动视频抠像/自动 Rotoscoping）。',
                feature_title2: '纯色背景替换',
                feature_desc2: '电商更好用。一键把产品视频背景改为纯白、纯黑或自定义颜色，提升商品展示与转化。',
                feature_title3: '透明导出',
                feature_desc3: '支持导出带 Alpha 通道的 WebM/MOV 透明视频，方便在 Premiere、达芬奇或 CapCut 中叠加到其它视频上。',
                faq: [
                    {
                        question: '不使用绿幕也能去除视频背景吗？',
                        answer: '可以！微鲤AI 使用先进的机器学习识别主体与背景，无论是在卧室、街头还是办公室拍摄，都能去除背景。',
                    },
                    {
                        question: '如何保存透明背景视频？',
                        answer: '去除背景后，选择 WebM（透明）或 MOV 作为导出格式。标准 MP4 不支持透明，会显示黑色背景。',
                    },
                    {
                        question: '可以把视频背景改成白色吗？',
                        answer: '可以。在工具设置里使用“Background Color”选择器选择白色、黑色或任意十六进制颜色，非常适合 Amazon/Shopify 商品视频。',
                    },
                    {
                        question: '头发边缘处理效果好吗？',
                        answer: '效果很好。我们的算法针对发丝、毛发以及半透明物体（如眼镜）等复杂边缘做过训练，细节保留更自然。',
                    },
                    {
                        question: '可以免费使用吗？',
                        answer: '可以，你每天都有免费积分可用于处理视频。',
                    },
                ],
            },
            faq: [
                {
                    question: '不使用绿幕也能去除视频背景吗？',
                    answer: '可以！微鲤AI 无需绿幕即可区分主体与背景。',
                },
                {
                    question: '如何保存透明背景视频？',
                    answer: '选择 WebM（透明）或 MOV 作为导出格式。标准 MP4 不支持透明。',
                },
                {
                    question: '可以把视频背景改成白色吗？',
                    answer: '可以。使用 Background Color 选择器选择白色，非常适合电商产品视频。',
                },
            ],
            app_name: '微鲤AI 视频背景去除器',
            app_desc: '免费 AI 工具：无需绿幕即可去除视频背景。支持导出透明视频，或在线把背景改成白/黑/自定义颜色。',
            featureList: '无需绿幕, 透明视频导出, 背景颜色替换, 发丝级抠像',
            step_name: '如何在线去除视频背景',
            step_list: [
                {
                    name: '上传视频',
                    text: '将视频文件（MP4、MOV）上传到 微鲤AI 背景去除器。',
                },
                {
                    name: '去除背景',
                    text: 'AI 会自动处理视频。你可以选择保持透明背景，或选择新的背景颜色。',
                },
                {
                    name: '导出下载',
                    text: '下载结果。透明背景请选择 WebM/MOV，纯色背景可选择 MP4。',
                },
            ],
        },
        aiVideoExtender: {
            title: 'AI 视频延长器 - 延长视频时长和长度 | 微鲤AI',
            description: '使用 AI 技术延长视频时长。无缝添加 5-8 秒视频内容，支持动漫、3D 动画、赛博朋克和漫画等多种风格选项。适合内容创作者和视频编辑者。',
            keywords: 'AI视频延长, 延长视频时长, 视频时长延长, AI视频扩展, 视频加长, 延长视频时间, AI视频工具',
            og_title: 'AI 视频延长器 - 延长视频时长和长度 | 微鲤AI',
            og_description: '使用 AI 技术延长视频时长。无缝添加 5-8 秒视频内容，支持动漫、3D 动画、赛博朋克和漫画等多种风格选项。适合内容创作者和视频编辑者。',
            twitter_title: 'AI 视频延长器 - 延长视频时长和长度 | 微鲤AI',
            twitter_description: '使用 AI 技术延长视频时长。无缝添加 5-8 秒视频内容，支持动漫、3D 动画、赛博朋克和漫画等多种风格选项。适合内容创作者和视频编辑者。',
            page: {
                title1: '免费 AI 视频延长器与续写',
                title2: '视频太短？微鲤AI 使用生成式 AI 预测并生成新帧，让你的视频自然续写并无缝变长。你还可以用提示词（Prompt）控制“接下来发生什么”，或者把普通素材变成丝滑慢动作。',
                feature_title1: '智能生成式延长',
                feature_desc1: '不只是把视频拉长，而是“生成新内容”。输入如“镜头拉远”或“角色转身”等提示词，AI 会生成与原视频风格一致的后续 5-10 秒画面。',
                feature_title2: '丝滑慢动作',
                feature_desc2: '把普通 30fps 视频变成高质量慢动作。微鲤AI 使用帧插值（Frame Interpolation）在原有帧之间插入 AI 生成帧，运动更流畅不抖动。',
                feature_title3: '完美循环',
                feature_desc3: '为社交媒体背景制作无限循环视频。AI 会分析起始与结束帧并进行自然融合，做出让人停不下来的循环效果。',
                faq: [
                    {
                        question: 'AI 视频延长器是怎么工作的？',
                        answer: '它使用“生成式补全（Generative Outpainting）”技术：AI 会分析你视频的最后几帧以及提示词，预测并生成逻辑上延续原动作的新帧。',
                    },
                    {
                        question: '我可以控制延长部分发生什么吗？',
                        answer: '可以！在工具的 “Prompt” 输入框描述动作。例如视频里是一辆车在行驶，你可以输入“汽车驶入隧道”来引导延长结果。',
                    },
                    {
                        question: '延长（Extension）和慢动作（Slow Motion）有什么区别？',
                        answer: '延长是通过生成新的事件/画面来增加“新时间”（让故事更长）；慢动作是通过插入中间帧来拉伸“已有时间”（让动作更慢更顺滑）。微鲤AI 两者都支持。',
                    },
                    {
                        question: '视频最长能延长多少？',
                        answer: '你可以每次延长 5 秒（可在 “Extension Duration” 设置中看到）。重复操作即可生成更长的序列。',
                    },
                    {
                        question: '免费吗？',
                        answer: '是的，微鲤AI 提供免费积分用于体验视频延长与慢动作效果。',
                    },
                ],
            },
            faq: [
                {
                    question: 'AI 视频延长器是怎么工作的？',
                    answer: '它使用“生成式补全（Generative Outpainting）”技术：AI 会分析你视频的最后几帧以及提示词，预测并生成逻辑上延续原动作的新帧。',
                },
                {
                    question: '我可以控制延长部分发生什么吗？',
                    answer: '可以！在工具的 “Prompt” 输入框描述动作。例如视频里是一辆车在行驶，你可以输入“汽车驶入隧道”来引导延长结果。',
                },
                {
                    question: '延长（Extension）和慢动作（Slow Motion）有什么区别？',
                    answer: '延长会生成新的事件来增加时间；慢动作通过插入中间帧让动作更慢更顺滑。微鲤AI 两者都支持。',
                },
            ],
            app_name: '微鲤AI 视频延长器',
            app_desc: '免费 AI 工具：使用生成式补全与提示词续写来延长视频长度。同时支持 AI 慢动作（帧插值）与视频循环制作。',
            featureList: '生成式视频延长, 提示词续写, AI 慢动作, 视频循环',
        },
        videoEffects: {
            title: 'AI 视频特效 - 使用 AI 制作爆款视频 | 微鲤AI',
            description: '在微鲤AI上探索热门 AI 视频特效模板：亲吻、舞蹈、换脸、变装等一键生成。上传素材或选择模板，几步做出爆款短视频，适用于社媒运营、节日营销与内容创作；支持高清导出与多端分享，帮助账号矩阵高效产出，立即免费试用。',
            keywords: 'AI视频特效, 视频特效模板, 爆款短视频, AI亲吻, AI舞蹈, 换脸特效, 变装特效, 微鲤AI',
        },
        aiDancing: {
            title: 'AI 舞蹈视频生成器 - 免费 AI 舞蹈视频制作工具 | 微鲤AI',
            description: '使用微鲤AI 的 AI 舞蹈视频生成器，上传全身照片即可让人物动起来跳舞。支持多种舞曲风格与热门舞蹈模板，几秒钟生成爆款舞蹈短视频，免费在线使用，适合抖音、快手等平台创作，立即体验打造爆款内容，一键生成。',
            keywords: 'AI舞蹈视频, AI舞蹈生成器, 照片转视频, AI视频生成, 微鲤AI, 免费AI工具',
        },
        aiKissing: {
            title: 'AI 亲吻视频生成器 - 两张照片合拍亲亲 | 微鲤AI',
            description: '使用微鲤AI 的 AI 亲吻视频生成器，上传两张照片即可生成逼真的亲吻动作视频。支持法式亲吻、脸颊亲吻、跨次元创作等多种风格，几秒钟完成，免费在线使用，适合抖音、快手等平台，打造浪漫爆款内容，一键生成。',
            keywords: 'AI 亲吻, 照片变视频, 动作迁移, 浪漫视频, 微鲤AI',
        },
        videoMotionImitation: {
            title: 'AI 舞蹈生成器 & 动作迁移 - 让照片跳舞 | 微鲤AI',
            description: '使用 微鲤AI 的动作迁移工具，让照片跳舞或在视频中替换人物。上传参考视频与人物图片，AI 会保留背景、光照与色调，实现自然融合与顺滑效果。',
            keywords: 'AI视频动作模仿, 视频动作迁移, 照片跳舞, 让照片跳舞, AI舞蹈生成器, 视频人物替换, 角色替换',
            og_title: 'AI 舞蹈生成器 & 动作迁移 - 让照片跳舞 | 微鲤AI',
            og_description: '使用 微鲤AI 的动作迁移工具，让照片跳舞或在视频中替换人物。上传参考视频与人物图片，AI 会保留背景、光照与色调，实现自然融合与顺滑效果。',
            twitter_title: 'AI 舞蹈生成器 & 动作迁移 - 让照片跳舞 | 微鲤AI',
            twitter_description: '使用 微鲤AI 的动作迁移工具，让照片跳舞或在视频中替换人物。上传参考视频与人物图片，AI 会保留背景、光照与色调，实现自然融合与顺滑效果。',
            page: {
                title1: '免费 AI 舞蹈生成器 & 动作迁移',
                title2: '想看你最喜欢的动漫角色像迈克尔·杰克逊一样跳舞？或让一张静态照片完成爆火的 TikTok 动作？只需上传参考视频和人物图片，我们的 AI 就能精准迁移动作。',
                feature_title1: '视频人物替换',
                feature_desc1: '真人变动漫：上传真人跳舞/打斗视频，将人物替换为 3D 角色、熊猫或动漫头像，同时保留原背景与光照。',
                feature_title2: '让照片跳舞',
                feature_desc2: '静态图动起来：上传你自己或角色的照片，选择参考舞蹈视频，照片就会完美复刻动作。非常适合制作 Viggle 风格的爆款内容。',
                feature_title3: '打破次元壁',
                feature_desc3: '跨次元风格：无论是把芭蕾舞者变成动漫少女，还是把空手道少年变成熊猫，微鲤AI 都能稳住复杂身体结构与遮挡。',
                faq: [
                    {
                        question: '如何用 AI 让照片跳舞？',
                        answer: '使用 微鲤AI 的“Move Mode”。上传要动起来的照片（Character Image）和包含动作的参考视频（Reference Video），点击 Create 即可完成动作迁移。',
                    },
                    {
                        question: 'Move Mode 和 Replace Mode 有什么区别？',
                        answer: 'Move Mode 用视频动作来驱动一张静态图片；Replace Mode 则是在已有视频里把人物替换成你上传的角色图片。',
                    },
                    {
                        question: '可以用于 TikTok 热门挑战吗？',
                        answer: '可以！非常适合做 TikTok 趋势舞蹈/挑战，让明星、动漫角色或朋友都能“秒会”热门动作。',
                    },
                    {
                        question: '支持全身镜头吗？',
                        answer: '支持。建议参考视频和人物图片都尽量包含清晰的全身，以便 AI 更准确追踪四肢。',
                    },
                    {
                        question: '免费吗？',
                        answer: '是的，你可以用每日免费积分免费生成动作迁移视频。',
                    },
                ],
            },
            faq: [
                {
                    question: '如何用 AI 让照片跳舞？',
                    answer: '使用 微鲤AI 的“Move Mode”。上传要动起来的照片（Character Image）和包含动作的参考视频（Reference Video），点击 Create 即可完成动作迁移。',
                },
                {
                    question: 'Move Mode 和 Replace Mode 有什么区别？',
                    answer: 'Move Mode 用视频动作来驱动一张静态图片；Replace Mode 则是在已有视频里把人物替换成你上传的角色图片。',
                },
            ],
            app_name: '微鲤AI 视频动作迁移',
            app_desc: '免费 AI 舞蹈生成与动作迁移工具。让照片跳舞、驱动静态图片、视频人物替换，一站式在线完成。',
            featureList: 'AI舞蹈生成, 姿态迁移, 视频人物替换, 让照片动起来',
            step_name: '如何用 AI 让照片跳舞',
            step_list: [
                {
                    name: '上传参考视频',
                    text: '上传包含你想要复制的舞蹈或动作的视频。',
                },
                {
                    name: '上传人物图片',
                    text: '上传你想要动起来的静态照片（人物/角色）。',
                },
                {
                    name: '选择 Move Mode',
                    text: '选择“Move Mode”并点击 Create，AI 会让照片表演参考视频里的动作。',
                },
            ],
        },
    },
    ja: {
        textToMusic: {
            title: 'AI音楽ジェネレーター - WeryAIでユニークな音楽を作成 | 微鲤AI',
            description: 'WeryAIのAI音楽ジェネレーターをご覧ください。高度なAI技術で、プロジェクトに合わせたユニークな著作権フリーの音楽を素早く作成。コンテンツクリエイター、ゲーム開発者、音楽愛好家に最適。',
            keywords: 'テキストから音楽, テキストから音楽無料, AIテキストから音楽, AI音楽ジェネレーター, AI楽曲メーカー, 歌詞から音楽生成, 類似音楽作成, 音楽作成, 著作権フリー音楽, 無料音楽ダウンロード, 微鲤AI',
        },
        textToVideo: {
            title: '無料 AI テキスト→動画ジェネレーター（Veo 3.1・Kling・Sora）| 微鲤AI',
            description: '微鲤AI のテキスト→動画 AI で、プロンプトを映画のような映像に即変換。Google Veo 3.1、Kling、Sora に対応。16:9 と 9:16 をサポートし、最長 8 秒まで生成可能。透かしなしのオプションも利用できます。',
            keywords: 'テキストから動画, text to video ai, AI動画ジェネレーター, Google Veo 3.1, Kling AI, Sora, prompt→動画, txt2vid, 微鲤AI',
            og_title: '無料 AI テキスト→動画ジェネレーター（Veo 3.1・Kling・Sora）| 微鲤AI',
            og_description: '微鲤AI のテキスト→動画 AI で、プロンプトを映画のような映像に即変換。Google Veo 3.1、Kling、Sora に対応。16:9 と 9:16 をサポートし、最長 8 秒まで生成可能。透かしなしのオプションも利用できます。',
            twitter_title: '無料 AI テキスト→動画ジェネレーター（Veo 3.1・Kling・Sora）| 微鲤AI',
            twitter_description: '微鲤AI のテキスト→動画 AI で、プロンプトを映画のような映像に即変換。Google Veo 3.1、Kling、Sora に対応。16:9 と 9:16 をサポートし、最長 8 秒まで生成可能。透かしなしのオプションも利用できます。',
            page: {
                title1: '無料 AI テキスト→動画ジェネレーター',
                title2: 'プロンプトを入力するだけで、微鲤AI があなたのアイデアを動画にします。Google Veo 3.1 や Kling などの最先端モデルを統合しており、SNS向けの縦動画（9:16）からシネマ向け横動画（16:9）まで、高品質で物理的に自然な映像を数秒で生成できます。',
                intro_title: 'テキスト→動画AIで想像を現実に',
                feature_title: '微鲤AI テキスト→動画の特徴',
                faq_title: 'テキスト→動画のよくある質問',
                feature_title1: 'マルチモデル対応',
                feature_desc1: 'リアルさは Veo 3.1、動きの一貫性は Kling。複数サブスクは不要です。',
                feature_title2: 'アスペクト比を自由に',
                feature_desc2: 'TikTok/Reels 向け 9:16、YouTube 向け 16:9 をそのまま生成できます。',
                feature_title3: '最長 8 秒（延長も可）',
                feature_desc3: '一度の生成で最大 8 秒（モデルにより異なる）。さらに延長ツールでシームレスに続編を作れます。',
                faq: [
                    {
                        question: '良いテキスト→動画プロンプトの書き方は？',
                        answer: '被写体、動き、光、カメラ角度を具体的に書きましょう。例：「夜の未来的なサイバーパンク都市をドローンで撮影、ネオン、4K」。統合モデルは複雑な説明も理解できます。',
                    },
                    {
                        question: 'Google Veo 3.1 と Kling、どちらを使うべき？',
                        answer: 'Veo 3.1 は画質とプロンプト追従に優れ、写実的なシーンに最適です。Kling は複雑な人物動作で強みを発揮することが多いです。両方試して最適な方を選ぶのがおすすめです。',
                    },
                    {
                        question: '微鲤AI のテキスト→動画は無料ですか？',
                        answer: 'はい。毎日付与される無料クレジットで、テキストから動画生成を試せます。複数クリップを生成して比較できます。',
                    },
                    {
                        question: '8 秒より長い動画は作れますか？',
                        answer: '基本生成は最大 8 秒（モデルにより異なります）。より長い動画は AI Video Extender で自然に延長できます。',
                    },
                    {
                        question: '生成動画に音は付きますか？',
                        answer: 'はい。ツール内の「Generate Audio」トグルをオンにすると、効果音や環境音を自動生成できます。',
                    },
                ],
            },
            faq: [
                {
                    question: '良いテキスト→動画プロンプトの書き方は？',
                    answer: '被写体、動き、光、カメラ角度を具体的に。例：「夜のサイバーパンク都市をドローン撮影、ネオン、4K」。',
                },
                {
                    question: 'Google Veo 3.1 と Kling、どちらを使うべき？',
                    answer: '写実と追従性なら Veo 3.1、動きの一貫性なら Kling。両方試すのがおすすめです。',
                },
                {
                    question: '微鲤AI のテキスト→動画は無料ですか？',
                    answer: 'はい。毎日無料クレジットが付与され、テキストから動画を試せます。',
                },
                {
                    question: '8 秒より長い動画は作れますか？',
                    answer: '基本は最大 8 秒。AI Video Extender を使えばシームレスに延長できます。',
                },
                {
                    question: '生成動画に音は付きますか？',
                    answer: 'はい。「Generate Audio」を有効にすると、音を自動生成できます。',
                },
            ],
        },
        imageToVideo: {
            title: 'AI 画像→動画ジェネレーター（無料・オンライン）- Kling・Veo・Sora 搭載',
            description: '微鲤AI の無料「画像→動画」AIで、静止画を数秒でリアルな動画に変換。Kling、Google Veo、Sora 2 などのトップモデルを1か所で利用できます。透かしなしのオプションも用意しています。',
            keywords: '画像から動画, 画像→動画AI, AI動画ジェネレーター, 画像アニメーション, Sora 動画, Veo 動画, Seedance 動画, 微鲤AI 動画ツール',
            og_title: 'AI 画像→動画ジェネレーター（無料・オンライン）- Kling・Veo・Sora 搭載',
            og_description: '微鲤AI の無料「画像→動画」AIで、静止画を数秒でリアルな動画に変換。Kling、Google Veo、Sora 2 などのトップモデルを1か所で利用できます。透かしなしのオプションも用意しています。',
            twitter_title: 'AI 画像→動画ジェネレーター（無料・オンライン）- Kling・Veo・Sora 搭載',
            twitter_description: '微鲤AI の無料「画像→動画」AIで、静止画を数秒でリアルな動画に変換。Kling、Google Veo、Sora 2 などのトップモデルを1か所で利用できます。透かしなしのオプションも用意しています。',
            page: {
                title1: '無料オンライン AI 画像→動画ジェネレーター',
                faq: [
                    {
                        question: 'AI 画像→動画ジェネレーターはどのように動作しますか？',
                        answer: 'Kling や Sora などの高度な深層学習モデルが静止画像を解析して動きを予測し、MP4 形式の一貫した動画クリップを生成します。',
                    },
                    {
                        question: '微鲤AI の画像→動画は無料で使えますか？',
                        answer: 'はい。毎日付与される無料クレジットで画像→動画 AI を試せます。より高性能なモデルや高速生成が必要な場合はアップグレードできます。',
                    },
                    {
                        question: 'よりリアルな動画なら Kling と Veo のどちらが良いですか？',
                        answer: 'Kling AI は自然な動きと長めの尺に強く、Google Veo は高解像度のディテールに優れます。微鲤AI ならモデルを切り替えて最適解を見つけられます。',
                    },
                    {
                        question: '生成した動画を商用利用できますか？',
                        answer: 'はい。有料プランで生成した動画には商用ライセンスが付与され、YouTube、TikTok、広告用途に最適です。',
                    },
                    {
                        question: 'AI 動画の透かしを消すには？',
                        answer: '微鲤AI は高品質な出力を提供します。透かしなしで利用するにはプラン内容をご確認いただくか、専用の AI Watermark Remover ツールをご利用ください。',
                    },
                ],
            },
            faq: [
                {
                    question: 'AI 画像→動画ジェネレーターはどのように動作しますか？',
                    answer: 'Kling や Sora などの高度な深層学習モデルが静止画像を解析して動きを予測し、MP4 形式の一貫した動画クリップを生成します。',
                },
                {
                    question: '微鲤AI の画像→動画は無料で使えますか？',
                    answer: 'はい。毎日付与される無料クレジットで画像→動画 AI を試せます。より高性能なモデルや高速生成が必要な場合はアップグレードできます。',
                },
                {
                    question: '生成した動画を商用利用できますか？',
                    answer: 'はい。有料プランで生成した動画には商用ライセンスが付与され、YouTube、TikTok、広告用途に最適です。',
                },
            ],
        },
        videoToVideo: {
            title: '無料 AI 動画→動画ジェネレーター - リスタイル＆アニメフィルター | 微鲤AI',
            description: '微鲤AI の動画→動画 AI で、動画を好きなスタイルに変換。実写をアニメ、3D カートゥーン、サイバーパンク風などに、テキストプロンプトでリスタイルしながら元の動きを保ちます。無料＆オンライン。',
            keywords: '動画から動画, vid2vid, 動画スタイル変換, 動画をアニメに, AI動画リスタイル, 無料AI動画フィルター',
            og_title: '無料 AI 動画→動画ジェネレーター - リスタイル＆アニメフィルター | 微鲤AI',
            og_description: '微鲤AI の動画→動画 AI で、動画を好きなスタイルに変換。実写をアニメ、3D カートゥーン、サイバーパンク風などに、テキストプロンプトでリスタイルしながら元の動きを保ちます。無料＆オンライン。',
            twitter_title: '無料 AI 動画→動画ジェネレーター - リスタイル＆アニメフィルター | 微鲤AI',
            twitter_description: '微鲤AI の動画→動画 AI で、動画を好きなスタイルに変換。実写をアニメ、3D カートゥーン、サイバーパンク風などに、テキストプロンプトでリスタイルしながら元の動きを保ちます。無料＆オンライン。',
            page: {
                title1: '無料 AI 動画→動画ジェネレーター（Vid2Vid）',
                title2: '動画をアップロードして、スタイルを入力するだけ。微鲤AI の動画→動画技術が元動画の動きを解析し、あなたのテキストプロンプトに基づいて全く新しいアートスタイルを適用します。アニメ編集、クレイアニメ風、超現実的な映像表現に最適です。',
                feature_title1: '動きの一貫性',
                feature_desc1: '通常の生成と違い、Vid2Vid エンジンが元動画の動きを捉え、ちらつきを抑えて滑らかな変換を実現します。',
                feature_title2: '実写→アニメ',
                feature_desc2: 'クリエイターに人気。自分の映像をアニメキャラや 3D ピクサー風アバターに一瞬で変換できます。',
                feature_title3: 'プロンプトでコントロール',
                feature_desc3: '「サイバーパンク都市風」や「油絵風」のように入力するだけで、出力の見た目を細かく指定できます。',
                faq: [
                    {
                        question: 'AI 動画→動画（Vid2Vid）とは？',
                        answer: '既存の動画を入力として、テキストプロンプトで指定した新しいスタイルに「塗り替える」生成 AI 技術です。元の動きと構造をできるだけ維持します。',
                    },
                    {
                        question: '動画をアニメ風にできますか？',
                        answer: 'はい。最も人気の使い方です。動画をアップロードし「日本アニメ風、ジブリ風」などのプロンプトで変換できます。',
                    },
                    {
                        question: '元動画の長さはどれくらいまで対応？',
                        answer: '高品質を保つため、現在は短いクリップ（例：5〜10 秒）を推奨しています。長い動画は分割して処理してください。',
                    },
                    {
                        question: '動画編集ソフトと何が違う？',
                        answer: '従来の編集はカットやトリミング中心ですが、微鲤AI の動画→動画は新しいピクセルを生成し、質感やアートスタイル自体を変えます。',
                    },
                    {
                        question: '料金はかかりますか？',
                        answer: '毎日無料クレジットで試せます。高速処理や透かしなしダウンロード向けのプレミアムプランもあります。',
                    },
                ],
            },
            faq: [
                {
                    question: 'AI 動画→動画（Vid2Vid）とは？',
                    answer: '既存動画を入力に、テキストで指定した新スタイルへリスタイルしつつ動きと構造を保つ生成 AI です。',
                },
                {
                    question: '動画をアニメ風にできますか？',
                    answer: 'はい。「日本アニメ風、ジブリ風」などのプロンプトで変換できます。',
                },
                {
                    question: '元動画の長さはどれくらいまで対応？',
                    answer: '現在は短いクリップ（例：5〜10 秒）推奨。長い動画は分割してください。',
                },
                {
                    question: '動画編集ソフトと何が違う？',
                    answer: '編集はカット中心、Vid2Vid は新ピクセル生成で質感・スタイルを変えます。',
                },
                {
                    question: '料金はかかりますか？',
                    answer: '毎日無料クレジットあり。プレミアムで高速＆透かしなしが利用できます。',
                },
            ],
        },
        removeWatermark: {
            title: '無料オンライン AI 動画透かし除去 - ロゴ・文字・字幕を削除 | 微鲤AI',
            description: '微鲤AI の無料 AI 透かし除去で、動画の透かし・ロゴ・字幕・日付スタンプを簡単に削除。MP4/MOV と動画リンクに対応。ぼかしではなく、AI で自然に修復します。',
            keywords: '動画 透かし除去, AI 動画消しゴム, 動画 ロゴ削除, 字幕削除, TikTok 透かし除去, 無料 透かし除去',
            og_title: '無料オンライン AI 動画透かし除去 - ロゴ・文字・字幕を削除 | 微鲤AI',
            og_description: '微鲤AI の無料 AI 透かし除去で、動画の透かし・ロゴ・字幕・日付スタンプを簡単に削除。MP4/MOV と動画リンクに対応。ぼかしではなく、AI で自然に修復します。',
            twitter_title: '無料オンライン AI 動画透かし除去 - ロゴ・文字・字幕を削除 | 微鲤AI',
            twitter_description: '微鲤AI の無料 AI 透かし除去で、動画の透かし・ロゴ・字幕・日付スタンプを簡単に削除。MP4/MOV と動画リンクに対応。ぼかしではなく、AI で自然に修復します。',
            page: {
                title1: '無料オンライン AI 動画透かし除去',
                title2: '動画の透かし、ロゴ、テキストオーバーレイ、字幕を即時に消去。動画リンクを貼り付けるかファイルをアップロードし、範囲を選択して AI に任せれば、ぼかしなしで背景をピクセルレベルに復元します。',
                click_erase: '1.ワンクリック消去：AI が一般的な透かしを自動検出して削除します。',
                percision_erase: '2.精密消去：ブラシで移動する字幕やタイムスタンプなど複雑な対象を手動で除去できます。',
                video_link_title: 'リンク対応',
                direct_link_desc: '1.直リンク除去：SNS のリンクを貼るだけで、ダウンロードせずに透かしを削除できます。',
                lossless_qua_title: '2.高品質復元：従来のぼかしと違い、周囲ピクセルを解析して背景を再構成します。',
                faq: [
                    {
                        question: '無料でオンラインで動画の透かしを消すには？',
                        answer: '微鲤AI に動画をアップロードするか、動画リンクを貼り付けます。透かしを選択範囲で囲んで「Generate」をクリック。無料で試せます。',
                    },
                    {
                        question: '動く字幕やテキストも消せますか？',
                        answer: 'はい。「Precision Erase」モードで文字エリアを選択してください。AI がフレーム間で追跡し、動画全体で綺麗に除去します。',
                    },
                    {
                        question: 'TikTok や YouTube の動画にも使えますか？',
                        answer: 'もちろんです。TikTok の跳ねる透かしなどプラットフォームロゴやチャンネル透かしを消して、個人利用向けにクリーンな動画にできます。',
                    },
                    {
                        question: '消した部分はぼやけますか？',
                        answer: 'いいえ。微鲤AI は高度な「Video In‑painting」で周囲の映像から自然な質感を生成し、見た目の悪いぼかしを回避します。',
                    },
                    {
                        question: '対応フォーマットは？',
                        answer: 'MP4、MOV、AVI、WebM など主要フォーマットに対応しています。',
                    },
                ],
            },
            faq: [
                {
                    question: '無料でオンラインで動画の透かしを消すには？',
                    answer: '動画をアップロード/リンク貼り付け → 範囲選択 →「Generate」で無料で試せます。',
                },
                {
                    question: '動く字幕やテキストも消せますか？',
                    answer: 'はい。「Precision Erase」で選択すると、AI がフレーム間で追跡して除去します。',
                },
                {
                    question: '消した部分はぼやけますか？',
                    answer: 'いいえ。Video In‑painting で自然な質感を生成して埋め戻します。',
                },
            ],
        },
        videoFaceSwap: {
            title: '無料 AI 動画顔交換（Video Face Swap）- リアルな Deepfake 作成 | 微鲤AI',
            description: '微鲤AI の AI フェイススワップで動画の顔を即交換。面白い映画クリップやミーム、リアルな deepfake を無料で作れます。透かしなしオプションあり。100% プライバシー重視。',
            keywords: '動画顔交換, AIフェイススワップ, 無料deepfake, 動画の顔入れ替え, 映画顔交換, reface オンライン, AIミーム',
            og_title: '無料 AI 動画顔交換（Video Face Swap）- リアルな Deepfake 作成 | 微鲤AI',
            og_description: '微鲤AI の AI フェイススワップで動画の顔を即交換。面白い映画クリップやミーム、リアルな deepfake を無料で作れます。透かしなしオプションあり。100% プライバシー重視。',
            twitter_title: '無料 AI 動画顔交換（Video Face Swap）- リアルな Deepfake 作成 | 微鲤AI',
            twitter_description: '微鲤AI の AI フェイススワップで動画の顔を即交換。面白い映画クリップやミーム、リアルな deepfake を無料で作れます。透かしなしオプションあり。100% プライバシー重視。',
            page: {
                title1: '無料 AI 動画顔交換',
                title2: 'どんな映画でも主役に！動画クリップとターゲット写真をアップロードすると、AI が自然に顔を入れ替えます。面白いミーム、パーソナライズド挨拶、プロ品質のVFX制作に最適。',
                feature_title1: '超リアル Deepfake',
                feature_desc1: '顔の形状と光を解析し、表情や頭の動きを保ったまま自然に合成します。',
                feature_title2: 'プライバシー最優先',
                feature_desc2: 'プライバシーを重視。アップロードされた動画と画像は安全に処理され、生成後まもなく削除されます。',
                feature_title3: '専門知識不要',
                feature_desc3: 'After Effects のような複雑なソフトは不要。「Create」を押すだけで数秒で結果を得られます。',
                faq: [
                    {
                        question: '微鲤AI の動画顔交換は無料ですか？',
                        answer: 'はい。オンラインで動画の顔交換を試せる無料クレジットを提供しています。クレカ不要で作成を始められます。',
                    },
                    {
                        question: '写真をアップロードしても安全ですか？',
                        answer: 'もちろんです。厳格なデータ保護を採用し、素材は生成にのみ使用され、恒久的には保存しません。',
                    },
                    {
                        question: 'GIF の顔も入れ替えられますか？',
                        answer: 'はい！動画（MP4/MOV）と GIF の両方に対応し、リアクションGIFも簡単に作れます。',
                    },
                    {
                        question: '最高の結果を得るコツは？',
                        answer: 'ターゲット顔は、鮮明で正面、明るい写真を推奨します。髪やメガネで顔が隠れている写真は避けてください。',
                    },
                    {
                        question: '商用プロジェクトに使えますか？',
                        answer: 'はい。ただし、元動画素材と人物肖像（同意・権利）を必ず保有していることを確認してください。',
                    },
                ],
            },
            faq: [
                {
                    question: '微鲤AI の動画顔交換は無料ですか？',
                    answer: 'はい。無料クレジットで試せます。クレカ不要です。',
                },
                {
                    question: '写真をアップロードしても安全ですか？',
                    answer: 'はい。厳格な保護のもと、素材は生成にのみ使用されます。',
                },
                {
                    question: '最高の結果を得るコツは？',
                    answer: '鮮明で正面、明るいターゲット写真を使い、顔が隠れていないものを選んでください。',
                },
            ],
        },
        videoLipSync: {
            title: '無料AI動画リップシンク生成 - 音声/テキストを動画に同期 | 微鲤AI',
            description: 'WeryAIのAIリップシンクで、任意の音声やテキストに口の動きを正確に同期します。Kling AI搭載。動画翻訳、吹き替え、しゃべるアバター作成に最適。無料・オンライン。',
            keywords: '動画リップシンク, リップシンク, AIリップシンク, 動画吹き替え, 音声同期, トーキング動画, リップシンクツール',
            og_title: '無料AI動画リップシンク生成 - 音声/テキストを動画に同期 | 微鲤AI',
            og_description: 'WeryAIのAIリップシンクで、任意の音声やテキストに口の動きを正確に同期します。Kling AI搭載。動画翻訳、吹き替え、しゃべるアバター作成に最適。無料・オンライン。',
            twitter_title: '無料AI動画リップシンク生成 - 音声/テキストを動画に同期 | 微鲤AI',
            twitter_description: 'WeryAIのAIリップシンクで、任意の音声やテキストに口の動きを正確に同期します。Kling AI搭載。動画翻訳、吹き替え、しゃべるアバター作成に最適。無料・オンライン。',
            page: {
                title1: '無料AI動画リップシンク＆吹き替えツール',
                title2: '不自然な吹き替えにさようなら。動画と音声ファイル（またはテキスト）をアップロードすると、AIが話者の口の動きを音にぴったり合わせて再生成します。Kling AI搭載で、多言語吹き替えとリアルな表情筋の調整に対応。',
                dual_input_modes: '2つの入力モード',
                audio_sync: '音声同期',
                text_sync: 'テキスト読み上げ',
                text_sync_tip: '任意のテキストを入力し、プリセットのAI音声を選んで、キャラクターにすぐ話させられます。',
                audio_sync_tip: '自分のナレーションや曲をアップロードして同期できます。',
                feature_title1: '多言語吹き替え',
                feature_desc1: 'リーチを拡大。スペイン語・フランス語・日本語などに翻訳した音声で吹き替えし、口元も同期してネイティブのように自然に見せられます。',
                feature_title2: 'Kling AIの精度',
                feature_desc2: '基本的なWav2Lip系ツールと異なり、Klingモデルで歯・舌・あごの動きまで解剖学的に自然になるよう最適化します。',
                faq: [
                    {
                        question: '動画の音声にリップシンクさせるには？',
                        answer: 'WeryAIに動画をアップロードし、音声ファイル（MP3/WAV）をアップロードするか、テキストを入力してAI音声を生成します。「Create」をクリックすると、AIが口の動きを音に合わせて調整します。',
                    },
                    {
                        question: '動画翻訳/吹き替えに使えますか？',
                        answer: 'はい。翻訳済みの音声トラックをアップロードすれば、AIがリップシンクを整えて自然な吹き替え動画を作れます。',
                    },
                    {
                        question: '静止画でも動きますか（トーキングヘッド）？',
                        answer: 'はい。静止画のポートレートを「動画」素材としてアップロードすると、しゃべるアバター動画（Live Portrait効果）としてアニメーション化できます。',
                    },
                    {
                        question: '対応言語は？',
                        answer: '音声波形を解析するため、基本的にどの言語でも利用できます（英語、スペイン語、中国語、ヒンディー語など）。テキスト読み上げ入力は50以上の言語に対応しています。',
                    },
                    {
                        question: 'リップシンクは無料ですか？',
                        answer: 'WeryAIでは、リップシンク機能を試せる無料デイリークレジットを提供しています。長尺動画や商用利用にはプレミアムプランをご用意しています。',
                    },
                ],
            },
            faq: [
                {
                    question: '動画の音声にリップシンクさせるには？',
                    answer: 'WeryAIに動画をアップロードし、音声ファイル（MP3/WAV）をアップロードするか、テキストを入力してAI音声を生成します。「Create」をクリックすると、AIが口の動きを音に合わせて調整します。',
                },
                {
                    question: '動画翻訳/吹き替えに使えますか？',
                    answer: 'はい。翻訳済みの音声トラックをアップロードすれば、AIがリップシンクを整えて自然な吹き替え動画を作れます。',
                },
                {
                    question: '静止画でも動きますか（トーキングヘッド）？',
                    answer: 'はい。静止画のポートレートを「動画」素材としてアップロードすると、しゃべるアバター動画（Live Portrait効果）としてアニメーション化できます。',
                },
            ],
        },
        translateVideoSubtitle: {
            title: '無料AI動画字幕翻訳 - 自動字幕生成＆オンライン翻訳 | 微鲤AI',
            description: 'WeryAIのAI字幕翻訳で、動画字幕を自動生成して翻訳します。英語・スペイン語・日本語など90以上の言語に対応。焼き込み字幕（ハードサブ）付き動画をすぐにダウンロードできます。',
            keywords: 'AI字幕翻訳, 動画字幕翻訳ツール, 多言語字幕, 動画翻訳, 字幕コンバーター, AI動画翻訳',
            og_title: '無料AI動画字幕翻訳 - 自動字幕生成＆オンライン翻訳 | 微鲤AI',
            og_description: 'WeryAIのAI字幕翻訳で、動画字幕を自動生成して翻訳します。英語・スペイン語・日本語など90以上の言語に対応。焼き込み字幕（ハードサブ）付き動画をすぐにダウンロードできます。',
            twitter_title: '無料AI動画字幕翻訳 - 自動字幕生成＆オンライン翻訳 | 微鲤AI',
            twitter_description: 'WeryAIのAI字幕翻訳で、動画字幕を自動生成して翻訳します。英語・スペイン語・日本語など90以上の言語に対応。焼き込み字幕（ハードサブ）付き動画をすぐにダウンロードできます。',
            page: {
                title1: '無料AI動画字幕翻訳',
                title2: '言語の壁を一瞬で解消。動画をアップロードして目的の言語を選ぶだけで、AIが音声を認識・文字起こしし、翻訳した字幕を動画へ焼き込みます。',
                feature_title1: '90+言語対応',
                feature_desc1: '英語からスペイン語、フランス語、ドイツ語、日本語、中国語などへ翻訳し、ワンクリックでグローバルに展開できます。',
                feature_title2: '自動同期＆焼き込み',
                feature_desc2: 'タイムスタンプ調整は不要。AIが音声と字幕を正確に同期し、動画に焼き込み（ハードサブ）で出力するため互換性も高いです。',
                feature_title3: '文脈を理解する高精度翻訳',
                feature_desc3: '高度なLLMにより、文脈やスラングを理解して自然な訳文を生成。機械的な直訳になりません。',
                faq: [
                    {
                        question: '動画字幕を自動で翻訳するには？',
                        answer: 'WeryAIに動画をアップロードし、「Target Language」（例：英語→スペイン語）を選んで「Create」をクリックします。AIが字幕を自動生成・翻訳します。',
                    },
                    {
                        question: '対応している翻訳言語は？',
                        answer: '英語、スペイン語、フランス語、ドイツ語、ポルトガル語、ヒンディー語、日本語、中国語など、90以上の言語に対応しています。',
                    },
                    {
                        question: '字幕翻訳は無料ですか？',
                        answer: 'はい。WeryAIはAI字幕翻訳を無料で試せます。高額な文字起こしサービスを使わずに動画を処理できます。',
                    },
                    {
                        question: 'SRTファイルをダウンロードする必要はありますか？',
                        answer: 'いいえ。WeryAIは字幕を焼き込んだ動画（ハードサブ）を生成します。TikTok、Instagram、YouTubeでも正しく表示されます。',
                    },
                    {
                        question: 'AI翻訳の精度はどのくらい？',
                        answer: '最先端の音声認識モデルを使用し高精度です。音声がクリアな場合、精度は95%を超えることもあります。',
                    },
                ],
            },
            faq: [
                {
                    question: '動画字幕を自動で翻訳するには？',
                    answer: 'WeryAIに動画をアップロードし、Target Languageを選んでCreateをクリックします。AIが字幕を自動生成・翻訳します。',
                },
                {
                    question: '対応している翻訳言語は？',
                    answer: '英語、スペイン語、フランス語、ドイツ語、ポルトガル語、ヒンディー語、日本語、中国語など、90以上の言語に対応しています。',
                },
                {
                    question: 'SRTファイルをダウンロードする必要はありますか？',
                    answer: 'いいえ。字幕を焼き込んだ動画（ハードサブ）として出力され、各SNSで正しく表示されます。',
                },
            ],
        },
        videoToAnime: {
            title: '無料AI動画→アニメ変換 - 実写をカートゥーン/ピクサー風に | 微鲤AI',
            description: 'WeryAIの動画→アニメ変換で、実写動画を日本アニメ、3Dピクサー風、カートゥーンに一瞬で変換。フレーム単位の安定性で滑らかなアニメーション。無料・オンライン。',
            keywords: '動画をアニメに, AIアニメフィルター, 動画をカートゥーン化, ピクサー風フィルター, 実写からアニメ, domoai 代替, アニメ動画生成',
            og_title: '無料AI動画→アニメ変換 - 実写をカートゥーン/ピクサー風に | 微鲤AI',
            og_description: 'WeryAIの動画→アニメ変換で、実写動画を日本アニメ、3Dピクサー風、カートゥーンに一瞬で変換。フレーム単位の安定性で滑らかなアニメーション。無料・オンライン。',
            twitter_title: '無料AI動画→アニメ変換 - 実写をカートゥーン/ピクサー風に | 微鲤AI',
            twitter_description: 'WeryAIの動画→アニメ変換で、実写動画を日本アニメ、3Dピクサー風、カートゥーンに一瞬で変換。フレーム単位の安定性で滑らかなアニメーション。無料・オンライン。',
            page: {
                title1: '無料AI 動画→アニメ変換',
                title2: 'ワンクリックでアニメ主人公に。実写動画をアップロードし、スタイル（ピクサー3D／クラシック2D／手描き）を選ぶだけ。AIがフレームごとにリスタイルしつつ、元の動きを滑らかに保ちます。',
                feature_desc1: '<div><p>Pixar & 3D：家族動画にぴったりな、ディズニー風の可愛い3Dアニメクリップを作成。</p><p>Classic Anime：本格的な日本アニメの質感（ジブリ/新海誠風）。</p><p>Sketch & Ink：動画を手描き鉛筆風のアートアニメに。</p></div>',
                feature_title2: 'フレーム単位の安定性',
                feature_desc2: 'AI動画のチラつきにうんざり？WeryAIは高度な時間的一貫性アルゴリズムで、よくある“ガタつき”を抑え、滑らかに再生できるアニメ動画にします。',
                feature_title3: 'バズるコンテンツ制作',
                feature_desc3: 'TikTokやReels向けに設計。「実写 vs アニメ」の比較動画など、目を引くトレンド動画をすぐ作れます。',
                faq: [
                    {
                        question: '無料で動画をアニメにする方法は？',
                        answer: 'WeryAIの動画→アニメツールに動画をアップロードし、スタイル（例：「2D Style」「Pixar Style」）を選んで Create をクリック。毎日の無料クレジットで試せます。',
                    },
                    {
                        question: 'ピクサー/ディズニー風に変換できますか？',
                        answer: 'はい！「3D Cartoon」または「Pixar Style」プリセットで、実写人物を可愛い3Dキャラに変換できます。',
                    },
                    {
                        question: '動画の長さはどれくらいまで？',
                        answer: '現在は最大30秒（UIの「Maximum video duration: 30s」）まで対応。Shorts/Reels/TikTokに最適です。',
                    },
                    {
                        question: 'アニメキャラは私の動きを真似しますか？',
                        answer: 'もちろん。骨格の動きや表情を解析し、動きをできるだけ忠実に再現します。',
                    },
                    {
                        question: '最高の動画→アニメ変換ツールは？',
                        answer: 'WeryAIは2D/3Dなど複数スタイルを提供し、フレーム安定性に注力してノイズやチラつきを減らす点で選ばれています。',
                    },
                ],
            },
            faq: [
                {
                    question: '無料で動画をアニメにする方法は？',
                    answer: 'WeryAIに動画をアップロードし、2D StyleやPixar Styleなどを選んで Create をクリックします。',
                },
                {
                    question: 'ピクサー/ディズニー風に変換できますか？',
                    answer: 'はい。3D Cartoon/Pixar Styleプリセットで、実写人物を可愛い3Dキャラに変換できます。',
                },
                {
                    question: 'アニメキャラは私の動きを真似しますか？',
                    answer: 'はい。骨格の動きや表情を解析し、動きをできるだけ忠実に再現します。',
                },
            ],
            app_name: '微鲤AI 動画→アニメ変換',
            app_desc: '実写動画をアニメ/カートゥーン/ピクサー風に変換する無料AIツール。フレーム単位レンダリングで安定したアニメーション。',
            featureList: '実写→アニメ, ピクサーフィルター, フレーム安定, 2D/3Dスタイル',
        },
        videoUpscaler: {
            title: '無料AI動画アップスケーラー＆高画質化 - 4Kまでオンライン | 微鲤AI',
            description: 'WeryAIの無料AI動画アップスケーラーで、低解像度動画を1080p/2K/4Kへ即時アップスケール。ブロックノイズを抑え、ノイズ除去と高画質化をオンラインで実行。インストール不要。',
            keywords: '動画アップスケーラー, AI動画高画質化, 動画を4Kにアップスケール, 動画のぼかし修正, 動画ノイズ除去, 画質向上, 無料オンライン動画アップスケール',
            og_title: '無料AI動画アップスケーラー＆高画質化 - 4Kまでオンライン | 微鲤AI',
            og_description: 'WeryAIの無料AI動画アップスケーラーで、低解像度動画を1080p/2K/4Kへ即時アップスケール。ブロックノイズを抑え、ノイズ除去と高画質化をオンラインで実行。インストール不要。',
            twitter_title: '無料AI動画アップスケーラー＆高画質化 - 4Kまでオンライン | 微鲤AI',
            twitter_description: 'WeryAIの無料AI動画アップスケーラーで、低解像度動画を1080p/2K/4Kへ即時アップスケール。ブロックノイズを抑え、ノイズ除去と高画質化をオンラインで実行。インストール不要。',
            page: {
                title1: '無料AI動画アップスケーラー＆高画質化',
                title2: 'ぼやけた・粗い映像で妥協しないでください。低解像度（360p/480p/720p）の動画をアップロードすると、AIが自動で美しい4Kにアップスケール。サイズ拡大だけでなく、ディテール復元・ノイズ除去・色補正まで行います。',
                feature_title1: '4Kへアップスケール',
                feature_desc1: '古い動画を蘇らせます。SDをHD/4Kへワンクリック変換し、大画面でもくっきり見える映像に。',
                feature_title2: 'ぼかし＆粒状ノイズを修正',
                feature_desc2: '暗所撮影でも安心。AIデノイズがデジタルノイズや圧縮アーティファクトを除去し、クリーンな見た目に。',
                feature_title3: '旧映像の復元',
                feature_desc3: '家族のアーカイブに最適。ホームビデオや古いクリップの色あせを補正し、ディテールをシャープに。',
                faq: [
                    {
                        question: '無料でオンラインで動画を4Kにできますか？',
                        answer: 'はい。WeryAIは最大4Kの出力解像度を選択できます（ツールオプション参照）。毎日の無料クレジットで試せます。',
                    },
                    {
                        question: 'ぼやけた動画を直すには？',
                        answer: 'ぼやけた動画をAI動画アップスケーラーにアップロードするだけ。失われたピクセルを解析し、ディテールを再構成して鮮明化します。',
                    },
                    {
                        question: '古いスマホ動画にも効きますか？',
                        answer: 'もちろん。古い端末/カメラの低画質（360p/480pなど）ほど効果が出やすく、1080p以上にクリアにできます。',
                    },
                    {
                        question: '処理にはどれくらい時間がかかりますか？',
                        answer: 'アップスケールは計算負荷が高い処理ですが、WeryAIは最適化されたクラウドGPUで高速処理します。短いクリップなら数分が目安です。',
                    },
                    {
                        question: 'Topaz Video AIより良いですか？',
                        answer: 'WeryAIは同等クラスのAI品質を提供し、ブラウザ内で完結します。高価なハードや重いソフトの導入なしでプロ品質を得られます。',
                    },
                ],
            },
            faq: [
                {
                    question: 'オンラインで動画を4Kにアップスケールできますか？',
                    answer: 'はい。最大4Kまで選べます。毎日の無料クレジットで試せます。',
                },
                {
                    question: 'ぼやけた動画を直すには？',
                    answer: 'ぼやけた動画をアップロードするだけ。AIが欠損を解析してディテールを再構成します。',
                },
                {
                    question: 'Topaz Video AIより良いですか？',
                    answer: 'WeryAIは同等クラスのAI品質を、インストール不要でブラウザ内で提供します。',
                },
            ],
            app_name: '微鲤AI Video Upscaler',
            app_desc: '無料のAI動画アップスケーラー。最大4Kまで高画質化し、ぼかし修正・ノイズ除去・旧映像復元をオンラインで実行。',
            featureList: '4Kアップスケール, AIデノイズ, 動画シャープ化, 色補正',
        },
        removeVideoSubtitles: {
            title: '字幕消去 - AI動画字幕削除ツール | 微鲤AI',
            description: 'AI技術で動画から埋め込まれた字幕を消去。動画内のハードコード字幕とテキストをスマートに削除し、動画品質を維持。高速で簡単に使用可能。',
            keywords: '動画字幕消去, 字幕削除, 字幕除去, 字幕消去, 動画字幕削除, ハードコード字幕削除',
            og_title: '字幕消去 - AI動画字幕削除ツール | 微鲤AI',
            og_description: 'AI技術で動画から埋め込まれた字幕を消去。動画内のハードコード字幕とテキストをスマートに削除し、動画品質を維持。高速で簡単に使用可能。',
            twitter_title: '字幕消去 - AI動画字幕削除ツール | 微鲤AI',
            twitter_description: 'AI技術で動画から埋め込まれた字幕を消去。動画内のハードコード字幕とテキストをスマートに削除し、動画品質を維持。高速で簡単に使用可能。',
            page: {
                title1: '無料AI 動画字幕消去',
                title2: '焼き付き字幕で困っていますか？微鲤AI のインテリジェントなアルゴリズムが、ハードコード字幕・歌詞・画面上テキストを自動検出して消去します。リンク貼り付けまたはファイルアップロードで、文字なしの綺麗な動画をすぐに復元。',
                feature_title1: 'テキスト自動検出',
                feature_desc1: '手動マスクは不要。AI が画面下部（または任意の位置）のテキスト領域を自動で見つけ、背景から分離します。',
                feature_title2: '自然なインペインティング',
                feature_desc2: 'ぼかし四角にさようなら。周囲のピクセルを解析し、消した部分を自然に“塗り直し”して質感を復元します。',
                feature_title3: 'リンク＆ファイル対応',
                feature_desc3: 'TikTok / YouTube / Instagram のリンクから直接字幕を除去、または MP4/MOV をアップロード。コンテンツ再利用にも最適です。',
                faq: [
                    {
                        question: '焼き付き（ハードコード）字幕は消せますか？',
                        answer: 'はい。本ツールは、動画画像に埋め込まれてオフにできないハードコード字幕向けに設計されています。画面上から視覚的に消去します。',
                    },
                    {
                        question: 'TikTok/YouTube の字幕を消すには？',
                        answer: '動画リンクをコピーして 微鲤AI の “Video Link” タブに貼り付け、“Generate” をクリックします。AI が字幕を消去し、文字なし動画をダウンロードできます。',
                    },
                    {
                        question: '文字の裏の背景まで消えませんか？',
                        answer: 'いいえ。微鲤AI は AI インペインティングで、テキストを消した後に背景を賢く“描き戻し”ます。元の映像のように自然に見えます。',
                    },
                    {
                        question: 'ウォーターマーク除去との違いは？',
                        answer: '仕組みは近いですが、字幕消去は下部の字幕帯・歌詞・キャプションなど“文字列”に最適化。一方ウォーターマーク除去はロゴやスタンプ向けです。',
                    },
                    {
                        question: '無料で使えますか？',
                        answer: 'はい。毎日の無料クレジットで基本機能を無料で試せます。',
                    },
                ],
            },
            faq: [
                {
                    question: 'ハードコード字幕は消せますか？',
                    answer: 'はい。動画画像に埋め込まれた字幕を画面上から視覚的に消去します。',
                },
                {
                    question: 'TikTok のリンク動画の字幕を消す方法は？',
                    answer: 'リンクをコピーして “Video Link” タブに貼り付け、“Generate” をクリックするだけで、AI が自動で字幕を消去します。',
                },
                {
                    question: 'テキストの裏の背景は壊れませんか？',
                    answer: 'いいえ。AI インペインティングで背景を自然に復元します。',
                },
            ],
            app_name: '微鲤AI 動画字幕消去',
            app_desc: '動画の焼き付き字幕・キャプション・テキストを無料で消すAIツール。インペインティングで背景を復元し、ぼかしブロックなしで仕上げます。',
            featureList: '焼き付き字幕削除, AI背景復元, 動画リンク対応, 歌詞/テキスト消去',
        },
        videoBackgroundRemover: {
            title: '動画背景除去ツール - AI動画背景削除 | 微鲤AI',
            description: 'AIで動画から背景を自動的に削除。グリーンスクリーン効果を作成し、被写体を分離し、動画背景を簡単に置き換え。コンテンツクリエイターと動画編集者に最適。',
            keywords: '動画背景除去, 動画背景削除, グリーンスクリーン, AI背景削除, 動画背景消しゴム, 動画被写体分離',
            og_title: '動画背景除去ツール - AI動画背景削除 | 微鲤AI',
            og_description: 'AIで動画から背景を自動的に削除。グリーンスクリーン効果を作成し、被写体を分離し、動画背景を簡単に置き換え。コンテンツクリエイターと動画編集者に最適。',
            twitter_title: '動画背景除去ツール - AI動画背景削除 | 微鲤AI',
            twitter_description: 'AIで動画から背景を自動的に削除。グリーンスクリーン効果を作成し、被写体を分離し、動画背景を簡単に置き換え。コンテンツクリエイターと動画編集者に最適。',
            page: {
                title1: '無料AI 動画背景除去',
                title2: 'グリーンスクリーン不要。動画をアップロードするとAIが被写体を自動検出し、髪の毛レベルの精度で切り抜きます。透明動画としてダウンロードするか、背景色をワンクリックで差し替えできます。',
                feature_title1: 'グリーンスクリーン不要',
                feature_desc1: '高価なスタジオは不要。AIが複雑な背景から人・ペット・物体を自動分離（自動ロトスコープ）。',
                feature_title2: '単色背景に置換',
                feature_desc2: 'EC向けに最適。商品動画の背景を純白・黒・任意カラーへワンクリックで変更し、見栄えとCVを向上。',
                feature_title3: '透明で書き出し',
                feature_desc3: 'アルファチャンネル付きの WebM/MOV を出力。Premiere、DaVinci、CapCut などで他の動画に重ねられます。',
                faq: [
                    {
                        question: 'グリーンスクリーンなしで動画背景を消せますか？',
                        answer: 'はい。WeryAIは高度な機械学習で被写体と背景を判別するため、どこで撮影した動画でも背景除去が可能です。',
                    },
                    {
                        question: '透明背景の動画はどう保存しますか？',
                        answer: '背景除去後、出力形式で WebM（Transparent）または MOV を選択してください。標準のMP4は透明に対応せず黒背景になります。',
                    },
                    {
                        question: '背景を白にできますか？',
                        answer: 'できます。ツール設定の “Background Color” で白・黒・任意のHEXカラーを選べます。Amazon/Shopifyの商品動画に最適です。',
                    },
                    {
                        question: '髪の毛の細部も綺麗に処理できますか？',
                        answer: '得意です。縮れ毛や毛並み、半透明物体（メガネなど）の複雑な輪郭も自然に残すよう学習されています。',
                    },
                    {
                        question: '無料で使えますか？',
                        answer: 'はい。毎日の無料クレジットで動画を無料で処理できます。',
                    },
                ],
            },
            faq: [
                {
                    question: 'グリーンスクリーンなしで動画背景を消せますか？',
                    answer: 'はい。WeryAIはグリーンスクリーン不要で背景を除去できます。',
                },
                {
                    question: '透明背景の動画はどう保存しますか？',
                    answer: '出力形式で WebM（Transparent）または MOV を選択してください。MP4は透明に対応していません。',
                },
                {
                    question: '背景を白にできますか？',
                    answer: 'はい。“Background Color” で白を選択できます。ECの商品動画に最適です。',
                },
            ],
            app_name: '微鲤AI 動画背景除去',
            app_desc: 'グリーンスクリーン不要で動画背景を消す無料AIツール。透明動画の書き出しや、白/黒/任意カラーへの背景変更に対応。',
            featureList: 'グリーンスクリーン不要, 透明動画書き出し, 背景色変更, 髪の毛レベル精度',
            step_name: 'オンラインで動画背景を消す方法',
            step_list: [
                {
                    name: '動画をアップロード',
                    text: 'MP4/MOV を 微鲤AI 背景除去ツールにアップロードします。',
                },
                {
                    name: '背景を除去',
                    text: 'AIが自動処理します。透明のままにするか、新しい背景色を選べます。',
                },
                {
                    name: '書き出し',
                    text: '結果をダウンロード。透明なら WebM/MOV、単色背景なら MP4 を選択してください。',
                },
            ],
        },
        aiVideoExtender: {
            title: 'AI動画延長ツール - 動画の長さと時間を延長 | 微鲤AI',
            description: 'AI技術で動画の長さを延長。アニメ、3Dアニメーション、サイバーパンク、コミックなど複数のスタイルオプションで、動画に5〜8秒をシームレスに追加。コンテンツクリエイターと動画編集者に最適。',
            keywords: 'AI動画延長, 動画の長さ延長, 動画時間延長, AI動画拡張, 動画伸長, 動画時間追加, AI動画ツール',
            og_title: 'AI動画延長ツール - 動画の長さと時間を延長 | 微鲤AI',
            og_description: 'AI技術で動画の長さを延長。アニメ、3Dアニメーション、サイバーパンク、コミックなど複数のスタイルオプションで、動画に5〜8秒をシームレスに追加。コンテンツクリエイターと動画編集者に最適。',
            twitter_title: 'AI動画延長ツール - 動画の長さと時間を延長 | 微鲤AI',
            twitter_description: 'AI技術で動画の長さを延長。アニメ、3Dアニメーション、サイバーパンク、コミックなど複数のスタイルオプションで、動画に5〜8秒をシームレスに追加。コンテンツクリエイターと動画編集者に最適。',
            page: {
                title1: '無料AI 動画延長＆続き生成',
                title2: '動画が短すぎますか？微鲤AI は生成AIで次のフレームを予測・生成し、自然に動画を延長します。プロンプトで“続き”を誘導したり、通常映像をなめらかなスローモーションに変換することも可能です。',
                feature_title1: 'スマート生成延長',
                feature_desc1: 'ただ伸ばすのではなく、新しい内容を生成。例えば「カメラがズームアウト」「キャラクターが振り向く」などのプロンプトで、元のスタイルに沿った次の 5〜10 秒を生成します。',
                feature_title2: 'なめらかスローモーション',
                feature_desc2: '通常の 30fps 動画を高品質なスローに。微鲤AI はフレーム補間（Frame Interpolation）で中間フレームを生成し、カクつきなく滑らかにします。',
                feature_title3: '完璧ループ作成',
                feature_desc3: 'SNSの背景向けに無限ループを作成。開始フレームと終了フレームを解析して自然にブレンドします。',
                faq: [
                    {
                        question: 'AI 動画延長はどう動作しますか？',
                        answer: '“Generative Outpainting（生成的アウトペインティング）”を使用します。動画の最後のフレームとプロンプトを解析し、次に起こる動作を予測して新しいフレームを生成します。',
                    },
                    {
                        question: '延長部分の内容をコントロールできますか？',
                        answer: 'はい。ツールの “Prompt” に動作を入力します。例えば車が走っている動画なら「車がトンネルに入る」と入力して延長を誘導できます。',
                    },
                    {
                        question: '延長（Extension）とスローモーションの違いは？',
                        answer: '延長は新しい出来事を生成して“新しい時間”を追加します（物語を長くする）。スローは中間フレームを追加して“既存の時間”を伸ばします（動きをゆっくりに）。微鲤AI は両方対応。',
                    },
                    {
                        question: 'どれくらい延長できますか？',
                        answer: '1回につき 5 秒延長できます（“Extension Duration” 設定）。繰り返してより長いシーケンスを作れます。',
                    },
                    {
                        question: '無料ですか？',
                        answer: 'はい。動画延長やスローモーションを試せる無料クレジットがあります。',
                    },
                ],
            },
            faq: [
                {
                    question: 'AI 動画延長はどう動作しますか？',
                    answer: '“Generative Outpainting”で、最後のフレームとプロンプトを解析し、続きのフレームを生成します。',
                },
                {
                    question: '延長部分の内容をコントロールできますか？',
                    answer: 'はい。“Prompt” に動作を入力して誘導できます。例：車の動画なら「車がトンネルに入る」。',
                },
                {
                    question: '延長（Extension）とスローモーションの違いは？',
                    answer: '延長は新しい出来事を生成して時間を追加。スローは中間フレームを追加して動きを遅くします。',
                },
            ],
            app_name: '微鲤AI 動画延長ツール',
            app_desc: '生成的補完とプロンプトで動画を延長できる無料AIツール。フレーム補間によるAIスローモーションやループ作成にも対応。',
            featureList: '生成動画延長, プロンプト誘導の続き生成, AIスローモーション, ループ作成',
        },
        videoEffects: {
            title: '動画エフェクト - AIでバイラル動画を作成 | 微鲤AI',
            description: 'WeryAIで人気のAI動画エフェクトを探索。AIキスからAIダンスまで、数回クリックするだけでバイラル動画を作成。',
            keywords: 'AI動画エフェクト, AIバイラル動画, 動画トレンド, AIキス, AIダンス, 動画ジェネレーター',
        },
        aiDancing: {
            title: 'AIダンス動画ジェネレーター - 無料AIダンス動画メーカー | 微鲤AI',
            description: 'WeryAIのAIダンスジェネレーターを使用して、写真から素晴らしいダンス動画を作成します。複数のダンステンプレートとスタイルをサポートし、写真に命を吹き込みます！',
            keywords: 'AIダンス動画, AIダンスジェネレーター, 写真から動画, AI動画生成, 微鲤AI, 無料AIツール',
        },
        aiKissing: {
            title: 'aiKissing | 微鲤AI',
            description: 'Experience aiKissing on 微鲤AI platform.',
            keywords: 'aiKissing, AI, 微鲤AI',
        },
        videoMotionImitation: {
            title: 'AI 動画モーション模倣 - 無料で写真を生き生きと | 微鲤AI',
            description: 'WeryAIの動画モーション模倣ツールは、写真のキャラクターを参照動画に統合でき、元のキャラクターを置き換えながら、シーンの照明とトーンを保持し、シームレスな環境融合を実現します。',
            keywords: 'AI動画モーション模倣, 写真を生き生きと, AI動画モーション模倣ツール, 微鲤AI, 無料AIツール',
            og_title: 'AI 動画モーション模倣 - 無料で写真を生き生きと | 微鲤AI',
            og_description: 'WeryAIの動画モーション模倣ツールは、写真のキャラクターを参照動画に統合でき、元のキャラクターを置き換えながら、シーンの照明とトーンを保持し、シームレスな環境融合を実現します。',
            twitter_title: 'AI 動画モーション模倣 - 無料で写真を生き生きと | 微鲤AI',
            twitter_description: 'WeryAIの動画モーション模倣ツールは、写真のキャラクターを参照動画に統合でき、元のキャラクターを置き換えながら、シーンの照明とトーンを保持し、シームレスな環境融合を実現します。',
            page: {
                title1: '無料AIダンス生成＆モーショントランスファー',
                title2: '好きなアニメキャラがマイケル・ジャクソンみたいに踊ったら？静止画にバズり中のTikTokムーブをさせたい？参照動画とキャラクター画像をアップロードするだけで、AIが動きを正確に転送します。',
                feature_title1: '動画キャラクター置き換え',
                feature_desc1: '実写→アニメ入れ替え：踊りやアクション動画の人物を、3Dキャラ・パンダ・アバターに置き換えつつ、背景とライティングはそのまま。',
                feature_title2: '写真を踊らせる',
                feature_desc2: '静止画をアニメーション化：自分やキャラの写真をアップロードし、参照ダンス動画を選ぶだけ。Viggle風のバイラル動画制作にも最適。',
                feature_title3: '次元の壁を越える',
                feature_desc3: '異次元スタイル対応：バレリーナをアニメ少女に、空手少年をパンダにしても、複雑な体型や遮蔽をうまく処理します。',
                faq: [
                    {
                        question: 'AIで写真を踊らせるには？',
                        answer: 'WeryAIの「Move Mode」を使います。動かしたい写真（Character Image）と、動きの参照となる動画（Reference Video）をアップロードして Create をクリックすると、モーションが転送されます。',
                    },
                    {
                        question: 'Move Mode と Replace Mode の違いは？',
                        answer: 'Move Mode は動画の動きで静止画像を動かします。Replace Mode は既存動画内の人物を、画像のキャラクターに置き換えます。',
                    },
                    {
                        question: 'TikTokトレンドにも使えますか？',
                        answer: 'はい。トレンドのダンスやチャレンジに最適で、セレブやアニメキャラ、友達にも流行の動きをさせられます。',
                    },
                    {
                        question: '全身ショットでも動きますか？',
                        answer: 'はい。参照動画とキャラクター画像は、できるだけ全身がはっきり見えるものがベストです。',
                    },
                    {
                        question: '無料ですか？',
                        answer: 'はい。毎日の無料クレジットで無料で生成できます。',
                    },
                ],
            },
            faq: [
                {
                    question: 'AIで写真を踊らせるには？',
                    answer: 'WeryAIの「Move Mode」を使います。動かしたい写真（Character Image）と、動きの参照となる動画（Reference Video）をアップロードして Create をクリックすると、モーションが転送されます。',
                },
                {
                    question: 'Move Mode と Replace Mode の違いは？',
                    answer: 'Move Mode は動画の動きで静止画像を動かします。Replace Mode は既存動画内の人物を、画像のキャラクターに置き換えます。',
                },
            ],
            app_name: '微鲤AI モーショントランスファー',
            app_desc: '無料のAIダンス生成＆モーショントランスファー。写真を踊らせる、静止画を動かす、動画の人物を入れ替える—すべてオンラインで。',
            featureList: 'AIダンス生成, ポーズ転送, 動画キャラ入れ替え, 写真アニメーション',
            step_name: 'AIで写真を踊らせる方法',
            step_list: [
                {
                    name: '参照動画をアップロード',
                    text: 'コピーしたいダンスや動きが入った動画をアップロードします。',
                },
                {
                    name: 'キャラクター画像をアップロード',
                    text: '動かしたい人物/キャラクターの静止画像をアップロードします。',
                },
                {
                    name: 'Move Mode を選択',
                    text: '「Move Mode」を選んで Create をクリック。AIが参照動画の動きを写真に転送します。',
                },
            ],
        },
    },
    ko: {
        textToMusic: {
            title: 'AI 음악 생성기 - WeryAI로 독특한 음악 만들기 | 微鲤AI',
            description: 'WeryAI의 AI 음악 생성기를 발견하세요. 고급 AI 기술로 프로젝트에 맞는 독특한 저작권 무료 음악을 빠르게 만들 수 있습니다. 콘텐츠 크리에이터, 게임 개발자, 음악 애호가에게 완벽합니다.',
            keywords: '텍스트 음악 생성, 텍스트 음악 무료, AI 텍스트 음악, AI 음악 생성기, AI 노래 메이커, 가사 음악 생성, 유사 음악 만들기, 음악 제작, 저작권 무료 음악, 무료 음악 다운로드, 微鲤AI',
        },
        textToVideo: {
            title: '무료 AI 텍스트→비디오 생성기(Veo 3.1, Kling & Sora) | 微鲤AI',
            description: 'WeryAI의 텍스트→비디오 AI로 프롬프트를 즉시 시네마틱 영상으로 변환하세요. Google Veo 3.1, Kling, Sora 기반. 16:9 및 9:16 비율 지원, 최대 8초까지 생성. 워터마크 없는 옵션도 제공됩니다.',
            keywords: '텍스트→비디오 AI, AI 비디오 생성기, Google Veo 3.1, Kling AI, Sora, 프롬프트로 비디오, txt2vid, 微鲤AI',
            og_title: '무료 AI 텍스트→비디오 생성기(Veo 3.1, Kling & Sora) | 微鲤AI',
            og_description: 'WeryAI의 텍스트→비디오 AI로 프롬프트를 즉시 시네마틱 영상으로 변환하세요. Google Veo 3.1, Kling, Sora 기반. 16:9 및 9:16 비율 지원, 최대 8초까지 생성. 워터마크 없는 옵션도 제공됩니다.',
            twitter_title: '무료 AI 텍스트→비디오 생성기(Veo 3.1, Kling & Sora) | 微鲤AI',
            twitter_description: 'WeryAI의 텍스트→비디오 AI로 프롬프트를 즉시 시네마틱 영상으로 변환하세요. Google Veo 3.1, Kling, Sora 기반. 16:9 및 9:16 비율 지원, 최대 8초까지 생성. 워터마크 없는 옵션도 제공됩니다.',
            page: {
                title1: '무료 AI 텍스트→비디오 생성기',
                title2: '프롬프트만 입력하면 WeryAI가 아이디어를 영상으로 만들어줍니다. Google Veo 3.1, Kling 등 최신 모델을 한곳에 모아, 소셜용 세로 영상(9:16)부터 시네마용 가로 영상(16:9)까지 고품질·물리적으로 자연스러운 영상을 몇 초 만에 생성할 수 있습니다.',
                intro_title: '텍스트→비디오 AI로 상상을 현실로',
                feature_title: '微鲤AI 텍스트→비디오 기능',
                faq_title: '텍스트→비디오 FAQ',
                feature_title1: '멀티 모델 파워',
                feature_desc1: '현실감은 Veo 3.1, 모션 일관성은 Kling. 여러 구독이 필요 없습니다.',
                feature_title2: '맞춤 화면 비율',
                feature_desc2: 'TikTok/Reels용 9:16 세로, YouTube용 16:9 가로를 바로 생성하세요.',
                feature_title3: '최대 8초(연장 가능)',
                feature_desc3: '한 번의 생성으로 최대 8초(모델별 상이). 연장 도구로 자연스럽게 이어서 만들 수 있습니다.',
                faq: [
                    {
                        question: '좋은 텍스트→비디오 프롬프트는 어떻게 쓰나요?',
                        answer: '구체적으로 작성하세요. 주제, 동작, 조명, 카메라 앵글을 포함하면 좋습니다. 예: "밤의 미래 사이버펑크 도시 드론 샷, 네온, 4K".',
                    },
                    {
                        question: 'Google Veo 3.1과 Kling 중 무엇을 써야 하나요?',
                        answer: 'Veo 3.1은 시각적 디테일과 프롬프트 준수에 강해 현실적인 장면에 적합합니다. Kling은 복잡한 캐릭터 움직임에서 더 좋은 경우가 많습니다. 둘 다 테스트해보길 권장합니다.',
                    },
                    {
                        question: '微鲤AI 텍스트→비디오는 무료인가요?',
                        answer: '네. 매일 제공되는 무료 크레딧으로 텍스트에서 비디오를 생성해볼 수 있습니다.',
                    },
                    {
                        question: '8초보다 긴 영상을 만들 수 있나요?',
                        answer: '기본 생성은 최대 8초(모델별 상이)입니다. 더 길게 만들려면 AI Video Extender 도구로 자연스럽게 이어서 생성하세요.',
                    },
                    {
                        question: '생성된 영상에 소리가 있나요?',
                        answer: '네. 도구에서 "Generate Audio" 토글을 켜면 효과음과 배경 앰비언스를 자동으로 생성할 수 있습니다.',
                    },
                ],
            },
            faq: [
                {
                    question: '좋은 텍스트→비디오 프롬프트는 어떻게 쓰나요?',
                    answer: '주제·동작·조명·카메라 앵글을 구체적으로 쓰세요. 예: "사이버펑크 도시 드론 샷, 네온, 4K".',
                },
                {
                    question: 'Google Veo 3.1과 Kling 중 무엇을 써야 하나요?',
                    answer: '현실감/준수는 Veo 3.1, 모션 일관성은 Kling이 강점입니다. 둘 다 시도해보세요.',
                },
                {
                    question: '微鲤AI 텍스트→비디오는 무료인가요?',
                    answer: '네. 매일 무료 크레딧이 제공됩니다.',
                },
                {
                    question: '8초보다 긴 영상을 만들 수 있나요?',
                    answer: '기본은 최대 8초이며, 연장 도구로 더 길게 이어서 만들 수 있습니다.',
                },
                {
                    question: '생성된 영상에 소리가 있나요?',
                    answer: '네. "Generate Audio"를 켜면 자동 생성됩니다.',
                },
            ],
        },
        imageToVideo: {
            title: 'AI 이미지→비디오 생성기(무료·온라인) - Kling, Veo & Sora 기반',
            description: 'WeryAI의 무료 이미지→비디오 AI로 정적인 사진을 몇 초 만에 사실적인 영상으로 변환하세요. Kling, Google Veo, Sora 2 등 최상급 모델을 한곳에서 사용할 수 있습니다. 워터마크 없는 옵션도 제공됩니다.',
            keywords: '이미지→비디오 AI, AI 비디오 생성기, 이미지 애니메이션, Sora 비디오, Veo 비디오, Seedance 비디오, 微鲤AI 비디오 도구',
            og_title: 'AI 이미지→비디오 생성기(무료·온라인) - Kling, Veo & Sora 기반',
            og_description: 'WeryAI의 무료 이미지→비디오 AI로 정적인 사진을 몇 초 만에 사실적인 영상으로 변환하세요. Kling, Google Veo, Sora 2 등 최상급 모델을 한곳에서 사용할 수 있습니다. 워터마크 없는 옵션도 제공됩니다.',
            twitter_title: 'AI 이미지→비디오 생성기(무료·온라인) - Kling, Veo & Sora 기반',
            twitter_description: 'WeryAI의 무료 이미지→비디오 AI로 정적인 사진을 몇 초 만에 사실적인 영상으로 변환하세요. Kling, Google Veo, Sora 2 등 최상급 모델을 한곳에서 사용할 수 있습니다. 워터마크 없는 옵션도 제공됩니다.',
            page: {
                title1: '무료 온라인 AI 이미지→비디오 생성기',
                faq: [
                    {
                        question: 'AI 이미지→비디오 생성기는 어떻게 작동하나요?',
                        answer: 'Kling, Sora 같은 고급 딥러닝 모델이 정지 이미지를 분석해 움직임을 예측하고, MP4 형식의 자연스러운 영상 클립을 생성합니다.',
                    },
                    {
                        question: '微鲤AI 이미지→비디오는 무료인가요?',
                        answer: '네. 매일 제공되는 무료 크레딧으로 이미지→비디오 AI를 체험할 수 있습니다. 프리미엄 모델과 더 빠른 생성 속도가 필요하면 업그레이드할 수 있습니다.',
                    },
                    {
                        question: '더 현실적인 영상에는 Kling과 Veo 중 어떤 것이 좋나요?',
                        answer: 'Kling AI는 현실적인 움직임과 더 긴 길이에 강점이 있고, Google Veo는 고해상도 디테일에 뛰어납니다. WeryAI에서는 모델을 바꿔가며 최적의 결과를 찾을 수 있습니다.',
                    },
                    {
                        question: '생성한 영상을 상업적으로 사용할 수 있나요?',
                        answer: '네. 유료 플랜에서 생성한 영상은 상업용 라이선스가 포함되어 YouTube, TikTok, 마케팅 광고에 적합합니다.',
                    },
                    {
                        question: 'AI 영상의 워터마크는 어떻게 제거하나요?',
                        answer: 'WeryAI는 고품질 출력을 제공합니다. 워터마크 없는 영상이 필요하다면 플랜 혜택을 확인하거나 전용 AI 워터마크 제거 도구를 이용하세요.',
                    },
                ],
            },
            faq: [
                {
                    question: 'AI 이미지→비디오 생성기는 어떻게 작동하나요?',
                    answer: 'Kling, Sora 같은 고급 딥러닝 모델이 정지 이미지를 분석해 움직임을 예측하고, MP4 형식의 자연스러운 영상 클립을 생성합니다.',
                },
                {
                    question: '微鲤AI 이미지→비디오는 무료인가요?',
                    answer: '네. 매일 제공되는 무료 크레딧으로 이미지→비디오 AI를 체험할 수 있습니다. 프리미엄 모델과 더 빠른 생성 속도가 필요하면 업그레이드할 수 있습니다.',
                },
                {
                    question: '생성한 영상을 상업적으로 사용할 수 있나요?',
                    answer: '네. 유료 플랜에서 생성한 영상은 상업용 라이선스가 포함되어 YouTube, TikTok, 마케팅 광고에 적합합니다.',
                },
            ],
        },
        videoToVideo: {
            title: '무료 AI 비디오→비디오 생성기 - 리스타일 & 애니 필터 | 微鲤AI',
            description: 'WeryAI의 비디오→비디오 AI로 영상을 원하는 스타일로 변환하세요. 실사 영상을 애니메이션, 3D 카툰, 사이버펑크 아트로 텍스트 프롬프트만으로 리스타일하면서 원본 모션을 일관되게 유지합니다. 무료 & 온라인.',
            keywords: '비디오 투 비디오 AI, vid2vid, AI 비디오 스타일 전환, 비디오를 애니로, AI 비디오 리스타일, 무료 AI 비디오 필터',
            og_title: '무료 AI 비디오→비디오 생성기 - 리스타일 & 애니 필터 | 微鲤AI',
            og_description: 'WeryAI의 비디오→비디오 AI로 영상을 원하는 스타일로 변환하세요. 실사 영상을 애니메이션, 3D 카툰, 사이버펑크 아트로 텍스트 프롬프트만으로 리스타일하면서 원본 모션을 일관되게 유지합니다. 무료 & 온라인.',
            twitter_title: '무료 AI 비디오→비디오 생성기 - 리스타일 & 애니 필터 | 微鲤AI',
            twitter_description: 'WeryAI의 비디오→비디오 AI로 영상을 원하는 스타일로 변환하세요. 실사 영상을 애니메이션, 3D 카툰, 사이버펑크 아트로 텍스트 프롬프트만으로 리스타일하면서 원본 모션을 일관되게 유지합니다. 무료 & 온라인.',
            page: {
                title1: '무료 AI 비디오→비디오 생성기 (Vid2Vid)',
                title2: '비디오를 업로드하고 스타일을 입력하면 끝. WeryAI의 비디오→비디오 기술이 원본 영상의 움직임을 분석하고, 텍스트 프롬프트에 따라 완전히 새로운 아트 스타일을 적용합니다. 애니 편집, 클레이메이션 효과, 초현실 비주얼 제작에 적합합니다.',
                feature_title1: '일관된 모션',
                feature_desc1: '일반 생성과 달리 Vid2Vid 엔진이 원본 움직임을 고정해 깜빡임을 줄이고 부드러운 전환을 제공합니다.',
                feature_title2: '실사 → 애니',
                feature_desc2: '크리에이터에게 인기 #1. 나를 애니 캐릭터나 3D 픽사풍 아바타로 즉시 변환하세요.',
                feature_title3: '프롬프트 컨트롤',
                feature_desc3: '"사이버펑크 도시 스타일" 또는 "유화 스타일"처럼 입력해 결과의 느낌을 정확히 지정할 수 있습니다.',
                faq: [
                    {
                        question: 'AI 비디오→비디오(Vid2Vid)란 무엇인가요?',
                        answer: '기존 비디오 클립을 입력으로 받아, 텍스트 프롬프트로 지정한 새로운 스타일로 “다시 그리되”, 원본의 움직임과 구조를 최대한 유지하는 생성형 AI 과정입니다.',
                    },
                    {
                        question: '비디오를 애니메이션 스타일로 바꿀 수 있나요?',
                        answer: '네! 가장 인기 있는 사용 사례입니다. 비디오를 업로드한 뒤 “일본 애니 스타일, 지브리 느낌” 같은 프롬프트를 입력하면 변환됩니다.',
                    },
                    {
                        question: '원본 비디오 길이는 얼마나 지원하나요?',
                        answer: '현재는 최고 품질을 위해 짧은 클립(예: 5~10초)을 지원/권장합니다. 더 긴 영상은 구간을 나눠 처리하는 것을 추천합니다.',
                    },
                    {
                        question: '일반 비디오 편집기와 무엇이 다른가요?',
                        answer: '전통적인 편집기는 자르고 붙이는 작업이 중심입니다. 微鲤AI 비디오→비디오는 새로운 픽셀을 생성해 질감과 아트 스타일 자체를 바꿉니다.',
                    },
                    {
                        question: '비용이 드나요?',
                        answer: 'WeryAI는 비디오→비디오 기능을 체험할 수 있도록 매일 무료 크레딧을 제공합니다. 더 빠른 처리와 워터마크 없는 다운로드를 위한 프리미엄 플랜도 있습니다.',
                    },
                ],
            },
            faq: [
                {
                    question: 'AI 비디오→비디오(Vid2Vid)란 무엇인가요?',
                    answer: '기존 비디오를 입력으로, 프롬프트로 지정한 새 스타일로 재도색하면서 원본 모션/구조를 유지하는 생성형 AI입니다.',
                },
                {
                    question: '비디오를 애니메이션 스타일로 바꿀 수 있나요?',
                    answer: '네. “일본 애니 스타일, 지브리 느낌” 같은 프롬프트로 변환할 수 있습니다.',
                },
                {
                    question: '원본 비디오 길이는 얼마나 지원하나요?',
                    answer: '현재는 5~10초 같은 짧은 클립을 권장합니다. 긴 영상은 분할해 주세요.',
                },
                {
                    question: '일반 비디오 편집기와 무엇이 다른가요?',
                    answer: '편집기는 컷/트림, Vid2Vid는 새 픽셀 생성으로 질감과 스타일을 변경합니다.',
                },
                {
                    question: '비용이 드나요?',
                    answer: '매일 무료 크레딧 제공. 프리미엄 플랜으로 더 빠르게/무워터마크로 이용할 수 있습니다.',
                },
            ],
        },
        removeWatermark: {
            title: '무료 온라인 AI 비디오 워터마크 제거 - 로고·텍스트·자막 삭제 | 微鲤AI',
            description: 'WeryAI의 무료 AI 워터마크 제거기로 비디오의 워터마크, 로고, 자막, 날짜 스탬프를 쉽게 지우세요. MP4/MOV 및 영상 링크를 지원합니다. 블러 없이 깔끔하게 AI로 복원합니다.',
            keywords: '비디오 워터마크 제거, AI 비디오 지우개, 비디오 로고 제거, 자막 삭제, TikTok 워터마크 제거, 무료 온라인 워터마크 제거',
            og_title: '무료 온라인 AI 비디오 워터마크 제거 - 로고·텍스트·자막 삭제 | 微鲤AI',
            og_description: 'WeryAI의 무료 AI 워터마크 제거기로 비디오의 워터마크, 로고, 자막, 날짜 스탬프를 쉽게 지우세요. MP4/MOV 및 영상 링크를 지원합니다. 블러 없이 깔끔하게 AI로 복원합니다.',
            twitter_title: '무료 온라인 AI 비디오 워터마크 제거 - 로고·텍스트·자막 삭제 | 微鲤AI',
            twitter_description: 'WeryAI의 무료 AI 워터마크 제거기로 비디오의 워터마크, 로고, 자막, 날짜 스탬프를 쉽게 지우세요. MP4/MOV 및 영상 링크를 지원합니다. 블러 없이 깔끔하게 AI로 복원합니다.',
            page: {
                title1: '무료 온라인 AI 비디오 워터마크 제거',
                title2: '비디오에서 워터마크, 로고, 텍스트 오버레이, 자막을 즉시 지우세요. 링크를 붙여넣거나 파일을 업로드한 뒤 영역을 선택하면, AI가 블러 없이 배경을 픽셀 단위로 복원합니다.',
                click_erase: '1.원클릭 지우기: AI가 흔한 워터마크를 자동 감지해 제거합니다.',
                percision_erase: '2.정밀 지우기: 브러시 도구로 움직이는 자막/타임스탬프 같은 복잡한 요소를 수동 제거합니다.',
                video_link_title: '링크로 사용',
                direct_link_desc: '1.직접 링크 제거: 소셜 플랫폼 링크를 붙여넣어 다운로드 없이 워터마크를 제거합니다.',
                lossless_qua_title: '2.무손실 품질: 기존 블러 도구와 달리 주변 픽셀을 분석해 배경을 재구성합니다.',
                faq: [
                    {
                        question: '무료로 온라인에서 비디오 워터마크를 제거하는 방법은?',
                        answer: 'WeryAI에 비디오를 업로드하거나 링크를 붙여넣으세요. 워터마크를 선택 박스로 덮고 “Generate”를 누르면 무료로 체험할 수 있습니다.',
                    },
                    {
                        question: '움직이는 자막이나 텍스트도 제거할 수 있나요?',
                        answer: '네. “Precision Erase” 모드로 텍스트 영역을 선택하세요. AI가 프레임 간 워터마크를 추적해 영상 전체에서 깔끔하게 제거합니다.',
                    },
                    {
                        question: 'TikTok이나 YouTube 영상에도 작동하나요?',
                        answer: '물론입니다. TikTok 점프 워터마크 같은 플랫폼 로고나 채널 워터마크를 제거해 개인 용도로 깔끔한 영상을 만들 수 있습니다.',
                    },
                    {
                        question: '제거된 영역이 흐릿하게 보이나요?',
                        answer: '아니요. WeryAI는 고급 “Video In‑painting”으로 주변 영상에서 자연스러운 텍스처를 생성해 채워 넣어, 보기 싫은 블러를 피합니다.',
                    },
                    {
                        question: '어떤 비디오 포맷을 지원하나요?',
                        answer: 'MP4, MOV, AVI, WebM 등 주요 포맷을 모두 지원합니다.',
                    },
                ],
            },
            faq: [
                {
                    question: '무료로 온라인에서 비디오 워터마크를 제거하는 방법은?',
                    answer: '업로드 또는 링크 붙여넣기 → 영역 선택 → “Generate”로 무료 체험 가능합니다.',
                },
                {
                    question: '움직이는 자막이나 텍스트도 제거할 수 있나요?',
                    answer: '네. “Precision Erase”로 선택하면 AI가 프레임 간 추적해 제거합니다.',
                },
                {
                    question: '제거된 영역이 흐릿하게 보이나요?',
                    answer: '아니요. Video In‑painting으로 자연스럽게 복원해 블러가 남지 않습니다.',
                },
            ],
        },
        videoFaceSwap: {
            title: '무료 AI 비디오 페이스 스왑 온라인 - 리얼 딥페이크 제작 | 微鲤AI',
            description: 'WeryAI의 AI 페이스 스와퍼로 비디오 얼굴을 즉시 교체하세요. 재미있는 영화 클립, 밈, 현실적인 딥페이크를 무료로 만들 수 있습니다. 워터마크 없는 옵션 제공. 100% 프라이빗 & 안전.',
            keywords: '비디오 페이스 스왑, AI 페이스 스와퍼, 무료 딥페이크 제작, 비디오 얼굴 교체, 영화 얼굴 스왑, reface 온라인, AI 밈 메이커',
            og_title: '무료 AI 비디오 페이스 스왑 온라인 - 리얼 딥페이크 제작 | 微鲤AI',
            og_description: 'WeryAI의 AI 페이스 스와퍼로 비디오 얼굴을 즉시 교체하세요. 재미있는 영화 클립, 밈, 현실적인 딥페이크를 무료로 만들 수 있습니다. 워터마크 없는 옵션 제공. 100% 프라이빗 & 안전.',
            twitter_title: '무료 AI 비디오 페이스 스왑 온라인 - 리얼 딥페이크 제작 | 微鲤AI',
            twitter_description: 'WeryAI의 AI 페이스 스와퍼로 비디오 얼굴을 즉시 교체하세요. 재미있는 영화 클립, 밈, 현실적인 딥페이크를 무료로 만들 수 있습니다. 워터마크 없는 옵션 제공. 100% 프라이빗 & 안전.',
            page: {
                title1: '무료 AI 비디오 페이스 스왑',
                title2: '어떤 영화든 주인공이 되어보세요! 비디오 클립과 타깃 얼굴 사진을 업로드하면, AI가 자연스럽게 얼굴을 교체합니다. 유쾌한 밈, 맞춤 인사 영상, 고품질 VFX 제작에 적합합니다.',
                feature_title1: '초현실 딥페이크',
                feature_desc1: 'AI가 얼굴 기하와 조명을 분석해 자연스럽게 합성하며, 표정과 머리 움직임을 그대로 유지합니다.',
                feature_title2: '프라이버시 우선',
                feature_desc2: '개인정보를 최우선으로 합니다. 업로드한 비디오/이미지는 안전하게 처리되며 생성 후 곧바로 삭제됩니다.',
                feature_title3: '기술 없이도 OK',
                feature_desc3: 'After Effects 같은 복잡한 소프트웨어가 필요 없습니다. “Create”만 누르면 몇 초 만에 결과를 얻습니다.',
                faq: [
                    {
                        question: '微鲤AI 비디오 페이스 스왑은 무료인가요?',
                        answer: '네. 온라인에서 비디오 페이스 스왑을 체험할 수 있도록 무료 크레딧을 제공합니다. 시작에 카드가 필요 없습니다.',
                    },
                    {
                        question: '사진을 업로드해도 안전한가요?',
                        answer: '물론입니다. 엄격한 데이터 보호 정책을 적용하며, 소스 영상과 타깃 얼굴 이미지는 생성 과정에만 사용되고 영구 저장되지 않습니다.',
                    },
                    {
                        question: 'GIF도 얼굴을 바꿀 수 있나요?',
                        answer: '네! WeryAI는 비디오(MP4/MOV)와 GIF 형식을 모두 지원합니다. 개인화된 리액션 GIF를 쉽게 만들 수 있어요.',
                    },
                    {
                        question: '최고의 결과를 얻으려면 어떻게 해야 하나요?',
                        answer: '선명하고 정면이며 조명이 좋은 타깃 얼굴 사진을 사용하세요. 머리카락이나 안경으로 얼굴이 가려진 사진은 피하는 것이 좋습니다.',
                    },
                    {
                        question: '상업 프로젝트에 사용해도 되나요?',
                        answer: '가능하지만, 원본 영상과 교체 대상 인물의 초상/권리에 대한 사용 권한을 보유했는지 확인해야 합니다.',
                    },
                ],
            },
            faq: [
                {
                    question: '微鲤AI 비디오 페이스 스왑은 무료인가요?',
                    answer: '네. 무료 크레딧으로 체험할 수 있으며 카드가 필요 없습니다.',
                },
                {
                    question: '사진을 업로드해도 안전한가요?',
                    answer: '네. 자료는 생성 과정에만 사용되며 엄격히 보호됩니다.',
                },
                {
                    question: '최고의 결과를 얻으려면 어떻게 해야 하나요?',
                    answer: '선명하고 정면이며 밝은 타깃 얼굴 사진을 사용하고, 얼굴 가림이 없는 사진을 선택하세요.',
                },
            ],
        },
        videoLipSync: {
            title: '무료 AI 비디오 립싱크 생성기 - 오디오/텍스트를 영상에 동기화 | 微鲤AI',
            description: 'WeryAI의 AI 립싱크 도구로 어떤 오디오나 텍스트에도 입 모양을 정확하게 맞추세요. Kling AI 기반으로 영상 번역, 더빙, 말하는 아바타 제작에 이상적입니다. 무료·온라인.',
            keywords: '비디오 립싱크, 립싱크, AI 립싱크, 비디오 더빙, 음성 동기화, 말하는 비디오, 립싱크 도구',
            og_title: '무료 AI 비디오 립싱크 생성기 - 오디오/텍스트를 영상에 동기화 | 微鲤AI',
            og_description: 'WeryAI의 AI 립싱크 도구로 어떤 오디오나 텍스트에도 입 모양을 정확하게 맞추세요. Kling AI 기반으로 영상 번역, 더빙, 말하는 아바타 제작에 이상적입니다. 무료·온라인.',
            twitter_title: '무료 AI 비디오 립싱크 생성기 - 오디오/텍스트를 영상에 동기화 | 微鲤AI',
            twitter_description: 'WeryAI의 AI 립싱크 도구로 어떤 오디오나 텍스트에도 입 모양을 정확하게 맞추세요. Kling AI 기반으로 영상 번역, 더빙, 말하는 아바타 제작에 이상적입니다. 무료·온라인.',
            page: {
                title1: '무료 AI 비디오 립싱크 & 더빙 도구',
                title2: '어색한 더빙 영상과 작별하세요. 영상과 오디오 파일(또는 텍스트)을 업로드하면, AI가 화자의 입 모양을 소리에 맞게 재생성합니다. Kling AI 기반으로 다국어 더빙과 현실적인 얼굴 근육 조정까지 지원합니다.',
                dual_input_modes: '듀얼 입력 모드',
                audio_sync: '오디오 동기화',
                text_sync: '텍스트 음성 변환',
                text_sync_tip: '원하는 텍스트를 입력하고 프리셋 AI 음성을 선택하면, 캐릭터가 즉시 말합니다.',
                audio_sync_tip: '직접 녹음한 보이스오버나 노래를 업로드해 동기화하세요.',
                feature_title1: '다국어 더빙',
                feature_desc1: '도달 범위를 확장하세요. 영상을 스페인어·프랑스어·일본어 등으로 번역하고 립싱크까지 맞춰 화자가 원어민처럼 자연스럽게 보이게 할 수 있습니다.',
                feature_title2: 'Kling AI 정밀도',
                feature_desc2: '기본적인 Wav2Lip 도구와 달리, Kling 모델을 사용해 치아·혀·턱 움직임이 해부학적으로 자연스럽도록 만듭니다.',
                faq: [
                    {
                        question: '영상에서 오디오에 맞춰 립싱크하려면 어떻게 하나요?',
                        answer: 'WeryAI에 영상 클립을 업로드한 뒤, 오디오 파일(MP3/WAV)을 업로드하거나 텍스트를 입력해 AI 음성을 생성하세요. "Create"를 클릭하면 AI가 입 모양을 소리에 맞게 조정합니다.',
                    },
                    {
                        question: '영상 번역/더빙에 사용할 수 있나요?',
                        answer: '네! 더빙에 최적입니다. 번역된 오디오 트랙을 업로드하면 AI가 립싱크를 맞춰 더빙 버전이 자연스럽게 보이도록 합니다.',
                    },
                    {
                        question: '정지 이미지(말하는 얼굴)에도 되나요?',
                        answer: '네. 정면 인물 사진을 “영상” 소스로 업로드하면, 도구가 말하는 얼굴 영상(Live Portrait 효과)으로 애니메이션화합니다.',
                    },
                    {
                        question: '어떤 언어를 지원하나요?',
                        answer: '오디오 파형을 분석하기 때문에 기본적으로 어떤 언어든 작동합니다(영어, 스페인어, 중국어, 힌디어 등). 텍스트-음성 입력은 50개 이상의 언어를 지원합니다.',
                    },
                    {
                        question: '립싱크는 무료인가요?',
                        answer: 'WeryAI는 립싱크 기능을 테스트할 수 있는 일일 무료 크레딧을 제공합니다. 장편 영상이나 상업적 사용을 위한 프리미엄 플랜도 있습니다.',
                    },
                ],
            },
            faq: [
                {
                    question: '영상에서 오디오에 맞춰 립싱크하려면 어떻게 하나요?',
                    answer: 'WeryAI에 영상 클립을 업로드한 뒤, 오디오 파일(MP3/WAV)을 업로드하거나 텍스트를 입력해 AI 음성을 생성하세요. "Create"를 클릭하면 AI가 입 모양을 소리에 맞게 조정합니다.',
                },
                {
                    question: '영상 번역/더빙에 사용할 수 있나요?',
                    answer: '네! 더빙에 최적입니다. 번역된 오디오 트랙을 업로드하면 AI가 립싱크를 맞춰 더빙 버전이 자연스럽게 보이도록 합니다.',
                },
                {
                    question: '정지 이미지(말하는 얼굴)에도 되나요?',
                    answer: '네. 정면 인물 사진을 “영상” 소스로 업로드하면, 도구가 말하는 얼굴 영상(Live Portrait 효과)으로 애니메이션화합니다.',
                },
            ],
        },
        translateVideoSubtitle: {
            title: '무료 AI 비디오 자막 번역기 - 자동 자막 생성 및 온라인 번역 | 微鲤AI',
            description: 'WeryAI의 AI 자막 번역기로 영상 자막을 자동 생성하고 번역하세요. 영어·스페인어·한국어 등 90개 이상의 언어를 지원하며, 자막이 영상에 소각된(하드서브) 결과물을 즉시 다운로드할 수 있습니다.',
            keywords: 'AI 자막 번역, 비디오 자막 번역기, 다국어 자막, 비디오 번역, 자막 변환기, AI 비디오 번역',
            og_title: '무료 AI 비디오 자막 번역기 - 자동 자막 생성 및 온라인 번역 | 微鲤AI',
            og_description: 'WeryAI의 AI 자막 번역기로 영상 자막을 자동 생성하고 번역하세요. 영어·스페인어·한국어 등 90개 이상의 언어를 지원하며, 자막이 영상에 소각된(하드서브) 결과물을 즉시 다운로드할 수 있습니다.',
            twitter_title: '무료 AI 비디오 자막 번역기 - 자동 자막 생성 및 온라인 번역 | 微鲤AI',
            twitter_description: 'WeryAI의 AI 자막 번역기로 영상 자막을 자동 생성하고 번역하세요. 영어·스페인어·한국어 등 90개 이상의 언어를 지원하며, 자막이 영상에 소각된(하드서브) 결과물을 즉시 다운로드할 수 있습니다.',
            page: {
                title1: '무료 AI 비디오 자막 번역기',
                title2: '언어 장벽을 즉시 허물어보세요. 영상을 업로드하고 목표 언어를 선택하면, AI가 음성을 자동 인식·전사한 뒤 정확한 번역 자막을 영상 파일에 바로 소각(하드서브)합니다.',
                feature_title1: '90+개 언어 지원',
                feature_desc1: '영어를 스페인어, 프랑스어, 독일어, 일본어, 중국어 등으로 번역해 한 번의 클릭으로 전 세계 аудит에 도달하세요.',
                feature_title2: '자동 동기화 & 소각',
                feature_desc2: '타임스탬프를 수동으로 조정할 필요가 없습니다. AI가 자막을 오디오에 정확히 동기화하고 영상에 소각(Hardsubs)하여 플랫폼 호환성을 높입니다.',
                feature_title3: '문맥 기반 정확도',
                feature_desc3: '고급 LLM 기반으로 문맥과 슬랭을 이해해 자연스럽고 정확한 번역을 제공합니다. 단순한 직역이 아닙니다.',
                faq: [
                    {
                        question: '영상 자막을 자동으로 번역하려면 어떻게 하나요?',
                        answer: 'WeryAI에 영상을 업로드하고 “Target Language”(예: 영어→스페인어)를 선택한 뒤 “Create”를 클릭하세요. AI가 자막을 자동 생성하고 번역합니다.',
                    },
                    {
                        question: '어떤 언어를 지원하나요?',
                        answer: '영어, 스페인어, 프랑스어, 독일어, 포르투갈어, 힌디어, 일본어, 중국어 등 90개 이상의 언어를 지원합니다.',
                    },
                    {
                        question: '자막 번역기는 무료인가요?',
                        answer: '네. WeryAI는 AI 비디오 자막 번역기를 무료로 제공하며, 비싼 전사 서비스 없이도 영상을 처리할 수 있습니다.',
                    },
                    {
                        question: 'SRT 파일을 다운로드해야 하나요?',
                        answer: '아니요. WeryAI는 자막이 영상에 소각된(하드코딩) 결과물을 생성합니다. 그래서 TikTok, Instagram, YouTube에서도 자막이 제대로 표시됩니다.',
                    },
                    {
                        question: 'AI 번역 정확도는 어느 정도인가요?',
                        answer: '최첨단 음성 인식 모델을 사용해 높은 정확도를 제공합니다. 오디오가 선명하면 정확도가 95%를 넘을 수 있습니다.',
                    },
                ],
            },
            faq: [
                {
                    question: '영상 자막을 자동으로 번역하려면 어떻게 하나요?',
                    answer: 'WeryAI에 영상을 업로드하고 Target Language를 선택한 뒤 Create를 클릭하세요. AI가 자막을 자동 생성하고 번역합니다.',
                },
                {
                    question: '어떤 언어를 지원하나요?',
                    answer: '영어, 스페인어, 프랑스어, 독일어, 포르투갈어, 힌디어, 일본어, 중국어 등 90개 이상의 언어를 지원합니다.',
                },
                {
                    question: 'SRT 파일을 다운로드해야 하나요?',
                    answer: '아니요. 자막이 영상에 소각된(하드서브) 형태로 생성되어 모든 소셜 플랫폼에서 잘 표시됩니다.',
                },
            ],
        },
        videoToAnime: {
            title: '무료 AI 비디오→애니 변환기 - 실사 영상을 만화/픽사 스타일로 | 微鲤AI',
            description: '微鲤AI 비디오→애니 변환기로 실사 영상을 일본 애니, 3D 픽사 스타일, 카툰으로 즉시 변환하세요. 프레임 단위 안정화로 더 매끄러운 애니메이션. 무료·온라인.',
            keywords: '비디오를 애니메이션으로, AI 애니 필터, 비디오를 카툰으로, 픽사 비디오 필터, 실사→애니, domoai 대안, 애니 영상 생성',
            og_title: '무료 AI 비디오→애니 변환기 - 실사 영상을 만화/픽사 스타일로 | 微鲤AI',
            og_description: '微鲤AI 비디오→애니 변환기로 실사 영상을 일본 애니, 3D 픽사 스타일, 카툰으로 즉시 변환하세요. 프레임 단위 안정화로 더 매끄러운 애니메이션. 무료·온라인.',
            twitter_title: '무료 AI 비디오→애니 변환기 - 실사 영상을 만화/픽사 스타일로 | 微鲤AI',
            twitter_description: '微鲤AI 비디오→애니 변환기로 실사 영상을 일본 애니, 3D 픽사 스타일, 카툰으로 즉시 변환하세요. 프레임 단위 안정화로 더 매끄러운 애니메이션. 무료·온라인.',
            page: {
                title1: '무료 AI 비디오→애니 변환기',
                title2: '한 번의 클릭으로 애니 주인공이 되어보세요. 실사 영상을 업로드하고 스타일(픽사 3D, 클래식 2D, 손그림)을 선택하면, AI가 프레임마다 스타일을 바꾸면서 원래 동작은 부드럽게 유지합니다.',
                feature_desc1: '<div><p>Pixar & 3D: 가족 영상에 딱 맞는 디즈니풍 귀여운 3D 애니 클립을 만들 수 있어요.</p><p>Classic Anime: 지브리/신카이 스타일 같은 일본 애니 감성을 구현합니다.</p><p>Sketch & Ink: 영상을 손그림 연필 스케치 애니로 바꿔줍니다.</p></div>',
                feature_title2: '프레임 단위 안정화',
                feature_desc2: 'AI 영상의 깜빡임/지터가 싫으신가요? WeryAI는 고급 시간적 일관성 알고리즘으로 흔한 “흔들림”을 줄여 더 매끄럽게 재생되게 합니다.',
                feature_title3: '바이럴 콘텐츠 제작',
                feature_desc3: 'TikTok과 Reels에 최적화. “실사 vs 애니” 비교 영상 같은 트렌드 콘텐츠를 빠르게 만들 수 있어요.',
                faq: [
                    {
                        question: '무료로 비디오를 애니로 바꾸는 방법은?',
                        answer: '微鲤AI 비디오→애니 도구에 영상을 업로드하고(예: “2D Style”, “Pixar Style”) 스타일을 선택한 뒤 Create를 누르세요. 매일 제공되는 무료 크레딧으로 체험 가능합니다.',
                    },
                    {
                        question: '픽사/디즈니 스타일로 변환할 수 있나요?',
                        answer: '네! “3D Cartoon” 또는 “Pixar Style” 프리셋으로 실사 인물을 귀여운 3D 캐릭터처럼 바꿔줍니다.',
                    },
                    {
                        question: '영상 길이는 얼마나 되나요?',
                        answer: '현재 최대 30초(도구 옵션의 “Maximum video duration: 30s”)까지 지원합니다. Shorts/Reels/TikTok에 적합합니다.',
                    },
                    {
                        question: '애니 캐릭터가 제 움직임을 따라하나요?',
                        answer: '물론입니다. AI가 골격 움직임과 표정을 분석해 동작을 최대한 잘 모사합니다.',
                    },
                    {
                        question: '최고의 비디오→애니 변환기는 무엇인가요?',
                        answer: 'WeryAI는 2D/3D 등 다양한 스타일을 제공하고, 프레임 안정성을 중점으로 최적화해 노이즈/깜빡임을 줄이는 점에서 많이 선택됩니다.',
                    },
                ],
            },
            faq: [
                {
                    question: '무료로 비디오를 애니로 바꾸는 방법은?',
                    answer: 'WeryAI에 영상을 업로드하고 2D Style 또는 Pixar Style 같은 프리셋을 선택한 뒤 Create를 클릭하면 됩니다.',
                },
                {
                    question: '픽사/디즈니 스타일로 변환할 수 있나요?',
                    answer: '네. 3D Cartoon/Pixar Style 프리셋으로 실사 인물을 귀여운 3D 캐릭터로 변환합니다.',
                },
                {
                    question: '애니 캐릭터가 제 움직임을 따라하나요?',
                    answer: '네. AI가 골격 움직임과 표정을 분석해 동작을 모사합니다.',
                },
            ],
            app_name: '微鲤AI 비디오→애니 변환기',
            app_desc: '실사 영상을 애니/카툰/픽사 스타일로 바꾸는 무료 AI 도구. 프레임 단위 렌더링으로 안정적인 애니메이션을 제공합니다.',
            featureList: '실사→애니, 픽사 필터, 프레임 안정화, 2D/3D 스타일',
        },
        videoUpscaler: {
            title: '무료 AI 비디오 업스케일러 & 향상 - 4K까지 온라인 업스케일 | 微鲤AI',
            description: '微鲤AI 무료 AI 비디오 업스케일러로 저해상도 영상을 1080p/2K/4K로 즉시 업스케일하세요. 픽셀 깨짐을 줄이고 노이즈를 제거해 영상 품질을 온라인에서 개선—설치 없이.',
            keywords: '비디오 업스케일러, AI 비디오 향상, 비디오를 4K로 업스케일, 흐린 영상 복원, 비디오 노이즈 제거, 영상 화질 개선, 무료 온라인 업스케일',
            og_title: '무료 AI 비디오 업스케일러 & 향상 - 4K까지 온라인 업스케일 | 微鲤AI',
            og_description: '微鲤AI 무료 AI 비디오 업스케일러로 저해상도 영상을 1080p/2K/4K로 즉시 업스케일하세요. 픽셀 깨짐을 줄이고 노이즈를 제거해 영상 품질을 온라인에서 개선—설치 없이.',
            twitter_title: '무료 AI 비디오 업스케일러 & 향상 - 4K까지 온라인 업스케일 | 微鲤AI',
            twitter_description: '微鲤AI 무료 AI 비디오 업스케일러로 저해상도 영상을 1080p/2K/4K로 즉시 업스케일하세요. 픽셀 깨짐을 줄이고 노이즈를 제거해 영상 품질을 온라인에서 개선—설치 없이.',
            page: {
                title1: '무료 AI 비디오 업스케일러 & 향상',
                title2: '흐리고 픽셀 깨진 영상에 만족하지 마세요. 저해상도(360p, 480p, 720p) 영상을 업로드하면 AI가 자동으로 멋진 4K로 업스케일합니다. 크기만 키우는 게 아니라 디테일 복원, 노이즈 제거, 색 보정까지 합니다.',
                feature_title1: '4K로 업스케일',
                feature_desc1: '오래된 영상에 새 생명을. SD 콘텐츠를 HD/4K로 원클릭 변환해 큰 화면에서도 선명하게.',
                feature_title2: '흐림 & 거친 노이즈 수정',
                feature_desc2: '어두운 곳에서 촬영했나요? AI 디노이징이 그레인과 압축 아티팩트를 제거해 깨끗하고 프로처럼 보이게 합니다.',
                feature_title3: '옛 영상 복원',
                feature_desc3: '가족 아카이브에 딱. 오래된 홈비디오나 빈티지 클립의 색을 되살리고 디테일을 선명하게.',
                faq: [
                    {
                        question: '무료로 온라인에서 비디오를 4K로 업스케일할 수 있나요?',
                        answer: '네. WeryAI는 최대 4K 출력 해상도를 선택할 수 있습니다(도구 옵션 참고). 매일 제공되는 무료 크레딧으로 체험할 수 있어요.',
                    },
                    {
                        question: '흐린 비디오를 어떻게 고치나요?',
                        answer: '흐린 영상을 AI 비디오 업스케일러에 업로드하기만 하면 됩니다. AI가 손실된 픽셀을 분석하고 디테일을 재구성해 선명하게 만듭니다.',
                    },
                    {
                        question: '오래된 휴대폰 영상에도 되나요?',
                        answer: '물론입니다. 360p/480p 같은 저화질 영상에 특히 효과가 좋고, 1080p 이상으로 선명해집니다.',
                    },
                    {
                        question: '업스케일 과정은 얼마나 걸리나요?',
                        answer: '업스케일은 연산량이 크지만, WeryAI는 최적화된 클라우드 GPU로 빠르게 처리합니다. 짧은 클립은 보통 몇 분이면 완료됩니다.',
                    },
                    {
                        question: 'Topaz Video AI보다 더 좋나요?',
                        answer: 'WeryAI는 비슷한 수준의 AI 품질을 제공하면서도 브라우저에서 바로 실행됩니다. 비싼 하드웨어나 무거운 설치 없이 전문가급 결과를 얻을 수 있습니다.',
                    },
                ],
            },
            faq: [
                {
                    question: '온라인에서 비디오를 4K로 업스케일할 수 있나요?',
                    answer: '네. 최대 4K 출력 해상도를 선택할 수 있고, 무료 일일 크레딧으로 체험 가능합니다.',
                },
                {
                    question: '흐린 비디오를 어떻게 고치나요?',
                    answer: '흐린 영상을 업로드하면 AI가 손실 픽셀을 분석해 디테일을 재구성합니다.',
                },
                {
                    question: 'Topaz Video AI보다 더 좋나요?',
                    answer: 'WeryAI는 비슷한 AI 품질을 제공하면서도 브라우저에서 바로 동작해 설치나 고가 장비가 필요 없습니다.',
                },
            ],
            app_name: '微鲤AI Video Upscaler',
            app_desc: '무료 AI 비디오 업스케일러로 최대 4K까지 영상 화질을 향상합니다. 흐림/노이즈를 줄이고 옛 영상을 온라인에서 복원하세요.',
            featureList: '4K 업스케일링, AI 디노이징, 영상 샤프닝, 색 보정',
        },
        removeVideoSubtitles: {
            title: '자막 제거 - AI 비디오 자막 제거 도구 | 微鲤AI',
            description: 'AI 기술로 비디오에서 임베디드 자막을 제거합니다. 비디오 품질을 유지하면서 하드코딩된 캡션과 텍스트를 지능적으로 지웁니다. 빠르고 사용하기 쉽습니다.',
            keywords: '비디오 자막 제거, 자막 지우기, 자막 제거, 자막 삭제, 비디오 자막 제거, 하드코딩 자막 제거',
            og_title: '자막 제거 - AI 비디오 자막 제거 도구 | 微鲤AI',
            og_description: 'AI 기술로 비디오에서 임베디드 자막을 제거합니다. 비디오 품질을 유지하면서 하드코딩된 캡션과 텍스트를 지능적으로 지웁니다. 빠르고 사용하기 쉽습니다.',
            twitter_title: '자막 제거 - AI 비디오 자막 제거 도구 | 微鲤AI',
            twitter_description: 'AI 기술로 비디오에서 임베디드 자막을 제거합니다. 비디오 품질을 유지하면서 하드코딩된 캡션과 텍스트를 지능적으로 지웁니다. 빠르고 사용하기 쉽습니다.',
            page: {
                title1: '무료 AI 비디오 자막 제거',
                title2: '화면에 박힌(번인) 자막 때문에 고민인가요? WeryAI의 지능형 알고리즘이 하드코딩 자막, 가사, 화면 텍스트를 자동 감지해 지웁니다. 링크를 붙여넣거나 파일을 업로드하면, 글자 없는 깨끗한 영상을 즉시 복원할 수 있어요.',
                feature_title1: '지능형 텍스트 감지',
                feature_desc1: '수동 마스킹이 필요 없습니다. AI가 화면 하단(또는 어디든)의 텍스트 영역을 자동으로 찾아 배경과 분리합니다.',
                feature_title2: '자연스러운 인페인팅',
                feature_desc2: '흐릿한 박스는 이제 끝. 주변 픽셀을 분석해 삭제된 영역을 자연스럽게 복원하여 질감(잔디, 모래, 군중 등)을 재구성합니다.',
                feature_title3: '링크 & 파일 지원',
                feature_desc3: 'TikTok, YouTube, Instagram 링크에서 바로 캡션을 제거하거나 MP4/MOV 파일을 업로드하세요. 콘텐츠 재활용에 딱입니다.',
                faq: [
                    {
                        question: '하드코딩(번인) 자막도 제거할 수 있나요?',
                        answer: '네. 이 도구는 영상 이미지에 포함되어 끌 수 없는 하드코딩 자막을 위해 설계되었습니다. 화면에서 시각적으로 지워줍니다.',
                    },
                    {
                        question: 'TikTok/YouTube 영상에서 자막을 어떻게 제거하나요?',
                        answer: '영상 링크를 복사해 WeryAI의 “Video Link” 탭에 붙여넣고 “Generate”를 클릭하세요. AI가 자막을 제거한 뒤 글자 없는 영상을 다운로드할 수 있게 해줍니다.',
                    },
                    {
                        question: '텍스트 뒤 배경까지 같이 사라지나요?',
                        answer: '아니요. WeryAI는 AI 인페인팅 기술로 텍스트를 지운 뒤 배경을 지능적으로 다시 채워 원본처럼 자연스럽게 보이게 합니다.',
                    },
                    {
                        question: '워터마크 제거기와 차이는 무엇인가요?',
                        answer: '원리는 비슷하지만, 자막 제거기는 하단 자막 스트립/가사/캡션 같은 “텍스트”에 최적화되어 있고, 워터마크 제거기는 로고/스탬프에 초점을 맞춥니다.',
                    },
                    {
                        question: '무료로 사용할 수 있나요?',
                        answer: '네. 매일 제공되는 무료 크레딧으로 기본 자막 제거 기능을 무료로 사용할 수 있습니다.',
                    },
                ],
            },
            faq: [
                {
                    question: '하드코딩 자막을 제거할 수 있나요?',
                    answer: '네. 영상 이미지에 포함된 하드코딩 자막을 화면에서 시각적으로 지웁니다.',
                },
                {
                    question: 'TikTok 링크 영상의 캡션을 어떻게 지우나요?',
                    answer: '링크를 복사해 “Video Link” 탭에 붙여넣고 “Generate”를 클릭하면 AI가 자동으로 제거합니다.',
                },
                {
                    question: '텍스트 뒤 배경이 망가지지 않나요?',
                    answer: '아니요. AI 인페인팅으로 배경을 자연스럽게 복원합니다.',
                },
            ],
            app_name: '微鲤AI 비디오 자막 제거기',
            app_desc: '영상의 하드코딩 자막/캡션/텍스트를 무료로 지우는 AI 도구. 인페인팅으로 배경을 복원해 흐릿한 블록 없이 깔끔하게 처리합니다.',
            featureList: '하드코딩 자막 제거, AI 배경 복원, 비디오 링크 지원, 가사/텍스트 삭제',
        },
        videoBackgroundRemover: {
            title: '비디오 배경 제거 도구 - AI 비디오 배경 제거 | 微鲤AI',
            description: 'AI로 비디오에서 배경을 자동으로 제거합니다. 그린 스크린 효과를 생성하고, 피사체를 분리하며, 비디오 배경을 쉽게 교체합니다. 콘텐츠 크리에이터와 비디오 편집자에게 완벽합니다.',
            keywords: '비디오 배경 제거, 비디오 배경 삭제, 그린 스크린, AI 배경 제거, 비디오 배경 지우개, 비디오 피사체 분리',
            og_title: '비디오 배경 제거 도구 - AI 비디오 배경 제거 | 微鲤AI',
            og_description: 'AI로 비디오에서 배경을 자동으로 제거합니다. 그린 스크린 효과를 생성하고, 피사체를 분리하며, 비디오 배경을 쉽게 교체합니다. 콘텐츠 크리에이터와 비디오 편집자에게 완벽합니다.',
            twitter_title: '비디오 배경 제거 도구 - AI 비디오 배경 제거 | 微鲤AI',
            twitter_description: 'AI로 비디오에서 배경을 자동으로 제거합니다. 그린 스크린 효과를 생성하고, 피사체를 분리하며, 비디오 배경을 쉽게 교체합니다. 콘텐츠 크리에이터와 비디오 편집자에게 완벽합니다.',
            page: {
                title1: '무료 AI 비디오 배경 제거',
                title2: '그린 스크린이 없어도 괜찮아요. 영상을 업로드하면 AI가 피사체를 자동 감지해 머리카락 수준으로 정교하게 분리하고, 투명 배경으로 다운로드하거나 배경색을 즉시 변경할 수 있습니다.',
                feature_title1: '그린 스크린 불필요',
                feature_desc1: '비싼 스튜디오 세팅 없이도 OK. AI가 복잡한 배경에서 사람/반려동물/물체를 자동으로 분리합니다(오토 로토스코핑).',
                feature_title2: '단색 배경 교체',
                feature_desc2: '이커머스에 최적. 제품 영상 배경을 순백/검정/원하는 색으로 한 번에 바꿔 전환율을 높여보세요.',
                feature_title3: '투명으로 내보내기',
                feature_desc3: '알파 채널(WebM/MOV)로 다운로드하여 Premiere Pro, DaVinci Resolve, CapCut 등에서 다른 영상 위에 쉽게 합성할 수 있습니다.',
                faq: [
                    {
                        question: '그린 스크린 없이도 비디오 배경을 제거할 수 있나요?',
                        answer: '네! WeryAI는 고급 머신러닝으로 피사체와 배경을 구분하므로, 침실/거리/사무실 등 어디서 촬영했든 배경 제거가 가능합니다.',
                    },
                    {
                        question: '투명 배경 비디오는 어떻게 저장하나요?',
                        answer: '배경 제거 후 출력 형식으로 WebM(Transparent) 또는 MOV를 선택하세요. 일반 MP4는 투명을 지원하지 않아 검은 배경으로 보입니다.',
                    },
                    {
                        question: '배경을 흰색으로 바꿀 수 있나요?',
                        answer: '가능합니다. 도구 설정의 “Background Color”에서 흰색/검정 또는 원하는 HEX 색상을 선택하세요. Amazon/Shopify 제품 영상에 특히 좋아요.',
                    },
                    {
                        question: '머리카락 처리도 잘 되나요?',
                        answer: '잘 됩니다. 잔머리, 털, 반투명 물체(안경 등)처럼 복잡한 경계를 자연스럽게 보존하도록 학습되어 있습니다.',
                    },
                    {
                        question: '무료인가요?',
                        answer: '네. 매일 제공되는 무료 크레딧으로 영상을 무료로 처리할 수 있습니다.',
                    },
                ],
            },
            faq: [
                {
                    question: '그린 스크린 없이도 비디오 배경을 제거할 수 있나요?',
                    answer: '네! WeryAI는 그린 스크린 없이도 배경을 제거합니다.',
                },
                {
                    question: '투명 배경 비디오는 어떻게 저장하나요?',
                    answer: '출력 형식으로 WebM(Transparent) 또는 MOV를 선택하세요. MP4는 투명을 지원하지 않습니다.',
                },
                {
                    question: '배경을 흰색으로 바꿀 수 있나요?',
                    answer: '네. Background Color에서 흰색을 선택하면 되며, 이커머스 제품 영상에 적합합니다.',
                },
            ],
            app_name: '微鲤AI 비디오 배경 제거기',
            app_desc: '그린 스크린 없이 비디오 배경을 제거하는 무료 AI 도구. 투명 비디오로 내보내거나 배경을 흰/검/원하는 색으로 온라인에서 변경할 수 있습니다.',
            featureList: '그린 스크린 없음, 투명 비디오 내보내기, 배경색 변경, 머리카락 정밀도',
            step_name: '온라인에서 비디오 배경 제거하는 방법',
            step_list: [
                {
                    name: '영상 업로드',
                    text: '영상 파일(MP4, MOV)을 微鲤AI 배경 제거기에 업로드하세요.',
                },
                {
                    name: '배경 제거',
                    text: 'AI가 자동으로 처리합니다. 투명으로 유지하거나 새로운 배경색을 선택할 수 있어요.',
                },
                {
                    name: '내보내기',
                    text: '결과를 다운로드하세요. 투명은 WebM/MOV, 단색 배경은 MP4를 선택합니다.',
                },
            ],
        },
        aiVideoExtender: {
            title: 'AI 비디오 확장 도구 - 비디오 길이 및 시간 연장 | 微鲤AI',
            description: 'AI 기술로 비디오 길이를 연장합니다. 애니메이션, 3D 애니메이션, 사이버펑크, 코믹 등 다양한 스타일 옵션으로 비디오에 5~8초를 매끄럽게 추가합니다. 콘텐츠 크리에이터와 비디오 편집자에게 완벽합니다.',
            keywords: 'AI 비디오 확장, 비디오 길이 연장, 비디오 시간 연장, AI 비디오 확대, 비디오 늘리기, 비디오 시간 추가, AI 비디오 도구',
            og_title: 'AI 비디오 확장 도구 - 비디오 길이 및 시간 연장 | 微鲤AI',
            og_description: 'AI 기술로 비디오 길이를 연장합니다. 애니메이션, 3D 애니메이션, 사이버펑크, 코믹 등 다양한 스타일 옵션으로 비디오에 5~8초를 매끄럽게 추가합니다. 콘텐츠 크리에이터와 비디오 편집자에게 완벽합니다.',
            twitter_title: 'AI 비디오 확장 도구 - 비디오 길이 및 시간 연장 | 微鲤AI',
            twitter_description: 'AI 기술로 비디오 길이를 연장합니다. 애니메이션, 3D 애니메이션, 사이버펑크, 코믹 등 다양한 스타일 옵션으로 비디오에 5~8초를 매끄럽게 추가합니다. 콘텐츠 크리에이터와 비디오 편집자에게 완벽합니다.',
            page: {
                title1: '무료 AI 비디오 확장 & 이어가기',
                title2: '영상이 너무 짧나요? WeryAI는 생성형 AI로 다음 프레임을 예측·생성해 클립을 자연스럽게 이어 붙입니다. 프롬프트로 “다음 장면”을 유도하거나, 일반 영상을 실크처럼 부드러운 슬로모션으로 만들 수도 있어요.',
                feature_title1: '스마트 생성형 확장',
                feature_desc1: '단순히 늘리는 게 아니라 새 장면을 생성합니다. “카메라 줌아웃”, “캐릭터가 돌아선다” 같은 프롬프트를 입력하면 원본 스타일에 맞는 다음 5~10초를 생성해요.',
                feature_title2: '실키 슬로모션',
                feature_desc2: '표준 30fps 영상을 고품질 슬로모션으로 변환. WeryAI는 프레임 보간(Frame Interpolation)으로 중간 프레임을 생성해 끊김 없이 매끈하게 만듭니다.',
                feature_title3: '완벽한 루프 만들기',
                feature_desc3: 'SNS 배경용 무한 루프를 제작하세요. 시작/끝 프레임을 분석해 자연스럽게 블렌딩합니다.',
                faq: [
                    {
                        question: 'AI 비디오 확장은 어떻게 작동하나요?',
                        answer: '“Generative Outpainting(생성형 아웃페인팅)” 기술을 사용합니다. 영상의 마지막 프레임과 프롬프트를 분석해 다음 장면을 예측하고 새로운 프레임을 생성합니다.',
                    },
                    {
                        question: '확장된 부분에서 어떤 일이 일어날지 제어할 수 있나요?',
                        answer: '네! 도구의 “Prompt” 입력란에 동작을 적어주세요. 예를 들어 자동차가 달리는 영상이라면 “차가 터널로 들어간다”라고 입력해 확장을 유도할 수 있습니다.',
                    },
                    {
                        question: '확장(Extension)과 슬로모션(Slow Motion)의 차이는 무엇인가요?',
                        answer: '확장은 새로운 이벤트를 생성해 “새 시간”을 추가합니다(스토리를 늘림). 슬로모션은 중간 프레임을 추가해 “기존 시간”을 늘립니다(동작을 느리게). WeryAI는 둘 다 지원합니다.',
                    },
                    {
                        question: '얼마나 길게 확장할 수 있나요?',
                        answer: '한 번에 5초씩 확장할 수 있습니다(“Extension Duration” 설정). 반복하면 더 긴 시퀀스를 만들 수 있어요.',
                    },
                    {
                        question: '무료인가요?',
                        answer: '네. WeryAI는 비디오 확장과 슬로모션을 체험할 수 있는 무료 크레딧을 제공합니다.',
                    },
                ],
            },
            faq: [
                {
                    question: 'AI 비디오 확장은 어떻게 작동하나요?',
                    answer: '“Generative Outpainting”으로 마지막 프레임과 프롬프트를 분석해 다음 프레임을 생성합니다.',
                },
                {
                    question: '확장된 부분을 제어할 수 있나요?',
                    answer: '네. “Prompt”에 원하는 동작을 입력해 확장 방향을 유도할 수 있습니다.',
                },
                {
                    question: '확장과 슬로모션의 차이는 무엇인가요?',
                    answer: '확장은 새 장면을 생성해 시간을 추가하고, 슬로모션은 중간 프레임을 추가해 동작을 느리게 합니다.',
                },
            ],
            app_name: '微鲤AI 비디오 확장기',
            app_desc: '생성형 보간과 프롬프트로 비디오 길이를 확장하는 무료 AI 도구. AI 슬로모션(프레임 보간)과 비디오 루프 기능도 제공합니다.',
            featureList: '생성형 비디오 확장, 프롬프트 기반 이어가기, AI 슬로모션, 비디오 루프',
        },
        videoEffects: {
            title: '비디오 효과 - AI로 바이럴 비디오 만들기 | 微鲤AI',
            description: 'WeryAI에서 인기 있는 AI 비디오 효과를 탐색하세요. AI 키싱부터 AI 댄싱까지, 몇 번의 클릭만으로 바이럴 비디오를 만드세요.',
            keywords: 'AI 비디오 효과, AI 바이럴 비디오, 비디오 트렌드, AI 키싱, AI 댄싱, 비디오 생성기',
        },
        aiDancing: {
            title: 'AI 댄스 비디오 생성기 - 무료 AI 댄스 비디오 메이커 | 微鲤AI',
            description: 'WeryAI의 AI 댄스 생성기를 사용하여 사진에서 놀라운 댄스 비디오를 만드세요. 여러 댄스 템플릿과 스타일을 지원하여 사진에 생명을 불어넣으세요!',
            keywords: 'AI 댄스 비디오, AI 댄스 생성기, 사진을 비디오로, AI 비디오 생성, 微鲤AI, 무료 AI 도구',
        },
        aiKissing: {
            title: 'aiKissing | 微鲤AI',
            description: 'Experience aiKissing on 微鲤AI platform.',
            keywords: 'aiKissing, AI, 微鲤AI',
        },
        videoMotionImitation: {
            title: 'AI 비디오 동작 모방 - 무료로 사진에 생명 불어넣기 | 微鲤AI',
            description: 'WeryAI의 비디오 동작 모방 도구는 사진 캐릭터를 참조 비디오에 통합할 수 있으며, 원본 캐릭터를 대체하면서 장면 조명과 톤을 보존하여 원활한 환경 융합을 구현합니다.',
            keywords: 'AI 비디오 동작 모방, 사진에 생명 불어넣기, AI 비디오 동작 모방 도구, 微鲤AI, 무료 AI 도구',
            og_title: 'AI 비디오 동작 모방 - 무료로 사진에 생명 불어넣기 | 微鲤AI',
            og_description: 'WeryAI의 비디오 동작 모방 도구는 사진 캐릭터를 참조 비디오에 통합할 수 있으며, 원본 캐릭터를 대체하면서 장면 조명과 톤을 보존하여 원활한 환경 융합을 구현합니다.',
            twitter_title: 'AI 비디오 동작 모방 - 무료로 사진에 생명 불어넣기 | 微鲤AI',
            twitter_description: 'WeryAI의 비디오 동작 모방 도구는 사진 캐릭터를 참조 비디오에 통합할 수 있으며, 원본 캐릭터를 대체하면서 장면 조명과 톤을 보존하여 원활한 환경 융합을 구현합니다.',
            page: {
                title1: '무료 AI 댄스 생성기 & 모션 전송',
                title2: '좋아하는 애니 캐릭터가 마이클 잭슨처럼 춤추는 모습을 보고 싶나요? 혹은 정지 사진으로 바이럴 TikTok 동작을 따라 하게 만들고 싶나요? 참조 영상과 캐릭터 이미지를 업로드하면 AI가 모션을 정확히 전송합니다.',
                feature_title1: '영상 캐릭터 교체',
                feature_desc1: '리얼→애니 스왑: 사람이 춤추거나 액션하는 영상을 업로드하고, 인물을 3D 캐릭터/판다/애니 아바타로 교체하면서 배경과 조명은 그대로 유지하세요.',
                feature_title2: '사진을 춤추게',
                feature_desc2: '정지 이미지를 애니메이션으로: 나 또는 캐릭터 사진을 올리고 참조 댄스 영상을 고르면, 사진이 동작을 자연스럽게 따라 합니다. Viggle 스타일 바이럴 콘텐츠에 최적.',
                feature_title3: '차원 벽 깨기',
                feature_desc3: '크로스-스타일: 발레리나를 애니 소녀로, 가라테 소년을 판다로 바꿔도 WeryAI는 복잡한 체형과 가림(오클루전)을 안정적으로 처리합니다.',
                faq: [
                    {
                        question: 'AI로 사진을 춤추게 하려면 어떻게 하나요?',
                        answer: 'WeryAI의 “Move Mode”를 사용하세요. 애니메이션으로 만들 사진(Character Image)과 동작이 담긴 영상(Reference Video)을 업로드하고 Create를 클릭하면 모션이 전송됩니다.',
                    },
                    {
                        question: 'Move Mode와 Replace Mode의 차이는 무엇인가요?',
                        answer: 'Move Mode는 영상의 움직임으로 정지 이미지를 움직이게 합니다. Replace Mode는 기존 영상 속 인물을 이미지의 캐릭터로 교체합니다.',
                    },
                    {
                        question: 'TikTok 트렌드에도 쓸 수 있나요?',
                        answer: '네! 트렌드 댄스/챌린지에 딱 맞습니다. 연예인, 애니 캐릭터, 친구에게도 유행 동작을 시킬 수 있어요.',
                    },
                    {
                        question: '전신 샷도 지원하나요?',
                        answer: '네. 더 좋은 결과를 위해 참조 영상과 캐릭터 이미지 모두 전신이 선명하게 보이도록 준비해 주세요.',
                    },
                    {
                        question: '무료인가요?',
                        answer: '네. 매일 제공되는 무료 크레딧으로 무료로 생성할 수 있습니다.',
                    },
                ],
            },
            faq: [
                {
                    question: 'AI로 사진을 춤추게 하려면 어떻게 하나요?',
                    answer: 'WeryAI의 “Move Mode”를 사용하세요. 애니메이션으로 만들 사진(Character Image)과 동작이 담긴 영상(Reference Video)을 업로드하고 Create를 클릭하면 모션이 전송됩니다.',
                },
                {
                    question: 'Move Mode와 Replace Mode의 차이는 무엇인가요?',
                    answer: 'Move Mode는 영상의 움직임으로 정지 이미지를 움직이게 합니다. Replace Mode는 기존 영상 속 인물을 이미지의 캐릭터로 교체합니다.',
                },
            ],
            app_name: '微鲤AI 모션 전송',
            app_desc: '무료 AI 댄스 생성기 & 모션 전송 도구. 사진을 춤추게 하고, 정지 이미지를 움직이고, 영상 속 인물을 교체—온라인에서 바로.',
            featureList: 'AI 댄스 생성, 바디 포즈 전송, 영상 캐릭터 교체, 사진 애니메이션',
            step_name: 'AI로 사진을 춤추게 하는 방법',
            step_list: [
                {
                    name: '참조 영상 업로드',
                    text: '복사하고 싶은 춤/동작이 들어있는 영상을 업로드하세요.',
                },
                {
                    name: '캐릭터 이미지 업로드',
                    text: '움직이게 만들 사람/캐릭터의 정지 사진을 업로드하세요.',
                },
                {
                    name: 'Move Mode 선택',
                    text: '“Move Mode”를 선택하고 Create를 클릭하면, AI가 영상의 동작을 사진에 전송합니다.',
                },
            ],
        },
    },
    es: {
        textToMusic: {
            title: 'Generador de Música con IA - Crea Música Única con 微鲤AI | 微鲤AI',
            description: 'Descubre el Generador de Música con IA de 微鲤AI. Crea rápidamente música única y libre de derechos adaptada a tus proyectos con tecnología de IA avanzada. Perfecto para creadores de contenido, desarrolladores de juegos y entusiastas de la música.',
            keywords: 'texto a música, texto a música gratis, IA texto a música, generador de música IA, creador de canciones IA, letra a música, crear música similar, creación de música, música libre de derechos, descargar música gratis, 微鲤AI',
        },
        textToVideo: {
            title: 'Generador IA de Texto a Video Gratis (Veo 3.1, Kling y Sora) | 微鲤AI',
            description: 'Convierte tus prompts en videos cinematográficos al instante con la IA de Texto a Video de 微鲤AI. Impulsado por Google Veo 3.1, Kling y Sora. Soporta formatos 16:9 y 9:16, hasta 8 s de duración. Opciones sin marca de agua disponibles.',
            keywords: 'texto a video IA, generador de video IA, google veo 3.1, prompt a video, kling ai, sora, txt2vid, 微鲤AI',
            og_title: 'Generador IA de Texto a Video Gratis (Veo 3.1, Kling y Sora) | 微鲤AI',
            og_description: 'Convierte tus prompts en videos cinematográficos al instante con la IA de Texto a Video de 微鲤AI. Impulsado por Google Veo 3.1, Kling y Sora. Soporta formatos 16:9 y 9:16, hasta 8 s de duración. Opciones sin marca de agua disponibles.',
            twitter_title: 'Generador IA de Texto a Video Gratis (Veo 3.1, Kling y Sora) | 微鲤AI',
            twitter_description: 'Convierte tus prompts en videos cinematográficos al instante con la IA de Texto a Video de 微鲤AI. Impulsado por Google Veo 3.1, Kling y Sora. Soporta formatos 16:9 y 9:16, hasta 8 s de duración. Opciones sin marca de agua disponibles.',
            page: {
                title1: 'Generador IA de Texto a Video Gratis',
                title2: 'Escribe un prompt y mira cómo 微鲤AI convierte tu idea en video. Nuestro generador de Texto a Video integra modelos de última generación como Google Veo 3.1 y Kling, para crear videos de alta calidad y movimiento natural para redes (9:16) o proyectos cinemáticos (16:9) en segundos.',
                intro_title: 'Convierte la imaginación en realidad con Texto a Video',
                feature_title: 'Funciones del Texto a Video de 微鲤AI',
                faq_title: 'Preguntas frecuentes sobre Texto a Video',
                feature_title1: 'Potencia multi‑modelo',
                feature_desc1: 'Alterna entre Veo 3.1 para realismo y Kling para consistencia de movimiento. Sin múltiples suscripciones.',
                feature_title2: 'Relaciones de aspecto personalizadas',
                feature_desc2: 'Genera videos verticales (9:16) para TikTok/Reels o widescreen (16:9) para YouTube.',
                feature_title3: 'Duración extendida',
                feature_desc3: 'Crea videos de hasta 8 s (o más con extensiones) en una sola generación, ideal para storytelling.',
                faq: [
                    {
                        question: '¿Cómo escribo un buen prompt para texto a video?',
                        answer: 'Sé específico: sujeto, acción, iluminación y ángulo de cámara. Ejemplo: "Toma de dron cinematográfica de una ciudad cyberpunk futurista de noche, luces neón, resolución 4K".',
                    },
                    {
                        question: '¿Qué modelo uso: Google Veo 3.1 o Kling?',
                        answer: 'Google Veo 3.1 ofrece gran fidelidad visual y adherencia al prompt, ideal para escenas realistas. Kling suele rendir mejor en movimientos complejos de personajes. Recomendamos probar ambos.',
                    },
                    {
                        question: '¿微鲤AI Texto a Video es gratis?',
                        answer: 'Sí, cada usuario recibe créditos diarios gratis para generar videos desde texto. Puedes crear varios clips para comparar prompts y modelos.',
                    },
                    {
                        question: '¿Puedo generar videos de más de 8 segundos?',
                        answer: 'La generación base llega hasta 8 s (según el modelo). Para videos más largos, usa nuestra herramienta AI Video Extender para continuar el metraje sin cortes.',
                    },
                    {
                        question: '¿Los videos generados tienen sonido?',
                        answer: 'Sí. Puedes activar el interruptor "Generate Audio" para crear automáticamente efectos de sonido y ambiente.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿Cómo escribo un buen prompt para texto a video?',
                    answer: 'Sé específico: sujeto, acción, iluminación y cámara. Ejemplo: "Ciudad cyberpunk de noche, neón, dron, 4K".',
                },
                {
                    question: '¿Qué modelo uso: Google Veo 3.1 o Kling?',
                    answer: 'Veo 3.1 destaca en realismo y adherencia al prompt; Kling suele ser mejor en movimientos complejos. Prueba ambos.',
                },
                {
                    question: '¿微鲤AI Texto a Video es gratis?',
                    answer: 'Sí. Hay créditos diarios gratis para generar videos desde texto.',
                },
                {
                    question: '¿Puedo generar videos de más de 8 segundos?',
                    answer: 'La base llega hasta 8 s; para más duración, usa AI Video Extender.',
                },
                {
                    question: '¿Los videos generados tienen sonido?',
                    answer: 'Sí. Activa "Generate Audio" para generar audio automáticamente.',
                },
            ],
        },
        imageToVideo: {
            title: 'Generador IA de Imagen a Video (Gratis y Online) - Con Kling, Veo y Sora',
            description: 'Convierte fotos estáticas en videos realistas en segundos con el generador IA de Imagen a Video gratis de 微鲤AI. Accede a modelos top como Kling, Google Veo y Sora 2 en un solo lugar. Opciones sin marca de agua disponibles.',
            keywords: 'imagen a video IA, generador de video IA, animación de imagen, video Sora, video Veo, video Seedance, herramientas de video 微鲤AI',
            og_title: 'Generador IA de Imagen a Video (Gratis y Online) - Con Kling, Veo y Sora',
            og_description: 'Convierte fotos estáticas en videos realistas en segundos con el generador IA de Imagen a Video gratis de 微鲤AI. Accede a modelos top como Kling, Google Veo y Sora 2 en un solo lugar. Opciones sin marca de agua disponibles.',
            twitter_title: 'Generador IA de Imagen a Video (Gratis y Online) - Con Kling, Veo y Sora',
            twitter_description: 'Convierte fotos estáticas en videos realistas en segundos con el generador IA de Imagen a Video gratis de 微鲤AI. Accede a modelos top como Kling, Google Veo y Sora 2 en un solo lugar. Opciones sin marca de agua disponibles.',
            page: {
                title1: 'Generador IA de Imagen a Video Gratis Online',
                faq: [
                    {
                        question: '¿Cómo funciona el generador IA de Imagen a Video?',
                        answer: 'Usa modelos avanzados de deep learning como Kling y Sora para analizar tu imagen estática y predecir el movimiento, generando un clip de video coherente en formato MP4.',
                    },
                    {
                        question: '¿微鲤AI Imagen a Video es gratis?',
                        answer: 'Sí, ofrecemos créditos gratis diarios para que pruebes nuestra IA de imagen a video. Puedes mejorar tu plan para acceder a modelos premium y mayor velocidad de generación.',
                    },
                    {
                        question: '¿Qué modelo es mejor para video realista: Kling o Veo?',
                        answer: 'Kling AI es famoso por su movimiento realista y mayor duración, mientras que Google Veo destaca por sus detalles en alta definición. En 微鲤AI puedes alternar entre ellos para encontrar el mejor resultado.',
                    },
                    {
                        question: '¿Puedo usar los videos generados comercialmente?',
                        answer: 'Sí, los videos generados bajo nuestros planes de pago incluyen licencia comercial, perfectos para YouTube, TikTok y anuncios de marketing.',
                    },
                    {
                        question: '¿Cómo quitar marcas de agua en videos con IA?',
                        answer: '微鲤AI ofrece salidas de alta calidad. Para videos sin marca de agua, revisa los detalles de tu plan o usa nuestra herramienta dedicada de Eliminación de Marca de Agua con IA.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿Cómo funciona el generador IA de Imagen a Video?',
                    answer: 'Usa modelos avanzados como Kling y Sora para analizar tu imagen y predecir el movimiento, generando un clip MP4 coherente.',
                },
                {
                    question: '¿微鲤AI Imagen a Video es gratis?',
                    answer: 'Sí, ofrecemos créditos gratis diarios para probar la IA de imagen a video. Puedes actualizar para modelos premium y mayor velocidad.',
                },
                {
                    question: '¿Puedo usar los videos generados comercialmente?',
                    answer: 'Sí, los videos de planes de pago incluyen licencia comercial, ideal para YouTube, TikTok y publicidad.',
                },
            ],
        },
        videoToVideo: {
            title: 'Generador Gratis de Video a Video con IA - Restyle y Filtro Anime | 微鲤AI',
            description: 'Transforma tus videos en cualquier estilo con la IA Video a Video de 微鲤AI. Convierte material real en anime, caricaturas 3D o arte cyberpunk usando prompts de texto, manteniendo el movimiento original consistente. Gratis y online.',
            keywords: 'video a video IA, vid2vid, transferencia de estilo de video IA, convertir video en anime, restyle de video IA, filtro de video IA gratis',
            og_title: 'Generador Gratis de Video a Video con IA - Restyle y Filtro Anime | 微鲤AI',
            og_description: 'Transforma tus videos en cualquier estilo con la IA Video a Video de 微鲤AI. Convierte material real en anime, caricaturas 3D o arte cyberpunk usando prompts de texto, manteniendo el movimiento original consistente. Gratis y online.',
            twitter_title: 'Generador Gratis de Video a Video con IA - Restyle y Filtro Anime | 微鲤AI',
            twitter_description: 'Transforma tus videos en cualquier estilo con la IA Video a Video de 微鲤AI. Convierte material real en anime, caricaturas 3D o arte cyberpunk usando prompts de texto, manteniendo el movimiento original consistente. Gratis y online.',
            page: {
                title1: 'Generador Gratis de Video a Video con IA (Vid2Vid)',
                title2: 'Sube un video, escribe un estilo y mira la magia. La tecnología Video a Video de 微鲤AI analiza el movimiento del metraje original y aplica un estilo artístico completamente nuevo según tu prompt. Ideal para edits anime, efectos de stop‑motion tipo plastilina o arte visual surrealista.',
                feature_title1: 'Movimiento Consistente',
                feature_desc1: 'A diferencia de una generación estándar, nuestro motor Vid2Vid se “ancla” al movimiento del video fuente para lograr transiciones suaves sin parpadeos.',
                feature_title2: 'De Real a Anime',
                feature_desc2: 'La herramienta #1 para creadores. Conviértete al instante en un personaje anime o en un avatar 3D estilo Pixar.',
                feature_title3: 'Control con Prompts',
                feature_desc3: 'Tienes control creativo total. Escribe “estilo ciudad cyberpunk” o “estilo pintura al óleo” para definir exactamente el look del resultado.',
                faq: [
                    {
                        question: '¿Qué es la IA de Video a Video (Vid2Vid)?',
                        answer: 'Video a Video es un proceso de IA generativa que toma un clip existente como entrada y lo “repinta” en un nuevo estilo descrito por tu prompt, manteniendo el movimiento y la estructura originales.',
                    },
                    {
                        question: '¿Puedo convertir mi video a estilo anime?',
                        answer: 'Sí. Es el caso de uso más popular. Sube tu video e ingresa prompts como “estilo anime japonés, look Studio Ghibli” para transformarlo.',
                    },
                    {
                        question: '¿Qué tan largo puede ser el video fuente?',
                        answer: 'Actualmente soportamos clips cortos (por ejemplo, 5–10 segundos) para asegurar la mejor calidad. Para videos largos, recomendamos dividirlos en segmentos.',
                    },
                    {
                        question: '¿En qué se diferencia de un editor de video?',
                        answer: 'Un editor tradicional recorta y corta clips. Video a Video de 微鲤AI genera nuevos píxeles, cambiando por completo la textura y el estilo artístico del metraje.',
                    },
                    {
                        question: '¿Cuesta dinero?',
                        answer: '微鲤AI ofrece créditos diarios gratis para probar Video a Video. Hay planes premium para procesamiento más rápido y descargas sin marca de agua.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿Qué es la IA de Video a Video (Vid2Vid)?',
                    answer: 'Toma un video existente y lo “repinta” en un nuevo estilo mediante prompts, preservando movimiento y estructura.',
                },
                {
                    question: '¿Puedo convertir mi video a estilo anime?',
                    answer: 'Sí. Sube tu video y usa prompts como “estilo anime japonés, Studio Ghibli”.',
                },
                {
                    question: '¿Qué tan largo puede ser el video fuente?',
                    answer: 'Recomendamos clips cortos (5–10 s) para máxima calidad; para largos, divide en segmentos.',
                },
                {
                    question: '¿En qué se diferencia de un editor de video?',
                    answer: 'Un editor recorta; Vid2Vid genera nuevos píxeles y cambia textura/estilo del metraje.',
                },
                {
                    question: '¿Cuesta dinero?',
                    answer: 'Hay créditos diarios gratis; planes premium ofrecen más velocidad y sin marca de agua.',
                },
            ],
        },
        removeWatermark: {
            title: 'Eliminador Gratis de Marca de Agua en Video con IA - Borra Logos, Texto y Subtítulos | 微鲤AI',
            description: 'Elimina fácilmente marcas de agua, logos, subtítulos y sellos de fecha de tus videos con el Eliminador de Marca de Agua con IA gratis de 微鲤AI. Soporta MP4/MOV y enlaces de video. Sin desenfoque: restauración limpia con IA.',
            keywords: 'quitar marca de agua de video, borrador de video IA, eliminar logo de video, borrar subtítulos, quitar marca de agua de TikTok, removedor de marca de agua online gratis',
            og_title: 'Eliminador Gratis de Marca de Agua en Video con IA - Borra Logos, Texto y Subtítulos | 微鲤AI',
            og_description: 'Elimina fácilmente marcas de agua, logos, subtítulos y sellos de fecha de tus videos con el Eliminador de Marca de Agua con IA gratis de 微鲤AI. Soporta MP4/MOV y enlaces de video. Sin desenfoque: restauración limpia con IA.',
            twitter_title: 'Eliminador Gratis de Marca de Agua en Video con IA - Borra Logos, Texto y Subtítulos | 微鲤AI',
            twitter_description: 'Elimina fácilmente marcas de agua, logos, subtítulos y sellos de fecha de tus videos con el Eliminador de Marca de Agua con IA gratis de 微鲤AI. Soporta MP4/MOV y enlaces de video. Sin desenfoque: restauración limpia con IA.',
            page: {
                title1: 'Eliminador Online Gratis de Marca de Agua en Video con IA',
                title2: 'Borra al instante marcas de agua, logos, texto superpuesto y subtítulos de tus videos. Pega un enlace o sube un archivo, selecciona el área y deja que la IA restaure el fondo píxel a píxel sin desenfocar.',
                click_erase: '1.Borrado en un clic: la IA detecta y elimina automáticamente marcas de agua comunes.',
                percision_erase: '2.Borrado de precisión: usa el pincel para eliminar manualmente objetos complejos como subtítulos en movimiento o marcas de tiempo.',
                video_link_title: 'Soporte por enlace',
                direct_link_desc: '1.Eliminación por enlace directo: pega enlaces de redes sociales para quitar marcas de agua sin descargar el archivo.',
                lossless_qua_title: '2.Calidad sin pérdida: a diferencia del desenfoque, 微鲤AI reconstruye el fondo analizando los píxeles alrededor.',
                faq: [
                    {
                        question: '¿Cómo quitar una marca de agua de un video online gratis?',
                        answer: 'Sube tu video a 微鲤AI o pega un enlace. Cubre la marca de agua con la caja de selección y haz clic en “Generate”. Es gratis para probar.',
                    },
                    {
                        question: '¿Puedo borrar subtítulos o texto en movimiento?',
                        answer: 'Sí. Usa el modo “Precision Erase” para seleccionar el área. Nuestra IA rastrea el texto entre fotogramas para eliminarlo limpiamente en todo el video.',
                    },
                    {
                        question: '¿Funciona para videos de TikTok o YouTube?',
                        answer: 'Sí. Puedes eliminar logos de plataforma (como la marca de agua saltarina de TikTok) o watermarks de canal para obtener un video limpio para uso personal.',
                    },
                    {
                        question: '¿La zona eliminada quedará borrosa?',
                        answer: 'No. 微鲤AI usa “Video In‑painting” avanzado para rellenar el área con texturas realistas generadas a partir del video alrededor, evitando el desenfoque feo.',
                    },
                    {
                        question: '¿Qué formatos de video soportan?',
                        answer: 'Soportamos los formatos principales, incluyendo MP4, MOV, AVI y WebM.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿Cómo quitar una marca de agua de un video online gratis?',
                    answer: 'Sube el video o pega un enlace, cubre la marca con la selección y pulsa “Generate”.',
                },
                {
                    question: '¿Puedo borrar subtítulos o texto en movimiento?',
                    answer: 'Sí. Con “Precision Erase”, la IA rastrea el texto entre fotogramas para eliminarlo en todo el video.',
                },
                {
                    question: '¿La zona eliminada quedará borrosa?',
                    answer: 'No. Con Video In‑painting, se rellena con texturas realistas sin desenfoque.',
                },
            ],
        },
        videoFaceSwap: {
            title: 'Intercambio de Rostros en Video con IA Gratis - Deepfake Realista Online | 微鲤AI',
            description: 'Cambia rostros en videos al instante con el Face Swapper IA de 微鲤AI. Crea clips divertidos, memes y deepfakes realistas gratis. Opciones sin marca de agua disponibles. 100% privado y seguro.',
            keywords: 'intercambio de rostros en video, face swap IA, creador deepfake gratis, reemplazar rostro en video, intercambio de rostro en películas, reface online, meme maker IA',
            og_title: 'Intercambio de Rostros en Video con IA Gratis - Deepfake Realista Online | 微鲤AI',
            og_description: 'Cambia rostros en videos al instante con el Face Swapper IA de 微鲤AI. Crea clips divertidos, memes y deepfakes realistas gratis. Opciones sin marca de agua disponibles. 100% privado y seguro.',
            twitter_title: 'Intercambio de Rostros en Video con IA Gratis - Deepfake Realista Online | 微鲤AI',
            twitter_description: 'Cambia rostros en videos al instante con el Face Swapper IA de 微鲤AI. Crea clips divertidos, memes y deepfakes realistas gratis. Opciones sin marca de agua disponibles. 100% privado y seguro.',
            page: {
                title1: 'Intercambio de Rostros en Video con IA (Gratis)',
                title2: '¡Sé la estrella de cualquier película! Sube un clip y una foto del rostro objetivo y deja que nuestra IA intercambie las caras de forma natural. Ideal para memes, saludos personalizados o efectos visuales profesionales con alta fidelidad.',
                feature_title1: 'Deepfake Hiperrealista',
                feature_desc1: 'La IA analiza geometría facial e iluminación para integrar el nuevo rostro de forma natural, manteniendo expresiones y movimientos de la cabeza.',
                feature_title2: 'Privacidad Primero',
                feature_desc2: 'Tu privacidad es prioridad. Los videos e imágenes subidos se procesan de forma segura y se eliminan poco después de la generación.',
                feature_title3: 'Sin Conocimientos Técnicos',
                feature_desc3: 'No necesitas software complejo como After Effects. Solo haz clic en “Create” y obtén resultados de nivel Hollywood en segundos.',
                faq: [
                    {
                        question: '¿微鲤AI Video Face Swap es gratis?',
                        answer: 'Sí. Ofrecemos créditos gratis para que pruebes el intercambio de rostros en video online. No necesitas tarjeta para empezar.',
                    },
                    {
                        question: '¿Es seguro subir mis fotos?',
                        answer: 'Totalmente. Usamos protocolos estrictos de protección de datos. Tus videos e imágenes se usan solo para generar el resultado y no se almacenan permanentemente.',
                    },
                    {
                        question: '¿Puedo intercambiar rostros en GIFs?',
                        answer: '¡Sí! 微鲤AI soporta formatos de video (MP4/MOV) y GIF. Puedes crear GIFs de reacción personalizados fácilmente.',
                    },
                    {
                        question: '¿Cómo obtener los mejores resultados?',
                        answer: 'Usa una foto de “Rostro objetivo” nítida, frontal y bien iluminada. Evita fotos donde el rostro esté cubierto por cabello o gafas.',
                    },
                    {
                        question: '¿Puedo usarlo en proyectos comerciales?',
                        answer: 'Sí, pero asegúrate de tener los derechos del metraje original y del uso de la imagen de la persona cuya cara estás intercambiando.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿微鲤AI Video Face Swap es gratis?',
                    answer: 'Sí. Hay créditos gratis para probar y no necesitas tarjeta para empezar.',
                },
                {
                    question: '¿Es seguro subir mis fotos?',
                    answer: 'Sí. Se usan solo para la generación y no se almacenan permanentemente.',
                },
                {
                    question: '¿Cómo obtener los mejores resultados?',
                    answer: 'Usa una foto nítida, frontal y bien iluminada; evita rostros cubiertos por cabello o gafas.',
                },
            ],
        },
        videoLipSync: {
            title: 'Generador gratis de lip sync en video con IA - Sincroniza audio y texto con video | 微鲤AI',
            description: 'Sincroniza perfectamente los movimientos de labios con cualquier audio o texto usando la herramienta de Lip Sync con IA de 微鲤AI. Impulsada por Kling AI. Ideal para traducción de video, doblaje y avatares parlantes. Gratis y online.',
            keywords: 'sincronización labial video, sincronización labial, sincronización labial IA, doblaje video, sincronización voz, video hablante, herramienta sincronización labial',
            og_title: 'Generador gratis de lip sync en video con IA - Sincroniza audio y texto con video | 微鲤AI',
            og_description: 'Sincroniza perfectamente los movimientos de labios con cualquier audio o texto usando la herramienta de Lip Sync con IA de 微鲤AI. Impulsada por Kling AI. Ideal para traducción de video, doblaje y avatares parlantes. Gratis y online.',
            twitter_title: 'Generador gratis de lip sync en video con IA - Sincroniza audio y texto con video | 微鲤AI',
            twitter_description: 'Sincroniza perfectamente los movimientos de labios con cualquier audio o texto usando la herramienta de Lip Sync con IA de 微鲤AI. Impulsada por Kling AI. Ideal para traducción de video, doblaje y avatares parlantes. Gratis y online.',
            page: {
                title1: 'Herramienta gratis de lip sync y doblaje con IA',
                title2: 'Dile adiós a los doblajes incómodos. Sube un video y un archivo de audio (o escribe texto) y nuestra IA regenerará los movimientos de la boca del hablante para que coincidan perfectamente con el sonido. Impulsada por Kling AI, admite doblaje multilingüe y ajustes faciales realistas.',
                dual_input_modes: 'Modos de entrada dual',
                audio_sync: 'Sincronización de audio',
                text_sync: 'Texto a voz',
                text_sync_tip: 'Escribe cualquier texto, elige una voz de IA predefinida y deja que el personaje lo diga al instante.',
                audio_sync_tip: 'Sube tu propia locución o canción para sincronizar.',
                feature_title1: 'Doblaje multilingüe',
                feature_desc1: 'Amplía tu alcance. Traduce tu video al español, francés o japonés y sincroniza los labios para que el hablante parezca nativo.',
                feature_title2: 'Precisión de Kling AI',
                feature_desc2: 'A diferencia de herramientas Wav2Lip básicas, usamos el modelo Kling para que los movimientos de dientes, lengua y mandíbula sean anatómicamente correctos.',
                faq: [
                    {
                        question: '¿Cómo sincronizo los labios con el audio en un video?',
                        answer: 'Sube tu clip a 微鲤AI. Luego, sube un archivo de audio (MP3/WAV) o escribe texto para generar voz con IA. Haz clic en "Create" y nuestra IA ajustará los movimientos de la boca para que coincidan con el sonido.',
                    },
                    {
                        question: '¿Puedo usarlo para traducción/doblaje de video?',
                        answer: '¡Sí! Es perfecto para doblaje. Puedes subir una pista de audio traducida y la IA corregirá el lip sync para que el doblaje se vea natural.',
                    },
                    {
                        question: '¿Funciona con imágenes estáticas (cabezas parlantes)?',
                        answer: 'Sí. Si subes un retrato como “video” de origen, la herramienta lo animará y lo convertirá en un video de cabeza parlante (efecto Live Portrait).',
                    },
                    {
                        question: '¿Qué idiomas se admiten?',
                        answer: 'Como la tecnología analiza ondas de audio, funciona con cualquier idioma (inglés, español, chino, hindi, etc.). Para entrada de Texto a Voz, admitimos más de 50 idiomas.',
                    },
                    {
                        question: '¿El lip sync es gratis?',
                        answer: '微鲤AI ofrece créditos diarios gratis para probar la función de Lip Sync. Para videos largos o uso comercial, hay planes premium.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿Cómo sincronizo los labios con el audio en un video?',
                    answer: 'Sube tu clip a 微鲤AI. Luego, sube un archivo de audio (MP3/WAV) o escribe texto para generar voz con IA. Haz clic en "Create" y nuestra IA ajustará los movimientos de la boca para que coincidan con el sonido.',
                },
                {
                    question: '¿Puedo usarlo para traducción/doblaje de video?',
                    answer: '¡Sí! Es perfecto para doblaje. Puedes subir una pista de audio traducida y la IA corregirá el lip sync para que el doblaje se vea natural.',
                },
                {
                    question: '¿Funciona con imágenes estáticas (cabezas parlantes)?',
                    answer: 'Sí. Si subes un retrato como “video” de origen, la herramienta lo animará y lo convertirá en un video de cabeza parlante (efecto Live Portrait).',
                },
            ],
        },
        translateVideoSubtitle: {
            title: 'Traductor de subtítulos de video con IA gratis - Genera y traduce online | 微鲤AI',
            description: 'Genera y traduce subtítulos de video automáticamente con el Traductor de Subtítulos IA de 微鲤AI. Compatible con inglés, español, chino y 90+ idiomas. Descarga al instante videos con subtítulos quemados (hardsubs).',
            keywords: 'traducción de subtítulos IA, traductor de subtítulos de video, subtítulos multilingües, traducción de video, convertidor de subtítulos, traducción de video IA',
            og_title: 'Traductor de subtítulos de video con IA gratis - Genera y traduce online | 微鲤AI',
            og_description: 'Genera y traduce subtítulos de video automáticamente con el Traductor de Subtítulos IA de 微鲤AI. Compatible con inglés, español, chino y 90+ idiomas. Descarga al instante videos con subtítulos quemados (hardsubs).',
            twitter_title: 'Traductor de subtítulos de video con IA gratis - Genera y traduce online | 微鲤AI',
            twitter_description: 'Genera y traduce subtítulos de video automáticamente con el Traductor de Subtítulos IA de 微鲤AI. Compatible con inglés, español, chino y 90+ idiomas. Descarga al instante videos con subtítulos quemados (hardsubs).',
            page: {
                title1: 'Traductor de subtítulos de video con IA gratis',
                title2: 'Rompe la barrera del idioma al instante. Sube tu video, elige tu idioma objetivo y deja que nuestra IA reconozca el habla, transcriba el audio y queme subtítulos traducidos y precisos directamente en tu archivo de video.',
                feature_title1: 'Soporte de 90+ idiomas',
                feature_desc1: 'Traduce tu contenido del inglés al español, francés, alemán, japonés, chino y más. Llega a una audiencia global con un clic.',
                feature_title2: 'Auto-sincronización y subtítulos quemados',
                feature_desc2: 'No hace falta ajustar marcas de tiempo manualmente. Nuestra IA sincroniza los subtítulos con el audio y los quema en el video (hardsubs) para máxima compatibilidad.',
                feature_title3: 'Precisión con contexto',
                feature_desc3: 'Impulsado por LLM avanzados, 微鲤AI entiende el contexto y la jerga para ofrecer traducciones naturales y precisas, no literales y robóticas.',
                faq: [
                    {
                        question: '¿Cómo traduzco subtítulos de video automáticamente?',
                        answer: 'Sube tu video a 微鲤AI, selecciona el “Target Language” (por ejemplo, inglés a español) y haz clic en “Create”. La IA generará y traducirá los subtítulos automáticamente.',
                    },
                    {
                        question: '¿Qué idiomas se admiten para la traducción?',
                        answer: 'Admitimos más de 90 idiomas globales, incluyendo inglés, español, francés, alemán, portugués, hindi, japonés y chino.',
                    },
                    {
                        question: '¿El traductor de subtítulos es gratis?',
                        answer: 'Sí. 微鲤AI ofrece acceso gratuito a nuestro traductor de subtítulos con IA. Puedes procesar videos sin pagar por servicios de transcripción costosos.',
                    },
                    {
                        question: '¿Necesito descargar un archivo SRT?',
                        answer: 'No. 微鲤AI genera videos con subtítulos incrustados (quemados), por lo que el texto es parte del video. Así se verán correctamente en TikTok, Instagram y YouTube.',
                    },
                    {
                        question: '¿Qué tan precisa es la traducción?',
                        answer: 'Usamos modelos de reconocimiento de voz de última generación para alta precisión. Con audio claro, la precisión puede superar el 95%.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿Cómo traduzco subtítulos de video automáticamente?',
                    answer: 'Sube tu video a 微鲤AI, selecciona el Target Language y haz clic en Create. La IA generará y traducirá los subtítulos automáticamente.',
                },
                {
                    question: '¿Qué idiomas se admiten para la traducción?',
                    answer: 'Admitimos más de 90 idiomas globales, incluyendo inglés, español, francés, alemán, portugués, hindi, japonés y chino.',
                },
                {
                    question: '¿Necesito descargar un archivo SRT?',
                    answer: 'No. 微鲤AI genera videos con subtítulos quemados (incrustados), para que se vean bien en todas las plataformas sociales.',
                },
            ],
        },
        videoToAnime: {
            title: 'Convertidor Gratis de Video a Anime con IA - De Real a Cartoon y Pixar | 微鲤AI',
            description: 'Transforma tus videos en anime japonés, estilo Pixar 3D o dibujos animados al instante con el Convertidor de Video a Anime de 微鲤AI. Estabilidad fotograma a fotograma para una animación suave. Gratis y online.',
            keywords: 'video a anime, filtro anime IA, convertir video en cartoon, filtro pixar video, real a anime, alternativa a domoai, generador de anime',
            og_title: 'Convertidor Gratis de Video a Anime con IA - De Real a Cartoon y Pixar | 微鲤AI',
            og_description: 'Transforma tus videos en anime japonés, estilo Pixar 3D o dibujos animados al instante con el Convertidor de Video a Anime de 微鲤AI. Estabilidad fotograma a fotograma para una animación suave. Gratis y online.',
            twitter_title: 'Convertidor Gratis de Video a Anime con IA - De Real a Cartoon y Pixar | 微鲤AI',
            twitter_description: 'Transforma tus videos en anime japonés, estilo Pixar 3D o dibujos animados al instante con el Convertidor de Video a Anime de 微鲤AI. Estabilidad fotograma a fotograma para una animación suave. Gratis y online.',
            page: {
                title1: 'Convertidor Gratis de Video a Anime con IA',
                title2: 'Conviértete en protagonista de anime con un clic. Sube cualquier video real, elige un estilo (Pixar 3D, 2D clásico o dibujado a mano) y deja que nuestra IA reestilice tu metraje fotograma a fotograma manteniendo el movimiento suave y consistente.',
                feature_desc1: '<div><p>Pixar y 3D: crea clips animados lindos, estilo Disney, perfectos para videos familiares.</p><p>Anime clásico: logra un look auténtico de animación japonesa (estilo Ghibli/Shinkai).</p><p>Boceto y tinta: convierte videos en animaciones artísticas tipo dibujo a lápiz.</p></div>',
                feature_title2: 'Estabilidad fotograma a fotograma',
                feature_desc2: '¿Cansado del parpadeo en videos IA? 微鲤AI usa algoritmos avanzados de consistencia temporal para que tu video anime se vea fluido, sin los “tirones” típicos de otras herramientas.',
                feature_title3: 'Creador de contenido viral',
                feature_desc3: 'Diseñado para TikTok y Reels. Crea videos tendencia tipo “Real vs Anime” que captan la atención al instante.',
                faq: [
                    {
                        question: '¿Cómo convertir un video a anime gratis?',
                        answer: 'Sube tu clip al Convertidor de Video a Anime de 微鲤AI. Elige un preset (como “2D Style” o “Pixar Style”) y haz clic en Create. Puedes probarlo gratis con créditos diarios.',
                    },
                    {
                        question: '¿Puedo convertir un video a estilo Pixar/Disney?',
                        answer: '¡Sí! Tenemos un preset “3D Cartoon” o “Pixar Style” que transforma personas reales en personajes 3D adorables.',
                    },
                    {
                        question: '¿Qué tan largo puede ser el video?',
                        answer: 'Actualmente soportamos clips de hasta 30 segundos (según “Maximum video duration: 30s”). Ideal para Shorts, Reels y TikTok.',
                    },
                    {
                        question: '¿El personaje anime se moverá como yo?',
                        answer: 'Sí. Nuestra IA analiza tu movimiento y expresiones para que el personaje imite tus acciones con precisión.',
                    },
                    {
                        question: '¿Cuál es el mejor convertidor de video a anime?',
                        answer: '微鲤AI es una gran opción por sus estilos 2D/3D y su enfoque en estabilidad para reducir ruido y parpadeos.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿Cómo convertir un video a anime gratis?',
                    answer: 'Sube tu clip a 微鲤AI, elige un preset (2D Style o Pixar Style) y haz clic en Create.',
                },
                {
                    question: '¿Puedo convertir un video a estilo Pixar/Disney?',
                    answer: 'Sí. Ofrecemos un preset 3D Cartoon/Pixar Style para transformar personas reales en personajes 3D.',
                },
                {
                    question: '¿El personaje anime se moverá como yo?',
                    answer: 'Sí. La IA analiza tu movimiento y expresiones para que el personaje imite tus acciones.',
                },
            ],
            app_name: '微鲤AI Convertidor de Video a Anime',
            app_desc: 'Herramienta IA gratis para convertir videos reales en anime, cartoon y estilo Pixar. Render fotograma a fotograma para animación estable.',
            featureList: 'Real a Anime, Filtro Pixar, Consistencia de fotogramas, Estilos 2D/3D',
        },
        videoUpscaler: {
            title: 'AI Video Upscaler Gratis - Mejora a 4K Online | 微鲤AI',
            description: 'Mejora al instante videos de baja resolución a 1080p, 2K y 4K con el AI Video Upscaler gratis de 微鲤AI. Corrige pixelación, reduce ruido y mejora la calidad online sin instalar software.',
            keywords: 'video upscaler, mejorador de video IA, upscaler a 4k, quitar desenfoque video, reducción de ruido video, mejorar calidad video, upscaler de video gratis online',
            og_title: 'AI Video Upscaler Gratis - Mejora a 4K Online | 微鲤AI',
            og_description: 'Mejora al instante videos de baja resolución a 1080p, 2K y 4K con el AI Video Upscaler gratis de 微鲤AI. Corrige pixelación, reduce ruido y mejora la calidad online sin instalar software.',
            twitter_title: 'AI Video Upscaler Gratis - Mejora a 4K Online | 微鲤AI',
            twitter_description: 'Mejora al instante videos de baja resolución a 1080p, 2K y 4K con el AI Video Upscaler gratis de 微鲤AI. Corrige pixelación, reduce ruido y mejora la calidad online sin instalar software.',
            page: {
                title1: 'AI Video Upscaler Gratis',
                title2: 'No te conformes con videos borrosos o pixelados. Sube tus videos de baja resolución (360p, 480p, 720p) y deja que nuestra IA los suba automáticamente a una impresionante resolución 4K. No solo aumenta el tamaño: también recupera detalles, elimina ruido y corrige color.',
                feature_title1: 'Mejora a 4K',
                feature_desc1: 'Dale nueva vida a videos antiguos. Convierte contenido SD a HD o 4K con un clic para que se vea nítido en pantallas modernas.',
                feature_title2: 'Arregla videos borrosos y con grano',
                feature_desc2: '¿Grabado con poca luz? Nuestro algoritmo de denoise elimina grano digital y artefactos de compresión para un look limpio y profesional.',
                feature_title3: 'Restauración de metraje antiguo',
                feature_desc3: 'Ideal para archivos familiares. Restaura colores deslavados y mejora detalles en videos caseros antiguos o clips vintage.',
                faq: [
                    {
                        question: '¿Puedo mejorar un video a 4K online gratis?',
                        answer: 'Sí. 微鲤AI permite elegir resoluciones de salida hasta 4K (según las opciones). Puedes probarlo gratis con créditos diarios.',
                    },
                    {
                        question: '¿Cómo arreglar un video borroso?',
                        answer: 'Sube el video borroso a nuestro AI Video Upscaler. La IA analiza los píxeles perdidos y reconstruye detalles para reducir el desenfoque.',
                    },
                    {
                        question: '¿Funciona con videos viejos de celular?',
                        answer: 'Sí. Funciona muy bien con videos de baja calidad (360p o 480p), convirtiéndolos en 1080p o superior.',
                    },
                    {
                        question: '¿Cuánto tarda el proceso?',
                        answer: 'El upscaling requiere cómputo, pero 微鲤AI usa GPUs en la nube optimizadas. Un clip corto suele tardar unos minutos.',
                    },
                    {
                        question: '¿Es mejor que Topaz Video AI?',
                        answer: '微鲤AI ofrece calidad comparable y funciona 100% en el navegador. No necesitas hardware caro ni instalar software pesado.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿Puedo mejorar un video a 4K online?',
                    answer: 'Sí. 微鲤AI permite elegir salida hasta 4K y puedes probarlo gratis con créditos diarios.',
                },
                {
                    question: '¿Cómo arreglar un video borroso?',
                    answer: 'Sube el video al AI Video Upscaler: la IA reconstruye detalles para reducir el desenfoque.',
                },
                {
                    question: '¿Es mejor que Topaz Video AI?',
                    answer: '微鲤AI ofrece calidad comparable y funciona en el navegador sin hardware caro ni instalación.',
                },
            ],
            app_name: '微鲤AI Video Upscaler',
            app_desc: 'AI Video Upscaler gratis para mejorar calidad hasta 4K. Arregla videos borrosos, reduce ruido y restaura metraje antiguo online.',
            featureList: 'Upscaling 4K, Denoise IA, Nitidez de video, Corrección de color',
        },
        removeVideoSubtitles: {
            title: 'Eliminar Subtítulos de Video - Eliminador de Subtítulos IA | 微鲤AI',
            description: 'Elimina subtítulos integrados de videos con tecnología IA. Borra inteligentemente subtítulos y texto codificado de videos mientras preservas la calidad del video. Rápido y fácil de usar.',
            keywords: 'eliminar subtítulos video, eliminador subtítulos, eliminar subtítulos, borrar subtítulos, eliminación subtítulos video, eliminar subtítulos codificados',
            og_title: 'Eliminar Subtítulos de Video - Eliminador de Subtítulos IA | 微鲤AI',
            og_description: 'Elimina subtítulos integrados de videos con tecnología IA. Borra inteligentemente subtítulos y texto codificado de videos mientras preservas la calidad del video. Rápido y fácil de usar.',
            twitter_title: 'Eliminar Subtítulos de Video - Eliminador de Subtítulos IA | 微鲤AI',
            twitter_description: 'Elimina subtítulos integrados de videos con tecnología IA. Borra inteligentemente subtítulos y texto codificado de videos mientras preservas la calidad del video. Rápido y fácil de usar.',
            page: {
                title1: 'Eliminador de Subtítulos IA Gratis',
                title2: '¿Tienes subtítulos “quemados” en el video? El algoritmo inteligente de 微鲤AI detecta y borra automáticamente subtítulos incrustados, letras y texto en pantalla. Pega un enlace o sube un archivo para recuperar un video limpio y sin texto al instante.',
                feature_title1: 'Detección inteligente de texto',
                feature_desc1: 'Sin enmascarar manualmente. La IA identifica automáticamente las áreas de texto (abajo o en cualquier parte) y las separa del fondo.',
                feature_title2: 'In‑painting sin marcas',
                feature_desc2: 'Adiós a los cuadros borrosos. 微鲤AI rellena el área eliminada analizando píxeles cercanos y reconstruye texturas (césped, arena, multitudes) de forma natural.',
                feature_title3: 'Soporte de enlaces y archivos',
                feature_desc3: 'Elimina subtítulos directamente desde enlaces de TikTok, YouTube o Instagram, o sube archivos MP4/MOV. Ideal para reutilizar contenido.',
                faq: [
                    {
                        question: '¿Puedo eliminar subtítulos hardcoded (quemados)?',
                        answer: 'Sí. Esta herramienta está diseñada para subtítulos hardcoded que forman parte de la imagen y no se pueden desactivar. Los borra visualmente.',
                    },
                    {
                        question: '¿Cómo quitar subtítulos de un video de TikTok/YouTube?',
                        answer: 'Copia el enlace del video, pégalo en la pestaña “Video Link” de 微鲤AI y haz clic en “Generate”. La IA eliminará los subtítulos y podrás descargar el video limpio.',
                    },
                    {
                        question: '¿Se eliminará el fondo detrás del texto?',
                        answer: 'No. 微鲤AI usa tecnología de AI In‑painting: borra el texto y “repinta” el fondo para que el video se vea original y completo.',
                    },
                    {
                        question: '¿En qué se diferencia del eliminador de marca de agua?',
                        answer: 'Aunque son similares, el eliminador de subtítulos está optimizado para tiras de texto, letras y captions (normalmente abajo), mientras que el eliminador de marca de agua se centra en logos y sellos.',
                    },
                    {
                        question: '¿Es gratis?',
                        answer: 'Sí, puedes usar las funciones básicas gratis con créditos diarios.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿Puedo eliminar subtítulos hardcoded?',
                    answer: 'Sí. Esta herramienta está diseñada para subtítulos hardcoded que forman parte de la imagen. Los borra visualmente.',
                },
                {
                    question: '¿Cómo quitar captions de un enlace de TikTok?',
                    answer: 'Copia el enlace, pégalo en la pestaña “Video Link” y haz clic en “Generate”. La IA los eliminará automáticamente.',
                },
                {
                    question: '¿Se dañará el fondo detrás del texto?',
                    answer: 'No. 微鲤AI usa AI In‑painting para borrar el texto y reconstruir el fondo de forma inteligente.',
                },
            ],
            app_name: '微鲤AI Eliminador de Subtítulos',
            app_desc: 'Herramienta IA gratis para borrar subtítulos hardcoded, captions y texto de videos. Usa in‑painting para restaurar el fondo sin bloques borrosos.',
            featureList: 'Eliminación de subtítulos hardcoded, Restauración de fondo con IA, Soporte de enlaces de video, Borrador de letras',
        },
        videoBackgroundRemover: {
            title: 'Eliminador de Fondo de Video - Eliminar Fondo de Video con IA | 微鲤AI',
            description: 'Elimina fondos de videos automáticamente con IA. Crea efectos de pantalla verde, aísla sujetos y reemplaza fondos de video fácilmente. Perfecto para creadores de contenido y editores de video.',
            keywords: 'eliminador fondo video, eliminar fondo video, pantalla verde, eliminación fondo IA, borrador fondo video, aislar sujeto video',
            og_title: 'Eliminador de Fondo de Video - Eliminar Fondo de Video con IA | 微鲤AI',
            og_description: 'Elimina fondos de videos automáticamente con IA. Crea efectos de pantalla verde, aísla sujetos y reemplaza fondos de video fácilmente. Perfecto para creadores de contenido y editores de video.',
            twitter_title: 'Eliminador de Fondo de Video - Eliminar Fondo de Video con IA | 微鲤AI',
            twitter_description: 'Elimina fondos de videos automáticamente con IA. Crea efectos de pantalla verde, aísla sujetos y reemplaza fondos de video fácilmente. Perfecto para creadores de contenido y editores de video.',
            page: {
                title1: 'Eliminador de Fondo de Video con IA Gratis',
                title2: '¿Sin pantalla verde? No pasa nada. Sube tu video y nuestra IA detecta el sujeto automáticamente, lo recorta con precisión (incluso cabello) y te permite descargar un video con fondo transparente o reemplazar el fondo por un color sólido al instante.',
                feature_title1: 'Sin pantalla verde',
                feature_desc1: 'Olvídate de estudios caros. La IA separa personas, mascotas y objetos de fondos complejos automáticamente (auto‑rotoscoping).',
                feature_title2: 'Reemplazo por color sólido',
                feature_desc2: 'Ideal para e‑commerce. Cambia el fondo de tu video de producto a blanco puro, negro o colores personalizados con un clic para mejorar conversiones.',
                feature_title3: 'Exportación transparente',
                feature_desc3: 'Descarga con canal alfa (WebM/MOV) y superpón el sujeto en otros videos en Premiere Pro, DaVinci Resolve o CapCut.',
                faq: [
                    {
                        question: '¿Puedo eliminar el fondo sin pantalla verde?',
                        answer: '¡Sí! 微鲤AI usa machine learning avanzado para distinguir el sujeto del fondo, así que puedes eliminar fondos de videos grabados en cualquier lugar.',
                    },
                    {
                        question: '¿Cómo guardo un video con fondo transparente?',
                        answer: 'Tras eliminar el fondo, elige WebM (Transparent) o MOV como formato de salida. El MP4 estándar no soporta transparencia y mostrará fondo negro.',
                    },
                    {
                        question: '¿Puedo cambiar el fondo del video a blanco?',
                        answer: 'Sí. En la configuración, usa el selector “Background Color” para elegir blanco, negro o cualquier color hex. Ideal para videos de producto en Amazon o Shopify.',
                    },
                    {
                        question: '¿Maneja bien el cabello?',
                        answer: 'Sí. Nuestro algoritmo está entrenado para conservar detalles finos como cabello, pelaje y objetos semitransparentes (como gafas).',
                    },
                    {
                        question: '¿Es gratis?',
                        answer: 'Sí, puedes procesar videos gratis con créditos diarios.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿Puedo eliminar el fondo sin pantalla verde?',
                    answer: '¡Sí! 微鲤AI no necesita pantalla verde para separar el sujeto del fondo.',
                },
                {
                    question: '¿Cómo guardo un video con fondo transparente?',
                    answer: 'Elige WebM (Transparent) o MOV como salida. El MP4 estándar no admite transparencia.',
                },
                {
                    question: '¿Puedo cambiar el fondo del video a blanco?',
                    answer: 'Sí. Usa el selector Background Color para elegir blanco, ideal para videos de producto.',
                },
            ],
            app_name: '微鲤AI Eliminador de Fondo de Video',
            app_desc: 'Herramienta IA gratis para eliminar fondos de video sin pantalla verde. Exporta videos transparentes o cambia el fondo a blanco/negro online.',
            featureList: 'Sin pantalla verde, Exportación de video transparente, Cambio de color de fondo, Precisión en cabello',
            step_name: 'Cómo eliminar el fondo de un video en línea',
            step_list: [
                {
                    name: 'Subir video',
                    text: 'Sube tu video (MP4, MOV) al Eliminador de Fondo de 微鲤AI.',
                },
                {
                    name: 'Eliminar fondo',
                    text: 'La IA procesa el video automáticamente. Puedes dejarlo transparente o elegir un nuevo color de fondo.',
                },
                {
                    name: 'Exportar',
                    text: 'Descarga el resultado. Elige WebM/MOV para transparencia o MP4 para fondos sólidos.',
                },
            ],
        },
        aiVideoExtender: {
            title: 'Extensor de Video IA - Extender Duración y Longitud de Video | 微鲤AI',
            description: 'Extiende la longitud del video con tecnología IA. Agrega 5-8 segundos a tus videos sin problemas con múltiples opciones de estilo incluyendo anime, animación 3D, cyberpunk y cómic. Perfecto para creadores de contenido y editores de video.',
            keywords: 'extensor video IA, extender longitud video, extensión duración video, extensión video IA, alargar video, extender tiempo video, herramienta video IA',
            og_title: 'Extensor de Video IA - Extender Duración y Longitud de Video | 微鲤AI',
            og_description: 'Extiende la longitud del video con tecnología IA. Agrega 5-8 segundos a tus videos sin problemas con múltiples opciones de estilo incluyendo anime, animación 3D, cyberpunk y cómic. Perfecto para creadores de contenido y editores de video.',
            twitter_title: 'Extensor de Video IA - Extender Duración y Longitud de Video | 微鲤AI',
            twitter_description: 'Extiende la longitud del video con tecnología IA. Agrega 5-8 segundos a tus videos sin problemas con múltiples opciones de estilo incluyendo anime, animación 3D, cyberpunk y cómic. Perfecto para creadores de contenido y editores de video.',
            page: {
                title1: 'Extensor de Video IA Gratis y Continuación',
                title2: '¿Tu video es demasiado corto? 微鲤AI usa IA generativa para predecir y crear nuevos fotogramas, extendiendo tu clip de forma fluida. También puedes usar prompts para guiar cómo continúa el video o convertir material normal en un slow motion súper suave.',
                feature_title1: 'Extensión generativa inteligente',
                feature_desc1: 'No solo “estires” el video: crea contenido nuevo. Escribe un prompt como “la cámara se aleja” o “el personaje se da la vuelta” y la IA generará los próximos 5–10 segundos coherentes con el estilo original.',
                feature_title2: 'Slow motion ultra suave',
                feature_desc2: 'Convierte videos 30fps en slow motion de alta calidad. 微鲤AI usa interpolación de fotogramas (Frame Interpolation) para insertar frames generados por IA y lograr movimiento fluido sin tirones.',
                feature_title3: 'Bucles perfectos',
                feature_desc3: 'Crea loops infinitos para fondos en redes sociales. La IA analiza el inicio y el final para mezclarlos perfectamente.',
                faq: [
                    {
                        question: '¿Cómo funciona el extensor de video con IA?',
                        answer: 'Usa la tecnología “Generative Outpainting”. La IA analiza los últimos fotogramas de tu video y tu prompt para predecir y generar nuevos frames que continúan lógicamente la acción.',
                    },
                    {
                        question: '¿Puedo controlar lo que pasa en la parte extendida?',
                        answer: '¡Sí! Usa la caja “Prompt” para describir la acción. Por ejemplo, si tu video muestra un coche conduciendo, escribe “el coche entra en un túnel” para guiar la extensión.',
                    },
                    {
                        question: '¿Cuál es la diferencia entre Extensión y Slow Motion?',
                        answer: 'Extensión añade tiempo nuevo generando eventos nuevos (alarga la historia). Slow Motion estira el tiempo existente agregando fotogramas intermedios (hace la acción más lenta). 微鲤AI hace ambos.',
                    },
                    {
                        question: '¿Cuánto puedo extender un video?',
                        answer: 'Puedes extender un clip 5 segundos por vez (según la configuración “Extension Duration”). Puedes repetir el proceso para crear secuencias más largas.',
                    },
                    {
                        question: '¿Es gratis?',
                        answer: 'Sí, 微鲤AI ofrece créditos gratis para probar extensión de video y efectos de slow motion.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿Cómo funciona el extensor de video con IA?',
                    answer: 'Usa “Generative Outpainting”. La IA analiza los últimos fotogramas y tu prompt para generar nuevos frames que continúan la acción.',
                },
                {
                    question: '¿Puedo controlar lo que pasa en la parte extendida?',
                    answer: 'Sí. Usa la caja “Prompt” para describir la acción (p. ej., “el coche entra en un túnel”).',
                },
                {
                    question: '¿Cuál es la diferencia entre Extensión y Slow Motion?',
                    answer: 'Extensión genera eventos nuevos para añadir tiempo; Slow Motion añade fotogramas intermedios para hacer la acción más lenta.',
                },
            ],
            app_name: '微鲤AI Extensor de Video',
            app_desc: 'Herramienta IA gratis para extender videos con relleno generativo y prompts. Incluye slow motion IA (interpolación de fotogramas) y creación de loops.',
            featureList: 'Extensión de video generativa, Continuación guiada por prompt, Slow motion IA, Loop de video',
        },
        videoEffects: {
            title: 'Efectos de Video - Crea Videos Virales con IA | 微鲤AI',
            description: 'Explora efectos de video IA populares en 微鲤AI. Desde Besos IA hasta Baile IA, crea videos virales con solo unos clics.',
            keywords: 'efectos de video IA, videos virales IA, tendencias de video, besos IA, baile IA, generador de video',
        },
        aiDancing: {
            title: 'Generador de Video de Baile IA - Creador de Video de Baile IA Gratuito | 微鲤AI',
            description: 'Usa el Generador de Baile IA de 微鲤AI para crear videos de baile increíbles desde fotos. Soporta múltiples plantillas y estilos de baile, ¡da vida a tus fotos!',
            keywords: 'video de baile IA, generador de baile IA, foto a video, generación de video IA, 微鲤AI, herramientas IA gratuitas',
        },
        aiKissing: {
            title: 'aiKissing | 微鲤AI',
            description: 'Experience aiKissing on 微鲤AI platform.',
            keywords: 'aiKissing, AI, 微鲤AI',
        },
        videoMotionImitation: {
            title: 'Imitación de Movimiento de Video con IA - Da Vida a Fotos Gratis | 微鲤AI',
            description: 'La herramienta de imitación de movimiento de video de 微鲤AI puede integrar personajes de fotos en videos de referencia, reemplazando personajes originales mientras preserva la iluminación y los tonos de la escena para una fusión ambiental perfecta.',
            keywords: 'imitación de movimiento de video IA, dar vida a fotos, herramienta de imitación de movimiento de video IA, 微鲤AI, herramientas IA gratuitas',
            og_title: 'Imitación de Movimiento de Video con IA - Da Vida a Fotos Gratis | 微鲤AI',
            og_description: 'La herramienta de imitación de movimiento de video de 微鲤AI puede integrar personajes de fotos en videos de referencia, reemplazando personajes originales mientras preserva la iluminación y los tonos de la escena para una fusión ambiental perfecta.',
            twitter_title: 'Imitación de Movimiento de Video con IA - Da Vida a Fotos Gratis | 微鲤AI',
            twitter_description: 'La herramienta de imitación de movimiento de video de 微鲤AI puede integrar personajes de fotos en videos de referencia, reemplazando personajes originales mientras preserva la iluminación y los tonos de la escena para una fusión ambiental perfecta.',
            page: {
                title1: 'Generador de Baile IA Gratis y Transferencia de Movimiento',
                title2: '¿Quieres ver a tu personaje de anime favorito bailar como Michael Jackson? ¿O hacer que una foto estática haga un movimiento viral de TikTok? Sube un video de referencia y una imagen del personaje, y nuestra IA transferirá el movimiento con precisión.',
                feature_title1: 'Reemplazo de Personaje en Video',
                feature_desc1: 'Intercambio Real→Anime: Sube un video de una persona bailando o peleando y reemplázala por un personaje 3D, panda o avatar anime, manteniendo el fondo y la iluminación originales.',
                feature_title2: 'Haz Bailar Fotos',
                feature_desc2: 'Anima imágenes estáticas: Da vida a fotos. Sube una foto tuya o de un personaje, elige un video de baile de referencia y mira cómo la foto imita los movimientos. Ideal para contenido viral estilo Viggle.',
                feature_title3: 'Rompe la Pared Dimensional',
                feature_desc3: 'Estilos cruzados: Ya sea convertir una bailarina en chica anime o a un chico karateka en panda, 微鲤AI maneja cuerpos complejos y oclusiones sin problemas.',
                faq: [
                    {
                        question: '¿Cómo hago que una foto baile con IA?',
                        answer: 'Usa el “Move Mode” de 微鲤AI. Sube la foto que quieres animar (Character Image) y un video con los movimientos (Reference Video). Haz clic en Create para transferir el movimiento.',
                    },
                    {
                        question: '¿Cuál es la diferencia entre Move Mode y Replace Mode?',
                        answer: 'Move Mode anima una imagen estática usando el movimiento de un video. Replace Mode reemplaza a la persona dentro de un video existente por un nuevo personaje desde una imagen.',
                    },
                    {
                        question: '¿Puedo usarlo para tendencias de TikTok?',
                        answer: '¡Sí! Es perfecto para retos de TikTok. Puedes hacer que celebridades, personajes anime o amigos hagan bailes de moda sin aprenderlos.',
                    },
                    {
                        question: '¿Funciona con tomas de cuerpo completo?',
                        answer: 'Sí. Para mejores resultados, asegúrate de que tanto el video de referencia como la imagen muestren el cuerpo completo con claridad.',
                    },
                    {
                        question: '¿Es gratis?',
                        answer: 'Sí, puedes crear videos de transferencia de movimiento gratis usando tus créditos diarios.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿Cómo hago que una foto baile con IA?',
                    answer: 'Usa el “Move Mode” de 微鲤AI. Sube la foto que quieres animar (Character Image) y un video con los movimientos (Reference Video). Haz clic en Create para transferir el movimiento.',
                },
                {
                    question: '¿Cuál es la diferencia entre Move Mode y Replace Mode?',
                    answer: 'Move Mode anima una imagen estática usando el movimiento de un video. Replace Mode reemplaza a la persona dentro de un video existente por un nuevo personaje desde una imagen.',
                },
            ],
            app_name: 'Transferencia de Movimiento de Video 微鲤AI',
            app_desc: 'Generador de baile IA y transferencia de movimiento gratis. Haz bailar fotos, anima imágenes estáticas y reemplaza personajes en video online.',
            featureList: 'Generación de baile IA, transferencia de pose corporal, intercambio de personaje en video, animar foto',
            step_name: 'Cómo hacer que una foto baile con IA',
            step_list: [
                {
                    name: 'Sube el video de referencia',
                    text: 'Sube un video que contenga los pasos de baile o el movimiento que quieres copiar.',
                },
                {
                    name: 'Sube la imagen del personaje',
                    text: 'Sube la foto estática de la persona o personaje que quieres animar.',
                },
                {
                    name: 'Selecciona Move Mode',
                    text: 'Elige “Move Mode” y haz clic en Create. La IA hará que la foto realice los movimientos del video.',
                },
            ],
        },
    },
    fr: {
        textToMusic: {
            title: 'Générateur de Musique IA - Créez de la Musique Unique avec 微鲤AI | 微鲤AI',
            description: 'Découvrez le Générateur de Musique IA de 微鲤AI. Créez rapidement de la musique unique et libre de droits adaptée à vos projets grâce à une technologie IA avancée. Parfait pour les créateurs de contenu, développeurs de jeux et passionnés de musique.',
            keywords: 'texte en musique, texte en musique gratuit, IA texte en musique, générateur de musique IA, créateur de chansons IA, paroles en musique, créer musique similaire, création musicale, musique libre de droits, télécharger musique gratuite, 微鲤AI',
        },
        textToVideo: {
            title: 'Générateur IA Texte→Vidéo Gratuit (Veo 3.1, Kling & Sora) | 微鲤AI',
            description: 'Transformez vos prompts en vidéos cinématographiques instantanément avec l’IA Texte→Vidéo de 微鲤AI. Propulsé par Google Veo 3.1, Kling et Sora. Formats 16:9 et 9:16 pris en charge, jusqu’à 8 secondes. Options sans filigrane disponibles.',
            keywords: 'texte vers vidéo IA, générateur vidéo IA, Google Veo 3.1, prompt vers vidéo, Kling AI, Sora, txt2vid, 微鲤AI',
            og_title: 'Générateur IA Texte→Vidéo Gratuit (Veo 3.1, Kling & Sora) | 微鲤AI',
            og_description: 'Transformez vos prompts en vidéos cinématographiques instantanément avec l’IA Texte→Vidéo de 微鲤AI. Propulsé par Google Veo 3.1, Kling et Sora. Formats 16:9 et 9:16 pris en charge, jusqu’à 8 secondes. Options sans filigrane disponibles.',
            twitter_title: 'Générateur IA Texte→Vidéo Gratuit (Veo 3.1, Kling & Sora) | 微鲤AI',
            twitter_description: 'Transformez vos prompts en vidéos cinématographiques instantanément avec l’IA Texte→Vidéo de 微鲤AI. Propulsé par Google Veo 3.1, Kling et Sora. Formats 16:9 et 9:16 pris en charge, jusqu’à 8 secondes. Options sans filigrane disponibles.',
            page: {
                title1: 'Générateur IA Texte→Vidéo gratuit',
                title2: 'Écrivez un prompt et regardez 微鲤AI donner vie à votre idée. Notre outil Texte→Vidéo agrège des modèles de pointe comme Google Veo 3.1 et Kling AI, afin de créer en quelques secondes des vidéos de haute qualité et physiquement cohérentes pour les réseaux (9:16) ou des projets cinématiques (16:9).',
                intro_title: 'Transformez l’imagination en réalité avec l’IA Texte→Vidéo',
                feature_title: 'Fonctionnalités de 微鲤AI Texte→Vidéo',
                faq_title: 'Questions fréquentes sur Texte→Vidéo',
                feature_title1: 'Puissance multi‑modèles',
                feature_desc1: 'Passez de Veo 3.1 pour le réalisme à Kling pour la cohérence du mouvement. Plus besoin de plusieurs abonnements.',
                feature_title2: 'Formats personnalisés',
                feature_desc2: 'Générez des vidéos verticales (9:16) pour TikTok/Reels ou 16:9 pour YouTube directement.',
                feature_title3: 'Durée étendue',
                feature_desc3: 'Créez des vidéos jusqu’à 8 s (ou plus avec extensions) en une seule génération, idéal pour le storytelling.',
                faq: [
                    {
                        question: 'Comment écrire un bon prompt pour texte→vidéo ?',
                        answer: 'Soyez précis : sujet, action, éclairage et angle de caméra. Exemple : « prise de drone cinématographique d’une ville cyberpunk futuriste la nuit, néons, 4K ».',
                    },
                    {
                        question: 'Quel modèle choisir : Google Veo 3.1 ou Kling ?',
                        answer: 'Google Veo 3.1 offre une excellente fidélité visuelle et une bonne adhérence au prompt, idéal pour des scènes réalistes. Kling est souvent meilleur pour des mouvements de personnages complexes. Testez les deux pour trouver le meilleur rendu.',
                    },
                    {
                        question: '微鲤AI Texte→Vidéo est-il gratuit ?',
                        answer: 'Oui. Chaque utilisateur reçoit des crédits gratuits quotidiens pour générer des vidéos à partir de texte.',
                    },
                    {
                        question: 'Puis-je générer des vidéos de plus de 8 secondes ?',
                        answer: 'La génération de base va jusqu’à 8 s (selon le modèle). Pour des vidéos plus longues, utilisez notre outil AI Video Extender pour continuer la séquence de manière fluide.',
                    },
                    {
                        question: 'Les vidéos générées ont-elles du son ?',
                        answer: 'Oui. Activez l’option « Generate Audio » pour générer automatiquement des effets sonores et une ambiance.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Comment écrire un bon prompt pour texte→vidéo ?',
                    answer: 'Décrivez le sujet, l’action, la lumière et la caméra. Exemple : « ville cyberpunk la nuit, néons, drone, 4K ».',
                },
                {
                    question: 'Quel modèle choisir : Google Veo 3.1 ou Kling ?',
                    answer: 'Veo 3.1 est fort en réalisme et adhérence, Kling en mouvement. Essayez les deux.',
                },
                {
                    question: '微鲤AI Texte→Vidéo est-il gratuit ?',
                    answer: 'Oui. Des crédits quotidiens gratuits sont disponibles.',
                },
                {
                    question: 'Puis-je générer des vidéos de plus de 8 secondes ?',
                    answer: 'Base jusqu’à 8 s ; pour plus long, utilisez AI Video Extender.',
                },
                {
                    question: 'Les vidéos générées ont-elles du son ?',
                    answer: 'Oui. Activez « Generate Audio » pour générer l’audio automatiquement.',
                },
            ],
        },
        imageToVideo: {
            title: 'Générateur IA Image→Vidéo (Gratuit & en ligne) - Avec Kling, Veo & Sora',
            description: 'Transformez des photos statiques en vidéos réalistes en quelques secondes avec l’outil Image→Vidéo gratuit de 微鲤AI. Accédez à des modèles de pointe comme Kling, Google Veo et Sora 2 au même endroit. Options sans filigrane disponibles.',
            keywords: 'image en vidéo IA, générateur vidéo IA, animation d’image, vidéo Sora, vidéo Veo, vidéo Seedance, outils vidéo 微鲤AI',
            og_title: 'Générateur IA Image→Vidéo (Gratuit & en ligne) - Avec Kling, Veo & Sora',
            og_description: 'Transformez des photos statiques en vidéos réalistes en quelques secondes avec l’outil Image→Vidéo gratuit de 微鲤AI. Accédez à des modèles de pointe comme Kling, Google Veo et Sora 2 au même endroit. Options sans filigrane disponibles.',
            twitter_title: 'Générateur IA Image→Vidéo (Gratuit & en ligne) - Avec Kling, Veo & Sora',
            twitter_description: 'Transformez des photos statiques en vidéos réalistes en quelques secondes avec l’outil Image→Vidéo gratuit de 微鲤AI. Accédez à des modèles de pointe comme Kling, Google Veo et Sora 2 au même endroit. Options sans filigrane disponibles.',
            page: {
                title1: 'Générateur IA Image→Vidéo gratuit en ligne',
                faq: [
                    {
                        question: 'Comment fonctionne le générateur IA Image→Vidéo ?',
                        answer: 'Il utilise des modèles de deep learning avancés comme Kling et Sora pour analyser votre image statique, prédire le mouvement et générer un clip vidéo cohérent au format MP4.',
                    },
                    {
                        question: '微鲤AI Image→Vidéo est-il gratuit à utiliser ?',
                        answer: 'Oui. Nous offrons des crédits gratuits quotidiens pour essayer notre IA Image→Vidéo. Vous pouvez passer à une offre supérieure pour des modèles premium et des vitesses de génération plus rapides.',
                    },
                    {
                        question: 'Quel modèle est le meilleur pour une vidéo réaliste : Kling ou Veo ?',
                        answer: 'Kling AI est réputé pour des mouvements réalistes et une durée plus longue, tandis que Google Veo excelle dans les détails haute définition. 微鲤AI vous permet de basculer entre eux pour trouver le meilleur rendu.',
                    },
                    {
                        question: 'Puis-je utiliser commercialement les vidéos générées ?',
                        answer: 'Oui. Les vidéos générées avec nos plans payants incluent une licence commerciale, idéale pour YouTube, TikTok et la publicité.',
                    },
                    {
                        question: 'Comment supprimer les filigranes des vidéos IA ?',
                        answer: '微鲤AI fournit des sorties de haute qualité. Pour des vidéos sans filigrane, vérifiez les détails de votre plan ou utilisez notre outil dédié de suppression de filigrane IA.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Comment fonctionne le générateur IA Image→Vidéo ?',
                    answer: 'Il analyse votre image avec des modèles comme Kling et Sora, prédit le mouvement et génère un clip MP4 cohérent.',
                },
                {
                    question: '微鲤AI Image→Vidéo est-il gratuit à utiliser ?',
                    answer: 'Oui. Des crédits gratuits quotidiens sont disponibles pour essayer l’outil. Vous pouvez aussi passer à une offre premium pour plus de vitesse.',
                },
                {
                    question: 'Puis-je utiliser commercialement les vidéos générées ?',
                    answer: 'Oui. Les vidéos générées avec un plan payant incluent une licence commerciale, parfaite pour YouTube, TikTok et le marketing.',
                },
            ],
        },
        videoToVideo: {
            title: 'Générateur IA Vidéo→Vidéo Gratuit - Restyle & Filtre Anime | 微鲤AI',
            description: 'Transformez vos vidéos dans n’importe quel style avec l’IA Vidéo→Vidéo de 微鲤AI. Convertissez des vidéos réelles en anime, cartoons 3D ou art cyberpunk via des prompts texte, tout en gardant un mouvement cohérent. Gratuit et en ligne.',
            keywords: 'vidéo en vidéo IA, vid2vid, transfert de style vidéo IA, transformer vidéo en anime, restyle vidéo IA, filtre vidéo IA gratuit',
            og_title: 'Générateur IA Vidéo→Vidéo Gratuit - Restyle & Filtre Anime | 微鲤AI',
            og_description: 'Transformez vos vidéos dans n’importe quel style avec l’IA Vidéo→Vidéo de 微鲤AI. Convertissez des vidéos réelles en anime, cartoons 3D ou art cyberpunk via des prompts texte, tout en gardant un mouvement cohérent. Gratuit et en ligne.',
            twitter_title: 'Générateur IA Vidéo→Vidéo Gratuit - Restyle & Filtre Anime | 微鲤AI',
            twitter_description: 'Transformez vos vidéos dans n’importe quel style avec l’IA Vidéo→Vidéo de 微鲤AI. Convertissez des vidéos réelles en anime, cartoons 3D ou art cyberpunk via des prompts texte, tout en gardant un mouvement cohérent. Gratuit et en ligne.',
            page: {
                title1: 'Générateur IA Vidéo→Vidéo Gratuit (Vid2Vid)',
                title2: 'Importez une vidéo, tapez un style et regardez la magie opérer. La technologie Vidéo→Vidéo de 微鲤AI analyse le mouvement de votre vidéo source et applique un tout nouveau style artistique selon votre prompt. Parfait pour des edits anime, des effets type claymation, ou des visuels surréalistes.',
                feature_title1: 'Mouvement Cohérent',
                feature_desc1: 'Contrairement à une génération standard, notre moteur Vid2Vid s’accroche au mouvement de la vidéo source pour des transitions fluides sans scintillement.',
                feature_title2: 'Du Réel à l’Anime',
                feature_desc2: 'L’outil n°1 pour les créateurs. Transformez-vous instantanément en personnage anime ou en avatar 3D style Pixar.',
                feature_title3: 'Contrôle par Prompt',
                feature_desc3: 'Vous gardez le contrôle créatif. Tapez simplement « style ville cyberpunk » ou « style peinture à l’huile » pour définir précisément le rendu.',
                faq: [
                    {
                        question: 'Qu’est-ce que l’IA Vidéo→Vidéo (Vid2Vid) ?',
                        answer: 'La Vidéo→Vidéo est un procédé d’IA générative qui prend une vidéo existante en entrée et la « repeint » dans un nouveau style décrit par votre prompt, tout en préservant le mouvement et la structure d’origine.',
                    },
                    {
                        question: 'Puis-je transformer ma vidéo en style anime ?',
                        answer: 'Oui ! C’est le cas d’usage le plus populaire. Importez votre vidéo et utilisez des prompts comme « anime japonais, style Studio Ghibli » pour la transformer.',
                    },
                    {
                        question: 'Quelle longueur pour la vidéo source ?',
                        answer: 'Pour garantir la meilleure qualité, nous supportons surtout des clips courts (par ex. 5–10 secondes). Pour des vidéos plus longues, nous recommandons de les découper en segments.',
                    },
                    {
                        question: 'En quoi est-ce différent d’un éditeur vidéo ?',
                        answer: 'Un éditeur traditionnel coupe et assemble. L’outil Vidéo→Vidéo de 微鲤AI génère de nouveaux pixels et change complètement la texture et le style artistique de vos images.',
                    },
                    {
                        question: 'Est-ce payant ?',
                        answer: '微鲤AI offre des crédits gratuits quotidiens pour essayer Vidéo→Vidéo. Des offres premium existent pour un traitement plus rapide et des téléchargements sans filigrane.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Qu’est-ce que l’IA Vidéo→Vidéo (Vid2Vid) ?',
                    answer: 'Elle « repeint » une vidéo existante dans un nouveau style via un prompt, en conservant mouvement et structure.',
                },
                {
                    question: 'Puis-je transformer ma vidéo en style anime ?',
                    answer: 'Oui. Importez votre vidéo et essayez « anime japonais, style Studio Ghibli ».',
                },
                {
                    question: 'Quelle longueur pour la vidéo source ?',
                    answer: 'Nous recommandons des clips courts (5–10 s) ; pour plus long, découpez en segments.',
                },
                {
                    question: 'En quoi est-ce différent d’un éditeur vidéo ?',
                    answer: 'Un éditeur coupe ; Vid2Vid génère de nouveaux pixels et change le style/texture.',
                },
                {
                    question: 'Est-ce payant ?',
                    answer: 'Crédits gratuits quotidiens disponibles ; premium = plus rapide et sans filigrane.',
                },
            ],
        },
        removeWatermark: {
            title: 'Suppresseur IA de Filigrane Vidéo Gratuit - Supprimez Logos, Texte & Sous‑titres | 微鲤AI',
            description: 'Supprimez facilement filigranes, logos, sous‑titres et dates de vos vidéos avec le Suppresseur de Filigrane IA gratuit de 微鲤AI. Compatible MP4/MOV et liens vidéo. Pas de flou : restauration propre par IA.',
            keywords: 'supprimer filigrane vidéo, gomme vidéo IA, supprimer logo vidéo, supprimer sous-titres, supprimer filigrane TikTok, suppresseur filigrane en ligne gratuit',
            og_title: 'Suppresseur IA de Filigrane Vidéo Gratuit - Supprimez Logos, Texte & Sous‑titres | 微鲤AI',
            og_description: 'Supprimez facilement filigranes, logos, sous‑titres et dates de vos vidéos avec le Suppresseur de Filigrane IA gratuit de 微鲤AI. Compatible MP4/MOV et liens vidéo. Pas de flou : restauration propre par IA.',
            twitter_title: 'Suppresseur IA de Filigrane Vidéo Gratuit - Supprimez Logos, Texte & Sous‑titres | 微鲤AI',
            twitter_description: 'Supprimez facilement filigranes, logos, sous‑titres et dates de vos vidéos avec le Suppresseur de Filigrane IA gratuit de 微鲤AI. Compatible MP4/MOV et liens vidéo. Pas de flou : restauration propre par IA.',
            page: {
                title1: 'Suppresseur IA de Filigrane Vidéo en Ligne (Gratuit)',
                title2: 'Effacez instantanément filigranes, logos, textes superposés et sous‑titres de vos vidéos. Collez un lien ou importez un fichier, sélectionnez la zone et laissez notre IA reconstruire l’arrière‑plan pixel par pixel, sans flouter.',
                click_erase: '1.Effacement en un clic : l’IA détecte et supprime automatiquement les filigranes courants.',
                percision_erase: '2.Effacement de précision : utilisez le pinceau pour enlever manuellement des objets complexes comme des sous‑titres en mouvement ou des horodatages.',
                video_link_title: 'Via un lien',
                direct_link_desc: '1.Suppression par lien direct : collez des liens de réseaux sociaux pour retirer le filigrane sans télécharger la vidéo.',
                lossless_qua_title: '2.Qualité sans perte : contrairement au floutage, 微鲤AI reconstruit le fond en analysant les pixels autour.',
                faq: [
                    {
                        question: 'Comment supprimer un filigrane d’une vidéo en ligne gratuitement ?',
                        answer: 'Importez votre vidéo sur 微鲤AI ou collez un lien. Couvrez le filigrane avec la zone de sélection puis cliquez sur “Generate”. C’est gratuit à essayer.',
                    },
                    {
                        question: 'Puis-je supprimer des sous‑titres ou du texte en mouvement ?',
                        answer: 'Oui. Utilisez le mode “Precision Erase” pour sélectionner la zone. Notre IA suit le filigrane à travers les images pour un retrait propre sur toute la vidéo.',
                    },
                    {
                        question: 'Ça marche pour TikTok ou YouTube ?',
                        answer: 'Oui. Vous pouvez supprimer les logos de plateforme (comme le filigrane animé TikTok) ou les watermarks de chaîne pour obtenir une vidéo propre pour un usage personnel.',
                    },
                    {
                        question: 'La zone supprimée sera‑t‑elle floue ?',
                        answer: 'Non. 微鲤AI utilise un “Video In‑painting” avancé pour remplir la zone avec des textures réalistes générées à partir de la vidéo environnante, sans flou disgracieux.',
                    },
                    {
                        question: 'Quels formats vidéo sont pris en charge ?',
                        answer: 'Nous prenons en charge les formats majeurs, dont MP4, MOV, AVI et WebM.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Comment supprimer un filigrane d’une vidéo en ligne gratuitement ?',
                    answer: 'Importez la vidéo ou collez un lien, sélectionnez le filigrane et cliquez sur “Generate”.',
                },
                {
                    question: 'Puis-je supprimer des sous‑titres ou du texte en mouvement ?',
                    answer: 'Oui. En mode “Precision Erase”, l’IA suit le texte entre les frames pour le retirer partout.',
                },
                {
                    question: 'La zone supprimée sera‑t‑elle floue ?',
                    answer: 'Non. Le Video In‑painting remplit avec des textures réalistes, sans flou.',
                },
            ],
        },
        videoFaceSwap: {
            title: 'Face Swap Vidéo IA Gratuit en Ligne - Deepfake Réaliste | 微鲤AI',
            description: 'Échangez des visages dans des vidéos instantanément avec l’IA Face Swapper de 微鲤AI. Créez des clips drôles, des mèmes et des deepfakes réalistes gratuitement. Options sans filigrane disponibles. 100% privé et sécurisé.',
            keywords: 'face swap vidéo, échange de visage IA, générateur deepfake gratuit, remplacer visage vidéo, face swap film, reface en ligne, mème IA',
            og_title: 'Face Swap Vidéo IA Gratuit en Ligne - Deepfake Réaliste | 微鲤AI',
            og_description: 'Échangez des visages dans des vidéos instantanément avec l’IA Face Swapper de 微鲤AI. Créez des clips drôles, des mèmes et des deepfakes réalistes gratuitement. Options sans filigrane disponibles. 100% privé et sécurisé.',
            twitter_title: 'Face Swap Vidéo IA Gratuit en Ligne - Deepfake Réaliste | 微鲤AI',
            twitter_description: 'Échangez des visages dans des vidéos instantanément avec l’IA Face Swapper de 微鲤AI. Créez des clips drôles, des mèmes et des deepfakes réalistes gratuitement. Options sans filigrane disponibles. 100% privé et sécurisé.',
            page: {
                title1: 'Face Swap Vidéo IA Gratuit',
                title2: 'Devenez la star de n’importe quel film ! Importez un clip vidéo et une photo du visage cible, et laissez l’IA échanger les visages de manière fluide. Parfait pour des mèmes hilarants, des messages personnalisés ou des effets visuels pro avec une grande fidélité.',
                feature_title1: 'Deepfake Hyper‑Réaliste',
                feature_desc1: 'L’IA analyse la géométrie du visage et l’éclairage pour intégrer le nouveau visage naturellement, tout en conservant expressions et mouvements.',
                feature_title2: 'Confidentialité d’abord',
                feature_desc2: 'Nous priorisons votre vie privée. Les vidéos et images importées sont traitées de manière sécurisée et supprimées peu après la génération.',
                feature_title3: 'Aucune Compétence Technique',
                feature_desc3: 'Pas besoin de logiciels complexes comme After Effects. Cliquez sur “Create” et obtenez un rendu niveau Hollywood en quelques secondes.',
                faq: [
                    {
                        question: 'Le Face Swap Vidéo 微鲤AI est‑il gratuit ?',
                        answer: 'Oui. Nous offrons des crédits gratuits pour essayer l’échange de visage vidéo en ligne. Aucune carte bancaire n’est nécessaire pour commencer.',
                    },
                    {
                        question: 'Est‑ce sûr d’importer mes photos ?',
                        answer: 'Absolument. Nous appliquons des protocoles stricts de protection des données. Vos vidéos et images ne servent qu’à la génération et ne sont pas stockées de façon permanente.',
                    },
                    {
                        question: 'Puis‑je faire un face swap sur des GIFs ?',
                        answer: 'Oui ! 微鲤AI prend en charge les vidéos (MP4/MOV) et les GIF. Vous pouvez créer facilement des GIFs de réaction personnalisés.',
                    },
                    {
                        question: 'Comment obtenir les meilleurs résultats ?',
                        answer: 'Utilisez une photo du visage cible nette, de face et bien éclairée. Évitez les visages cachés par des cheveux ou des lunettes.',
                    },
                    {
                        question: 'Puis‑je l’utiliser pour des projets commerciaux ?',
                        answer: 'Oui, mais assurez‑vous d’avoir les droits sur la vidéo source et l’autorisation d’utiliser l’image de la personne.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Le Face Swap Vidéo 微鲤AI est‑il gratuit ?',
                    answer: 'Oui. Des crédits gratuits sont disponibles et aucune carte n’est requise.',
                },
                {
                    question: 'Est‑ce sûr d’importer mes photos ?',
                    answer: 'Oui. Elles sont utilisées uniquement pour la génération et ne sont pas stockées durablement.',
                },
                {
                    question: 'Comment obtenir les meilleurs résultats ?',
                    answer: 'Choisissez une photo nette, de face et bien éclairée, sans cheveux ni lunettes qui cachent le visage.',
                },
            ],
        },
        videoLipSync: {
            title: 'Générateur gratuit de lip sync vidéo IA - Synchronisez audio & texte à la vidéo | 微鲤AI',
            description: 'Synchronisez parfaitement les mouvements des lèvres avec n’importe quel audio ou texte grâce à l’outil IA Lip Sync de 微鲤AI. Propulsé par Kling AI. Idéal pour la traduction vidéo, le doublage et les avatars parlants. Gratuit & en ligne.',
            keywords: 'synchronisation labiale vidéo, synchronisation labiale, synchronisation labiale IA, doublage vidéo, synchronisation voix, vidéo parlante, outil synchronisation labiale',
            og_title: 'Générateur gratuit de lip sync vidéo IA - Synchronisez audio & texte à la vidéo | 微鲤AI',
            og_description: 'Synchronisez parfaitement les mouvements des lèvres avec n’importe quel audio ou texte grâce à l’outil IA Lip Sync de 微鲤AI. Propulsé par Kling AI. Idéal pour la traduction vidéo, le doublage et les avatars parlants. Gratuit & en ligne.',
            twitter_title: 'Générateur gratuit de lip sync vidéo IA - Synchronisez audio & texte à la vidéo | 微鲤AI',
            twitter_description: 'Synchronisez parfaitement les mouvements des lèvres avec n’importe quel audio ou texte grâce à l’outil IA Lip Sync de 微鲤AI. Propulsé par Kling AI. Idéal pour la traduction vidéo, le doublage et les avatars parlants. Gratuit & en ligne.',
            page: {
                title1: 'Outil gratuit de lip sync & doublage IA',
                title2: 'Fini les doublages maladroits. Importez une vidéo et un fichier audio (ou saisissez un texte) et notre IA régénère les mouvements des lèvres pour correspondre parfaitement au son. Propulsé par Kling AI, il prend en charge le doublage multilingue et des ajustements faciaux réalistes.',
                dual_input_modes: 'Double mode d’entrée',
                audio_sync: 'Synchronisation audio',
                text_sync: 'Synthèse vocale',
                text_sync_tip: 'Saisissez n’importe quel texte, choisissez une voix IA prédéfinie et faites parler le personnage instantanément.',
                audio_sync_tip: 'Importez votre voix off ou une chanson à synchroniser.',
                feature_title1: 'Doublage multilingue',
                feature_desc1: 'Élargissez votre audience. Traduisez votre vidéo en espagnol, français ou japonais, puis synchronisez les lèvres pour un rendu naturel, comme un locuteur natif.',
                feature_title2: 'Précision Kling AI',
                feature_desc2: 'Contrairement aux outils Wav2Lip basiques, nous utilisons le modèle Kling pour garantir des mouvements des dents, de la langue et de la mâchoire anatomiquement corrects.',
                faq: [
                    {
                        question: 'Comment synchroniser les lèvres avec l’audio d’une vidéo ?',
                        answer: 'Importez votre clip vidéo sur 微鲤AI. Puis importez un fichier audio (MP3/WAV) ou saisissez un texte pour générer une voix IA. Cliquez sur "Create" et notre IA ajustera les mouvements de la bouche au son.',
                    },
                    {
                        question: 'Puis‑je l’utiliser pour la traduction/le doublage vidéo ?',
                        answer: 'Oui ! C’est l’outil idéal pour le doublage. Importez une piste audio traduite et l’IA corrigera le lip sync pour un rendu naturel.',
                    },
                    {
                        question: 'Est‑ce que ça marche avec des images fixes (têtes parlantes) ?',
                        answer: 'Oui. Si vous importez un portrait statique comme source “vidéo”, l’outil l’animera en vidéo de tête parlante (effet Live Portrait).',
                    },
                    {
                        question: 'Quelles langues sont prises en charge ?',
                        answer: 'Comme la technologie analyse les ondes audio, elle fonctionne avec n’importe quelle langue (anglais, espagnol, chinois, hindi, etc.). Pour l’entrée Synthèse vocale, nous prenons en charge 50+ langues.',
                    },
                    {
                        question: 'Le lip sync est‑il gratuit ?',
                        answer: '微鲤AI offre des crédits gratuits quotidiens pour tester la fonctionnalité Lip Sync. Pour les vidéos longues ou un usage commercial, des offres premium sont disponibles.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Comment synchroniser les lèvres avec l’audio d’une vidéo ?',
                    answer: 'Importez votre clip vidéo sur 微鲤AI. Puis importez un fichier audio (MP3/WAV) ou saisissez un texte pour générer une voix IA. Cliquez sur "Create" et notre IA ajustera les mouvements de la bouche au son.',
                },
                {
                    question: 'Puis‑je l’utiliser pour la traduction/le doublage vidéo ?',
                    answer: 'Oui ! C’est l’outil idéal pour le doublage. Importez une piste audio traduite et l’IA corrigera le lip sync pour un rendu naturel.',
                },
                {
                    question: 'Est‑ce que ça marche avec des images fixes (têtes parlantes) ?',
                    answer: 'Oui. Si vous importez un portrait statique comme source “vidéo”, l’outil l’animera en vidéo de tête parlante (effet Live Portrait).',
                },
            ],
        },
        translateVideoSubtitle: {
            title: 'Traducteur de sous-titres vidéo IA gratuit - Générer & traduire en ligne | 微鲤AI',
            description: 'Générez et traduisez automatiquement des sous-titres vidéo avec le traducteur IA de 微鲤AI. Compatible avec l’anglais, l’espagnol, le chinois et 90+ langues. Téléchargez instantanément des vidéos avec sous-titres incrustés (hardsubs).',
            keywords: 'traduction de sous-titres IA, traducteur de sous-titres vidéo, sous-titres multilingues, traduction vidéo, convertisseur de sous-titres, traduction vidéo IA',
            og_title: 'Traducteur de sous-titres vidéo IA gratuit - Générer & traduire en ligne | 微鲤AI',
            og_description: 'Générez et traduisez automatiquement des sous-titres vidéo avec le traducteur IA de 微鲤AI. Compatible avec l’anglais, l’espagnol, le chinois et 90+ langues. Téléchargez instantanément des vidéos avec sous-titres incrustés (hardsubs).',
            twitter_title: 'Traducteur de sous-titres vidéo IA gratuit - Générer & traduire en ligne | 微鲤AI',
            twitter_description: 'Générez et traduisez automatiquement des sous-titres vidéo avec le traducteur IA de 微鲤AI. Compatible avec l’anglais, l’espagnol, le chinois et 90+ langues. Téléchargez instantanément des vidéos avec sous-titres incrustés (hardsubs).',
            page: {
                title1: 'Traducteur de sous-titres vidéo IA gratuit',
                title2: 'Brisez la barrière linguistique instantanément. Importez votre vidéo, choisissez votre langue cible et laissez l’IA reconnaître la parole, transcrire l’audio et incruster des sous-titres traduits et précis directement dans votre fichier vidéo.',
                feature_title1: '90+ langues prises en charge',
                feature_desc1: 'Traduisez votre contenu de l’anglais vers l’espagnol, le français, l’allemand, le japonais, le chinois, etc. Touchez une audience mondiale en un clic.',
                feature_title2: 'Auto‑synchronisation & incrustation',
                feature_desc2: 'Plus besoin d’ajuster les timecodes. Notre IA synchronise parfaitement les sous‑titres avec l’audio et les incruste dans la vidéo (hardsubs) pour une compatibilité maximale.',
                feature_title3: 'Précision basée sur le contexte',
                feature_desc3: 'Propulsé par des LLM avancés, 微鲤AI comprend le contexte et l’argot pour des traductions naturelles et précises, pas des traductions littérales.',
                faq: [
                    {
                        question: 'Comment traduire automatiquement des sous-titres vidéo ?',
                        answer: 'Importez votre vidéo sur 微鲤AI, sélectionnez la “Target Language” (ex. anglais→espagnol), puis cliquez sur “Create”. L’IA générera et traduira les sous‑titres automatiquement.',
                    },
                    {
                        question: 'Quelles langues sont prises en charge ?',
                        answer: 'Nous prenons en charge plus de 90 langues, dont l’anglais, l’espagnol, le français, l’allemand, le portugais, l’hindi, le japonais et le chinois.',
                    },
                    {
                        question: 'Le traducteur de sous-titres est-il gratuit ?',
                        answer: 'Oui. 微鲤AI offre un accès gratuit à notre traducteur de sous‑titres vidéo IA. Vous pouvez traiter des vidéos sans payer des services de transcription coûteux.',
                    },
                    {
                        question: 'Dois-je télécharger un fichier SRT ?',
                        answer: 'Non. 微鲤AI génère des vidéos avec sous‑titres incrustés (hardsubs) : le texte fait partie de la vidéo. Cela garantit un affichage correct sur TikTok, Instagram et YouTube.',
                    },
                    {
                        question: 'Quelle est la précision de la traduction ?',
                        answer: 'Nous utilisons des modèles de reconnaissance vocale de pointe pour une grande précision. Avec un audio clair, la précision peut dépasser 95%.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Comment traduire automatiquement des sous-titres vidéo ?',
                    answer: 'Importez votre vidéo sur 微鲤AI, sélectionnez la Target Language, puis cliquez sur Create. L’IA générera et traduira les sous‑titres automatiquement.',
                },
                {
                    question: 'Quelles langues sont prises en charge ?',
                    answer: 'Nous prenons en charge plus de 90 langues, dont l’anglais, l’espagnol, le français, l’allemand, le portugais, l’hindi, le japonais et le chinois.',
                },
                {
                    question: 'Dois-je télécharger un fichier SRT ?',
                    answer: 'Non. 微鲤AI produit des vidéos avec sous‑titres incrustés (hardsubs), affichés correctement sur toutes les plateformes.',
                },
            ],
        },
        videoToAnime: {
            title: 'Convertisseur IA Vidéo→Anime Gratuit - Du réel au cartoon & Pixar | 微鲤AI',
            description: 'Transformez instantanément vos vidéos en anime japonais, style Pixar 3D ou cartoons avec le Convertisseur Vidéo→Anime de 微鲤AI. Stabilité image par image pour une animation fluide. Gratuit et en ligne.',
            keywords: 'vidéo en anime, filtre anime IA, convertir vidéo en cartoon, filtre pixar vidéo, réel vers anime, alternative domoai, générateur anime',
            og_title: 'Convertisseur IA Vidéo→Anime Gratuit - Du réel au cartoon & Pixar | 微鲤AI',
            og_description: 'Transformez instantanément vos vidéos en anime japonais, style Pixar 3D ou cartoons avec le Convertisseur Vidéo→Anime de 微鲤AI. Stabilité image par image pour une animation fluide. Gratuit et en ligne.',
            twitter_title: 'Convertisseur IA Vidéo→Anime Gratuit - Du réel au cartoon & Pixar | 微鲤AI',
            twitter_description: 'Transformez instantanément vos vidéos en anime japonais, style Pixar 3D ou cartoons avec le Convertisseur Vidéo→Anime de 微鲤AI. Stabilité image par image pour une animation fluide. Gratuit et en ligne.',
            page: {
                title1: 'Convertisseur IA Vidéo→Anime gratuit',
                title2: 'Devenez un héros d’anime en un clic. Importez une vidéo réelle, choisissez un style (Pixar 3D, 2D classique ou dessin à la main) et laissez notre IA restyler votre séquence image par image tout en gardant un mouvement fluide et cohérent.',
                feature_desc1: '<div><p>Pixar & 3D : créez des clips animés mignons, style Disney, parfaits pour des vidéos familiales.</p><p>Anime classique : obtenez un vrai rendu d’animation japonaise (style Ghibli/Shinkai).</p><p>Sketch & Ink : transformez vos vidéos en animations artistiques au crayon.</p></div>',
                feature_title2: 'Stabilité image par image',
                feature_desc2: 'Marre des vidéos IA qui scintillent ? 微鲤AI utilise des algorithmes avancés de cohérence temporelle pour que votre vidéo anime soit fluide, sans les “saccades” courantes.',
                feature_title3: 'Créateur de contenu viral',
                feature_desc3: 'Pensé pour TikTok et Reels. Créez des comparatifs tendance “Réel vs Anime” qui captent l’attention instantanément.',
                faq: [
                    {
                        question: 'Comment transformer une vidéo en anime gratuitement ?',
                        answer: 'Importez votre clip dans l’outil Vidéo→Anime de 微鲤AI. Choisissez un preset (ex. “2D Style” ou “Pixar Style”) puis cliquez sur Create. C’est gratuit à tester avec les crédits quotidiens.',
                    },
                    {
                        question: 'Puis-je convertir une vidéo en style Pixar/Disney ?',
                        answer: 'Oui ! Nous proposons un preset “3D Cartoon” ou “Pixar Style” qui transforme des personnes réelles en personnages 3D adorables.',
                    },
                    {
                        question: 'Quelle peut être la durée de la vidéo ?',
                        answer: 'Actuellement, nous prenons en charge des clips jusqu’à 30 secondes (voir “Maximum video duration: 30s”). Idéal pour Shorts, Reels et TikTok.',
                    },
                    {
                        question: 'Le personnage anime bougera-t-il comme moi ?',
                        answer: 'Oui. Notre IA analyse vos mouvements et expressions pour que le personnage imite vos actions le plus fidèlement possible.',
                    },
                    {
                        question: 'Quel est le meilleur convertisseur vidéo→anime ?',
                        answer: '微鲤AI est souvent choisi pour ses styles 2D/3D et sa priorité donnée à la stabilité afin de réduire le bruit visuel et le scintillement.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Comment transformer une vidéo en anime gratuitement ?',
                    answer: 'Importez votre vidéo sur 微鲤AI, choisissez un preset (2D Style ou Pixar Style) puis cliquez sur Create.',
                },
                {
                    question: 'Puis-je convertir une vidéo en style Pixar/Disney ?',
                    answer: 'Oui. Nous proposons un preset 3D Cartoon/Pixar Style pour transformer des personnes réelles en personnages 3D.',
                },
                {
                    question: 'Le personnage anime bougera-t-il comme moi ?',
                    answer: 'Oui. L’IA analyse vos mouvements et expressions pour imiter vos actions.',
                },
            ],
            app_name: '微鲤AI Convertisseur Vidéo→Anime',
            app_desc: 'Outil IA gratuit pour convertir des vidéos réelles en anime, cartoon et style Pixar. Rendu image par image pour une animation stable.',
            featureList: 'Réel→Anime, Filtre Pixar, Cohérence temporelle, Styles 2D/3D',
        },
        videoUpscaler: {
            title: 'AI Video Upscaler gratuit - Améliorez en 4K en ligne | 微鲤AI',
            description: 'Améliorez instantanément des vidéos basse résolution en 1080p, 2K et 4K avec l’AI Video Upscaler gratuit de 微鲤AI. Corrige la pixellisation, réduit le bruit et améliore la qualité en ligne, sans installer de logiciel.',
            keywords: 'video upscaler, amélioration vidéo IA, upscaler vidéo 4k, déflouter vidéo, réduction de bruit vidéo, améliorer qualité vidéo, upscaler vidéo gratuit en ligne',
            og_title: 'AI Video Upscaler gratuit - Améliorez en 4K en ligne | 微鲤AI',
            og_description: 'Améliorez instantanément des vidéos basse résolution en 1080p, 2K et 4K avec l’AI Video Upscaler gratuit de 微鲤AI. Corrige la pixellisation, réduit le bruit et améliore la qualité en ligne, sans installer de logiciel.',
            twitter_title: 'AI Video Upscaler gratuit - Améliorez en 4K en ligne | 微鲤AI',
            twitter_description: 'Améliorez instantanément des vidéos basse résolution en 1080p, 2K et 4K avec l’AI Video Upscaler gratuit de 微鲤AI. Corrige la pixellisation, réduit le bruit et améliore la qualité en ligne, sans installer de logiciel.',
            page: {
                title1: 'AI Video Upscaler & Enhancer gratuit',
                title2: 'Ne vous contentez pas d’images floues et pixellisées. Importez vos vidéos basse résolution (360p, 480p, 720p) et laissez notre IA les upscaler automatiquement en 4K. Notre moteur augmente la taille, restaure les détails, supprime le bruit et corrige les couleurs.',
                feature_title1: 'Upscale en 4K',
                feature_desc1: 'Redonnez vie aux anciennes vidéos. Convertissez du SD en HD ou 4K en un clic, net sur les grands écrans modernes.',
                feature_title2: 'Corriger vidéos floues & granuleuses',
                feature_desc2: 'Tourné en basse lumière ? Notre algorithme de débruitage IA supprime le grain et les artefacts de compression pour un rendu propre et pro.',
                feature_title3: 'Restauration d’archives',
                feature_desc3: 'Parfait pour les archives familiales. Restaurez les couleurs ternes et renforcez les détails sur de vieux films maison ou clips vintage.',
                faq: [
                    {
                        question: 'Puis‑je upscaler une vidéo en 4K en ligne gratuitement ?',
                        answer: 'Oui. 微鲤AI permet de sélectionner une sortie jusqu’à 4K (voir options). Vous pouvez tester gratuitement avec des crédits quotidiens.',
                    },
                    {
                        question: 'Comment corriger une vidéo floue ?',
                        answer: 'Importez simplement la vidéo floue dans notre AI Video Upscaler. L’IA analyse les pixels perdus et reconstruit les détails pour réduire le flou.',
                    },
                    {
                        question: 'Ça marche sur de vieilles vidéos de téléphone ?',
                        answer: 'Oui. C’est même idéal pour des vidéos 360p/480p issues d’anciens téléphones ou caméras, transformées en 1080p ou plus.',
                    },
                    {
                        question: 'Combien de temps prend l’upscaling ?',
                        answer: 'L’upscaling est coûteux en calcul. Mais 微鲤AI utilise des GPU cloud optimisés. Un clip court prend généralement quelques minutes.',
                    },
                    {
                        question: 'Est‑ce mieux que Topaz Video AI ?',
                        answer: '微鲤AI offre une qualité IA comparable et fonctionne entièrement dans le navigateur, sans matériel coûteux ni installation.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Puis‑je upscaler une vidéo en 4K en ligne ?',
                    answer: 'Oui. 微鲤AI permet une sortie jusqu’à 4K, testable gratuitement avec des crédits quotidiens.',
                },
                {
                    question: 'Comment corriger une vidéo floue ?',
                    answer: 'Importez la vidéo dans l’AI Video Upscaler : l’IA reconstruit les détails pour réduire le flou.',
                },
                {
                    question: 'Est‑ce mieux que Topaz Video AI ?',
                    answer: '微鲤AI offre une qualité comparable et fonctionne dans le navigateur, sans hardware cher ni installation.',
                },
            ],
            app_name: '微鲤AI Video Upscaler',
            app_desc: 'AI Video Upscaler gratuit pour améliorer la qualité jusqu’à 4K. Corrige le flou, réduit le bruit et restaure les anciennes vidéos en ligne.',
            featureList: 'Upscaling 4K, Débruitage IA, Netteté vidéo, Correction colorimétrique',
        },
        removeVideoSubtitles: {
            title: 'Supprimer Sous-titres Vidéo - Suppresseur de Sous-titres IA | 微鲤AI',
            description: 'Supprimez les sous-titres intégrés des vidéos avec la technologie IA. Effacez intelligemment les sous-titres et texte codés des vidéos tout en préservant la qualité vidéo. Rapide et facile à utiliser.',
            keywords: 'supprimer sous-titres vidéo, suppresseur sous-titres, supprimer sous-titres, effacer sous-titres, suppression sous-titres vidéo, supprimer sous-titres codés',
            og_title: 'Supprimer Sous-titres Vidéo - Suppresseur de Sous-titres IA | 微鲤AI',
            og_description: 'Supprimez les sous-titres intégrés des vidéos avec la technologie IA. Effacez intelligemment les sous-titres et texte codés des vidéos tout en préservant la qualité vidéo. Rapide et facile à utiliser.',
            twitter_title: 'Supprimer Sous-titres Vidéo - Suppresseur de Sous-titres IA | 微鲤AI',
            twitter_description: 'Supprimez les sous-titres intégrés des vidéos avec la technologie IA. Effacez intelligemment les sous-titres et texte codés des vidéos tout en préservant la qualité vidéo. Rapide et facile à utiliser.',
            page: {
                title1: 'Suppresseur IA de sous-titres (gratuit)',
                title2: 'Des sous-titres “incrustés” gênants ? L’algorithme intelligent de 微鲤AI détecte et efface automatiquement les sous‑titres hardcodés, les paroles et le texte à l’écran. Collez un lien ou importez un fichier pour retrouver une vidéo propre, sans texte, en quelques instants.',
                feature_title1: 'Détection intelligente du texte',
                feature_desc1: 'Pas de masquage manuel. L’IA repère automatiquement les zones de texte en bas (ou ailleurs) et les sépare de l’arrière‑plan.',
                feature_title2: 'In‑painting naturel',
                feature_desc2: 'Fini les rectangles flous. 微鲤AI remplit la zone effacée en analysant les pixels voisins et reconstruit naturellement les textures (herbe, sable, foule…).',
                feature_title3: 'Liens & fichiers pris en charge',
                feature_desc3: 'Supprimez les sous‑titres depuis des liens TikTok/YouTube/Instagram, ou importez des fichiers MP4/MOV. Idéal pour le repurposing de contenu.',
                faq: [
                    {
                        question: 'Puis‑je supprimer des sous‑titres hardcodés (incrustés) ?',
                        answer: 'Oui. Cet outil est conçu pour les sous‑titres hardcodés intégrés à l’image et impossibles à désactiver. Il les efface visuellement.',
                    },
                    {
                        question: 'Comment enlever les sous‑titres d’une vidéo TikTok/YouTube ?',
                        answer: 'Copiez le lien, collez‑le dans l’onglet “Video Link” sur 微鲤AI puis cliquez sur “Generate”. L’IA supprimera les sous‑titres et vous pourrez télécharger la vidéo propre.',
                    },
                    {
                        question: 'Est‑ce que l’arrière‑plan derrière le texte sera supprimé ?',
                        answer: 'Non. 微鲤AI utilise l’AI In‑painting : il supprime le texte puis “repeint” l’arrière‑plan pour que la vidéo paraisse originale et complète.',
                    },
                    {
                        question: 'Quelle différence avec le suppresseur de filigrane ?',
                        answer: 'C’est proche, mais le Suppresseur de sous‑titres est optimisé pour les bandes de texte, paroles et captions (souvent en bas), tandis que le Suppresseur de filigrane vise surtout les logos et tampons.',
                    },
                    {
                        question: 'Est‑ce gratuit ?',
                        answer: 'Oui, vous pouvez utiliser les fonctions de base gratuitement avec des crédits quotidiens.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Puis‑je supprimer des sous‑titres hardcodés ?',
                    answer: 'Oui. Cet outil est conçu pour les sous‑titres intégrés à l’image. Il les efface visuellement.',
                },
                {
                    question: 'Comment enlever des captions via un lien TikTok ?',
                    answer: 'Copiez le lien, collez‑le dans l’onglet “Video Link”, puis cliquez sur “Generate”. L’IA supprimera automatiquement les captions.',
                },
                {
                    question: 'L’arrière‑plan derrière le texte sera‑t‑il abîmé ?',
                    answer: 'Non. 微鲤AI utilise l’AI In‑painting pour supprimer le texte et reconstruire l’arrière‑plan intelligemment.',
                },
            ],
            app_name: '微鲤AI Suppresseur de sous‑titres',
            app_desc: 'Outil IA gratuit pour effacer les sous‑titres hardcodés, captions et texte dans les vidéos. Restaure l’arrière‑plan via in‑painting, sans blocs flous.',
            featureList: 'Suppression de sous‑titres hardcodés, Restauration d’arrière‑plan IA, Support des liens vidéo, Gomme à paroles',
        },
        videoBackgroundRemover: {
            title: 'Suppresseur de Fond Vidéo - Supprimer Fond Vidéo avec IA | 微鲤AI',
            description: `Supprimez automatiquement les fonds des vidéos avec l'IA. Créez des effets d'écran vert, isolez les sujets et remplacez facilement les fonds vidéo. Parfait pour les créateurs de contenu et éditeurs vidéo.`,
            keywords: 'suppresseur fond vidéo, supprimer fond vidéo, écran vert, suppression fond IA, gomme fond vidéo, isoler sujet vidéo',
            og_title: 'Suppresseur de Fond Vidéo - Supprimer Fond Vidéo avec IA | 微鲤AI',
            og_description: `Supprimez automatiquement les fonds des vidéos avec l'IA. Créez des effets d'écran vert, isolez les sujets et remplacez facilement les fonds vidéo. Parfait pour les créateurs de contenu et éditeurs vidéo.`,
            twitter_title: 'Suppresseur de Fond Vidéo - Supprimer Fond Vidéo avec IA | 微鲤AI',
            twitter_description: `Supprimez automatiquement les fonds des vidéos avec l'IA. Créez des effets d'écran vert, isolez les sujets et remplacez facilement les fonds vidéo. Parfait pour les créateurs de contenu et éditeurs vidéo.`,
            page: {
                title1: 'Suppresseur IA de fond vidéo (gratuit)',
                title2: 'Pas de fond vert ? Aucun problème. Importez votre vidéo : notre IA détecte automatiquement le sujet, le détoure avec une précision “cheveux” et vous permet de télécharger une vidéo transparente ou de remplacer le fond par une couleur unie instantanément.',
                feature_title1: 'Sans fond vert',
                feature_desc1: 'Oubliez les setups studio coûteux. L’IA sépare automatiquement humains, animaux et objets d’arrière‑plans complexes (auto‑rotoscoping).',
                feature_title2: 'Remplacement par couleur unie',
                feature_desc2: 'Parfait pour l’e‑commerce. Passez le fond de vos vidéos produit en blanc pur, noir ou couleur personnalisée en un clic pour booster la conversion.',
                feature_title3: 'Export transparent',
                feature_desc3: 'Téléchargez avec canal alpha (WebM/MOV) et superposez facilement le sujet sur d’autres vidéos dans Premiere Pro, DaVinci Resolve ou CapCut.',
                faq: [
                    {
                        question: 'Puis‑je supprimer le fond vidéo sans écran vert ?',
                        answer: 'Oui ! 微鲤AI utilise du machine learning avancé pour distinguer le sujet du fond, vous pouvez donc supprimer le fond de vidéos tournées n’importe où.',
                    },
                    {
                        question: 'Comment enregistrer une vidéo avec fond transparent ?',
                        answer: 'Après suppression du fond, choisissez WebM (Transparent) ou MOV en sortie. Le MP4 standard ne gère pas la transparence et affichera un fond noir.',
                    },
                    {
                        question: 'Puis‑je mettre le fond en blanc ?',
                        answer: 'Oui. Dans les réglages, utilisez le sélecteur “Background Color” pour choisir blanc, noir ou un code hex. Idéal pour les vidéos produit Amazon/Shopify.',
                    },
                    {
                        question: 'Gère‑t‑il bien les cheveux ?',
                        answer: 'Oui. L’algorithme est entraîné pour préserver les contours complexes (cheveux, fourrure) et les objets semi‑transparents (comme des lunettes).',
                    },
                    {
                        question: 'Est‑ce gratuit ?',
                        answer: 'Oui, vous pouvez traiter des vidéos gratuitement avec des crédits quotidiens.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Puis‑je supprimer le fond vidéo sans écran vert ?',
                    answer: 'Oui ! 微鲤AI n’a pas besoin d’un écran vert pour séparer le sujet du fond.',
                },
                {
                    question: 'Comment enregistrer une vidéo avec fond transparent ?',
                    answer: 'Choisissez WebM (Transparent) ou MOV. Le MP4 standard ne supporte pas la transparence.',
                },
                {
                    question: 'Puis‑je mettre le fond en blanc ?',
                    answer: 'Oui. Utilisez le sélecteur Background Color pour choisir blanc, idéal pour l’e‑commerce.',
                },
            ],
            app_name: '微鲤AI Suppresseur de fond vidéo',
            app_desc: 'Outil IA gratuit pour supprimer le fond d’une vidéo sans écran vert. Export transparent ou changement du fond en blanc/noir en ligne.',
            featureList: 'Sans écran vert, Export vidéo transparent, Changement de couleur de fond, Précision cheveux',
            step_name: 'Comment supprimer un fond vidéo en ligne',
            step_list: [
                {
                    name: 'Importer la vidéo',
                    text: 'Importez votre vidéo (MP4, MOV) dans le Suppresseur de fond de 微鲤AI.',
                },
                {
                    name: 'Supprimer le fond',
                    text: 'L’IA traite automatiquement la vidéo. Vous pouvez la laisser transparente ou choisir une nouvelle couleur de fond.',
                },
                {
                    name: 'Exporter',
                    text: 'Téléchargez le résultat. Choisissez WebM/MOV pour la transparence ou MP4 pour un fond uni.',
                },
            ],
        },
        aiVideoExtender: {
            title: 'Extension Vidéo IA - Prolonger la Durée et Longueur de Vidéo | 微鲤AI',
            description: 'Prolongez la durée des vidéos avec la technologie IA. Ajoutez 5 à 8 secondes à vos vidéos de manière transparente avec plusieurs options de style incluant anime, animation 3D, cyberpunk et bande dessinée. Parfait pour les créateurs de contenu et éditeurs vidéo.',
            keywords: 'extension vidéo IA, prolonger longueur vidéo, extension durée vidéo, extension vidéo IA, allonger vidéo, prolonger temps vidéo, outil vidéo IA',
            og_title: 'Extension Vidéo IA - Prolonger la Durée et Longueur de Vidéo | 微鲤AI',
            og_description: 'Prolongez la durée des vidéos avec la technologie IA. Ajoutez 5 à 8 secondes à vos vidéos de manière transparente avec plusieurs options de style incluant anime, animation 3D, cyberpunk et bande dessinée. Parfait pour les créateurs de contenu et éditeurs vidéo.',
            twitter_title: 'Extension Vidéo IA - Prolonger la Durée et Longueur de Vidéo | 微鲤AI',
            twitter_description: 'Prolongez la durée des vidéos avec la technologie IA. Ajoutez 5 à 8 secondes à vos vidéos de manière transparente avec plusieurs options de style incluant anime, animation 3D, cyberpunk et bande dessinée. Parfait pour les créateurs de contenu et éditeurs vidéo.',
            page: {
                title1: 'Extension vidéo IA gratuite & continuation',
                title2: 'Votre vidéo est trop courte ? 微鲤AI utilise l’IA générative pour prédire et créer de nouveaux frames afin d’étendre votre clip de façon fluide. Vous pouvez aussi guider la suite avec des prompts, ou transformer une vidéo standard en slow motion ultra fluide.',
                feature_title1: 'Extension générative intelligente',
                feature_desc1: 'Ne “tirez” pas simplement la vidéo : créez du nouveau contenu. Entrez un prompt comme « la caméra zoome arrière » ou « le personnage se retourne », et l’IA générera les 5–10 prochaines secondes dans le style d’origine.',
                feature_title2: 'Slow motion ultra fluide',
                feature_desc2: 'Transformez une vidéo 30fps en slow motion de haute qualité. 微鲤AI utilise l’interpolation d’images (Frame Interpolation) pour insérer des frames générées par IA et obtenir un mouvement sans saccades.',
                feature_title3: 'Boucle parfaite',
                feature_desc3: 'Créez des loops infinis pour des fonds sur les réseaux sociaux. L’IA analyse le début et la fin pour les fusionner parfaitement.',
                faq: [
                    {
                        question: 'Comment fonctionne l’extension vidéo IA ?',
                        answer: 'Elle utilise la technologie « Generative Outpainting ». L’IA analyse les derniers frames et votre prompt pour prédire et générer de nouveaux frames qui prolongent logiquement l’action.',
                    },
                    {
                        question: 'Puis‑je contrôler ce qui se passe dans la partie étendue ?',
                        answer: 'Oui ! Utilisez la zone “Prompt” pour décrire l’action. Par exemple, si votre vidéo montre une voiture, tapez « la voiture entre dans un tunnel » pour guider l’extension.',
                    },
                    {
                        question: 'Quelle différence entre Extension et Slow Motion ?',
                        answer: 'L’Extension ajoute du temps en générant de nouveaux événements (la scène continue). Le Slow Motion étire le temps existant en ajoutant des frames intermédiaires (l’action devient plus lente). 微鲤AI fait les deux.',
                    },
                    {
                        question: 'Jusqu’où puis‑je étendre une vidéo ?',
                        answer: 'Vous pouvez étendre un clip de 5 secondes à la fois (réglage “Extension Duration”). Répétez l’opération pour créer des séquences plus longues.',
                    },
                    {
                        question: 'Est‑ce gratuit ?',
                        answer: 'Oui, 微鲤AI propose des crédits gratuits pour essayer l’extension vidéo et le slow motion.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Comment fonctionne l’extension vidéo IA ?',
                    answer: 'Avec « Generative Outpainting », l’IA analyse les derniers frames et votre prompt pour générer la suite.',
                },
                {
                    question: 'Puis‑je contrôler la partie étendue ?',
                    answer: 'Oui. Décrivez l’action dans “Prompt” (ex. « la voiture entre dans un tunnel »).',
                },
                {
                    question: 'Quelle différence entre Extension et Slow Motion ?',
                    answer: 'L’Extension génère de nouveaux événements pour ajouter du temps ; le Slow Motion ajoute des frames intermédiaires pour ralentir l’action.',
                },
            ],
            app_name: '微鲤AI Extension Vidéo',
            app_desc: 'Outil IA gratuit pour prolonger des vidéos avec remplissage génératif et prompts. Inclut aussi le slow motion IA (interpolation) et la création de boucles.',
            featureList: 'Extension vidéo générative, Continuation guidée par prompt, Slow motion IA, Boucle vidéo',
        },
        videoEffects: {
            title: `Effets Vidéo - Créez des Vidéos Virales avec l'IA | 微鲤AI`,
            description: 'Explorez les effets vidéo IA populaires sur 微鲤AI. Du Baiser IA à la Danse IA, créez des vidéos virales en quelques clics.',
            keywords: 'effets vidéo IA, vidéos virales IA, tendances vidéo, baiser IA, danse IA, générateur vidéo',
        },
        aiDancing: {
            title: 'Générateur de Vidéo de Danse IA - Créateur de Vidéo de Danse IA Gratuit | 微鲤AI',
            description: 'Utilisez le Générateur de Danse IA de 微鲤AI pour créer des vidéos de danse incroyables à partir de photos. Prend en charge plusieurs modèles et styles de danse, donnez vie à vos photos!',
            keywords: 'vidéo de danse IA, générateur de danse IA, photo en vidéo, génération vidéo IA, 微鲤AI, outils IA gratuits',
        },
        aiKissing: {
            title: 'aiKissing | 微鲤AI',
            description: 'Experience aiKissing on 微鲤AI platform.',
            keywords: 'aiKissing, AI, 微鲤AI',
        },
        videoMotionImitation: {
            title: 'Imitation de Mouvement Vidéo IA - Donnez Vie aux Photos Gratuitement | 微鲤AI',
            description: `L'outil d'imitation de mouvement vidéo de 微鲤AI peut intégrer des personnages de photos dans des vidéos de référence, remplaçant les personnages originaux tout en préservant l'éclairage et les tons de la scène pour une fusion environnementale parfaite.`,
            keywords: `imitation de mouvement vidéo IA, donner vie aux photos, outil d'imitation de mouvement vidéo IA, 微鲤AI, outils IA gratuits`,
            og_title: 'Imitation de Mouvement Vidéo IA - Donnez Vie aux Photos Gratuitement | 微鲤AI',
            og_description: `L'outil d'imitation de mouvement vidéo de 微鲤AI peut intégrer des personnages de photos dans des vidéos de référence, remplaçant les personnages originaux tout en préservant l'éclairage et les tons de la scène pour une fusion environnementale parfaite.`,
            twitter_title: 'Imitation de Mouvement Vidéo IA - Donnez Vie aux Photos Gratuitement | 微鲤AI',
            twitter_description: `L'outil d'imitation de mouvement vidéo de 微鲤AI peut intégrer des personnages de photos dans des vidéos de référence, remplaçant les personnages originaux tout en préservant l'éclairage et les tons de la scène pour une fusion environnementale parfaite.`,
            page: {
                title1: 'Générateur de Danse IA Gratuit & Transfert de Mouvement',
                title2: 'Envie de voir votre personnage d’anime préféré danser comme Michael Jackson ? Ou de faire exécuter à une photo statique un mouvement viral TikTok ? Importez une vidéo de référence et une image, et notre IA transférera le mouvement avec précision.',
                feature_title1: 'Remplacement de Personnage Vidéo',
                feature_desc1: 'Swap Réel→Anime : importez une vidéo d’une personne qui danse/se bat et remplacez-la par un personnage 3D, un panda ou un avatar anime tout en conservant le fond et l’éclairage.',
                feature_title2: 'Faites Danser des Photos',
                feature_desc2: 'Animez des images statiques : donnez vie aux photos. Importez une photo (vous ou un personnage), choisissez une vidéo de danse de référence et regardez la photo imiter les mouvements. Idéal pour du contenu viral style Viggle.',
                feature_title3: 'Brisez le Mur des Dimensions',
                feature_desc3: 'Styles croisés : qu’il s’agisse de transformer une ballerine en fille d’anime ou un karatéka en panda, 微鲤AI gère les corps complexes et les occlusions avec fluidité.',
                faq: [
                    {
                        question: 'Comment faire danser une photo avec l’IA ?',
                        answer: 'Utilisez le « Move Mode » de 微鲤AI. Importez la photo à animer (Character Image) et une vidéo contenant les mouvements (Reference Video). Cliquez sur Create pour transférer le mouvement.',
                    },
                    {
                        question: 'Quelle est la différence entre Move Mode et Replace Mode ?',
                        answer: 'Move Mode anime une image statique à partir du mouvement d’une vidéo. Replace Mode remplace la personne dans une vidéo existante par un personnage provenant d’une image.',
                    },
                    {
                        question: 'Puis-je l’utiliser pour des tendances TikTok ?',
                        answer: 'Oui ! Parfait pour les challenges TikTok : célébrités, personnages d’anime ou amis peuvent reproduire des danses tendance sans les apprendre.',
                    },
                    {
                        question: 'Ça marche sur des plans en pied ?',
                        answer: 'Oui. Pour de meilleurs résultats, assurez-vous que la vidéo de référence et l’image montrent le corps entier clairement.',
                    },
                    {
                        question: 'Est-ce gratuit ?',
                        answer: 'Oui, vous pouvez générer des vidéos de transfert de mouvement gratuitement avec vos crédits quotidiens.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Comment faire danser une photo avec l’IA ?',
                    answer: 'Utilisez le « Move Mode » de 微鲤AI. Importez la photo à animer (Character Image) et une vidéo contenant les mouvements (Reference Video). Cliquez sur Create pour transférer le mouvement.',
                },
                {
                    question: 'Quelle est la différence entre Move Mode et Replace Mode ?',
                    answer: 'Move Mode anime une image statique à partir du mouvement d’une vidéo. Replace Mode remplace la personne dans une vidéo existante par un personnage provenant d’une image.',
                },
            ],
            app_name: 'Transfert de Mouvement 微鲤AI',
            app_desc: 'Générateur de danse IA et transfert de mouvement gratuits. Faites danser des photos, animez des images statiques et remplacez des personnages vidéo en ligne.',
            featureList: 'Génération de danse IA, transfert de pose, swap de personnage vidéo, animer une photo',
            step_name: 'Comment faire danser une photo avec l’IA',
            step_list: [
                {
                    name: 'Importer la vidéo de référence',
                    text: 'Importez une vidéo qui contient la danse ou le mouvement que vous voulez copier.',
                },
                {
                    name: 'Importer l’image du personnage',
                    text: 'Importez la photo statique de la personne ou du personnage à animer.',
                },
                {
                    name: 'Choisir Move Mode',
                    text: 'Choisissez « Move Mode » puis cliquez sur Create. L’IA fera exécuter à la photo les mouvements de la vidéo.',
                },
            ],
        },
    },
    de: {
        textToMusic: {
            title: 'KI-Musikgenerator - Erstellen Sie Einzigartige Musik mit 微鲤AI | 微鲤AI',
            description: 'Entdecken Sie den KI-Musikgenerator von 微鲤AI. Erstellen Sie schnell einzigartige, lizenzfreie Musik, die auf Ihre Projekte zugeschnitten ist, mit fortschrittlicher KI-Technologie. Perfekt für Content-Ersteller, Spieleentwickler und Musikliebhaber.',
            keywords: 'Text zu Musik, Text zu Musik kostenlos, KI Text zu Musik, KI-Musikgenerator, KI-Song-Maker, ähnliche Musik erstellen, Musikerstellung, lizenzfreie Musik, Musik kostenlos herunterladen, 微鲤AI',
        },
        textToVideo: {
            title: 'Kostenloser KI Text-zu-Video Generator (Veo 3.1, Kling & Sora) | 微鲤AI',
            description: 'Verwandeln Sie Text-Prompts sofort in cineastische Videos mit WeryAIs Text‑to‑Video‑KI. Angetrieben von Google Veo 3.1, Kling und Sora. Unterstützt 16:9 und 9:16, bis zu 8 Sekunden Dauer. Optionen ohne Wasserzeichen verfügbar.',
            keywords: 'text zu video KI, KI-Videogenerator, google veo 3.1, prompt zu video, kling ai video, sora, txt2vid, 微鲤AI',
            og_title: 'Kostenloser KI Text-zu-Video Generator (Veo 3.1, Kling & Sora) | 微鲤AI',
            og_description: 'Verwandeln Sie Text-Prompts sofort in cineastische Videos mit WeryAIs Text‑to‑Video‑KI. Angetrieben von Google Veo 3.1, Kling und Sora. Unterstützt 16:9 und 9:16, bis zu 8 Sekunden Dauer. Optionen ohne Wasserzeichen verfügbar.',
            twitter_title: 'Kostenloser KI Text-zu-Video Generator (Veo 3.1, Kling & Sora) | 微鲤AI',
            twitter_description: 'Verwandeln Sie Text-Prompts sofort in cineastische Videos mit WeryAIs Text‑to‑Video‑KI. Angetrieben von Google Veo 3.1, Kling und Sora. Unterstützt 16:9 und 9:16, bis zu 8 Sekunden Dauer. Optionen ohne Wasserzeichen verfügbar.',
            page: {
                title1: 'Kostenloser KI Text-zu-Video Generator',
                title2: 'Tippen Sie einfach einen Prompt ein und sehen Sie zu, wie 微鲤AI Ihre Idee zum Leben erweckt. Unser Text‑zu‑Video‑Generator bündelt modernste Modelle wie Google Veo 3.1 und Kling AI, sodass Sie in Sekunden hochwertige, physikalisch stimmige Videos für Social (9:16) oder Kino‑Projekte (16:9) erstellen können.',
                intro_title: 'Machen Sie Fantasie mit Text‑zu‑Video KI real',
                feature_title: 'Funktionen von 微鲤AI Text‑zu‑Video',
                faq_title: 'Häufige Fragen zu Text‑zu‑Video',
                feature_title1: 'Multi‑Model Power',
                feature_desc1: 'Wechseln Sie zwischen Veo 3.1 für Realismus und Kling für Bewegungs‑Konsistenz. Keine separaten Abos nötig.',
                feature_title2: 'Eigene Seitenverhältnisse',
                feature_desc2: 'Erzeugen Sie vertikale Videos (9:16) für TikTok/Reels oder 16:9 für YouTube direkt.',
                feature_title3: 'Längere Dauer',
                feature_desc3: 'Erstellen Sie Videos bis zu 8 Sekunden (oder länger mit Erweiterungen) in einer Generierung – ideal fürs Storytelling.',
                faq: [
                    {
                        question: 'Wie schreibe ich einen guten Prompt für Text‑zu‑Video?',
                        answer: 'Seien Sie konkret: Motiv, Aktion, Licht und Kamerawinkel. Beispiel: „Cineastische Drohnenaufnahme einer futuristischen Cyberpunk‑Stadt bei Nacht, Neonlichter, 4K“.',
                    },
                    {
                        question: 'Welches Modell soll ich nutzen: Google Veo 3.1 oder Kling?',
                        answer: 'Google Veo 3.1 bietet starke Bildqualität und Prompt‑Treue, ideal für realistische Szenen. Kling AI ist oft besser bei komplexen Charakterbewegungen. Probieren Sie beide aus.',
                    },
                    {
                        question: 'Ist 微鲤AI Text‑zu‑Video kostenlos?',
                        answer: 'Ja. Jeder Nutzer erhält tägliche Gratis‑Credits, um Videos aus Text zu generieren. Sie können mehrere Clips erstellen und vergleichen.',
                    },
                    {
                        question: 'Kann ich Videos länger als 8 Sekunden generieren?',
                        answer: 'Die Basis‑Generierung erstellt Clips bis zu 8 Sekunden (modellabhängig). Für längere Videos nutzen Sie unser AI Video Extender‑Tool, um nahtlos fortzusetzen.',
                    },
                    {
                        question: 'Haben die generierten Videos Ton?',
                        answer: 'Ja. Aktivieren Sie den „Generate Audio“-Schalter, um passende Soundeffekte und Ambiente automatisch zu erzeugen.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Wie schreibe ich einen guten Prompt für Text‑zu‑Video?',
                    answer: 'Beschreiben Sie Motiv, Aktion, Licht und Kamera. Beispiel: „Cyberpunk‑Stadt bei Nacht, Neon, Drohne, 4K“.',
                },
                {
                    question: 'Welches Modell soll ich nutzen: Google Veo 3.1 oder Kling?',
                    answer: 'Veo 3.1 ist stark bei Realismus/Prompt‑Treue, Kling bei Bewegungen. Testen Sie beide.',
                },
                {
                    question: 'Ist 微鲤AI Text‑zu‑Video kostenlos?',
                    answer: 'Ja. Tägliche Gratis‑Credits sind verfügbar.',
                },
                {
                    question: 'Kann ich Videos länger als 8 Sekunden generieren?',
                    answer: 'Basis bis 8 Sekunden; für mehr Dauer nutzen Sie AI Video Extender.',
                },
                {
                    question: 'Haben die generierten Videos Ton?',
                    answer: 'Ja. Mit „Generate Audio“ können Sie Audio automatisch erzeugen.',
                },
            ],
        },
        imageToVideo: {
            title: 'KI Bild-zu-Video Generator (kostenlos & online) – mit Kling, Veo & Sora',
            description: 'Verwandeln Sie statische Fotos in Sekunden in realistische Videos – mit WeryAIs kostenlosem Bild-zu-Video-KI-Tool. Nutzen Sie Top-Modelle wie Kling, Google Veo und Sora 2 an einem Ort. Optionen ohne Wasserzeichen verfügbar.',
            keywords: 'Bild zu Video KI, KI-Videogenerator, Bildanimation, Sora Video, Veo Video, Seedance Video, 微鲤AI Video-Tools',
            og_title: 'KI Bild-zu-Video Generator (kostenlos & online) – mit Kling, Veo & Sora',
            og_description: 'Verwandeln Sie statische Fotos in Sekunden in realistische Videos – mit WeryAIs kostenlosem Bild-zu-Video-KI-Tool. Nutzen Sie Top-Modelle wie Kling, Google Veo und Sora 2 an einem Ort. Optionen ohne Wasserzeichen verfügbar.',
            twitter_title: 'KI Bild-zu-Video Generator (kostenlos & online) – mit Kling, Veo & Sora',
            twitter_description: 'Verwandeln Sie statische Fotos in Sekunden in realistische Videos – mit WeryAIs kostenlosem Bild-zu-Video-KI-Tool. Nutzen Sie Top-Modelle wie Kling, Google Veo und Sora 2 an einem Ort. Optionen ohne Wasserzeichen verfügbar.',
            page: {
                title1: 'Kostenloser Online KI Bild-zu-Video Generator',
                faq: [
                    {
                        question: 'Wie funktioniert der KI Bild-zu-Video Generator?',
                        answer: 'Er nutzt fortschrittliche Deep-Learning-Modelle wie Kling und Sora, um Ihr statisches Bild zu analysieren und Bewegungen vorherzusagen – daraus entsteht ein stimmiger MP4‑Videoclip.',
                    },
                    {
                        question: 'Ist 微鲤AI Bild-zu-Video kostenlos?',
                        answer: 'Ja. Wir bieten tägliche Gratis‑Credits, damit Sie unsere Bild‑zu‑Video‑KI testen können. Für Premium‑Modelle und schnellere Generierung können Sie upgraden.',
                    },
                    {
                        question: 'Welches Modell ist besser für realistische Videos: Kling oder Veo?',
                        answer: 'Kling AI ist bekannt für realistische Bewegungen und längere Dauer, während Google Veo bei hochauflösenden Details glänzt. Mit 微鲤AI können Sie zwischen den Modellen wechseln und das beste Ergebnis finden.',
                    },
                    {
                        question: 'Kann ich die generierten Videos kommerziell nutzen?',
                        answer: 'Ja. Videos, die unter unseren bezahlten Plänen erstellt werden, enthalten eine kommerzielle Lizenz – ideal für YouTube, TikTok und Marketing‑Ads.',
                    },
                    {
                        question: 'Wie entferne ich Wasserzeichen aus KI‑Videos?',
                        answer: '微鲤AI liefert hochwertige Ergebnisse. Für Videos ohne Wasserzeichen prüfen Sie bitte Ihren Plan oder nutzen Sie unser spezielles KI‑Wasserzeichen‑Entferner‑Tool.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Wie funktioniert der KI Bild-zu-Video Generator?',
                    answer: 'Er analysiert Ihr Bild mit Modellen wie Kling und Sora, sagt Bewegungen voraus und erzeugt einen stimmigen MP4‑Clip.',
                },
                {
                    question: 'Ist 微鲤AI Bild-zu-Video kostenlos?',
                    answer: 'Ja. Tägliche Gratis‑Credits sind verfügbar. Für Premium‑Modelle und schnellere Generierung können Sie upgraden.',
                },
                {
                    question: 'Kann ich die generierten Videos kommerziell nutzen?',
                    answer: 'Ja. Bei einem bezahlten Plan erhalten Sie eine kommerzielle Lizenz – perfekt für YouTube, TikTok und Werbung.',
                },
            ],
        },
        videoToVideo: {
            title: 'Kostenloser KI Video-zu-Video Generator - Restyle & Anime-Filter | 微鲤AI',
            description: 'Verwandeln Sie Ihre Videos in jeden Stil mit WeryAIs Video-zu-Video KI. Machen Sie aus Realfilm Anime, 3D-Cartoons oder Cyberpunk-Art – per Text-Prompt und mit konsistenter Originalbewegung. Kostenlos & online.',
            keywords: 'video zu video ki, vid2vid, KI video stiltransfer, video in anime verwandeln, KI video restyle, kostenloser KI video filter',
            og_title: 'Kostenloser KI Video-zu-Video Generator - Restyle & Anime-Filter | 微鲤AI',
            og_description: 'Verwandeln Sie Ihre Videos in jeden Stil mit WeryAIs Video-zu-Video KI. Machen Sie aus Realfilm Anime, 3D-Cartoons oder Cyberpunk-Art – per Text-Prompt und mit konsistenter Originalbewegung. Kostenlos & online.',
            twitter_title: 'Kostenloser KI Video-zu-Video Generator - Restyle & Anime-Filter | 微鲤AI',
            twitter_description: 'Verwandeln Sie Ihre Videos in jeden Stil mit WeryAIs Video-zu-Video KI. Machen Sie aus Realfilm Anime, 3D-Cartoons oder Cyberpunk-Art – per Text-Prompt und mit konsistenter Originalbewegung. Kostenlos & online.',
            page: {
                title1: 'Kostenloser KI Video-zu-Video Generator (Vid2Vid)',
                title2: 'Laden Sie ein Video hoch, geben Sie einen Stil ein – und sehen Sie die Magie. WeryAIs Video-zu-Video-Technologie analysiert die Bewegung Ihres Quellvideos und wendet anhand Ihres Text-Prompts einen komplett neuen Kunststil an. Perfekt für Anime-Edits, Claymation-Effekte oder surreale Visuals.',
                feature_title1: 'Konsistente Bewegung',
                feature_desc1: 'Anders als bei Standard-Generierung „rastet“ unsere Vid2Vid-Engine in die Bewegung des Quellvideos ein und sorgt für flüssige Übergänge ohne Flackern.',
                feature_title2: 'Real zu Anime',
                feature_desc2: 'Tool #1 für Creator: Verwandeln Sie sich sofort in eine Anime-Figur oder einen 3D-Pixar-Style-Avatar.',
                feature_title3: 'Prompt-Kontrolle',
                feature_desc3: 'Volle kreative Kontrolle: Tippen Sie einfach „Cyberpunk-City Style“ oder „Ölgemälde Style“, um den Look exakt zu definieren.',
                faq: [
                    {
                        question: 'Was ist KI Video-zu-Video (Vid2Vid)?',
                        answer: 'Video-zu-Video ist ein generativer KI-Prozess, der ein vorhandenes Video als Input nimmt und es in einem neuen, durch Ihren Prompt beschriebenen Stil „neu malt“, während Bewegung und Struktur erhalten bleiben.',
                    },
                    {
                        question: 'Kann ich mein Video in einen Anime-Stil verwandeln?',
                        answer: 'Ja! Das ist der beliebteste Anwendungsfall. Laden Sie Ihr Video hoch und nutzen Sie Prompts wie „Japanese anime style, Studio Ghibli look“.',
                    },
                    {
                        question: 'Wie lang darf das Quellvideo sein?',
                        answer: 'Aktuell empfehlen wir kurze Clips (z. B. 5–10 Sekunden) für die beste Qualität. Für längere Videos empfehlen wir, sie in Segmente zu teilen.',
                    },
                    {
                        question: 'Worin unterscheidet es sich von einem Videoeditor?',
                        answer: 'Ein klassischer Editor schneidet und trimmt Clips. 微鲤AI Video-zu-Video erzeugt neue Pixel und verändert Textur und Kunststil Ihres Materials vollständig.',
                    },
                    {
                        question: 'Kostet es Geld?',
                        answer: '微鲤AI bietet tägliche Gratis-Credits zum Ausprobieren. Premium-Pläne bieten schnellere Verarbeitung und Downloads ohne Wasserzeichen.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Was ist KI Video-zu-Video (Vid2Vid)?',
                    answer: 'Es „malt“ ein bestehendes Video per Prompt in einen neuen Stil um und behält Bewegung und Struktur bei.',
                },
                {
                    question: 'Kann ich mein Video in einen Anime-Stil verwandeln?',
                    answer: 'Ja. Probieren Sie Prompts wie „Japanese anime style, Studio Ghibli look“.',
                },
                {
                    question: 'Wie lang darf das Quellvideo sein?',
                    answer: 'Für beste Qualität empfehlen wir kurze Clips (5–10 s). Lange Videos bitte segmentieren.',
                },
                {
                    question: 'Worin unterscheidet es sich von einem Videoeditor?',
                    answer: 'Editor = schneiden; Vid2Vid = neue Pixel generieren und Stil/Textur verändern.',
                },
                {
                    question: 'Kostet es Geld?',
                    answer: 'Tägliche Gratis-Credits verfügbar; Premium = schneller & ohne Wasserzeichen.',
                },
            ],
        },
        removeWatermark: {
            title: 'Kostenloser KI Video-Wasserzeichen-Entferner - Logos, Text & Untertitel löschen | 微鲤AI',
            description: 'Entfernen Sie Wasserzeichen, Logos, Untertitel und Datumsstempel ganz einfach mit WeryAIs kostenlosem KI‑Wasserzeichen‑Entferner. Unterstützt MP4/MOV und Videolinks. Kein Blur – saubere KI‑Wiederherstellung.',
            keywords: 'wasserzeichen aus video entfernen, KI video radierer, logo aus video entfernen, untertitel löschen, tiktok wasserzeichen entfernen, kostenloser wasserzeichen entferner online',
            og_title: 'Kostenloser KI Video-Wasserzeichen-Entferner - Logos, Text & Untertitel löschen | 微鲤AI',
            og_description: 'Entfernen Sie Wasserzeichen, Logos, Untertitel und Datumsstempel ganz einfach mit WeryAIs kostenlosem KI‑Wasserzeichen‑Entferner. Unterstützt MP4/MOV und Videolinks. Kein Blur – saubere KI‑Wiederherstellung.',
            twitter_title: 'Kostenloser KI Video-Wasserzeichen-Entferner - Logos, Text & Untertitel löschen | 微鲤AI',
            twitter_description: 'Entfernen Sie Wasserzeichen, Logos, Untertitel und Datumsstempel ganz einfach mit WeryAIs kostenlosem KI‑Wasserzeichen‑Entferner. Unterstützt MP4/MOV und Videolinks. Kein Blur – saubere KI‑Wiederherstellung.',
            page: {
                title1: 'Kostenloser Online KI Video-Wasserzeichen-Entferner',
                title2: 'Entfernen Sie Wasserzeichen, Logos, Text-Overlays und Untertitel sofort aus Ihren Videos. Fügen Sie einen Videolink ein oder laden Sie eine Datei hoch, wählen Sie den Bereich aus und lassen Sie unsere KI den Hintergrund pixelgenau wiederherstellen – ohne Verwischen.',
                click_erase: '1.One‑Click Erase: Die KI erkennt und entfernt gängige Wasserzeichen automatisch.',
                percision_erase: '2.Precision Erase: Mit dem Pinsel entfernen Sie komplexe Objekte wie bewegte Untertitel oder Zeitstempel manuell.',
                video_link_title: 'Per Link',
                direct_link_desc: '1.Direct Link Removal: Fügen Sie Links von Social‑Media‑Plattformen ein und entfernen Sie Wasserzeichen direkt – ohne vorher herunterzuladen.',
                lossless_qua_title: '2.Lossless Quality: Anders als Blur‑Tools rekonstruiert 微鲤AI den Hintergrund durch Analyse der umliegenden Pixel.',
                faq: [
                    {
                        question: 'Wie entferne ich ein Wasserzeichen kostenlos online aus einem Video?',
                        answer: 'Laden Sie Ihr Video bei 微鲤AI hoch oder fügen Sie einen Videolink ein. Decken Sie das Wasserzeichen mit der Auswahlbox ab und klicken Sie auf „Generate“. Kostenlos zum Ausprobieren.',
                    },
                    {
                        question: 'Kann ich bewegte Untertitel oder Text entfernen?',
                        answer: 'Ja. Nutzen Sie den Modus „Precision Erase“, um den Textbereich zu markieren. Unsere KI verfolgt das Wasserzeichen über Frames hinweg für eine saubere Entfernung.',
                    },
                    {
                        question: 'Funktioniert das für TikTok- oder YouTube‑Videos?',
                        answer: 'Absolut. Entfernen Sie Plattformlogos (z. B. das springende TikTok‑Wasserzeichen) oder Kanal‑Wasserzeichen für ein sauberes Video zur privaten Nutzung.',
                    },
                    {
                        question: 'Sieht der entfernte Bereich verschwommen aus?',
                        answer: 'Nein. 微鲤AI nutzt „Video In‑painting“, um die gelöschte Fläche mit realistischen Texturen aus dem umliegenden Video zu füllen – ohne hässlichen Blur.',
                    },
                    {
                        question: 'Welche Videoformate werden unterstützt?',
                        answer: 'Wir unterstützen alle gängigen Formate, darunter MP4, MOV, AVI und WebM.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Wie entferne ich ein Wasserzeichen kostenlos online aus einem Video?',
                    answer: 'Video hochladen oder Link einfügen, Bereich auswählen, „Generate“ klicken – kostenlos testbar.',
                },
                {
                    question: 'Kann ich bewegte Untertitel oder Text entfernen?',
                    answer: 'Ja. Mit „Precision Erase“ verfolgt die KI den Text über Frames und entfernt ihn sauber.',
                },
                {
                    question: 'Sieht der entfernte Bereich verschwommen aus?',
                    answer: 'Nein. Video In‑painting füllt realistisch auf – ohne Blur.',
                },
            ],
        },
        videoFaceSwap: {
            title: 'Kostenloser KI Video Face Swap Online - Realistischer Deepfake‑Maker | 微鲤AI',
            description: 'Tauschen Sie Gesichter in Videos sofort mit WeryAIs KI Face Swapper. Erstellen Sie lustige Clips, Memes und realistische Deepfakes kostenlos. Optionen ohne Wasserzeichen verfügbar. 100% privat & sicher.',
            keywords: 'video face swap, KI face swapper, kostenloser deepfake maker, gesicht in video ersetzen, film face swap, reface online, meme maker KI',
            og_title: 'Kostenloser KI Video Face Swap Online - Realistischer Deepfake‑Maker | 微鲤AI',
            og_description: 'Tauschen Sie Gesichter in Videos sofort mit WeryAIs KI Face Swapper. Erstellen Sie lustige Clips, Memes und realistische Deepfakes kostenlos. Optionen ohne Wasserzeichen verfügbar. 100% privat & sicher.',
            twitter_title: 'Kostenloser KI Video Face Swap Online - Realistischer Deepfake‑Maker | 微鲤AI',
            twitter_description: 'Tauschen Sie Gesichter in Videos sofort mit WeryAIs KI Face Swapper. Erstellen Sie lustige Clips, Memes und realistische Deepfakes kostenlos. Optionen ohne Wasserzeichen verfügbar. 100% privat & sicher.',
            page: {
                title1: 'Kostenloser KI Video Face Swap',
                title2: 'Werden Sie der Star in jedem Film! Laden Sie einen Videoclip und ein Zielfoto hoch – unsere KI tauscht die Gesichter nahtlos aus. Ideal für witzige Memes, personalisierte Grüße oder professionelle VFX mit hoher Qualität.',
                feature_title1: 'Hyper‑realistischer Deepfake',
                feature_desc1: 'Unsere KI analysiert Gesichtsgeometrie und Licht, integriert das neue Gesicht natürlich und erhält Mimik sowie Kopfbewegungen.',
                feature_title2: 'Privacy First',
                feature_desc2: 'Ihre Privatsphäre ist uns wichtig. Uploads werden sicher verarbeitet und kurz nach der Generierung von unseren Servern gelöscht.',
                feature_title3: 'Keine Technik‑Skills nötig',
                feature_desc3: 'Keine komplexe Software wie After Effects. Klicken Sie einfach auf „Create“ und erhalten Sie Ergebnisse in Hollywood‑Qualität in Sekunden.',
                faq: [
                    {
                        question: 'Ist 微鲤AI Video Face Swap kostenlos?',
                        answer: 'Ja. Wir bieten kostenlose Credits, damit Sie Video‑Face‑Swaps online testen können. Keine Kreditkarte erforderlich.',
                    },
                    {
                        question: 'Ist das Hochladen meiner Fotos sicher?',
                        answer: 'Absolut. Wir nutzen strenge Datenschutzprotokolle. Ihre Quellvideos und Zielbilder werden nur für die Generierung verwendet und nicht dauerhaft gespeichert.',
                    },
                    {
                        question: 'Kann ich Gesichter in GIFs tauschen?',
                        answer: 'Ja! 微鲤AI unterstützt Video (MP4/MOV) und GIF. Sie können personalisierte Reaction‑GIFs leicht erstellen.',
                    },
                    {
                        question: 'Wie bekomme ich die besten Ergebnisse?',
                        answer: 'Nutzen Sie ein klares, frontales und gut ausgeleuchtetes Zielfoto. Vermeiden Sie Fotos, bei denen das Gesicht durch Haare oder Brillen verdeckt ist.',
                    },
                    {
                        question: 'Kann ich es für kommerzielle Projekte nutzen?',
                        answer: 'Ja, aber stellen Sie bitte sicher, dass Sie die Rechte am Originalmaterial und an der Person (Abbild) besitzen.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Ist 微鲤AI Video Face Swap kostenlos?',
                    answer: 'Ja. Kostenlose Credits sind verfügbar; keine Kreditkarte nötig.',
                },
                {
                    question: 'Ist das Hochladen meiner Fotos sicher?',
                    answer: 'Ja. Inhalte werden nur für die Generierung genutzt.',
                },
                {
                    question: 'Wie bekomme ich die besten Ergebnisse?',
                    answer: 'Klares, frontales, gut beleuchtetes Zielfoto verwenden; verdeckte Gesichter vermeiden.',
                },
            ],
        },
        videoLipSync: {
            title: 'Kostenloser KI-Video-Lip-Sync-Generator – Audio & Text mit Video synchronisieren | 微鲤AI',
            description: 'Synchronisieren Sie Lippenbewegungen perfekt zu jedem Audio oder Text mit WeryAIs KI-Lip-Sync-Tool. Angetrieben von Kling AI. Ideal für Videoübersetzung, Synchronisation/Dubbing und sprechende Avatare. Kostenlos & online.',
            keywords: 'Video-Lippensynchronisation, Lippensynchronisation, KI-Lippensynchronisation, Video-Synchronisation, Sprach-Synchronisation, Sprechvideo, Lippensynchronisations-Tool',
            og_title: 'Kostenloser KI-Video-Lip-Sync-Generator – Audio & Text mit Video synchronisieren | 微鲤AI',
            og_description: 'Synchronisieren Sie Lippenbewegungen perfekt zu jedem Audio oder Text mit WeryAIs KI-Lip-Sync-Tool. Angetrieben von Kling AI. Ideal für Videoübersetzung, Synchronisation/Dubbing und sprechende Avatare. Kostenlos & online.',
            twitter_title: 'Kostenloser KI-Video-Lip-Sync-Generator – Audio & Text mit Video synchronisieren | 微鲤AI',
            twitter_description: 'Synchronisieren Sie Lippenbewegungen perfekt zu jedem Audio oder Text mit WeryAIs KI-Lip-Sync-Tool. Angetrieben von Kling AI. Ideal für Videoübersetzung, Synchronisation/Dubbing und sprechende Avatare. Kostenlos & online.',
            page: {
                title1: 'Kostenloses KI-Lip-Sync- & Dubbing-Tool',
                title2: 'Sagen Sie peinlichen Dub-Videos ade. Laden Sie ein Video und eine Audiodatei hoch (oder tippen Sie Text), und unsere KI regeneriert die Lippenbewegungen des Sprechers, damit sie perfekt zum Ton passen. Angetrieben von Kling AI – mit mehrsprachigem Dubbing und realistischen Gesichtsmuskel‑Anpassungen.',
                dual_input_modes: 'Zwei Eingabemodi',
                audio_sync: 'Audio-Synchronisation',
                text_sync: 'Text‑zu‑Sprache',
                text_sync_tip: 'Geben Sie beliebigen Text ein, wählen Sie eine voreingestellte KI‑Stimme und lassen Sie die Figur ihn sofort sprechen.',
                audio_sync_tip: 'Laden Sie Ihr eigenes Voice‑over oder einen Song hoch, um zu synchronisieren.',
                feature_title1: 'Mehrsprachiges Dubbing',
                feature_desc1: 'Erweitern Sie Ihre Reichweite. Übersetzen Sie Ihr Video z. B. ins Spanische, Französische oder Japanische und synchronisieren Sie die Lippen, sodass es wie von einem Muttersprachler wirkt.',
                feature_title2: 'Kling‑AI‑Präzision',
                feature_desc2: 'Im Gegensatz zu einfachen Wav2Lip‑Tools nutzen wir das Kling‑Modell, damit Zähne‑, Zungen‑ und Kieferbewegungen anatomisch korrekt sind.',
                faq: [
                    {
                        question: 'Wie synchronisiere ich Lippen zu Audio in einem Video?',
                        answer: 'Laden Sie Ihren Videoclip bei 微鲤AI hoch. Laden Sie dann eine Audiodatei (MP3/WAV) hoch oder tippen Sie Text, um KI‑Sprache zu erzeugen. Klicken Sie auf "Create" – unsere KI passt die Mundbewegungen an den Ton an.',
                    },
                    {
                        question: 'Kann ich das für Videoübersetzung/Dubbing nutzen?',
                        answer: 'Ja! Das ist ideal fürs Dubbing. Laden Sie eine übersetzte Audiospur hoch, und die KI korrigiert den Lip‑Sync, damit die synchronisierte Version natürlich aussieht.',
                    },
                    {
                        question: 'Funktioniert es auch mit Standbildern (Talking Heads)?',
                        answer: 'Ja. Wenn Sie ein statisches Portraitfoto als „Video“-Quelle hochladen, animiert das Tool es zu einem Talking‑Head‑Video (Live‑Portrait‑Effekt).',
                    },
                    {
                        question: 'Welche Sprachen werden unterstützt?',
                        answer: 'Da die Technologie Audio‑Wellen analysiert, funktioniert sie mit jeder Sprache (Englisch, Spanisch, Chinesisch, Hindi usw.). Für Text‑zu‑Sprache unterstützen wir 50+ Sprachen.',
                    },
                    {
                        question: 'Ist Lip Sync kostenlos?',
                        answer: '微鲤AI bietet tägliche Gratis‑Credits, um die Lip‑Sync‑Funktion zu testen. Für längere Videos oder kommerzielle Nutzung sind Premium‑Pläne verfügbar.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Wie synchronisiere ich Lippen zu Audio in einem Video?',
                    answer: 'Laden Sie Ihren Videoclip bei 微鲤AI hoch. Laden Sie dann eine Audiodatei (MP3/WAV) hoch oder tippen Sie Text, um KI‑Sprache zu erzeugen. Klicken Sie auf "Create" – unsere KI passt die Mundbewegungen an den Ton an.',
                },
                {
                    question: 'Kann ich das für Videoübersetzung/Dubbing nutzen?',
                    answer: 'Ja! Das ist ideal fürs Dubbing. Laden Sie eine übersetzte Audiospur hoch, und die KI korrigiert den Lip‑Sync, damit die synchronisierte Version natürlich aussieht.',
                },
                {
                    question: 'Funktioniert es auch mit Standbildern (Talking Heads)?',
                    answer: 'Ja. Wenn Sie ein statisches Portraitfoto als „Video“-Quelle hochladen, animiert das Tool es zu einem Talking‑Head‑Video (Live‑Portrait‑Effekt).',
                },
            ],
        },
        translateVideoSubtitle: {
            title: 'Kostenloser KI-Video-Untertitel-Übersetzer – Automatisch untertiteln & online übersetzen | 微鲤AI',
            description: 'Erstellen und übersetzen Sie Video-Untertitel automatisch mit WeryAIs KI-Untertitel-Übersetzer. Unterstützt Englisch, Spanisch, Chinesisch und 90+ Sprachen. Laden Sie sofort Videos mit eingebrannten Untertiteln (Hardsubs) herunter.',
            keywords: 'KI-Untertitel-Übersetzung, Video-Untertitel-Übersetzer, mehrsprachige Untertitel, Video-Übersetzung, Untertitel-Konverter, KI-Video-Übersetzung',
            og_title: 'Kostenloser KI-Video-Untertitel-Übersetzer – Automatisch untertiteln & online übersetzen | 微鲤AI',
            og_description: 'Erstellen und übersetzen Sie Video-Untertitel automatisch mit WeryAIs KI-Untertitel-Übersetzer. Unterstützt Englisch, Spanisch, Chinesisch und 90+ Sprachen. Laden Sie sofort Videos mit eingebrannten Untertiteln (Hardsubs) herunter.',
            twitter_title: 'Kostenloser KI-Video-Untertitel-Übersetzer – Automatisch untertiteln & online übersetzen | 微鲤AI',
            twitter_description: 'Erstellen und übersetzen Sie Video-Untertitel automatisch mit WeryAIs KI-Untertitel-Übersetzer. Unterstützt Englisch, Spanisch, Chinesisch und 90+ Sprachen. Laden Sie sofort Videos mit eingebrannten Untertiteln (Hardsubs) herunter.',
            page: {
                title1: 'Kostenloser KI-Video-Untertitel-Übersetzer',
                title2: 'Durchbrechen Sie Sprachbarrieren sofort. Laden Sie Ihr Video hoch, wählen Sie die Zielsprache, und unsere KI erkennt Sprache, transkribiert Audio und brennt präzise übersetzte Untertitel direkt in Ihre Videodatei ein.',
                feature_title1: '90+ Sprachen',
                feature_desc1: 'Übersetzen Sie Inhalte von Englisch nach Spanisch, Französisch, Deutsch, Japanisch, Chinesisch und mehr – erreichen Sie ein globales Publikum mit einem Klick.',
                feature_title2: 'Auto‑Sync & Einbrennen',
                feature_desc2: 'Keine manuelle Zeitstempel‑Anpassung. Unsere KI synchronisiert Untertitel perfekt mit dem Audio und brennt sie in das Video ein (Hardsubs) – für maximale Kompatibilität.',
                feature_title3: 'Kontext‑basierte Genauigkeit',
                feature_desc3: 'Dank fortschrittlicher LLMs versteht 微鲤AI Kontext und Slang und liefert natürliche, präzise Übersetzungen statt roboterhafter Wort‑für‑Wort‑Übertragungen.',
                faq: [
                    {
                        question: 'Wie übersetze ich Video-Untertitel automatisch?',
                        answer: 'Laden Sie Ihr Video bei 微鲤AI hoch, wählen Sie die „Target Language“ (z. B. Englisch→Spanisch) und klicken Sie auf „Create“. Unsere KI erstellt und übersetzt die Untertitel automatisch.',
                    },
                    {
                        question: 'Welche Sprachen werden unterstützt?',
                        answer: 'Wir unterstützen über 90 Sprachen weltweit, darunter Englisch, Spanisch, Französisch, Deutsch, Portugiesisch, Hindi, Japanisch und Chinesisch.',
                    },
                    {
                        question: 'Ist der Untertitel-Übersetzer kostenlos?',
                        answer: 'Ja. 微鲤AI bietet kostenlosen Zugriff auf den KI‑Video‑Untertitel‑Übersetzer. Sie können Videos verarbeiten, ohne teure Transkriptionsdienste zu bezahlen.',
                    },
                    {
                        question: 'Muss ich eine SRT-Datei herunterladen?',
                        answer: 'Nein. 微鲤AI erzeugt Videos mit eingebrannten Untertiteln (Hardsubs). Dadurch werden Ihre Untertitel auf TikTok, Instagram und YouTube korrekt angezeigt.',
                    },
                    {
                        question: 'Wie genau ist die KI-Übersetzung?',
                        answer: 'Wir nutzen modernste Spracherkennungsmodelle für hohe Genauigkeit. Bei klarem Audio kann die Genauigkeit über 95% liegen.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Wie übersetze ich Video-Untertitel automatisch?',
                    answer: 'Laden Sie Ihr Video bei 微鲤AI hoch, wählen Sie die Target Language und klicken Sie auf Create. Unsere KI erstellt und übersetzt die Untertitel automatisch.',
                },
                {
                    question: 'Welche Sprachen werden unterstützt?',
                    answer: 'Wir unterstützen über 90 Sprachen weltweit, darunter Englisch, Spanisch, Französisch, Deutsch, Portugiesisch, Hindi, Japanisch und Chinesisch.',
                },
                {
                    question: 'Muss ich eine SRT-Datei herunterladen?',
                    answer: 'Nein. 微鲤AI erzeugt Videos mit eingebrannten Untertiteln (Hardsubs), die auf allen sozialen Plattformen korrekt angezeigt werden.',
                },
            ],
        },
        videoToAnime: {
            title: 'Kostenloser KI Video‑zu‑Anime Konverter – Real zu Cartoon & Pixar | 微鲤AI',
            description: 'Verwandeln Sie Videos sofort in japanischen Anime, 3D‑Pixar‑Stil oder Cartoons mit WeryAIs Video‑zu‑Anime‑Konverter. Frame‑by‑Frame‑Stabilität für flüssige Animation. Kostenlos & online.',
            keywords: 'Video zu Anime, KI Anime Filter, Video zu Cartoon, Pixar Video Filter, Real zu Anime, domoai Alternative, Anime Video Generator',
            og_title: 'Kostenloser KI Video‑zu‑Anime Konverter – Real zu Cartoon & Pixar | 微鲤AI',
            og_description: 'Verwandeln Sie Videos sofort in japanischen Anime, 3D‑Pixar‑Stil oder Cartoons mit WeryAIs Video‑zu‑Anime‑Konverter. Frame‑by‑Frame‑Stabilität für flüssige Animation. Kostenlos & online.',
            twitter_title: 'Kostenloser KI Video‑zu‑Anime Konverter – Real zu Cartoon & Pixar | 微鲤AI',
            twitter_description: 'Verwandeln Sie Videos sofort in japanischen Anime, 3D‑Pixar‑Stil oder Cartoons mit WeryAIs Video‑zu‑Anime‑Konverter. Frame‑by‑Frame‑Stabilität für flüssige Animation. Kostenlos & online.',
            page: {
                title1: 'Kostenloser KI Video‑zu‑Anime Konverter',
                title2: 'Verwandeln Sie sich mit einem Klick in einen Anime‑Protagonisten. Laden Sie ein Real‑Video hoch, wählen Sie einen Stil (Pixar 3D, klassisches 2D oder Hand‑Drawn) und lassen Sie unsere KI das Material Frame für Frame restylen – bei gleichmäßigem, konsistentem Motion‑Flow.',
                feature_desc1: '<div><p>Pixar & 3D: Erstellen Sie süße, Disney‑artige 3D‑Clips – perfekt für Familienvideos.</p><p>Classic Anime: Authentischer japanischer Anime‑Look (Ghibli/Shinkai‑Stil).</p><p>Sketch & Ink: Verwandeln Sie Videos in künstlerische, handgezeichnete Bleistift‑Animationen.</p></div>',
                feature_title2: 'Frame‑by‑Frame‑Stabilität',
                feature_desc2: 'Genervt von flackernden KI‑Videos? 微鲤AI nutzt fortschrittliche temporale Konsistenz‑Algorithmen, damit Ihr Anime‑Video ohne typische „Jitter“ flüssig abläuft.',
                feature_title3: 'Viral‑Content‑Creator',
                feature_desc3: 'Für TikTok & Reels gemacht. Erstellen Sie trendige „Real vs Anime“‑Vergleichsvideos, die sofort Aufmerksamkeit ziehen.',
                faq: [
                    {
                        question: 'Wie mache ich ein Video kostenlos zu Anime?',
                        answer: 'Laden Sie Ihren Clip in WeryAIs Video‑zu‑Anime‑Tool hoch. Wählen Sie ein Preset (z. B. „2D Style“ oder „Pixar Style“) und klicken Sie auf Create. Mit täglichen Credits kostenlos testbar.',
                    },
                    {
                        question: 'Kann ich Video in Pixar/Disney‑Stil umwandeln?',
                        answer: 'Ja! Wir bieten ein Preset „3D Cartoon“ bzw. „Pixar Style“, das reale Personen in süße 3D‑Charaktere verwandelt – ähnlich populären Filmstilen.',
                    },
                    {
                        question: 'Wie lang darf das Video sein?',
                        answer: 'Aktuell unterstützen wir Clips bis zu 30 Sekunden (siehe „Maximum video duration: 30s“). Ideal für Shorts, Reels und TikTok.',
                    },
                    {
                        question: 'Bewegt sich der Anime‑Charakter wie ich?',
                        answer: 'Absolut. Unsere KI analysiert Skelettbewegungen und Mimik, damit der Charakter Ihre Aktionen möglichst genau nachahmt.',
                    },
                    {
                        question: 'Was ist der beste Video‑zu‑Anime‑Konverter?',
                        answer: '微鲤AI wird oft gewählt, weil es mehrere 2D/3D‑Stile bietet und auf Stabilität setzt, um Flimmern und visuelles Rauschen zu reduzieren.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Wie mache ich ein Video kostenlos zu Anime?',
                    answer: 'Laden Sie Ihren Clip bei 微鲤AI hoch, wählen Sie ein Preset (2D Style oder Pixar Style) und klicken Sie auf Create.',
                },
                {
                    question: 'Kann ich Video in Pixar/Disney‑Stil umwandeln?',
                    answer: 'Ja. Wir bieten ein Preset 3D Cartoon/Pixar Style, das reale Menschen in süße 3D‑Charaktere verwandelt.',
                },
                {
                    question: 'Bewegt sich der Anime‑Charakter wie ich?',
                    answer: 'Ja. Die KI analysiert Bewegungen und Mimik, damit der Charakter Ihre Aktionen nachahmt.',
                },
            ],
            app_name: '微鲤AI Video‑zu‑Anime Konverter',
            app_desc: 'Kostenloses KI‑Tool zum Umwandeln echter Videos in Anime‑, Cartoon‑ und Pixar‑Stile. Frame‑by‑Frame‑Rendering für stabile Animation.',
            featureList: 'Real→Anime, Pixar‑Filter, Frame‑Konsistenz, 2D/3D‑Stile',
        },
        videoUpscaler: {
            title: 'Kostenloser KI Video Upscaler & Enhancer - Online bis 4K hochskalieren | 微鲤AI',
            description: 'Skalieren Sie Low‑Res‑Videos sofort auf 1080p, 2K und 4K – mit WeryAIs kostenlosem KI Video Upscaler. Behebt Pixelbildung, reduziert Rauschen und verbessert die Qualität online – ohne Installation.',
            keywords: 'video upscaler, KI video enhancer, video auf 4k hochskalieren, video entblur, video rauschen reduzieren, videoqualität verbessern, kostenloser online video upscaler',
            og_title: 'Kostenloser KI Video Upscaler & Enhancer - Online bis 4K hochskalieren | 微鲤AI',
            og_description: 'Skalieren Sie Low‑Res‑Videos sofort auf 1080p, 2K und 4K – mit WeryAIs kostenlosem KI Video Upscaler. Behebt Pixelbildung, reduziert Rauschen und verbessert die Qualität online – ohne Installation.',
            twitter_title: 'Kostenloser KI Video Upscaler & Enhancer - Online bis 4K hochskalieren | 微鲤AI',
            twitter_description: 'Skalieren Sie Low‑Res‑Videos sofort auf 1080p, 2K und 4K – mit WeryAIs kostenlosem KI Video Upscaler. Behebt Pixelbildung, reduziert Rauschen und verbessert die Qualität online – ohne Installation.',
            page: {
                title1: 'Kostenloser KI Video Upscaler & Enhancer',
                title2: 'Geben Sie sich nicht mit verschwommenem, pixeligem Material zufrieden. Laden Sie Low‑Res‑Videos (360p, 480p, 720p) hoch und lassen Sie unsere KI automatisch auf beeindruckende 4K hochskalieren. Nicht nur größer – auch Details wiederherstellen, Rauschen entfernen und Farben korrigieren.',
                feature_title1: 'Bis 4K hochskalieren',
                feature_desc1: 'Bringen Sie alte Videos zurück. Wandeln Sie SD mit einem Klick in HD oder 4K um – scharf auf modernen großen Displays.',
                feature_title2: 'Verschwommene & körnige Videos reparieren',
                feature_desc2: 'Bei wenig Licht aufgenommen? Unser KI‑Denoising entfernt digitales Korn und Kompressionsartefakte – sauber und professionell.',
                feature_title3: 'Altes Material restaurieren',
                feature_desc3: 'Perfekt für Familienarchive. Stellen Sie verblasste Farben wieder her und schärfen Sie Details in alten Home‑Videos oder Vintage‑Clips.',
                faq: [
                    {
                        question: 'Kann ich Videos kostenlos online auf 4K hochskalieren?',
                        answer: 'Ja. 微鲤AI ermöglicht Ausgabeauflösungen bis 4K (siehe Tool‑Optionen). Mit täglichen Credits kostenlos testbar.',
                    },
                    {
                        question: 'Wie behebe ich ein verschwommenes Video?',
                        answer: 'Laden Sie das verschwommene Video in den KI Video Upscaler hoch. Die KI analysiert verlorene Pixel und rekonstruiert Details, um das Material zu entblurren.',
                    },
                    {
                        question: 'Funktioniert das bei alten Handyvideos?',
                        answer: 'Absolut. Besonders bei 360p/480p‑Clips von alten Handys/Kameras – sie werden in klare 1080p oder höher transformiert.',
                    },
                    {
                        question: 'Wie lange dauert der Upscaling‑Prozess?',
                        answer: 'Upscaling ist rechenintensiv. 微鲤AI nutzt jedoch optimierte Cloud‑GPUs. Ein kurzer Clip dauert typischerweise nur wenige Minuten.',
                    },
                    {
                        question: 'Ist es besser als Topaz Video AI?',
                        answer: '微鲤AI bietet vergleichbare KI‑Qualität und läuft komplett im Browser – ohne teure Hardware oder Installation.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Kann ich Videos online auf 4K hochskalieren?',
                    answer: 'Ja. 微鲤AI unterstützt Ausgaben bis 4K – kostenlos testbar mit täglichen Credits.',
                },
                {
                    question: 'Wie behebe ich ein verschwommenes Video?',
                    answer: 'Video hochladen – die KI rekonstruiert Details und reduziert Unschärfe.',
                },
                {
                    question: 'Ist es besser als Topaz Video AI?',
                    answer: '微鲤AI bietet vergleichbare Qualität und läuft im Browser, ohne Installation oder teure Hardware.',
                },
            ],
            app_name: '微鲤AI Video Upscaler',
            app_desc: 'Kostenloser KI Video Upscaler zur Qualitätsverbesserung bis 4K. Repariert Unschärfe, entfernt Rauschen und restauriert altes Material online.',
            featureList: '4K Upscaling, KI‑Denoising, Video‑Sharpening, Farbkorrektur',
        },
        removeVideoSubtitles: {
            title: 'Video-Untertitel Entfernen - KI-Untertitel-Entferner | 微鲤AI',
            description: 'Entfernen Sie eingebettete Untertitel aus Videos mit KI-Technologie. Löschen Sie intelligent hart codierte Untertitel und Text aus Videos und bewahren Sie dabei die Videoqualität. Schnell und einfach zu verwenden.',
            keywords: 'Video-Untertitel entfernen, Untertitel-Entferner, Untertitel entfernen, Untertitel löschen, Video-Untertitel-Entfernung, hart codierte Untertitel entfernen',
            og_title: 'Video-Untertitel Entfernen - KI-Untertitel-Entferner | 微鲤AI',
            og_description: 'Entfernen Sie eingebettete Untertitel aus Videos mit KI-Technologie. Löschen Sie intelligent hart codierte Untertitel und Text aus Videos und bewahren Sie dabei die Videoqualität. Schnell und einfach zu verwenden.',
            twitter_title: 'Video-Untertitel Entfernen - KI-Untertitel-Entferner | 微鲤AI',
            twitter_description: 'Entfernen Sie eingebettete Untertitel aus Videos mit KI-Technologie. Löschen Sie intelligent hart codierte Untertitel und Text aus Videos und bewahren Sie dabei die Videoqualität. Schnell und einfach zu verwenden.',
            page: {
                title1: 'Kostenloser KI‑Untertitel‑Entferner',
                title2: 'Genervt von eingebrannten Untertiteln? WeryAIs intelligenter Algorithmus erkennt und entfernt automatisch hart codierte Untertitel, Lyrics und Bildschirmtext aus Ihren Videos. Link einfügen oder Datei hochladen – und in Sekunden ein sauberes, textfreies Video erhalten.',
                feature_title1: 'Intelligente Texterkennung',
                feature_desc1: 'Kein manuelles Maskieren. Die KI erkennt Textbereiche unten (oder überall) automatisch und trennt sie vom Hintergrund.',
                feature_title2: 'Nahtloses In‑painting',
                feature_desc2: 'Keine verschwommenen Kästen mehr. 微鲤AI füllt die entfernte Textfläche, indem es umliegende Pixel analysiert und Texturen wie Gras, Sand oder Menschenmengen natürlich rekonstruiert.',
                feature_title3: 'Link‑ & Datei‑Support',
                feature_desc3: 'Untertitel direkt aus TikTok-, YouTube- oder Instagram‑Links entfernen oder MP4/MOV hochladen. Perfekt für Content‑Repurposing.',
                faq: [
                    {
                        question: 'Kann ich hart codierte (eingebrannte) Untertitel entfernen?',
                        answer: 'Ja. Dieses Tool ist speziell für hart codierte Untertitel gedacht, die Teil des Bildes sind und nicht ausgeschaltet werden können. Es entfernt sie visuell.',
                    },
                    {
                        question: 'Wie entferne ich Captions aus einem TikTok/YouTube‑Video?',
                        answer: 'Kopieren Sie den Videolink, fügen Sie ihn im “Video Link”‑Tab bei 微鲤AI ein und klicken Sie auf “Generate”. Die KI entfernt die Captions und Sie können das saubere Video herunterladen.',
                    },
                    {
                        question: 'Entfernt es auch den Hintergrund hinter dem Text?',
                        answer: 'Nein. 微鲤AI nutzt AI In‑painting: Es entfernt den Text und “malt” den Hintergrund dahinter intelligent neu, damit das Video original und vollständig wirkt.',
                    },
                    {
                        question: 'Was ist der Unterschied zum Wasserzeichen‑Entferner?',
                        answer: 'Ähnlich, aber der Untertitel‑Entferner ist für Textstreifen, Lyrics und Captions (oft unten) optimiert, während der Wasserzeichen‑Entferner auf Logos und Stempel fokussiert.',
                    },
                    {
                        question: 'Ist es kostenlos?',
                        answer: 'Ja, Sie können die Grundfunktionen kostenlos mit täglichen Credits nutzen.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Kann ich hart codierte Untertitel entfernen?',
                    answer: 'Ja. Dieses Tool ist für hart codierte Untertitel gedacht, die Teil des Videobildes sind. Es entfernt sie visuell.',
                },
                {
                    question: 'Wie entferne ich Captions aus einem TikTok‑Link?',
                    answer: 'Kopieren Sie den Link, fügen Sie ihn in den “Video Link”‑Tab ein und klicken Sie auf “Generate”. Die KI entfernt die Captions automatisch.',
                },
                {
                    question: 'Wird der Hintergrund hinter dem Text beschädigt?',
                    answer: 'Nein. 微鲤AI verwendet AI In‑painting, um den Text zu entfernen und den Hintergrund intelligent zu rekonstruieren.',
                },
            ],
            app_name: '微鲤AI Untertitel‑Entferner',
            app_desc: 'Kostenloses KI‑Tool zum Entfernen von eingebrannten Untertiteln, Captions und Text aus Videos. Stellt Hintergründe per In‑painting wieder her – ohne verschwommene Blöcke.',
            featureList: 'Hardcoded Untertitel entfernen, KI‑Hintergrund‑Wiederherstellung, Video‑Link‑Support, Lyrics‑Radierer',
        },
        videoBackgroundRemover: {
            title: 'Video-Hintergrund-Entferner - Video-Hintergrund mit KI Entfernen | 微鲤AI',
            description: 'Entfernen Sie Hintergründe aus Videos automatisch mit KI. Erstellen Sie Greenscreen-Effekte, isolieren Sie Motive und ersetzen Sie Videohintergründe einfach. Perfekt für Content-Ersteller und Video-Editoren.',
            keywords: 'Video-Hintergrund-Entferner, Video-Hintergrund entfernen, Greenscreen, KI-Hintergrundentfernung, Video-Hintergrund-Radierer, Video-Motiv isolieren',
            og_title: 'Video-Hintergrund-Entferner - Video-Hintergrund mit KI Entfernen | 微鲤AI',
            og_description: 'Entfernen Sie Hintergründe aus Videos automatisch mit KI. Erstellen Sie Greenscreen-Effekte, isolieren Sie Motive und ersetzen Sie Videohintergründe einfach. Perfekt für Content-Ersteller und Video-Editoren.',
            twitter_title: 'Video-Hintergrund-Entferner - Video-Hintergrund mit KI Entfernen | 微鲤AI',
            twitter_description: 'Entfernen Sie Hintergründe aus Videos automatisch mit KI. Erstellen Sie Greenscreen-Effekte, isolieren Sie Motive und ersetzen Sie Videohintergründe einfach. Perfekt für Content-Ersteller und Video-Editoren.',
            page: {
                title1: 'Kostenloser KI‑Video‑Hintergrund‑Entferner',
                title2: 'Kein Greenscreen? Kein Problem. Laden Sie Ihr Video hoch – unsere KI erkennt das Motiv automatisch, schneidet es mit Haar‑Präzision aus und lässt Sie ein transparentes Video herunterladen oder den Hintergrund sofort durch eine Vollfarbe ersetzen.',
                feature_title1: 'Kein Greenscreen nötig',
                feature_desc1: 'Vergessen Sie teure Studio‑Setups. Unsere KI trennt Menschen, Haustiere und Objekte automatisch von komplexen Hintergründen (Auto‑Rotoscoping).',
                feature_title2: 'Vollfarben‑Hintergrund',
                feature_desc2: 'Perfekt für E‑Commerce. Ändern Sie den Hintergrund Ihres Produktvideos mit einem Klick auf Reinweiß, Schwarz oder eigene Farben – für bessere Conversion.',
                feature_title3: 'Transparenter Export',
                feature_desc3: 'Exportieren Sie mit Alpha‑Kanal (WebM/MOV) und legen Sie das Motiv in Premiere Pro, DaVinci Resolve oder CapCut einfach über andere Videos.',
                faq: [
                    {
                        question: 'Kann ich den Videohintergrund ohne Greenscreen entfernen?',
                        answer: 'Ja! 微鲤AI nutzt fortschrittliches Machine Learning, um Motiv und Hintergrund zu unterscheiden – so können Sie Hintergründe von überall aufgenommenen Videos entfernen.',
                    },
                    {
                        question: 'Wie speichere ich ein Video mit transparentem Hintergrund?',
                        answer: 'Nach der Hintergrundentfernung wählen Sie WebM (Transparent) oder MOV als Ausgabeformat. Standard‑MP4 unterstützt keine Transparenz und zeigt einen schwarzen Hintergrund.',
                    },
                    {
                        question: 'Kann ich den Hintergrund auf Weiß ändern?',
                        answer: 'Ja. Nutzen Sie in den Tool‑Einstellungen den “Background Color”‑Picker für Weiß/Schwarz oder einen beliebigen Hex‑Code. Ideal für Amazon/Shopify‑Produktvideos.',
                    },
                    {
                        question: 'Funktioniert es gut bei Haaren?',
                        answer: 'Ja. Der Algorithmus ist auf feine Kanten wie Haare, Fell und halbtransparente Objekte (z. B. Brillen) trainiert.',
                    },
                    {
                        question: 'Ist es kostenlos?',
                        answer: 'Ja, Sie können Videos kostenlos mit täglichen Credits bearbeiten.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Kann ich den Videohintergrund ohne Greenscreen entfernen?',
                    answer: 'Ja! 微鲤AI benötigt keinen Greenscreen, um Motiv und Hintergrund zu trennen.',
                },
                {
                    question: 'Wie speichere ich ein Video mit transparentem Hintergrund?',
                    answer: 'Wählen Sie WebM (Transparent) oder MOV. Standard‑MP4 unterstützt keine Transparenz.',
                },
                {
                    question: 'Kann ich den Hintergrund auf Weiß ändern?',
                    answer: 'Ja. Nutzen Sie den Background‑Color‑Picker und wählen Sie Weiß – ideal für Produktvideos.',
                },
            ],
            app_name: '微鲤AI Video‑Hintergrund‑Entferner',
            app_desc: 'Kostenloses KI‑Tool zum Entfernen von Videohintergründen ohne Greenscreen. Exportieren Sie transparente Videos oder ändern Sie den Hintergrund online auf Weiß/Schwarz.',
            featureList: 'Kein Greenscreen, Transparenter Video‑Export, Hintergrundfarbe ändern, Haar‑Präzision',
            step_name: 'So entfernen Sie Videohintergründe online',
            step_list: [
                {
                    name: 'Video hochladen',
                    text: 'Laden Sie Ihr Material (MP4, MOV) in den 微鲤AI Hintergrund‑Entferner hoch.',
                },
                {
                    name: 'Hintergrund entfernen',
                    text: 'Die KI verarbeitet das Video automatisch. Sie können es transparent lassen oder eine neue Hintergrundfarbe wählen.',
                },
                {
                    name: 'Exportieren',
                    text: 'Laden Sie das Ergebnis herunter. Für Transparenz WebM/MOV, für Vollfarben MP4 wählen.',
                },
            ],
        },
        aiVideoExtender: {
            title: 'KI-Video-Verlängerung - Videolänge und -dauer Verlängern | 微鲤AI',
            description: 'Verlängern Sie die Videolänge mit KI-Technologie. Fügen Sie Ihren Videos nahtlos 5-8 Sekunden hinzu mit mehreren Stiloptionen einschließlich Anime, 3D-Animation, Cyberpunk und Comic. Perfekt für Content-Ersteller und Video-Editoren.',
            keywords: 'KI-Video-Verlängerung, Videolänge verlängern, Videodauer-Verlängerung, KI-Video-Erweiterung, Video verlängern, Videozeit verlängern, KI-Video-Tool',
            og_title: 'KI-Video-Verlängerung - Videolänge und -dauer Verlängern | 微鲤AI',
            og_description: 'Verlängern Sie die Videolänge mit KI-Technologie. Fügen Sie Ihren Videos nahtlos 5-8 Sekunden hinzu mit mehreren Stiloptionen einschließlich Anime, 3D-Animation, Cyberpunk und Comic. Perfekt für Content-Ersteller und Video-Editoren.',
            twitter_title: 'KI-Video-Verlängerung - Videolänge und -dauer Verlängern | 微鲤AI',
            twitter_description: 'Verlängern Sie die Videolänge mit KI-Technologie. Fügen Sie Ihren Videos nahtlos 5-8 Sekunden hinzu mit mehreren Stiloptionen einschließlich Anime, 3D-Animation, Cyberpunk und Comic. Perfekt für Content-Ersteller und Video-Editoren.',
            page: {
                title1: 'Kostenloser KI‑Video‑Extender & Fortsetzung',
                title2: 'Ist Ihr Video zu kurz? 微鲤AI nutzt generative KI, um neue Frames vorherzusagen und zu erzeugen – so wird Ihr Clip nahtlos länger. Sie können die Fortsetzung sogar per Prompt steuern oder Standardmaterial in butterweiches Slow Motion verwandeln.',
                feature_title1: 'Intelligente generative Verlängerung',
                feature_desc1: 'Nicht nur strecken – neue Inhalte erzeugen. Geben Sie Prompts wie „Kamera zoomt raus“ oder „Charakter dreht sich um“ ein, und die KI generiert die nächsten 5–10 Sekunden im Originalstil.',
                feature_title2: 'Butterweiches Slow Motion',
                feature_desc2: 'Machen Sie aus 30fps‑Videos hochwertige Slow‑Motion. 微鲤AI nutzt Frame Interpolation, um KI‑Frames zwischen vorhandene Frames einzufügen – flüssig ohne Ruckeln.',
                feature_title3: 'Perfekte Loops',
                feature_desc3: 'Erstellen Sie endlose Loops für Social‑Media‑Hintergründe. Die KI analysiert Start‑ und Endframes und blendet sie perfekt ineinander.',
                faq: [
                    {
                        question: 'Wie funktioniert der KI‑Video‑Extender?',
                        answer: 'Er verwendet „Generative Outpainting“. Die KI analysiert die letzten Frames Ihres Videos und Ihren Prompt, um neue Frames vorherzusagen und zu erzeugen, die logisch an die Aktion anschließen.',
                    },
                    {
                        question: 'Kann ich steuern, was im erweiterten Teil passiert?',
                        answer: 'Ja! Nutzen Sie das Feld “Prompt”, um die Aktion zu beschreiben. Wenn Ihr Video z. B. ein fahrendes Auto zeigt, tippen Sie „Auto fährt in einen Tunnel“, um die Fortsetzung zu lenken.',
                    },
                    {
                        question: 'Was ist der Unterschied zwischen Extension und Slow Motion?',
                        answer: 'Extension fügt neue Zeit hinzu, indem neue Ereignisse generiert werden (die Story wird länger). Slow Motion streckt bestehende Zeit durch Zwischenframes (die Aktion wird langsamer). 微鲤AI kann beides.',
                    },
                    {
                        question: 'Wie lange kann ich ein Video verlängern?',
                        answer: 'Sie können einen Clip pro Durchlauf um 5 Sekunden verlängern (siehe Einstellung “Extension Duration”). Wiederholen Sie den Prozess für längere Sequenzen.',
                    },
                    {
                        question: 'Ist es kostenlos?',
                        answer: 'Ja, 微鲤AI bietet kostenlose Credits zum Testen von Video‑Verlängerung und Slow‑Motion‑Effekten.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Wie funktioniert der KI‑Video‑Extender?',
                    answer: 'Mit „Generative Outpainting“ analysiert die KI die letzten Frames und Ihren Prompt und erzeugt die Fortsetzung.',
                },
                {
                    question: 'Kann ich den erweiterten Teil steuern?',
                    answer: 'Ja. Beschreiben Sie die Aktion im “Prompt” (z. B. „Auto fährt in einen Tunnel“).',
                },
                {
                    question: 'Unterschied zwischen Extension und Slow Motion?',
                    answer: 'Extension erzeugt neue Ereignisse, Slow Motion fügt Zwischenframes hinzu, um die Aktion zu verlangsamen.',
                },
            ],
            app_name: '微鲤AI Video‑Extender',
            app_desc: 'Kostenloses KI‑Tool zum Verlängern von Videos mit generativem Fill und Prompts. Zusätzlich mit KI‑Slow‑Motion (Frame Interpolation) und Loop‑Erstellung.',
            featureList: 'Generative Video‑Verlängerung, Prompt‑gesteuerte Fortsetzung, KI‑Slow‑Motion, Video‑Loops',
        },
        videoEffects: {
            title: 'Videoeffekte - Erstellen Sie Virale Videos mit KI | 微鲤AI',
            description: 'Erkunden Sie beliebte KI-Videoeffekte auf 微鲤AI. Von KI-Kuss bis KI-Tanz, erstellen Sie virale Videos mit nur wenigen Klicks.',
            keywords: 'KI-Videoeffekte, virale KI-Videos, Videotrends, KI-Kuss, KI-Tanz, Videogenerator',
        },
        aiDancing: {
            title: 'KI-Tanzvideo-Generator - Kostenloser KI-Tanzvideo-Ersteller | 微鲤AI',
            description: 'Verwenden Sie WeryAIs KI-Tanzgenerator, um erstaunliche Tanzvideos aus Fotos zu erstellen. Unterstützt mehrere Tanzvorlagen und -stile, erwecken Sie Ihre Fotos zum Leben!',
            keywords: 'KI-Tanzvideo, KI-Tanzgenerator, Foto zu Video, KI-Videogenerierung, 微鲤AI, kostenlose KI-Tools',
        },
        aiKissing: {
            title: 'aiKissing | 微鲤AI',
            description: 'Experience aiKissing on 微鲤AI platform.',
            keywords: 'aiKissing, AI, 微鲤AI',
        },
        videoMotionImitation: {
            title: 'KI-Video-Bewegungsnachahmung - Fotos Kostenlos zum Leben Erwecken | 微鲤AI',
            description: 'Das KI-Video-Bewegungsnachahmungstool von 微鲤AI kann Foto-Charaktere in Referenzvideos integrieren, ursprüngliche Charaktere ersetzen und dabei die Beleuchtung und Töne der Szene bewahren, um eine nahtlose Umgebungsfusion zu erreichen.',
            keywords: 'KI-Video-Bewegungsnachahmung, Fotos zum Leben erwecken, KI-Video-Bewegungsnachahmungstool, 微鲤AI, kostenlose KI-Tools',
            og_title: 'KI-Video-Bewegungsnachahmung - Fotos Kostenlos zum Leben Erwecken | 微鲤AI',
            og_description: 'Das KI-Video-Bewegungsnachahmungstool von 微鲤AI kann Foto-Charaktere in Referenzvideos integrieren, ursprüngliche Charaktere ersetzen und dabei die Beleuchtung und Töne der Szene bewahren, um eine nahtlose Umgebungsfusion zu erreichen.',
            twitter_title: 'KI-Video-Bewegungsnachahmung - Fotos Kostenlos zum Leben Erwecken | 微鲤AI',
            twitter_description: 'Das KI-Video-Bewegungsnachahmungstool von 微鲤AI kann Foto-Charaktere in Referenzvideos integrieren, ursprüngliche Charaktere ersetzen und dabei die Beleuchtung und Töne der Szene bewahren, um eine nahtlose Umgebungsfusion zu erreichen.',
            page: {
                title1: 'Kostenloser KI-Tanzgenerator & Motion Transfer',
                title2: 'Sie wollen Ihren Lieblings-Anime-Charakter wie Michael Jackson tanzen sehen? Oder ein statisches Foto einen viralen TikTok-Move ausführen lassen? Laden Sie ein Referenzvideo und ein Charakterbild hoch – unsere KI überträgt die Bewegung präzise.',
                feature_title1: 'Video-Charakter-Austausch',
                feature_desc1: 'Real→Anime Swap: Laden Sie ein Tanz-/Actionvideo hoch und ersetzen Sie die Person durch einen 3D-Charakter, Panda oder Anime-Avatar – Hintergrund und Licht bleiben erhalten.',
                feature_title2: 'Fotos tanzen lassen',
                feature_desc2: 'Statische Bilder animieren: Laden Sie ein Foto von sich oder einer Figur hoch, wählen Sie ein Referenz-Tanzvideo und sehen Sie, wie das Foto die Moves nachahmt. Ideal für viralen Viggle-Style-Content.',
                feature_title3: 'Dimensionen durchbrechen',
                feature_desc3: 'Cross-Dimensional Styles: Ob Ballerina→Anime-Girl oder Karate-Kid→Panda – 微鲤AI verarbeitet komplexe Körperstrukturen und Verdeckungen nahtlos.',
                faq: [
                    {
                        question: 'Wie lasse ich ein Foto mit KI tanzen?',
                        answer: 'Verwenden Sie WeryAIs „Move Mode“. Laden Sie das Foto (Character Image) und ein Video mit den Bewegungen (Reference Video) hoch. Klicken Sie auf Create, um die Bewegung zu übertragen.',
                    },
                    {
                        question: 'Was ist der Unterschied zwischen Move Mode und Replace Mode?',
                        answer: 'Move Mode animiert ein statisches Bild mit der Bewegung eines Videos. Replace Mode ersetzt die Person in einem vorhandenen Video durch einen neuen Charakter aus einem Bild.',
                    },
                    {
                        question: 'Kann ich das für TikTok-Trends nutzen?',
                        answer: 'Ja! Perfekt für TikTok-Challenges: Lassen Sie Promis, Anime-Charaktere oder Freunde trendige Tänze ausführen – ohne sie zu lernen.',
                    },
                    {
                        question: 'Funktioniert es auch bei Ganzkörper-Aufnahmen?',
                        answer: 'Ja. Für beste Ergebnisse sollten Referenzvideo und Bild den ganzen Körper klar zeigen, damit die KI Gliedmaßen korrekt trackt.',
                    },
                    {
                        question: 'Ist es kostenlos?',
                        answer: 'Ja, Sie können mit Ihren täglichen Credits kostenlos Motion-Transfer-Videos erstellen.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Wie lasse ich ein Foto mit KI tanzen?',
                    answer: 'Verwenden Sie WeryAIs „Move Mode“. Laden Sie das Foto (Character Image) und ein Video mit den Bewegungen (Reference Video) hoch. Klicken Sie auf Create, um die Bewegung zu übertragen.',
                },
                {
                    question: 'Was ist der Unterschied zwischen Move Mode und Replace Mode?',
                    answer: 'Move Mode animiert ein statisches Bild mit der Bewegung eines Videos. Replace Mode ersetzt die Person in einem vorhandenen Video durch einen neuen Charakter aus einem Bild.',
                },
            ],
            app_name: '微鲤AI Motion Transfer',
            app_desc: 'Kostenloser KI-Tanzgenerator und Motion Transfer. Lassen Sie Fotos tanzen, animieren Sie statische Bilder und tauschen Sie Video-Charaktere online aus.',
            featureList: 'KI-Tanzgenerierung, Körperpose-Transfer, Video-Charakter-Swap, Foto animieren',
            step_name: 'So lassen Sie ein Foto mit KI tanzen',
            step_list: [
                {
                    name: 'Referenzvideo hochladen',
                    text: 'Laden Sie ein Video hoch, das die Tanzschritte oder Bewegung enthält, die Sie kopieren möchten.',
                },
                {
                    name: 'Charakterbild hochladen',
                    text: 'Laden Sie das statische Foto der Person oder Figur hoch, die Sie animieren möchten.',
                },
                {
                    name: 'Move Mode auswählen',
                    text: 'Wählen Sie „Move Mode“ und klicken Sie auf Create. Die KI lässt das Foto die Bewegungen aus dem Video ausführen.',
                },
            ],
        },
    },
    ru: {
        textToMusic: {
            title: 'Генератор Музыки с ИИ - Создавайте Уникальную Музыку с 微鲤AI | 微鲤AI',
            description: 'Откройте для себя Генератор Музыки с ИИ от 微鲤AI. Быстро создавайте уникальную, бесплатную музыку, адаптированную для ваших проектов, с помощью передовой технологии ИИ. Идеально для создателей контента, разработчиков игр и любителей музыки.',
            keywords: 'текст в музыку, текст в музыку бесплатно, ИИ текст в музыку, генератор музыки ИИ, создатель песен ИИ, создать похожую музыку, создание музыки, музыка без авторских прав, скачать музыку бесплатно, 微鲤AI',
        },
        textToVideo: {
            title: 'Бесплатный AI Text‑to‑Video генератор (Veo 3.1, Kling и Sora) | 微鲤AI',
            description: 'Превратите текстовые промпты в кинематографичные видео мгновенно с Text‑to‑Video AI от 微鲤AI. Работает на Google Veo 3.1, Kling и Sora. Поддержка 16:9 и 9:16, длительность до 8 секунд. Доступны опции без водяных знаков.',
            keywords: 'текст в видео ИИ, генератор видео ИИ, google veo 3.1, промпт в видео, kling ai, sora, txt2vid, 微鲤AI',
            og_title: 'Бесплатный AI Text‑to‑Video генератор (Veo 3.1, Kling и Sora) | 微鲤AI',
            og_description: 'Превратите текстовые промпты в кинематографичные видео мгновенно с Text‑to‑Video AI от 微鲤AI. Работает на Google Veo 3.1, Kling и Sora. Поддержка 16:9 и 9:16, длительность до 8 секунд. Доступны опции без водяных знаков.',
            twitter_title: 'Бесплатный AI Text‑to‑Video генератор (Veo 3.1, Kling и Sora) | 微鲤AI',
            twitter_description: 'Превратите текстовые промпты в кинематографичные видео мгновенно с Text‑to‑Video AI от 微鲤AI. Работает на Google Veo 3.1, Kling и Sora. Поддержка 16:9 и 9:16, длительность до 8 секунд. Доступны опции без водяных знаков.',
            page: {
                title1: 'Бесплатный AI Text‑to‑Video генератор',
                title2: 'Просто введите промпт — и 微鲤AI превратит идею в видео. Наш Text‑to‑Video агрегирует передовые модели вроде Google Veo 3.1 и Kling AI, позволяя создавать качественные, физически правдоподобные ролики для соцсетей (9:16) или кино‑формата (16:9) за секунды.',
                intro_title: 'Превратите воображение в реальность с Text‑to‑Video AI',
                feature_title: 'Возможности 微鲤AI Text‑to‑Video',
                faq_title: 'FAQ по Text‑to‑Video',
                feature_title1: 'Сила нескольких моделей',
                feature_desc1: 'Переключайтесь между Veo 3.1 для реализма и Kling для стабильного движения. Без множества подписок.',
                feature_title2: 'Нужное соотношение сторон',
                feature_desc2: 'Генерируйте вертикальные видео (9:16) для TikTok/Reels или 16:9 для YouTube напрямую.',
                feature_title3: 'Увеличенная длительность',
                feature_desc3: 'Создавайте видео до 8 секунд (или дольше с расширением) за одну генерацию — идеально для сторителлинга.',
                faq: [
                    {
                        question: 'Как написать хороший промпт для text‑to‑video?',
                        answer: 'Будьте конкретны: субъект, действие, свет и угол камеры. Пример: «Кинематографичный дрон‑шот футуристического киберпанк‑города ночью, неон, 4K».',
                    },
                    {
                        question: 'Что выбрать: Google Veo 3.1 или Kling?',
                        answer: 'Veo 3.1 даёт высокую детализацию и хорошее следование промпту, подходит для реалистичных сцен. Kling часто лучше для сложных движений персонажей. Рекомендуем попробовать оба.',
                    },
                    {
                        question: '微鲤AI Text‑to‑Video бесплатно?',
                        answer: 'Да. Каждый пользователь получает ежедневные бесплатные кредиты для генерации видео из текста.',
                    },
                    {
                        question: 'Можно ли делать видео длиннее 8 секунд?',
                        answer: 'Базовая генерация — до 8 секунд (зависит от модели). Для более длинных роликов используйте AI Video Extender, чтобы продолжить клип без швов.',
                    },
                    {
                        question: 'Будет ли звук в сгенерированных видео?',
                        answer: 'Да. Включите переключатель “Generate Audio”, чтобы автоматически создать подходящие звуки и атмосферу.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Как написать хороший промпт для text‑to‑video?',
                    answer: 'Опишите субъект, действие, свет и камеру. Пример: «киберпанк‑город ночью, неон, дрон, 4K».',
                },
                {
                    question: 'Что выбрать: Google Veo 3.1 или Kling?',
                    answer: 'Veo 3.1 сильнее в реализме и следовании промпту, Kling — в движении. Протестируйте оба.',
                },
                {
                    question: '微鲤AI Text‑to‑Video бесплатно?',
                    answer: 'Да. Есть ежедневные бесплатные кредиты.',
                },
                {
                    question: 'Можно ли делать видео длиннее 8 секунд?',
                    answer: 'База до 8 секунд; для большего используйте AI Video Extender.',
                },
                {
                    question: 'Будет ли звук в сгенерированных видео?',
                    answer: 'Да. Включите “Generate Audio” для автогенерации звука.',
                },
            ],
        },
        imageToVideo: {
            title: 'AI Генератор Изображение→Видео (Бесплатно и онлайн) — Kling, Veo и Sora',
            description: 'Преобразуйте статичные фото в реалистичные видео за секунды с бесплатным AI Image→Video от 微鲤AI. Используйте топ‑модели Kling, Google Veo и Sora 2 в одном месте. Доступны опции без водяных знаков.',
            keywords: 'изображение в видео ИИ, генератор видео ИИ, анимация изображения, Sora видео, Veo видео, Seedance видео, видео инструменты 微鲤AI',
            og_title: 'AI Генератор Изображение→Видео (Бесплатно и онлайн) — Kling, Veo и Sora',
            og_description: 'Преобразуйте статичные фото в реалистичные видео за секунды с бесплатным AI Image→Video от 微鲤AI. Используйте топ‑модели Kling, Google Veo и Sora 2 в одном месте. Доступны опции без водяных знаков.',
            twitter_title: 'AI Генератор Изображение→Видео (Бесплатно и онлайн) — Kling, Veo и Sora',
            twitter_description: 'Преобразуйте статичные фото в реалистичные видео за секунды с бесплатным AI Image→Video от 微鲤AI. Используйте топ‑модели Kling, Google Veo и Sora 2 в одном месте. Доступны опции без водяных знаков.',
            page: {
                title1: 'Бесплатный онлайн AI Генератор Изображение→Видео',
                faq: [
                    {
                        question: 'Как работает AI‑генератор Изображение→Видео?',
                        answer: 'Он использует продвинутые модели глубокого обучения, такие как Kling и Sora, чтобы анализировать статичное изображение и предсказывать движение, создавая связный MP4‑видеоклип.',
                    },
                    {
                        question: '微鲤AI Изображение→Видео бесплатно?',
                        answer: 'Да. Мы ежедневно выдаём бесплатные кредиты, чтобы вы могли попробовать наш AI Image→Video. Вы можете перейти на платный план для премиальных моделей и более высокой скорости генерации.',
                    },
                    {
                        question: 'Какая модель лучше для реалистичного видео: Kling или Veo?',
                        answer: 'Kling AI известен реалистичным движением и более длинной длительностью, а Google Veo выделяется деталями в высоком разрешении. 微鲤AI позволяет переключаться между ними, чтобы выбрать лучший вариант.',
                    },
                    {
                        question: 'Можно ли использовать сгенерированные видео коммерчески?',
                        answer: 'Да. Видео, созданные в рамках платных планов, включают коммерческую лицензию — идеально для YouTube, TikTok и маркетинговой рекламы.',
                    },
                    {
                        question: 'Как убрать водяные знаки с AI‑видео?',
                        answer: '微鲤AI обеспечивает высокое качество. Для видео без водяных знаков проверьте условия вашего плана или используйте наш специальный инструмент AI Watermark Remover.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Как работает AI‑генератор Изображение→Видео?',
                    answer: 'Он анализирует изображение с помощью моделей Kling и Sora, предсказывает движение и создаёт связный MP4‑клип.',
                },
                {
                    question: '微鲤AI Изображение→Видео бесплатно?',
                    answer: 'Да. Доступны ежедневные бесплатные кредиты; для премиальных моделей и скорости можно обновить план.',
                },
                {
                    question: 'Можно ли использовать сгенерированные видео коммерчески?',
                    answer: 'Да. В платных планах есть коммерческая лицензия — подходит для YouTube, TikTok и рекламы.',
                },
            ],
        },
        videoToVideo: {
            title: 'Бесплатный AI Video-to-Video генератор — Рестайл и Аниме‑фильтр | 微鲤AI',
            description: 'Преобразуйте видео в любой стиль с Video‑to‑Video AI от 微鲤AI. Превращайте реальную съёмку в аниме, 3D‑мультфильм или киберпанк‑арт с помощью текстового промпта, сохраняя исходное движение. Бесплатно и онлайн.',
            keywords: 'видео в видео ИИ, vid2vid, перенос стиля видео ИИ, превратить видео в аниме, рестайл видео ИИ, бесплатный ИИ видео фильтр',
            og_title: 'Бесплатный AI Video-to-Video генератор — Рестайл и Аниме‑фильтр | 微鲤AI',
            og_description: 'Преобразуйте видео в любой стиль с Video‑to‑Video AI от 微鲤AI. Превращайте реальную съёмку в аниме, 3D‑мультфильм или киберпанк‑арт с помощью текстового промпта, сохраняя исходное движение. Бесплатно и онлайн.',
            twitter_title: 'Бесплатный AI Video-to-Video генератор — Рестайл и Аниме‑фильтр | 微鲤AI',
            twitter_description: 'Преобразуйте видео в любой стиль с Video‑to‑Video AI от 微鲤AI. Превращайте реальную съёмку в аниме, 3D‑мультфильм или киберпанк‑арт с помощью текстового промпта, сохраняя исходное движение. Бесплатно и онлайн.',
            page: {
                title1: 'Бесплатный AI Video‑to‑Video генератор (Vid2Vid)',
                title2: 'Загрузите видео, укажите стиль — и наблюдайте магию. Технология Video‑to‑Video от 微鲤AI анализирует движение исходного ролика и применяет совершенно новый художественный стиль по вашему текстовому промпту. Отлично подходит для аниме‑эдитов, эффектов claymation и сюрреалистичных визуалов.',
                feature_title1: 'Стабильное движение',
                feature_desc1: 'В отличие от обычной генерации, наш Vid2Vid‑движок «цепляется» за движение исходника и делает переходы плавными без мерцания.',
                feature_title2: 'Из Реала в Аниме',
                feature_desc2: 'Топ‑инструмент для креаторов: превратите себя в аниме‑персонажа или 3D‑аватар в стиле Pixar за секунды.',
                feature_title3: 'Контроль промптом',
                feature_desc3: 'Полный творческий контроль: просто напишите «киберпанк‑город» или «масляная живопись», чтобы точно задать внешний вид результата.',
                faq: [
                    {
                        question: 'Что такое AI Video‑to‑Video (Vid2Vid)?',
                        answer: 'Video‑to‑Video — это генеративный процесс, который берёт готовый видеоклип как вход и «перерисовывает» его в новом стиле по вашему промпту, сохраняя исходное движение и структуру.',
                    },
                    {
                        question: 'Можно ли превратить видео в аниме‑стиль?',
                        answer: 'Да! Это самый популярный сценарий. Загрузите видео и используйте промпты вроде «японское аниме, стиль Studio Ghibli».',
                    },
                    {
                        question: 'Какой максимальной длины может быть исходный ролик?',
                        answer: 'Сейчас лучше всего поддерживаются короткие клипы (например, 5–10 секунд) для максимального качества. Длинные видео рекомендуем делить на части.',
                    },
                    {
                        question: 'Чем это отличается от видеоредактора?',
                        answer: 'Обычный редактор режет и склеивает клипы. 微鲤AI Video‑to‑Video генерирует новые пиксели и полностью меняет текстуру и художественный стиль вашего видео.',
                    },
                    {
                        question: 'Это платно?',
                        answer: '微鲤AI даёт ежедневные бесплатные кредиты, чтобы попробовать Video‑to‑Video. Премиум‑планы доступны для более быстрой обработки и скачивания без водяных знаков.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Что такое AI Video‑to‑Video (Vid2Vid)?',
                    answer: 'Это «перерисовка» существующего видео в новый стиль по промпту с сохранением движения и структуры.',
                },
                {
                    question: 'Можно ли превратить видео в аниме‑стиль?',
                    answer: 'Да. Попробуйте промпты вроде «японское аниме, Studio Ghibli».',
                },
                {
                    question: 'Какой максимальной длины может быть исходный ролик?',
                    answer: 'Рекомендуем 5–10 секунд для лучшего качества; длинные видео делите на сегменты.',
                },
                {
                    question: 'Чем это отличается от видеоредактора?',
                    answer: 'Редактор режет клипы, а Vid2Vid генерирует новые пиксели и меняет стиль/текстуру.',
                },
                {
                    question: 'Это платно?',
                    answer: 'Есть ежедневные бесплатные кредиты; премиум даёт скорость и скачивание без водяных знаков.',
                },
            ],
        },
        removeWatermark: {
            title: 'Бесплатный AI‑удалитель водяных знаков с видео онлайн — Удалите логотипы, текст и субтитры | 微鲤AI',
            description: 'Легко удаляйте водяные знаки, логотипы, субтитры и штампы даты с помощью бесплатного AI Watermark Remover от 微鲤AI. Поддерживаются MP4/MOV и ссылки на видео. Без размытия — чистое восстановление ИИ.',
            keywords: 'удалить водяной знак с видео онлайн, ИИ видео ластик, удалить логотип из видео, удалить субтитры, убрать водяной знак TikTok, бесплатный удалитель водяных знаков',
            og_title: 'Бесплатный AI‑удалитель водяных знаков с видео онлайн — Удалите логотипы, текст и субтитры | 微鲤AI',
            og_description: 'Легко удаляйте водяные знаки, логотипы, субтитры и штампы даты с помощью бесплатного AI Watermark Remover от 微鲤AI. Поддерживаются MP4/MOV и ссылки на видео. Без размытия — чистое восстановление ИИ.',
            twitter_title: 'Бесплатный AI‑удалитель водяных знаков с видео онлайн — Удалите логотипы, текст и субтитры | 微鲤AI',
            twitter_description: 'Легко удаляйте водяные знаки, логотипы, субтитры и штампы даты с помощью бесплатного AI Watermark Remover от 微鲤AI. Поддерживаются MP4/MOV и ссылки на видео. Без размытия — чистое восстановление ИИ.',
            page: {
                title1: 'Бесплатный онлайн AI‑удалитель водяных знаков с видео',
                title2: 'Мгновенно удаляйте водяные знаки, логотипы, текстовые оверлеи и субтитры из видео. Вставьте ссылку или загрузите файл, выделите область — и ИИ восстановит фон пиксель‑в‑пиксель без размытия.',
                click_erase: '1.One‑Click Erase: ИИ автоматически распознаёт и удаляет распространённые водяные знаки.',
                percision_erase: '2.Precision Erase: Используйте кисть, чтобы вручную удалить сложные объекты — например, движущиеся субтитры или тайм‑коды.',
                video_link_title: 'По ссылке',
                direct_link_desc: '1.Direct Link Removal: Вставьте ссылки из соцсетей и удаляйте водяные знаки без предварительного скачивания.',
                lossless_qua_title: '2.Без потери качества: В отличие от размытия, 微鲤AI анализирует соседние пиксели и реконструирует фон.',
                faq: [
                    {
                        question: 'Как бесплатно удалить водяной знак с видео онлайн?',
                        answer: 'Загрузите видео в 微鲤AI или вставьте ссылку. Накройте водяной знак рамкой и нажмите “Generate”. Это бесплатно для теста.',
                    },
                    {
                        question: 'Можно ли убрать движущиеся субтитры или текст?',
                        answer: 'Да. Используйте режим “Precision Erase”, выделите область текста. ИИ отслеживает объект по кадрам и удаляет его по всему видео.',
                    },
                    {
                        question: 'Работает ли для TikTok или YouTube?',
                        answer: 'Конечно. Можно убрать логотипы платформ (например, прыгающий водяной знак TikTok) или водяные знаки каналов для личного использования.',
                    },
                    {
                        question: 'Удалённая область будет размытой?',
                        answer: 'Нет. 微鲤AI применяет “Video In‑painting”, заполняя область реалистичными текстурами из окружающего видео без некрасивого blur‑эффекта.',
                    },
                    {
                        question: 'Какие форматы видео поддерживаются?',
                        answer: 'Поддерживаем основные форматы, включая MP4, MOV, AVI и WebM.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Как бесплатно удалить водяной знак с видео онлайн?',
                    answer: 'Загрузите видео или вставьте ссылку, выделите водяной знак и нажмите “Generate”.',
                },
                {
                    question: 'Можно ли убрать движущиеся субтитры или текст?',
                    answer: 'Да. В “Precision Erase” ИИ отслеживает объект по кадрам и удаляет его везде.',
                },
                {
                    question: 'Удалённая область будет размытой?',
                    answer: 'Нет. Video In‑painting восстанавливает фон реалистично, без размытия.',
                },
            ],
        },
        videoFaceSwap: {
            title: 'Бесплатный AI Face Swap для видео онлайн — Реалистичный Deepfake | 微鲤AI',
            description: 'Меняйте лица в видео мгновенно с AI Face Swapper от 微鲤AI. Создавайте смешные клипы, мемы и реалистичные deepfake бесплатно. Доступны опции без водяных знаков. 100% приватно и безопасно.',
            keywords: 'замена лица в видео, AI face swap, бесплатный deepfake, заменить лицо в видео, face swap фильм, reface онлайн, генератор мемов ИИ',
            og_title: 'Бесплатный AI Face Swap для видео онлайн — Реалистичный Deepfake | 微鲤AI',
            og_description: 'Меняйте лица в видео мгновенно с AI Face Swapper от 微鲤AI. Создавайте смешные клипы, мемы и реалистичные deepfake бесплатно. Доступны опции без водяных знаков. 100% приватно и безопасно.',
            twitter_title: 'Бесплатный AI Face Swap для видео онлайн — Реалистичный Deepfake | 微鲤AI',
            twitter_description: 'Меняйте лица в видео мгновенно с AI Face Swapper от 微鲤AI. Создавайте смешные клипы, мемы и реалистичные deepfake бесплатно. Доступны опции без водяных знаков. 100% приватно и безопасно.',
            page: {
                title1: 'Бесплатный AI Face Swap для видео',
                title2: 'Станьте звездой любого фильма! Загрузите видеоклип и фото целевого лица — и наша ИИ‑модель аккуратно заменит лицо. Отлично подходит для мемов, персональных поздравлений и профессиональных VFX с высокой точностью.',
                feature_title1: 'Гипер‑реалистичный Deepfake',
                feature_desc1: 'ИИ анализирует геометрию лица и освещение, естественно смешивая новое лицо и сохраняя мимику и движения головы.',
                feature_title2: 'Приватность прежде всего',
                feature_desc2: 'Мы защищаем вашу приватность. Загруженные видео и изображения обрабатываются безопасно и удаляются вскоре после генерации.',
                feature_title3: 'Без навыков монтажа',
                feature_desc3: 'Не нужен сложный софт вроде After Effects. Просто нажмите “Create” и получите результат уровня кино за секунды.',
                faq: [
                    {
                        question: '微鲤AI Video Face Swap бесплатный?',
                        answer: 'Да. Мы даём бесплатные кредиты, чтобы вы могли попробовать замену лиц в видео онлайн. Банковская карта не нужна.',
                    },
                    {
                        question: 'Безопасно ли загружать мои фото?',
                        answer: 'Абсолютно. Мы используем строгие протоколы защиты данных. Ваши исходные видео и целевые фото используются только для генерации и не хранятся постоянно.',
                    },
                    {
                        question: 'Можно ли делать face swap в GIF?',
                        answer: 'Да! 微鲤AI поддерживает видео (MP4/MOV) и GIF. Вы легко создадите персональные реакционные GIF.',
                    },
                    {
                        question: 'Как получить лучший результат?',
                        answer: 'Используйте чёткое, фронтальное и хорошо освещённое фото “целевого лица”. Избегайте фото, где лицо закрыто волосами или очками.',
                    },
                    {
                        question: 'Можно ли использовать для коммерческих проектов?',
                        answer: 'Да, но убедитесь, что у вас есть права на исходное видео и согласие/права на изображение человека.',
                    },
                ],
            },
            faq: [
                {
                    question: '微鲤AI Video Face Swap бесплатный?',
                    answer: 'Да. Есть бесплатные кредиты; карта не требуется.',
                },
                {
                    question: 'Безопасно ли загружать мои фото?',
                    answer: 'Да. Материалы используются только для генерации.',
                },
                {
                    question: 'Как получить лучший результат?',
                    answer: 'Берите чёткое фото анфас при хорошем освещении и без закрывающих лицо волос/очков.',
                },
            ],
        },
        videoLipSync: {
            title: 'Бесплатный ИИ‑генератор липсинка — синхронизируйте аудио и текст с видео | 微鲤AI',
            description: 'Точно синхронизируйте движения губ с любым аудио или текстом с помощью инструмента Lip Sync от 微鲤AI. Работает на Kling AI. Идеально для перевода видео, дубляжа и «говорящих» аватаров. Бесплатно и онлайн.',
            keywords: 'синхронизация губ видео, синхронизация губ, синхронизация губ ИИ, дубляж видео, синхронизация голоса, говорящее видео, инструмент синхронизации губ',
            og_title: 'Бесплатный ИИ‑генератор липсинка — синхронизируйте аудио и текст с видео | 微鲤AI',
            og_description: 'Точно синхронизируйте движения губ с любым аудио или текстом с помощью инструмента Lip Sync от 微鲤AI. Работает на Kling AI. Идеально для перевода видео, дубляжа и «говорящих» аватаров. Бесплатно и онлайн.',
            twitter_title: 'Бесплатный ИИ‑генератор липсинка — синхронизируйте аудио и текст с видео | 微鲤AI',
            twitter_description: 'Точно синхронизируйте движения губ с любым аудио или текстом с помощью инструмента Lip Sync от 微鲤AI. Работает на Kling AI. Идеально для перевода видео, дубляжа и «говорящих» аватаров. Бесплатно и онлайн.',
            page: {
                title1: 'Бесплатный ИИ‑инструмент липсинка и дубляжа',
                title2: 'Попрощайтесь с неловкими дубляжами. Загрузите видео и аудиофайл (или введите текст), и наша ИИ‑система заново сгенерирует движения губ спикера так, чтобы они идеально совпали со звуком. На базе Kling AI: поддержка многоязычного дубляжа и реалистичных мимических корректировок.',
                dual_input_modes: 'Два режима ввода',
                audio_sync: 'Синхронизация аудио',
                text_sync: 'Текст‑в‑речь',
                text_sync_tip: 'Введите любой текст, выберите предустановленный голос ИИ — и персонаж сразу произнесёт его.',
                audio_sync_tip: 'Загрузите свой войсовер или песню для синхронизации.',
                feature_title1: 'Многоязычный дубляж',
                feature_desc1: 'Расширяйте аудиторию. Переведите видео на испанский, французский или японский и синхронизируйте губы так, будто спикер — носитель языка.',
                feature_title2: 'Точность Kling AI',
                feature_desc2: 'В отличие от базовых инструментов Wav2Lip, мы используем модель Kling, чтобы движения зубов, языка и челюсти были анатомически корректными.',
                faq: [
                    {
                        question: 'Как синхронизировать губы с аудио в видео?',
                        answer: 'Загрузите видеоклип в 微鲤AI. Затем загрузите аудиофайл (MP3/WAV) или введите текст, чтобы сгенерировать ИИ‑речь. Нажмите "Create", и наша ИИ‑система подстроит движения рта под звук.',
                    },
                    {
                        question: 'Можно ли использовать для перевода/дубляжа видео?',
                        answer: 'Да! Это отличный инструмент для дубляжа. Загрузите переведённую аудиодорожку — и ИИ исправит липсинк, чтобы дубляж выглядел естественно.',
                    },
                    {
                        question: 'Работает ли со статичными изображениями (говорящая голова)?',
                        answer: 'Да. Если вы загрузите статичный портрет как источник «видео», инструмент анимирует его в talking‑head‑видео (эффект Live Portrait).',
                    },
                    {
                        question: 'Какие языки поддерживаются?',
                        answer: 'Так как технология анализирует аудиоволны, она работает с любым языком (английский, испанский, китайский, хинди и т. д.). Для режима Текст‑в‑речь мы поддерживаем 50+ языков.',
                    },
                    {
                        question: 'Липсинк бесплатный?',
                        answer: '微鲤AI предоставляет ежедневные бесплатные кредиты, чтобы протестировать Lip Sync. Для длинных видео или коммерческого использования доступны премиум‑планы.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Как синхронизировать губы с аудио в видео?',
                    answer: 'Загрузите видеоклип в 微鲤AI. Затем загрузите аудиофайл (MP3/WAV) или введите текст, чтобы сгенерировать ИИ‑речь. Нажмите "Create", и наша ИИ‑система подстроит движения рта под звук.',
                },
                {
                    question: 'Можно ли использовать для перевода/дубляжа видео?',
                    answer: 'Да! Это отличный инструмент для дубляжа. Загрузите переведённую аудиодорожку — и ИИ исправит липсинк, чтобы дубляж выглядел естественно.',
                },
                {
                    question: 'Работает ли со статичными изображениями (говорящая голова)?',
                    answer: 'Да. Если вы загрузите статичный портрет как источник «видео», инструмент анимирует его в talking‑head‑видео (эффект Live Portrait).',
                },
            ],
        },
        translateVideoSubtitle: {
            title: 'Бесплатный ИИ‑переводчик видеосубтитров — авто‑субтитры и перевод онлайн | 微鲤AI',
            description: 'Автоматически создавайте и переводите субтитры к видео с помощью 微鲤AI. Поддержка английского, испанского, китайского и 90+ языков. Мгновенно скачивайте видео с «вшитыми» субтитрами (hardsubs).',
            keywords: 'перевод субтитров ИИ, переводчик субтитров видео, многоязычные субтитры, перевод видео, конвертер субтитров, перевод видео ИИ',
            og_title: 'Бесплатный ИИ‑переводчик видеосубтитров — авто‑субтитры и перевод онлайн | 微鲤AI',
            og_description: 'Автоматически создавайте и переводите субтитры к видео с помощью 微鲤AI. Поддержка английского, испанского, китайского и 90+ языков. Мгновенно скачивайте видео с «вшитыми» субтитрами (hardsubs).',
            twitter_title: 'Бесплатный ИИ‑переводчик видеосубтитров — авто‑субтитры и перевод онлайн | 微鲤AI',
            twitter_description: 'Автоматически создавайте и переводите субтитры к видео с помощью 微鲤AI. Поддержка английского, испанского, китайского и 90+ языков. Мгновенно скачивайте видео с «вшитыми» субтитрами (hardsubs).',
            page: {
                title1: 'Бесплатный ИИ‑переводчик видеосубтитров',
                title2: 'Снимите языковой барьер за секунды. Загрузите видео, выберите целевой язык — и ИИ распознает речь, сделает расшифровку и «вошьет» точные переведённые субтитры прямо в видеоролик.',
                feature_title1: '90+ языков',
                feature_desc1: 'Переводите контент с английского на испанский, французский, немецкий, японский, китайский и многие другие языки — одним кликом.',
                feature_title2: 'Автосинхронизация и «вшивание»',
                feature_desc2: 'Не нужно вручную править таймкоды. ИИ синхронизирует субтитры с аудио и встраивает их в видео (hardsubs) для максимальной совместимости.',
                feature_title3: 'Точность с учетом контекста',
                feature_desc3: 'Благодаря продвинутым LLM 微鲤AI понимает контекст и сленг, поэтому перевод получается естественным и точным, а не «роботизированным».',
                faq: [
                    {
                        question: 'Как автоматически переводить субтитры к видео?',
                        answer: 'Загрузите видео в 微鲤AI, выберите “Target Language” (например, английский→испанский) и нажмите “Create”. ИИ автоматически создаст и переведёт субтитры.',
                    },
                    {
                        question: 'Какие языки поддерживаются?',
                        answer: 'Мы поддерживаем более 90 языков, включая английский, испанский, французский, немецкий, португальский, хинди, японский и китайский.',
                    },
                    {
                        question: 'Переводчик субтитров бесплатный?',
                        answer: 'Да. 微鲤AI предлагает бесплатный доступ к ИИ‑переводчику видеосубтитров — можно обрабатывать видео без дорогих сервисов транскрибации.',
                    },
                    {
                        question: 'Нужно ли скачивать файл SRT?',
                        answer: 'Нет. 微鲤AI генерирует видео с «вшитыми» субтитрами (burn‑in/hardsubs), поэтому они корректно отображаются в TikTok, Instagram и YouTube.',
                    },
                    {
                        question: 'Насколько точен перевод?',
                        answer: 'Мы используем современные модели распознавания речи для высокой точности. При хорошем качестве звука точность может превышать 95%.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Как автоматически переводить субтитры к видео?',
                    answer: 'Загрузите видео в 微鲤AI, выберите Target Language и нажмите Create. ИИ автоматически создаст и переведёт субтитры.',
                },
                {
                    question: 'Какие языки поддерживаются?',
                    answer: 'Мы поддерживаем более 90 языков, включая английский, испанский, французский, немецкий, португальский, хинди, японский и китайский.',
                },
                {
                    question: 'Нужно ли скачивать файл SRT?',
                    answer: 'Нет. 微鲤AI выдаёт видео с «вшитыми» субтитрами (hardsubs), которые корректно отображаются на всех соцплатформах.',
                },
            ],
        },
        videoToAnime: {
            title: 'Бесплатный AI‑конвертер Видео→Аниме — Реал→Картун и Pixar | 微鲤AI',
            description: 'Мгновенно превращайте видео в японское аниме, 3D‑Pixar‑стиль или мультфильм с конвертером Видео→Аниме от 微鲤AI. Стабильность кадр‑за‑кадром для плавной анимации. Бесплатно и онлайн.',
            keywords: 'видео в аниме, AI аниме фильтр, видео в мультфильм, pixar фильтр, реал в аниме, альтернатива domoai, генератор аниме видео',
            og_title: 'Бесплатный AI‑конвертер Видео→Аниме — Реал→Картун и Pixar | 微鲤AI',
            og_description: 'Мгновенно превращайте видео в японское аниме, 3D‑Pixar‑стиль или мультфильм с конвертером Видео→Аниме от 微鲤AI. Стабильность кадр‑за‑кадром для плавной анимации. Бесплатно и онлайн.',
            twitter_title: 'Бесплатный AI‑конвертер Видео→Аниме — Реал→Картун и Pixar | 微鲤AI',
            twitter_description: 'Мгновенно превращайте видео в японское аниме, 3D‑Pixar‑стиль или мультфильм с конвертером Видео→Аниме от 微鲤AI. Стабильность кадр‑за‑кадром для плавной анимации. Бесплатно и онлайн.',
            page: {
                title1: 'Бесплатный AI‑конвертер Видео→Аниме',
                title2: 'Станьте героем аниме в один клик. Загрузите любое реальное видео, выберите стиль (Pixar 3D, классический 2D или ручной рисунок), и наша ИИ перерисует ролик кадр‑за‑кадром, сохранив движение плавным и стабильным.',
                feature_desc1: '<div><p>Pixar & 3D: создавайте милые 3D‑анимационные клипы в духе Disney — идеально для семейных видео.</p><p>Classic Anime: получите аутентичный японский аниме‑вид (стиль Ghibli/Shinkai).</p><p>Sketch & Ink: превратите видео в художественную «карандашную» анимацию.</p></div>',
                feature_title2: 'Стабильность кадр‑за‑кадром',
                feature_desc2: 'Надоело мерцание в AI‑видео? 微鲤AI использует продвинутые алгоритмы временной согласованности, чтобы аниме‑видео шло плавно без типичных “дёрганий”.',
                feature_title3: 'Создатель вирусного контента',
                feature_desc3: 'Сделано для TikTok и Reels. Создавайте трендовые видео “Real vs Anime”, которые сразу цепляют внимание.',
                faq: [
                    {
                        question: 'Как бесплатно превратить видео в аниме?',
                        answer: 'Загрузите клип в инструмент Видео→Аниме от 微鲤AI. Выберите пресет (например, “2D Style” или “Pixar Style”) и нажмите Create. Доступно бесплатно с ежедневными кредитами.',
                    },
                    {
                        question: 'Можно ли конвертировать в стиль Pixar/Disney?',
                        answer: 'Да! Есть пресет “3D Cartoon” или “Pixar Style”, который превращает реальных людей в милых 3D‑персонажей.',
                    },
                    {
                        question: 'Какой длины может быть видео?',
                        answer: 'Сейчас поддерживаются клипы до 30 секунд (см. “Maximum video duration: 30s”). Идеально для Shorts, Reels и TikTok.',
                    },
                    {
                        question: 'Будет ли аниме‑персонаж двигаться как я?',
                        answer: 'Да. ИИ анализирует движения скелета и мимику, чтобы персонаж максимально точно повторял ваши действия.',
                    },
                    {
                        question: 'Какой лучший конвертер видео→аниме?',
                        answer: '微鲤AI часто выбирают за разнообразие 2D/3D‑стилей и приоритет на стабильности, чтобы уменьшать шум и мерцание.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Как бесплатно превратить видео в аниме?',
                    answer: 'Загрузите видео в 微鲤AI, выберите пресет (2D Style или Pixar Style) и нажмите Create.',
                },
                {
                    question: 'Можно ли конвертировать в стиль Pixar/Disney?',
                    answer: 'Да. Есть пресет 3D Cartoon/Pixar Style для превращения реальных людей в 3D‑персонажей.',
                },
                {
                    question: 'Будет ли аниме‑персонаж двигаться как я?',
                    answer: 'Да. ИИ анализирует движения и выражения, чтобы повторять ваши действия.',
                },
            ],
            app_name: '微鲤AI Видео→Аниме Конвертер',
            app_desc: 'Бесплатный AI‑инструмент для конвертации реальных видео в аниме, мультфильм и стиль Pixar. Рендер кадр‑за‑кадром для стабильной анимации.',
            featureList: 'Реал→Аниме, Pixar‑фильтр, Стабильность кадров, 2D/3D‑стили',
        },
        videoUpscaler: {
            title: 'Бесплатный AI Video Upscaler — Улучшение видео до 4K онлайн | 微鲤AI',
            description: 'Мгновенно повышайте качество низкого разрешения до 1080p, 2K и 4K с бесплатным AI Video Upscaler от 微鲤AI. Убирает пикселизацию, снижает шум и улучшает качество онлайн без установки софта.',
            keywords: 'video upscaler, AI улучшение видео, апскейл видео до 4k, убрать размытие видео, шумоподавление видео, повысить качество видео, бесплатный онлайн апскейлер',
            og_title: 'Бесплатный AI Video Upscaler — Улучшение видео до 4K онлайн | 微鲤AI',
            og_description: 'Мгновенно повышайте качество низкого разрешения до 1080p, 2K и 4K с бесплатным AI Video Upscaler от 微鲤AI. Убирает пикселизацию, снижает шум и улучшает качество онлайн без установки софта.',
            twitter_title: 'Бесплатный AI Video Upscaler — Улучшение видео до 4K онлайн | 微鲤AI',
            twitter_description: 'Мгновенно повышайте качество низкого разрешения до 1080p, 2K и 4K с бесплатным AI Video Upscaler от 微鲤AI. Убирает пикселизацию, снижает шум и улучшает качество онлайн без установки софта.',
            page: {
                title1: 'Бесплатный AI Video Upscaler',
                title2: 'Не миритесь с размытым и “пиксельным” видео. Загрузите клипы низкого разрешения (360p, 480p, 720p), и ИИ автоматически апскейлит до впечатляющих 4K. Движок не только увеличивает размер, но и восстанавливает детали, убирает шум и корректирует цвет.',
                feature_title1: 'Апскейл до 4K',
                feature_desc1: 'Верните жизнь старым видео. Превратите SD в HD или 4K одним кликом — чётко на современных больших экранах.',
                feature_title2: 'Исправление размытия и “зерна”',
                feature_desc2: 'Снято в темноте? Наш алгоритм AI Denoising удаляет цифровой шум и артефакты сжатия — чисто и профессионально.',
                feature_title3: 'Восстановление старых записей',
                feature_desc3: 'Идеально для семейных архивов. Возвращайте цвет и резкость в старых домашних видео и винтажных клипах.',
                faq: [
                    {
                        question: 'Можно ли бесплатно апскейлить видео до 4K онлайн?',
                        answer: 'Да. 微鲤AI позволяет выбрать выходное разрешение до 4K (см. опции инструмента). Можно попробовать бесплатно с ежедневными кредитами.',
                    },
                    {
                        question: 'Как исправить размытое видео?',
                        answer: 'Просто загрузите размытое видео в AI Video Upscaler. ИИ анализирует потерянные пиксели и реконструирует детали, чтобы уменьшить размытие.',
                    },
                    {
                        question: 'Работает ли с видео со старого телефона?',
                        answer: 'Да. Особенно хорошо работает с низким качеством (360p/480p), превращая клипы в чёткие 1080p или выше.',
                    },
                    {
                        question: 'Сколько времени занимает апскейл?',
                        answer: 'Апскейл вычислительно сложен, но 微鲤AI использует оптимизированные облачные GPU. Короткий клип обычно занимает несколько минут.',
                    },
                    {
                        question: 'Это лучше, чем Topaz Video AI?',
                        answer: '微鲤AI даёт сопоставимое качество ИИ и работает полностью в браузере — без дорогого железа и установки.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Можно ли апскейлить видео до 4K онлайн?',
                    answer: 'Да. 微鲤AI поддерживает выход до 4K и бесплатный тест с ежедневными кредитами.',
                },
                {
                    question: 'Как исправить размытое видео?',
                    answer: 'Загрузите видео в AI Video Upscaler — ИИ восстановит детали и снизит размытие.',
                },
                {
                    question: 'Это лучше, чем Topaz Video AI?',
                    answer: '微鲤AI даёт сопоставимое качество и работает в браузере без установки и дорогого оборудования.',
                },
            ],
            app_name: '微鲤AI Video Upscaler',
            app_desc: 'Бесплатный AI Video Upscaler для улучшения качества до 4K. Исправляет размытость, снижает шум и восстанавливает старые видео онлайн.',
            featureList: '4K Upscaling, AI Denoising, Sharpening, Color Correction',
        },
        removeVideoSubtitles: {
            title: 'Удалить Субтитры из Видео - Удалитель Субтитров ИИ | 微鲤AI',
            description: 'Удаляйте встроенные субтитры из видео с помощью технологии ИИ. Интеллектуально стирайте жестко закодированные субтитры и текст из видео, сохраняя качество видео. Быстро и легко в использовании.',
            keywords: 'удалить субтитры из видео, удалитель субтитров, удалить субтитры, стереть субтитры, удаление субтитров видео, удалить закодированные субтитры',
            og_title: 'Удалить Субтитры из Видео - Удалитель Субтитров ИИ | 微鲤AI',
            og_description: 'Удаляйте встроенные субтитры из видео с помощью технологии ИИ. Интеллектуально стирайте жестко закодированные субтитры и текст из видео, сохраняя качество видео. Быстро и легко в использовании.',
            twitter_title: 'Удалить Субтитры из Видео - Удалитель Субтитров ИИ | 微鲤AI',
            twitter_description: 'Удаляйте встроенные субтитры из видео с помощью технологии ИИ. Интеллектуально стирайте жестко закодированные субтитры и текст из видео, сохраняя качество видео. Быстро и легко в использовании.',
            page: {
                title1: 'Бесплатный AI‑удалитель субтитров',
                title2: 'Мешают “вшитые” субтитры? Интеллектуальный алгоритм 微鲤AI автоматически распознаёт и стирает жёстко закодированные субтитры, слова песен и экранный текст. Вставьте ссылку или загрузите файл — и мгновенно получите чистое видео без текста.',
                feature_title1: 'Умное распознавание текста',
                feature_desc1: 'Без ручной маски. ИИ сам находит области текста внизу (или в любом месте) и отделяет их от фона.',
                feature_title2: 'Бесшовный In‑painting',
                feature_desc2: 'Никаких размытых прямоугольников. 微鲤AI заполняет удалённую область, анализируя окружающие пиксели и естественно восстанавливая текстуры (трава, песок, толпа и т. п.).',
                feature_title3: 'Ссылки и файлы',
                feature_desc3: 'Удаляйте подписи прямо из ссылок TikTok, YouTube или Instagram, либо загружайте MP4/MOV. Отлично подходит для повторного использования контента.',
                faq: [
                    {
                        question: 'Можно ли удалить жёстко закодированные (вшитые) субтитры?',
                        answer: 'Да. Инструмент создан именно для “вшитых” субтитров, которые являются частью изображения и не отключаются. Он удаляет их визуально.',
                    },
                    {
                        question: 'Как убрать подписи из видео TikTok/YouTube?',
                        answer: 'Скопируйте ссылку, вставьте её во вкладку “Video Link” на 微鲤AI и нажмите “Generate”. ИИ удалит подписи и позволит скачать чистое видео.',
                    },
                    {
                        question: 'Удалит ли он фон за текстом?',
                        answer: 'Нет. 微鲤AI использует AI In‑painting: удаляет текст и интеллектуально “дорисовывает” фон, чтобы видео выглядело как оригинал.',
                    },
                    {
                        question: 'Чем отличается от удаления водяных знаков?',
                        answer: 'Похоже, но Удалитель субтитров оптимизирован под текстовые полосы/лирику/капшены (обычно снизу), а Watermark Remover больше ориентирован на логотипы и штампы.',
                    },
                    {
                        question: 'Это бесплатно?',
                        answer: 'Да, базовые функции доступны бесплатно с ежедневными кредитами.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Можно ли удалить вшитые субтитры?',
                    answer: 'Да. Инструмент предназначен для субтитров, встроенных в изображение видео. Он удаляет их визуально.',
                },
                {
                    question: 'Как убрать подписи по ссылке TikTok?',
                    answer: 'Скопируйте ссылку, вставьте её во вкладку “Video Link” и нажмите “Generate”. ИИ удалит подписи автоматически.',
                },
                {
                    question: 'Не испортится ли фон за текстом?',
                    answer: 'Нет. 微鲤AI использует AI In‑painting, чтобы удалить текст и восстановить фон.',
                },
            ],
            app_name: '微鲤AI Удалитель субтитров',
            app_desc: 'Бесплатный AI‑инструмент для удаления вшитых субтитров, капшенов и текста из видео. Восстанавливает фон с помощью in‑painting без размытых блоков.',
            featureList: 'Удаление вшитых субтитров, AI‑восстановление фона, Поддержка видеоссылок, Ластик текста/лирики',
        },
        videoBackgroundRemover: {
            title: 'Удалитель Фона Видео - Удалить Фон Видео с ИИ | 微鲤AI',
            description: 'Автоматически удаляйте фон из видео с помощью ИИ. Создавайте эффекты зеленого экрана, изолируйте объекты и легко заменяйте фоны видео. Идеально для создателей контента и видеоредакторов.',
            keywords: 'удалитель фона видео, удалить фон видео, зеленый экран, удаление фона ИИ, ластик фона видео, изолировать объект видео',
            og_title: 'Удалитель Фона Видео - Удалить Фон Видео с ИИ | 微鲤AI',
            og_description: 'Автоматически удаляйте фон из видео с помощью ИИ. Создавайте эффекты зеленого экрана, изолируйте объекты и легко заменяйте фоны видео. Идеально для создателей контента и видеоредакторов.',
            twitter_title: 'Удалитель Фона Видео - Удалить Фон Видео с ИИ | 微鲤AI',
            twitter_description: 'Автоматически удаляйте фон из видео с помощью ИИ. Создавайте эффекты зеленого экрана, изолируйте объекты и легко заменяйте фоны видео. Идеально для создателей контента и видеоредакторов.',
            page: {
                title1: 'Бесплатный AI‑удалитель фона видео',
                title2: 'Нет хромакея? Не проблема. Загрузите видео — ИИ автоматически найдёт объект, вырежет его с точностью до волос и позволит скачать прозрачное видео или мгновенно заменить фон на однотонный цвет.',
                feature_title1: 'Без зелёного экрана',
                feature_desc1: 'Забудьте про дорогие студии. ИИ автоматически отделяет людей, животных и объекты от сложного фона (авто‑ротоскопинг).',
                feature_title2: 'Замена на однотонный фон',
                feature_desc2: 'Идеально для e‑commerce. Меняйте фон товарного видео на чисто белый, чёрный или любой цвет в один клик — для лучшей конверсии.',
                feature_title3: 'Прозрачный экспорт',
                feature_desc3: 'Скачивайте с альфа‑каналом (WebM/MOV) и легко накладывайте объект на другие видео в Premiere Pro, DaVinci Resolve или CapCut.',
                faq: [
                    {
                        question: 'Можно ли удалить фон без хромакея?',
                        answer: 'Да! 微鲤AI использует продвинутое машинное обучение, чтобы отличать объект от фона — можно удалять фон у видео, снятых где угодно.',
                    },
                    {
                        question: 'Как сохранить видео с прозрачным фоном?',
                        answer: 'После удаления фона выберите WebM (Transparent) или MOV. Стандартный MP4 не поддерживает прозрачность и покажет чёрный фон.',
                    },
                    {
                        question: 'Можно ли сделать фон белым?',
                        answer: 'Да. В настройках используйте “Background Color” и выберите белый/чёрный или любой hex‑цвет. Отлично для видео товаров на Amazon/Shopify.',
                    },
                    {
                        question: 'Хорошо ли обрабатывает волосы?',
                        answer: 'Да. Алгоритм обучен сохранять тонкие детали: волосы, шерсть и полупрозрачные объекты (например, очки).',
                    },
                    {
                        question: 'Это бесплатно?',
                        answer: 'Да, вы можете обрабатывать видео бесплатно с ежедневными кредитами.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Можно ли удалить фон без зелёного экрана?',
                    answer: 'Да! 微鲤AI не требует хромакея для отделения объекта от фона.',
                },
                {
                    question: 'Как сохранить видео с прозрачным фоном?',
                    answer: 'Выберите WebM (Transparent) или MOV. Стандартный MP4 не поддерживает прозрачность.',
                },
                {
                    question: 'Можно ли сделать фон белым?',
                    answer: 'Да. Выберите белый в Background Color — идеально для товарных видео.',
                },
            ],
            app_name: '微鲤AI Удалитель фона видео',
            app_desc: 'Бесплатный AI‑инструмент для удаления фона видео без хромакея. Экспортируйте прозрачные видео или меняйте фон на белый/чёрный онлайн.',
            featureList: 'Без зелёного экрана, Прозрачный экспорт, Смена цвета фона, Точность по волосам',
            step_name: 'Как удалить фон видео онлайн',
            step_list: [
                {
                    name: 'Загрузить видео',
                    text: 'Загрузите видео (MP4, MOV) в 微鲤AI Background Remover.',
                },
                {
                    name: 'Удалить фон',
                    text: 'ИИ автоматически обработает видео. Можно оставить прозрачный фон или выбрать новый цвет.',
                },
                {
                    name: 'Экспорт',
                    text: 'Скачайте результат. Для прозрачности выберите WebM/MOV, для однотонного фона — MP4.',
                },
            ],
        },
        aiVideoExtender: {
            title: 'Расширение Видео с ИИ - Увеличить Длину и Продолжительность Видео | 微鲤AI',
            description: 'Увеличивайте длину видео с помощью технологии ИИ. Добавляйте 5-8 секунд к вашим видео плавно с несколькими вариантами стилей, включая аниме, 3D-анимацию, киберпанк и комиксы. Идеально для создателей контента и видеоредакторов.',
            keywords: 'расширение видео ИИ, увеличить длину видео, продление видео, расширение видео ИИ, удлинить видео, увеличить время видео, инструмент видео ИИ',
            og_title: 'Расширение Видео с ИИ - Увеличить Длину и Продолжительность Видео | 微鲤AI',
            og_description: 'Увеличивайте длину видео с помощью технологии ИИ. Добавляйте 5-8 секунд к вашим видео плавно с несколькими вариантами стилей, включая аниме, 3D-анимацию, киберпанк и комиксы. Идеально для создателей контента и видеоредакторов.',
            twitter_title: 'Расширение Видео с ИИ - Увеличить Длину и Продолжительность Видео | 微鲤AI',
            twitter_description: 'Увеличивайте длину видео с помощью технологии ИИ. Добавляйте 5-8 секунд к вашим видео плавно с несколькими вариантами стилей, включая аниме, 3D-анимацию, киберпанк и комиксы. Идеально для создателей контента и видеоредакторов.',
            page: {
                title1: 'Бесплатное AI‑расширение видео и продолжение',
                title2: 'Видео слишком короткое? 微鲤AI использует генеративный ИИ, чтобы предсказывать и создавать новые кадры — клип становится длиннее без швов. Можно управлять продолжением с помощью prompt‑ов или превратить обычное видео в очень плавное slow motion.',
                feature_title1: 'Умное генеративное продление',
                feature_desc1: 'Не просто “растягивайте” — создавайте новое. Введите prompt вроде «камера отъезжает» или «персонаж поворачивается», и ИИ сгенерирует следующие 5–10 секунд в стиле оригинала.',
                feature_title2: 'Сверхплавное slow motion',
                feature_desc2: 'Превращайте 30fps в качественное замедление. 微鲤AI использует Frame Interpolation, вставляя AI‑кадры между существующими — без рывков и дрожания.',
                feature_title3: 'Идеальные петли',
                feature_desc3: 'Создавайте бесконечные loops для фонов в соцсетях. ИИ анализирует начальные и конечные кадры и идеально смешивает их.',
                faq: [
                    {
                        question: 'Как работает AI‑расширение видео?',
                        answer: 'Используется технология “Generative Outpainting”. ИИ анализирует последние кадры и ваш prompt, чтобы предсказать и сгенерировать новые кадры, логично продолжающие действие.',
                    },
                    {
                        question: 'Могу ли я контролировать, что произойдёт в продолжении?',
                        answer: 'Да! В поле “Prompt” опишите действие. Например, если в видео едет машина, напишите «машина въезжает в туннель», чтобы направить продление.',
                    },
                    {
                        question: 'Чем отличается Extension от Slow Motion?',
                        answer: 'Extension добавляет новое время, генерируя новые события (делает историю длиннее). Slow Motion растягивает существующее время, добавляя промежуточные кадры (делает действие медленнее). 微鲤AI умеет оба.',
                    },
                    {
                        question: 'Насколько можно продлить видео?',
                        answer: 'Можно продлевать клип на 5 секунд за раз (настройка “Extension Duration”). Повторяйте процесс, чтобы получить более длинные последовательности.',
                    },
                    {
                        question: 'Это бесплатно?',
                        answer: 'Да, 微鲤AI предоставляет бесплатные кредиты, чтобы попробовать продление видео и slow motion.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Как работает AI‑расширение видео?',
                    answer: '“Generative Outpainting” анализирует последние кадры и prompt и генерирует продолжение действия.',
                },
                {
                    question: 'Можно ли управлять продолжением?',
                    answer: 'Да. Опишите действие в “Prompt” (например: «машина въезжает в туннель»).',
                },
                {
                    question: 'Разница между Extension и Slow Motion?',
                    answer: 'Extension генерирует новые события, Slow Motion добавляет промежуточные кадры для замедления.',
                },
            ],
            app_name: '微鲤AI Video Extender',
            app_desc: 'Бесплатный AI‑инструмент для продления видео с generative fill и prompt‑ами. Также есть AI slow motion (frame interpolation) и создание loops.',
            featureList: 'Генеративное продление видео, Продолжение по prompt, AI slow motion, Видео‑лупы',
        },
        videoEffects: {
            title: 'Видео Эффекты - Создавайте Вирусные Видео с ИИ | 微鲤AI',
            description: 'Исследуйте популярные видео эффекты ИИ на 微鲤AI. От Поцелуев ИИ до Танцев ИИ, создавайте вирусные видео всего за несколько кликов.',
            keywords: 'видео эффекты ИИ, вирусные видео ИИ, видео тренды, поцелуи ИИ, танцы ИИ, генератор видео',
        },
        aiDancing: {
            title: 'Генератор Танцевальных Видео ИИ - Бесплатный Создатель Танцевальных Видео ИИ | 微鲤AI',
            description: 'Используйте Генератор Танцев ИИ 微鲤AI для создания потрясающих танцевальных видео из фотографий. Поддерживает множество танцевальных шаблонов и стилей, оживите свои фотографии!',
            keywords: 'танцевальное видео ИИ, генератор танцев ИИ, фото в видео, генерация видео ИИ, 微鲤AI, бесплатные инструменты ИИ',
        },
        aiKissing: {
            title: 'aiKissing | 微鲤AI',
            description: 'Experience aiKissing on 微鲤AI platform.',
            keywords: 'aiKissing, AI, 微鲤AI',
        },
        videoMotionImitation: {
            title: 'ИИ Имитация Движения Видео - Оживите Фотографии Бесплатно | 微鲤AI',
            description: 'Инструмент имитации движения видео 微鲤AI может интегрировать персонажей с фотографий в эталонные видео, заменяя оригинальных персонажей, сохраняя при этом освещение и тона сцены для бесшовного слияния с окружающей средой.',
            keywords: 'имитация движения видео ИИ, оживить фотографии, инструмент имитации движения видео ИИ, 微鲤AI, бесплатные инструменты ИИ',
            og_title: 'ИИ Имитация Движения Видео - Оживите Фотографии Бесплатно | 微鲤AI',
            og_description: 'Инструмент имитации движения видео 微鲤AI может интегрировать персонажей с фотографий в эталонные видео, заменяя оригинальных персонажей, сохраняя при этом освещение и тона сцены для бесшовного слияния с окружающей средой.',
            twitter_title: 'ИИ Имитация Движения Видео - Оживите Фотографии Бесплатно | 微鲤AI',
            twitter_description: 'Инструмент имитации движения видео 微鲤AI может интегрировать персонажей с фотографий в эталонные видео, заменяя оригинальных персонажей, сохраняя при этом освещение и тона сцены для бесшовного слияния с окружающей средой.',
            page: {
                title1: 'Бесплатный AI‑генератор танцев и перенос движения',
                title2: 'Хотите увидеть, как ваш любимый аниме‑персонаж танцует как Майкл Джексон? Или заставить статичное фото повторить вирусный TikTok‑движ? Просто загрузите референс‑видео и изображение персонажа — наша ИИ перенесёт движение точно.',
                feature_title1: 'Замена персонажа в видео',
                feature_desc1: 'Swap Реал→Аниме: загрузите видео танца/драки и замените человека на 3D‑персонажа, панду или аниме‑аватар, сохранив фон и освещение.',
                feature_title2: 'Заставьте фото танцевать',
                feature_desc2: 'Анимация статичных изображений: оживите фото. Загрузите своё фото или персонажа, выберите танцевальное референс‑видео — и фото будет повторять движения. Идеально для вирусного контента в стиле Viggle.',
                feature_title3: 'Сломайте стену измерений',
                feature_desc3: 'Кросс‑стили: превратить балерину в аниме‑девушку или каратиста в панду — 微鲤AI уверенно справляется со сложной анатомией и перекрытиями.',
                faq: [
                    {
                        question: 'Как заставить фото танцевать с помощью ИИ?',
                        answer: 'Используйте «Move Mode» в 微鲤AI. Загрузите фото (Character Image) и видео с движениями (Reference Video). Нажмите Create — ИИ перенесёт движение.',
                    },
                    {
                        question: 'В чём разница между Move Mode и Replace Mode?',
                        answer: 'Move Mode анимирует статичную картинку движением из видео. Replace Mode заменяет человека внутри существующего видео на нового персонажа из изображения.',
                    },
                    {
                        question: 'Можно использовать для трендов TikTok?',
                        answer: 'Да! Отлично подходит для челленджей TikTok — можно заставить знаменитостей, аниме‑персонажей или друзей повторять трендовые танцы без обучения.',
                    },
                    {
                        question: 'Работает на кадрах в полный рост?',
                        answer: 'Да. Для лучшего результата убедитесь, что и референс‑видео, и изображение показывают тело целиком и достаточно чётко.',
                    },
                    {
                        question: 'Это бесплатно?',
                        answer: 'Да, вы можете создавать видео переноса движения бесплатно, используя ежедневные кредиты.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Как заставить фото танцевать с помощью ИИ?',
                    answer: 'Используйте «Move Mode» в 微鲤AI. Загрузите фото (Character Image) и видео с движениями (Reference Video). Нажмите Create — ИИ перенесёт движение.',
                },
                {
                    question: 'В чём разница между Move Mode и Replace Mode?',
                    answer: 'Move Mode анимирует статичную картинку движением из видео. Replace Mode заменяет человека внутри существующего видео на нового персонажа из изображения.',
                },
            ],
            app_name: '微鲤AI Motion Transfer',
            app_desc: 'Бесплатный AI‑генератор танцев и перенос движения. Заставляйте фото танцевать, анимируйте статичные изображения и меняйте персонажей в видео онлайн.',
            featureList: 'AI‑генерация танца, перенос позы тела, замена персонажа в видео, анимация фото',
            step_name: 'Как заставить фото танцевать с помощью ИИ',
            step_list: [
                {
                    name: 'Загрузите референс‑видео',
                    text: 'Загрузите видео с танцем или движением, которое вы хотите скопировать.',
                },
                {
                    name: 'Загрузите изображение персонажа',
                    text: 'Загрузите статичное фото человека или персонажа, которого вы хотите анимировать.',
                },
                {
                    name: 'Выберите Move Mode',
                    text: 'Выберите «Move Mode» и нажмите Create. ИИ заставит фото повторить движения из видео.',
                },
            ],
        },
    },
    pt: {
        textToMusic: {
            title: 'Gerador de Música com IA - Crie Música Única com 微鲤AI | 微鲤AI',
            description: 'Descubra o Gerador de Música com IA da 微鲤AI. Crie rapidamente música única e livre de direitos autorais adaptada aos seus projetos com tecnologia de IA avançada. Perfeito para criadores de conteúdo, desenvolvedores de jogos e entusiastas da música.',
            keywords: 'texto para música, texto para música grátis, IA texto para música, gerador de música IA, criador de músicas IA, letra para música, criar música similar, criação de música, música livre de direitos, download música grátis, 微鲤AI',
        },
        textToVideo: {
            title: 'Gerador de IA de Texto para Vídeo Grátis (Veo 3.1, Kling e Sora) | 微鲤AI',
            description: 'Transforme seus prompts em vídeos cinematográficos instantaneamente com a IA de Texto para Vídeo da 微鲤AI. Com Google Veo 3.1, Kling e Sora. Suporta 16:9 e 9:16, até 8s de duração. Opções sem marca d’água disponíveis.',
            keywords: 'texto para vídeo IA, gerador de vídeo IA, google veo 3.1, prompt para vídeo, kling ai, sora, txt2vid, 微鲤AI',
            og_title: 'Gerador de IA de Texto para Vídeo Grátis (Veo 3.1, Kling e Sora) | 微鲤AI',
            og_description: 'Transforme seus prompts em vídeos cinematográficos instantaneamente com a IA de Texto para Vídeo da 微鲤AI. Com Google Veo 3.1, Kling e Sora. Suporta 16:9 e 9:16, até 8s de duração. Opções sem marca d’água disponíveis.',
            twitter_title: 'Gerador de IA de Texto para Vídeo Grátis (Veo 3.1, Kling e Sora) | 微鲤AI',
            twitter_description: 'Transforme seus prompts em vídeos cinematográficos instantaneamente com a IA de Texto para Vídeo da 微鲤AI. Com Google Veo 3.1, Kling e Sora. Suporta 16:9 e 9:16, até 8s de duração. Opções sem marca d’água disponíveis.',
            page: {
                title1: 'Gerador de IA de Texto para Vídeo Grátis',
                title2: 'Digite um prompt e veja a 微鲤AI dar vida à sua ideia. Nosso gerador Texto‑para‑Vídeo agrega modelos de ponta como Google Veo 3.1 e Kling AI, permitindo criar vídeos de alta qualidade e movimento natural para redes sociais (9:16) ou projetos cinematográficos (16:9) em segundos.',
                intro_title: 'Transforme imaginação em realidade com Texto‑para‑Vídeo',
                feature_title: 'Recursos do Texto para Vídeo da 微鲤AI',
                faq_title: 'Perguntas frequentes sobre Texto para Vídeo',
                feature_title1: 'Potência multi‑modelo',
                feature_desc1: 'Alterne entre Veo 3.1 para realismo e Kling para consistência de movimento. Sem várias assinaturas.',
                feature_title2: 'Proporções personalizadas',
                feature_desc2: 'Gere vídeos verticais (9:16) para TikTok/Reels ou 16:9 para YouTube diretamente.',
                feature_title3: 'Duração estendida',
                feature_desc3: 'Crie vídeos de até 8s (ou mais com extensões) em uma única geração — perfeito para storytelling.',
                faq: [
                    {
                        question: 'Como escrever um bom prompt de texto para vídeo?',
                        answer: 'Seja específico: sujeito, ação, iluminação e ângulo de câmera. Ex.: "Toma de drone cinematográfica de uma cidade cyberpunk futurista à noite, luzes neon, 4K".',
                    },
                    {
                        question: 'Qual modelo usar: Google Veo 3.1 ou Kling?',
                        answer: 'O Veo 3.1 oferece alta fidelidade visual e ótima aderência ao prompt, ideal para cenas realistas. O Kling costuma ir melhor em movimentos complexos de personagens. Recomendamos testar ambos.',
                    },
                    {
                        question: 'Texto para Vídeo da 微鲤AI é grátis?',
                        answer: 'Sim. Cada usuário recebe créditos diários gratuitos para gerar vídeos a partir de texto.',
                    },
                    {
                        question: 'Posso gerar vídeos com mais de 8 segundos?',
                        answer: 'A geração base cria clipes de até 8s (dependendo do modelo). Para vídeos mais longos, use o AI Video Extender para continuar o vídeo de forma contínua.',
                    },
                    {
                        question: 'Os vídeos gerados têm som?',
                        answer: 'Sim. Ative o toggle “Generate Audio” para criar automaticamente efeitos sonoros e ambiência.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Como escrever um bom prompt de texto para vídeo?',
                    answer: 'Descreva sujeito, ação, luz e câmera. Ex.: "cidade cyberpunk à noite, neon, drone, 4K".',
                },
                {
                    question: 'Qual modelo usar: Google Veo 3.1 ou Kling?',
                    answer: 'Veo 3.1 é forte em realismo e aderência; Kling em movimento. Teste ambos.',
                },
                {
                    question: 'Texto para Vídeo da 微鲤AI é grátis?',
                    answer: 'Sim. Há créditos diários gratuitos.',
                },
                {
                    question: 'Posso gerar vídeos com mais de 8 segundos?',
                    answer: 'Base até 8s; para mais duração, use AI Video Extender.',
                },
                {
                    question: 'Os vídeos gerados têm som?',
                    answer: 'Sim. Ative “Generate Audio” para gerar som automaticamente.',
                },
            ],
        },
        imageToVideo: {
            title: 'Gerador de IA de Imagem para Vídeo (Grátis e Online) - Kling, Veo e Sora',
            description: 'Transforme fotos estáticas em vídeos realistas em segundos com o Image-to-Video IA gratuito da 微鲤AI. Acesse modelos de ponta como Kling, Google Veo e Sora 2 em um só lugar. Opções sem marca d’água disponíveis.',
            keywords: 'imagem para vídeo IA, gerador de vídeo IA, animação de imagem, vídeo Sora, vídeo Veo, vídeo Seedance, ferramentas de vídeo 微鲤AI',
            og_title: 'Gerador de IA de Imagem para Vídeo (Grátis e Online) - Kling, Veo e Sora',
            og_description: 'Transforme fotos estáticas em vídeos realistas em segundos com o Image-to-Video IA gratuito da 微鲤AI. Acesse modelos de ponta como Kling, Google Veo e Sora 2 em um só lugar. Opções sem marca d’água disponíveis.',
            twitter_title: 'Gerador de IA de Imagem para Vídeo (Grátis e Online) - Kling, Veo e Sora',
            twitter_description: 'Transforme fotos estáticas em vídeos realistas em segundos com o Image-to-Video IA gratuito da 微鲤AI. Acesse modelos de ponta como Kling, Google Veo e Sora 2 em um só lugar. Opções sem marca d’água disponíveis.',
            page: {
                title1: 'Gerador de IA de Imagem para Vídeo grátis online',
                faq: [
                    {
                        question: 'Como funciona o gerador de IA de Imagem para Vídeo?',
                        answer: 'Ele usa modelos avançados de deep learning como Kling e Sora para analisar sua imagem estática e prever movimento, gerando um clipe de vídeo coerente em MP4.',
                    },
                    {
                        question: 'O Imagem para Vídeo da 微鲤AI é gratuito?',
                        answer: 'Sim. Oferecemos créditos gratuitos diários para você testar a IA de imagem para vídeo. Você pode fazer upgrade para modelos premium e maior velocidade de geração.',
                    },
                    {
                        question: 'Qual modelo é melhor para vídeo realista: Kling ou Veo?',
                        answer: 'O Kling AI é conhecido por movimentos realistas e maior duração, enquanto o Google Veo se destaca em detalhes em alta definição. A 微鲤AI permite alternar entre eles para encontrar o melhor resultado.',
                    },
                    {
                        question: 'Posso usar os vídeos gerados comercialmente?',
                        answer: 'Sim. Vídeos gerados nos planos pagos incluem licença comercial, perfeitos para YouTube, TikTok e anúncios de marketing.',
                    },
                    {
                        question: 'Como remover marcas d’água de vídeos de IA?',
                        answer: 'A 微鲤AI entrega saídas de alta qualidade. Para vídeos sem marca d’água, verifique seu plano ou use nossa ferramenta dedicada de remoção de marca d’água com IA.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Como funciona o gerador de IA de Imagem para Vídeo?',
                    answer: 'Ele analisa sua imagem com modelos como Kling e Sora, prevê movimento e gera um clipe MP4 coerente.',
                },
                {
                    question: 'O Imagem para Vídeo da 微鲤AI é gratuito?',
                    answer: 'Sim. Há créditos diários gratuitos; você pode fazer upgrade para modelos premium e maior velocidade.',
                },
                {
                    question: 'Posso usar os vídeos gerados comercialmente?',
                    answer: 'Sim. Planos pagos incluem licença comercial, ideal para YouTube, TikTok e publicidade.',
                },
            ],
        },
        videoToVideo: {
            title: 'Gerador Gratuito de Vídeo para Vídeo com IA - Restyle & Filtro Anime | 微鲤AI',
            description: 'Transforme seus vídeos em qualquer estilo com o Vídeo‑para‑Vídeo IA da 微鲤AI. Converta filmagens reais em anime, cartoons 3D ou arte cyberpunk usando prompts de texto, mantendo o movimento original consistente. Grátis e online.',
            keywords: 'vídeo para vídeo IA, vid2vid, transferência de estilo de vídeo IA, transformar vídeo em anime, restyle de vídeo IA, filtro de vídeo IA grátis',
            og_title: 'Gerador Gratuito de Vídeo para Vídeo com IA - Restyle & Filtro Anime | 微鲤AI',
            og_description: 'Transforme seus vídeos em qualquer estilo com o Vídeo‑para‑Vídeo IA da 微鲤AI. Converta filmagens reais em anime, cartoons 3D ou arte cyberpunk usando prompts de texto, mantendo o movimento original consistente. Grátis e online.',
            twitter_title: 'Gerador Gratuito de Vídeo para Vídeo com IA - Restyle & Filtro Anime | 微鲤AI',
            twitter_description: 'Transforme seus vídeos em qualquer estilo com o Vídeo‑para‑Vídeo IA da 微鲤AI. Converta filmagens reais em anime, cartoons 3D ou arte cyberpunk usando prompts de texto, mantendo o movimento original consistente. Grátis e online.',
            page: {
                title1: 'Gerador Gratuito de Vídeo para Vídeo com IA (Vid2Vid)',
                title2: 'Envie um vídeo, digite um estilo e veja a mágica. A tecnologia Vídeo‑para‑Vídeo da 微鲤AI analisa o movimento do seu vídeo de origem e aplica um novo estilo artístico baseado no seu prompt. Perfeito para edits de anime, efeitos tipo claymation ou artes visuais surreais.',
                feature_title1: 'Movimento Consistente',
                feature_desc1: 'Diferente da geração padrão, nosso motor Vid2Vid “gruda” no movimento do vídeo fonte, garantindo transições suaves sem flicker.',
                feature_title2: 'Real para Anime',
                feature_desc2: 'A ferramenta #1 para criadores: transforme-se em um personagem de anime ou avatar 3D estilo Pixar em instantes.',
                feature_title3: 'Controle por Prompt',
                feature_desc3: 'Controle criativo total: basta digitar “cidade cyberpunk” ou “pintura a óleo” para definir exatamente o visual do resultado.',
                faq: [
                    {
                        question: 'O que é IA de Vídeo para Vídeo (Vid2Vid)?',
                        answer: 'Vídeo‑para‑Vídeo é um processo de IA generativa que usa um vídeo existente como entrada e o “repinta” em um novo estilo descrito pelo seu prompt, preservando o movimento e a estrutura originais.',
                    },
                    {
                        question: 'Posso transformar meu vídeo em estilo anime?',
                        answer: 'Sim! É o caso de uso mais popular. Envie seu vídeo e use prompts como “anime japonês, estilo Studio Ghibli” para transformar a filmagem.',
                    },
                    {
                        question: 'Qual pode ser a duração do vídeo de origem?',
                        answer: 'Atualmente suportamos/indicamos clipes curtos (por exemplo, 5–10 segundos) para garantir a melhor qualidade. Para vídeos longos, recomendamos dividir em segmentos.',
                    },
                    {
                        question: 'Isso é diferente de um editor de vídeo?',
                        answer: 'Sim. Um editor tradicional corta e trimma clipes. O Vídeo‑para‑Vídeo da 微鲤AI gera novos pixels, mudando completamente a textura e o estilo artístico do seu vídeo.',
                    },
                    {
                        question: 'Custa dinheiro?',
                        answer: 'A 微鲤AI oferece créditos diários grátis para testar o Vídeo‑para‑Vídeo. Planos premium estão disponíveis para processamento mais rápido e downloads sem marca d’água.',
                    },
                ],
            },
            faq: [
                {
                    question: 'O que é IA de Vídeo para Vídeo (Vid2Vid)?',
                    answer: 'Ele “repinta” um vídeo existente em um novo estilo via prompt, preservando movimento e estrutura.',
                },
                {
                    question: 'Posso transformar meu vídeo em estilo anime?',
                    answer: 'Sim. Use prompts como “anime japonês, estilo Studio Ghibli”.',
                },
                {
                    question: 'Qual pode ser a duração do vídeo de origem?',
                    answer: 'Recomendamos clipes curtos (5–10 s) para máxima qualidade; para longos, divida em segmentos.',
                },
                {
                    question: 'Isso é diferente de um editor de vídeo?',
                    answer: 'Editor corta; Vid2Vid gera novos pixels e muda textura/estilo do vídeo.',
                },
                {
                    question: 'Custa dinheiro?',
                    answer: 'Há créditos diários grátis; premium oferece mais velocidade e sem marca d’água.',
                },
            ],
        },
        removeWatermark: {
            title: `Removedor de Marca d'Água de Vídeo com IA (Grátis) - Apague Logos, Texto e Legendas | 微鲤AI`,
            description: `Remova facilmente marcas d'água, logos, legendas e carimbos de data com o Removedor de Marca d'Água IA grátis da 微鲤AI. Suporta MP4/MOV e links de vídeo. Sem borrão: restauração limpa com IA.`,
            keywords: `remover marca d'água de vídeo, borracha de vídeo IA, remover logo de vídeo, apagar legendas, removedor marca d'água TikTok, removedor de marca d'água online grátis`,
            og_title: `Removedor de Marca d'Água de Vídeo com IA (Grátis) - Apague Logos, Texto e Legendas | 微鲤AI`,
            og_description: `Remova facilmente marcas d'água, logos, legendas e carimbos de data com o Removedor de Marca d'Água IA grátis da 微鲤AI. Suporta MP4/MOV e links de vídeo. Sem borrão: restauração limpa com IA.`,
            twitter_title: `Removedor de Marca d'Água de Vídeo com IA (Grátis) - Apague Logos, Texto e Legendas | 微鲤AI`,
            twitter_description: `Remova facilmente marcas d'água, logos, legendas e carimbos de data com o Removedor de Marca d'Água IA grátis da 微鲤AI. Suporta MP4/MOV e links de vídeo. Sem borrão: restauração limpa com IA.`,
            page: {
                title1: `Removedor de Marca d'Água de Vídeo com IA (Online e Grátis)`,
                title2: `Apague instantaneamente marcas d'água, logos, textos sobrepostos e legendas dos seus vídeos. Cole um link ou envie um arquivo, selecione a área e deixe a IA restaurar o fundo pixel a pixel, sem borrão.`,
                click_erase: `1.Apagar com um clique: a IA detecta e remove automaticamente marcas d'água comuns.`,
                percision_erase: '2.Apagar com precisão: use o pincel para remover manualmente objetos complexos como legendas em movimento ou timestamps.',
                video_link_title: 'Via link',
                direct_link_desc: `1.Remover por link direto: cole links de redes sociais para remover marcas d'água sem baixar o arquivo.`,
                lossless_qua_title: '2.Qualidade sem perdas: diferente de ferramentas de blur, a 微鲤AI reconstrói o fundo analisando os pixels ao redor.',
                faq: [
                    {
                        question: 'Como remover marca d’água de vídeo online grátis?',
                        answer: 'Envie seu vídeo para a 微鲤AI ou cole um link. Cubra a marca d’água com a caixa de seleção e clique em “Generate”. É grátis para testar.',
                    },
                    {
                        question: 'Posso remover legendas ou texto em movimento?',
                        answer: 'Sim. Use o modo “Precision Erase” para selecionar a área do texto. A IA rastreia o objeto entre frames para remover com limpeza no vídeo inteiro.',
                    },
                    {
                        question: 'Funciona para vídeos do TikTok ou YouTube?',
                        answer: 'Com certeza. Você pode remover logos de plataforma (como a marca d’água saltitante do TikTok) ou watermarks de canal para obter um vídeo limpo para uso pessoal.',
                    },
                    {
                        question: 'A área removida vai ficar borrada?',
                        answer: 'Não. A 微鲤AI usa “Video In‑painting” avançado para preencher a área com texturas realistas geradas do vídeo ao redor, evitando o blur feio.',
                    },
                    {
                        question: 'Quais formatos de vídeo vocês suportam?',
                        answer: 'Suportamos os principais formatos, incluindo MP4, MOV, AVI e WebM.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Como remover marca d’água de vídeo online grátis?',
                    answer: 'Envie o vídeo ou cole um link, selecione a marca e clique em “Generate”.',
                },
                {
                    question: 'Posso remover legendas ou texto em movimento?',
                    answer: 'Sim. No “Precision Erase”, a IA rastreia entre frames para limpar o vídeo todo.',
                },
                {
                    question: 'A área removida vai ficar borrada?',
                    answer: 'Não. O Video In‑painting restaura com texturas realistas, sem blur.',
                },
            ],
        },
        videoFaceSwap: {
            title: 'Face Swap em Vídeo com IA Grátis Online - Deepfake Realista | 微鲤AI',
            description: 'Troque rostos em vídeos instantaneamente com o AI Face Swapper da 微鲤AI. Crie clipes engraçados, memes e deepfakes realistas grátis. Opções sem marca d’água disponíveis. 100% privado e seguro.',
            keywords: 'face swap em vídeo, trocador de rosto IA, deepfake grátis, substituir rosto no vídeo, face swap filme, reface online, meme maker IA',
            og_title: 'Face Swap em Vídeo com IA Grátis Online - Deepfake Realista | 微鲤AI',
            og_description: 'Troque rostos em vídeos instantaneamente com o AI Face Swapper da 微鲤AI. Crie clipes engraçados, memes e deepfakes realistas grátis. Opções sem marca d’água disponíveis. 100% privado e seguro.',
            twitter_title: 'Face Swap em Vídeo com IA Grátis Online - Deepfake Realista | 微鲤AI',
            twitter_description: 'Troque rostos em vídeos instantaneamente com o AI Face Swapper da 微鲤AI. Crie clipes engraçados, memes e deepfakes realistas grátis. Opções sem marca d’água disponíveis. 100% privado e seguro.',
            page: {
                title1: 'Face Swap em Vídeo com IA (Grátis)',
                title2: 'Seja a estrela de qualquer filme! Envie um clipe de vídeo e uma foto do rosto alvo e veja nossa IA trocar os rostos de forma natural. Perfeito para memes, mensagens personalizadas ou VFX profissionais com alta fidelidade.',
                feature_title1: 'Deepfake Hiper‑realista',
                feature_desc1: 'A IA analisa geometria facial e iluminação para mesclar o novo rosto naturalmente, preservando expressões e movimentos da cabeça.',
                feature_title2: 'Privacidade em Primeiro Lugar',
                feature_desc2: 'Priorizamos sua privacidade. Vídeos e imagens enviados são processados com segurança e apagados pouco após a geração.',
                feature_title3: 'Sem Habilidades Técnicas',
                feature_desc3: 'Não precisa de softwares complexos como After Effects. Clique em “Create” e obtenha resultados nível Hollywood em segundos.',
                faq: [
                    {
                        question: 'O Face Swap em Vídeo da 微鲤AI é grátis?',
                        answer: 'Sim. Oferecemos créditos grátis para você testar a troca de rosto em vídeos online. Não é necessário cartão.',
                    },
                    {
                        question: 'É seguro enviar minhas fotos?',
                        answer: 'Com certeza. Usamos protocolos rígidos de proteção de dados. Seus vídeos e imagens são usados apenas para a geração e não ficam armazenados permanentemente.',
                    },
                    {
                        question: 'Posso trocar rostos em GIFs?',
                        answer: 'Sim! A 微鲤AI suporta vídeo (MP4/MOV) e GIF. Você pode criar GIFs de reação personalizados facilmente.',
                    },
                    {
                        question: 'Como obter os melhores resultados?',
                        answer: 'Use uma foto do rosto alvo nítida, de frente e bem iluminada. Evite fotos com o rosto coberto por cabelo ou óculos.',
                    },
                    {
                        question: 'Posso usar em projetos comerciais?',
                        answer: 'Sim, mas garanta que você possui os direitos do vídeo original e autorização para usar a imagem da pessoa.',
                    },
                ],
            },
            faq: [
                {
                    question: 'O Face Swap em Vídeo da 微鲤AI é grátis?',
                    answer: 'Sim. Há créditos grátis e não é necessário cartão.',
                },
                {
                    question: 'É seguro enviar minhas fotos?',
                    answer: 'Sim. Os arquivos são usados apenas para a geração.',
                },
                {
                    question: 'Como obter os melhores resultados?',
                    answer: 'Use foto nítida, frontal e bem iluminada; evite rosto coberto por cabelo/óculos.',
                },
            ],
        },
        videoLipSync: {
            title: 'Gerador grátis de lip sync em vídeo com IA — Sincronize áudio e texto com vídeo | 微鲤AI',
            description: 'Sincronize perfeitamente os movimentos dos lábios com qualquer áudio ou texto usando a ferramenta de Lip Sync com IA da 微鲤AI. Com tecnologia Kling AI. Ideal para tradução de vídeos, dublagem e avatares falantes. Grátis e online.',
            keywords: 'sincronização labial vídeo, sincronização labial, sincronização labial IA, dublagem vídeo, sincronização voz, vídeo falante, ferramenta sincronização labial',
            og_title: 'Gerador grátis de lip sync em vídeo com IA — Sincronize áudio e texto com vídeo | 微鲤AI',
            og_description: 'Sincronize perfeitamente os movimentos dos lábios com qualquer áudio ou texto usando a ferramenta de Lip Sync com IA da 微鲤AI. Com tecnologia Kling AI. Ideal para tradução de vídeos, dublagem e avatares falantes. Grátis e online.',
            twitter_title: 'Gerador grátis de lip sync em vídeo com IA — Sincronize áudio e texto com vídeo | 微鲤AI',
            twitter_description: 'Sincronize perfeitamente os movimentos dos lábios com qualquer áudio ou texto usando a ferramenta de Lip Sync com IA da 微鲤AI. Com tecnologia Kling AI. Ideal para tradução de vídeos, dublagem e avatares falantes. Grátis e online.',
            page: {
                title1: 'Ferramenta grátis de lip sync e dublagem com IA',
                title2: 'Diga adeus a dublagens estranhas. Envie um vídeo e um arquivo de áudio (ou digite um texto), e nossa IA vai regenerar os movimentos labiais do(a) falante para combinar perfeitamente com o som. Com tecnologia Kling AI, oferece dublagem multilíngue e ajustes faciais realistas.',
                dual_input_modes: 'Modos de entrada duplos',
                audio_sync: 'Sincronização de áudio',
                text_sync: 'Texto para fala',
                text_sync_tip: 'Digite qualquer texto, escolha uma voz de IA predefinida e faça o personagem falar na hora.',
                audio_sync_tip: 'Envie sua própria narração ou música para sincronizar.',
                feature_title1: 'Dublagem multilíngue',
                feature_desc1: 'Aumente seu alcance. Traduza seu vídeo para espanhol, francês ou japonês e sincronize os lábios para parecer que o(a) falante é nativo(a).',
                feature_title2: 'Precisão do Kling AI',
                feature_desc2: 'Ao contrário de ferramentas Wav2Lip básicas, usamos o modelo Kling para garantir que dentes, língua e mandíbula se movam de forma anatomicamente correta.',
                faq: [
                    {
                        question: 'Como sincronizar os lábios com o áudio em um vídeo?',
                        answer: 'Envie seu clipe para a 微鲤AI. Depois, envie um arquivo de áudio (MP3/WAV) ou digite um texto para gerar fala por IA. Clique em "Create" e nossa IA ajustará os movimentos da boca para combinar com o som.',
                    },
                    {
                        question: 'Posso usar isso para tradução/dublagem de vídeos?',
                        answer: 'Sim! É perfeito para dublagem. Você pode enviar uma faixa de áudio traduzida e a IA corrigirá o lip sync para que a versão dublada pareça natural.',
                    },
                    {
                        question: 'Funciona com imagens estáticas (cabeça falante)?',
                        answer: 'Sim. Se você enviar um retrato estático como fonte “de vídeo”, a ferramenta o animará em um vídeo de cabeça falante (efeito Live Portrait).',
                    },
                    {
                        question: 'Quais idiomas são suportados?',
                        answer: 'Como a tecnologia analisa ondas de áudio, ela funciona com qualquer idioma (inglês, espanhol, chinês, hindi etc.). Para entrada de Texto para Fala, suportamos 50+ idiomas.',
                    },
                    {
                        question: 'O lip sync é grátis?',
                        answer: 'A 微鲤AI oferece créditos diários grátis para testar o recurso de Lip Sync. Para vídeos longos ou uso comercial, há planos premium.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Como sincronizar os lábios com o áudio em um vídeo?',
                    answer: 'Envie seu clipe para a 微鲤AI. Depois, envie um arquivo de áudio (MP3/WAV) ou digite um texto para gerar fala por IA. Clique em "Create" e nossa IA ajustará os movimentos da boca para combinar com o som.',
                },
                {
                    question: 'Posso usar isso para tradução/dublagem de vídeos?',
                    answer: 'Sim! É perfeito para dublagem. Você pode enviar uma faixa de áudio traduzida e a IA corrigirá o lip sync para que a versão dublada pareça natural.',
                },
                {
                    question: 'Funciona com imagens estáticas (cabeça falante)?',
                    answer: 'Sim. Se você enviar um retrato estático como fonte “de vídeo”, a ferramenta o animará em um vídeo de cabeça falante (efeito Live Portrait).',
                },
            ],
        },
        translateVideoSubtitle: {
            title: 'Tradutor de legendas de vídeo com IA grátis — Gerar e traduzir online | 微鲤AI',
            description: 'Gere e traduza legendas automaticamente com o Tradutor de Legendas IA da 微鲤AI. Suporta inglês, espanhol, chinês e mais de 90 idiomas. Baixe instantaneamente vídeos com legendas queimadas (hardsubs).',
            keywords: 'tradução de legendas IA, tradutor de legendas de vídeo, legendas multilíngues, tradução de vídeo, conversor de legendas, tradução de vídeo IA',
            og_title: 'Tradutor de legendas de vídeo com IA grátis — Gerar e traduzir online | 微鲤AI',
            og_description: 'Gere e traduza legendas automaticamente com o Tradutor de Legendas IA da 微鲤AI. Suporta inglês, espanhol, chinês e mais de 90 idiomas. Baixe instantaneamente vídeos com legendas queimadas (hardsubs).',
            twitter_title: 'Tradutor de legendas de vídeo com IA grátis — Gerar e traduzir online | 微鲤AI',
            twitter_description: 'Gere e traduza legendas automaticamente com o Tradutor de Legendas IA da 微鲤AI. Suporta inglês, espanhol, chinês e mais de 90 idiomas. Baixe instantaneamente vídeos com legendas queimadas (hardsubs).',
            page: {
                title1: 'Tradutor de legendas de vídeo com IA grátis',
                title2: 'Quebre a barreira do idioma em segundos. Envie seu vídeo, selecione o idioma de destino e deixe a IA reconhecer a fala, transcrever o áudio e queimar legendas traduzidas e precisas diretamente no arquivo de vídeo.',
                feature_title1: 'Suporte a 90+ idiomas',
                feature_desc1: 'Traduza seu conteúdo do inglês para espanhol, francês, alemão, japonês, chinês e muito mais. Alcance um público global com um clique.',
                feature_title2: 'Auto-sincronização e queima',
                feature_desc2: 'Não é preciso ajustar timestamps manualmente. A IA sincroniza as legendas com o áudio e as queima no vídeo (hardsubs) para máxima compatibilidade.',
                feature_title3: 'Precisão com contexto',
                feature_desc3: 'Com LLMs avançados, a 微鲤AI entende contexto e gírias, entregando traduções naturais e precisas — não traduções literais e robóticas.',
                faq: [
                    {
                        question: 'Como traduzir legendas de vídeo automaticamente?',
                        answer: 'Envie seu vídeo para a 微鲤AI, selecione o “Target Language” (ex.: inglês→espanhol) e clique em “Create”. A IA gerará e traduzirá as legendas automaticamente.',
                    },
                    {
                        question: 'Quais idiomas são suportados?',
                        answer: 'Suportamos mais de 90 idiomas, incluindo inglês, espanhol, francês, alemão, português, hindi, japonês e chinês.',
                    },
                    {
                        question: 'O tradutor de legendas é gratuito?',
                        answer: 'Sim. A 微鲤AI oferece acesso gratuito ao tradutor de legendas com IA, para você processar vídeos sem pagar por serviços caros de transcrição.',
                    },
                    {
                        question: 'Preciso baixar um arquivo SRT?',
                        answer: 'Não. A 微鲤AI gera vídeos com legendas embutidas (queimadas), garantindo que apareçam corretamente no TikTok, Instagram e YouTube.',
                    },
                    {
                        question: 'Quão precisa é a tradução?',
                        answer: 'Usamos modelos de reconhecimento de fala de ponta para alta precisão. Com áudio claro, a precisão pode ultrapassar 95%.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Como traduzir legendas de vídeo automaticamente?',
                    answer: 'Envie seu vídeo para a 微鲤AI, selecione o Target Language e clique em Create. A IA gerará e traduzirá as legendas automaticamente.',
                },
                {
                    question: 'Quais idiomas são suportados?',
                    answer: 'Suportamos mais de 90 idiomas, incluindo inglês, espanhol, francês, alemão, português, hindi, japonês e chinês.',
                },
                {
                    question: 'Preciso baixar um arquivo SRT?',
                    answer: 'Não. A 微鲤AI gera vídeos com legendas queimadas (embutidas), que funcionam corretamente em todas as redes sociais.',
                },
            ],
        },
        videoToAnime: {
            title: 'Conversor de Vídeo para Anime com IA Grátis — Real para Cartoon e Pixar | 微鲤AI',
            description: 'Transforme seus vídeos em anime japonês, estilo Pixar 3D ou cartoons instantaneamente com o Conversor de Vídeo para Anime da 微鲤AI. Estabilidade quadro a quadro para animação suave. Grátis e online.',
            keywords: 'vídeo para anime, filtro anime IA, transformar vídeo em cartoon, filtro pixar vídeo, real para anime, alternativa domoai, gerador de anime',
            og_title: 'Conversor de Vídeo para Anime com IA Grátis — Real para Cartoon e Pixar | 微鲤AI',
            og_description: 'Transforme seus vídeos em anime japonês, estilo Pixar 3D ou cartoons instantaneamente com o Conversor de Vídeo para Anime da 微鲤AI. Estabilidade quadro a quadro para animação suave. Grátis e online.',
            twitter_title: 'Conversor de Vídeo para Anime com IA Grátis — Real para Cartoon e Pixar | 微鲤AI',
            twitter_description: 'Transforme seus vídeos em anime japonês, estilo Pixar 3D ou cartoons instantaneamente com o Conversor de Vídeo para Anime da 微鲤AI. Estabilidade quadro a quadro para animação suave. Grátis e online.',
            page: {
                title1: 'Conversor de Vídeo para Anime com IA Grátis',
                title2: 'Vire protagonista de anime com um clique. Envie qualquer vídeo real, escolha um estilo (Pixar 3D, 2D clássico ou desenho à mão) e deixe nossa IA reestilizar quadro a quadro mantendo o movimento suave e consistente.',
                feature_desc1: '<div><p>Pixar & 3D: crie clipes fofos estilo Disney, perfeitos para vídeos de família.</p><p>Anime clássico: obtenha um visual autêntico de animação japonesa (estilo Ghibli/Shinkai).</p><p>Sketch & Ink: transforme vídeos em animações artísticas tipo desenho a lápis.</p></div>',
                feature_title2: 'Estabilidade quadro a quadro',
                feature_desc2: 'Cansado de vídeos IA piscando? A 微鲤AI usa algoritmos avançados de consistência temporal para que seu vídeo anime fique suave, sem os “trancos” comuns em outras ferramentas.',
                feature_title3: 'Criador de conteúdo viral',
                feature_desc3: 'Feito para TikTok e Reels. Crie comparações “Real vs Anime” que prendem a atenção imediatamente.',
                faq: [
                    {
                        question: 'Como transformar um vídeo em anime grátis?',
                        answer: 'Envie seu clipe para a ferramenta Vídeo→Anime da 微鲤AI. Selecione um preset (como “2D Style” ou “Pixar Style”) e clique em Create. Dá para testar grátis com créditos diários.',
                    },
                    {
                        question: 'Posso converter para estilo Pixar/Disney?',
                        answer: 'Sim! Temos um preset “3D Cartoon” ou “Pixar Style” que transforma pessoas reais em personagens 3D fofos.',
                    },
                    {
                        question: 'Qual pode ser a duração do vídeo?',
                        answer: 'Atualmente suportamos clipes de até 30 segundos (como em “Maximum video duration: 30s”). Ideal para Shorts, Reels e TikTok.',
                    },
                    {
                        question: 'O personagem anime vai se mover como eu?',
                        answer: 'Com certeza. A IA analisa seus movimentos e expressões para que o personagem imite suas ações.',
                    },
                    {
                        question: 'Qual é o melhor conversor de vídeo para anime?',
                        answer: 'A 微鲤AI é uma ótima opção por oferecer estilos 2D/3D e focar em estabilidade para reduzir ruído e piscadas.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Como transformar um vídeo em anime grátis?',
                    answer: 'Envie seu vídeo para a 微鲤AI, escolha um preset (2D Style ou Pixar Style) e clique em Create.',
                },
                {
                    question: 'Posso converter para estilo Pixar/Disney?',
                    answer: 'Sim. Oferecemos um preset 3D Cartoon/Pixar Style para transformar pessoas reais em personagens 3D.',
                },
                {
                    question: 'O personagem anime vai se mover como eu?',
                    answer: 'Sim. A IA analisa movimentos e expressões para imitar suas ações.',
                },
            ],
            app_name: '微鲤AI Conversor de Vídeo para Anime',
            app_desc: 'Ferramenta de IA grátis para converter vídeos reais em anime, cartoon e estilo Pixar. Renderização quadro a quadro para animação estável.',
            featureList: 'Real→Anime, Filtro Pixar, Consistência de quadros, Estilos 2D/3D',
        },
        videoUpscaler: {
            title: 'AI Video Upscaler grátis — Melhore para 4K online | 微鲤AI',
            description: 'Melhore instantaneamente vídeos de baixa resolução para 1080p, 2K e 4K com o AI Video Upscaler grátis da 微鲤AI. Corrige pixelização, reduz ruído e melhora a qualidade online sem instalar software.',
            keywords: 'video upscaler, melhorador de vídeo IA, upscale vídeo para 4k, remover desfoque de vídeo, redução de ruído de vídeo, melhorar qualidade de vídeo, upscaler de vídeo grátis online',
            og_title: 'AI Video Upscaler grátis — Melhore para 4K online | 微鲤AI',
            og_description: 'Melhore instantaneamente vídeos de baixa resolução para 1080p, 2K e 4K com o AI Video Upscaler grátis da 微鲤AI. Corrige pixelização, reduz ruído e melhora a qualidade online sem instalar software.',
            twitter_title: 'AI Video Upscaler grátis — Melhore para 4K online | 微鲤AI',
            twitter_description: 'Melhore instantaneamente vídeos de baixa resolução para 1080p, 2K e 4K com o AI Video Upscaler grátis da 微鲤AI. Corrige pixelização, reduz ruído e melhora a qualidade online sem instalar software.',
            page: {
                title1: 'AI Video Upscaler & Enhancer grátis',
                title2: 'Não aceite vídeos borrados e pixelados. Envie seus vídeos de baixa resolução (360p, 480p, 720p) e use nossa IA para fazer upscale automático para 4K. O motor não só aumenta o tamanho: também restaura detalhes, remove ruído e corrige cores.',
                feature_title1: 'Upscale para 4K',
                feature_desc1: 'Dê nova vida a vídeos antigos. Converta SD para HD ou 4K com um clique, deixando nítido em telas grandes.',
                feature_title2: 'Corrija vídeo borrado e granulado',
                feature_desc2: 'Gravado com pouca luz? Nosso algoritmo de denoise remove granulação e artefatos de compressão para um visual limpo e profissional.',
                feature_title3: 'Restauração de filmagens antigas',
                feature_desc3: 'Perfeito para arquivos de família. Restaure cores desbotadas e aumente detalhes em vídeos caseiros antigos ou clipes vintage.',
                faq: [
                    {
                        question: 'Posso fazer upscale para 4K online de graça?',
                        answer: 'Sim. A 微鲤AI permite selecionar resolução de saída até 4K (nas opções). Você pode testar de graça com créditos diários.',
                    },
                    {
                        question: 'Como corrigir um vídeo borrado?',
                        answer: 'Basta enviar o vídeo borrado ao AI Video Upscaler. A IA analisa os pixels perdidos e reconstrói detalhes para reduzir o desfoque.',
                    },
                    {
                        question: 'Funciona com vídeos antigos de celular?',
                        answer: 'Com certeza. Funciona melhor em vídeos de baixa qualidade (360p/480p), transformando em 1080p ou superior.',
                    },
                    {
                        question: 'Quanto tempo leva o processo?',
                        answer: 'Upscaling é computacionalmente pesado, mas a 微鲤AI usa GPUs na nuvem otimizadas. Um clipe curto geralmente leva alguns minutos.',
                    },
                    {
                        question: 'É melhor que o Topaz Video AI?',
                        answer: 'A 微鲤AI oferece qualidade comparável e roda totalmente no navegador, sem exigir hardware caro ou instalação.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Posso fazer upscale de vídeo para 4K online?',
                    answer: 'Sim. A 微鲤AI permite saída até 4K e você pode testar com créditos diários.',
                },
                {
                    question: 'Como corrigir um vídeo borrado?',
                    answer: 'Envie o vídeo ao AI Video Upscaler: a IA reconstrói detalhes para reduzir o desfoque.',
                },
                {
                    question: 'É melhor que o Topaz Video AI?',
                    answer: 'A 微鲤AI oferece qualidade comparável e roda no navegador sem instalação ou hardware caro.',
                },
            ],
            app_name: '微鲤AI Video Upscaler',
            app_desc: 'AI Video Upscaler grátis para melhorar a qualidade até 4K. Corrige vídeos borrados, remove ruído e restaura filmagens antigas online.',
            featureList: 'Upscaling 4K, AI Denoising, Nitidez de vídeo, Correção de cor',
        },
        removeVideoSubtitles: {
            title: 'Remover Legendas de Vídeo - Removedor de Legendas IA | 微鲤AI',
            description: 'Remova legendas incorporadas de vídeos com tecnologia IA. Apague inteligentemente legendas e texto codificados de vídeos preservando a qualidade do vídeo. Rápido e fácil de usar.',
            keywords: 'remover legendas de vídeo, removedor legendas, remover legendas, apagar legendas, remoção legendas vídeo, remover legendas codificadas',
            og_title: 'Remover Legendas de Vídeo - Removedor de Legendas IA | 微鲤AI',
            og_description: 'Remova legendas incorporadas de vídeos com tecnologia IA. Apague inteligentemente legendas e texto codificados de vídeos preservando a qualidade do vídeo. Rápido e fácil de usar.',
            twitter_title: 'Remover Legendas de Vídeo - Removedor de Legendas IA | 微鲤AI',
            twitter_description: 'Remova legendas incorporadas de vídeos com tecnologia IA. Apague inteligentemente legendas e texto codificados de vídeos preservando a qualidade do vídeo. Rápido e fácil de usar.',
            page: {
                title1: 'Removedor de Legendas IA (Grátis)',
                title2: 'Legendas “queimadas” atrapalhando? O algoritmo inteligente da 微鲤AI detecta e apaga automaticamente legendas hardcoded, letras e textos na tela. Cole um link ou envie um arquivo para restaurar um vídeo limpo e sem texto em instantes.',
                feature_title1: 'Detecção inteligente de texto',
                feature_desc1: 'Sem máscara manual. A IA identifica automaticamente áreas de texto na parte inferior (ou em qualquer lugar) e as separa do fundo.',
                feature_title2: 'In‑painting perfeito',
                feature_desc2: 'Diga adeus aos blocos borrados. A 微鲤AI preenche a área removida analisando pixels ao redor e reconstruindo texturas de forma natural.',
                feature_title3: 'Suporte a links e arquivos',
                feature_desc3: 'Remova legendas diretamente de links do TikTok, YouTube ou Instagram, ou envie arquivos MP4/MOV. Ideal para reaproveitar conteúdo.',
                faq: [
                    {
                        question: 'Posso remover legendas hardcoded (queimadas)?',
                        answer: 'Sim. Esta ferramenta foi feita para legendas hardcoded que fazem parte da imagem do vídeo e não podem ser desativadas. Ela apaga visualmente.',
                    },
                    {
                        question: 'Como remover legendas de um vídeo do TikTok/YouTube?',
                        answer: 'Copie o link do vídeo, cole na aba “Video Link” da 微鲤AI e clique em “Generate”. A IA removerá as legendas e você poderá baixar o vídeo limpo.',
                    },
                    {
                        question: 'Ela remove o fundo atrás do texto?',
                        answer: 'Não. A 微鲤AI usa AI In‑painting: remove o texto e “repinta” o fundo para que o vídeo pareça original e completo.',
                    },
                    {
                        question: 'Qual a diferença para o Removedor de Marca d’água?',
                        answer: 'São parecidos, mas o Removedor de Legendas é otimizado para faixas de texto/lyrics/captions (geralmente embaixo), enquanto o Removedor de Marca d’água foca em logos e carimbos.',
                    },
                    {
                        question: 'É gratuito?',
                        answer: 'Sim, você pode usar as funções básicas de remoção de legendas gratuitamente com créditos diários.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Posso remover legendas hardcoded?',
                    answer: 'Sim. Esta ferramenta é feita para legendas que fazem parte da imagem do vídeo. Ela apaga visualmente.',
                },
                {
                    question: 'Como remover captions de um link do TikTok?',
                    answer: 'Copie o link, cole na aba “Video Link” e clique em “Generate”. A IA remove automaticamente.',
                },
                {
                    question: 'O fundo atrás do texto será afetado?',
                    answer: 'Não. A 微鲤AI usa AI In‑painting para remover o texto e reconstruir o fundo de forma inteligente.',
                },
            ],
            app_name: '微鲤AI Removedor de Legendas',
            app_desc: 'Ferramenta IA grátis para apagar legendas hardcoded, captions e textos de vídeos. Usa in‑painting para restaurar o fundo sem blocos borrados.',
            featureList: 'Remoção de legendas hardcoded, Restauração de fundo com IA, Suporte a links de vídeo, Apagador de letras',
        },
        videoBackgroundRemover: {
            title: 'Removedor de Fundo de Vídeo - Remover Fundo de Vídeo com IA | 微鲤AI',
            description: 'Remova fundos de vídeos automaticamente com IA. Crie efeitos de tela verde, isole assuntos e substitua fundos de vídeo facilmente. Perfeito para criadores de conteúdo e editores de vídeo.',
            keywords: 'removedor fundo vídeo, remover fundo vídeo, tela verde, remoção fundo IA, borracha fundo vídeo, isolar assunto vídeo',
            og_title: 'Removedor de Fundo de Vídeo - Remover Fundo de Vídeo com IA | 微鲤AI',
            og_description: 'Remova fundos de vídeos automaticamente com IA. Crie efeitos de tela verde, isole assuntos e substitua fundos de vídeo facilmente. Perfeito para criadores de conteúdo e editores de vídeo.',
            twitter_title: 'Removedor de Fundo de Vídeo - Remover Fundo de Vídeo com IA | 微鲤AI',
            twitter_description: 'Remova fundos de vídeos automaticamente com IA. Crie efeitos de tela verde, isole assuntos e substitua fundos de vídeo facilmente. Perfeito para criadores de conteúdo e editores de vídeo.',
            page: {
                title1: 'Removedor de Fundo de Vídeo com IA (Grátis)',
                title2: 'Sem tela verde? Sem problema. Envie seu vídeo e a IA detecta o sujeito automaticamente, recorta com precisão de cabelo e permite baixar um vídeo com fundo transparente ou substituir o fundo por uma cor sólida na hora.',
                feature_title1: 'Não precisa de tela verde',
                feature_desc1: 'Esqueça estúdios caros. A IA separa pessoas, pets e objetos de fundos complexos automaticamente (auto‑rotoscoping).',
                feature_title2: 'Troca por cor sólida',
                feature_desc2: 'Perfeito para e‑commerce. Mude o fundo do seu vídeo de produto para branco puro, preto ou cores personalizadas com um clique para aumentar conversões.',
                feature_title3: 'Exportação transparente',
                feature_desc3: 'Baixe com canal alfa (WebM/MOV) e sobreponha o sujeito em outros vídeos no Premiere Pro, DaVinci Resolve ou CapCut.',
                faq: [
                    {
                        question: 'Posso remover o fundo do vídeo sem tela verde?',
                        answer: 'Sim! A 微鲤AI usa machine learning avançado para distinguir sujeito e fundo, permitindo remover fundos de vídeos gravados em qualquer lugar.',
                    },
                    {
                        question: 'Como salvar um vídeo com fundo transparente?',
                        answer: 'Após remover o fundo, selecione WebM (Transparent) ou MOV como formato de saída. O MP4 padrão não suporta transparência e mostrará fundo preto.',
                    },
                    {
                        question: 'Posso trocar o fundo do vídeo para branco?',
                        answer: 'Sim. Nas configurações, use o seletor “Background Color” para escolher branco, preto ou qualquer cor em hex. Ideal para vídeos de produto em Amazon/Shopify.',
                    },
                    {
                        question: 'Ele lida bem com cabelo?',
                        answer: 'Sim. O algoritmo foi treinado para preservar detalhes finos como cabelo, pelos e objetos semitransparentes (como óculos).',
                    },
                    {
                        question: 'É gratuito?',
                        answer: 'Sim, você pode processar vídeos gratuitamente com créditos diários.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Posso remover o fundo do vídeo sem tela verde?',
                    answer: 'Sim! A 微鲤AI não precisa de tela verde para separar o sujeito do fundo.',
                },
                {
                    question: 'Como salvar um vídeo com fundo transparente?',
                    answer: 'Selecione WebM (Transparent) ou MOV. O MP4 padrão não suporta transparência.',
                },
                {
                    question: 'Posso trocar o fundo do vídeo para branco?',
                    answer: 'Sim. Use o Background Color para escolher branco, ideal para vídeos de produto.',
                },
            ],
            app_name: '微鲤AI Removedor de Fundo de Vídeo',
            app_desc: 'Ferramenta IA grátis para remover fundo de vídeo sem tela verde. Exporte vídeos transparentes ou troque o fundo para branco/preto online.',
            featureList: 'Sem tela verde, Exportação de vídeo transparente, Troca de cor de fundo, Precisão em cabelo',
            step_name: 'Como remover o fundo do vídeo online',
            step_list: [
                {
                    name: 'Enviar vídeo',
                    text: 'Envie seu vídeo (MP4, MOV) para o Removedor de Fundo da 微鲤AI.',
                },
                {
                    name: 'Remover fundo',
                    text: 'A IA processa automaticamente. Você pode deixar transparente ou escolher uma nova cor de fundo.',
                },
                {
                    name: 'Exportar',
                    text: 'Baixe o resultado. Escolha WebM/MOV para transparência ou MP4 para fundos sólidos.',
                },
            ],
        },
        aiVideoExtender: {
            title: 'Extensor de Vídeo IA - Estender Comprimento e Duração de Vídeo | 微鲤AI',
            description: 'Estenda o comprimento do vídeo com tecnologia IA. Adicione 5-8 segundos aos seus vídeos perfeitamente com várias opções de estilo incluindo anime, animação 3D, cyberpunk e quadrinhos. Perfeito para criadores de conteúdo e editores de vídeo.',
            keywords: 'extensor vídeo IA, estender comprimento vídeo, extensão duração vídeo, extensão vídeo IA, alongar vídeo, estender tempo vídeo, ferramenta vídeo IA',
            og_title: 'Extensor de Vídeo IA - Estender Comprimento e Duração de Vídeo | 微鲤AI',
            og_description: 'Estenda o comprimento do vídeo com tecnologia IA. Adicione 5-8 segundos aos seus vídeos perfeitamente com várias opções de estilo incluindo anime, animação 3D, cyberpunk e quadrinhos. Perfeito para criadores de conteúdo e editores de vídeo.',
            twitter_title: 'Extensor de Vídeo IA - Estender Comprimento e Duração de Vídeo | 微鲤AI',
            twitter_description: 'Estenda o comprimento do vídeo com tecnologia IA. Adicione 5-8 segundos aos seus vídeos perfeitamente com várias opções de estilo incluindo anime, animação 3D, cyberpunk e quadrinhos. Perfeito para criadores de conteúdo e editores de vídeo.',
            page: {
                title1: 'Extensor de Vídeo com IA (Grátis) e Continuação',
                title2: 'Seu vídeo ficou curto? A 微鲤AI usa IA generativa para prever e criar novos frames, estendendo seu clipe sem emendas. Você também pode usar prompts para guiar como o vídeo continua ou transformar uma gravação normal em slow motion super suave.',
                feature_title1: 'Extensão generativa inteligente',
                feature_desc1: 'Não apenas estique o vídeo: crie conteúdo novo. Digite um prompt como “a câmera dá zoom para fora” ou “o personagem vira”, e a IA vai gerar os próximos 5–10 segundos consistentes com o estilo original.',
                feature_title2: 'Slow motion super suave',
                feature_desc2: 'Transforme vídeos 30fps em slow motion de alta qualidade. A 微鲤AI usa Frame Interpolation para inserir frames gerados por IA entre os frames existentes, criando movimento fluido sem travar.',
                feature_title3: 'Loops perfeitos',
                feature_desc3: 'Crie loops infinitos para fundos em redes sociais. A IA analisa os frames inicial e final para fazer uma transição perfeita.',
                faq: [
                    {
                        question: 'Como funciona o extensor de vídeo com IA?',
                        answer: 'Ele usa a tecnologia “Generative Outpainting”. A IA analisa os últimos frames do seu vídeo e seu prompt para prever e gerar novos frames que continuam a ação de forma lógica.',
                    },
                    {
                        question: 'Posso controlar o que acontece na parte estendida?',
                        answer: 'Sim! Use a caixa “Prompt” para descrever a ação. Por exemplo, se o vídeo mostra um carro dirigindo, você pode digitar “o carro entra em um túnel” para guiar a extensão.',
                    },
                    {
                        question: 'Qual a diferença entre Extensão e Slow Motion?',
                        answer: 'Extensão adiciona tempo novo gerando novos eventos (deixa a história mais longa). Slow Motion estica o tempo existente adicionando frames intermediários (deixa a ação mais lenta). A 微鲤AI faz os dois.',
                    },
                    {
                        question: 'Quanto posso estender um vídeo?',
                        answer: 'Você pode estender 5 segundos por vez (configuração “Extension Duration”). Repita o processo para criar sequências mais longas.',
                    },
                    {
                        question: 'É gratuito?',
                        answer: 'Sim, a 微鲤AI oferece créditos grátis para testar extensão de vídeo e slow motion.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Como funciona o extensor de vídeo com IA?',
                    answer: 'Com “Generative Outpainting”, a IA analisa os últimos frames e seu prompt para gerar a continuação.',
                },
                {
                    question: 'Posso controlar a parte estendida?',
                    answer: 'Sim. Descreva a ação na caixa “Prompt” (ex.: “o carro entra em um túnel”).',
                },
                {
                    question: 'Diferença entre Extensão e Slow Motion?',
                    answer: 'Extensão gera eventos novos; Slow Motion adiciona frames intermediários para desacelerar.',
                },
            ],
            app_name: '微鲤AI Extensor de Vídeo',
            app_desc: 'Ferramenta IA grátis para estender vídeos com generative fill e prompts. Também inclui slow motion com IA (frame interpolation) e criação de loops.',
            featureList: 'Extensão de vídeo generativa, Continuação guiada por prompt, Slow motion IA, Loops de vídeo',
        },
        videoEffects: {
            title: 'Efeitos de Vídeo - Crie Vídeos Virais com IA | 微鲤AI',
            description: 'Explore efeitos de vídeo IA populares no 微鲤AI. De Beijos IA a Dança IA, crie vídeos virais com apenas alguns cliques.',
            keywords: 'efeitos de vídeo IA, vídeos virais IA, tendências de vídeo, beijos IA, dança IA, gerador de vídeo',
        },
        aiDancing: {
            title: 'Gerador de Vídeo de Dança IA - Criador de Vídeo de Dança IA Gratuito | 微鲤AI',
            description: 'Use o Gerador de Dança IA do 微鲤AI para criar vídeos de dança incríveis a partir de fotos. Suporta vários modelos e estilos de dança, dê vida às suas fotos!',
            keywords: 'vídeo de dança IA, gerador de dança IA, foto para vídeo, geração de vídeo IA, 微鲤AI, ferramentas IA gratuitas',
        },
        aiKissing: {
            title: 'aiKissing | 微鲤AI',
            description: 'Experience aiKissing on 微鲤AI platform.',
            keywords: 'aiKissing, AI, 微鲤AI',
        },
        videoMotionImitation: {
            title: 'Imitação de Movimento de Vídeo IA - Dê Vida às Fotos Gratuitamente | 微鲤AI',
            description: 'A ferramenta de imitação de movimento de vídeo do 微鲤AI pode integrar personagens de fotos em vídeos de referência, substituindo personagens originais enquanto preserva a iluminação e os tons da cena para uma fusão ambiental perfeita.',
            keywords: 'imitação de movimento de vídeo IA, dar vida às fotos, ferramenta de imitação de movimento de vídeo IA, 微鲤AI, ferramentas IA gratuitas',
            og_title: 'Imitação de Movimento de Vídeo IA - Dê Vida às Fotos Gratuitamente | 微鲤AI',
            og_description: 'A ferramenta de imitação de movimento de vídeo do 微鲤AI pode integrar personagens de fotos em vídeos de referência, substituindo personagens originais enquanto preserva a iluminação e os tons da cena para uma fusão ambiental perfeita.',
            twitter_title: 'Imitação de Movimento de Vídeo IA - Dê Vida às Fotos Gratuitamente | 微鲤AI',
            twitter_description: 'A ferramenta de imitação de movimento de vídeo do 微鲤AI pode integrar personagens de fotos em vídeos de referência, substituindo personagens originais enquanto preserva a iluminação e os tons da cena para uma fusão ambiental perfeita.',
            page: {
                title1: 'Gerador de Dança com IA Grátis e Transferência de Movimento',
                title2: 'Quer ver seu personagem de anime favorito dançar como Michael Jackson? Ou fazer uma foto estática executar um movimento viral do TikTok? Basta enviar um vídeo de referência e uma imagem do personagem — nossa IA transfere o movimento com precisão.',
                feature_title1: 'Substituição de Personagem no Vídeo',
                feature_desc1: 'Troca Real→Anime: envie um vídeo de uma pessoa dançando ou lutando e substitua por um personagem 3D, panda ou avatar de anime, mantendo o fundo e a iluminação originais.',
                feature_title2: 'Faça Fotos Dançarem',
                feature_desc2: 'Anime imagens estáticas: dê vida às fotos. Envie uma foto sua ou de um personagem, escolha um vídeo de dança de referência e veja a foto imitar os movimentos. Ideal para conteúdo viral estilo Viggle.',
                feature_title3: 'Quebre a Parede das Dimensões',
                feature_desc3: 'Estilos cruzados: seja transformar uma bailarina em garota de anime ou um garoto de karatê em panda, o 微鲤AI lida bem com corpos complexos e oclusões.',
                faq: [
                    {
                        question: 'Como fazer uma foto dançar com IA?',
                        answer: 'Use o “Move Mode” do 微鲤AI. Envie a foto que você quer animar (Character Image) e um vídeo com os movimentos (Reference Video). Clique em Create para transferir o movimento.',
                    },
                    {
                        question: 'Qual a diferença entre Move Mode e Replace Mode?',
                        answer: 'Move Mode anima uma imagem estática usando o movimento de um vídeo. Replace Mode substitui a pessoa dentro de um vídeo existente por um novo personagem a partir de uma imagem.',
                    },
                    {
                        question: 'Posso usar para tendências do TikTok?',
                        answer: 'Sim! Perfeito para desafios do TikTok: faça celebridades, personagens de anime ou amigos executarem danças populares sem precisar aprender.',
                    },
                    {
                        question: 'Funciona em planos de corpo inteiro?',
                        answer: 'Sim. Para melhores resultados, certifique-se de que o vídeo de referência e a imagem mostrem o corpo inteiro com clareza.',
                    },
                    {
                        question: 'É grátis?',
                        answer: 'Sim, você pode criar vídeos de transferência de movimento gratuitamente usando seus créditos diários.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Como fazer uma foto dançar com IA?',
                    answer: 'Use o “Move Mode” do 微鲤AI. Envie a foto que você quer animar (Character Image) e um vídeo com os movimentos (Reference Video). Clique em Create para transferir o movimento.',
                },
                {
                    question: 'Qual a diferença entre Move Mode e Replace Mode?',
                    answer: 'Move Mode anima uma imagem estática usando o movimento de um vídeo. Replace Mode substitui a pessoa dentro de um vídeo existente por um novo personagem a partir de uma imagem.',
                },
            ],
            app_name: '微鲤AI Motion Transfer',
            app_desc: 'Gerador de dança com IA e transferência de movimento grátis. Faça fotos dançarem, anime imagens estáticas e troque personagens no vídeo online.',
            featureList: 'Geração de dança com IA, transferência de pose corporal, troca de personagem no vídeo, animar foto',
            step_name: 'Como fazer uma foto dançar com IA',
            step_list: [
                {
                    name: 'Envie o vídeo de referência',
                    text: 'Envie um vídeo que contenha os passos de dança ou o movimento que você quer copiar.',
                },
                {
                    name: 'Envie a imagem do personagem',
                    text: 'Envie a foto estática da pessoa ou personagem que você quer animar.',
                },
                {
                    name: 'Selecione o Move Mode',
                    text: 'Escolha “Move Mode” e clique em Create. A IA fará a foto executar os movimentos do vídeo.',
                },
            ],
        },
    },
    it: {
        textToMusic: {
            title: 'Generatore di Musica IA - Crea Musica Unica con 微鲤AI | 微鲤AI',
            description: 'Scopri il Generatore di Musica IA di 微鲤AI. Crea rapidamente musica unica e royalty-free adattata ai tuoi progetti con tecnologia IA avanzata. Perfetto per creatori di contenuti, sviluppatori di giochi e appassionati di musica.',
            keywords: 'testo in musica, testo in musica gratuito, IA testo in musica, generatore di musica IA, creatore di canzoni IA, creare musica simile, creazione musicale, musica royalty-free, download musica gratuito, 微鲤AI',
        },
        textToVideo: {
            title: 'Generatore IA da Testo a Video Gratis (Veo 3.1, Kling e Sora) | 微鲤AI',
            description: 'Trasforma i tuoi prompt in video cinematografici all’istante con l’IA Text‑to‑Video di 微鲤AI. Basato su Google Veo 3.1, Kling e Sora. Supporta 16:9 e 9:16, fino a 8s di durata. Opzioni senza watermark disponibili.',
            keywords: 'testo a video IA, generatore video IA, google veo 3.1, prompt a video, kling ai, sora, txt2vid, 微鲤AI',
            og_title: 'Generatore IA da Testo a Video Gratis (Veo 3.1, Kling e Sora) | 微鲤AI',
            og_description: 'Trasforma i tuoi prompt in video cinematografici all’istante con l’IA Text‑to‑Video di 微鲤AI. Basato su Google Veo 3.1, Kling e Sora. Supporta 16:9 e 9:16, fino a 8s di durata. Opzioni senza watermark disponibili.',
            twitter_title: 'Generatore IA da Testo a Video Gratis (Veo 3.1, Kling e Sora) | 微鲤AI',
            twitter_description: 'Trasforma i tuoi prompt in video cinematografici all’istante con l’IA Text‑to‑Video di 微鲤AI. Basato su Google Veo 3.1, Kling e Sora. Supporta 16:9 e 9:16, fino a 8s di durata. Opzioni senza watermark disponibili.',
            page: {
                title1: 'Generatore IA da Testo a Video Gratis',
                title2: 'Scrivi un prompt e guarda 微鲤AI dare vita alla tua idea. Il nostro Text‑to‑Video aggrega modelli all’avanguardia come Google Veo 3.1 e Kling AI, permettendoti di creare video di alta qualità e fisicamente coerenti per social (9:16) o progetti cinematografici (16:9) in pochi secondi.',
                intro_title: 'Trasforma l’immaginazione in realtà con Text‑to‑Video',
                feature_title: 'Funzioni di 微鲤AI Text‑to‑Video',
                faq_title: 'Domande frequenti su Text‑to‑Video',
                feature_title1: 'Potenza multi‑modello',
                feature_desc1: 'Passa da Veo 3.1 per il realismo a Kling per la coerenza del movimento. Niente abbonamenti multipli.',
                feature_title2: 'Rapporti personalizzati',
                feature_desc2: 'Genera video verticali (9:16) per TikTok/Reels o 16:9 per YouTube direttamente.',
                feature_title3: 'Durata estesa',
                feature_desc3: 'Crea video fino a 8s (o più con estensioni) in una sola generazione, perfetto per storytelling.',
                faq: [
                    {
                        question: 'Come scrivo un buon prompt per il text‑to‑video?',
                        answer: 'Sii specifico: soggetto, azione, luce e angolo camera. Esempio: "Ripresa drone cinematografica di una città cyberpunk futuristica di notte, luci al neon, 4K".',
                    },
                    {
                        question: 'Quale modello usare: Google Veo 3.1 o Kling?',
                        answer: 'Google Veo 3.1 offre grande fedeltà visiva e aderenza al prompt, ideale per scene realistiche. Kling spesso rende meglio con movimenti complessi dei personaggi. Consigliamo di provarli entrambi.',
                    },
                    {
                        question: '微鲤AI Text‑to‑Video è gratis?',
                        answer: 'Sì. Ogni utente riceve crediti gratuiti giornalieri per generare video dal testo.',
                    },
                    {
                        question: 'Posso generare video più lunghi di 8 secondi?',
                        answer: 'La generazione base crea clip fino a 8s (a seconda del modello). Per video più lunghi, usa il nostro AI Video Extender per continuare la scena senza stacchi.',
                    },
                    {
                        question: 'I video generati hanno audio?',
                        answer: 'Sì. Puoi attivare l’opzione “Generate Audio” per creare automaticamente effetti sonori e ambience.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Come scrivo un buon prompt per il text‑to‑video?',
                    answer: 'Descrivi soggetto, azione, luce e camera. Esempio: "città cyberpunk di notte, neon, drone, 4K".',
                },
                {
                    question: 'Quale modello usare: Google Veo 3.1 o Kling?',
                    answer: 'Veo 3.1 è forte in realismo/aderenza; Kling in movimento. Prova entrambi.',
                },
                {
                    question: '微鲤AI Text‑to‑Video è gratis?',
                    answer: 'Sì. Sono disponibili crediti gratuiti giornalieri.',
                },
                {
                    question: 'Posso generare video più lunghi di 8 secondi?',
                    answer: 'Base fino a 8s; per più durata usa AI Video Extender.',
                },
                {
                    question: 'I video generati hanno audio?',
                    answer: 'Sì. Attiva “Generate Audio” per generare l’audio automaticamente.',
                },
            ],
        },
        imageToVideo: {
            title: 'Generatore IA da Immagine a Video (Gratis & Online) - Con Kling, Veo e Sora',
            description: 'Trasforma foto statiche in video realistici in pochi secondi con l’Image-to-Video IA gratuito di 微鲤AI. Accedi a modelli top come Kling, Google Veo e Sora 2 in un unico posto. Disponibili opzioni senza watermark.',
            keywords: 'immagine in video IA, generatore video IA, animazione immagine, video Sora, video Veo, video Seedance, strumenti video 微鲤AI',
            og_title: 'Generatore IA da Immagine a Video (Gratis & Online) - Con Kling, Veo e Sora',
            og_description: 'Trasforma foto statiche in video realistici in pochi secondi con l’Image-to-Video IA gratuito di 微鲤AI. Accedi a modelli top come Kling, Google Veo e Sora 2 in un unico posto. Disponibili opzioni senza watermark.',
            twitter_title: 'Generatore IA da Immagine a Video (Gratis & Online) - Con Kling, Veo e Sora',
            twitter_description: 'Trasforma foto statiche in video realistici in pochi secondi con l’Image-to-Video IA gratuito di 微鲤AI. Accedi a modelli top come Kling, Google Veo e Sora 2 in un unico posto. Disponibili opzioni senza watermark.',
            page: {
                title1: 'Generatore IA da Immagine a Video gratis online',
                faq: [
                    {
                        question: 'Come funziona il generatore IA da Immagine a Video?',
                        answer: 'Utilizza modelli avanzati di deep learning come Kling e Sora per analizzare la tua immagine statica e prevedere il movimento, generando un clip video coerente in formato MP4.',
                    },
                    {
                        question: '微鲤AI Immagine a Video è gratuito?',
                        answer: 'Sì. Offriamo crediti gratuiti giornalieri per provare la nostra IA da immagine a video. Puoi fare upgrade per modelli premium e velocità di generazione più elevate.',
                    },
                    {
                        question: 'Qual è il modello migliore per video realistici: Kling o Veo?',
                        answer: 'Kling AI è rinomato per movimenti realistici e durate più lunghe, mentre Google Veo eccelle nei dettagli in alta definizione. 微鲤AI ti permette di passare da uno all’altro per trovare la scelta migliore.',
                    },
                    {
                        question: 'Posso usare i video generati a scopo commerciale?',
                        answer: 'Sì. I video generati con i nostri piani a pagamento includono una licenza commerciale, perfetta per YouTube, TikTok e annunci marketing.',
                    },
                    {
                        question: 'Come rimuovere i watermark dai video IA?',
                        answer: '微鲤AI fornisce output di alta qualità. Per video senza watermark, verifica i dettagli del tuo piano o usa il nostro strumento dedicato di rimozione watermark con IA.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Come funziona il generatore IA da Immagine a Video?',
                    answer: 'Analizza l’immagine con modelli come Kling e Sora, prevede il movimento e genera un clip MP4 coerente.',
                },
                {
                    question: '微鲤AI Immagine a Video è gratuito?',
                    answer: 'Sì. Sono disponibili crediti gratuiti giornalieri; puoi fare upgrade per modelli premium e maggiore velocità.',
                },
                {
                    question: 'Posso usare i video generati a scopo commerciale?',
                    answer: 'Sì. Con un piano a pagamento hai una licenza commerciale, ideale per YouTube, TikTok e pubblicità.',
                },
            ],
        },
        videoToVideo: {
            title: 'Generatore Gratis AI Video→Video - Restyle & Filtro Anime | 微鲤AI',
            description: 'Trasforma i tuoi video in qualsiasi stile con l’AI Video→Video di 微鲤AI. Converti riprese reali in anime, cartoon 3D o arte cyberpunk usando prompt di testo, mantenendo coerente il movimento originale. Gratis e online.',
            keywords: 'video in video AI, vid2vid, trasferimento stile video AI, trasformare video in anime, restyle video AI, filtro video AI gratis',
            og_title: 'Generatore Gratis AI Video→Video - Restyle & Filtro Anime | 微鲤AI',
            og_description: 'Trasforma i tuoi video in qualsiasi stile con l’AI Video→Video di 微鲤AI. Converti riprese reali in anime, cartoon 3D o arte cyberpunk usando prompt di testo, mantenendo coerente il movimento originale. Gratis e online.',
            twitter_title: 'Generatore Gratis AI Video→Video - Restyle & Filtro Anime | 微鲤AI',
            twitter_description: 'Trasforma i tuoi video in qualsiasi stile con l’AI Video→Video di 微鲤AI. Converti riprese reali in anime, cartoon 3D o arte cyberpunk usando prompt di testo, mantenendo coerente il movimento originale. Gratis e online.',
            page: {
                title1: 'Generatore Gratis AI Video→Video (Vid2Vid)',
                title2: 'Carica un video, scrivi uno stile e guarda la magia. La tecnologia Video→Video di 微鲤AI analizza il movimento del video sorgente e applica un nuovo stile artistico basato sul tuo prompt. Perfetto per edit anime, effetti claymation o arte visiva surreale.',
                feature_title1: 'Movimento Coerente',
                feature_desc1: 'A differenza della generazione standard, il nostro motore Vid2Vid si aggancia al movimento del video sorgente, garantendo transizioni fluide senza sfarfallii.',
                feature_title2: 'Da Reale ad Anime',
                feature_desc2: 'Lo strumento #1 per creator: trasformati in un personaggio anime o in un avatar 3D stile Pixar in un attimo.',
                feature_title3: 'Controllo con Prompt',
                feature_desc3: 'Hai il pieno controllo creativo. Scrivi “stile città cyberpunk” o “stile pittura a olio” per definire esattamente l’aspetto dell’output.',
                faq: [
                    {
                        question: 'Che cos’è l’AI Video→Video (Vid2Vid)?',
                        answer: 'Video→Video è un processo di AI generativa che usa un clip esistente come input e lo “ridipinge” in un nuovo stile descritto dal tuo prompt, preservando movimento e struttura originali.',
                    },
                    {
                        question: 'Posso trasformare il mio video in stile anime?',
                        answer: 'Sì! È il caso d’uso più popolare. Carica il video e inserisci prompt come “anime giapponese, stile Studio Ghibli” per trasformarlo.',
                    },
                    {
                        question: 'Quanto può essere lungo il video sorgente?',
                        answer: 'Al momento supportiamo/consigliamo clip brevi (ad es. 5–10 secondi) per garantire la massima qualità. Per video lunghi, consigliamo di dividerli in segmenti.',
                    },
                    {
                        question: 'È diverso da un editor video?',
                        answer: 'Sì. Un editor tradizionale taglia e rifila clip. Video→Video di 微鲤AI genera nuovi pixel, cambiando completamente texture e stile artistico del filmato.',
                    },
                    {
                        question: 'Costa denaro?',
                        answer: '微鲤AI offre crediti gratuiti giornalieri per provare Video→Video. Sono disponibili piani premium per elaborazione più rapida e download senza watermark.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Che cos’è l’AI Video→Video (Vid2Vid)?',
                    answer: '“Ridipinge” un video esistente in un nuovo stile via prompt, preservando movimento e struttura.',
                },
                {
                    question: 'Posso trasformare il mio video in stile anime?',
                    answer: 'Sì. Prova prompt come “anime giapponese, stile Studio Ghibli”.',
                },
                {
                    question: 'Quanto può essere lungo il video sorgente?',
                    answer: 'Consigliamo clip brevi (5–10 s) per massima qualità; per lunghi, dividi in segmenti.',
                },
                {
                    question: 'È diverso da un editor video?',
                    answer: 'Un editor taglia; Vid2Vid genera nuovi pixel e cambia texture/stile.',
                },
                {
                    question: 'Costa denaro?',
                    answer: 'Crediti gratuiti giornalieri disponibili; premium = più veloce e senza watermark.',
                },
            ],
        },
        removeWatermark: {
            title: 'Rimuovi Filigrana Video con IA Gratis - Elimina Loghi, Testo e Sottotitoli | 微鲤AI',
            description: 'Rimuovi facilmente filigrane, loghi, sottotitoli e timbri data dai video con il Rimuovi Filigrana IA gratuito di 微鲤AI. Supporta MP4/MOV e link video. Niente blur: ripristino pulito con IA.',
            keywords: 'rimuovere filigrana da video, gomma video IA, rimuovere logo da video, eliminare sottotitoli, rimuovere filigrana TikTok, rimuovi filigrana online gratis',
            og_title: 'Rimuovi Filigrana Video con IA Gratis - Elimina Loghi, Testo e Sottotitoli | 微鲤AI',
            og_description: 'Rimuovi facilmente filigrane, loghi, sottotitoli e timbri data dai video con il Rimuovi Filigrana IA gratuito di 微鲤AI. Supporta MP4/MOV e link video. Niente blur: ripristino pulito con IA.',
            twitter_title: 'Rimuovi Filigrana Video con IA Gratis - Elimina Loghi, Testo e Sottotitoli | 微鲤AI',
            twitter_description: 'Rimuovi facilmente filigrane, loghi, sottotitoli e timbri data dai video con il Rimuovi Filigrana IA gratuito di 微鲤AI. Supporta MP4/MOV e link video. Niente blur: ripristino pulito con IA.',
            page: {
                title1: 'Rimuovi Filigrana Video con IA Gratis Online',
                title2: 'Cancella istantaneamente filigrane, loghi, testo sovrapposto e sottotitoli dai tuoi video. Incolla un link o carica un file, seleziona l’area e lascia che la nostra IA ripristini lo sfondo pixel‑per‑pixel senza sfocature.',
                click_erase: '1.Cancellazione con un clic: l’IA rileva e rimuove automaticamente le filigrane più comuni.',
                percision_erase: '2.Cancellazione di precisione: usa il pennello per rimuovere manualmente oggetti complessi come sottotitoli in movimento o timestamp.',
                video_link_title: 'Supporto via link',
                direct_link_desc: '1.Rimozione da link diretto: incolla link dai social per rimuovere filigrane senza scaricare il file.',
                lossless_qua_title: '2.Qualità senza perdita: a differenza della sfocatura, 微鲤AI analizza i pixel intorno e ricostruisce lo sfondo.',
                faq: [
                    {
                        question: 'Come rimuovere una filigrana da un video online gratis?',
                        answer: 'Carica il video su 微鲤AI o incolla un link. Copri la filigrana con il riquadro di selezione e clicca “Generate”. È gratis da provare.',
                    },
                    {
                        question: 'Posso rimuovere sottotitoli o testo in movimento?',
                        answer: 'Sì. Usa la modalità “Precision Erase” per selezionare l’area del testo. L’IA segue l’oggetto tra i frame per una rimozione pulita su tutto il video.',
                    },
                    {
                        question: 'Funziona per video TikTok o YouTube?',
                        answer: 'Certo. Puoi rimuovere loghi di piattaforma (come la filigrana “saltellante” di TikTok) o watermark di canale per ottenere un video pulito per uso personale.',
                    },
                    {
                        question: 'L’area rimossa risulterà sfocata?',
                        answer: 'No. 微鲤AI usa “Video In‑painting” avanzato per riempire l’area con texture realistiche generate dal video circostante, evitando l’effetto blur.',
                    },
                    {
                        question: 'Quali formati video supportate?',
                        answer: 'Supportiamo i principali formati, inclusi MP4, MOV, AVI e WebM.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Come rimuovere una filigrana da un video online gratis?',
                    answer: 'Carica il video o incolla un link, seleziona la filigrana e clicca “Generate”.',
                },
                {
                    question: 'Posso rimuovere sottotitoli o testo in movimento?',
                    answer: 'Sì. Con “Precision Erase”, l’IA traccia tra i frame e pulisce tutto il video.',
                },
                {
                    question: 'L’area rimossa risulterà sfocata?',
                    answer: 'No. Il Video In‑painting ripristina con texture realistiche, senza blur.',
                },
            ],
        },
        videoFaceSwap: {
            title: 'Face Swap Video con IA Gratis Online - Deepfake Realistico | 微鲤AI',
            description: 'Scambia volti nei video all’istante con l’AI Face Swapper di 微鲤AI. Crea clip divertenti, meme e deepfake realistici gratis. Disponibili opzioni senza watermark. 100% privato e sicuro.',
            keywords: 'face swap video, scambio volto IA, deepfake gratis, sostituire volto nel video, face swap film, reface online, meme maker IA',
            og_title: 'Face Swap Video con IA Gratis Online - Deepfake Realistico | 微鲤AI',
            og_description: 'Scambia volti nei video all’istante con l’AI Face Swapper di 微鲤AI. Crea clip divertenti, meme e deepfake realistici gratis. Disponibili opzioni senza watermark. 100% privato e sicuro.',
            twitter_title: 'Face Swap Video con IA Gratis Online - Deepfake Realistico | 微鲤AI',
            twitter_description: 'Scambia volti nei video all’istante con l’AI Face Swapper di 微鲤AI. Crea clip divertenti, meme e deepfake realistici gratis. Disponibili opzioni senza watermark. 100% privato e sicuro.',
            page: {
                title1: 'Face Swap Video con IA Gratis',
                title2: 'Diventa la star di qualsiasi film! Carica un clip video e una foto del volto target: la nostra IA scambia i volti in modo naturale. Perfetto per meme esilaranti, auguri personalizzati o VFX professionali ad alta fedeltà.',
                feature_title1: 'Deepfake Iper‑realistico',
                feature_desc1: 'L’IA analizza geometria del volto e illuminazione per fondere il nuovo volto in modo naturale, preservando espressioni e movimenti della testa.',
                feature_title2: 'Privacy Prima di Tutto',
                feature_desc2: 'La tua privacy è una priorità. Video e immagini caricati vengono elaborati in modo sicuro e cancellati poco dopo la generazione.',
                feature_title3: 'Nessuna Competenza Tecnica',
                feature_desc3: 'Non serve software complesso come After Effects. Clicca “Create” e ottieni risultati livello Hollywood in pochi secondi.',
                faq: [
                    {
                        question: 'Il Face Swap Video di 微鲤AI è gratuito?',
                        answer: 'Sì. Offriamo crediti gratuiti per provare lo scambio volto nei video online. Non serve carta di credito per iniziare.',
                    },
                    {
                        question: 'È sicuro caricare le mie foto?',
                        answer: 'Assolutamente. Usiamo protocolli rigorosi di protezione dati. I tuoi video e le foto del volto target sono usati solo per la generazione e non vengono conservati in modo permanente.',
                    },
                    {
                        question: 'Posso scambiare volti nei GIF?',
                        answer: 'Sì! 微鲤AI supporta video (MP4/MOV) e GIF. Puoi creare facilmente GIF di reazione personalizzate.',
                    },
                    {
                        question: 'Come ottenere i migliori risultati?',
                        answer: 'Per la massima qualità, usa una foto del volto target nitida, frontale e ben illuminata. Evita foto con volto coperto da capelli o occhiali.',
                    },
                    {
                        question: 'Posso usarlo per progetti commerciali?',
                        answer: 'Sì, ma assicurati di avere i diritti sul video originale e il consenso/diritti sull’immagine della persona.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Il Face Swap Video di 微鲤AI è gratuito?',
                    answer: 'Sì. Ci sono crediti gratuiti e non serve carta.',
                },
                {
                    question: 'È sicuro caricare le mie foto?',
                    answer: 'Sì. I file sono usati solo per la generazione.',
                },
                {
                    question: 'Come ottenere i migliori risultati?',
                    answer: 'Usa una foto nitida, frontale e ben illuminata; evita volti coperti da capelli/occhiali.',
                },
            ],
        },
        videoLipSync: {
            title: 'Generatore gratuito di lip sync video con IA — Sincronizza audio e testo con video | 微鲤AI',
            description: 'Sincronizza perfettamente i movimenti delle labbra con qualsiasi audio o testo grazie allo strumento AI Lip Sync di 微鲤AI. Basato su Kling AI. Ideale per traduzione video, doppiaggio e avatar parlanti. Gratis e online.',
            keywords: 'sincronizzazione labiale video, sincronizzazione labiale, sincronizzazione labiale IA, doppiaggio video, sincronizzazione voce, video parlante, strumento sincronizzazione labiale',
            og_title: 'Generatore gratuito di lip sync video con IA — Sincronizza audio e testo con video | 微鲤AI',
            og_description: 'Sincronizza perfettamente i movimenti delle labbra con qualsiasi audio o testo grazie allo strumento AI Lip Sync di 微鲤AI. Basato su Kling AI. Ideale per traduzione video, doppiaggio e avatar parlanti. Gratis e online.',
            twitter_title: 'Generatore gratuito di lip sync video con IA — Sincronizza audio e testo con video | 微鲤AI',
            twitter_description: 'Sincronizza perfettamente i movimenti delle labbra con qualsiasi audio o testo grazie allo strumento AI Lip Sync di 微鲤AI. Basato su Kling AI. Ideale per traduzione video, doppiaggio e avatar parlanti. Gratis e online.',
            page: {
                title1: 'Strumento gratuito di lip sync e doppiaggio con IA',
                title2: 'Addio ai doppiaggi imbarazzanti. Carica un video e un file audio (o digita un testo) e la nostra IA rigenererà i movimenti delle labbra del parlante per farli combaciare perfettamente con l’audio. Basato su Kling AI, supporta doppiaggio multilingue e regolazioni facciali realistiche.',
                dual_input_modes: 'Modalità di input doppie',
                audio_sync: 'Sincronizzazione audio',
                text_sync: 'Testo‑in‑voce',
                text_sync_tip: 'Digita qualsiasi testo, scegli una voce IA preimpostata e fai parlare il personaggio all’istante.',
                audio_sync_tip: 'Carica il tuo voice‑over o una canzone da sincronizzare.',
                feature_title1: 'Doppiaggio multilingue',
                feature_desc1: 'Espandi la tua portata. Traduce il tuo video in spagnolo, francese o giapponese e sincronizza le labbra per far sembrare il parlante madrelingua.',
                feature_title2: 'Precisione Kling AI',
                feature_desc2: 'A differenza dei tool Wav2Lip di base, usiamo il modello Kling per garantire movimenti di denti, lingua e mandibola anatomicamente corretti.',
                faq: [
                    {
                        question: 'Come sincronizzo le labbra con l’audio in un video?',
                        answer: 'Carica il tuo clip su 微鲤AI. Poi carica un file audio (MP3/WAV) oppure digita un testo per generare voce con IA. Clicca "Create" e la nostra IA regolerà i movimenti della bocca per combaciare con il suono.',
                    },
                    {
                        question: 'Posso usarlo per traduzione/doppiaggio video?',
                        answer: 'Sì! È perfetto per il doppiaggio. Puoi caricare una traccia audio tradotta e l’IA sistemerà il lip sync per rendere naturale la versione doppiata.',
                    },
                    {
                        question: 'Funziona con immagini statiche (talking head)?',
                        answer: 'Sì. Se carichi un ritratto statico come sorgente “video”, lo strumento lo animerà in un video di testa parlante (effetto Live Portrait).',
                    },
                    {
                        question: 'Quali lingue sono supportate?',
                        answer: 'Poiché la tecnologia analizza le onde audio, funziona con qualsiasi lingua (inglese, spagnolo, cinese, hindi, ecc.). Per l’input testo‑in‑voce supportiamo oltre 50 lingue.',
                    },
                    {
                        question: 'Il lip sync è gratuito?',
                        answer: '微鲤AI offre crediti gratuiti giornalieri per testare la funzione Lip Sync. Per video lunghi o uso commerciale sono disponibili piani premium.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Come sincronizzo le labbra con l’audio in un video?',
                    answer: 'Carica il tuo clip su 微鲤AI. Poi carica un file audio (MP3/WAV) oppure digita un testo per generare voce con IA. Clicca "Create" e la nostra IA regolerà i movimenti della bocca per combaciare con il suono.',
                },
                {
                    question: 'Posso usarlo per traduzione/doppiaggio video?',
                    answer: 'Sì! È perfetto per il doppiaggio. Puoi caricare una traccia audio tradotta e l’IA sistemerà il lip sync per rendere naturale la versione doppiata.',
                },
                {
                    question: 'Funziona con immagini statiche (talking head)?',
                    answer: 'Sì. Se carichi un ritratto statico come sorgente “video”, lo strumento lo animerà in un video di testa parlante (effetto Live Portrait).',
                },
            ],
        },
        translateVideoSubtitle: {
            title: 'Traduttore sottotitoli video con IA gratis — Genera e traduci online | 微鲤AI',
            description: 'Genera e traduci automaticamente i sottotitoli con il Traduttore IA di 微鲤AI. Supporta inglese, spagnolo, cinese e 90+ lingue. Scarica subito video con sottotitoli incorporati (hardsubs).',
            keywords: 'traduzione sottotitoli IA, traduttore sottotitoli video, sottotitoli multilingue, traduzione video, convertitore sottotitoli, traduzione video IA',
            og_title: 'Traduttore sottotitoli video con IA gratis — Genera e traduci online | 微鲤AI',
            og_description: 'Genera e traduci automaticamente i sottotitoli con il Traduttore IA di 微鲤AI. Supporta inglese, spagnolo, cinese e 90+ lingue. Scarica subito video con sottotitoli incorporati (hardsubs).',
            twitter_title: 'Traduttore sottotitoli video con IA gratis — Genera e traduci online | 微鲤AI',
            twitter_description: 'Genera e traduci automaticamente i sottotitoli con il Traduttore IA di 微鲤AI. Supporta inglese, spagnolo, cinese e 90+ lingue. Scarica subito video con sottotitoli incorporati (hardsubs).',
            page: {
                title1: 'Traduttore sottotitoli video con IA gratis',
                title2: 'Abbatti le barriere linguistiche in un attimo. Carica il tuo video, scegli la lingua di destinazione e lascia che l’IA riconosca il parlato, trascriva l’audio e inserisca sottotitoli tradotti e accurati direttamente nel file video.',
                feature_title1: 'Supporto per 90+ lingue',
                feature_desc1: 'Traduci i tuoi contenuti dall’inglese allo spagnolo, francese, tedesco, giapponese, cinese e altro. Raggiungi un pubblico globale con un clic.',
                feature_title2: 'Auto‑sync e sottotitoli incorporati',
                feature_desc2: 'Niente più modifiche manuali dei timestamp. La nostra IA sincronizza perfettamente i sottotitoli con l’audio e li “brucia” nel video (hardsubs) per la massima compatibilità.',
                feature_title3: 'Precisione basata sul contesto',
                feature_desc3: 'Grazie a LLM avanzati, 微鲤AI capisce contesto e slang, offrendo traduzioni naturali e accurate, non semplici traduzioni letterali.',
                faq: [
                    {
                        question: 'Come traduco automaticamente i sottotitoli di un video?',
                        answer: 'Carica il tuo video su 微鲤AI, seleziona la “Target Language” (es. inglese→spagnolo) e clicca “Create”. L’IA genererà e tradurrà i sottotitoli automaticamente.',
                    },
                    {
                        question: 'Quali lingue sono supportate?',
                        answer: 'Supportiamo oltre 90 lingue, incluse inglese, spagnolo, francese, tedesco, portoghese, hindi, giapponese e cinese.',
                    },
                    {
                        question: 'Il traduttore di sottotitoli è gratuito?',
                        answer: 'Sì. 微鲤AI offre accesso gratuito al traduttore di sottotitoli video con IA, così puoi elaborare video senza pagare servizi di trascrizione costosi.',
                    },
                    {
                        question: 'Devo scaricare un file SRT?',
                        answer: 'No. 微鲤AI genera video con sottotitoli incorporati (burn‑in/hardsubs), così i sottotitoli vengono visualizzati correttamente su TikTok, Instagram e YouTube.',
                    },
                    {
                        question: 'Quanto è accurata la traduzione?',
                        answer: 'Usiamo modelli di riconoscimento vocale all’avanguardia per garantire alta accuratezza. Con audio pulito, l’accuratezza può superare il 95%.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Come traduco automaticamente i sottotitoli di un video?',
                    answer: 'Carica il tuo video su 微鲤AI, seleziona la Target Language e clicca Create. L’IA genererà e tradurrà i sottotitoli automaticamente.',
                },
                {
                    question: 'Quali lingue sono supportate?',
                    answer: 'Supportiamo oltre 90 lingue, incluse inglese, spagnolo, francese, tedesco, portoghese, hindi, giapponese e cinese.',
                },
                {
                    question: 'Devo scaricare un file SRT?',
                    answer: 'No. 微鲤AI produce video con sottotitoli incorporati (hardsubs), visibili correttamente su tutte le piattaforme social.',
                },
            ],
        },
        videoToAnime: {
            title: 'Convertitore IA Video→Anime Gratis — Da reale a cartoon e Pixar | 微鲤AI',
            description: 'Trasforma i tuoi video in anime giapponese, stile Pixar 3D o cartoon con il Convertitore Video→Anime di 微鲤AI. Stabilità fotogramma per fotogramma per un’animazione fluida. Gratis e online.',
            keywords: 'video ad anime, filtro anime IA, video a cartoon, filtro pixar video, reale in anime, alternativa domoai, generatore video anime',
            og_title: 'Convertitore IA Video→Anime Gratis — Da reale a cartoon e Pixar | 微鲤AI',
            og_description: 'Trasforma i tuoi video in anime giapponese, stile Pixar 3D o cartoon con il Convertitore Video→Anime di 微鲤AI. Stabilità fotogramma per fotogramma per un’animazione fluida. Gratis e online.',
            twitter_title: 'Convertitore IA Video→Anime Gratis — Da reale a cartoon e Pixar | 微鲤AI',
            twitter_description: 'Trasforma i tuoi video in anime giapponese, stile Pixar 3D o cartoon con il Convertitore Video→Anime di 微鲤AI. Stabilità fotogramma per fotogramma per un’animazione fluida. Gratis e online.',
            page: {
                title1: 'Convertitore IA Video→Anime gratuito',
                title2: 'Trasformati in un protagonista anime con un clic. Carica un video reale, scegli uno stile (Pixar 3D, 2D classico o disegnato a mano) e lascia che la nostra IA restilizzi il filmato fotogramma per fotogramma mantenendo il movimento fluido e coerente.',
                feature_desc1: '<div><p>Pixar & 3D: crea clip animate carine in stile Disney, perfette per video di famiglia.</p><p>Anime classico: ottieni un look autentico di animazione giapponese (stile Ghibli/Shinkai).</p><p>Sketch & Ink: trasforma i video in animazioni artistiche a matita.</p></div>',
                feature_title2: 'Stabilità fotogramma per fotogramma',
                feature_desc2: 'Stanco di video IA che sfarfallano? 微鲤AI usa algoritmi avanzati di consistenza temporale per far scorrere l’anime in modo fluido, senza i “tremolii” tipici di altri strumenti.',
                feature_title3: 'Creatore di contenuti virali',
                feature_desc3: 'Pensato per TikTok e Reels. Crea video trend “Real vs Anime” che catturano subito l’attenzione.',
                faq: [
                    {
                        question: 'Come trasformo un video in anime gratis?',
                        answer: 'Carica il tuo clip nello strumento Video→Anime di 微鲤AI. Seleziona un preset (come “2D Style” o “Pixar Style”) e clicca Create. È gratis da provare con crediti giornalieri.',
                    },
                    {
                        question: 'Posso convertire in stile Pixar/Disney?',
                        answer: 'Sì! Offriamo un preset “3D Cartoon” o “Pixar Style” che trasforma persone reali in personaggi 3D carini.',
                    },
                    {
                        question: 'Quanto può essere lungo il video?',
                        answer: 'Attualmente supportiamo clip fino a 30 secondi (come in “Maximum video duration: 30s”). Ideale per Shorts, Reels e TikTok.',
                    },
                    {
                        question: 'Il personaggio anime si muoverà come me?',
                        answer: 'Assolutamente. L’IA analizza movimenti e espressioni per far imitare le tue azioni al personaggio.',
                    },
                    {
                        question: 'Qual è il miglior convertitore video→anime?',
                        answer: '微鲤AI è spesso scelto perché offre stili 2D/3D e si concentra sulla stabilità per ridurre rumore e sfarfallii.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Come trasformo un video in anime gratis?',
                    answer: 'Carica il video su 微鲤AI, scegli un preset (2D Style o Pixar Style) e clicca Create.',
                },
                {
                    question: 'Posso convertire in stile Pixar/Disney?',
                    answer: 'Sì. Offriamo un preset 3D Cartoon/Pixar Style per trasformare persone reali in personaggi 3D.',
                },
                {
                    question: 'Il personaggio anime si muoverà come me?',
                    answer: 'Sì. L’IA analizza movimenti ed espressioni per imitare le tue azioni.',
                },
            ],
            app_name: '微鲤AI Convertitore Video→Anime',
            app_desc: 'Strumento IA gratuito per convertire video reali in anime, cartoon e stile Pixar. Rendering fotogramma per fotogramma per animazione stabile.',
            featureList: 'Reale→Anime, Filtro Pixar, Consistenza fotogrammi, Stili 2D/3D',
        },
        videoUpscaler: {
            title: 'AI Video Upscaler gratis — Migliora fino a 4K online | 微鲤AI',
            description: 'Esegui l’upscaling istantaneo di video a bassa risoluzione a 1080p, 2K e 4K con l’AI Video Upscaler gratuito di 微鲤AI. Corregge la pixelatura, riduce il rumore e migliora la qualità online senza installare software.',
            keywords: 'video upscaler, miglioratore video IA, upscaling video a 4k, rimuovere sfocatura video, riduzione rumore video, migliorare qualità video, upscaler video gratis online',
            og_title: 'AI Video Upscaler gratis — Migliora fino a 4K online | 微鲤AI',
            og_description: 'Esegui l’upscaling istantaneo di video a bassa risoluzione a 1080p, 2K e 4K con l’AI Video Upscaler gratuito di 微鲤AI. Corregge la pixelatura, riduce il rumore e migliora la qualità online senza installare software.',
            twitter_title: 'AI Video Upscaler gratis — Migliora fino a 4K online | 微鲤AI',
            twitter_description: 'Esegui l’upscaling istantaneo di video a bassa risoluzione a 1080p, 2K e 4K con l’AI Video Upscaler gratuito di 微鲤AI. Corregge la pixelatura, riduce il rumore e migliora la qualità online senza installare software.',
            page: {
                title1: 'AI Video Upscaler & Enhancer gratuito',
                title2: 'Non accontentarti di video sfocati o pixelati. Carica i tuoi video a bassa risoluzione (360p, 480p, 720p) e lascia che la nostra IA li porti automaticamente a una splendida risoluzione 4K. Il motore non solo aumenta la dimensione: ripristina dettagli, rimuove rumore e corregge i colori.',
                feature_title1: 'Upscale fino a 4K',
                feature_desc1: 'Dai nuova vita ai video vecchi. Converti SD in HD o 4K con un clic, rendendoli nitidi su schermi moderni.',
                feature_title2: 'Correggi video sfocati e “granulosi”',
                feature_desc2: 'Girato con poca luce? Il nostro algoritmo di denoise rimuove grana digitale e artefatti di compressione per un risultato pulito e professionale.',
                feature_title3: 'Restauro di filmati vecchi',
                feature_desc3: 'Perfetto per archivi di famiglia. Ripristina colori sbiaditi e aumenta i dettagli in vecchi home video o clip vintage.',
                faq: [
                    {
                        question: 'Posso fare upscaling a 4K online gratis?',
                        answer: 'Sì. 微鲤AI consente di selezionare output fino a 4K (come nelle opzioni). Puoi provarlo gratis con crediti giornalieri.',
                    },
                    {
                        question: 'Come correggere un video sfocato?',
                        answer: 'Carica il video sfocato nel nostro AI Video Upscaler. L’IA analizza i pixel persi e ricostruisce i dettagli per ridurre la sfocatura.',
                    },
                    {
                        question: 'Funziona sui video vecchi del telefono?',
                        answer: 'Assolutamente. Funziona al meglio con video di bassa qualità (360p/480p), trasformandoli in 1080p o superiore.',
                    },
                    {
                        question: 'Quanto tempo richiede l’upscaling?',
                        answer: 'L’upscaling è computazionalmente intenso, ma 微鲤AI usa GPU cloud ottimizzate. Un clip breve richiede in genere pochi minuti.',
                    },
                    {
                        question: 'È meglio di Topaz Video AI?',
                        answer: '微鲤AI offre qualità IA comparabile e funziona interamente nel browser, senza hardware costoso né installazioni.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Posso fare upscaling video a 4K online?',
                    answer: 'Sì. 微鲤AI consente output fino a 4K e puoi provarlo gratis con crediti giornalieri.',
                },
                {
                    question: 'Come correggere un video sfocato?',
                    answer: 'Carica il video nell’AI Video Upscaler: l’IA ricostruisce dettagli per ridurre la sfocatura.',
                },
                {
                    question: 'È meglio di Topaz Video AI?',
                    answer: '微鲤AI offre qualità comparabile e gira nel browser senza installazione o hardware costoso.',
                },
            ],
            app_name: '微鲤AI Video Upscaler',
            app_desc: 'AI Video Upscaler gratuito per migliorare la qualità fino a 4K. Corregge video sfocati, riduce rumore e ripristina filmati vecchi online.',
            featureList: 'Upscaling 4K, AI Denoising, Video Sharpening, Color Correction',
        },
        removeVideoSubtitles: {
            title: 'Rimuovi Sottotitoli Video - Rimozione Sottotitoli IA | 微鲤AI',
            description: 'Rimuovi sottotitoli incorporati dai video con tecnologia IA. Cancella intelligentemente sottotitoli e testo codificati dai video preservando la qualità video. Veloce e facile da usare.',
            keywords: 'rimuovi sottotitoli video, rimozione sottotitoli, rimuovi sottotitoli, cancella sottotitoli, rimozione sottotitoli video, rimuovi sottotitoli codificati',
            og_title: 'Rimuovi Sottotitoli Video - Rimozione Sottotitoli IA | 微鲤AI',
            og_description: 'Rimuovi sottotitoli incorporati dai video con tecnologia IA. Cancella intelligentemente sottotitoli e testo codificati dai video preservando la qualità video. Veloce e facile da usare.',
            twitter_title: 'Rimuovi Sottotitoli Video - Rimozione Sottotitoli IA | 微鲤AI',
            twitter_description: 'Rimuovi sottotitoli incorporati dai video con tecnologia IA. Cancella intelligentemente sottotitoli e testo codificati dai video preservando la qualità video. Veloce e facile da usare.',
            page: {
                title1: 'Rimozione sottotitoli AI gratis',
                title2: 'Hai sottotitoli “bruciati” nel video? L’algoritmo intelligente di 微鲤AI rileva e cancella automaticamente sottotitoli hardcoded, testi e scritte sullo schermo. Incolla un link o carica un file per ottenere subito un video pulito, senza testo.',
                feature_title1: 'Rilevamento intelligente del testo',
                feature_desc1: 'Niente mascherature manuali. L’IA identifica automaticamente le aree di testo in basso (o ovunque) e le separa dallo sfondo.',
                feature_title2: 'In‑painting naturale',
                feature_desc2: 'Addio riquadri sfocati. 微鲤AI riempie l’area rimossa analizzando i pixel vicini e ricostruendo texture (erba, sabbia, folla) in modo naturale.',
                feature_title3: 'Supporto link e file',
                feature_desc3: 'Rimuovi sottotitoli direttamente da link TikTok/YouTube/Instagram oppure carica MP4/MOV. Perfetto per riutilizzare contenuti.',
                faq: [
                    {
                        question: 'Posso rimuovere sottotitoli hardcoded (bruciati)?',
                        answer: 'Sì. Questo strumento è progettato per i sottotitoli hardcoded che fanno parte dell’immagine e non possono essere disattivati. Li elimina visivamente.',
                    },
                    {
                        question: 'Come rimuovere i captions da un video TikTok/YouTube?',
                        answer: 'Copia il link del video, incollalo nella scheda “Video Link” su 微鲤AI e clicca “Generate”. L’IA rimuove i captions e ti fa scaricare il video pulito.',
                    },
                    {
                        question: 'Rimuove anche lo sfondo dietro al testo?',
                        answer: 'No. 微鲤AI usa AI In‑painting: rimuove il testo e “ridisegna” lo sfondo dietro di esso, così il video sembra originale e completo.',
                    },
                    {
                        question: 'Che differenza c’è rispetto al Watermark Remover?',
                        answer: 'Sono simili, ma il Subtitle Remover è ottimizzato per strisce di testo, lyrics e captions (di solito in basso), mentre il Watermark Remover si concentra su loghi e timbri.',
                    },
                    {
                        question: 'È gratuito?',
                        answer: 'Sì, puoi usare le funzioni base gratis con crediti giornalieri.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Posso rimuovere sottotitoli hardcoded?',
                    answer: 'Sì. Questo strumento è progettato per sottotitoli hardcoded che fanno parte dell’immagine del video. Li elimina visivamente.',
                },
                {
                    question: 'Come rimuovere i captions da un link TikTok?',
                    answer: 'Copia il link, incollalo nella scheda “Video Link” e clicca “Generate”. L’IA li rimuove automaticamente.',
                },
                {
                    question: 'Lo sfondo dietro al testo verrà rovinato?',
                    answer: 'No. 微鲤AI usa AI In‑painting per rimuovere il testo e ricostruire lo sfondo in modo intelligente.',
                },
            ],
            app_name: '微鲤AI Rimozione sottotitoli',
            app_desc: 'Strumento AI gratuito per eliminare sottotitoli hardcoded, captions e testo dai video. Ripristina lo sfondo con in‑painting senza riquadri sfocati.',
            featureList: 'Rimozione sottotitoli hardcoded, Ripristino sfondo con AI, Supporto link video, Gomma testi/lyrics',
        },
        videoBackgroundRemover: {
            title: 'Rimozione Sfondo Video - Rimuovi Sfondo Video con IA | 微鲤AI',
            description: 'Rimuovi sfondi dai video automaticamente con IA. Crea effetti green screen, isola soggetti e sostituisci sfondi video facilmente. Perfetto per creatori di contenuti e editor video.',
            keywords: 'rimozione sfondo video, rimuovi sfondo video, green screen, rimozione sfondo IA, gomma sfondo video, isola soggetto video',
            og_title: 'Rimozione Sfondo Video - Rimuovi Sfondo Video con IA | 微鲤AI',
            og_description: 'Rimuovi sfondi dai video automaticamente con IA. Crea effetti green screen, isola soggetti e sostituisci sfondi video facilmente. Perfetto per creatori di contenuti e editor video.',
            twitter_title: 'Rimozione Sfondo Video - Rimuovi Sfondo Video con IA | 微鲤AI',
            twitter_description: 'Rimuovi sfondi dai video automaticamente con IA. Crea effetti green screen, isola soggetti e sostituisci sfondi video facilmente. Perfetto per creatori di contenuti e editor video.',
            page: {
                title1: 'Rimozione sfondo video AI (gratis)',
                title2: 'Niente green screen? Nessun problema. Carica il tuo video: l’IA rileva automaticamente il soggetto, lo ritaglia con precisione “capelli” e ti permette di scaricare un video con sfondo trasparente o sostituire lo sfondo con un colore pieno all’istante.',
                feature_title1: 'Green screen non necessario',
                feature_desc1: 'Dimentica set costosi. L’IA separa automaticamente persone, animali e oggetti da sfondi complessi (auto‑rotoscoping).',
                feature_title2: 'Sostituzione con colore pieno',
                feature_desc2: 'Perfetto per e‑commerce. Cambia lo sfondo dei video prodotto in bianco puro, nero o colori personalizzati con un clic per aumentare le conversioni.',
                feature_title3: 'Export trasparente',
                feature_desc3: 'Scarica con canale alfa (WebM/MOV) e sovrapponi facilmente il soggetto ad altri video in Premiere Pro, DaVinci Resolve o CapCut.',
                faq: [
                    {
                        question: 'Posso rimuovere lo sfondo senza green screen?',
                        answer: 'Sì! 微鲤AI usa machine learning avanzato per distinguere soggetto e sfondo, così puoi rimuovere lo sfondo da video girati ovunque.',
                    },
                    {
                        question: 'Come salvo un video con sfondo trasparente?',
                        answer: 'Dopo la rimozione, scegli WebM (Transparent) o MOV come formato di output. L’MP4 standard non supporta la trasparenza e mostrerà uno sfondo nero.',
                    },
                    {
                        question: 'Posso cambiare lo sfondo in bianco?',
                        answer: 'Sì. Nelle impostazioni usa il selettore “Background Color” per scegliere bianco, nero o un colore hex. Ideale per video prodotto Amazon/Shopify.',
                    },
                    {
                        question: 'Gestisce bene i capelli?',
                        answer: 'Sì. L’algoritmo è addestrato per gestire contorni complessi come capelli, pelliccia e oggetti semitrasparenti (come gli occhiali).',
                    },
                    {
                        question: 'È gratuito?',
                        answer: 'Sì, puoi elaborare video gratuitamente con crediti giornalieri.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Posso rimuovere lo sfondo senza green screen?',
                    answer: 'Sì! 微鲤AI non richiede un green screen per separare il soggetto dallo sfondo.',
                },
                {
                    question: 'Come salvo un video con sfondo trasparente?',
                    answer: 'Scegli WebM (Transparent) o MOV. L’MP4 standard non supporta la trasparenza.',
                },
                {
                    question: 'Posso cambiare lo sfondo in bianco?',
                    answer: 'Sì. Usa Background Color e seleziona il bianco, ideale per video prodotto.',
                },
            ],
            app_name: '微鲤AI Rimozione sfondo video',
            app_desc: 'Strumento AI gratuito per rimuovere lo sfondo dei video senza green screen. Esporta video trasparenti o cambia lo sfondo in bianco/nero online.',
            featureList: 'Niente green screen, Export video trasparente, Cambio colore sfondo, Precisione capelli',
            step_name: 'Come rimuovere lo sfondo video online',
            step_list: [
                {
                    name: 'Carica video',
                    text: 'Carica il tuo video (MP4, MOV) su 微鲤AI Background Remover.',
                },
                {
                    name: 'Rimuovi sfondo',
                    text: 'L’IA elabora automaticamente. Puoi lasciarlo trasparente o scegliere un nuovo colore di sfondo.',
                },
                {
                    name: 'Esporta',
                    text: 'Scarica il risultato. Scegli WebM/MOV per la trasparenza o MP4 per sfondi pieni.',
                },
            ],
        },
        aiVideoExtender: {
            title: 'Estensione Video IA - Estendi Lunghezza e Durata Video | 微鲤AI',
            description: 'Estendi la lunghezza del video con tecnologia IA. Aggiungi 5-8 secondi ai tuoi video senza interruzioni con molteplici opzioni di stile inclusi anime, animazione 3D, cyberpunk e fumetto. Perfetto per creatori di contenuti e editor video.',
            keywords: 'estensione video IA, estendi lunghezza video, estensione durata video, estensione video IA, allungare video, estendi tempo video, strumento video IA',
            og_title: 'Estensione Video IA - Estendi Lunghezza e Durata Video | 微鲤AI',
            og_description: 'Estendi la lunghezza del video con tecnologia IA. Aggiungi 5-8 secondi ai tuoi video senza interruzioni con molteplici opzioni di stile inclusi anime, animazione 3D, cyberpunk e fumetto. Perfetto per creatori di contenuti e editor video.',
            twitter_title: 'Estensione Video IA - Estendi Lunghezza e Durata Video | 微鲤AI',
            twitter_description: 'Estendi la lunghezza del video con tecnologia IA. Aggiungi 5-8 secondi ai tuoi video senza interruzioni con molteplici opzioni di stile inclusi anime, animazione 3D, cyberpunk e fumetto. Perfetto per creatori di contenuti e editor video.',
            page: {
                title1: 'Estensione video AI gratis & continuazione',
                title2: 'Il tuo video è troppo corto? 微鲤AI usa l’IA generativa per prevedere e creare nuovi fotogrammi, estendendo il clip in modo fluido. Puoi anche usare i prompt per guidare la continuazione o trasformare un video standard in uno slow motion super scorrevole.',
                feature_title1: 'Estensione generativa smart',
                feature_desc1: 'Non limitarti ad “allungare” il video: crea nuovi contenuti. Inserisci un prompt come “la camera zooma indietro” o “il personaggio si gira” e l’IA genererà i prossimi 5–10 secondi coerenti con lo stile originale.',
                feature_title2: 'Slow motion super fluido',
                feature_desc2: 'Trasforma video a 30fps in slow motion di alta qualità. 微鲤AI usa Frame Interpolation per inserire fotogrammi generati dall’IA tra quelli esistenti, creando movimento fluido senza scatti.',
                feature_title3: 'Loop perfetti',
                feature_desc3: 'Crea loop infiniti per sfondi social. L’IA analizza l’inizio e la fine per fonderli perfettamente.',
                faq: [
                    {
                        question: 'Come funziona l’AI video extender?',
                        answer: 'Usa la tecnologia “Generative Outpainting”. L’IA analizza gli ultimi fotogrammi del video e il tuo prompt per prevedere e generare nuovi fotogrammi che continuano logicamente l’azione.',
                    },
                    {
                        question: 'Posso controllare cosa succede nella parte estesa?',
                        answer: 'Sì! Usa la casella “Prompt” per descrivere l’azione. Ad esempio, se nel video c’è un’auto che guida, puoi scrivere “l’auto entra in un tunnel” per guidare l’estensione.',
                    },
                    {
                        question: 'Qual è la differenza tra Estensione e Slow Motion?',
                        answer: 'Estensione aggiunge tempo nuovo generando nuovi eventi (allunga la storia). Slow Motion estende il tempo esistente aggiungendo fotogrammi intermedi (rallenta l’azione). 微鲤AI fa entrambi.',
                    },
                    {
                        question: 'Quanto posso estendere un video?',
                        answer: 'Puoi estendere un clip di 5 secondi alla volta (impostazione “Extension Duration”). Puoi ripetere il processo per creare sequenze più lunghe.',
                    },
                    {
                        question: 'È gratis?',
                        answer: 'Sì, 微鲤AI offre crediti gratuiti per provare estensione video e slow motion.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Come funziona l’AI video extender?',
                    answer: 'Con “Generative Outpainting”, l’IA analizza gli ultimi fotogrammi e il prompt per generare la continuazione.',
                },
                {
                    question: 'Posso controllare la parte estesa?',
                    answer: 'Sì. Descrivi l’azione nella casella “Prompt” (es.: “l’auto entra in un tunnel”).',
                },
                {
                    question: 'Differenza tra Estensione e Slow Motion?',
                    answer: 'Estensione genera nuovi eventi; Slow Motion aggiunge fotogrammi intermedi per rallentare.',
                },
            ],
            app_name: '微鲤AI Video Extender',
            app_desc: 'Strumento AI gratuito per estendere video con generative fill e prompt. Include anche slow motion AI (frame interpolation) e creazione di loop.',
            featureList: 'Estensione video generativa, Continuazione guidata da prompt, Slow motion AI, Loop video',
        },
        videoEffects: {
            title: 'Effetti Video - Crea Video Virali con IA | 微鲤AI',
            description: 'Esplora gli effetti video IA popolari su 微鲤AI. Dal Bacio IA alla Danza IA, crea video virali con pochi clic.',
            keywords: 'effetti video IA, video virali IA, tendenze video, bacio IA, danza IA, generatore video',
        },
        aiDancing: {
            title: 'Generatore di Video di Danza IA - Creatore di Video di Danza IA Gratuito | 微鲤AI',
            description: 'Usa il Generatore di Danza IA di 微鲤AI per creare incredibili video di danza dalle foto. Supporta più modelli e stili di danza, dai vita alle tue foto!',
            keywords: 'video di danza IA, generatore di danza IA, foto a video, generazione video IA, 微鲤AI, strumenti IA gratuiti',
        },
        aiKissing: {
            title: 'aiKissing | 微鲤AI',
            description: 'Experience aiKissing on 微鲤AI platform.',
            keywords: 'aiKissing, AI, 微鲤AI',
        },
        videoMotionImitation: {
            title: 'Imitazione Movimento Video IA - Dai Vita alle Foto Gratuitamente | 微鲤AI',
            description: `Lo strumento di imitazione del movimento video di 微鲤AI può integrare personaggi di foto in video di riferimento, sostituendo i personaggi originali preservando l'illuminazione e i toni della scena per una fusione ambientale perfetta.`,
            keywords: 'imitazione movimento video IA, dare vita alle foto, strumento imitazione movimento video IA, 微鲤AI, strumenti IA gratuiti',
            og_title: 'Imitazione Movimento Video IA - Dai Vita alle Foto Gratuitamente | 微鲤AI',
            og_description: `Lo strumento di imitazione del movimento video di 微鲤AI può integrare personaggi di foto in video di riferimento, sostituendo i personaggi originali preservando l'illuminazione e i toni della scena per una fusione ambientale perfetta.`,
            twitter_title: 'Imitazione Movimento Video IA - Dai Vita alle Foto Gratuitamente | 微鲤AI',
            twitter_description: `Lo strumento di imitazione del movimento video di 微鲤AI può integrare personaggi di foto in video di riferimento, sostituendo i personaggi originali preservando l'illuminazione e i toni della scena per una fusione ambientale perfetta.`,
            page: {
                title1: 'Generatore di Danza IA Gratis & Trasferimento del Movimento',
                title2: 'Vuoi vedere il tuo personaggio anime preferito ballare come Michael Jackson? O far eseguire a una foto statica una mossa virale di TikTok? Carica un video di riferimento e un’immagine del personaggio: la nostra IA trasferirà il movimento con precisione.',
                feature_title1: 'Sostituzione Personaggio nel Video',
                feature_desc1: 'Swap Reale→Anime: carica un video di una persona che balla o combatte e sostituiscila con un personaggio 3D, un panda o un avatar anime, mantenendo sfondo e illuminazione originali.',
                feature_title2: 'Fai Ballare le Foto',
                feature_desc2: 'Anima immagini statiche: dai vita alle foto. Carica una tua foto o di un personaggio, scegli un video di danza di riferimento e guarda la foto imitare i movimenti. Ideale per contenuti virali stile Viggle.',
                feature_title3: 'Rompi le Barriere tra Dimensioni',
                feature_desc3: 'Stili cross‑dimension: che tu trasformi una ballerina in una ragazza anime o un karateka in un panda, 微鲤AI gestisce corpi complessi e occlusioni senza problemi.',
                faq: [
                    {
                        question: 'Come faccio a far ballare una foto con l’IA?',
                        answer: 'Usa il “Move Mode” di 微鲤AI. Carica la foto da animare (Character Image) e un video con i movimenti (Reference Video). Clicca Create per trasferire il movimento.',
                    },
                    {
                        question: 'Qual è la differenza tra Move Mode e Replace Mode?',
                        answer: 'Move Mode anima un’immagine statica usando il movimento di un video. Replace Mode sostituisce la persona dentro un video esistente con un nuovo personaggio a partire da un’immagine.',
                    },
                    {
                        question: 'Posso usarlo per i trend TikTok?',
                        answer: 'Sì! Perfetto per le challenge TikTok: fai ballare celebrità, personaggi anime o amici senza che imparino i movimenti.',
                    },
                    {
                        question: 'Funziona con riprese a figura intera?',
                        answer: 'Sì. Per risultati migliori, assicurati che sia il video di riferimento sia l’immagine mostrino il corpo intero in modo chiaro.',
                    },
                    {
                        question: 'È gratis?',
                        answer: 'Sì, puoi creare video di trasferimento del movimento gratis usando i crediti giornalieri.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Come faccio a far ballare una foto con l’IA?',
                    answer: 'Usa il “Move Mode” di 微鲤AI. Carica la foto da animare (Character Image) e un video con i movimenti (Reference Video). Clicca Create per trasferire il movimento.',
                },
                {
                    question: 'Qual è la differenza tra Move Mode e Replace Mode?',
                    answer: 'Move Mode anima un’immagine statica usando il movimento di un video. Replace Mode sostituisce la persona dentro un video esistente con un nuovo personaggio a partire da un’immagine.',
                },
            ],
            app_name: '微鲤AI Motion Transfer',
            app_desc: 'Generatore di danza IA e trasferimento del movimento gratis. Fai ballare le foto, anima immagini statiche e sostituisci i personaggi nei video online.',
            featureList: 'Generazione danza IA, trasferimento pose, swap personaggio video, anima foto',
            step_name: 'Come far ballare una foto con l’IA',
            step_list: [
                {
                    name: 'Carica il video di riferimento',
                    text: 'Carica un video che contiene i passi di danza o il movimento che vuoi copiare.',
                },
                {
                    name: 'Carica l’immagine del personaggio',
                    text: 'Carica la foto statica della persona o del personaggio che vuoi animare.',
                },
                {
                    name: 'Seleziona Move Mode',
                    text: 'Scegli “Move Mode” e clicca Create. L’IA farà eseguire alla foto i movimenti del video.',
                },
            ],
        },
    },
    ar: {
        textToMusic: {
            title: 'مولد الموسيقى بالذكاء الاصطناعي - أنشئ موسيقى فريدة مع 微鲤AI | 微鲤AI',
            description: 'اكتشف مولد الموسيقى بالذكاء الاصطناعي من 微鲤AI. أنشئ بسرعة موسيقى فريدة وخالية من حقوق الملكية مصممة خصيصًا لمشاريعك بتقنية الذكاء الاصطناعي المتقدمة. مثالي لمنشئي المحتوى ومطوري الألعاب وعشاق الموسيقى.',
            keywords: 'نص إلى موسيقى, نص إلى موسيقى مجاني, ذكاء اصطناعي نص إلى موسيقى, مولد موسيقى بالذكاء الاصطناعي, صانع أغاني بالذكاء الاصطناعي, كلمات إلى موسيقى, إنشاء موسيقى مشابهة, إنشاء موسيقى, موسيقى خالية من حقوق الملكية, تحميل موسيقى مجاني, 微鲤AI',
        },
        textToVideo: {
            title: 'مولّد تحويل النص إلى فيديو بالذكاء الاصطناعي مجانًا (Veo 3.1 وKling وSora) | 微鲤AI',
            description: 'حوّل مطالباتك النصية إلى فيديوهات سينمائية فورًا باستخدام أداة Text‑to‑Video من 微鲤AI. مدعومة بـ Google Veo 3.1 وKling وSora. تدعم 16:9 و9:16، حتى 8 ثوانٍ. تتوفر خيارات بدون علامة مائية.',
            keywords: 'تحويل النص إلى فيديو, مولد فيديو بالذكاء الاصطناعي, Google Veo 3.1, Kling AI, Sora, prompt إلى فيديو, txt2vid, 微鲤AI',
            og_title: 'مولّد تحويل النص إلى فيديو بالذكاء الاصطناعي مجانًا (Veo 3.1 وKling وSora) | 微鲤AI',
            og_description: 'حوّل مطالباتك النصية إلى فيديوهات سينمائية فورًا باستخدام أداة Text‑to‑Video من 微鲤AI. مدعومة بـ Google Veo 3.1 وKling وSora. تدعم 16:9 و9:16، حتى 8 ثوانٍ. تتوفر خيارات بدون علامة مائية.',
            twitter_title: 'مولّد تحويل النص إلى فيديو بالذكاء الاصطناعي مجانًا (Veo 3.1 وKling وSora) | 微鲤AI',
            twitter_description: 'حوّل مطالباتك النصية إلى فيديوهات سينمائية فورًا باستخدام أداة Text‑to‑Video من 微鲤AI. مدعومة بـ Google Veo 3.1 وKling وSora. تدعم 16:9 و9:16، حتى 8 ثوانٍ. تتوفر خيارات بدون علامة مائية.',
            page: {
                title1: 'مولّد تحويل النص إلى فيديو بالذكاء الاصطناعي مجانًا',
                title2: 'اكتب مطالبة نصية وشاهد 微鲤AI يحوّل فكرتك إلى فيديو. تجمع أداة تحويل النص إلى فيديو لدينا نماذج متقدمة مثل Google Veo 3.1 وKling AI، لتمنحك فيديوهات عالية الجودة ومتسقة فيزيائيًا لمقاطع السوشيال العمودية (9:16) أو المشاريع السينمائية (16:9) خلال ثوانٍ.',
                intro_title: 'حوّل الخيال إلى واقع مع تحويل النص إلى فيديو',
                feature_title: 'ميزات تحويل النص إلى فيديو من 微鲤AI',
                faq_title: 'الأسئلة الشائعة حول تحويل النص إلى فيديو',
                feature_title1: 'قوة متعددة النماذج',
                feature_desc1: 'بدّل بين Veo 3.1 للواقعية وKling لاتساق الحركة — بدون الحاجة لاشتراكات متعددة.',
                feature_title2: 'نِسَب عرض مخصصة',
                feature_desc2: 'أنشئ فيديوهات عمودية (9:16) لـ TikTok/Reels أو أفقية (16:9) لـ YouTube مباشرة.',
                feature_title3: 'مدة أطول',
                feature_desc3: 'أنشئ فيديوهات حتى 8 ثوانٍ (أو أطول عبر أدوات التمديد) في توليد واحد — مثالي للسرد القصصي.',
                faq: [
                    {
                        question: 'كيف أكتب مطالبة جيدة لتحويل النص إلى فيديو؟',
                        answer: 'كن محددًا: صف الموضوع والحركة والإضاءة وزاوية الكاميرا. مثال: "لقطة درون سينمائية لمدينة سايبربانك مستقبلية ليلًا، أضواء نيون، 4K".',
                    },
                    {
                        question: 'أي نموذج أختار: Google Veo 3.1 أم Kling؟',
                        answer: 'يتميز Veo 3.1 بجودة بصرية عالية والالتزام بالمطالبة، وهو مناسب للمشاهد الواقعية. غالبًا ما يكون Kling أفضل في حركات الشخصيات المعقدة. ننصح بتجربة الاثنين.',
                    },
                    {
                        question: 'هل تحويل النص إلى فيديو في 微鲤AI مجاني؟',
                        answer: 'نعم. يحصل كل مستخدم على رصيد مجاني يوميًا لتوليد فيديوهات من النص.',
                    },
                    {
                        question: 'هل يمكنني إنشاء فيديو أطول من 8 ثوانٍ؟',
                        answer: 'التوليد الأساسي يصل حتى 8 ثوانٍ (حسب النموذج). لمقاطع أطول، استخدم أداة AI Video Extender لمتابعة الفيديو بسلاسة.',
                    },
                    {
                        question: 'هل تحتوي الفيديوهات المُولَّدة على صوت؟',
                        answer: 'نعم. يمكنك تفعيل خيار "Generate Audio" لإنشاء مؤثرات صوتية وأجواء خلفية تلقائيًا.',
                    },
                ],
            },
            faq: [
                {
                    question: 'كيف أكتب مطالبة جيدة لتحويل النص إلى فيديو؟',
                    answer: 'صف الموضوع والحركة والإضاءة والكاميرا بوضوح. مثال: "مدينة سايبربانك ليلًا، نيون، درون، 4K".',
                },
                {
                    question: 'أي نموذج أختار: Google Veo 3.1 أم Kling؟',
                    answer: 'Veo 3.1 قوي في الواقعية والالتزام، وKling قوي في الحركة. جرّب الاثنين.',
                },
                {
                    question: 'هل تحويل النص إلى فيديو في 微鲤AI مجاني؟',
                    answer: 'نعم. تتوفر أرصدة مجانية يومية.',
                },
                {
                    question: 'هل يمكنني إنشاء فيديو أطول من 8 ثوانٍ؟',
                    answer: 'الأساسي حتى 8 ثوانٍ؛ للمدة الأطول استخدم AI Video Extender.',
                },
                {
                    question: 'هل تحتوي الفيديوهات المُولَّدة على صوت؟',
                    answer: 'نعم. فعّل "Generate Audio" لتوليد الصوت تلقائيًا.',
                },
            ],
        },
        imageToVideo: {
            title: 'مولّد تحويل الصورة إلى فيديو بالذكاء الاصطناعي (مجاني وأونلاين) - مدعوم من Kling وVeo وSora',
            description: 'حوّل الصور الثابتة إلى فيديوهات واقعية خلال ثوانٍ باستخدام أداة Image-to-Video المجانية من 微鲤AI. استخدم نماذج قوية مثل Kling وGoogle Veo وSora 2 في مكان واحد. تتوفر خيارات بدون علامة مائية.',
            keywords: 'تحويل الصورة إلى فيديو بالذكاء الاصطناعي, مولد فيديو بالذكاء الاصطناعي, تحريك الصور, فيديو Sora, فيديو Veo, فيديو Seedance, أدوات فيديو 微鲤AI',
            og_title: 'مولّد تحويل الصورة إلى فيديو بالذكاء الاصطناعي (مجاني وأونلاين) - مدعوم من Kling وVeo وSora',
            og_description: 'حوّل الصور الثابتة إلى فيديوهات واقعية خلال ثوانٍ باستخدام أداة Image-to-Video المجانية من 微鲤AI. استخدم نماذج قوية مثل Kling وGoogle Veo وSora 2 في مكان واحد. تتوفر خيارات بدون علامة مائية.',
            twitter_title: 'مولّد تحويل الصورة إلى فيديو بالذكاء الاصطناعي (مجاني وأونلاين) - مدعوم من Kling وVeo وSora',
            twitter_description: 'حوّل الصور الثابتة إلى فيديوهات واقعية خلال ثوانٍ باستخدام أداة Image-to-Video المجانية من 微鲤AI. استخدم نماذج قوية مثل Kling وGoogle Veo وSora 2 في مكان واحد. تتوفر خيارات بدون علامة مائية.',
            page: {
                title1: 'مولّد تحويل الصورة إلى فيديو بالذكاء الاصطناعي مجانًا عبر الإنترنت',
                faq: [
                    {
                        question: 'كيف يعمل مولّد تحويل الصورة إلى فيديو بالذكاء الاصطناعي؟',
                        answer: 'يستخدم نماذج تعلم عميق متقدمة مثل Kling وSora لتحليل الصورة الثابتة وتوقع الحركة، ثم يولّد مقطع فيديو متماسكًا بصيغة MP4.',
                    },
                    {
                        question: 'هل أداة Image-to-Video في 微鲤AI مجانية؟',
                        answer: 'نعم. نقدم رصيدًا مجانيًا يوميًا لتجربة أداة تحويل الصورة إلى فيديو. يمكنك الترقية للحصول على نماذج مميزة وسرعات توليد أعلى.',
                    },
                    {
                        question: 'أي نموذج أفضل للفيديو الواقعي: Kling أم Veo؟',
                        answer: 'يُعرف Kling AI بحركة واقعية ومدة أطول، بينما يتفوق Google Veo في التفاصيل عالية الدقة. يتيح لك 微鲤AI التبديل بينهما لاختيار الأنسب.',
                    },
                    {
                        question: 'هل يمكنني استخدام الفيديوهات الناتجة تجاريًا؟',
                        answer: 'نعم. الفيديوهات التي تُنشأ ضمن الخطط المدفوعة تأتي مع ترخيص تجاري، وهي مثالية لـ YouTube وTikTok وإعلانات التسويق.',
                    },
                    {
                        question: 'كيف أزيل العلامات المائية من فيديوهات الذكاء الاصطناعي؟',
                        answer: 'يوفر 微鲤AI مخرجات عالية الجودة. للحصول على فيديوهات بدون علامة مائية، تحقّق من مزايا خطتك أو استخدم أداة إزالة العلامة المائية بالذكاء الاصطناعي المخصصة لدينا.',
                    },
                ],
            },
            faq: [
                {
                    question: 'كيف يعمل مولّد تحويل الصورة إلى فيديو بالذكاء الاصطناعي؟',
                    answer: 'يحلّل الصورة بنماذج مثل Kling وSora ويتوقع الحركة ليولّد مقطع MP4 متماسكًا.',
                },
                {
                    question: 'هل أداة Image-to-Video في 微鲤AI مجانية؟',
                    answer: 'نعم. تتوفر أرصدة مجانية يومية للتجربة، ويمكنك الترقية للحصول على نماذج مميزة وسرعة أعلى.',
                },
                {
                    question: 'هل يمكنني استخدام الفيديوهات الناتجة تجاريًا؟',
                    answer: 'نعم. الخطط المدفوعة تتضمن ترخيصًا تجاريًا مناسبًا لـ YouTube وTikTok والإعلانات.',
                },
            ],
        },
        videoToVideo: {
            title: 'مولّد تحويل الفيديو إلى فيديو بالذكاء الاصطناعي مجانًا - إعادة الأسلوب وفلتر الأنمي | 微鲤AI',
            description: 'حوّل فيديوهاتك إلى أي أسلوب باستخدام Video‑to‑Video من 微鲤AI. حوّل لقطات واقعية إلى أنمي أو كرتون ثلاثي الأبعاد أو فن سايبربانك عبر مطالبات نصية، مع الحفاظ على حركة الفيديو الأصلية بشكل متسق. مجاني وأونلاين.',
            keywords: 'تحويل الفيديو إلى فيديو, vid2vid, نقل أسلوب الفيديو بالذكاء الاصطناعي, تحويل الفيديو إلى أنمي, إعادة أسلوب الفيديو, فلتر فيديو بالذكاء الاصطناعي مجاني',
            og_title: 'مولّد تحويل الفيديو إلى فيديو بالذكاء الاصطناعي مجانًا - إعادة الأسلوب وفلتر الأنمي | 微鲤AI',
            og_description: 'حوّل فيديوهاتك إلى أي أسلوب باستخدام Video‑to‑Video من 微鲤AI. حوّل لقطات واقعية إلى أنمي أو كرتون ثلاثي الأبعاد أو فن سايبربانك عبر مطالبات نصية، مع الحفاظ على حركة الفيديو الأصلية بشكل متسق. مجاني وأونلاين.',
            twitter_title: 'مولّد تحويل الفيديو إلى فيديو بالذكاء الاصطناعي مجانًا - إعادة الأسلوب وفلتر الأنمي | 微鲤AI',
            twitter_description: 'حوّل فيديوهاتك إلى أي أسلوب باستخدام Video‑to‑Video من 微鲤AI. حوّل لقطات واقعية إلى أنمي أو كرتون ثلاثي الأبعاد أو فن سايبربانك عبر مطالبات نصية، مع الحفاظ على حركة الفيديو الأصلية بشكل متسق. مجاني وأونلاين.',
            page: {
                title1: 'مولّد تحويل الفيديو إلى فيديو بالذكاء الاصطناعي مجانًا (Vid2Vid)',
                title2: 'ارفع فيديو، اكتب الأسلوب، وشاهد السحر يحدث. تحلل تقنية Video‑to‑Video من 微鲤AI حركة فيديو المصدر وتطبّق أسلوبًا فنيًا جديدًا بالكامل بناءً على مطالبتك النصية. مثالي لعمل تعديلات أنمي، تأثيرات claymation، أو فن بصري سريالي.',
                feature_title1: 'حركة متسقة',
                feature_desc1: 'على عكس التوليد القياسي، يثبت محرك Vid2Vid لدينا حركة الفيديو المصدر ليضمن انتقالات سلسة بدون وميض.',
                feature_title2: 'من الواقعي إلى الأنمي',
                feature_desc2: 'الأداة رقم 1 لصنّاع المحتوى: حوّل نفسك إلى شخصية أنمي أو أفاتار ثلاثي الأبعاد بأسلوب Pixar فورًا.',
                feature_title3: 'تحكم بالمطالبة',
                feature_desc3: 'لديك تحكم إبداعي كامل. اكتب "أسلوب مدينة سايبربانك" أو "أسلوب لوحة زيتية" لتحديد شكل الإخراج بدقة.',
                faq: [
                    {
                        question: 'ما هو تحويل الفيديو إلى فيديو بالذكاء الاصطناعي (Vid2Vid)؟',
                        answer: 'هو عملية ذكاء اصطناعي توليدية تأخذ مقطع فيديو موجودًا كمدخل وتُعيد "تلوينه" بأسلوب جديد تصفه مطالبتك النصية، مع الحفاظ على الحركة والبنية الأصلية.',
                    },
                    {
                        question: 'هل يمكنني تحويل الفيديو إلى أسلوب أنمي؟',
                        answer: 'نعم! هذا أشهر استخدام. ارفع الفيديو واكتب مطالبات مثل "أنمي ياباني، أسلوب Studio Ghibli" لتحويله.',
                    },
                    {
                        question: 'ما أقصى مدة لفيديو المصدر؟',
                        answer: 'حاليًا ندعم مقاطع قصيرة (مثل 5–10 ثوانٍ) لضمان أعلى جودة. للفيديوهات الأطول، نوصي بتقسيمها إلى مقاطع.',
                    },
                    {
                        question: 'هل يختلف عن محرر الفيديو؟',
                        answer: 'نعم. محرر الفيديو التقليدي يقتص ويقص المقاطع. أما Video‑to‑Video من 微鲤AI فيولّد بكسلات جديدة ويغيّر نسيج وأسلوب الفيديو بالكامل.',
                    },
                    {
                        question: 'هل يكلف المال؟',
                        answer: 'تقدم 微鲤AI أرصدة مجانية يومية لتجربة Video‑to‑Video. تتوفر خطط مدفوعة لمعالجة أسرع وتنزيلات بدون علامة مائية.',
                    },
                ],
            },
            faq: [
                {
                    question: 'ما هو تحويل الفيديو إلى فيديو بالذكاء الاصناعي (Vid2Vid)؟',
                    answer: 'يعيد "تلوين" فيديو موجود بأسلوب جديد عبر مطالبة نصية مع الحفاظ على الحركة والبنية.',
                },
                {
                    question: 'هل يمكنني تحويل الفيديو إلى أسلوب أنمي؟',
                    answer: 'نعم. جرّب مطالبات مثل "أنمي ياباني، Studio Ghibli".',
                },
                {
                    question: 'ما أقصى مدة لفيديو المصدر؟',
                    answer: 'نوصي بمقاطع قصيرة (5–10 ثوانٍ) لأفضل جودة؛ للفيديوهات الأطول قسّمها لمقاطع.',
                },
                {
                    question: 'هل يختلف عن محرر الفيديو؟',
                    answer: 'المحرر يقتص؛ Vid2Vid يولّد بكسلات جديدة ويغيّر النسيج/الأسلوب.',
                },
                {
                    question: 'هل يكلف المال؟',
                    answer: 'توجد أرصدة مجانية يومية؛ والخطط المدفوعة أسرع وبدون علامة مائية.',
                },
            ],
        },
        removeWatermark: {
            title: 'مزيل العلامة المائية من الفيديو بالذكاء الاصطناعي مجانًا أونلاين - احذف الشعارات والنصوص والترجمات | 微鲤AI',
            description: 'أزل العلامات المائية والشعارات والترجمات وأختام التاريخ بسهولة باستخدام مزيل العلامة المائية المجاني من 微鲤AI. يدعم MP4/MOV وروابط الفيديو. بدون ضبابية — ترميم نظيف بالذكاء الاصطناعي.',
            keywords: 'إزالة علامة مائية من فيديو, ممحاة فيديو بالذكاء الاصطناعي, إزالة شعار من فيديو, حذف الترجمات, إزالة علامة مائية TikTok, مزيل علامة مائية مجاني أونلاين',
            og_title: 'مزيل العلامة المائية من الفيديو بالذكاء الاصطناعي مجانًا أونلاين - احذف الشعارات والنصوص والترجمات | 微鲤AI',
            og_description: 'أزل العلامات المائية والشعارات والترجمات وأختام التاريخ بسهولة باستخدام مزيل العلامة المائية المجاني من 微鲤AI. يدعم MP4/MOV وروابط الفيديو. بدون ضبابية — ترميم نظيف بالذكاء الاصطناعي.',
            twitter_title: 'مزيل العلامة المائية من الفيديو بالذكاء الاصطناعي مجانًا أونلاين - احذف الشعارات والنصوص والترجمات | 微鲤AI',
            twitter_description: 'أزل العلامات المائية والشعارات والترجمات وأختام التاريخ بسهولة باستخدام مزيل العلامة المائية المجاني من 微鲤AI. يدعم MP4/MOV وروابط الفيديو. بدون ضبابية — ترميم نظيف بالذكاء الاصطناعي.',
            page: {
                title1: 'مزيل العلامة المائية من الفيديو بالذكاء الاصطناعي (مجاني أونلاين)',
                title2: 'امسح العلامات المائية والشعارات والنصوص فوق الفيديو والترجمات فورًا. ألصق رابط فيديو أو ارفع ملفًا، حدّد المنطقة، ودع الذكاء الاصطناعي يعيد ترميم الخلفية بدقة بدون أي ضبابية.',
                click_erase: '1.مسح بنقرة واحدة: يتعرّف الذكاء الاصطناعي تلقائيًا على العلامات المائية الشائعة ويزيلها.',
                percision_erase: '2.مسح دقيق: استخدم أداة الفرشاة لإزالة عناصر معقدة مثل الترجمات المتحركة أو الطوابع الزمنية.',
                video_link_title: 'عبر رابط',
                direct_link_desc: '1.إزالة عبر رابط مباشر: ألصق روابط منصات التواصل لإزالة العلامة المائية بدون تنزيل الفيديو أولاً.',
                lossless_qua_title: '2.جودة بدون فقدان: بخلاف أدوات التمويه، يحلل 微鲤AI البكسلات المحيطة لإعادة بناء الخلفية.',
                faq: [
                    {
                        question: 'كيف أزيل علامة مائية من فيديو أونلاين مجانًا؟',
                        answer: 'ارفع الفيديو إلى 微鲤AI أو ألصق رابط فيديو. غطّ العلامة المائية بمربع التحديد واضغط “Generate”. مجاني للتجربة.',
                    },
                    {
                        question: 'هل يمكنني إزالة ترجمات أو نص متحرك؟',
                        answer: 'نعم. استخدم وضع “Precision Erase” وحدّد منطقة النص. يتتبع الذكاء الاصطناعي العنصر عبر الإطارات لضمان إزالة نظيفة طوال الفيديو.',
                    },
                    {
                        question: 'هل يعمل مع فيديوهات TikTok أو YouTube؟',
                        answer: 'بالتأكيد. يمكنك إزالة شعارات المنصات (مثل علامة TikTok المتحركة) أو علامات القناة للحصول على فيديو نظيف للاستخدام الشخصي.',
                    },
                    {
                        question: 'هل ستبدو المنطقة المزالة ضبابية؟',
                        answer: 'لا. يستخدم 微鲤AI تقنية “Video In‑painting” لملء المنطقة المحذوفة بقوام واقعي مشتق من الفيديو المحيط، لتجنب التمويه القبيح.',
                    },
                    {
                        question: 'ما صيغ الفيديو التي تدعمونها؟',
                        answer: 'ندعم الصيغ الرئيسية بما في ذلك MP4 وMOV وAVI وWebM.',
                    },
                ],
            },
            faq: [
                {
                    question: 'كيف أزيل علامة مائية من فيديو أونلاين مجانًا؟',
                    answer: 'ارفع الفيديو أو ألصق رابطًا، حدّد العلامة واضغط “Generate”.',
                },
                {
                    question: 'هل يمكنني إزالة ترجمات أو نص متحرك؟',
                    answer: 'نعم. في “Precision Erase” يتتبع الذكاء الاصطناعي عبر الإطارات ويزيله في الفيديو كله.',
                },
                {
                    question: 'هل ستبدو المنطقة المزالة ضبابية؟',
                    answer: 'لا. Video In‑painting يعيد ترميم الخلفية بقوام واقعي بدون تمويه.',
                },
            ],
        },
        videoFaceSwap: {
            title: 'تبديل الوجوه في الفيديو بالذكاء الاصطناعي مجانًا أونلاين - ديب فيك واقعي | 微鲤AI',
            description: 'بدّل الوجوه في الفيديوهات فورًا باستخدام AI Face Swapper من 微鲤AI. أنشئ مقاطع مضحكة وميمات وديب فيك واقعي مجانًا. تتوفر خيارات بدون علامة مائية. 100% خاص وآمن.',
            keywords: 'تبديل الوجوه في الفيديو, مبدل وجه بالذكاء الاصطناعي, صانع ديب فيك مجاني, استبدال الوجه في الفيديو, تبديل وجه فيلم, reface أونلاين, صانع ميم بالذكاء الاصطناعي',
            og_title: 'تبديل الوجوه في الفيديو بالذكاء الاصطناعي مجانًا أونلاين - ديب فيك واقعي | 微鲤AI',
            og_description: 'بدّل الوجوه في الفيديوهات فورًا باستخدام AI Face Swapper من 微鲤AI. أنشئ مقاطع مضحكة وميمات وديب فيك واقعي مجانًا. تتوفر خيارات بدون علامة مائية. 100% خاص وآمن.',
            twitter_title: 'تبديل الوجوه في الفيديو بالذكاء الاصطناعي مجانًا أونلاين - ديب فيك واقعي | 微鲤AI',
            twitter_description: 'بدّل الوجوه في الفيديوهات فورًا باستخدام AI Face Swapper من 微鲤AI. أنشئ مقاطع مضحكة وميمات وديب فيك واقعي مجانًا. تتوفر خيارات بدون علامة مائية. 100% خاص وآمن.',
            page: {
                title1: 'تبديل الوجوه في الفيديو بالذكاء الاصطناعي مجانًا',
                title2: 'كن نجم أي فيلم! ارفع مقطع فيديو وصورة للوجه المستهدف، وشاهد الذكاء الاصطناعي يبدّل الوجوه بسلاسة. مثالي للميمات، التحيات المخصصة، أو مؤثرات بصرية احترافية بجودة عالية.',
                feature_title1: 'ديب فيك فائق الواقعية',
                feature_desc1: 'يحلل الذكاء الاصطناعي هندسة الوجه والإضاءة لدمج الوجه الجديد بشكل طبيعي مع الحفاظ على تعابير الوجه وحركة الرأس.',
                feature_title2: 'الخصوصية أولاً',
                feature_desc2: 'نحن نعطي الأولوية لخصوصيتك. تتم معالجة الفيديوهات والصور بأمان ويتم حذفها بعد وقت قصير من التوليد.',
                feature_title3: 'بدون خبرة تقنية',
                feature_desc3: 'لا حاجة لبرامج معقدة مثل After Effects. اضغط “Create” واحصل على نتائج بمستوى هوليوود خلال ثوانٍ.',
                faq: [
                    {
                        question: 'هل تبديل الوجوه في الفيديو على 微鲤AI مجاني؟',
                        answer: 'نعم. نوفر أرصدة مجانية لتجربة تبديل الوجوه في الفيديو أونلاين. لا تحتاج بطاقة ائتمان للبدء.',
                    },
                    {
                        question: 'هل من الآمن رفع صوري؟',
                        answer: 'بالتأكيد. نستخدم بروتوكولات صارمة لحماية البيانات. تُستخدم الفيديوهات والصور فقط لعملية التوليد ولا تُخزَّن بشكل دائم.',
                    },
                    {
                        question: 'هل يمكنني تبديل الوجوه في ملفات GIF؟',
                        answer: 'نعم! يدعم 微鲤AI الفيديو (MP4/MOV) وGIF. يمكنك إنشاء GIFs تفاعلية مخصصة بسهولة.',
                    },
                    {
                        question: 'كيف أحصل على أفضل النتائج؟',
                        answer: 'استخدم صورة وجه مستهدف واضحة، أمامية، وبإضاءة جيدة. تجنب الصور التي يكون فيها الوجه مغطى بالشعر أو النظارات.',
                    },
                    {
                        question: 'هل يمكنني استخدامه في مشاريع تجارية؟',
                        answer: 'نعم، لكن تأكد من امتلاك حقوق الفيديو الأصلي وحقوق/موافقة استخدام صورة الشخص.',
                    },
                ],
            },
            faq: [
                {
                    question: 'هل تبديل الوجوه في الفيديو على 微鲤AI مجاني؟',
                    answer: 'نعم. تتوفر أرصدة مجانية ولا تحتاج بطاقة ائتمان.',
                },
                {
                    question: 'هل من الآمن رفع صوري؟',
                    answer: 'نعم. تُستخدم الملفات فقط لعملية التوليد.',
                },
                {
                    question: 'كيف أحصل على أفضل النتائج؟',
                    answer: 'استخدم صورة واضحة أمامية وبإضاءة جيدة، وتجنب الوجه المغطى بالشعر/النظارات.',
                },
            ],
        },
        videoLipSync: {
            title: 'مولّد مزامنة الشفاه في الفيديو بالذكاء الاصطناعي مجانًا — مزامنة الصوت والنص مع الفيديو | 微鲤AI',
            description: 'زامن حركة الشفاه بدقة مع أي صوت أو نص باستخدام أداة Lip Sync من 微鲤AI. مدعومة بـ Kling AI. مثالية لترجمة الفيديو والدبلجة وإنشاء صور رمزية ناطقة. مجانية وأونلاين.',
            keywords: 'مزامنة حركة الشفاه في الفيديو, مزامنة الشفاه, مزامنة الشفاه بالذكاء الاصطناعي, دبلجة الفيديو, مزامنة الصوت, فيديو متحدث, أداة مزامنة الشفاه',
            og_title: 'مولّد مزامنة الشفاه في الفيديو بالذكاء الاصطناعي مجانًا — مزامنة الصوت والنص مع الفيديو | 微鲤AI',
            og_description: 'زامن حركة الشفاه بدقة مع أي صوت أو نص باستخدام أداة Lip Sync من 微鲤AI. مدعومة بـ Kling AI. مثالية لترجمة الفيديو والدبلجة وإنشاء صور رمزية ناطقة. مجانية وأونلاين.',
            twitter_title: 'مولّد مزامنة الشفاه في الفيديو بالذكاء الاصطناعي مجانًا — مزامنة الصوت والنص مع الفيديو | 微鲤AI',
            twitter_description: 'زامن حركة الشفاه بدقة مع أي صوت أو نص باستخدام أداة Lip Sync من 微鲤AI. مدعومة بـ Kling AI. مثالية لترجمة الفيديو والدبلجة وإنشاء صور رمزية ناطقة. مجانية وأونلاين.',
            page: {
                title1: 'أداة مزامنة الشفاه والدبلجة بالذكاء الاصطناعي مجانًا',
                title2: 'وداعًا لمقاطع الدبلجة غير الطبيعية. ارفع فيديو وملفًا صوتيًا (أو اكتب نصًا)، وستقوم أداة الذكاء الاصطناعي بإعادة توليد حركة شفاه المتحدث لتطابق الصوت بدقة. مدعومة بـ Kling AI وتدعم الدبلجة متعددة اللغات وتعديلات عضلات الوجه الواقعية.',
                dual_input_modes: 'وضعا إدخال',
                audio_sync: 'مزامنة الصوت',
                text_sync: 'تحويل النص إلى كلام',
                text_sync_tip: 'اكتب أي نص، اختر صوتًا بالذكاء الاصطناعي مُسبق الإعداد، ودع الشخصية تنطق به فورًا.',
                audio_sync_tip: 'ارفع تعليقك الصوتي أو أغنيتك لمزامنتها.',
                feature_title1: 'دبلجة متعددة اللغات',
                feature_desc1: 'وسّع وصولك. ترجم فيديوك إلى الإسبانية أو الفرنسية أو اليابانية ثم زامن الشفاه ليبدو المتحدث كأنه يتحدث بطلاقة كلغة أم.',
                feature_title2: 'دقة Kling AI',
                feature_desc2: 'على عكس أدوات Wav2Lip الأساسية، نستخدم نموذج Kling لضمان أن حركات الأسنان واللسان والفك صحيحة تشريحيًا.',
                faq: [
                    {
                        question: 'كيف أزامن الشفاه مع الصوت داخل الفيديو؟',
                        answer: 'ارفع مقطع الفيديو إلى 微鲤AI. ثم ارفع ملفًا صوتيًا (MP3/WAV) أو اكتب نصًا لتوليد صوت بالذكاء الاصطناعي. اضغط "Create" وستقوم الأداة بضبط حركة الفم لتطابق الصوت.',
                    },
                    {
                        question: 'هل يمكنني استخدامه لترجمة/دبلجة الفيديو؟',
                        answer: 'نعم! إنها أداة مثالية للدبلجة. ارفع مسارًا صوتيًا مترجمًا وستقوم الأداة بإصلاح مزامنة الشفاه ليبدو الدبلج طبيعيًا.',
                    },
                    {
                        question: 'هل يعمل مع الصور الثابتة (رأس ناطق)؟',
                        answer: 'نعم. إذا رفعت صورة بورتريه ثابتة كمصدر “فيديو”، فستحوّلها الأداة إلى فيديو رأس ناطق (تأثير Live Portrait).',
                    },
                    {
                        question: 'ما اللغات المدعومة؟',
                        answer: 'لأن التقنية تحلل الموجات الصوتية، فهي تعمل مع أي لغة (الإنجليزية، الإسبانية، الصينية، الهندية… إلخ). أما إدخال تحويل النص إلى كلام فيدعم أكثر من 50 لغة.',
                    },
                    {
                        question: 'هل مزامنة الشفاه مجانية؟',
                        answer: 'توفر 微鲤AI أرصدة مجانية يومية لتجربة ميزة Lip Sync. للمقاطع الطويلة أو الاستخدام التجاري تتوفر خطط مدفوعة.',
                    },
                ],
            },
            faq: [
                {
                    question: 'كيف أزامن الشفاه مع الصوت داخل الفيديو؟',
                    answer: 'ارفع مقطع الفيديو إلى 微鲤AI. ثم ارفع ملفًا صوتيًا (MP3/WAV) أو اكتب نصًا لتوليد صوت بالذكاء الاصطناعي. اضغط "Create" وستقوم الأداة بضبط حركة الفم لتطابق الصوت.',
                },
                {
                    question: 'هل يمكنني استخدامه لترجمة/دبلجة الفيديو؟',
                    answer: 'نعم! إنها أداة مثالية للدبلجة. ارفع مسارًا صوتيًا مترجمًا وستقوم الأداة بإصلاح مزامنة الشفاه ليبدو الدبلج طبيعيًا.',
                },
                {
                    question: 'هل يعمل مع الصور الثابتة (رأس ناطق)؟',
                    answer: 'نعم. إذا رفعت صورة بورتريه ثابتة كمصدر “فيديو”، فستحوّلها الأداة إلى فيديو رأس ناطق (تأثير Live Portrait).',
                },
            ],
        },
        translateVideoSubtitle: {
            title: 'مترجم ترجمات الفيديو بالذكاء الاصطناعي مجانًا — إنشاء وترجمة عبر الإنترنت | 微鲤AI',
            description: 'أنشئ ترجمات الفيديو وترجمها تلقائيًا باستخدام مترجم 微鲤AI. يدعم الإنجليزية والإسبانية والصينية وأكثر من 90 لغة. حمّل فورًا فيديوهات بترجمات مدمجة/محروقة (hardsubs).',
            keywords: 'ترجمة الترجمات بالذكاء الاصطناعي, مترجم ترجمات الفيديو, ترجمات متعددة اللغات, ترجمة الفيديو, محول الترجمات, ترجمة الفيديو بالذكاء الاصطناعي',
            og_title: 'مترجم ترجمات الفيديو بالذكاء الاصطناعي مجانًا — إنشاء وترجمة عبر الإنترنت | 微鲤AI',
            og_description: 'أنشئ ترجمات الفيديو وترجمها تلقائيًا باستخدام مترجم 微鲤AI. يدعم الإنجليزية والإسبانية والصينية وأكثر من 90 لغة. حمّل فورًا فيديوهات بترجمات مدمجة/محروقة (hardsubs).',
            twitter_title: 'مترجم ترجمات الفيديو بالذكاء الاصطناعي مجانًا — إنشاء وترجمة عبر الإنترنت | 微鲤AI',
            twitter_description: 'أنشئ ترجمات الفيديو وترجمها تلقائيًا باستخدام مترجم 微鲤AI. يدعم الإنجليزية والإسبانية والصينية وأكثر من 90 لغة. حمّل فورًا فيديوهات بترجمات مدمجة/محروقة (hardsubs).',
            page: {
                title1: 'مترجم ترجمات الفيديو بالذكاء الاصطناعي مجانًا',
                title2: 'اكسر حاجز اللغة فورًا. ارفع فيديوك، اختر اللغة المستهدفة، ودع الذكاء الاصطناعي يتعرف على الكلام ويقوم بنسخ الصوت ثم يدمج ترجمات دقيقة مترجمة مباشرة داخل ملف الفيديو.',
                feature_title1: 'دعم أكثر من 90 لغة',
                feature_desc1: 'ترجم محتواك من الإنجليزية إلى الإسبانية والفرنسية والألمانية واليابانية والصينية وغيرها، واصل إلى جمهور عالمي بنقرة واحدة.',
                feature_title2: 'مزامنة تلقائية ودمج (حرق) الترجمات',
                feature_desc2: 'لا حاجة لضبط التوقيت يدويًا. يضمن الذكاء الاصطناعي مزامنة الترجمات مع الصوت بدقة ثم يدمجها داخل الفيديو (hardsubs) لتوافق أفضل.',
                feature_title3: 'دقة واعية بالسياق',
                feature_desc3: 'مدعوم بنماذج لغوية متقدمة، يفهم 微鲤AI السياق والعبارات الدارجة ليقدم ترجمة طبيعية ودقيقة وليست حرفية آلية.',
                faq: [
                    {
                        question: 'كيف أترجم ترجمات الفيديو تلقائيًا؟',
                        answer: 'ارفع الفيديو إلى 微鲤AI، اختر “Target Language” (مثلاً: الإنجليزية إلى الإسبانية) ثم اضغط “Create”. سيقوم الذكاء الاصطناعي بإنشاء الترجمات وترجمتها تلقائيًا.',
                    },
                    {
                        question: 'ما اللغات المدعومة للترجمة؟',
                        answer: 'ندعم أكثر من 90 لغة عالمية، بما في ذلك الإنجليزية والإسبانية والفرنسية والألمانية والبرتغالية والهندية واليابانية والصينية.',
                    },
                    {
                        question: 'هل مترجم الترجمات مجاني؟',
                        answer: 'نعم. يوفر 微鲤AI وصولًا مجانيًا لمترجم ترجمات الفيديو بالذكاء الاصطناعي، ويمكنك معالجة الفيديوهات دون دفع خدمات تفريغ مكلفة.',
                    },
                    {
                        question: 'هل أحتاج إلى تنزيل ملف SRT؟',
                        answer: 'لا. ينشئ 微鲤AI فيديوهات بترجمات مدمجة/محروقة (burn‑in/hardsubs)، مما يضمن ظهور الترجمات بشكل صحيح على TikTok وInstagram وYouTube.',
                    },
                    {
                        question: 'ما مدى دقة الترجمة؟',
                        answer: 'نستخدم نماذج تعرّف على الكلام متقدمة لضمان دقة عالية. مع صوت واضح قد تتجاوز الدقة 95%.',
                    },
                ],
            },
            faq: [
                {
                    question: 'كيف أترجم ترجمات الفيديو تلقائيًا؟',
                    answer: 'ارفع الفيديو إلى 微鲤AI، اختر Target Language ثم اضغط Create. سيقوم الذكاء الاصطناعي بإنشاء الترجمات وترجمتها تلقائيًا.',
                },
                {
                    question: 'ما اللغات المدعومة للترجمة؟',
                    answer: 'ندعم أكثر من 90 لغة، بما في ذلك الإنجليزية والإسبانية والفرنسية والألمانية والبرتغالية والهندية واليابانية والصينية.',
                },
                {
                    question: 'هل أحتاج إلى تنزيل ملف SRT؟',
                    answer: 'لا. يخرج 微鲤AI فيديوهات بترجمات مدمجة/محروقة (hardsubs) لتظهر بشكل صحيح على كل المنصات.',
                },
            ],
        },
        videoToAnime: {
            title: 'محوّل فيديو إلى أنمي بالذكاء الاصطناعي مجانًا — من واقعي إلى كرتون وPixar | 微鲤AI',
            description: 'حوّل فيديوهاتك فورًا إلى أنمي ياباني أو أسلوب Pixar ثلاثي الأبعاد أو كرتون باستخدام محوّل الفيديو إلى أنمي من 微鲤AI. ثبات إطار بإطار للحصول على حركة سلسة. مجاني وعبر الإنترنت.',
            keywords: 'فيديو إلى أنمي, فلتر أنمي بالذكاء الاصطناعي, تحويل فيديو إلى كرتون, فلتر Pixar للفيديو, واقعي إلى أنمي, بديل domoai, مولد فيديو أنمي',
            og_title: 'محوّل فيديو إلى أنمي بالذكاء الاصطناعي مجانًا — من واقعي إلى كرتون وPixar | 微鲤AI',
            og_description: 'حوّل فيديوهاتك فورًا إلى أنمي ياباني أو أسلوب Pixar ثلاثي الأبعاد أو كرتون باستخدام محوّل الفيديو إلى أنمي من 微鲤AI. ثبات إطار بإطار للحصول على حركة سلسة. مجاني وعبر الإنترنت.',
            twitter_title: 'محوّل فيديو إلى أنمي بالذكاء الاصطناعي مجانًا — من واقعي إلى كرتون وPixar | 微鲤AI',
            twitter_description: 'حوّل فيديوهاتك فورًا إلى أنمي ياباني أو أسلوب Pixar ثلاثي الأبعاد أو كرتون باستخدام محوّل الفيديو إلى أنمي من 微鲤AI. ثبات إطار بإطار للحصول على حركة سلسة. مجاني وعبر الإنترنت.',
            page: {
                title1: 'محوّل فيديو إلى أنمي بالذكاء الاصطناعي مجانًا',
                title2: 'تحوّل إلى بطل أنمي بنقرة واحدة. ارفع أي فيديو واقعي، اختر أسلوبًا (Pixar ثلاثي الأبعاد، 2D كلاسيكي، أو مرسوم يدويًا)، ودع الذكاء الاصطناعي يعيد تنميط الفيديو إطارًا بإطار مع الحفاظ على الحركة سلسة ومتسقة.',
                feature_desc1: '<div><p>Pixar و3D: أنشئ مقاطع لطيفة بأسلوب ديزني ثلاثي الأبعاد مثالية لفيديوهات العائلة.</p><p>أنمي كلاسيكي: احصل على مظهر أنمي ياباني أصيل (أسلوب Ghibli/Shinkai).</p><p>Sketch & Ink: حوّل الفيديو إلى أنيميشن فني مرسوم بالقلم.</p></div>',
                feature_title2: 'ثبات إطار بإطار',
                feature_desc2: 'هل سئمت من وميض فيديوهات الذكاء الاصطناعي؟ يستخدم 微鲤AI خوارزميات متقدمة للاتساق الزمني لضمان تشغيل فيديو الأنمي بسلاسة بدون “اهتزازات” شائعة.',
                feature_title3: 'صانع محتوى فيروسي',
                feature_desc3: 'مصمم لـ TikTok وReels. أنشئ فيديوهات مقارنة رائجة “واقعي vs أنمي” تجذب الانتباه فورًا.',
                faq: [
                    {
                        question: 'كيف أحوّل فيديو إلى أنمي مجانًا؟',
                        answer: 'ارفع مقطعك إلى أداة الفيديو إلى أنمي في 微鲤AI. اختر إعدادًا مسبقًا مثل “2D Style” أو “Pixar Style” ثم اضغط Create. يمكنك التجربة مجانًا عبر الأرصدة اليومية.',
                    },
                    {
                        question: 'هل يمكنني التحويل إلى أسلوب Pixar/Disney؟',
                        answer: 'نعم! لدينا إعداد “3D Cartoon” أو “Pixar Style” يحوّل الأشخاص الحقيقيين إلى شخصيات ثلاثية الأبعاد لطيفة.',
                    },
                    {
                        question: 'كم يمكن أن تكون مدة الفيديو؟',
                        answer: 'حاليًا ندعم مقاطع حتى 30 ثانية (كما في “Maximum video duration: 30s”). مثالي لـ Shorts وReels وTikTok.',
                    },
                    {
                        question: 'هل سيتحرك персонаج الأنمي مثلي؟',
                        answer: 'بالتأكيد. يحلل الذكاء الاصطناعي حركة الجسم وتعبيرات الوجه ليحاكي أفعالك بأفضل شكل.',
                    },
                    {
                        question: 'ما أفضل محوّل فيديو إلى أنمي؟',
                        answer: 'يُعد 微鲤AI خيارًا قويًا لأنه يقدم أنماطًا متعددة (2D/3D) ويركّز على الثبات لتقليل الضجيج والوميض.',
                    },
                ],
            },
            faq: [
                {
                    question: 'كيف أحوّل فيديو إلى أنمي مجانًا؟',
                    answer: 'ارفع الفيديو إلى 微鲤AI، اختر إعدادًا مسبقًا (2D Style أو Pixar Style) ثم اضغط Create.',
                },
                {
                    question: 'هل يمكنني التحويل إلى أسلوب Pixar/Disney؟',
                    answer: 'نعم. نقدم إعدادًا مسبقًا 3D Cartoon/Pixar Style لتحويل الأشخاص الحقيقيين إلى شخصيات ثلاثية الأبعاد.',
                },
                {
                    question: 'هل سيتحرك персонаج الأنمي مثلي؟',
                    answer: 'نعم. يحلل الذكاء الاصطناعي الحركة والتعبيرات ليحاكي أفعالك.',
                },
            ],
            app_name: '微鲤AI Video to Anime Converter',
            app_desc: 'أداة ذكاء اصطناعي مجانية لتحويل الفيديوهات الواقعية إلى أنمي وكرتون وأسلوب Pixar. تعتمد على رندر إطار بإطار لثبات الحركة.',
            featureList: 'واقعي→أنمي, فلتر Pixar, اتساق الإطارات, أنماط 2D/3D',
        },
        videoUpscaler: {
            title: 'مكبّر فيديو بالذكاء الاصطناعي مجانًا — تحسين حتى 4K أونلاين | 微鲤AI',
            description: 'حسّن فيديوهات منخفضة الدقة فورًا إلى 1080p و2K و4K باستخدام مكبّر الفيديو المجاني من 微鲤AI. يصلح التكسّر، يقلل الضوضاء، ويحسّن الجودة أونلاين دون تثبيت برامج.',
            keywords: 'مكبر فيديو, تحسين الفيديو بالذكاء الاصطناعي, تكبير فيديو إلى 4k, إزالة ضبابية الفيديو, تقليل ضوضاء الفيديو, تحسين جودة الفيديو, مكبر فيديو مجاني أونلاين',
            og_title: 'مكبّر فيديو بالذكاء الاصطناعي مجانًا — تحسين حتى 4K أونلاين | 微鲤AI',
            og_description: 'حسّن فيديوهات منخفضة الدقة فورًا إلى 1080p و2K و4K باستخدام مكبّر الفيديو المجاني من 微鲤AI. يصلح التكسّر، يقلل الضوضاء، ويحسّن الجودة أونلاين دون تثبيت برامج.',
            twitter_title: 'مكبّر فيديو بالذكاء الاصطناعي مجانًا — تحسين حتى 4K أونلاين | 微鲤AI',
            twitter_description: 'حسّن فيديوهات منخفضة الدقة فورًا إلى 1080p و2K و4K باستخدام مكبّر الفيديو المجاني من 微鲤AI. يصلح التكسّر، يقلل الضوضاء، ويحسّن الجودة أونلاين دون تثبيت برامج.',
            page: {
                title1: 'مكبّر فيديو بالذكاء الاصطناعي مجانًا',
                title2: 'لا تكتفِ بفيديو ضبابي أو متكسّر. ارفع فيديوهاتك منخفضة الدقة (360p، 480p، 720p) ودع الذكاء الاصطناعي يرفعها تلقائيًا إلى 4K مذهلة. لا يزيد الحجم فقط، بل يستعيد التفاصيل ويزيل الضوضاء ويصحح الألوان.',
                feature_title1: 'تكبير حتى 4K',
                feature_desc1: 'أعِد الحياة للفيديوهات القديمة. حوّل محتوى SD إلى HD أو 4K بنقرة واحدة ليبدو حادًا على الشاشات الحديثة.',
                feature_title2: 'إصلاح الضبابية والحبيبات',
                feature_desc2: 'تم التصوير بإضاءة منخفضة؟ خوارزمية إزالة الضوضاء بالذكاء الاصطناعي تزيل الحبيبات والعيوب الناتجة عن الضغط ليبدو الفيديو نظيفًا واحترافيًا.',
                feature_title3: 'ترميم المقاطع القديمة',
                feature_desc3: 'مثالي لأرشيف العائلة. استعد الألوان الباهتة وحدد التفاصيل في فيديوهات منزلية قديمة أو مقاطع كلاسيكية.',
                faq: [
                    {
                        question: 'هل يمكنني تكبير الفيديو إلى 4K أونلاين مجانًا؟',
                        answer: 'نعم. يتيح 微鲤AI اختيار دقة إخراج حتى 4K (كما في خيارات الأداة). يمكنك تجربته مجانًا عبر الأرصدة اليومية.',
                    },
                    {
                        question: 'كيف أصلح فيديو ضبابيًا؟',
                        answer: 'ارفع الفيديو الضبابي إلى مكبّر الفيديو بالذكاء الاصطناعي. يحلل الذكاء الاصطناعي البكسلات المفقودة ويعيد بناء التفاصيل لتقليل الضبابية.',
                    },
                    {
                        question: 'هل يعمل على فيديوهات الهاتف القديمة؟',
                        answer: 'بالتأكيد. يعمل بشكل ممتاز على الفيديوهات منخفضة الجودة (مثل 360p أو 480p) ويحوّلها إلى 1080p أو أعلى.',
                    },
                    {
                        question: 'كم يستغرق التكبير؟',
                        answer: 'التكبير مكلف حسابيًا، لكن 微鲤AI يستخدم GPU سحابيًا مُحسّنًا. عادةً يستغرق مقطع قصير بضع دقائق.',
                    },
                    {
                        question: 'هل هو أفضل من Topaz Video AI؟',
                        answer: 'يوفر 微鲤AI جودة ذكاء اصطناعي مشابهة ويعمل بالكامل في المتصفح دون الحاجة لعتاد باهظ أو تثبيت.',
                    },
                ],
            },
            faq: [
                {
                    question: 'هل يمكنني تكبير الفيديو إلى 4K أونلاين؟',
                    answer: 'نعم. يتيح 微鲤AI إخراجًا حتى 4K ويمكنك التجربة عبر الأرصدة اليومية.',
                },
                {
                    question: 'كيف أصلح فيديو ضبابيًا؟',
                    answer: 'ارفع الفيديو إلى مكبّر الفيديو بالذكاء الاصطناعي: سيعيد بناء التفاصيل لتقليل الضبابية.',
                },
                {
                    question: 'هل هو أفضل من Topaz Video AI؟',
                    answer: 'يوفر 微鲤AI جودة مشابهة ويعمل في المتصفح دون تثبيت أو عتاد باهظ.',
                },
            ],
            app_name: '微鲤AI Video Upscaler',
            app_desc: 'مكبّر فيديو مجاني بالذكاء الاصطناعي لتحسين الجودة حتى 4K. يصلح الضبابية، يزيل الضوضاء، ويرمم المقاطع القديمة أونلاين.',
            featureList: 'تكبير 4K, إزالة الضوضاء بالذكاء الاصطناعي, زيادة الحدة, تصحيح الألوان',
        },
        removeVideoSubtitles: {
            title: 'إزالة الترجمات من الفيديو - أداة إزالة الترجمات بالذكاء الاصطناعي | 微鲤AI',
            description: 'أزل الترجمات المدمجة من الفيديوهات باستخدام تقنية الذكاء الاصطناعي. امسح بذكاء الترجمات والنصوص المشفرة من الفيديوهات مع الحفاظ على جودة الفيديو. سريع وسهل الاستخدام.',
            keywords: 'إزالة ترجمات الفيديو, أداة إزالة ترجمات, إزالة ترجمات, مسح ترجمات, إزالة ترجمات فيديو, إزالة ترجمات مشفرة',
            og_title: 'إزالة الترجمات من الفيديو - أداة إزالة الترجمات بالذكاء الاصطناعي | 微鲤AI',
            og_description: 'أزل الترجمات المدمجة من الفيديوهات باستخدام تقنية الذكاء الاصطناعي. امسح بذكاء الترجمات والنصوص المشفرة من الفيديوهات مع الحفاظ على جودة الفيديو. سريع وسهل الاستخدام.',
            twitter_title: 'إزالة الترجمات من الفيديو - أداة إزالة الترجمات بالذكاء الاصطناعي | 微鲤AI',
            twitter_description: 'أزل الترجمات المدمجة من الفيديوهات باستخدام تقنية الذكاء الاصطناعي. امسح بذكاء الترجمات والنصوص المشفرة من الفيديوهات مع الحفاظ على جودة الفيديو. سريع وسهل الاستخدام.',
            page: {
                title1: 'مزيل ترجمات الفيديو بالذكاء الاصطناعي (مجاني)',
                title2: 'هل تعاني من ترجمات “محروقة/مدمجة” داخل الفيديو؟ يقوم خوارزم 微鲤AI الذكي باكتشاف الترجمات المدمجة وكلمات الأغاني والنصوص على الشاشة ومسحها تلقائيًا. الصق رابطًا أو ارفع ملفًا لتحصل فورًا على فيديو نظيف بلا نص.',
                feature_title1: 'اكتشاف ذكي للنص',
                feature_desc1: 'لا حاجة للقص أو التمويه يدويًا. يحدد الذكاء الاصطناعي مناطق النص أسفل الشاشة (أو في أي مكان) ويفصلها عن الخلفية.',
                feature_title2: 'ترميم In‑painting سلس',
                feature_desc2: 'وداعًا للمربعات الضبابية. يملأ 微鲤AI المنطقة المزالة عبر تحليل البكسلات المحيطة وإعادة بناء القوام بشكل طبيعي.',
                feature_title3: 'يدعم الروابط والملفات',
                feature_desc3: 'أزل الترجمات مباشرة من روابط TikTok وYouTube وInstagram، أو ارفع ملفات MP4/MOV. مثالي لإعادة استخدام المحتوى.',
                faq: [
                    {
                        question: 'هل يمكنني إزالة الترجمات المدمجة (المحروقة)؟',
                        answer: 'نعم. هذه الأداة مخصصة للترجمات المدمجة التي تكون جزءًا من صورة الفيديو ولا يمكن إيقافها. تقوم بمسحها بصريًا.',
                    },
                    {
                        question: 'كيف أزيل الترجمات من فيديو TikTok/YouTube؟',
                        answer: 'انسخ رابط الفيديو والصقه في تبويب “Video Link” على 微鲤AI ثم اضغط “Generate”. سيزيل الذكاء الاصطناعي الترجمات ويمكنك تنزيل الفيديو النظيف.',
                    },
                    {
                        question: 'هل سيزيل الخلفية خلف النص؟',
                        answer: 'لا. يستخدم 微鲤AI تقنية AI In‑painting: يزيل النص ثم “يعيد رسم” الخلفية خلفه بذكاء ليبدو الفيديو طبيعيًا ومتكاملًا.',
                    },
                    {
                        question: 'ما الفرق بين هذه الأداة وأداة إزالة العلامة المائية؟',
                        answer: 'هما متشابهتان، لكن مزيل الترجمات مُحسّن لشرائط النص والكلمات والكابتشن (غالبًا في الأسفل)، بينما تركز أداة إزالة العلامة المائية على الشعارات والأختام.',
                    },
                    {
                        question: 'هل هي مجانية؟',
                        answer: 'نعم، يمكنك استخدام الميزات الأساسية مجانًا عبر رصيد يومي.',
                    },
                ],
            },
            faq: [
                {
                    question: 'هل يمكنني إزالة الترجمات المدمجة؟',
                    answer: 'نعم. هذه الأداة مخصصة للترجمات المدمجة التي تكون جزءًا من صورة الفيديو. تقوم بمسحها بصريًا.',
                },
                {
                    question: 'كيف أزيل الكابتشن من رابط TikTok؟',
                    answer: 'انسخ الرابط والصقه في تبويب “Video Link” ثم اضغط “Generate”. سيزيلها الذكاء الاصطناعي تلقائيًا.',
                },
                {
                    question: 'هل ستتأثر الخلفية خلف النص؟',
                    answer: 'لا. يستخدم 微鲤AI AI In‑painting لإزالة النص وإعادة بناء الخلفية بذكاء.',
                },
            ],
            app_name: '微鲤AI مزيل ترجمات الفيديو',
            app_desc: 'أداة مجانية بالذكاء الاصطناعي لمسح الترجمات المدمجة والكابتشن والنص من الفيديوهات. ترمم الخلفية بتقنية in‑painting بدون مربعات ضبابية.',
            featureList: 'إزالة ترجمات مدمجة, ترميم الخلفية بالذكاء الاصطناعي, دعم روابط الفيديو, ممحاة كلمات/نص',
        },
        videoBackgroundRemover: {
            title: 'أداة إزالة خلفية الفيديو - إزالة خلفية الفيديو بالذكاء الاصطناعي | 微鲤AI',
            description: 'أزل الخلفيات من الفيديوهات تلقائيًا باستخدام الذكاء الاصطناعي. أنشئ تأثيرات الشاشة الخضراء، عزل الموضوعات، واستبدل خلفيات الفيديو بسهولة. مثالي لمنشئي المحتوى ومحرري الفيديو.',
            keywords: 'أداة إزالة خلفية الفيديو, إزالة خلفية الفيديو, الشاشة الخضراء, إزالة الخلفية بالذكاء الاصطناعي, ممحاة خلفية الفيديو, عزل موضوع الفيديو',
            og_title: 'أداة إزالة خلفية الفيديو - إزالة خلفية الفيديو بالذكاء الاصطناعي | 微鲤AI',
            og_description: 'أزل الخلفيات من الفيديوهات تلقائيًا باستخدام الذكاء الاصطناعي. أنشئ تأثيرات الشاشة الخضراء، عزل الموضوعات، واستبدل خلفيات الفيديو بسهولة. مثالي لمنشئي المحتوى ومحرري الفيديو.',
            twitter_title: 'أداة إزالة خلفية الفيديو - إزالة خلفية الفيديو بالذكاء الاصطناعي | 微鲤AI',
            twitter_description: 'أزل الخلفيات من الفيديوهات تلقائيًا باستخدام الذكاء الاصطناعي. أنشئ تأثيرات الشاشة الخضراء، عزل الموضوعات، واستبدل خلفيات الفيديو بسهولة. مثالي لمنشئي المحتوى ومحرري الفيديو.',
            page: {
                title1: 'مزيل خلفية الفيديو بالذكاء الاصطناعي (مجاني)',
                title2: 'لا توجد شاشة خضراء؟ لا مشكلة. ارفع الفيديو وسيقوم الذكاء الاصطناعي باكتشاف الموضوع تلقائيًا وقصّه بدقة عالية حتى تفاصيل الشعر، ثم يمكنك تنزيل فيديو بخلفية شفافة أو استبدال الخلفية بلون ثابت فورًا.',
                feature_title1: 'بدون شاشة خضراء',
                feature_desc1: 'انسَ تجهيزات الاستوديو المكلفة. يفصل الذكاء الاصطناعي الأشخاص والحيوانات والأشياء عن الخلفيات المعقدة تلقائيًا (Auto‑Rotoscoping).',
                feature_title2: 'استبدال بخلفية لون ثابت',
                feature_desc2: 'مثالي للتجارة الإلكترونية. غيّر خلفية فيديو المنتج إلى أبيض ناصع أو أسود أو أي لون مخصص بنقرة واحدة لرفع التحويلات.',
                feature_title3: 'تصدير بخلفية شفافة',
                feature_desc3: 'نزّل الفيديو مع قناة ألفا (WebM/MOV) وادمج الموضوع بسهولة فوق أي فيديو آخر في Premiere Pro أو DaVinci Resolve أو CapCut.',
                faq: [
                    {
                        question: 'هل يمكنني إزالة خلفية الفيديو بدون شاشة خضراء؟',
                        answer: 'نعم! يستخدم 微鲤AI تعلمًا آليًا متقدمًا لتمييز الموضوع عن الخلفية، لذا يمكنك إزالة الخلفيات من فيديوهات مصورة في أي مكان.',
                    },
                    {
                        question: 'كيف أحفظ فيديو بخلفية شفافة؟',
                        answer: 'بعد إزالة الخلفية اختر WebM (Transparent) أو MOV كصيغة إخراج. لا يدعم MP4 القياسي الشفافية وسيظهر بخلفية سوداء.',
                    },
                    {
                        question: 'هل يمكنني تغيير خلفية الفيديو إلى اللون الأبيض؟',
                        answer: 'نعم. في إعدادات الأداة استخدم “Background Color” لاختيار الأبيض أو الأسود أو أي لون hex. هذا مثالي لفيديوهات منتجات Amazon/Shopify.',
                    },
                    {
                        question: 'هل يتعامل جيدًا مع الشعر؟',
                        answer: 'نعم. تم تدريب الخوارزمية على الحواف المعقدة مثل الشعر والفراء والأشياء شبه الشفافة (مثل النظارات) مع الحفاظ على التفاصيل.',
                    },
                    {
                        question: 'هل هو مجاني؟',
                        answer: 'نعم، يمكنك معالجة الفيديوهات مجانًا باستخدام رصيدك اليومي.',
                    },
                ],
            },
            faq: [
                {
                    question: 'هل يمكنني إزالة خلفية الفيديو بدون شاشة خضراء؟',
                    answer: 'نعم! لا يحتاج 微鲤AI إلى شاشة خضراء لفصل الموضوع عن الخلفية.',
                },
                {
                    question: 'كيف أحفظ فيديو بخلفية شفافة؟',
                    answer: 'اختر WebM (Transparent) أو MOV. لا يدعم MP4 القياسي الشفافية.',
                },
                {
                    question: 'هل يمكنني تغيير خلفية الفيديو إلى اللون الأبيض؟',
                    answer: 'نعم. استخدم Background Color لاختيار الأبيض، وهو مثالي لفيديوهات المنتجات.',
                },
            ],
            app_name: '微鲤AI مزيل خلفية الفيديو',
            app_desc: 'أداة مجانية بالذكاء الاصطناعي لإزالة خلفية الفيديو بدون شاشة خضراء. تصدير فيديوهات شفافة أو تغيير الخلفية إلى أبيض/أسود عبر الإنترنت.',
            featureList: 'بدون شاشة خضراء, تصدير فيديو شفاف, تغيير لون الخلفية, دقة تفاصيل الشعر',
            step_name: 'كيفية إزالة خلفية الفيديو عبر الإنترنت',
            step_list: [
                {
                    name: 'رفع الفيديو',
                    text: 'ارفع الفيديو (MP4, MOV) إلى مزيل الخلفية من 微鲤AI.',
                },
                {
                    name: 'إزالة الخلفية',
                    text: 'يعالج الذكاء الاصطناعي الفيديو تلقائيًا. يمكنك إبقاؤه شفافًا أو اختيار لون خلفية جديد.',
                },
                {
                    name: 'التصدير',
                    text: 'نزّل النتيجة. اختر WebM/MOV للشفافية أو MP4 لخلفيات اللون الثابت.',
                },
            ],
        },
        aiVideoExtender: {
            title: 'أداة تمديد الفيديو بالذكاء الاصطناعي - تمديد طول ومدة الفيديو | 微鲤AI',
            description: 'مدد طول الفيديو باستخدام تقنية الذكاء الاصطناعي. أضف 5-8 ثوانٍ إلى فيديوهاتك بسلاسة مع خيارات أنماط متعددة تشمل الأنمي والرسوم المتحركة ثلاثية الأبعاد والسايبربانك والكوميكس. مثالي لمنشئي المحتوى ومحرري الفيديو.',
            keywords: 'تمديد الفيديو بالذكاء الاصطناعي, تمديد طول الفيديو, تمديد مدة الفيديو, توسيع الفيديو بالذكاء الاصطناعي, إطالة الفيديو, تمديد وقت الفيديو, أداة فيديو الذكاء الاصطناعي',
            og_title: 'أداة تمديد الفيديو بالذكاء الاصطناعي - تمديد طول ومدة الفيديو | 微鲤AI',
            og_description: 'مدد طول الفيديو باستخدام تقنية الذكاء الاصطناعي. أضف 5-8 ثوانٍ إلى فيديوهاتك بسلاسة مع خيارات أنماط متعددة تشمل الأنمي والرسوم المتحركة ثلاثية الأبعاد والسايبربانك والكوميكس. مثالي لمنشئي المحتوى ومحرري الفيديو.',
            twitter_title: 'أداة تمديد الفيديو بالذكاء الاصطناعي - تمديد طول ومدة الفيديو | 微鲤AI',
            twitter_description: 'مدد طول الفيديو باستخدام تقنية الذكاء الاصطناعي. أضف 5-8 ثوانٍ إلى فيديوهاتك بسلاسة مع خيارات أنماط متعددة تشمل الأنمي والرسوم المتحركة ثلاثية الأبعاد والسايبربانك والكوميكس. مثالي لمنشئي المحتوى ومحرري الفيديو.',
            page: {
                title1: 'مُمدِّد الفيديو بالذكاء الاصطناعي مجانًا والاستكمال',
                title2: 'هل الفيديو قصير جدًا؟ يستخدم 微鲤AI ذكاءً اصطناعيًا توليديًا للتنبؤ بإطارات جديدة وإنشائها لتمديد المقطع بسلاسة. يمكنك أيضًا استخدام Prompt لتوجيه كيفية استمرار الفيديو أو تحويل اللقطات العادية إلى حركة بطيئة ناعمة جدًا.',
                feature_title1: 'تمديد توليدي ذكي',
                feature_desc1: 'لا تكتفِ بتمطيط الفيديو—أنشئ محتوى جديدًا. اكتب Prompt مثل “الكاميرا تبتعد” أو “الشخصية تلتفت”، وسيولّد الذكاء الاصطناعي 5–10 ثوانٍ التالية بما يتوافق مع أسلوب الفيديو الأصلي.',
                feature_title2: 'حركة بطيئة فائقة السلاسة',
                feature_desc2: 'حوّل فيديو 30fps إلى Slow Motion عالي الجودة. يستخدم 微鲤AI Frame Interpolation لإدراج إطارات مولّدة بالذكاء الاصطناعي بين الإطارات الحالية للحصول على حركة سلسة بدون تقطيع.',
                feature_title3: 'صنع حلقات مثالية',
                feature_desc3: 'أنشئ Loops لا نهائية لخلفيات السوشيال. يحلل الذكاء الاصطناعي الإطارات الأولى والأخيرة لدمجها بشكل مثالي.',
                faq: [
                    {
                        question: 'كيف يعمل مُمدِّد الفيديو بالذكاء الاصطناعي؟',
                        answer: 'يستخدم تقنية “Generative Outpainting”. يحلل الذكاء الاصطناعي آخر إطارات الفيديو وPrompt الخاص بك للتنبؤ بإطارات جديدة وتوليدها لتكمل الحركة بشكل منطقي.',
                    },
                    {
                        question: 'هل يمكنني التحكم بما يحدث في الجزء المُمتد؟',
                        answer: 'نعم! استخدم مربع “Prompt” لوصف الحركة. مثلًا إذا كان الفيديو يظهر سيارة تقود، اكتب “السيارة تدخل نفقًا” لتوجيه التمديد.',
                    },
                    {
                        question: 'ما الفرق بين Extension و Slow Motion؟',
                        answer: 'Extension يضيف وقتًا جديدًا بتوليد أحداث جديدة (يجعل القصة أطول). Slow Motion يمدّ الوقت الموجود بإضافة إطارات وسطية (يجعل الحركة أبطأ). 微鲤AI يدعم الاثنين.',
                    },
                    {
                        question: 'إلى أي مدى يمكنني تمديد الفيديو؟',
                        answer: 'يمكنك تمديد المقطع 5 ثوانٍ في كل مرة (كما في إعداد “Extension Duration”). يمكنك تكرار العملية لإنشاء تسلسلات أطول.',
                    },
                    {
                        question: 'هل هو مجاني؟',
                        answer: 'نعم، يوفر 微鲤AI رصيدًا مجانيًا لتجربة تمديد الفيديو وتأثيرات الحركة البطيئة.',
                    },
                ],
            },
            faq: [
                {
                    question: 'كيف يعمل مُمدِّد الفيديو بالذكاء الاصطناعي؟',
                    answer: 'مع “Generative Outpainting”، يحلل الذكاء الاصطناعي آخر الإطارات وPrompt ليولّد إطارات جديدة تُكمل الحركة.',
                },
                {
                    question: 'هل يمكنني التحكم بالجزء المُمتد؟',
                    answer: 'نعم. صف الحركة في “Prompt” (مثلًا: “السيارة تدخل نفقًا”).',
                },
                {
                    question: 'ما الفرق بين Extension و Slow Motion؟',
                    answer: 'Extension يولّد أحداثًا جديدة لإضافة وقت، وSlow Motion يضيف إطارات وسطية لإبطاء الحركة.',
                },
            ],
            app_name: '微鲤AI Video Extender',
            app_desc: 'أداة مجانية لتمديد الفيديو باستخدام generative fill وprompts. تتضمن أيضًا Slow Motion بالذكاء الاصطناعي (frame interpolation) وصنع حلقات loop.',
            featureList: 'تمديد فيديو توليدي, استكمال موجّه بـ Prompt, حركة بطيئة بالذكاء الاصطناعي, حلقات فيديو',
        },
        videoEffects: {
            title: 'تأثيرات الفيديو - أنشئ فيديوهات فيروسية بالذكاء الاصطناعي | 微鲤AI',
            description: 'استكشف تأثيرات الفيديو بالذكاء الاصطناعي الشائعة على 微鲤AI. من القبلات بالذكاء الاصطناعي إلى الرقص بالذكاء الاصطناعي، أنشئ فيديوهات فيروسية بنقرات قليلة فقط.',
            keywords: 'تأثيرات فيديو بالذكاء الاصطناعي, فيديوهات فيروسية بالذكاء الاصطناعي, اتجاهات الفيديو, قبلات بالذكاء الاصطناعي, رقص بالذكاء الاصطناعي, مولد فيديو',
        },
        aiDancing: {
            title: 'مولد فيديو الرقص بالذكاء الاصطناعي - صانع فيديو رقص مجاني بالذكاء الاصطناعي | 微鲤AI',
            description: 'استخدم مولد الرقص بالذكاء الاصطناعي من 微鲤AI لإنشاء فيديوهات رقص مذهلة من الصور. يدعم قوالب وأنماط رقص متعددة، أحيِ صورك!',
            keywords: 'فيديو رقص بالذكاء الاصطناعي, مولد رقص بالذكاء الاصطناعي, صورة إلى فيديو, توليد فيديو بالذكاء الاصطناعي, 微鲤AI, أدوات ذكاء اصطناعي مجانية',
        },
        aiKissing: {
            title: 'aiKissing | 微鲤AI',
            description: 'Experience aiKissing on 微鲤AI platform.',
            keywords: 'aiKissing, AI, 微鲤AI',
        },
        videoMotionImitation: {
            title: 'محاكاة حركة الفيديو بالذكاء الاصطناعي - أحيِ الصور مجانًا | 微鲤AI',
            description: 'يمكن لأداة محاكاة حركة الفيديو من 微鲤AI دمج شخصيات الصور في مقاطع فيديو مرجعية، واستبدال الشخصيات الأصلية مع الحفاظ على إضاءة المشهد ونغماته لتحقيق اندماج بيئي سلس.',
            keywords: 'محاكاة حركة الفيديو بالذكاء الاصطناعي, إحياء الصور, أداة محاكاة حركة الفيديو بالذكاء الاصطناعي, 微鲤AI, أدوات ذكاء اصطناعي مجانية',
            og_title: 'محاكاة حركة الفيديو بالذكاء الاصطناعي - أحيِ الصور مجانًا | 微鲤AI',
            og_description: 'يمكن لأداة محاكاة حركة الفيديو من 微鲤AI دمج شخصيات الصور في مقاطع فيديو مرجعية، واستبدال الشخصيات الأصلية مع الحفاظ على إضاءة المشهد ونغماته لتحقيق اندماج بيئي سلس.',
            twitter_title: 'محاكاة حركة الفيديو بالذكاء الاصطناعي - أحيِ الصور مجانًا | 微鲤AI',
            twitter_description: 'يمكن لأداة محاكاة حركة الفيديو من 微鲤AI دمج شخصيات الصور في مقاطع فيديو مرجعية، واستبدال الشخصيات الأصلية مع الحفاظ على إضاءة المشهد ونغماته لتحقيق اندماج بيئي سلس.',
            page: {
                title1: 'مولّد رقص بالذكاء الاصطناعي مجانًا ونقل الحركة',
                title2: 'هل تريد رؤية شخصية الأنمي المفضلة لديك ترقص مثل مايكل جاكسون؟ أو جعل صورة ثابتة تؤدي حركة TikTok فيروسية؟ ارفع فيديو مرجعيًا وصورة للشخصية، وستقوم أداة الذكاء الاصطناعي بنقل الحركة بدقة.',
                feature_title1: 'استبدال شخصية داخل الفيديو',
                feature_desc1: 'تبديل من حقيقي إلى أنمي: ارفع فيديو لشخص يرقص أو يقاتل واستبدله بشخصية ثلاثية الأبعاد أو باندا أو أفاتار أنمي مع الحفاظ على الخلفية والإضاءة.',
                feature_title2: 'اجعل الصور ترقص',
                feature_desc2: 'تحريك الصور الثابتة: أحيِ الصور. ارفع صورة لك أو لشخصية، واختر فيديو رقص مرجعيًا وشاهد الصورة تقلّد الحركات. مثالي لمحتوى فيروسي بأسلوب Viggle.',
                feature_title3: 'اكسر جدار الأبعاد',
                feature_desc3: 'أنماط عبر الأبعاد: سواء تحويل راقصة باليه إلى فتاة أنمي أو فتى كاراتيه إلى باندا، يتعامل 微鲤AI بسلاسة مع الأجسام المعقدة وحالات الحجب.',
                faq: [
                    {
                        question: 'كيف أجعل صورة ترقص باستخدام الذكاء الاصطناعي؟',
                        answer: 'استخدم “Move Mode” في 微鲤AI. ارفع الصورة التي تريد تحريكها (Character Image) وفيديو الحركات (Reference Video)، ثم اضغط Create لنقل الحركة.',
                    },
                    {
                        question: 'ما الفرق بين Move Mode و Replace Mode؟',
                        answer: 'Move Mode يحرك صورة ثابتة باستخدام حركة فيديو. Replace Mode يستبدل الشخص داخل فيديو موجود بشخصية جديدة من صورة.',
                    },
                    {
                        question: 'هل يمكنني استخدامه لاتجاهات TikTok؟',
                        answer: 'نعم! مثالي لتحديات TikTok: اجعل المشاهير أو شخصيات الأنمي أو الأصدقاء يؤدون رقصات رائجة دون تعلمها.',
                    },
                    {
                        question: 'هل يعمل على لقطات الجسم بالكامل؟',
                        answer: 'نعم. للحصول على أفضل النتائج، تأكد أن الفيديو المرجعي والصورة يظهران الجسم بالكامل بوضوح.',
                    },
                    {
                        question: 'هل هو مجاني؟',
                        answer: 'نعم، يمكنك إنشاء فيديوهات نقل الحركة مجانًا باستخدام رصيدك اليومي.',
                    },
                ],
            },
            faq: [
                {
                    question: 'كيف أجعل صورة ترقص باستخدام الذكاء الاصطناعي؟',
                    answer: 'استخدم “Move Mode” في 微鲤AI. ارفع الصورة التي تريد تحريكها (Character Image) وفيديو الحركات (Reference Video)، ثم اضغط Create لنقل الحركة.',
                },
                {
                    question: 'ما الفرق بين Move Mode و Replace Mode؟',
                    answer: 'Move Mode يحرك صورة ثابتة باستخدام حركة فيديو. Replace Mode يستبدل الشخص داخل فيديو موجود بشخصية جديدة من صورة.',
                },
            ],
            app_name: '微鲤AI Motion Transfer',
            app_desc: 'مولّد رقص بالذكاء الاصطناعي ونقل حركة مجانًا. اجعل الصور ترقص، حرّك الصور الثابتة، واستبدل شخصيات الفيديو عبر الإنترنت.',
            featureList: 'توليد رقص بالذكاء الاصطناعي, نقل وضعية الجسم, تبديل شخصية الفيديو, تحريك الصور',
            step_name: 'كيفية جعل صورة ترقص باستخدام الذكاء الاصطناعي',
            step_list: [
                {
                    name: 'ارفع الفيديو المرجعي',
                    text: 'ارفع فيديو يحتوي على خطوات الرقص أو الحركة التي تريد نسخها.',
                },
                {
                    name: 'ارفع صورة الشخصية',
                    text: 'ارفع الصورة الثابتة للشخص أو الشخصية التي تريد تحريكها.',
                },
                {
                    name: 'اختر Move Mode',
                    text: 'اختر “Move Mode” ثم اضغط Create. سيجعل الذكاء الاصطناعي الصورة تؤدي حركات الفيديو.',
                },
            ],
        },
    },
    tw: {
        textToMusic: {
            title: 'AI 音樂產生器 - 創作專屬免版稅音樂 | 微鲤AI',
            description: '利用先進的 AI 技術，快速創建獨特的免版稅音樂，完美適配您的項目。',
            keywords: 'AI 音樂產生器, 免版稅音樂, 微鲤AI',
        },
        textToVideo: {
            title: '免費 AI 文生影片生成器（Veo 3.1、Kling 與 Sora）- 文字生成影片 | 微鲤AI',
            description: '使用 微鲤AI 的文生影片 AI，立即將文字提示轉成電影感影片。由 Google Veo 3.1、Kling 與 Sora 驅動。支援 16:9 與 9:16，最長 8 秒。提供無浮水印選項。',
            keywords: '文生影片, 文字轉影片, AI 影片生成器, Google Veo 3.1, Kling, Sora, txt2vid, 微鲤AI',
            og_title: '免費 AI 文生影片生成器（Veo 3.1、Kling 與 Sora）- 文字生成影片 | 微鲤AI',
            og_description: '使用 微鲤AI 的文生影片 AI，立即將文字提示轉成電影感影片。由 Google Veo 3.1、Kling 與 Sora 驅動。支援 16:9 與 9:16，最長 8 秒。提供無浮水印選項。',
            twitter_title: '免費 AI 文生影片生成器（Veo 3.1、Kling 與 Sora）- 文字生成影片 | 微鲤AI',
            twitter_description: '使用 微鲤AI 的文生影片 AI，立即將文字提示轉成電影感影片。由 Google Veo 3.1、Kling 與 Sora 驅動。支援 16:9 與 9:16，最長 8 秒。提供無浮水印選項。',
            page: {
                title1: '免費 AI 文生影片生成器',
                title2: '只要輸入提示詞，微鲤AI 就能讓你的想法成形。我們的文生影片生成器整合 Google Veo 3.1、Kling AI 等頂尖模型，讓你在數秒內產生高品質、符合物理一致性的影片，適用於社群直式（9:16）或電影感橫式（16:9）。',
                intro_title: '用文生影片 AI 把想像變成現實',
                feature_title: '微鲤AI 文生影片功能特色',
                faq_title: '文生影片常見問題',
                feature_title1: '多模型強力整合',
                feature_desc1: '可在 Veo 3.1 的真實感與 Kling 的動作一致性之間切換，無需多重訂閱。',
                feature_title2: '自訂畫面比例',
                feature_desc2: '直接生成 TikTok/Reels 的直式 9:16 或 YouTube 的橫式 16:9。',
                feature_title3: '延長生成時長',
                feature_desc3: '單次生成最長 8 秒（或使用延長工具產生更長片段），適合敘事創作。',
                faq: [
                    {
                        question: '如何寫出好的文生影片提示詞？',
                        answer: '要具體描述主體、動作、光線與鏡頭角度。例如：「夜晚未來賽博龐克城市的電影感空拍，霓虹燈，4K。」微鲤AI 的整合模型能理解複雜描述。',
                    },
                    {
                        question: '該選 Google Veo 3.1 還是 Kling？',
                        answer: 'Veo 3.1 具備更高畫質與提示詞遵循度，適合寫實場景；Kling 通常在複雜角色動作上更好。建議兩者都試試。',
                    },
                    {
                        question: '微鲤AI 文生影片是免費的嗎？',
                        answer: '是的，每位使用者每天都有免費點數，可用於文生影片。',
                    },
                    {
                        question: '可以生成超過 8 秒的影片嗎？',
                        answer: '基礎生成最長 8 秒（視模型而定）。若需要更長影片，可使用 AI 影片延長工具無縫續接。',
                    },
                    {
                        question: '生成的影片有聲音嗎？',
                        answer: '可以，開啟工具中的「Generate Audio」即可自動產生符合畫面的音效與環境聲。',
                    },
                ],
            },
            faq: [
                {
                    question: '如何寫出好的文生影片提示詞？',
                    answer: '要具體描述主體、動作、光線與鏡頭角度。例如：「夜晚未來賽博龐克城市的電影感空拍，霓虹燈，4K。」微鲤AI 的整合模型能理解複雜描述。',
                },
                {
                    question: '該選 Google Veo 3.1 還是 Kling？',
                    answer: 'Veo 3.1 具備更高畫質與提示詞遵循度，適合寫實場景；Kling 通常在複雜角色動作上更好。建議兩者都試試。',
                },
                {
                    question: '微鲤AI 文生影片是免費的嗎？',
                    answer: '是的，每位使用者每天都有免費點數，可用於文生影片。',
                },
                {
                    question: '可以生成超過 8 秒的影片嗎？',
                    answer: '基礎生成最長 8 秒（視模型而定）。若需要更長影片，可使用 AI 影片延長工具無縫續接。',
                },
                {
                    question: '生成的影片有聲音嗎？',
                    answer: '可以，開啟工具中的「Generate Audio」即可自動產生符合畫面的音效與環境聲。',
                },
            ],
        },
        imageToVideo: {
            title: 'AI 圖生影片生成器（免費線上）- 由 Kling、Veo 與 Sora 驅動',
            description: '使用 微鲤AI 的免費圖生影片 AI，幾秒內將靜態照片變成逼真影片。在同一個地方即可切換 Kling、Google Veo 與 Sora 2 等頂級模型。提供無浮水印選項。',
            keywords: '圖生影片, 圖片轉影片, AI 影片生成器, 圖片動畫, Sora 影片, Veo 影片, Seedance 影片, 微鲤AI 影片工具',
            og_title: 'AI 圖生影片生成器（免費線上）- 由 Kling、Veo 與 Sora 驅動',
            og_description: '使用 微鲤AI 的免費圖生影片 AI，幾秒內將靜態照片變成逼真影片。在同一個地方即可切換 Kling、Google Veo 與 Sora 2 等頂級模型。提供無浮水印選項。',
            twitter_title: 'AI 圖生影片生成器（免費線上）- 由 Kling、Veo 與 Sora 驅動',
            twitter_description: '使用 微鲤AI 的免費圖生影片 AI，幾秒內將靜態照片變成逼真影片。在同一個地方即可切換 Kling、Google Veo 與 Sora 2 等頂級模型。提供無浮水印選項。',
            page: {
                title1: '免費線上 AI 圖生影片生成器',
                faq: [
                    {
                        question: 'AI 圖生影片生成器是怎麼運作的？',
                        answer: '它會使用 Kling、Sora 等先進深度學習模型分析你的靜態圖片並預測動作軌跡，生成連貫的 MP4 影片片段。',
                    },
                    {
                        question: '微鲤AI 的圖生影片是免費的嗎？',
                        answer: '是的，我們每天提供免費點數，方便你體驗圖生影片 AI。你也可以升級以解鎖更高階的模型與更快的生成速度。',
                    },
                    {
                        question: '想要更真實的影片，該選 Kling 還是 Veo？',
                        answer: 'Kling AI 以更真實的動作與更長時長著稱，而 Google Veo 在高解析細節方面表現突出。微鲤AI 讓你一鍵切換模型，找到最合適的效果。',
                    },
                    {
                        question: '生成的影片可以商用嗎？',
                        answer: '可以。在付費方案下生成的影片包含商業授權，非常適合用於 YouTube、TikTok 與行銷廣告。',
                    },
                    {
                        question: '如何移除 AI 影片浮水印？',
                        answer: '微鲤AI 提供高品質輸出。若需無浮水印影片，請確認你的方案權益，或使用我們專用的 AI 去浮水印工具。',
                    },
                ],
            },
            faq: [
                {
                    question: 'AI 圖生影片生成器是怎麼運作的？',
                    answer: '它會使用 Kling、Sora 等先進深度學習模型分析你的靜態圖片並預測動作軌跡，生成連貫的 MP4 影片片段。',
                },
                {
                    question: '微鲤AI 的圖生影片是免費的嗎？',
                    answer: '是的，我們每天提供免費點數，方便你體驗圖生影片 AI。你也可以升級以解鎖更高階的模型與更快的生成速度。',
                },
                {
                    question: '生成的影片可以商用嗎？',
                    answer: '可以。在付費方案下生成的影片包含商業授權，非常適合用於 YouTube、TikTok 與行銷廣告。',
                },
            ],
        },
        videoToVideo: {
            title: '免費 AI 影片轉影片生成器 - 線上換風格與動漫濾鏡 | 微鲤AI',
            description: '使用 微鲤AI 的影片轉影片 AI，將你的影片變成任意風格：把真人素材變成動漫、3D 卡通或賽博龐克藝術。透過文字提示維持原始動作一致。免費且線上。',
            keywords: '影片轉影片, vid2vid, AI 影片風格遷移, 影片變動漫, AI 影片重風格, 免費 AI 影片濾鏡',
            og_title: '免費 AI 影片轉影片生成器 - 線上換風格與動漫濾鏡 | 微鲤AI',
            og_description: '使用 微鲤AI 的影片轉影片 AI，將你的影片變成任意風格：把真人素材變成動漫、3D 卡通或賽博龐克藝術。透過文字提示維持原始動作一致。免費且線上。',
            twitter_title: '免費 AI 影片轉影片生成器 - 線上換風格與動漫濾鏡 | 微鲤AI',
            twitter_description: '使用 微鲤AI 的影片轉影片 AI，將你的影片變成任意風格：把真人素材變成動漫、3D 卡通或賽博龐克藝術。透過文字提示維持原始動作一致。免費且線上。',
            page: {
                title1: '免費 AI 影片轉影片生成器（Vid2Vid）',
                title2: '上傳影片、輸入風格，看見魔法發生。微鲤AI 的影片轉影片技術會分析原片段的動作，並依照你的文字提示套用全新的藝術風格。非常適合做動漫剪輯、黏土動畫效果或超現實視覺藝術。',
                feature_title1: '動作一致性',
                feature_desc1: '不同於一般生成，我們的 Vid2Vid 引擎會鎖定原始影片的運動，確保轉場順滑、不易閃爍。',
                feature_title2: '真人變動漫',
                feature_desc2: '內容創作者首選：一鍵把自己變成動漫角色或 3D 皮克斯風格形象。',
                feature_title3: '提示詞控制',
                feature_desc3: '你擁有完整創作控制權。只要輸入「賽博龐克城市風格」或「油畫風格」，即可定義輸出視覺。',
                faq: [
                    {
                        question: '什麼是 AI 影片轉影片（Vid2Vid）？',
                        answer: '影片轉影片是一種生成式 AI 流程：以現有影片片段為輸入，依你的文字提示「重繪」成新風格，同時保留原始動作與結構。',
                    },
                    {
                        question: '我可以把影片變成動漫風格嗎？',
                        answer: '可以！這是最熱門的用途。上傳影片後輸入「日系動漫風格、吉卜力畫風」等提示詞即可轉換。',
                    },
                    {
                        question: '來源影片最長可以多長？',
                        answer: '目前為了最佳品質，較適合短片段（例如 5–10 秒）。較長影片建議分段處理。',
                    },
                    {
                        question: '它和傳統影片剪輯軟體不同嗎？',
                        answer: '是的。傳統剪輯是裁切與拼接；微鲤AI 影片轉影片會生成新像素，徹底改變素材的紋理與藝術風格。',
                    },
                    {
                        question: '需要付費嗎？',
                        answer: '微鲤AI 提供每日免費點數體驗影片轉影片；也有進階方案可獲得更快處理與無浮水印下載。',
                    },
                ],
            },
            faq: [
                {
                    question: '什麼是 AI 影片轉影片（Vid2Vid）？',
                    answer: '影片轉影片是一種生成式 AI 流程：以現有影片片段為輸入，依你的文字提示重繪成新風格，同時保留原始動作與結構。',
                },
                {
                    question: '我可以把影片變成動漫風格嗎？',
                    answer: '可以！上傳影片後輸入「日系動漫風格、吉卜力畫風」等提示詞即可轉換。',
                },
                {
                    question: '來源影片最長可以多長？',
                    answer: '較適合短片段（例如 5–10 秒）以確保品質；較長影片建議分段處理。',
                },
                {
                    question: '它和傳統影片剪輯軟體不同嗎？',
                    answer: '傳統剪輯是裁切與拼接；影片轉影片會生成新像素，改變素材的紋理與藝術風格。',
                },
                {
                    question: '需要付費嗎？',
                    answer: '提供每日免費點數；升級方案可獲得更快處理與無浮水印下載。',
                },
            ],
        },
        removeWatermark: {
            title: '免費 AI 影片去浮水印 - 在線擦除標誌與字幕 | 微鲤AI',
            description: '輕鬆移除影片中的浮水印、標誌與日期。基於 AI Inpainting 技術，無損修復背景。',
            keywords: '影片去浮水印, 擦除標誌, 字幕移除, AI 修復, 微鲤AI',
            page: {
                title1: '免費在線 AI 影片去浮水印',
                title2: '立即擦除影片中的浮水印、標誌、文字疊加和字幕。粘貼影片鏈接或上傳文件，讓我們的 AI 以像素級精度恢復背景，無損畫質。',
            },
        },
        videoFaceSwap: {
            title: '免費 AI 影片換臉在線 - 超逼真 Deepfake 製作 | 微鲤AI',
            description: '即時更換影片中的臉部。建立有趣的迷因或專業級視覺效果，高度保護隱私。',
            keywords: '影片換臉, Deepfake, 臉部替換, AI 影片編輯, 微鲤AI',
            page: {
                title1: '免費 AI 影片換臉',
                title2: '成為任何電影的主角！上傳影片剪輯和目標照片，觀看我們的 AI 無縫更換人臉。非常適合製作搞笑迷因、個性化祝福或高品質專業視覺效果。',
            },
        },
        videoLipSync: {
            title: '免費 AI 影片對口型產生器 - 影音同步工具 | 微鲤AI',
            description: '讓影片人物完美對齊音訊或文字。支援多語言配音與逼真面部肌肉調整。',
            keywords: '影片對口型, AI 配音, 唇形同步, 虛擬人說話, 微鲤AI',
        },
        translateVideoSubtitle: {
            title: '免費 AI 影片字幕翻譯 - 智慧生成並在線翻譯 | 微鲤AI',
            description: '自動識別語音並翻譯字幕。支援 90+ 語言，支援硬字幕燒錄下載。',
            keywords: '字幕翻譯, 影片翻譯, 自動字幕, AI 字幕, 微鲤AI',
        },
        videoToAnime: {
            title: '免費 AI 影片轉動漫 - 真實影片一鍵變二次元 | 微鲤AI',
            description: '將您的影片轉換為日本動漫、3D 動畫或皮克斯風格。支援逐幀穩定，畫面絲滑不閃爍。',
            keywords: 'videoToAnime, AI, 微鲤AI',
        },
        videoUpscaler: {
            title: '免費 AI 影片超解析 - 在線畫質提升至 4K | 微鲤AI',
            description: '使用頂尖 AI 技術修復模糊影片，將低解析度影片提升至 4K 清晰度。',
            keywords: 'videoUpscaler, AI, 微鲤AI',
        },
        removeVideoSubtitles: {
            title: '影片去字幕 - AI 智慧擦除影片字幕 | 微鲤AI',
            description: '智慧識別並移除影片中的硬字幕，無損修復影片內容。',
            keywords: '影片去字幕, 擦除字幕, 字幕移除, 微鲤AI',
        },
        videoBackgroundRemover: {
            title: '影片去背景 - 一鍵更換或移除影片背景 | 微鲤AI',
            description: '使用 AI 精準移除影片背景，支援一鍵更換或導出透明背景。',
            keywords: '影片去背景, 移除背景, 影片編輯, 微鲤AI',
        },
        aiVideoExtender: {
            title: '影片擴展 - AI 智慧補全影片邊框 | 微鲤AI',
            description: '使用 AI 智慧擴展影片畫面，補全缺失內容，完美適配不同比例。',
            keywords: '影片擴展, AI 補全, 影片比例調整, 微鲤AI',
        },
        videoEffects: {
            title: '影片特效 - 用 AI 創作熱門爆款影片 | 微鲤AI',
            description: '在 微鲤AI 探索熱門 AI 影片特效。從 AI 親吻到 AI 舞蹈，只需點擊幾下即可製作爆款影片。',
            keywords: '影片特效, AI 影片, 熱門影片製作, AI 親吻, AI 舞蹈, 微鲤AI',
        },
        aiDancing: {
            title: 'AI 舞蹈影片產生器 - 照片變舞蹈影片 | 微鲤AI',
            description: '使用 微鲤AI 的 AI 舞蹈影片產生器，讓任何照片跳起舞來。上傳全身照片，透過先進的姿勢估計和動作遷移技術，立即將其轉換為絲滑、逼真的舞蹈影片。',
            keywords: 'AI 舞蹈影片產生器, 照片變舞蹈影片, AI 動作遷移, 微鲤AI',
        },
        aiKissing: {
            title: 'AI 親吻影片產生器 - 讓兩張照片親親 | 微鲤AI',
            description: 'AI 親吻影片產生器 - 讓兩張照片親親 on 微鲤AI. Realistic and professional results.',
            keywords: 'aiKissing, AI, 微鲤AI',
        },
        videoMotionImitation: {
            title: '影片動作遷移 - 讓照片模仿影片動作 | 微鲤AI',
            description: '提取影片中的動作，並將其應用於靜態照片，讓照片「動起來」。',
            keywords: '動作遷移, 影片模仿, 照片變影片, 微鲤AI',
        },
    },
    pl: {
        textToMusic: {
            title: 'Generator muzyki AI - Twórz unikalną muzykę bez tantiem | 微鲤AI',
            description: 'Użyj zaawansowanej technologii AI, aby szybko tworzyć muzykę dopasowaną do projektów.',
            keywords: 'generator muzyki AI, muzyka bez tantiem, 微鲤AI',
        },
        textToVideo: {
            title: 'Darmowy generator AI tekst na wideo (Veo 3.1, Kling i Sora) | 微鲤AI',
            description: 'Zamień swoje prompty tekstowe w filmowe wideo natychmiast dzięki AI Text to Video od 微鲤AI. Zasilane przez Google Veo 3.1, Kling i Sora. Obsługuje 16:9 i 9:16, do 8 s. Dostępne opcje bez znaku wodnego.',
            keywords: 'tekst na wideo ai, generator wideo ai, google veo 3.1, prompt na wideo, kling ai, sora ai, txt2vid, 微鲤AI',
            og_title: 'Darmowy generator AI tekst na wideo (Veo 3.1, Kling i Sora) | 微鲤AI',
            og_description: 'Zamień swoje prompty tekstowe w filmowe wideo natychmiast dzięki AI Text to Video od 微鲤AI. Zasilane przez Google Veo 3.1, Kling i Sora. Obsługuje 16:9 i 9:16, do 8 s. Dostępne opcje bez znaku wodnego.',
            twitter_title: 'Darmowy generator AI tekst na wideo (Veo 3.1, Kling i Sora) | 微鲤AI',
            twitter_description: 'Zamień swoje prompty tekstowe w filmowe wideo natychmiast dzięki AI Text to Video od 微鲤AI. Zasilane przez Google Veo 3.1, Kling i Sora. Obsługuje 16:9 i 9:16, do 8 s. Dostępne opcje bez znaku wodnego.',
            page: {
                title1: 'Darmowy generator AI tekst→wideo',
                title2: 'Wpisz prompt i zobacz, jak 微鲤AI ożywia Twój pomysł. Nasz generator tekst→wideo agreguje najnowsze modele, takie jak Google Veo 3.1 i Kling AI, pozwalając tworzyć wysokiej jakości, fizycznie spójne filmy dla social mediów (9:16) lub projektów kinowych (16:9) w kilka sekund.',
                intro_title: 'Zamień wyobraźnię w rzeczywistość dzięki AI tekst→wideo',
                feature_title: 'Funkcje 微鲤AI tekst→wideo',
                faq_title: 'Najczęstsze pytania o tekst→wideo',
                feature_title1: 'Moc wielu modeli',
                feature_desc1: 'Przełączaj się między Veo 3.1 dla realizmu a Kling dla spójności ruchu. Bez wielu subskrypcji.',
                feature_title2: 'Niestandardowe proporcje',
                feature_desc2: 'Generuj pionowe wideo (9:16) na TikToka/Reels lub szeroki kadr (16:9) na YouTube bezpośrednio.',
                feature_title3: 'Wydłużony czas',
                feature_desc3: 'Twórz filmy do 8 sekund (lub dłuższe z rozszerzeniami) w jednym generowaniu — idealne do opowiadania historii.',
                faq: [
                    {
                        question: 'Jak napisać dobry prompt do AI tekst→wideo?',
                        answer: 'Bądź konkretny: opisz temat, akcję, światło i kąt kamery. Np.: "Filmowe ujęcie dronem futurystycznego miasta cyberpunkowego nocą, neony, 4K". Zintegrowane modele 微鲤AI dobrze rozumieją złożone opisy.',
                    },
                    {
                        question: 'Który model wybrać: Google Veo 3.1 czy Kling?',
                        answer: 'Veo 3.1 zapewnia świetną jakość obrazu i zgodność z promptem, idealny do realistycznych scen. Kling AI często lepiej radzi sobie z złożonym ruchem postaci. Warto przetestować oba.',
                    },
                    {
                        question: 'Czy 微鲤AI tekst→wideo jest darmowe?',
                        answer: 'Tak, każdy użytkownik otrzymuje codzienne darmowe kredyty na generowanie wideo z tekstu. Możesz tworzyć wiele klipów, aby testować różne prompty i modele.',
                    },
                    {
                        question: 'Czy mogę generować filmy dłuższe niż 8 sekund?',
                        answer: 'Podstawowa generacja tworzy klipy do 8 s (zależnie od modelu). Aby uzyskać dłuższe wideo, użyj narzędzia AI Video Extender, które płynnie kontynuuje ujęcie.',
                    },
                    {
                        question: 'Czy wygenerowane wideo ma dźwięk?',
                        answer: 'Tak, możesz włączyć przełącznik "Generate Audio" (w narzędziu), aby automatycznie tworzyć pasujące efekty dźwiękowe i tło.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Jak napisać dobry prompt do AI tekst→wideo?',
                    answer: 'Bądź konkretny: opisz temat, akcję, światło i kąt kamery. Np.: "Filmowe ujęcie dronem futurystycznego miasta cyberpunkowego nocą, neony, 4K". Zintegrowane modele 微鲤AI dobrze rozumieją złożone opisy.',
                },
                {
                    question: 'Który model wybrać: Google Veo 3.1 czy Kling?',
                    answer: 'Veo 3.1 zapewnia świetną jakość obrazu i zgodność z promptem, idealny do realistycznych scen. Kling AI często lepiej radzi sobie z złożonym ruchem postaci. Warto przetestować oba.',
                },
                {
                    question: 'Czy 微鲤AI tekst→wideo jest darmowe?',
                    answer: 'Tak, każdy użytkownik otrzymuje codzienne darmowe kredyty na generowanie wideo z tekstu. Możesz tworzyć wiele klipów, aby testować różne prompty i modele.',
                },
                {
                    question: 'Czy mogę generować filmy dłuższe niż 8 sekund?',
                    answer: 'Podstawowa generacja tworzy klipy do 8 s (zależnie od modelu). Aby uzyskać dłuższe wideo, użyj narzędzia AI Video Extender, które płynnie kontynuuje ujęcie.',
                },
                {
                    question: 'Czy wygenerowane wideo ma dźwięk?',
                    answer: 'Tak, możesz włączyć przełącznik "Generate Audio" (w narzędziu), aby automatycznie tworzyć pasujące efekty dźwiękowe i tło.',
                },
            ],
        },
        imageToVideo: {
            title: 'Generator AI Obraz→Wideo (Darmowy i Online) - Zasilany przez Kling, Veo i Sora',
            description: 'Zamień statyczne zdjęcia w realistyczne wideo w kilka sekund dzięki darmowemu AI obraz→wideo od 微鲤AI. Korzystaj z topowych modeli, takich jak Kling, Google Veo i Sora 2 w jednym miejscu. Dostępne opcje bez znaku wodnego.',
            keywords: 'obraz na wideo AI, generator wideo AI, animacja obrazu, wideo Sora, wideo Veo, wideo Seedance, narzędzia wideo 微鲤AI',
            og_title: 'Generator AI Obraz→Wideo (Darmowy i Online) - Zasilany przez Kling, Veo i Sora',
            og_description: 'Zamień statyczne zdjęcia w realistyczne wideo w kilka sekund dzięki darmowemu AI obraz→wideo od 微鲤AI. Korzystaj z topowych modeli, takich jak Kling, Google Veo i Sora 2 w jednym miejscu. Dostępne opcje bez znaku wodnego.',
            twitter_title: 'Generator AI Obraz→Wideo (Darmowy i Online) - Zasilany przez Kling, Veo i Sora',
            twitter_description: 'Zamień statyczne zdjęcia w realistyczne wideo w kilka sekund dzięki darmowemu AI obraz→wideo od 微鲤AI. Korzystaj z topowych modeli, takich jak Kling, Google Veo i Sora 2 w jednym miejscu. Dostępne opcje bez znaku wodnego.',
            page: {
                title1: 'Darmowy internetowy generator AI obraz→wideo',
                faq: [
                    {
                        question: 'Jak działa generator AI obraz→wideo?',
                        answer: 'Wykorzystuje zaawansowane modele deep learning, takie jak Kling i Sora, aby analizować statyczny obraz i przewidywać ruch, generując spójny klip wideo w formacie MP4.',
                    },
                    {
                        question: 'Czy 微鲤AI obraz→wideo jest darmowe?',
                        answer: 'Tak, oferujemy codzienne darmowe kredyty, aby wypróbować nasze AI obraz→wideo. Możesz też przejść na plan premium, aby uzyskać lepsze modele i szybsze generowanie.',
                    },
                    {
                        question: 'Który model daje bardziej realistyczne wideo: Kling czy Veo?',
                        answer: 'Kling AI słynie z realistycznego ruchu i dłuższego czasu trwania, a Google Veo wyróżnia się detalami w wysokiej rozdzielczości. W 微鲤AI możesz przełączać modele i wybrać najlepszy.',
                    },
                    {
                        question: 'Czy mogę używać wygenerowanych wideo komercyjnie?',
                        answer: 'Tak, wideo generowane w ramach płatnych planów mają licencję komercyjną — idealne na YouTube, TikTok i reklamy marketingowe.',
                    },
                    {
                        question: 'Jak usunąć znaki wodne z wideo AI?',
                        answer: '微鲤AI zapewnia wysoką jakość wyjścia. Aby uzyskać wideo bez znaku wodnego, sprawdź szczegóły planu lub użyj naszego narzędzia AI Watermark Remover.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Jak działa generator AI obraz→wideo?',
                    answer: 'Wykorzystuje zaawansowane modele deep learning, takie jak Kling i Sora, aby analizować statyczny obraz i przewidywać ruch, generując spójny klip wideo w formacie MP4.',
                },
                {
                    question: 'Czy 微鲤AI obraz→wideo jest darmowe?',
                    answer: 'Tak, oferujemy codzienne darmowe kredyty, aby wypróbować nasze AI obraz→wideo. Możesz też przejść na plan premium, aby uzyskać lepsze modele i szybsze generowanie.',
                },
                {
                    question: 'Czy mogę używać wygenerowanych wideo komercyjnie?',
                    answer: 'Tak, wideo generowane w ramach płatnych planów mają licencję komercyjną — idealne na YouTube, TikTok i reklamy marketingowe.',
                },
            ],
        },
        videoToVideo: {
            title: 'Darmowy generator AI wideo→wideo - Zmiana stylu i filtr anime online | 微鲤AI',
            description: 'Przekształcaj swoje filmy w dowolny styl dzięki 微鲤AI Video to Video AI. Zmieniaj materiały na anime, kreskówkę 3D lub cyberpunk za pomocą promptów tekstowych, zachowując spójny ruch. Za darmo i online.',
            keywords: 'wideo na wideo ai, vid2vid, transfer stylu wideo ai, zamień wideo w anime, restylizacja wideo ai, darmowy filtr wideo ai',
            og_title: 'Darmowy generator AI wideo→wideo - Zmiana stylu i filtr anime online | 微鲤AI',
            og_description: 'Przekształcaj swoje filmy w dowolny styl dzięki 微鲤AI Video to Video AI. Zmieniaj materiały na anime, kreskówkę 3D lub cyberpunk za pomocą promptów tekstowych, zachowując spójny ruch. Za darmo i online.',
            twitter_title: 'Darmowy generator AI wideo→wideo - Zmiana stylu i filtr anime online | 微鲤AI',
            twitter_description: 'Przekształcaj swoje filmy w dowolny styl dzięki 微鲤AI Video to Video AI. Zmieniaj materiały na anime, kreskówkę 3D lub cyberpunk za pomocą promptów tekstowych, zachowując spójny ruch. Za darmo i online.',
            page: {
                title1: 'Darmowy generator AI wideo→wideo (Vid2Vid)',
                title2: 'Prześlij wideo, wpisz styl i zobacz magię. Technologia 微鲤AI Video to Video analizuje ruch z materiału źródłowego i nakłada zupełnie nowy styl na podstawie Twojego promptu. Idealne do anime editów, efektu plasteliny lub surrealistycznej sztuki.',
                feature_title1: 'Spójny ruch',
                feature_desc1: 'W przeciwieństwie do zwykłej generacji nasz silnik Vid2Vid śledzi ruch w źródłowym wideo, zapewniając płynne przejścia bez migotania.',
                feature_title2: 'Real → Anime',
                feature_desc2: 'Narzędzie nr 1 dla twórców. Zmień się w postać anime lub w avatara 3D w stylu Pixara.',
                feature_title3: 'Kontrola promptu',
                feature_desc3: 'Masz pełną kontrolę twórczą. Wpisz np. "styl cyberpunkowego miasta" lub "styl malarstwa olejnego", aby zdefiniować wygląd wyjścia.',
                faq: [
                    {
                        question: 'Czym jest AI Video to Video (Vid2Vid)?',
                        answer: 'Video to Video to proces generatywnej AI, który bierze istniejący klip jako wejście i "przemalowuje" go na nowy styl opisany w promptcie, zachowując oryginalny ruch i strukturę.',
                    },
                    {
                        question: 'Czy mogę zamienić wideo w styl anime?',
                        answer: 'Tak! To najpopularniejsze zastosowanie. Prześlij wideo i wpisz prompty typu "japoński styl anime, Studio Ghibli", aby je przekształcić.',
                    },
                    {
                        question: 'Jak długi może być film źródłowy?',
                        answer: 'Obecnie najlepiej sprawdzają się krótkie klipy (np. 5–10 sekund), aby zapewnić najwyższą jakość transferu stylu. Dłuższe filmy warto dzielić na segmenty.',
                    },
                    {
                        question: 'Czy to różni się od edytora wideo?',
                        answer: 'Tak. Tradycyjny edytor tnie i przycina klipy. 微鲤AI Video to Video generuje nowe piksele, całkowicie zmieniając teksturę i styl artystyczny materiału.',
                    },
                    {
                        question: 'Czy to kosztuje?',
                        answer: '微鲤AI oferuje darmowe dzienne kredyty na wypróbowanie Video to Video. Dostępne są też plany premium z szybszym przetwarzaniem i pobraniami bez znaku wodnego.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Czym jest AI Video to Video (Vid2Vid)?',
                    answer: 'Video to Video to proces generatywnej AI, który bierze istniejący klip i "przemalowuje" go na nowy styl zgodnie z promptem, zachowując ruch i strukturę.',
                },
                {
                    question: 'Czy mogę zamienić wideo w styl anime?',
                    answer: 'Tak! Prześlij wideo i użyj promptów typu "japoński styl anime, Studio Ghibli".',
                },
                {
                    question: 'Jak długi może być film źródłowy?',
                    answer: 'Najlepiej sprawdzają się krótkie klipy (np. 5–10 sekund); dłuższe filmy warto dzielić.',
                },
                {
                    question: 'Czy to różni się od edytora wideo?',
                    answer: 'Tradycyjny edytor tnie i przycina, a Video to Video generuje nowe piksele i zmienia styl materiału.',
                },
                {
                    question: 'Czy to kosztuje?',
                    answer: 'Dostępne są darmowe dzienne kredyty; plany premium oferują szybsze przetwarzanie i pobrania bez znaku wodnego.',
                },
            ],
        },
        removeWatermark: {
            title: 'Usuwanie znaku wodnego z wideo AI - Usuń logo i napisy | 微鲤AI',
            description: 'Łatwo usuwaj znaki wodne, logo i daty z filmów za pomocą technologii AI Inpainting.',
            keywords: 'usuwanie znaku wodnego, usuń logo, edycja wideo AI, 微鲤AI',
            page: {
                title1: 'Darmowe usuwanie znaku wodnego AI online',
                title2: 'Natychmiast usuwaj znaki wodne, logo, nakładki tekstowe i napisy ze swoich filmów. Wklej link lub prześlij plik, a nasza AI przywróci tło z precyzją co do piksela.',
            },
        },
        videoFaceSwap: {
            title: 'Podmiana twarzy w wideo AI online - Realistyczne Deepfake | 微鲤AI',
            description: 'Zmieniaj twarze w filmach natychmiastowo. Twórz zabawne memy lub profesjonalne efekty.',
            keywords: 'podmiana twarzy, deepfake, edytor wideo AI, 微鲤AI',
            page: {
                title1: 'Darmowa podmiana twarzy w wideo AI',
                title2: 'Zostań gwiazdą dowolnego filmu! Prześlij klip wideo i zdjęcie docelowe, a nasza AI bezproblemowo zamieni twarze. Idealne do tworzenia memów i spersonalizowanych życzeń.',
            },
        },
        videoLipSync: {
            title: 'Synchronizacja ust wideo AI - Synchronizacja głosu i twarzy | 微鲤AI',
            description: 'Dopasuj ruchy ust do dowolnego dźwięku lub tekstu. Twórz mówiące postacie.',
            keywords: 'synchronizacja ust, lip sync AI, dubbing AI, 微鲤AI',
        },
        translateVideoSubtitle: {
            title: 'Tłumaczenie napisów wideo AI - Automatyczne tłumaczenie | 微鲤AI',
            description: 'Automatycznie rozpoznawaj i tłumacz napisy w filmach na ponad 90 języków.',
            keywords: 'tłumaczenie napisów, tłumacz wideo, napisy AI, 微鲤AI',
        },
        videoToAnime: {
            title: 'Wideo na Anime AI - Zmień film w styl animowany | 微鲤AI',
            description: 'Przekształć swoje filmy w styl anime, 3D lub Pixar jednym kliknięciem.',
            keywords: 'wideo na anime, styl anime AI, konwersja wideo, 微鲤AI',
        },
        videoUpscaler: {
            title: 'Skalowanie wideo AI - Zwiększ jakość do 4K | 微鲤AI',
            description: 'Napraw rozmyte filmy i zwiększ ich rozdzielczość do 4K za pomocą zaawansowanej AI.',
            keywords: 'skalowanie wideo, jakość 4K, ulepszanie wideo, 微鲤AI',
        },
        removeVideoSubtitles: {
            title: 'Usuwanie napisów z wideo - Inteligentne usuwanie AI | 微鲤AI',
            description: 'Inteligentnie rozpoznawaj i usuwaj napisy z wideo bez utraty jakości.',
            keywords: 'usuwanie napisów, wymazywanie tekstu, 微鲤AI',
        },
        videoBackgroundRemover: {
            title: 'Usuwanie tła z wideo - Zmień lub usuń tło jednym kliknięciem | 微鲤AI',
            description: 'Użyj AI, aby precyzyjnie usunąć tło z wideo lub wyeksportować przezroczyste tło.',
            keywords: 'usuwanie tła, edycja wideo, 微鲤AI',
        },
        aiVideoExtender: {
            title: 'Rozszerzanie wideo - Inteligentne uzupełnianie klatek AI | 微鲤AI',
            description: 'Użyj AI, aby inteligentnie rozszerzyć klatki wideo i dopasować proporcje.',
            keywords: 'rozszerzanie wideo, uzupełnianie AI, proporcje wideo, 微鲤AI',
        },
        videoEffects: {
            title: 'Efekty wideo - Twórz viralowe filmy z AI | 微鲤AI',
            description: 'Odkryj popularne efekty wideo AI na 微鲤AI. Od AI Kissing po AI Dancing, twórz viralowe filmy kilkoma kliknięciami.',
            keywords: 'efekty wideo AI, viralowe wideo, 微鲤AI',
        },
        aiDancing: {
            title: 'Generator wideo tańca AI | Kreator wideo z tańcem ze zdjęć | 微鲤AI',
            description: 'Twórz filmy z tańcem z dowolnego zdjęcia za pomocą generatora wideo tańca AI 微鲤AI.',
            keywords: 'generator wideo tańca AI, zdjęcie do wideo z tańcem, 微鲤AI',
        },
        aiKissing: {
            title: 'Generator wideo pocałunku AI - Spraw, by dwa zdjęcia się pocałowały | 微鲤AI',
            description: 'Generator wideo pocałunku AI - Spraw, by dwa zdjęcia się pocałowały on 微鲤AI. Realistic and professional results.',
            keywords: 'aiKissing, AI, 微鲤AI',
        },
        videoMotionImitation: {
            title: 'Imitacja ruchu wideo - Zdjęcia naśladujące ruchy z filmu | 微鲤AI',
            description: 'Wyodrębnij ruch z wideo i zastosuj go do zdjęć, aby je ożywić.',
            keywords: 'imitacja ruchu, zdjęcie na film, 微鲤AI',
        },
    },
    th: {
        textToMusic: {
            title: 'เครื่องมือสร้างเพลง AI - สร้างเพลงเฉพาะตัวที่ไม่มีค่าลิขสิทธิ์ | 微鲤AI',
            description: 'ใช้เทคโนโลยี AI ขั้นสูงเพื่อสร้างเพลงที่ไม่มีค่าลิขสิทธิ์อย่างรวดเร็ว เหมาะสำหรับโปรเจกต์ของคุณ',
            keywords: 'เครื่องมือสร้างเพลง AI, เพลงไม่มีค่าลิขสิทธิ์, 微鲤AI',
        },
        textToVideo: {
            title: 'เครื่องมือสร้างวิดีโอจากข้อความด้วย AI ฟรี (Veo 3.1, Kling & Sora) | 微鲤AI',
            description: 'แปลงข้อความให้เป็นวิดีโอสไตล์ภาพยนตร์ได้ทันทีด้วย AI ข้อความเป็นวิดีโอของ 微鲤AI ขับเคลื่อนโดย Google Veo 3.1, Kling และ Sora รองรับ 16:9 และ 9:16 สูงสุด 8 วินาที พร้อมตัวเลือกแบบไม่มีลายน้ำ',
            keywords: 'ข้อความเป็นวิดีโอ ai, เครื่องมือสร้างวิดีโอ ai, google veo 3.1, prompt เป็นวิดีโอ, kling ai, sora, txt2vid, 微鲤AI',
            og_title: 'เครื่องมือสร้างวิดีโอจากข้อความด้วย AI ฟรี (Veo 3.1, Kling & Sora) | 微鲤AI',
            og_description: 'แปลงข้อความให้เป็นวิดีโอสไตล์ภาพยนตร์ได้ทันทีด้วย AI ข้อความเป็นวิดีโอของ 微鲤AI ขับเคลื่อนโดย Google Veo 3.1, Kling และ Sora รองรับ 16:9 และ 9:16 สูงสุด 8 วินาที พร้อมตัวเลือกแบบไม่มีลายน้ำ',
            twitter_title: 'เครื่องมือสร้างวิดีโอจากข้อความด้วย AI ฟรี (Veo 3.1, Kling & Sora) | 微鲤AI',
            twitter_description: 'แปลงข้อความให้เป็นวิดีโอสไตล์ภาพยนตร์ได้ทันทีด้วย AI ข้อความเป็นวิดีโอของ 微鲤AI ขับเคลื่อนโดย Google Veo 3.1, Kling และ Sora รองรับ 16:9 และ 9:16 สูงสุด 8 วินาที พร้อมตัวเลือกแบบไม่มีลายน้ำ',
            page: {
                title1: 'เครื่องมือสร้างวิดีโอจากข้อความด้วย AI ฟรี',
                title2: 'เพียงพิมพ์พรอมต์ แล้ว 微鲤AI จะทำให้ไอเดียของคุณมีชีวิต เครื่องมือข้อความเป็นวิดีโอของเรารวมโมเดลล้ำสมัยอย่าง Google Veo 3.1 และ Kling AI ให้คุณสร้างวิดีโอคุณภาพสูงที่สมจริงทางกายภาพสำหรับโซเชียลมีเดียแนวตั้ง (9:16) หรือโปรเจกต์แบบภาพยนตร์ (16:9) ได้ภายในไม่กี่วินาที',
                intro_title: 'เปลี่ยนจินตนาการให้เป็นจริงด้วย AI ข้อความเป็นวิดีโอ',
                feature_title: 'ฟีเจอร์ของ 微鲤AI ข้อความเป็นวิดีโอ',
                faq_title: 'คำถามที่พบบ่อยเกี่ยวกับข้อความเป็นวิดีโอ',
                feature_title1: 'พลังหลายโมเดล',
                feature_desc1: 'สลับระหว่าง Veo 3.1 เพื่อความสมจริง และ Kling เพื่อความต่อเนื่องของการเคลื่อนไหว ไม่ต้องสมัครหลายบริการ',
                feature_title2: 'อัตราส่วนภาพตามต้องการ',
                feature_desc2: 'สร้างวิดีโอแนวตั้ง (9:16) สำหรับ TikTok/Reels หรือแนวนอน (16:9) สำหรับ YouTube ได้ทันที',
                feature_title3: 'ความยาววิดีโอมากขึ้น',
                feature_desc3: 'สร้างวิดีโอได้สูงสุด 8 วินาที (หรือยาวกว่านั้นด้วยเครื่องมือขยาย) ในการสร้างครั้งเดียว เหมาะกับการเล่าเรื่อง',
                faq: [
                    {
                        question: 'จะเขียนพรอมต์ให้ดีสำหรับ AI ข้อความเป็นวิดีโอได้อย่างไร?',
                        answer: 'ระบุให้ชัดเจนทั้งตัวแบบ การกระทำ แสง และมุมกล้อง เช่น "ภาพโดรนสไตล์ภาพยนตร์ของเมืองไซเบอร์พังก์ในตอนกลางคืน แสงนีออน ความละเอียด 4K" โมเดลที่รวมใน 微鲤AI เข้าใจคำบรรยายที่ซับซ้อนได้ดี',
                    },
                    {
                        question: 'ควรใช้โมเดลไหน: Google Veo 3.1 หรือ Kling?',
                        answer: 'Veo 3.1 ให้ความคมชัดสูงและตรงตามพรอมต์ เหมาะกับฉากสมจริง ส่วน Kling มักทำได้ดีกว่าสำหรับการเคลื่อนไหวตัวละครที่ซับซ้อน แนะนำให้ลองทั้งสองแบบ',
                    },
                    {
                        question: '微鲤AI ข้อความเป็นวิดีโอใช้ฟรีไหม?',
                        answer: 'ใช่ ผู้ใช้ทุกคนได้รับเครดิตฟรีรายวันสำหรับสร้างวิดีโอจากข้อความ คุณสามารถสร้างหลายคลิปเพื่อทดสอบพรอมต์และโมเดลต่างๆ ได้',
                    },
                    {
                        question: 'สามารถสร้างวิดีโอที่ยาวกว่า 8 วินาทีได้ไหม?',
                        answer: 'การสร้างพื้นฐานทำได้สูงสุด 8 วินาที (ขึ้นอยู่กับโมเดล) หากต้องการวิดีโอยาวขึ้น สามารถใช้เครื่องมือ AI Video Extender เพื่อขยายต่อเนื่องได้',
                    },
                    {
                        question: 'วิดีโอที่สร้างมีเสียงไหม?',
                        answer: 'มี คุณสามารถเปิดสวิตช์ "Generate Audio" (ในเครื่องมือ) เพื่อให้ระบบสร้างเอฟเฟกต์เสียงและบรรยากาศที่เข้ากันโดยอัตโนมัติ',
                    },
                ],
            },
            faq: [
                {
                    question: 'จะเขียนพรอมต์ให้ดีสำหรับ AI ข้อความเป็นวิดีโอได้อย่างไร?',
                    answer: 'ระบุให้ชัดเจนทั้งตัวแบบ การกระทำ แสง และมุมกล้อง เช่น "ภาพโดรนสไตล์ภาพยนตร์ของเมืองไซเบอร์พังก์ในตอนกลางคืน แสงนีออน ความละเอียด 4K" โมเดลที่รวมใน 微鲤AI เข้าใจคำบรรยายที่ซับซ้อนได้ดี',
                },
                {
                    question: 'ควรใช้โมเดลไหน: Google Veo 3.1 หรือ Kling?',
                    answer: 'Veo 3.1 ให้ความคมชัดสูงและตรงตามพรอมต์ เหมาะกับฉากสมจริง ส่วน Kling มักทำได้ดีกว่าสำหรับการเคลื่อนไหวตัวละครที่ซับซ้อน แนะนำให้ลองทั้งสองแบบ',
                },
                {
                    question: '微鲤AI ข้อความเป็นวิดีโอใช้ฟรีไหม?',
                    answer: 'ใช่ ผู้ใช้ทุกคนได้รับเครดิตฟรีรายวันสำหรับสร้างวิดีโอจากข้อความ คุณสามารถสร้างหลายคลิปเพื่อทดสอบพรอมต์และโมเดลต่างๆ ได้',
                },
                {
                    question: 'สามารถสร้างวิดีโอที่ยาวกว่า 8 วินาทีได้ไหม?',
                    answer: 'การสร้างพื้นฐานทำได้สูงสุด 8 วินาที (ขึ้นอยู่กับโมเดล) หากต้องการวิดีโอยาวขึ้น สามารถใช้เครื่องมือ AI Video Extender เพื่อขยายต่อเนื่องได้',
                },
                {
                    question: 'วิดีโอที่สร้างมีเสียงไหม?',
                    answer: 'มี คุณสามารถเปิดสวิตช์ "Generate Audio" (ในเครื่องมือ) เพื่อให้ระบบสร้างเอฟเฟกต์เสียงและบรรยากาศที่เข้ากันโดยอัตโนมัติ',
                },
            ],
        },
        imageToVideo: {
            title: 'เครื่องมือแปลงภาพเป็นวิดีโอด้วย AI (ฟรีและออนไลน์) - ขับเคลื่อนโดย Kling, Veo และ Sora',
            description: 'เปลี่ยนภาพนิ่งให้เป็นวิดีโอสมจริงในไม่กี่วินาทีด้วย AI ภาพเป็นวิดีโอฟรีของ 微鲤AI ใช้งานโมเดลชั้นนำอย่าง Kling, Google Veo และ Sora 2 ในที่เดียว มีตัวเลือกแบบไม่มีลายน้ำ',
            keywords: 'ภาพเป็นวิดีโอ AI, เครื่องสร้างวิดีโอ AI, แอนิเมชันภาพ, วิดีโอ Sora, วิดีโอ Veo, วิดีโอ Seedance, เครื่องมือวิดีโอ 微鲤AI',
            og_title: 'เครื่องมือแปลงภาพเป็นวิดีโอด้วย AI (ฟรีและออนไลน์) - ขับเคลื่อนโดย Kling, Veo และ Sora',
            og_description: 'เปลี่ยนภาพนิ่งให้เป็นวิดีโอสมจริงในไม่กี่วินาทีด้วย AI ภาพเป็นวิดีโอฟรีของ 微鲤AI ใช้งานโมเดลชั้นนำอย่าง Kling, Google Veo และ Sora 2 ในที่เดียว มีตัวเลือกแบบไม่มีลายน้ำ',
            twitter_title: 'เครื่องมือแปลงภาพเป็นวิดีโอด้วย AI (ฟรีและออนไลน์) - ขับเคลื่อนโดย Kling, Veo และ Sora',
            twitter_description: 'เปลี่ยนภาพนิ่งให้เป็นวิดีโอสมจริงในไม่กี่วินาทีด้วย AI ภาพเป็นวิดีโอฟรีของ 微鲤AI ใช้งานโมเดลชั้นนำอย่าง Kling, Google Veo และ Sora 2 ในที่เดียว มีตัวเลือกแบบไม่มีลายน้ำ',
            page: {
                title1: 'เครื่องมือแปลงภาพเป็นวิดีโอด้วย AI ฟรีออนไลน์',
                faq: [
                    {
                        question: 'เครื่องมือ AI ภาพเป็นวิดีโอทำงานอย่างไร?',
                        answer: 'ใช้โมเดลดีปเลิร์นนิงขั้นสูงอย่าง Kling และ Sora วิเคราะห์ภาพนิ่งและคาดการณ์การเคลื่อนไหว เพื่อสร้างคลิปวิดีโอ MP4 ที่ต่อเนื่อง',
                    },
                    {
                        question: '微鲤AI ภาพเป็นวิดีโอใช้ฟรีไหม?',
                        answer: 'ใช่ เรามีเครดิตฟรีรายวันให้ลองใช้ AI ภาพเป็นวิดีโอ คุณสามารถอัปเกรดเพื่อใช้โมเดลพรีเมียมและความเร็วที่สูงขึ้น',
                    },
                    {
                        question: 'อยากได้วิดีโอสมจริง ควรเลือก Kling หรือ Veo?',
                        answer: 'Kling AI เด่นด้านการเคลื่อนไหวสมจริงและความยาวที่มากกว่า ส่วน Google Veo เด่นด้านรายละเอียดความคมชัดสูง 微鲤AI ให้สลับโมเดลเพื่อเลือกสิ่งที่เหมาะที่สุด',
                    },
                    {
                        question: 'สามารถใช้วิดีโอที่สร้างเชิงพาณิชย์ได้ไหม?',
                        answer: 'ได้ วิดีโอที่สร้างในแพ็กเกจแบบชำระเงินมาพร้อมสิทธิ์เชิงพาณิชย์ เหมาะสำหรับ YouTube, TikTok และโฆษณาการตลาด',
                    },
                    {
                        question: 'ลบลายน้ำจากวิดีโอ AI ได้อย่างไร?',
                        answer: '微鲤AI ให้ผลลัพธ์คุณภาพสูง หากต้องการวิดีโอแบบไม่มีลายน้ำ โปรดตรวจสอบสิทธิ์ในแพ็กเกจของคุณหรือใช้เครื่องมือ AI Watermark Remover ของเรา',
                    },
                ],
            },
            faq: [
                {
                    question: 'เครื่องมือ AI ภาพเป็นวิดีโอทำงานอย่างไร?',
                    answer: 'ใช้โมเดลดีปเลิร์นนิงขั้นสูงอย่าง Kling และ Sora วิเคราะห์ภาพนิ่งและคาดการณ์การเคลื่อนไหว เพื่อสร้างคลิปวิดีโอ MP4 ที่ต่อเนื่อง',
                },
                {
                    question: '微鲤AI ภาพเป็นวิดีโอใช้ฟรีไหม?',
                    answer: 'ใช่ เรามีเครดิตฟรีรายวันให้ลองใช้ AI ภาพเป็นวิดีโอ คุณสามารถอัปเกรดเพื่อใช้โมเดลพรีเมียมและความเร็วที่สูงขึ้น',
                },
                {
                    question: 'สามารถใช้วิดีโอที่สร้างเชิงพาณิชย์ได้ไหม?',
                    answer: 'ได้ วิดีโอที่สร้างในแพ็กเกจแบบชำระเงินมาพร้อมสิทธิ์เชิงพาณิชย์ เหมาะสำหรับ YouTube, TikTok และโฆษณาการตลาด',
                },
            ],
        },
        videoToVideo: {
            title: 'เครื่องมือสร้างวิดีโอเป็นวิดีโอด้วย AI ฟรี - เปลี่ยนสไตล์และฟิลเตอร์อนิเมะออนไลน์ | 微鲤AI',
            description: 'แปลงวิดีโอของคุณเป็นสไตล์ใดก็ได้ด้วย Video to Video AI ของ 微鲤AI เปลี่ยนฟุตเทจจริงเป็นอนิเมะ การ์ตูน 3D หรือไซเบอร์พังก์ด้วยพรอมต์ข้อความ พร้อมคงการเคลื่อนไหวเดิม ฟรีและออนไลน์',
            keywords: 'วิดีโอเป็นวิดีโอ ai, vid2vid, การถ่ายโอนสไตล์วิดีโอ ai, แปลงวิดีโอเป็นอนิเมะ, รีสไตล์วิดีโอ ai, ฟิลเตอร์วิดีโอ ai ฟรี',
            og_title: 'เครื่องมือสร้างวิดีโอเป็นวิดีโอด้วย AI ฟรี - เปลี่ยนสไตล์และฟิลเตอร์อนิเมะออนไลน์ | 微鲤AI',
            og_description: 'แปลงวิดีโอของคุณเป็นสไตล์ใดก็ได้ด้วย Video to Video AI ของ 微鲤AI เปลี่ยนฟุตเทจจริงเป็นอนิเมะ การ์ตูน 3D หรือไซเบอร์พังก์ด้วยพรอมต์ข้อความ พร้อมคงการเคลื่อนไหวเดิม ฟรีและออนไลน์',
            twitter_title: 'เครื่องมือสร้างวิดีโอเป็นวิดีโอด้วย AI ฟรี - เปลี่ยนสไตล์และฟิลเตอร์อนิเมะออนไลน์ | 微鲤AI',
            twitter_description: 'แปลงวิดีโอของคุณเป็นสไตล์ใดก็ได้ด้วย Video to Video AI ของ 微鲤AI เปลี่ยนฟุตเทจจริงเป็นอนิเมะ การ์ตูน 3D หรือไซเบอร์พังก์ด้วยพรอมต์ข้อความ พร้อมคงการเคลื่อนไหวเดิม ฟรีและออนไลน์',
            page: {
                title1: 'เครื่องมือสร้างวิดีโอเป็นวิดีโอด้วย AI ฟรี (Vid2Vid)',
                title2: 'อัปโหลดวิดีโอ พิมพ์สไตล์ แล้วดูเวทมนตร์เกิดขึ้น เทคโนโลยี Video to Video ของ 微鲤AI จะวิเคราะห์การเคลื่อนไหวจากวิดีโอต้นฉบับ และใส่สไตล์ศิลปะใหม่ตามพรอมต์ของคุณ เหมาะสำหรับทำคลิปอนิเมะ เอฟเฟกต์สต็อปโมชัน หรือศิลปะแนวเหนือจริง',
                feature_title1: 'การเคลื่อนไหวสม่ำเสมอ',
                feature_desc1: 'ต่างจากการสร้างทั่วไป เอนจิน Vid2Vid ของเรายึดการเคลื่อนไหวจากวิดีโอต้นฉบับ ทำให้การเปลี่ยนเฟรมลื่นไหลและไม่กะพริบ',
                feature_title2: 'จากของจริงเป็นอนิเมะ',
                feature_desc2: 'เครื่องมือยอดนิยมสำหรับครีเอเตอร์ เปลี่ยนตัวคุณให้เป็นตัวละครอนิเมะหรืออวตาร 3D สไตล์พิกซาร์ได้ทันที',
                feature_title3: 'ควบคุมด้วยพรอมต์',
                feature_desc3: 'คุณควบคุมงานสร้างสรรค์ได้เต็มที่ แค่พิมพ์ “สไตล์เมืองไซเบอร์พังก์” หรือ “สไตล์ภาพสีน้ำมัน” ก็ได้ลุคที่ต้องการ',
                faq: [
                    {
                        question: 'AI วิดีโอเป็นวิดีโอ (Vid2Vid) คืออะไร?',
                        answer: 'Video to Video คือกระบวนการ AI เชิงสร้างสรรค์ที่ใช้คลิปวิดีโอเดิมเป็นอินพุต แล้ว “วาดใหม่” ให้เป็นสไตล์ตามพรอมต์ พร้อมคงการเคลื่อนไหวและโครงสร้างเดิม',
                    },
                    {
                        question: 'สามารถเปลี่ยนวิดีโอเป็นสไตล์อนิเมะได้ไหม?',
                        answer: 'ได้! นี่คือการใช้งานยอดนิยม เพียงอัปโหลดวิดีโอและใส่พรอมต์ เช่น “อนิเมะญี่ปุ่น, สไตล์สตูดิโอจิบลิ”',
                    },
                    {
                        question: 'วิดีโอต้นฉบับยาวได้เท่าไร?',
                        answer: 'ปัจจุบันเหมาะกับคลิปสั้น (เช่น 5–10 วินาที) เพื่อคุณภาพการถ่ายโอนสไตล์สูงสุด สำหรับวิดีโอยาว แนะนำแบ่งเป็นช่วง',
                    },
                    {
                        question: 'ต่างจากโปรแกรมตัดต่อวิดีโออย่างไร?',
                        answer: 'ต่างกัน โปรแกรมตัดต่อแบบเดิมคือการตัดและเรียงคลิป ส่วน 微鲤AI Video to Video จะสร้างพิกเซลใหม่และเปลี่ยนสไตล์ศิลป์ของฟุตเทจทั้งหมด',
                    },
                    {
                        question: 'ต้องเสียเงินไหม?',
                        answer: '微鲤AI มีเครดิตฟรีรายวันให้ลองใช้ Video to Video และมีแพ็กเกจพรีเมียมสำหรับประมวลผลเร็วขึ้นและดาวน์โหลดแบบไม่มีลายน้ำ',
                    },
                ],
            },
            faq: [
                {
                    question: 'AI วิดีโอเป็นวิดีโอ (Vid2Vid) คืออะไร?',
                    answer: 'Video to Video คือกระบวนการ AI ที่ใช้คลิปเดิมเป็นอินพุตแล้ววาดใหม่ตามพรอมต์ โดยคงการเคลื่อนไหวและโครงสร้างเดิม',
                },
                {
                    question: 'สามารถเปลี่ยนวิดีโอเป็นสไตล์อนิเมะได้ไหม?',
                    answer: 'ได้ เพียงอัปโหลดวิดีโอและใช้พรอมต์ เช่น “อนิเมะญี่ปุ่น, สไตล์สตูดิโอจิบลิ”',
                },
                {
                    question: 'วิดีโอต้นฉบับยาวได้เท่าไร?',
                    answer: 'เหมาะกับคลิปสั้น (เช่น 5–10 วินาที) เพื่อคุณภาพที่ดีที่สุด; วิดีโอยาวแนะนำแบ่งเป็นช่วง',
                },
                {
                    question: 'ต่างจากโปรแกรมตัดต่อวิดีโออย่างไร?',
                    answer: 'โปรแกรมตัดต่อคือการตัดต่อคลิป ส่วน Video to Video สร้างพิกเซลใหม่และเปลี่ยนสไตล์ของฟุตเทจ',
                },
                {
                    question: 'ต้องเสียเงินไหม?',
                    answer: 'มีเครดิตฟรีรายวันให้ทดลอง และมีแพ็กเกจพรีเมียมสำหรับความเร็วและดาวน์โหลดแบบไม่มีลายน้ำ',
                },
            ],
        },
        removeWatermark: {
            title: 'เครื่องมือลบลายน้ำวิดีโอ AI - ลบโลโก้และคำบรรยาย | 微鲤AI',
            description: 'เครื่องมือลบลายน้ำวิดีโอ AI - ลบโลโก้และคำบรรยาย on 微鲤AI platform. High-quality results.',
            keywords: 'removeWatermark, AI, 微鲤AI',
            page: {
                title1: 'เครื่องมือลบลายน้ำวิดีโอ AI ออนไลน์ฟรี',
                title2: 'ลบลายน้ำ โลโก้ ข้อความ และคำบรรยายออกจากวิดีโอของคุณทันที วางลิงก์วิดีโอหรืออัปโหลดไฟล์เพื่อให้ AI ของเรากู้คืนพื้นหลังได้อย่างสมบูรณ์แบบ',
            },
        },
        videoFaceSwap: {
            title: 'เครื่องมือสลับใบหน้าในวิดีโอ AI ออนไลน์ - เครื่องมือสร้าง Deepfake ที่สมจริง | 微鲤AI',
            description: 'เครื่องมือสลับใบหน้าในวิดีโอ AI ออนไลน์ - เครื่องมือสร้าง Deepfake ที่สมจริง on 微鲤AI platform. High-quality results.',
            keywords: 'videoFaceSwap, AI, 微鲤AI',
            page: {
                title1: 'สลับใบหน้าในวิดีโอ AI ฟรี',
                title2: 'เป็นดาราในภาพยนตร์เรื่องใดก็ได้! อัปโหลดคลิปวิดีโอและรูปภาพเป้าหมาย แล้วดู AI ของเราสลับใบหน้าอย่างแนบเนียน เหมาะสำหรับสร้างมีมหรือวิดีโออวยพร',
            },
        },
        videoLipSync: {
            title: 'เครื่องมือลิปซิงค์วิดีโอ AI - การซิงโครไนซ์เสียงและใบหน้า | 微鲤AI',
            description: 'เครื่องมือลิปซิงค์วิดีโอ AI - การซิงโครไนซ์เสียงและใบหน้า on 微鲤AI platform. High-quality results.',
            keywords: 'videoLipSync, AI, 微鲤AI',
        },
        translateVideoSubtitle: {
            title: 'เครื่องมือแปลคำบรรยายวิดีโอ AI - การแปลอัตโนมัติ | 微鲤AI',
            description: 'เครื่องมือแปลคำบรรยายวิดีโอ AI - การแปลอัตโนมัติ on 微鲤AI platform. High-quality results.',
            keywords: 'translateVideoSubtitle, AI, 微鲤AI',
        },
        videoToAnime: {
            title: 'เครื่องมือเปลี่ยนวิดีโอเป็นอนิเมะ AI - เปลี่ยนวิดีโอเป็นสไตล์แอนิเมชัน | 微鲤AI',
            description: 'เครื่องมือเปลี่ยนวิดีโอเป็นอนิเมะ AI - เปลี่ยนวิดีโอเป็นสไตล์แอนิเมชัน on 微鲤AI platform. High-quality results.',
            keywords: 'videoToAnime, AI, 微鲤AI',
        },
        videoUpscaler: {
            title: 'เครื่องมืออัปสเกลวิดีโอ AI - เพิ่มคุณภาพเป็น 4K | 微鲤AI',
            description: 'เครื่องมืออัปสเกลวิดีโอ AI - เพิ่มคุณภาพเป็น 4K on 微鲤AI platform. High-quality results.',
            keywords: 'videoUpscaler, AI, 微鲤AI',
        },
        removeVideoSubtitles: {
            title: 'ลบคำบรรยายวิดีโอ - การลบอัจฉริยะด้วย AI | 微鲤AI',
            description: 'ระบุและลบคำบรรยายที่ฝังในวิดีโออย่างอัจฉริยะ โดยไม่เสียคุณภาพเนื้อหาวิดีโอ',
            keywords: 'ลบคำบรรยายวิดีโอ, ลบคำบรรยาย, 微鲤AI',
        },
        videoBackgroundRemover: {
            title: 'ลบพื้นหลังวิดีโอ - เปลี่ยนหรือลบพื้นหลังในคลิกเดียว | 微鲤AI',
            description: 'ใช้ AI ลบพื้นหลังวิดีโออย่างแม่นยำ รองรับการเปลี่ยนพื้นหลังหรือส่งออกพื้นหลังโปร่งใส',
            keywords: 'ลบพื้นหลังวิดีโอ, ลบพื้นหลัง, แก้ไขวิดีโอ, 微鲤AI',
        },
        aiVideoExtender: {
            title: 'ขยายวิดีโอ - การเติมเฟรมวิดีโออัจฉริยะด้วย AI | 微鲤AI',
            description: 'ใช้ AI ขยายเฟรมวิดีโออย่างอัจฉริยะ เติมเนื้อหาที่ขาดหายไปเพื่อให้เข้ากับอัตราส่วนที่ต้องการ',
            keywords: 'ขยายวิดีโอ, การเติม AI, การปรับอัตราส่วนวิดีโอ, 微鲤AI',
        },
        videoEffects: {
            title: 'เอฟเฟกต์วิดีโอ - สร้างวิดีโอไวรัลด้วย AI | 微鲤AI',
            description: 'สำรวจเอฟเฟกต์วิดีโอ AI ยอดนิยมบน 微鲤AI ตั้งแต่ AI Kissing ไปจนถึง AI Dancing สร้างวิดีโอไวรัลได้ในไม่กี่คลิก',
            keywords: 'เอฟเฟกต์วิดีโอ AI, วิดีโอไวรัล, 微鲤AI',
        },
        aiDancing: {
            title: 'เครื่องมือสร้างวิดีโอเต้น AI | เปลี่ยนรูปภาพเป็นวิดีโอเต้น | 微鲤AI',
            description: 'สร้างวิดีโอเต้นจากรูปภาพใดก็ได้โดยใช้เครื่องมือสร้างวิดีโอเต้น AI ของ 微鲤AI',
            keywords: 'เครื่องมือสร้างวิดีโอเต้น AI, เปลี่ยนรูปภาพเป็นวิดีโอเต้น, 微鲤AI',
        },
        aiKissing: {
            title: 'เครื่องมือสร้างวิดีโอจูบ AI - ทำให้คนในสองภาพจูบกัน | 微鲤AI',
            description: 'เครื่องมือสร้างวิดีโอจูบ AI - ทำให้คนในสองภาพจูบกัน on 微鲤AI. Realistic and professional results.',
            keywords: 'aiKissing, AI, 微鲤AI',
        },
        videoMotionImitation: {
            title: 'การเลียนแบบการเคลื่อนไหว - ให้รูปภาพเลียนแบบท่าทางจากวิดีโอ | 微鲤AI',
            description: 'ดึงการเคลื่อนไหวจากวิดีโอและนำไปใช้กับรูปภาพนิ่งเพื่อให้รูปภาพ "เคลื่อนไหว"',
            keywords: 'การเลียนแบบการเคลื่อนไหว, รูปภาพเป็นวิดีโอ, 微鲤AI',
        },
    },
    da: {
        textToMusic: {
            title: 'AI Musikgenerator - Skab unik musik uden royalties | 微鲤AI',
            description: 'Brug avanceret AI-teknologi til hurtigt at skabe unik musik uden royalties til dine projekter.',
            keywords: 'AI musikgenerator, royalty-fri musik, 微鲤AI',
        },
        textToVideo: {
            title: 'Gratis AI tekst-til-video generator (Veo 3.1, Kling & Sora) | 微鲤AI',
            description: 'Lav dine tekstprompter om til filmiske videoer med 微鲤AI Text to Video AI. Drevet af Google Veo 3.1, Kling og Sora. Understøtter 16:9 og 9:16, op til 8 sekunder. Mulighed for uden vandmærke.',
            keywords: 'tekst til video ai, ai videogenerator, google veo 3.1, prompt til video, kling ai, sora, txt2vid, 微鲤AI',
            og_title: 'Gratis AI tekst-til-video generator (Veo 3.1, Kling & Sora) | 微鲤AI',
            og_description: 'Lav dine tekstprompter om til filmiske videoer med 微鲤AI Text to Video AI. Drevet af Google Veo 3.1, Kling og Sora. Understøtter 16:9 og 9:16, op til 8 sekunder. Mulighed for uden vandmærke.',
            twitter_title: 'Gratis AI tekst-til-video generator (Veo 3.1, Kling & Sora) | 微鲤AI',
            twitter_description: 'Lav dine tekstprompter om til filmiske videoer med 微鲤AI Text to Video AI. Drevet af Google Veo 3.1, Kling og Sora. Understøtter 16:9 og 9:16, op til 8 sekunder. Mulighed for uden vandmærke.',
            page: {
                title1: 'Gratis AI tekst-til-video generator',
                title2: 'Skriv blot en prompt, og se 微鲤AI gøre din idé levende. Vores tekst-til-video-generator samler topmodeller som Google Veo 3.1 og Kling AI, så du kan skabe videoer i høj kvalitet og fysisk sammenhæng til sociale medier (9:16) eller filmiske projekter (16:9) på få sekunder.',
                intro_title: 'Gør fantasi til virkelighed med AI tekst-til-video',
                feature_title: 'Funktioner i 微鲤AI tekst-til-video',
                faq_title: 'Ofte stillede spørgsmål om tekst-til-video',
                feature_title1: 'Kraftfuld multi-model',
                feature_desc1: 'Skift mellem Veo 3.1 for realisme og Kling for konsistent bevægelse. Ingen behov for flere abonnementer.',
                feature_title2: 'Tilpassede billedformater',
                feature_desc2: 'Generer lodrette videoer (9:16) til TikTok/Reels eller bredformat (16:9) til YouTube direkte.',
                feature_title3: 'Forlænget varighed',
                feature_desc3: 'Lav videoer op til 8 sekunder (eller længere med udvidelser) i én generering, perfekt til storytelling.',
                faq: [
                    {
                        question: 'Hvordan skriver jeg en god prompt til AI tekst-til-video?',
                        answer: 'Vær specifik: beskriv motiv, handling, lys og kameravinkel. Fx: "Et filmisk drone-shot af en futuristisk cyberpunk-by om natten, neonlys, 4K". De integrerede modeller i 微鲤AI forstår komplekse beskrivelser godt.',
                    },
                    {
                        question: 'Hvilken model skal jeg bruge: Google Veo 3.1 eller Kling?',
                        answer: 'Google Veo 3.1 giver høj visuel kvalitet og følger prompten godt, ideel til realistiske scener. Kling AI klarer ofte komplekse karakterbevægelser bedre. Vi anbefaler at prøve begge.',
                    },
                    {
                        question: 'Er 微鲤AI tekst-til-video gratis?',
                        answer: 'Ja, hver bruger får daglige gratis kreditter til at generere videoer fra tekst. Du kan lave flere klip for at teste forskellige prompts og modeller.',
                    },
                    {
                        question: 'Kan jeg generere videoer længere end 8 sekunder?',
                        answer: 'Basisgenerering laver klip op til 8 sekunder (afhængigt af modellen). For længere videoer kan du bruge vores AI Video Extender-værktøj til at fortsætte optagelsen sømløst.',
                    },
                    {
                        question: 'Har de genererede videoer lyd?',
                        answer: 'Ja, du kan aktivere "Generate Audio"-knappen (i værktøjet) for automatisk at skabe matchende lydeffekter og baggrundsambience.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Hvordan skriver jeg en god prompt til AI tekst-til-video?',
                    answer: 'Vær specifik: beskriv motiv, handling, lys og kameravinkel. Fx: "Et filmisk drone-shot af en futuristisk cyberpunk-by om natten, neonlys, 4K". De integrerede modeller i 微鲤AI forstår komplekse beskrivelser godt.',
                },
                {
                    question: 'Hvilken model skal jeg bruge: Google Veo 3.1 eller Kling?',
                    answer: 'Google Veo 3.1 giver høj visuel kvalitet og følger prompten godt, ideel til realistiske scener. Kling AI klarer ofte komplekse karakterbevægelser bedre. Vi anbefaler at prøve begge.',
                },
                {
                    question: 'Er 微鲤AI tekst-til-video gratis?',
                    answer: 'Ja, hver bruger får daglige gratis kreditter til at generere videoer fra tekst. Du kan lave flere klip for at teste forskellige prompts og modeller.',
                },
                {
                    question: 'Kan jeg generere videoer længere end 8 sekunder?',
                    answer: 'Basisgenerering laver klip op til 8 sekunder (afhængigt af modellen). For længere videoer kan du bruge vores AI Video Extender-værktøj til at fortsætte optagelsen sømløst.',
                },
                {
                    question: 'Har de genererede videoer lyd?',
                    answer: 'Ja, du kan aktivere "Generate Audio"-knappen (i værktøjet) for automatisk at skabe matchende lydeffekter og baggrundsambience.',
                },
            ],
        },
        imageToVideo: {
            title: 'AI Billede-til-Video Generator (Gratis & Online) - Drevet af Kling, Veo & Sora',
            description: `Gør statiske fotos til realistiske videoer på få sekunder med 微鲤AI's gratis billede-til-video AI. Få adgang til topmodeller som Kling, Google Veo og Sora 2 ét sted. Mulighed for ingen vandmærke.`,
            keywords: 'billede til video AI, AI video generator, billedanimation, Sora video, Veo video, Seedance video, 微鲤AI video værktøjer',
            og_title: 'AI Billede-til-Video Generator (Gratis & Online) - Drevet af Kling, Veo & Sora',
            og_description: `Gør statiske fotos til realistiske videoer på få sekunder med 微鲤AI's gratis billede-til-video AI. Få adgang til topmodeller som Kling, Google Veo og Sora 2 ét sted. Mulighed for ingen vandmærke.`,
            twitter_title: 'AI Billede-til-Video Generator (Gratis & Online) - Drevet af Kling, Veo & Sora',
            twitter_description: `Gør statiske fotos til realistiske videoer på få sekunder med 微鲤AI's gratis billede-til-video AI. Få adgang til topmodeller som Kling, Google Veo og Sora 2 ét sted. Mulighed for ingen vandmærke.`,
            page: {
                title1: 'Gratis online AI billede-til-video generator',
                faq: [
                    {
                        question: 'Hvordan fungerer AI billede-til-video generatoren?',
                        answer: 'Den bruger avancerede deep learning-modeller som Kling og Sora til at analysere dit statiske billede og forudsige bevægelse, så der genereres et sammenhængende MP4-videoklip.',
                    },
                    {
                        question: 'Er 微鲤AI billede-til-video gratis at bruge?',
                        answer: 'Ja, vi giver daglige gratis kreditter til at prøve vores billede-til-video AI. Du kan opgradere til premium-modeller og hurtigere generering.',
                    },
                    {
                        question: 'Hvilken model er bedst til realistisk video: Kling eller Veo?',
                        answer: 'Kling AI er kendt for realistisk bevægelse og længere varighed, mens Google Veo excellerer i højopløste detaljer. 微鲤AI lader dig skifte mellem dem for at finde det bedste match.',
                    },
                    {
                        question: 'Kan jeg bruge de genererede videoer kommercielt?',
                        answer: 'Ja, videoer genereret under betalte planer har kommerciel licens, perfekt til YouTube, TikTok og marketingannoncer.',
                    },
                    {
                        question: 'Hvordan fjerner man vandmærker fra AI-videoer?',
                        answer: '微鲤AI leverer output i høj kvalitet. For vandmærkefrie videoer, tjek dine plandetaljer eller brug vores dedikerede AI Watermark Remover-værktøj.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Hvordan fungerer AI billede-til-video generatoren?',
                    answer: 'Den bruger avancerede deep learning-modeller som Kling og Sora til at analysere dit statiske billede og forudsige bevægelse, så der genereres et sammenhængende MP4-videoklip.',
                },
                {
                    question: 'Er 微鲤AI billede-til-video gratis at bruge?',
                    answer: 'Ja, vi giver daglige gratis kreditter til at prøve vores billede-til-video AI. Du kan opgradere til premium-modeller og hurtigere generering.',
                },
                {
                    question: 'Kan jeg bruge de genererede videoer kommercielt?',
                    answer: 'Ja, videoer genereret under betalte planer har kommerciel licens, perfekt til YouTube, TikTok og marketingannoncer.',
                },
            ],
        },
        videoToVideo: {
            title: 'Gratis AI video-til-video generator - Omstil stil & animefilter online | 微鲤AI',
            description: `Forvandl dine videoer til enhver stil med 微鲤AI's Video to Video AI. Lav virkelige optagelser om til anime, 3D-tegneserier eller cyberpunk med tekstprompter, mens den originale bevægelse bevares. Gratis og online.`,
            keywords: 'video til video ai, vid2vid, ai videostiloverførsel, gør video til anime, ai videorestyle, gratis ai videofilter',
            og_title: 'Gratis AI video-til-video generator - Omstil stil & animefilter online | 微鲤AI',
            og_description: `Forvandl dine videoer til enhver stil med 微鲤AI's Video to Video AI. Lav virkelige optagelser om til anime, 3D-tegneserier eller cyberpunk med tekstprompter, mens den originale bevægelse bevares. Gratis og online.`,
            twitter_title: 'Gratis AI video-til-video generator - Omstil stil & animefilter online | 微鲤AI',
            twitter_description: `Forvandl dine videoer til enhver stil med 微鲤AI's Video to Video AI. Lav virkelige optagelser om til anime, 3D-tegneserier eller cyberpunk med tekstprompter, mens den originale bevægelse bevares. Gratis og online.`,
            page: {
                title1: 'Gratis AI video-til-video generator (Vid2Vid)',
                title2: `Upload en video, skriv en stil, og se magien ske. 微鲤AI's Video to Video-teknologi analyserer bevægelsen i dit kildemateriale og anvender en helt ny kunstnerisk stil baseret på din tekstprompt. Perfekt til anime-edits, claymation-effekter eller surrealistisk visuel kunst.`,
                feature_title1: 'Konsistent bevægelse',
                feature_desc1: 'I modsætning til standardgenerering låser vores Vid2Vid-motor sig fast på bevægelsen i din kildevideo og sikrer glatte overgange uden flimmer.',
                feature_title2: 'Real til anime',
                feature_desc2: '#1 værktøj for content creators. Forvandl dig selv til en animefigur eller en 3D Pixar-lignende avatar med det samme.',
                feature_title3: 'Prompt-kontrol',
                feature_desc3: 'Du har fuld kreativ kontrol. Skriv fx "cyberpunk-by stil" eller "oliemaleri-stil" for at definere udseendet præcist.',
                faq: [
                    {
                        question: 'Hvad er AI Video to Video (Vid2Vid)?',
                        answer: 'Video to Video er en generativ AI-proces, der tager et eksisterende videoklip som input og "genmaler" det i en ny stil beskrevet af din tekstprompt, mens den originale bevægelse og struktur bevares.',
                    },
                    {
                        question: 'Kan jeg gøre min video til en anime-stil?',
                        answer: 'Ja! Det er den mest populære use case. Upload din video og skriv prompts som "japansk anime-stil, Studio Ghibli-look" for at transformere optagelsen.',
                    },
                    {
                        question: 'Hvor lang må kildevideoen være?',
                        answer: 'I øjeblikket understøtter vi korte klip (fx op til 5–10 sekunder) for at sikre den højeste kvalitet. Længere videoer anbefales delt i segmenter.',
                    },
                    {
                        question: 'Er det anderledes end en videoredigerer?',
                        answer: 'Ja. En traditionel videoredigerer klipper og trimmer klip. 微鲤AI Video to Video genererer nye pixels og ændrer hele teksturen og den kunstneriske stil i dit materiale.',
                    },
                    {
                        question: 'Koster det penge?',
                        answer: '微鲤AI tilbyder daglige gratis credits for at prøve Video to Video. Premium-planer er tilgængelige for hurtigere behandling og downloads uden vandmærke.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Hvad er AI Video to Video (Vid2Vid)?',
                    answer: 'Video to Video er en generativ AI-proces, der tager et eksisterende videoklip og genmaler det i en ny stil baseret på din prompt, mens bevægelse og struktur bevares.',
                },
                {
                    question: 'Kan jeg gøre min video til en anime-stil?',
                    answer: 'Ja! Upload din video og brug prompts som "japansk anime-stil, Studio Ghibli-look".',
                },
                {
                    question: 'Hvor lang må kildevideoen være?',
                    answer: 'Vi understøtter bedst korte klip (fx 5–10 sekunder); længere videoer bør deles op.',
                },
                {
                    question: 'Er det anderledes end en videoredigerer?',
                    answer: 'En videoredigerer klipper og trimmer; Video to Video genererer nye pixels og ændrer stilen.',
                },
                {
                    question: 'Koster det penge?',
                    answer: 'Der er daglige gratis credits, og premium-planer giver hurtigere behandling og downloads uden vandmærke.',
                },
            ],
        },
        removeWatermark: {
            title: 'AI video vandmærke fjerner - Slet logoer og undertekster | 微鲤AI',
            description: 'AI video vandmærke fjerner - Slet logoer og undertekster on 微鲤AI platform. High-quality results.',
            keywords: 'removeWatermark, AI, 微鲤AI',
            page: {
                title1: 'Gratis online AI video-vandmærke fjerner',
                title2: 'Slet øjeblikkeligt vandmærker, logoer, tekst og undertekster fra dine videoer. Indsæt et videolink eller upload en fil og lad vores AI gendanne baggrunden.',
            },
        },
        videoFaceSwap: {
            title: 'AI video ansigtsskift online - Realistisk Deepfake maker | 微鲤AI',
            description: 'AI video ansigtsskift online - Realistisk Deepfake maker on 微鲤AI platform. High-quality results.',
            keywords: 'videoFaceSwap, AI, 微鲤AI',
            page: {
                title1: 'Gratis AI video ansigtsskift',
                title2: 'Bliv stjernen i enhver film! Upload et videoklip og et målbillede, og se vores AI skifte ansigter problemfrit. Perfekt til sjove memes eller personlige hilsner.',
            },
        },
        videoLipSync: {
            title: 'AI video lip sync - Stemme og ansigt synkronisering | 微鲤AI',
            description: 'AI video lip sync - Stemme og ansigt synkronisering on 微鲤AI platform. High-quality results.',
            keywords: 'videoLipSync, AI, 微鲤AI',
        },
        translateVideoSubtitle: {
            title: 'AI video undertekst oversætter - Automatisk oversættelse | 微鲤AI',
            description: 'AI video undertekst oversætter - Automatisk oversættelse on 微鲤AI platform. High-quality results.',
            keywords: 'translateVideoSubtitle, AI, 微鲤AI',
        },
        videoToAnime: {
            title: 'AI video til anime - Skift video til animeret stil | 微鲤AI',
            description: 'AI video til anime - Skift video til animeret stil on 微鲤AI platform. High-quality results.',
            keywords: 'videoToAnime, AI, 微鲤AI',
        },
        videoUpscaler: {
            title: 'AI video upscaler - Forbedre kvalitet til 4K | 微鲤AI',
            description: 'AI video upscaler - Forbedre kvalitet til 4K on 微鲤AI platform. High-quality results.',
            keywords: 'videoUpscaler, AI, 微鲤AI',
        },
        removeVideoSubtitles: {
            title: 'Fjern videoundertekster - Intelligent fjernelse med AI | 微鲤AI',
            description: 'Identificer og fjern hardkodede undertekster fra videoer uden at miste kvalitet.',
            keywords: 'fjern videoundertekster, slet tekst, 微鲤AI',
        },
        videoBackgroundRemover: {
            title: 'Fjern videobaggrund - Skift eller fjern baggrund med ét klik | 微鲤AI',
            description: 'Brug AI til præcist at fjerne videobaggrund, understøtter skift af baggrund.',
            keywords: 'fjern videobaggrund, fjern baggrund, videoredigering, 微鲤AI',
        },
        aiVideoExtender: {
            title: 'Videoudvidelse - Intelligent AI-rammeudfyldning | 微鲤AI',
            description: 'Brug AI til intelligent at udvide videorammer og udfylde manglende indhold.',
            keywords: 'videoudvidelse, AI udfyldning, videoforhold, 微鲤AI',
        },
        videoEffects: {
            title: 'Videoeffekter - Skab virale videoer med AI | 微鲤AI',
            description: 'Udforsk populære AI-videoeffekter på 微鲤AI. Fra AI Kissing til AI Dancing, skab virale videoer med få klik.',
            keywords: 'AI videoeffekter, virale videoer, 微鲤AI',
        },
        aiDancing: {
            title: 'AI Dansevideo Generator | Foto til dansevideo maker | 微鲤AI',
            description: 'Opret dansevideoer fra ethvert foto ved hjælp af WeryAIs AI Dansevideo Generator.',
            keywords: 'AI dansevideo generator, foto til dansevideo, 微鲤AI',
        },
        aiKissing: {
            title: 'AI kyssevideo generator - Få to fotos til at kysse | 微鲤AI',
            description: 'AI kyssevideo generator - Få to fotos til at kysse on 微鲤AI. Realistic and professional results.',
            keywords: 'aiKissing, AI, 微鲤AI',
        },
        videoMotionImitation: {
            title: 'Videobevægelse imitation - Få fotos til at efterligne bevægelser | 微鲤AI',
            description: 'Udtræk bevægelse fra video og anvend det på fotos for at få dem til at "bevæge sig".',
            keywords: 'bevægelse imitation, foto til video, 微鲤AI',
        },
    },
    no: {
        textToMusic: {
            title: 'AI Musikkgenerator - Lag unik musikk uten royalties | 微鲤AI',
            description: 'Bruk avansert AI-teknologi til å raskt skape unik musikk uten royalties for dine prosjekter.',
            keywords: 'AI musikkgenerator, royalty-fri musikk, 微鲤AI',
        },
        textToVideo: {
            title: 'Gratis AI tekst-til-video-generator (Veo 3.1, Kling & Sora) | 微鲤AI',
            description: 'Gjør tekstpromptene dine om til filmatiske videoer umiddelbart med 微鲤AI Text to Video AI. Drevet av Google Veo 3.1, Kling og Sora. Støtter 16:9 og 9:16, opptil 8 sekunder. Alternativer uten vannmerke tilgjengelig.',
            keywords: 'tekst til video ai, ai videogenerator, google veo 3.1, prompt til video, kling ai, sora, txt2vid, 微鲤AI',
            og_title: 'Gratis AI tekst-til-video-generator (Veo 3.1, Kling & Sora) | 微鲤AI',
            og_description: 'Gjør tekstpromptene dine om til filmatiske videoer umiddelbart med 微鲤AI Text to Video AI. Drevet av Google Veo 3.1, Kling og Sora. Støtter 16:9 og 9:16, opptil 8 sekunder. Alternativer uten vannmerke tilgjengelig.',
            twitter_title: 'Gratis AI tekst-til-video-generator (Veo 3.1, Kling & Sora) | 微鲤AI',
            twitter_description: 'Gjør tekstpromptene dine om til filmatiske videoer umiddelbart med 微鲤AI Text to Video AI. Drevet av Google Veo 3.1, Kling og Sora. Støtter 16:9 og 9:16, opptil 8 sekunder. Alternativer uten vannmerke tilgjengelig.',
            page: {
                title1: 'Gratis AI tekst-til-video-generator',
                title2: 'Bare skriv inn en prompt, og se 微鲤AI gi liv til ideen din. Vår tekst-til-video-generator samler toppmodeller som Google Veo 3.1 og Kling AI, slik at du kan lage videoer i høy kvalitet og fysisk konsistens for sosiale medier (9:16) eller filmatiske prosjekter (16:9) på sekunder.',
                intro_title: 'Gjør fantasi til virkelighet med AI tekst-til-video',
                feature_title: 'Funksjoner i 微鲤AI tekst-til-video',
                faq_title: 'Ofte stilte spørsmål om tekst-til-video',
                feature_title1: 'Kraftig fler-modell',
                feature_desc1: 'Bytt mellom Veo 3.1 for realisme og Kling for bevegelseskonsistens. Ingen behov for flere abonnementer.',
                feature_title2: 'Tilpassede sideforhold',
                feature_desc2: 'Lag vertikale videoer (9:16) for TikTok/Reels eller bredformat (16:9) for YouTube direkte.',
                feature_title3: 'Lengre varighet',
                feature_desc3: 'Lag videoer opptil 8 sekunder (eller lenger med utvidelser) i én generering, perfekt for historiefortelling.',
                faq: [
                    {
                        question: 'Hvordan skriver jeg en god prompt for AI tekst-til-video?',
                        answer: 'Vær spesifikk: beskriv motiv, handling, lys og kameravinkel. For eksempel: "Et filmatisk droneopptak av en futuristisk cyberpunk-by om natten, neonlys, 4K". De integrerte modellene i 微鲤AI forstår komplekse beskrivelser godt.',
                    },
                    {
                        question: 'Hvilken modell bør jeg bruke: Google Veo 3.1 eller Kling?',
                        answer: 'Google Veo 3.1 gir eksepsjonell visuell kvalitet og følger prompten godt, ideelt for realistiske scener. Kling AI fungerer ofte bedre for komplekse karakterbevegelser. Vi anbefaler å prøve begge.',
                    },
                    {
                        question: 'Er 微鲤AI tekst-til-video gratis?',
                        answer: 'Ja, hver bruker får daglige gratis kreditter til å generere videoer fra tekst. Du kan lage flere klipp for å teste ulike prompt og modeller.',
                    },
                    {
                        question: 'Kan jeg generere videoer lengre enn 8 sekunder?',
                        answer: 'Grunngenereringen lager klipp opptil 8 sekunder (avhengig av modellen). For lengre videoer kan du bruke vårt AI Video Extender-verktøy for å fortsette opptaket sømløst.',
                    },
                    {
                        question: 'Har de genererte videoene lyd?',
                        answer: 'Ja, du kan aktivere "Generate Audio"-bryteren (i verktøyet) for automatisk å lage matchende lydeffekter og bakgrunnsambience.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Hvordan skriver jeg en god prompt for AI tekst-til-video?',
                    answer: 'Vær spesifikk: beskriv motiv, handling, lys og kameravinkel. For eksempel: "Et filmatisk droneopptak av en futuristisk cyberpunk-by om natten, neonlys, 4K". De integrerte modellene i 微鲤AI forstår komplekse beskrivelser godt.',
                },
                {
                    question: 'Hvilken modell bør jeg bruke: Google Veo 3.1 eller Kling?',
                    answer: 'Google Veo 3.1 gir eksepsjonell visuell kvalitet og følger prompten godt, ideelt for realistiske scener. Kling AI fungerer ofte bedre for komplekse karakterbevegelser. Vi anbefaler å prøve begge.',
                },
                {
                    question: 'Er 微鲤AI tekst-til-video gratis?',
                    answer: 'Ja, hver bruker får daglige gratis kreditter til å generere videoer fra tekst. Du kan lage flere klipp for å teste ulike prompt og modeller.',
                },
                {
                    question: 'Kan jeg generere videoer lengre enn 8 sekunder?',
                    answer: 'Grunngenereringen lager klipp opptil 8 sekunder (avhengig av modellen). For lengre videoer kan du bruke vårt AI Video Extender-verktøy for å fortsette opptaket sømløst.',
                },
                {
                    question: 'Har de genererte videoene lyd?',
                    answer: 'Ja, du kan aktivere "Generate Audio"-bryteren (i verktøyet) for automatisk å lage matchende lydeffekter og bakgrunnsambience.',
                },
            ],
        },
        imageToVideo: {
            title: 'AI Bilde-til-Video Generator (Gratis og Online) - Drevet av Kling, Veo og Sora',
            description: 'Gjør stillbilder om til realistiske videoer på sekunder med 微鲤AI sin gratis bilde-til-video AI. Få tilgang til toppmodeller som Kling, Google Veo og Sora 2 på ett sted. Alternativer uten vannmerke tilgjengelig.',
            keywords: 'bilde til video AI, AI video generator, bildeanimasjon, Sora video, Veo video, Seedance video, 微鲤AI videoverktøy',
            og_title: 'AI Bilde-til-Video Generator (Gratis og Online) - Drevet av Kling, Veo og Sora',
            og_description: 'Gjør stillbilder om til realistiske videoer på sekunder med 微鲤AI sin gratis bilde-til-video AI. Få tilgang til toppmodeller som Kling, Google Veo og Sora 2 på ett sted. Alternativer uten vannmerke tilgjengelig.',
            twitter_title: 'AI Bilde-til-Video Generator (Gratis og Online) - Drevet av Kling, Veo og Sora',
            twitter_description: 'Gjør stillbilder om til realistiske videoer på sekunder med 微鲤AI sin gratis bilde-til-video AI. Få tilgang til toppmodeller som Kling, Google Veo og Sora 2 på ett sted. Alternativer uten vannmerke tilgjengelig.',
            page: {
                title1: 'Gratis online AI bilde-til-video generator',
                faq: [
                    {
                        question: 'Hvordan fungerer AI bilde-til-video-generatoren?',
                        answer: 'Den bruker avanserte deep learning-modeller som Kling og Sora for å analysere bildet ditt og forutsi bevegelse, og lager et sammenhengende MP4-videoklipp.',
                    },
                    {
                        question: 'Er 微鲤AI bilde-til-video gratis å bruke?',
                        answer: 'Ja, vi tilbyr daglige gratiskreditter for å prøve bilde-til-video AI. Du kan oppgradere til premium-modeller og raskere generering.',
                    },
                    {
                        question: 'Hvilken modell er best for realistisk video: Kling eller Veo?',
                        answer: 'Kling AI er kjent for realistisk bevegelse og lengre varighet, mens Google Veo utmerker seg med høyoppløste detaljer. 微鲤AI lar deg bytte mellom dem for å finne beste match.',
                    },
                    {
                        question: 'Kan jeg bruke de genererte videoene kommersielt?',
                        answer: 'Ja, videoer generert under betalte planer har kommersiell lisens, perfekt for YouTube, TikTok og markedsføringsannonser.',
                    },
                    {
                        question: 'Hvordan fjerner man vannmerker fra AI-videoer?',
                        answer: '微鲤AI leverer høy kvalitet. For videoer uten vannmerke, sjekk plandetaljene eller bruk vårt dedikerte AI Watermark Remover-verktøy.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Hvordan fungerer AI bilde-til-video-generatoren?',
                    answer: 'Den bruker avanserte deep learning-modeller som Kling og Sora for å analysere bildet ditt og forutsi bevegelse, og lager et sammenhengende MP4-videoklipp.',
                },
                {
                    question: 'Er 微鲤AI bilde-til-video gratis å bruke?',
                    answer: 'Ja, vi tilbyr daglige gratiskreditter for å prøve bilde-til-video AI. Du kan oppgradere til premium-modeller og raskere generering.',
                },
                {
                    question: 'Kan jeg bruke de genererte videoene kommersielt?',
                    answer: 'Ja, videoer generert under betalte planer har kommersiell lisens, perfekt for YouTube, TikTok og markedsføringsannonser.',
                },
            ],
        },
        videoToVideo: {
            title: 'Gratis AI video-til-video-generator - Endre stil og animefilter online | 微鲤AI',
            description: 'Forvandle videoene dine til hvilken som helst stil med 微鲤AI Video to Video AI. Gjør ekte opptak om til anime, 3D-tegneserier eller cyberpunk med tekstprompter, samtidig som den originale bevegelsen bevares. Gratis og online.',
            keywords: 'video til video ai, vid2vid, ai videostiloverføring, gjør video til anime, ai videorestyle, gratis ai videofilter',
            og_title: 'Gratis AI video-til-video-generator - Endre stil og animefilter online | 微鲤AI',
            og_description: 'Forvandle videoene dine til hvilken som helst stil med 微鲤AI Video to Video AI. Gjør ekte opptak om til anime, 3D-tegneserier eller cyberpunk med tekstprompter, samtidig som den originale bevegelsen bevares. Gratis og online.',
            twitter_title: 'Gratis AI video-til-video-generator - Endre stil og animefilter online | 微鲤AI',
            twitter_description: 'Forvandle videoene dine til hvilken som helst stil med 微鲤AI Video to Video AI. Gjør ekte opptak om til anime, 3D-tegneserier eller cyberpunk med tekstprompter, samtidig som den originale bevegelsen bevares. Gratis og online.',
            page: {
                title1: 'Gratis AI video-til-video-generator (Vid2Vid)',
                title2: 'Last opp en video, skriv inn en stil, og se magien skje. 微鲤AI sin Video to Video-teknologi analyserer bevegelsen i kildematerialet og legger på en helt ny kunstnerisk stil basert på tekstprompten din. Perfekt for anime-edits, claymation-effekter eller surrealistisk visuell kunst.',
                feature_title1: 'Konsistent bevegelse',
                feature_desc1: 'I motsetning til vanlig generering låser Vid2Vid-motoren vår seg til bevegelsen i kildevideoen, noe som gir jevne overganger uten flimring.',
                feature_title2: 'Real til anime',
                feature_desc2: '#1-verktøyet for skapere. Gjør deg selv om til en animefigur eller en 3D Pixar-stil avatar på et øyeblikk.',
                feature_title3: 'Prompt-kontroll',
                feature_desc3: 'Du har full kreativ kontroll. Skriv for eksempel "cyberpunk-by stil" eller "oljemaleri-stil" for å definere nøyaktig utseende.',
                faq: [
                    {
                        question: 'Hva er AI Video to Video (Vid2Vid)?',
                        answer: 'Video to Video er en generativ AI-prosess som tar et eksisterende videoklipp som input og "maler" det om til en ny stil beskrevet av tekstprompten din, samtidig som den originale bevegelsen og strukturen bevares.',
                    },
                    {
                        question: 'Kan jeg gjøre videoen min om til anime-stil?',
                        answer: 'Ja! Dette er den mest populære bruken. Last opp videoen din og skriv prompts som "japansk anime-stil, Studio Ghibli-look" for å transformere klippet.',
                    },
                    {
                        question: 'Hvor lang kan kildevideoen være?',
                        answer: 'Per nå støtter vi korte klipp (f.eks. opptil 5–10 sekunder) for å sikre best mulig kvalitet. For lengre videoer anbefaler vi å dele dem opp.',
                    },
                    {
                        question: 'Er det annerledes enn en videoredigerer?',
                        answer: 'Ja. En tradisjonell videoredigerer klipper og trimmer klipp. 微鲤AI Video to Video genererer nye piksler og endrer tekstur og kunstnerisk stil fullstendig.',
                    },
                    {
                        question: 'Koster det penger?',
                        answer: '微鲤AI tilbyr daglige gratis kreditter for å prøve Video to Video. Premium-planer er tilgjengelige for raskere behandling og nedlasting uten vannmerke.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Hva er AI Video to Video (Vid2Vid)?',
                    answer: 'Video to Video er en generativ AI-prosess som tar et eksisterende videoklipp og maler det om til en ny stil basert på prompten, mens bevegelse og struktur bevares.',
                },
                {
                    question: 'Kan jeg gjøre videoen min om til anime-stil?',
                    answer: 'Ja! Last opp videoen og bruk prompts som "japansk anime-stil, Studio Ghibli-look".',
                },
                {
                    question: 'Hvor lang kan kildevideoen være?',
                    answer: 'Best for korte klipp (f.eks. 5–10 sekunder); lengre videoer bør deles opp.',
                },
                {
                    question: 'Er det annerledes enn en videoredigerer?',
                    answer: 'En videoredigerer klipper og trimmer; Video to Video genererer nye piksler og endrer stilen.',
                },
                {
                    question: 'Koster det penger?',
                    answer: 'Det finnes daglige gratis kreditter, og premium-planer gir raskere behandling og nedlasting uten vannmerke.',
                },
            ],
        },
        removeWatermark: {
            title: 'AI video vannmerke fjerner - Slett logoer og undertekster | 微鲤AI',
            description: 'AI video vannmerke fjerner - Slett logoer og undertekster on 微鲤AI platform. High-quality results.',
            keywords: 'removeWatermark, AI, 微鲤AI',
            page: {
                title1: 'Gratis online AI videovannmerke-fjerner',
                title2: 'Slett vannmerker, logoer, tekst og undertekster fra videoene dine umiddelbart. Lim inn en videolenke eller last opp en fil og la vår AI gjenopprette bakgrunnen.',
            },
        },
        videoFaceSwap: {
            title: 'AI video ansiktsbytte online - Realistisk Deepfake maker | 微鲤AI',
            description: 'AI video ansiktsbytte online - Realistisk Deepfake maker on 微鲤AI platform. High-quality results.',
            keywords: 'videoFaceSwap, AI, 微鲤AI',
            page: {
                title1: 'Gratis AI video-ansiktsbytte',
                title2: 'Bli stjernen i hvilken som helst film! Last opp et videoklipp og et målbilde, og se vår AI bytte ansikter sømløst. Perfekt for morsomme memes eller personlige hilsener.',
            },
        },
        videoLipSync: {
            title: 'AI video lip sync - Stemme og ansikt synkronisering | 微鲤AI',
            description: 'AI video lip sync - Stemme og ansikt synkronisering on 微鲤AI platform. High-quality results.',
            keywords: 'videoLipSync, AI, 微鲤AI',
        },
        translateVideoSubtitle: {
            title: 'AI video undertekst oversetter - Automatisk oversettelse | 微鲤AI',
            description: 'AI video undertekst oversetter - Automatisk oversettelse on 微鲤AI platform. High-quality results.',
            keywords: 'translateVideoSubtitle, AI, 微鲤AI',
        },
        videoToAnime: {
            title: 'AI video til anime - Endre video til animert stil | 微鲤AI',
            description: 'AI video til anime - Endre video til animert stil on 微鲤AI platform. High-quality results.',
            keywords: 'videoToAnime, AI, 微鲤AI',
        },
        videoUpscaler: {
            title: 'AI video upscaler - Forbedre kvalitet til 4K | 微鲤AI',
            description: 'AI video upscaler - Forbedre kvalitet til 4K on 微鲤AI platform. High-quality results.',
            keywords: 'videoUpscaler, AI, 微鲤AI',
        },
        removeVideoSubtitles: {
            title: 'Fjern videoundertekster - Intelligent fjerning med AI | 微鲤AI',
            description: 'Identifiser og fjern hardkodede undertekster fra videoer uten å miste kvalitet.',
            keywords: 'fjern videoundertekster, slett tekst, 微鲤AI',
        },
        videoBackgroundRemover: {
            title: 'Fjern videobakgrunn - Bytt eller fjern bakgrunn med ett klikk | 微鲤AI',
            description: 'Bruk AI til å fjerne videobakgrunn nøyaktig, støtter bytte av bakgrunn.',
            keywords: 'fjern videobakgrunn, fjern bakgrunn, videoredigering, 微鲤AI',
        },
        aiVideoExtender: {
            title: 'Videoutvidelse - Intelligent AI-rammeutfylling | 微鲤AI',
            description: 'Bruk AI til å utvide videorammer intelligent og fylle ut manglende innhold.',
            keywords: 'videoutvidelse, AI utfylling, videoforhold, 微鲤AI',
        },
        videoEffects: {
            title: 'Videoeffekter - Lag virale videoer med AI | 微鲤AI',
            description: 'Utforsk populære AI-videoeffekter på 微鲤AI. Fra AI Kissing til AI Dancing, lag virale videoer med noen få klikk.',
            keywords: 'AI videoeffekter, virale videoer, 微鲤AI',
        },
        aiDancing: {
            title: 'AI Dansevideogenerator | Foto til dansevideo maker | 微鲤AI',
            description: 'Lag dansevideoer fra hvilket som helst bilde med WeryAIs AI Dansevideogenerator.',
            keywords: 'AI dansevideogenerator, bilde til dansevideo, 微鲤AI',
        },
        aiKissing: {
            title: 'AI kyssvideogenerator - Få to bilder til å kysse | 微鲤AI',
            description: 'AI kyssvideogenerator - Få to bilder til å kysse on 微鲤AI. Realistic and professional results.',
            keywords: 'aiKissing, AI, 微鲤AI',
        },
        videoMotionImitation: {
            title: 'Video etterligning - Få bilder til å etterligne bevegelser | 微鲤AI',
            description: 'Trekk ut bevegelse fra video og bruk det på bilder for å få dem til å "bevege seg".',
            keywords: 'bevegelse etterligning, bilde til video, 微鲤AI',
        },
    },
    nl: {
        textToMusic: {
            title: `AI-muziekgenerator - Maak unieke muziek zonder royalty's | 微鲤AI`,
            description: `Gebruik geavanceerde AI-technologie om snel unieke muziek zonder royalty's te creëren voor je projecten.`,
            keywords: 'AI-muziekgenerator, royalty-vrije muziek, 微鲤AI',
        },
        textToVideo: {
            title: 'Gratis AI tekst-naar-video generator (Veo 3.1, Kling & Sora) | 微鲤AI',
            description: `Zet je tekstprompts direct om in filmische video's met 微鲤AI Text to Video AI. Aangedreven door Google Veo 3.1, Kling en Sora. Ondersteunt 16:9 en 9:16, tot 8 seconden. Opties zonder watermerk beschikbaar.`,
            keywords: 'tekst naar video ai, ai videogenerator, google veo 3.1, prompt naar video, kling ai, sora, txt2vid, 微鲤AI',
            og_title: 'Gratis AI tekst-naar-video generator (Veo 3.1, Kling & Sora) | 微鲤AI',
            og_description: `Zet je tekstprompts direct om in filmische video's met 微鲤AI Text to Video AI. Aangedreven door Google Veo 3.1, Kling en Sora. Ondersteunt 16:9 en 9:16, tot 8 seconden. Opties zonder watermerk beschikbaar.`,
            twitter_title: 'Gratis AI tekst-naar-video generator (Veo 3.1, Kling & Sora) | 微鲤AI',
            twitter_description: `Zet je tekstprompts direct om in filmische video's met 微鲤AI Text to Video AI. Aangedreven door Google Veo 3.1, Kling en Sora. Ondersteunt 16:9 en 9:16, tot 8 seconden. Opties zonder watermerk beschikbaar.`,
            page: {
                title1: 'Gratis AI tekst-naar-video generator',
                title2: `Typ gewoon een prompt en zie hoe 微鲤AI je idee tot leven brengt. Onze tekst-naar-video generator bundelt topmodellen zoals Google Veo 3.1 en Kling AI, zodat je in enkele seconden hoogwaardige, fysiek consistente video's kunt maken voor social media (9:16) of filmische projecten (16:9).`,
                intro_title: 'Maak van verbeelding werkelijkheid met AI tekst-naar-video',
                feature_title: 'Functies van 微鲤AI tekst-naar-video',
                faq_title: 'Veelgestelde vragen over tekst-naar-video',
                feature_title1: 'Krachtige multi-model',
                feature_desc1: 'Schakel tussen Veo 3.1 voor realisme en Kling voor consistente beweging. Geen meerdere abonnementen nodig.',
                feature_title2: 'Aangepaste beeldverhoudingen',
                feature_desc2: `Genereer verticale video's (9:16) voor TikTok/Reels of breedbeeld (16:9) voor YouTube direct.`,
                feature_title3: 'Langere duur',
                feature_desc3: `Maak video's tot 8 seconden (of langer met extensies) in één generatie, perfect voor storytelling.`,
                faq: [
                    {
                        question: 'Hoe schrijf ik een goede prompt voor AI tekst-naar-video?',
                        answer: 'Wees specifiek: beschrijf onderwerp, actie, belichting en camerahoek. Bijvoorbeeld: "Een filmische drone-opname van een futuristische cyberpunkstad in de nacht, neonlichten, 4K". De geïntegreerde modellen van 微鲤AI begrijpen complexe beschrijvingen goed.',
                    },
                    {
                        question: 'Welk model moet ik gebruiken: Google Veo 3.1 of Kling?',
                        answer: 'Google Veo 3.1 biedt uitzonderlijke visuele kwaliteit en houdt zich goed aan de prompt, ideaal voor realistische scènes. Kling AI presteert vaak beter bij complexe karakterbewegingen. We raden aan beide te proberen.',
                    },
                    {
                        question: 'Is 微鲤AI tekst-naar-video gratis?',
                        answer: `Ja, elke gebruiker krijgt dagelijkse gratis credits om video's uit tekst te genereren. Je kunt meerdere clips maken om verschillende prompts en modellen te testen.`,
                    },
                    {
                        question: `Kan ik video's genereren langer dan 8 seconden?`,
                        answer: `De basisgeneratie maakt clips tot 8 seconden (afhankelijk van het model). Voor langere video's kun je onze AI Video Extender-tool gebruiken om het beeld naadloos te verlengen.`,
                    },
                    {
                        question: `Hebben de gegenereerde video's geluid?`,
                        answer: 'Ja, je kunt de schakelaar "Generate Audio" (in de tool) inschakelen om automatisch bijpassende geluidseffecten en achtergrondambience te maken.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Hoe schrijf ik een goede prompt voor AI tekst-naar-video?',
                    answer: 'Wees specifiek: beschrijf onderwerp, actie, belichting en camerahoek. Bijvoorbeeld: "Een filmische drone-opname van een futuristische cyberpunkstad in de nacht, neonlichten, 4K". De geïntegreerde modellen van 微鲤AI begrijpen complexe beschrijvingen goed.',
                },
                {
                    question: 'Welk model moet ik gebruiken: Google Veo 3.1 of Kling?',
                    answer: 'Google Veo 3.1 biedt uitzonderlijke visuele kwaliteit en houdt zich goed aan de prompt, ideaal voor realistische scènes. Kling AI presteert vaak beter bij complexe karakterbewegingen. We raden aan beide te proberen.',
                },
                {
                    question: 'Is 微鲤AI tekst-naar-video gratis?',
                    answer: `Ja, elke gebruiker krijgt dagelijkse gratis credits om video's uit tekst te genereren. Je kunt meerdere clips maken om verschillende prompts en modellen te testen.`,
                },
                {
                    question: `Kan ik video's genereren langer dan 8 seconden?`,
                    answer: `De basisgeneratie maakt clips tot 8 seconden (afhankelijk van het model). Voor langere video's kun je onze AI Video Extender-tool gebruiken om het beeld naadloos te verlengen.`,
                },
                {
                    question: `Hebben de gegenereerde video's geluid?`,
                    answer: 'Ja, je kunt de schakelaar "Generate Audio" (in de tool) inschakelen om automatisch bijpassende geluidseffecten en achtergrondambience te maken.',
                },
            ],
        },
        imageToVideo: {
            title: 'AI Afbeelding-naar-Video Generator (Gratis & Online) - Aangedreven door Kling, Veo & Sora',
            description: `Zet statische foto's in enkele seconden om in realistische video's met 微鲤AI's gratis afbeelding-naar-video AI. Gebruik topmodellen zoals Kling, Google Veo en Sora 2 op één plek. Opties zonder watermerk beschikbaar.`,
            keywords: 'afbeelding naar video AI, AI video generator, afbeeldingsanimatie, Sora video, Veo video, Seedance video, 微鲤AI video tools',
            og_title: 'AI Afbeelding-naar-Video Generator (Gratis & Online) - Aangedreven door Kling, Veo & Sora',
            og_description: `Zet statische foto's in enkele seconden om in realistische video's met 微鲤AI's gratis afbeelding-naar-video AI. Gebruik topmodellen zoals Kling, Google Veo en Sora 2 op één plek. Opties zonder watermerk beschikbaar.`,
            twitter_title: 'AI Afbeelding-naar-Video Generator (Gratis & Online) - Aangedreven door Kling, Veo & Sora',
            twitter_description: `Zet statische foto's in enkele seconden om in realistische video's met 微鲤AI's gratis afbeelding-naar-video AI. Gebruik topmodellen zoals Kling, Google Veo en Sora 2 op één plek. Opties zonder watermerk beschikbaar.`,
            page: {
                title1: 'Gratis online AI afbeelding-naar-video generator',
                faq: [
                    {
                        question: 'Hoe werkt de AI afbeelding-naar-video generator?',
                        answer: 'Hij gebruikt geavanceerde deep-learningmodellen zoals Kling en Sora om je statische afbeelding te analyseren en beweging te voorspellen, en genereert een samenhangende MP4-videoclip.',
                    },
                    {
                        question: 'Is 微鲤AI afbeelding-naar-video gratis te gebruiken?',
                        answer: 'Ja, we bieden dagelijks gratis credits om onze afbeelding-naar-video AI uit te proberen. Je kunt upgraden voor premium modellen en snellere generatie.',
                    },
                    {
                        question: 'Welke model is het beste voor realistische video: Kling of Veo?',
                        answer: 'Kling AI staat bekend om realistische beweging en langere duur, terwijl Google Veo uitblinkt in hoge-resolutiedetails. 微鲤AI laat je tussen modellen schakelen om de beste match te vinden.',
                    },
                    {
                        question: `Kan ik de gegenereerde video's commercieel gebruiken?`,
                        answer: `Ja, video's die onder betaalde plannen worden gegenereerd hebben een commerciële licentie, perfect voor YouTube, TikTok en marketingadvertenties.`,
                    },
                    {
                        question: `Hoe verwijder ik watermerken van AI-video's?`,
                        answer: `微鲤AI levert outputs van hoge kwaliteit. Voor video's zonder watermerk, controleer je plandetails of gebruik onze speciale AI Watermark Remover-tool.`,
                    },
                ],
            },
            faq: [
                {
                    question: 'Hoe werkt de AI afbeelding-naar-video generator?',
                    answer: 'Hij gebruikt geavanceerde deep-learningmodellen zoals Kling en Sora om je statische afbeelding te analyseren en beweging te voorspellen, en genereert een samenhangende MP4-videoclip.',
                },
                {
                    question: 'Is 微鲤AI afbeelding-naar-video gratis te gebruiken?',
                    answer: 'Ja, we bieden dagelijks gratis credits om onze afbeelding-naar-video AI uit te proberen. Je kunt upgraden voor premium modellen en snellere generatie.',
                },
                {
                    question: `Kan ik de gegenereerde video's commercieel gebruiken?`,
                    answer: `Ja, video's die onder betaalde plannen worden gegenereerd hebben een commerciële licentie, perfect voor YouTube, TikTok en marketingadvertenties.`,
                },
            ],
        },
        videoToVideo: {
            title: 'Gratis AI video-naar-video generator - Stijlwissel & animefilter online | 微鲤AI',
            description: `Transformeer je video's naar elke stijl met 微鲤AI Video to Video AI. Zet echte beelden om in anime, 3D-cartoons of cyberpunk met tekstprompts, terwijl de oorspronkelijke beweging behouden blijft. Gratis en online.`,
            keywords: 'video naar video ai, vid2vid, ai videostijloverdracht, video naar anime, ai videorestyle, gratis ai videofilter',
            og_title: 'Gratis AI video-naar-video generator - Stijlwissel & animefilter online | 微鲤AI',
            og_description: `Transformeer je video's naar elke stijl met 微鲤AI Video to Video AI. Zet echte beelden om in anime, 3D-cartoons of cyberpunk met tekstprompts, terwijl de oorspronkelijke beweging behouden blijft. Gratis en online.`,
            twitter_title: 'Gratis AI video-naar-video generator - Stijlwissel & animefilter online | 微鲤AI',
            twitter_description: `Transformeer je video's naar elke stijl met 微鲤AI Video to Video AI. Zet echte beelden om in anime, 3D-cartoons of cyberpunk met tekstprompts, terwijl de oorspronkelijke beweging behouden blijft. Gratis en online.`,
            page: {
                title1: 'Gratis AI video-naar-video generator (Vid2Vid)',
                title2: `Upload een video, typ een stijl en zie de magie gebeuren. 微鲤AI's Video to Video-technologie analyseert de beweging in je bronmateriaal en past een compleet nieuwe artistieke stijl toe op basis van je tekstprompt. Perfect voor anime-edits, claymation-effecten of surrealistische visuele kunst.`,
                feature_title1: 'Consistente beweging',
                feature_desc1: 'In tegenstelling tot standaardgeneratie verankert onze Vid2Vid-engine de beweging van je bronvideo, waardoor overgangen soepel blijven zonder flikkeren.',
                feature_title2: 'Van echt naar anime',
                feature_desc2: 'De #1 tool voor creators. Verander jezelf direct in een animepersonage of een 3D Pixar-achtige avatar.',
                feature_title3: 'Promptcontrole',
                feature_desc3: 'Je hebt volledige creatieve controle. Typ bijvoorbeeld "cyberpunk-stad stijl" of "olieverf-stijl" om de look precies te bepalen.',
                faq: [
                    {
                        question: 'Wat is AI Video to Video (Vid2Vid)?',
                        answer: 'Video to Video is een generatief AI-proces dat een bestaand videofragment als input neemt en het "overschildert" naar een nieuwe stijl die door je tekstprompt wordt beschreven, terwijl de originele beweging en structuur behouden blijven.',
                    },
                    {
                        question: 'Kan ik mijn video omzetten naar anime-stijl?',
                        answer: 'Ja! Dit is de populairste use case. Upload je video en gebruik prompts zoals "Japanse anime-stijl, Studio Ghibli-look" om je beelden te transformeren.',
                    },
                    {
                        question: 'Hoe lang mag de bronvideo zijn?',
                        answer: `Momenteel ondersteunen we korte clips (bijv. 5–10 seconden) om de hoogste kwaliteit te garanderen. Voor langere video's raden we aan ze op te splitsen.`,
                    },
                    {
                        question: 'Is dit anders dan een videobewerker?',
                        answer: 'Ja. Een traditionele videobewerker knipt en trimt clips. 微鲤AI Video to Video genereert nieuwe pixels en verandert de textuur en artistieke stijl volledig.',
                    },
                    {
                        question: 'Kost het geld?',
                        answer: '微鲤AI biedt dagelijkse gratis credits om Video to Video te proberen. Premiumplannen zijn beschikbaar voor snellere verwerking en downloads zonder watermerk.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Wat is AI Video to Video (Vid2Vid)?',
                    answer: 'Video to Video is een generatief AI-proces dat een bestaande clip "overschildert" naar een nieuwe stijl op basis van je prompt, met behoud van beweging en structuur.',
                },
                {
                    question: 'Kan ik mijn video omzetten naar anime-stijl?',
                    answer: 'Ja! Upload je video en gebruik prompts zoals "Japanse anime-stijl, Studio Ghibli-look".',
                },
                {
                    question: 'Hoe lang mag de bronvideo zijn?',
                    answer: `Korte clips (bijv. 5–10 seconden) werken het best; langere video's kun je opsplitsen.`,
                },
                {
                    question: 'Is dit anders dan een videobewerker?',
                    answer: 'Een videobewerker knipt en trimt; Video to Video genereert nieuwe pixels en verandert de stijl.',
                },
                {
                    question: 'Kost het geld?',
                    answer: 'Er zijn dagelijkse gratis credits; premiumplannen bieden snellere verwerking en downloads zonder watermerk.',
                },
            ],
        },
        removeWatermark: {
            title: `AI video watermerk verwijderaar - Verwijder logo's en ondertitels | 微鲤AI`,
            description: `AI video watermerk verwijderaar - Verwijder logo's en ondertitels on 微鲤AI platform. High-quality results.`,
            keywords: 'removeWatermark, AI, 微鲤AI',
            page: {
                title1: 'Gratis online AI videowatermerk verwijderaar',
                title2: `Wis direct watermerken, logo's, tekstoverlays en ondertitels uit je video's. Plak een videolink of upload een bestand en laat onze AI de achtergrond herstellen.`,
            },
        },
        videoFaceSwap: {
            title: 'AI video gezichtswissel online - Realistische Deepfake maker | 微鲤AI',
            description: 'AI video gezichtswissel online - Realistische Deepfake maker on 微鲤AI platform. High-quality results.',
            keywords: 'videoFaceSwap, AI, 微鲤AI',
            page: {
                title1: 'Gratis AI video gezichtswissel',
                title2: 'Word de ster van elke film! Upload een videoclip en een doelfoto, en zie hoe onze AI naadloos gezichten verwisselt. Perfect voor grappige memes of gepersonaliseerde groeten.',
            },
        },
        videoLipSync: {
            title: 'AI video lip sync - Stem en gezicht synchronisatie | 微鲤AI',
            description: 'AI video lip sync - Stem en gezicht synchronisatie on 微鲤AI platform. High-quality results.',
            keywords: 'videoLipSync, AI, 微鲤AI',
        },
        translateVideoSubtitle: {
            title: 'AI video ondertiteling vertaler - Automatische vertaling | 微鲤AI',
            description: 'AI video ondertiteling vertaler - Automatische vertaling on 微鲤AI platform. High-quality results.',
            keywords: 'translateVideoSubtitle, AI, 微鲤AI',
        },
        videoToAnime: {
            title: 'AI video naar anime - Verander video in geanimeerde stijl | 微鲤AI',
            description: 'AI video naar anime - Verander video in geanimeerde stijl on 微鲤AI platform. High-quality results.',
            keywords: 'videoToAnime, AI, 微鲤AI',
        },
        videoUpscaler: {
            title: 'AI video upscaler - Verbeter kwaliteit naar 4K | 微鲤AI',
            description: 'AI video upscaler - Verbeter kwaliteit naar 4K on 微鲤AI platform. High-quality results.',
            keywords: 'videoUpscaler, AI, 微鲤AI',
        },
        removeVideoSubtitles: {
            title: 'Video-ondertitels verwijderen - Intelligente verwijdering met AI | 微鲤AI',
            description: 'Identificeer en verwijder hardgecodeerde ondertitels uit videos zonder kwaliteitsverlies.',
            keywords: 'video-ondertitels verwijderen, tekst wissen, 微鲤AI',
        },
        videoBackgroundRemover: {
            title: 'Video-achtergrond verwijderen - Verander of verwijder achtergrond met één klik | 微鲤AI',
            description: 'Gebruik AI om nauwkeurig de video-achtergrond te verwijderen, ondersteunt het veranderen van de achtergrond.',
            keywords: 'video-achtergrond verwijderen, achtergrond verwijderen, videobewerking, 微鲤AI',
        },
        aiVideoExtender: {
            title: 'Video-uitbreiding - Intelligente AI-frame-invulling | 微鲤AI',
            description: 'Gebruik AI om videoframes intelligent uit te breiden en ontbrekende inhoud in te vullen.',
            keywords: 'video-uitbreiding, AI-invulling, videoverhouding, 微鲤AI',
        },
        videoEffects: {
            title: `Video-effecten - Maak virale video's met AI | 微鲤AI`,
            description: `Ontdek populaire AI-video-effecten op 微鲤AI. Van AI Kissing tot AI Dancing, maak virale video's in slechts een paar klikken.`,
            keywords: 'AI video-effecten, virale video, 微鲤AI',
        },
        aiDancing: {
            title: 'AI-dansvideogenerator | Van foto naar dansvideo | 微鲤AI',
            description: `Maak dansvideo's van elke foto met de AI-dansvideogenerator van 微鲤AI.`,
            keywords: 'AI-dansvideogenerator, foto naar dansvideo, 微鲤AI',
        },
        aiKissing: {
            title: `AI-kusvideogenerator - Laat twee foto's kussen | 微鲤AI`,
            description: `AI-kusvideogenerator - Laat twee foto's kussen on 微鲤AI. Realistic and professional results.`,
            keywords: 'aiKissing, AI, 微鲤AI',
        },
        videoMotionImitation: {
            title: 'Videobeweging imitatie - Laat fotos bewegingen uit een film nadoen | 微鲤AI',
            description: 'Extraheer beweging uit video en pas deze toe op stilstaande fotos om ze te laten "bewenen".',
            keywords: 'beweging imitatie, foto naar video, 微鲤AI',
        },
    },
    id: {
        textToMusic: {
            title: 'Generator Musik AI - Ciptakan musik unik tanpa royalti | 微鲤AI',
            description: 'Gunakan teknologi AI canggih untuk menciptakan musik unik tanpa royalti untuk proyek Anda.',
            keywords: 'generator musik AI, musik bebas royalti, 微鲤AI',
        },
        textToVideo: {
            title: 'Generator AI Teks ke Video Gratis (Veo 3.1, Kling & Sora) | 微鲤AI',
            description: 'Ubah prompt teks menjadi video sinematik secara instan dengan Text to Video AI dari 微鲤AI. Didukung oleh Google Veo 3.1, Kling, dan Sora. Mendukung 16:9 & 9:16, hingga 8 detik. Opsi tanpa watermark tersedia.',
            keywords: 'teks ke video ai, generator video ai, google veo 3.1, prompt ke video, kling ai, sora, txt2vid, 微鲤AI',
            og_title: 'Generator AI Teks ke Video Gratis (Veo 3.1, Kling & Sora) | 微鲤AI',
            og_description: 'Ubah prompt teks menjadi video sinematik secara instan dengan Text to Video AI dari 微鲤AI. Didukung oleh Google Veo 3.1, Kling, dan Sora. Mendukung 16:9 & 9:16, hingga 8 detik. Opsi tanpa watermark tersedia.',
            twitter_title: 'Generator AI Teks ke Video Gratis (Veo 3.1, Kling & Sora) | 微鲤AI',
            twitter_description: 'Ubah prompt teks menjadi video sinematik secara instan dengan Text to Video AI dari 微鲤AI. Didukung oleh Google Veo 3.1, Kling, dan Sora. Mendukung 16:9 & 9:16, hingga 8 detik. Opsi tanpa watermark tersedia.',
            page: {
                title1: 'Generator AI Teks ke Video Gratis',
                title2: 'Cukup ketik prompt dan lihat 微鲤AI mewujudkan ide Anda. Generator teks ke video kami menggabungkan model mutakhir seperti Google Veo 3.1 dan Kling AI, sehingga Anda dapat membuat video berkualitas tinggi dan konsisten secara fisik untuk media sosial (9:16) atau proyek sinematik (16:9) hanya dalam hitungan detik.',
                intro_title: 'Ubah imajinasi menjadi kenyataan dengan AI teks ke video',
                feature_title: 'Fitur 微鲤AI teks ke video',
                faq_title: 'Pertanyaan umum tentang teks ke video',
                feature_title1: 'Kekuatan multi-model',
                feature_desc1: 'Beralih antara Veo 3.1 untuk realisme dan Kling untuk konsistensi gerak. Tidak perlu banyak langganan.',
                feature_title2: 'Rasio aspek kustom',
                feature_desc2: 'Buat video vertikal (9:16) untuk TikTok/Reels atau layar lebar (16:9) untuk YouTube secara langsung.',
                feature_title3: 'Durasi lebih panjang',
                feature_desc3: 'Buat video hingga 8 detik (atau lebih lama dengan ekstensi) dalam sekali generasi, ideal untuk bercerita.',
                faq: [
                    {
                        question: 'Bagaimana menulis prompt yang baik untuk AI teks ke video?',
                        answer: 'Jelaskan secara spesifik: subjek, aksi, pencahayaan, dan sudut kamera. Contoh: "Bidikan drone sinematik kota cyberpunk futuristik pada malam hari, lampu neon, 4K". Model terintegrasi 微鲤AI memahami deskripsi kompleks dengan baik.',
                    },
                    {
                        question: 'Model mana yang sebaiknya saya gunakan: Google Veo 3.1 atau Kling?',
                        answer: 'Google Veo 3.1 menawarkan kualitas visual tinggi dan kepatuhan prompt yang kuat, ideal untuk adegan realistis. Kling AI sering lebih baik untuk gerakan karakter kompleks. Kami sarankan mencoba keduanya.',
                    },
                    {
                        question: 'Apakah 微鲤AI teks ke video gratis?',
                        answer: 'Ya, setiap pengguna mendapatkan kredit gratis harian untuk menghasilkan video dari teks. Anda bisa membuat beberapa klip untuk menguji prompt dan model yang berbeda.',
                    },
                    {
                        question: 'Bisakah saya membuat video lebih dari 8 detik?',
                        answer: 'Generasi dasar membuat klip hingga 8 detik (tergantung model). Untuk video lebih panjang, gunakan alat AI Video Extender agar footage berlanjut secara mulus.',
                    },
                    {
                        question: 'Apakah video yang dihasilkan memiliki suara?',
                        answer: 'Ya, Anda dapat mengaktifkan toggle "Generate Audio" (di alat) untuk membuat efek suara dan ambience latar secara otomatis.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Bagaimana menulis prompt yang baik untuk AI teks ke video?',
                    answer: 'Jelaskan secara spesifik: subjek, aksi, pencahayaan, dan sudut kamera. Contoh: "Bidikan drone sinematik kota cyberpunk futuristik pada malam hari, lampu neon, 4K". Model terintegrasi 微鲤AI memahami deskripsi kompleks dengan baik.',
                },
                {
                    question: 'Model mana yang sebaiknya saya gunakan: Google Veo 3.1 atau Kling?',
                    answer: 'Google Veo 3.1 menawarkan kualitas visual tinggi dan kepatuhan prompt yang kuat, ideal untuk adegan realistis. Kling AI sering lebih baik untuk gerakan karakter kompleks. Kami sarankan mencoba keduanya.',
                },
                {
                    question: 'Apakah 微鲤AI teks ke video gratis?',
                    answer: 'Ya, setiap pengguna mendapatkan kredit gratis harian untuk menghasilkan video dari teks. Anda bisa membuat beberapa klip untuk menguji prompt dan model yang berbeda.',
                },
                {
                    question: 'Bisakah saya membuat video lebih dari 8 detik?',
                    answer: 'Generasi dasar membuat klip hingga 8 detik (tergantung model). Untuk video lebih panjang, gunakan alat AI Video Extender agar footage berlanjut secara mulus.',
                },
                {
                    question: 'Apakah video yang dihasilkan memiliki suara?',
                    answer: 'Ya, Anda dapat mengaktifkan toggle "Generate Audio" (di alat) untuk membuat efek suara dan ambience latar secara otomatis.',
                },
            ],
        },
        imageToVideo: {
            title: 'Generator AI Gambar ke Video (Gratis & Online) - Didukung Kling, Veo & Sora',
            description: 'Ubah foto statis menjadi video realistis dalam hitungan detik dengan AI Gambar ke Video gratis dari 微鲤AI. Akses model top seperti Kling, Google Veo, dan Sora 2 di satu tempat. Tersedia opsi tanpa watermark.',
            keywords: 'gambar ke video AI, generator video AI, animasi gambar, video Sora, video Veo, video Seedance, alat video 微鲤AI',
            og_title: 'Generator AI Gambar ke Video (Gratis & Online) - Didukung Kling, Veo & Sora',
            og_description: 'Ubah foto statis menjadi video realistis dalam hitungan detik dengan AI Gambar ke Video gratis dari 微鲤AI. Akses model top seperti Kling, Google Veo, dan Sora 2 di satu tempat. Tersedia opsi tanpa watermark.',
            twitter_title: 'Generator AI Gambar ke Video (Gratis & Online) - Didukung Kling, Veo & Sora',
            twitter_description: 'Ubah foto statis menjadi video realistis dalam hitungan detik dengan AI Gambar ke Video gratis dari 微鲤AI. Akses model top seperti Kling, Google Veo, dan Sora 2 di satu tempat. Tersedia opsi tanpa watermark.',
            page: {
                title1: 'Generator AI Gambar ke Video Gratis Online',
                faq: [
                    {
                        question: 'Bagaimana cara kerja generator AI gambar ke video?',
                        answer: 'Menggunakan model deep learning canggih seperti Kling dan Sora untuk menganalisis gambar statis dan memprediksi gerakan, menghasilkan klip video MP4 yang koheren.',
                    },
                    {
                        question: 'Apakah 微鲤AI gambar ke video gratis digunakan?',
                        answer: 'Ya, kami memberi kredit gratis harian untuk mencoba AI gambar ke video. Anda dapat upgrade untuk model premium dan kecepatan lebih cepat.',
                    },
                    {
                        question: 'Model mana yang terbaik untuk video realistis: Kling atau Veo?',
                        answer: 'Kling AI terkenal dengan gerakan realistis dan durasi lebih panjang, sementara Google Veo unggul pada detail HD. 微鲤AI memungkinkan Anda beralih model untuk menemukan yang paling cocok.',
                    },
                    {
                        question: 'Apakah saya bisa menggunakan video yang dihasilkan secara komersial?',
                        answer: 'Ya, video yang dihasilkan di paket berbayar memiliki lisensi komersial, cocok untuk YouTube, TikTok, dan iklan pemasaran.',
                    },
                    {
                        question: 'Bagaimana cara menghapus watermark dari video AI?',
                        answer: '微鲤AI menyediakan output berkualitas tinggi. Untuk video tanpa watermark, silakan periksa detail paket Anda atau gunakan alat AI Watermark Remover kami.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Bagaimana cara kerja generator AI gambar ke video?',
                    answer: 'Menggunakan model deep learning canggih seperti Kling dan Sora untuk menganalisis gambar statis dan memprediksi gerakan, menghasilkan klip video MP4 yang koheren.',
                },
                {
                    question: 'Apakah 微鲤AI gambar ke video gratis digunakan?',
                    answer: 'Ya, kami memberi kredit gratis harian untuk mencoba AI gambar ke video. Anda dapat upgrade untuk model premium dan kecepatan lebih cepat.',
                },
                {
                    question: 'Apakah saya bisa menggunakan video yang dihasilkan secara komersial?',
                    answer: 'Ya, video yang dihasilkan di paket berbayar memiliki lisensi komersial, cocok untuk YouTube, TikTok, dan iklan pemasaran.',
                },
            ],
        },
        videoToVideo: {
            title: 'Generator AI Video ke Video Gratis - Ubah gaya & filter anime online | 微鲤AI',
            description: 'Ubah video Anda ke gaya apa pun dengan Video to Video AI dari 微鲤AI. Jadikan footage nyata menjadi anime, kartun 3D, atau cyberpunk dengan prompt teks, sambil menjaga gerakan asli tetap konsisten. Gratis dan online.',
            keywords: 'video ke video ai, vid2vid, transfer gaya video ai, ubah video jadi anime, restyle video ai, filter video ai gratis',
            og_title: 'Generator AI Video ke Video Gratis - Ubah gaya & filter anime online | 微鲤AI',
            og_description: 'Ubah video Anda ke gaya apa pun dengan Video to Video AI dari 微鲤AI. Jadikan footage nyata menjadi anime, kartun 3D, atau cyberpunk dengan prompt teks, sambil menjaga gerakan asli tetap konsisten. Gratis dan online.',
            twitter_title: 'Generator AI Video ke Video Gratis - Ubah gaya & filter anime online | 微鲤AI',
            twitter_description: 'Ubah video Anda ke gaya apa pun dengan Video to Video AI dari 微鲤AI. Jadikan footage nyata menjadi anime, kartun 3D, atau cyberpunk dengan prompt teks, sambil menjaga gerakan asli tetap konsisten. Gratis dan online.',
            page: {
                title1: 'Generator AI Video ke Video Gratis (Vid2Vid)',
                title2: 'Unggah video, ketik gaya, dan lihat keajaiban terjadi. Teknologi Video to Video 微鲤AI menganalisis gerakan di footage sumber dan menerapkan gaya artistik baru berdasarkan prompt teks Anda. Cocok untuk edit anime, efek claymation, atau seni visual surealis.',
                feature_title1: 'Gerakan konsisten',
                feature_desc1: 'Berbeda dari generasi standar, mesin Vid2Vid kami mengunci gerakan pada video sumber agar transisi tetap halus tanpa flicker.',
                feature_title2: 'Dari nyata ke anime',
                feature_desc2: 'Alat #1 untuk kreator. Ubah diri Anda menjadi karakter anime atau avatar 3D gaya Pixar secara instan.',
                feature_title3: 'Kontrol prompt',
                feature_desc3: 'Anda punya kendali kreatif penuh. Cukup ketik "gaya kota cyberpunk" atau "gaya lukisan minyak" untuk menentukan tampilan output.',
                faq: [
                    {
                        question: 'Apa itu AI Video ke Video (Vid2Vid)?',
                        answer: 'Video ke Video adalah proses AI generatif yang mengambil klip video yang ada sebagai input dan "melukis ulang" ke gaya baru sesuai prompt teks Anda, sambil mempertahankan gerakan dan struktur asli.',
                    },
                    {
                        question: 'Bisakah saya mengubah video menjadi gaya anime?',
                        answer: 'Bisa! Ini adalah use case paling populer. Cukup unggah video dan masukkan prompt seperti "gaya anime Jepang, tampilan Studio Ghibli" untuk mengubah footage Anda.',
                    },
                    {
                        question: 'Berapa lama durasi video sumber?',
                        answer: 'Saat ini kami mendukung klip pendek (misalnya 5–10 detik) untuk memastikan kualitas transfer gaya terbaik. Untuk video yang lebih panjang, sebaiknya bagi menjadi beberapa segmen.',
                    },
                    {
                        question: 'Apakah ini berbeda dari editor video?',
                        answer: 'Ya. Editor video tradisional memotong dan memangkas klip. 微鲤AI Video to Video menghasilkan piksel baru dan sepenuhnya mengubah tekstur serta gaya artistik footage Anda.',
                    },
                    {
                        question: 'Apakah ini berbayar?',
                        answer: '微鲤AI menyediakan kredit gratis harian untuk mencoba Video to Video. Paket premium tersedia untuk pemrosesan lebih cepat dan unduhan tanpa watermark.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Apa itu AI Video ke Video (Vid2Vid)?',
                    answer: 'Video ke Video adalah proses AI generatif yang "melukis ulang" klip video ke gaya baru berdasarkan prompt Anda sambil menjaga gerakan dan struktur.',
                },
                {
                    question: 'Bisakah saya mengubah video menjadi gaya anime?',
                    answer: 'Bisa! Unggah video dan gunakan prompt seperti "gaya anime Jepang, tampilan Studio Ghibli".',
                },
                {
                    question: 'Berapa lama durasi video sumber?',
                    answer: 'Paling cocok untuk klip pendek (misalnya 5–10 detik); video panjang sebaiknya dibagi.',
                },
                {
                    question: 'Apakah ini berbeda dari editor video?',
                    answer: 'Editor tradisional memotong klip, sedangkan Video to Video menghasilkan piksel baru dan mengubah gaya.',
                },
                {
                    question: 'Apakah ini berbayar?',
                    answer: 'Ada kredit gratis harian; paket premium menawarkan pemrosesan lebih cepat dan unduhan tanpa watermark.',
                },
            ],
        },
        removeWatermark: {
            title: 'Penghapus Watermark Video AI - Hapus Logo & Subtitle | 微鲤AI',
            description: 'Penghapus Watermark Video AI - Hapus Logo & Subtitle on 微鲤AI platform. High-quality results.',
            keywords: 'removeWatermark, AI, 微鲤AI',
            page: {
                title1: 'Penghapus Watermark Video AI Online Gratis',
                title2: 'Hapus tanda air, logo, overlay teks, dan subtitle dari video Anda secara instan. Tempel tautan video atau unggah file agar AI kami memulihkan latar belakang dengan sempurna.',
            },
        },
        videoFaceSwap: {
            title: 'Tukar Wajah Video AI Online - Pembuat Deepfake Realistis | 微鲤AI',
            description: 'Tukar Wajah Video AI Online - Pembuat Deepfake Realistis on 微鲤AI platform. High-quality results.',
            keywords: 'videoFaceSwap, AI, 微鲤AI',
            page: {
                title1: 'Tukar Wajah Video AI Gratis',
                title2: 'Jadilah bintang film apa pun! Unggah klip video dan foto target, lalu lihat AI kami menukar wajah dengan mulus. Sempurna untuk membuat meme lucu atau ucapan personal.',
            },
        },
        videoLipSync: {
            title: 'Lip Sync Video AI - Sinkronisasi Suara & Wajah | 微鲤AI',
            description: 'Lip Sync Video AI - Sinkronisasi Suara & Wajah on 微鲤AI platform. High-quality results.',
            keywords: 'videoLipSync, AI, 微鲤AI',
        },
        translateVideoSubtitle: {
            title: 'Penerjemah Subtitle Video AI - Terjemahan Otomatis | 微鲤AI',
            description: 'Penerjemah Subtitle Video AI - Terjemahan Otomatis on 微鲤AI platform. High-quality results.',
            keywords: 'translateVideoSubtitle, AI, 微鲤AI',
        },
        videoToAnime: {
            title: 'Video ke Anime AI - Ubah Video ke Gaya Animasi | 微鲤AI',
            description: 'Video ke Anime AI - Ubah Video ke Gaya Animasi on 微鲤AI platform. High-quality results.',
            keywords: 'videoToAnime, AI, 微鲤AI',
        },
        videoUpscaler: {
            title: 'AI Video Upscaler - Tingkatkan Kualitas ke 4K | 微鲤AI',
            description: 'AI Video Upscaler - Tingkatkan Kualitas ke 4K on 微鲤AI platform. High-quality results.',
            keywords: 'videoUpscaler, AI, 微鲤AI',
        },
        removeVideoSubtitles: {
            title: 'Hapus Subtitle Video - Penghapusan cerdas dengan AI | 微鲤AI',
            description: 'Identifikasi dan hapus subtitle hardcoded dari video tanpa kehilangan kualitas.',
            keywords: 'hapus subtitle video, hapus teks, 微鲤AI',
        },
        videoBackgroundRemover: {
            title: 'Hapus Latar Belakang Video - Ubah atau hapus latar belakang dengan satu klik | 微鲤AI',
            description: 'Gunakan AI untuk menghapus latar belakang video secara akurat, mendukung perubahan latar belakang.',
            keywords: 'hapus latar belakang video, hapus latar belakang, pengeditan video, 微鲤AI',
        },
        aiVideoExtender: {
            title: 'Perluasan Video - Pengisian bingkai AI cerdas | 微鲤AI',
            description: 'Gunakan AI untuk memperluas bingkai video secara cerdas dan mengisi konten yang hilang.',
            keywords: 'perluasan video, pengisian AI, rasio video, 微鲤AI',
        },
        videoEffects: {
            title: 'Efek Video - Buat Video Viral dengan AI | 微鲤AI',
            description: 'Jelajahi efek video AI populer di 微鲤AI. Dari AI Kissing hingga AI Dancing, buat video viral hanya dengan beberapa klik.',
            keywords: 'efek video AI, video viral, 微鲤AI',
        },
        aiDancing: {
            title: 'Generator Video Tari AI | Pembuat Video Tari dari Foto | 微鲤AI',
            description: 'Buat video tari dari foto apa pun menggunakan Generator Video Tari AI 微鲤AI.',
            keywords: 'generator video tari AI, foto ke video tari, 微鲤AI',
        },
        aiKissing: {
            title: 'Generator Video Ciuman AI - Buat Dua Foto Berciuman | 微鲤AI',
            description: 'Generator Video Ciuman AI - Buat Dua Foto Berciuman on 微鲤AI. Realistic and professional results.',
            keywords: 'aiKissing, AI, 微鲤AI',
        },
        videoMotionImitation: {
            title: 'Imitasi Gerakan Video - Foto meniru gerakan dari film | 微鲤AI',
            description: 'Ekstrak gerakan dari video dan terapkan ke foto diam agar foto "bergerak".',
            keywords: 'imitasi gerakan, foto ke video, 微鲤AI',
        },
    },
    tr: {
        textToMusic: {
            title: 'AI Müzik Oluşturucu - 微鲤AI ile benzersiz müzik oluşturun | 微鲤AI',
            description: 'Projeleriniz için telifsiz ve benzersiz müzikleri hızlıca oluşturmak için gelişmiş AI teknolojisini kullanın.',
            keywords: 'AI müzik oluşturucu, telifsiz müzik, 微鲤AI',
        },
        textToVideo: {
            title: 'Ücretsiz AI Metinden Videoya Üretici (Veo 3.1, Kling & Sora) | 微鲤AI',
            description: 'Metin istemlerinizi 微鲤AI Metinden Videoya AI aracıyla anında sinematik videolara dönüştürün. Google Veo 3.1, Kling ve Sora tarafından desteklenir. 16:9 ve 9:16 oranlarını destekler, 8 saniyeye kadar. Filigransız seçenekler mevcut.',
            keywords: 'metinden videoya ai, ai video üretici, google veo 3.1, prompttan video, kling ai, sora, txt2vid, 微鲤AI',
            og_title: 'Ücretsiz AI Metinden Videoya Üretici (Veo 3.1, Kling & Sora) | 微鲤AI',
            og_description: 'Metin istemlerinizi 微鲤AI Metinden Videoya AI aracıyla anında sinematik videolara dönüştürün. Google Veo 3.1, Kling ve Sora tarafından desteklenir. 16:9 ve 9:16 oranlarını destekler, 8 saniyeye kadar. Filigransız seçenekler mevcut.',
            twitter_title: 'Ücretsiz AI Metinden Videoya Üretici (Veo 3.1, Kling & Sora) | 微鲤AI',
            twitter_description: 'Metin istemlerinizi 微鲤AI Metinden Videoya AI aracıyla anında sinematik videolara dönüştürün. Google Veo 3.1, Kling ve Sora tarafından desteklenir. 16:9 ve 9:16 oranlarını destekler, 8 saniyeye kadar. Filigransız seçenekler mevcut.',
            page: {
                title1: 'Ücretsiz AI Metinden Videoya Üretici',
                title2: `Sadece bir istem yazın ve 微鲤AI'nin fikrinizi hayata geçirdiğini görün. Metinden Videoya üreticimiz Google Veo 3.1 ve Kling AI gibi en iyi modelleri bir araya getirir; sosyal medya (9:16) ya da sinematik projeler (16:9) için fiziksel olarak tutarlı, yüksek kaliteli videoları saniyeler içinde oluşturabilirsiniz.`,
                intro_title: 'AI metinden videoya ile hayali gerçeğe dönüştürün',
                feature_title: '微鲤AI Metinden Videoya özellikleri',
                faq_title: 'Metinden videoya hakkında sık sorulan sorular',
                feature_title1: 'Çoklu model gücü',
                feature_desc1: 'Gerçekçilik için Veo 3.1 ile hareket tutarlılığı için Kling arasında geçiş yapın. Birden fazla aboneliğe gerek yok.',
                feature_title2: 'Özel en-boy oranları',
                feature_desc2: 'TikTok/Reels için dikey (9:16) veya YouTube için geniş (16:9) videoları doğrudan üretin.',
                feature_title3: 'Uzatılmış süre',
                feature_desc3: 'Tek bir üretimde 8 saniyeye kadar (veya uzatmalarla daha uzun) video oluşturun; hikaye anlatımı için idealdir.',
                faq: [
                    {
                        question: 'AI metinden videoya için iyi bir istem nasıl yazılır?',
                        answer: 'Özgül olun: konu, hareket, ışık ve kamera açısını tarif edin. Örneğin: "Gecede futuristik siberpunk şehirde sinematik drone çekimi, neon ışıklar, 4K". 微鲤AI entegre modelleri karmaşık betimlemeleri iyi anlar.',
                    },
                    {
                        question: 'Hangi modeli kullanmalıyım: Google Veo 3.1 mi Kling mi?',
                        answer: 'Google Veo 3.1 üstün görsel kalite ve isteme uyum sağlar, gerçekçi sahneler için idealdir. Kling AI karmaşık karakter hareketlerinde genellikle daha iyidir. İkisini de denemenizi öneririz.',
                    },
                    {
                        question: '微鲤AI Metinden Videoya ücretsiz mi?',
                        answer: 'Evet, her kullanıcı metinden video üretmek için günlük ücretsiz krediler alır. Farklı istemleri ve modelleri denemek için birden fazla klip oluşturabilirsiniz.',
                    },
                    {
                        question: '8 saniyeden uzun videolar oluşturabilir miyim?',
                        answer: 'Temel üretim 8 saniyeye kadar klip oluşturur (modele bağlı). Daha uzun videolar için AI Video Extender aracımızı kullanarak görüntüyü sorunsuz şekilde uzatabilirsiniz.',
                    },
                    {
                        question: 'Oluşturulan videolarda ses var mı?',
                        answer: 'Evet, araçtaki "Generate Audio" anahtarını etkinleştirerek uygun ses efektleri ve arka plan ambiyansı otomatik oluşturabilirsiniz.',
                    },
                ],
            },
            faq: [
                {
                    question: 'AI metinden videoya için iyi bir istem nasıl yazılır?',
                    answer: 'Özgül olun: konu, hareket, ışık ve kamera açısını tarif edin. Örneğin: "Gecede futuristik siberpunk şehirde sinematik drone çekimi, neon ışıklar, 4K". 微鲤AI entegre modelleri karmaşık betimlemeleri iyi anlar.',
                },
                {
                    question: 'Hangi modeli kullanmalıyım: Google Veo 3.1 mi Kling mi?',
                    answer: 'Google Veo 3.1 üstün görsel kalite ve isteme uyum sağlar, gerçekçi sahneler için idealdir. Kling AI karmaşık karakter hareketlerinde genellikle daha iyidir. İkisini de denemenizi öneririz.',
                },
                {
                    question: '微鲤AI Metinden Videoya ücretsiz mi?',
                    answer: 'Evet, her kullanıcı metinden video üretmek için günlük ücretsiz krediler alır. Farklı istemleri ve modelleri denemek için birden fazla klip oluşturabilirsiniz.',
                },
                {
                    question: '8 saniyeden uzun videolar oluşturabilir miyim?',
                    answer: 'Temel üretim 8 saniyeye kadar klip oluşturur (modele bağlı). Daha uzun videolar için AI Video Extender aracımızı kullanarak görüntüyü sorunsuz şekilde uzatabilirsiniz.',
                },
                {
                    question: 'Oluşturulan videolarda ses var mı?',
                    answer: 'Evet, araçtaki "Generate Audio" anahtarını etkinleştirerek uygun ses efektleri ve arka plan ambiyansı otomatik oluşturabilirsiniz.',
                },
            ],
        },
        imageToVideo: {
            title: 'AI Görselden Videoya Oluşturucu (Ücretsiz ve Online) - Kling, Veo ve Sora ile',
            description: `微鲤AI'nin ücretsiz Görselden Videoya AI aracıyla statik fotoğrafları saniyeler içinde gerçekçi videolara dönüştürün. Kling, Google Veo ve Sora 2 gibi üst düzey modellere tek yerden erişin. Filigransız seçenekler mevcut.`,
            keywords: 'görselden videoya AI, AI video oluşturucu, görsel animasyon, Sora video, Veo video, Seedance video, 微鲤AI video araçları',
            og_title: 'AI Görselden Videoya Oluşturucu (Ücretsiz ve Online) - Kling, Veo ve Sora ile',
            og_description: `微鲤AI'nin ücretsiz Görselden Videoya AI aracıyla statik fotoğrafları saniyeler içinde gerçekçi videolara dönüştürün. Kling, Google Veo ve Sora 2 gibi üst düzey modellere tek yerden erişin. Filigransız seçenekler mevcut.`,
            twitter_title: 'AI Görselden Videoya Oluşturucu (Ücretsiz ve Online) - Kling, Veo ve Sora ile',
            twitter_description: `微鲤AI'nin ücretsiz Görselden Videoya AI aracıyla statik fotoğrafları saniyeler içinde gerçekçi videolara dönüştürün. Kling, Google Veo ve Sora 2 gibi üst düzey modellere tek yerden erişin. Filigransız seçenekler mevcut.`,
            page: {
                title1: 'Ücretsiz Online AI Görselden Videoya Oluşturucu',
                faq: [
                    {
                        question: 'AI görselden videoya oluşturucu nasıl çalışır?',
                        answer: 'Kling ve Sora gibi gelişmiş derin öğrenme modelleriyle statik görselinizi analiz eder ve hareketi tahmin ederek MP4 formatında tutarlı bir video klibi üretir.',
                    },
                    {
                        question: '微鲤AI görselden videoya ücretsiz mi?',
                        answer: `Evet, görselden videoya AI'ı denemeniz için günlük ücretsiz krediler sunuyoruz. Premium modeller ve daha hızlı üretim için yükseltebilirsiniz.`,
                    },
                    {
                        question: 'Gerçekçi video için hangi model daha iyi: Kling mi Veo mu?',
                        answer: 'Kling AI gerçekçi hareket ve daha uzun süreyle bilinirken, Google Veo yüksek çözünürlüklü detaylarda öne çıkar. 微鲤AI modeller arasında geçiş yapmanıza olanak tanır.',
                    },
                    {
                        question: 'Üretilen videoları ticari olarak kullanabilir miyim?',
                        answer: 'Evet, ücretli planlarla üretilen videolar ticari lisansla gelir; YouTube, TikTok ve pazarlama reklamları için uygundur.',
                    },
                    {
                        question: 'AI videolardan filigran nasıl kaldırılır?',
                        answer: '微鲤AI yüksek kaliteli çıktılar sağlar. Filigransız videolar için plan detaylarınızı kontrol edin veya özel AI Watermark Remover aracımızı kullanın.',
                    },
                ],
            },
            faq: [
                {
                    question: 'AI görselden videoya oluşturucu nasıl çalışır?',
                    answer: 'Kling ve Sora gibi gelişmiş derin öğrenme modelleriyle statik görselinizi analiz eder ve hareketi tahmin ederek MP4 formatında tutarlı bir video klibi üretir.',
                },
                {
                    question: '微鲤AI görselden videoya ücretsiz mi?',
                    answer: `Evet, görselden videoya AI'ı denemeniz için günlük ücretsiz krediler sunuyoruz. Premium modeller ve daha hızlı üretim için yükseltebilirsiniz.`,
                },
                {
                    question: 'Üretilen videoları ticari olarak kullanabilir miyim?',
                    answer: 'Evet, ücretli planlarla üretilen videolar ticari lisansla gelir; YouTube, TikTok ve pazarlama reklamları için uygundur.',
                },
            ],
        },
        videoToVideo: {
            title: 'Ücretsiz AI Videodan Videoya Üretici - Stil değiştir & anime filtresi online | 微鲤AI',
            description: '微鲤AI Video to Video AI ile videolarınızı istediğiniz stile dönüştürün. Gerçek görüntüleri metin istemleriyle anime, 3D çizgi film veya siberpunk görünüme çevirin; orijinal hareketi koruyun. Ücretsiz ve online.',
            keywords: 'videodan videoya ai, vid2vid, ai video stil transferi, videoyu animeye çevir, ai video restyle, ücretsiz ai video filtresi',
            og_title: 'Ücretsiz AI Videodan Videoya Üretici - Stil değiştir & anime filtresi online | 微鲤AI',
            og_description: '微鲤AI Video to Video AI ile videolarınızı istediğiniz stile dönüştürün. Gerçek görüntüleri metin istemleriyle anime, 3D çizgi film veya siberpunk görünüme çevirin; orijinal hareketi koruyun. Ücretsiz ve online.',
            twitter_title: 'Ücretsiz AI Videodan Videoya Üretici - Stil değiştir & anime filtresi online | 微鲤AI',
            twitter_description: '微鲤AI Video to Video AI ile videolarınızı istediğiniz stile dönüştürün. Gerçek görüntüleri metin istemleriyle anime, 3D çizgi film veya siberpunk görünüme çevirin; orijinal hareketi koruyun. Ücretsiz ve online.',
            page: {
                title1: 'Ücretsiz AI Videodan Videoya Üretici (Vid2Vid)',
                title2: 'Bir video yükleyin, bir stil yazın ve sihri izleyin. 微鲤AI Video to Video teknolojisi, kaynak videodaki hareketi analiz eder ve metin isteminize göre tamamen yeni bir sanatsal stil uygular. Anime düzenlemeleri, claymation efektleri veya sürreal görsel sanat için idealdir.',
                feature_title1: 'Tutarlı hareket',
                feature_desc1: 'Standart üretimin aksine, Vid2Vid motorumuz kaynak videonun hareketini kilitler ve titreşimsiz, akıcı geçişler sağlar.',
                feature_title2: 'Gerçekten animeye',
                feature_desc2: 'İçerik üreticileri için #1 araç. Kendinizi anında bir anime karakterine veya Pixar tarzı 3D avatara dönüştürün.',
                feature_title3: 'İstem kontrolü',
                feature_desc3: 'Tam yaratıcı kontrol sizde. Çıktının görünümünü belirlemek için "siberpunk şehir stili" veya "yağlı boya stili" yazmanız yeterli.',
                faq: [
                    {
                        question: 'AI Videodan Videoya (Vid2Vid) nedir?',
                        answer: 'Video to Video, mevcut bir video klibini girdi olarak alıp metin isteminizle tanımlanan yeni bir stile "yeniden boyayan" ve orijinal hareketi ile yapıyı koruyan üretken bir AI sürecidir.',
                    },
                    {
                        question: 'Videomu anime stiline çevirebilir miyim?',
                        answer: 'Evet! Bu en popüler kullanım. Videonuzu yükleyin ve "Japon anime stili, Studio Ghibli görünümü" gibi istemler girin.',
                    },
                    {
                        question: 'Kaynak video ne kadar uzun olabilir?',
                        answer: 'Şu anda en yüksek kalite için kısa klipleri (ör. 5–10 saniye) destekliyoruz. Daha uzun videoları segmentlere ayırmanızı öneririz.',
                    },
                    {
                        question: 'Bu bir video editöründen farklı mı?',
                        answer: 'Evet. Geleneksel editör klipleri kesip biçer. 微鲤AI Video to Video yeni pikseller üretir ve görüntünün dokusunu ile sanatsal stilini tamamen değiştirir.',
                    },
                    {
                        question: 'Ücretli mi?',
                        answer: '微鲤AI Video to Video’yu denemek için günlük ücretsiz krediler sunar. Daha hızlı işlem ve filigransız indirme için premium planlar mevcuttur.',
                    },
                ],
            },
            faq: [
                {
                    question: 'AI Videodan Videoya (Vid2Vid) nedir?',
                    answer: 'Video to Video, mevcut bir klibi yeni bir stile yeniden boyayan üretken bir AI sürecidir; hareket ve yapı korunur.',
                },
                {
                    question: 'Videomu anime stiline çevirebilir miyim?',
                    answer: 'Evet! Videonuzu yükleyin ve "Japon anime stili, Studio Ghibli görünümü" gibi istemler kullanın.',
                },
                {
                    question: 'Kaynak video ne kadar uzun olabilir?',
                    answer: 'En iyi kalite için kısa klipler (ör. 5–10 saniye) önerilir; daha uzun videoları bölün.',
                },
                {
                    question: 'Bu bir video editöründen farklı mı?',
                    answer: 'Editörler kesip biçer; Video to Video yeni pikseller üretir ve stili değiştirir.',
                },
                {
                    question: 'Ücretli mi?',
                    answer: 'Günlük ücretsiz krediler vardır; premium planlar daha hızlı işlem ve filigransız indirme sunar.',
                },
            ],
        },
        removeWatermark: {
            title: 'Yapay Zeka Video Filigran Kaldırıcı - Logoları ve Altyazıları Sil | 微鲤AI',
            description: 'Yapay Zeka Video Filigran Kaldırıcı - Logoları ve Altyazıları Sil on 微鲤AI platform. High-quality results.',
            keywords: 'removeWatermark, AI, 微鲤AI',
            page: {
                title1: 'Ücretsiz Çevrimiçi AI Video Filigran Kaldırıcı',
                title2: `Videolarınızdaki filigranları, logoları, metinleri ve altyazıları anında silin. Bir video bağlantısı yapıştırın veya dosya yükleyin ve AI'mızın arka planı geri yüklemesine izin verin.`,
            },
        },
        videoFaceSwap: {
            title: 'Yapay Zeka Video Yüz Değiştirme Online - Gerçekçi Deepfake Yapıcı | 微鲤AI',
            description: 'Yapay Zeka Video Yüz Değiştirme Online - Gerçekçi Deepfake Yapıcı on 微鲤AI platform. High-quality results.',
            keywords: 'videoFaceSwap, AI, 微鲤AI',
            page: {
                title1: 'Ücretsiz AI Video Yüz Değiştirme',
                title2: `Herhangi bir filmin yıldızı olun! Bir video klibi ve bir hedef fotoğraf yükleyin ve AI'mızın yüzleri sorunsuz bir şekilde değiştirmesini izleyin. Komik memler veya kişiselleştirilmiş kutlamalar için mükemmel.`,
            },
        },
        videoLipSync: {
            title: 'Yapay Zeka Video Dudak Senkronizasyonu - Ses ve Yüz Senkronizasyonu | 微鲤AI',
            description: 'Yapay Zeka Video Dudak Senkronizasyonu - Ses ve Yüz Senkronizasyonu on 微鲤AI platform. High-quality results.',
            keywords: 'videoLipSync, AI, 微鲤AI',
        },
        translateVideoSubtitle: {
            title: 'Yapay Zeka Video Altyazı Çevirmeni - Otomatik Çeviri | 微鲤AI',
            description: 'Yapay Zeka Video Altyazı Çevirmeni - Otomatik Çeviri on 微鲤AI platform. High-quality results.',
            keywords: 'translateVideoSubtitle, AI, 微鲤AI',
        },
        videoToAnime: {
            title: 'Yapay Zeka Videodan Animeye - Videoyu Animasyon Stiline Dönüştür | 微鲤AI',
            description: 'Yapay Zeka Videodan Animeye - Videoyu Animasyon Stiline Dönüştür on 微鲤AI platform. High-quality results.',
            keywords: 'videoToAnime, AI, 微鲤AI',
        },
        videoUpscaler: {
            title: `Yapay Zeka Video Yükseltici - Kaliteyi 4K'ya Artır | 微鲤AI`,
            description: `Yapay Zeka Video Yükseltici - Kaliteyi 4K'ya Artır on 微鲤AI platform. High-quality results.`,
            keywords: 'videoUpscaler, AI, 微鲤AI',
        },
        removeVideoSubtitles: {
            title: 'Video Altyazılarını Kaldır - AI ile akıllı kaldırma | 微鲤AI',
            description: 'Videolardaki gömülü altyazıları kalite kaybı olmadan akıllıca tanımlayın ve kaldırın.',
            keywords: 'video altyazılarını kaldır, metni sil, 微鲤AI',
        },
        videoBackgroundRemover: {
            title: 'Video Arka Planını Kaldır - Tek tıkla arka planı değiştirin veya kaldırın | 微鲤AI',
            description: `Video arka planını doğru bir şekilde kaldırmak için AI'yı kullanın.`,
            keywords: 'video arka planını kaldır, arka planı kaldır, video düzenleme, 微鲤AI',
        },
        aiVideoExtender: {
            title: 'Video Genişletme - Akıllı AI çerçeve doldurma | 微鲤AI',
            description: `Video çerçevelerini akıllıca genişletmek ve eksik içeriği doldurmak için AI'yı kullanın.`,
            keywords: 'video genişletme, AI doldurma, video oranı, 微鲤AI',
        },
        videoEffects: {
            title: 'Video Efektleri - AI ile Viral Videolar Oluşturun | 微鲤AI',
            description: `微鲤AI'daki popüler AI video efektlerini keşdedin. AI Kissing'den AI Dancing'e, sadece birkaç tıkla viral videolar oluşturun.`,
            keywords: 'AI video efektleri, viral videolar, 微鲤AI',
        },
        aiDancing: {
            title: 'Yapay Zeka Dans Videosu Üreticisi | Fotoğraftan Dans Videosu Yapıcı | 微鲤AI',
            description: `微鲤AI'nın Yapay Zeka Dans Videosu Üreticisi ile herhangi bir fotoğraftan dans videoları oluşturun.`,
            keywords: 'yapay zeka dans videosu üreticisi, fotoğraftan dans videosuna, 微鲤AI',
        },
        aiKissing: {
            title: 'Yapay Zeka Öpücük Videosu Üreticisi - İki Fotoğrafı Öpüştürün | 微鲤AI',
            description: 'Yapay Zeka Öpücük Videosu Üreticisi - İki Fotoğrafı Öpüştürün on 微鲤AI. Realistic and professional results.',
            keywords: 'aiKissing, AI, 微鲤AI',
        },
        videoMotionImitation: {
            title: 'Video Hareket Taklidi - Fotoğrafların filmdeki hareketleri taklit etmesini sağlayın | 微鲤AI',
            description: 'Videodan hareketi çıkarın ve fotoğrafları "hareket ettirmek" için hareketsiz fotoğraflara uygulayın.',
            keywords: 'hareket taklidi, fotoğraftan videoya, 微鲤AI',
        },
    },
}
